(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8765],{

/***/ 8765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Components_GlobeAnimation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(603);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(9477);
// EXTERNAL MODULE: ./node_modules/satellite.js/dist/satellite.es.js
var satellite_es = __webpack_require__(2946);
// EXTERNAL MODULE: ./node_modules/three-orbitcontrols-ts/dist/index.js
var dist = __webpack_require__(6242);
// EXTERNAL MODULE: ./pages/_app.tsx + 10 modules
var _app = __webpack_require__(5189);
;// CONCATENATED MODULE: ./PageSections/HomeSections/Components/preProcessedTLE.js
var preProcessedTLE = [
    {
        "satrec": {
            "error": 0,
            "satnum": "44914",
            "epochyr": 22,
            "epochdays": 53.53416548,
            "ndot": 2.4280075167066946e-10,
            "nddot": 0,
            "bstar": 0.00055599,
            "inclo": 0.9259320747680317,
            "nodeo": 2.3271417394636473,
            "ecco": 0.0001439,
            "argpo": 1.2329389808523383,
            "mo": 5.052244728320782,
            "no": 0.06572603265671342,
            "a": 1.0857868766168948,
            "alta": 0.08594312134844007,
            "altp": 0.0856306318853497,
            "jdsatepoch": 2459633.03416548,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009345988817350469,
            "con41": 0.08392740850246616,
            "cc1": 2.5513999585174098e-9,
            "cc4": 7.069322540903912e-8,
            "cc5": 0.00013916421774545602,
            "d2": 3.84152687017525e-16,
            "d3": 8.643347516786133e-23,
            "d4": 2.2669785563291326e-29,
            "delmo": 1.0021246042393408,
            "eta": 0.0021229882457074506,
            "argpdot": 0.00003642397755312047,
            "omgcof": 2.739790900398123e-7,
            "sinmao": -0.9428027619207776,
            "t": 242539.2276585102,
            "t2cof": 3.827099937776115e-9,
            "t3cof": 3.9717197051417026e-16,
            "t4cof": 6.780700957427517e-23,
            "t5cof": 1.432335386272676e-29,
            "x1mth2": 0.6386908638325113,
            "x7thm1": 1.529163953172421,
            "mdot": 0.06572983859489723,
            "nodedot": -0.00005443144661777359,
            "xlcof": 0.0017527705512754965,
            "xmcof": -0.07774831955861486,
            "nodecf": -4.859282531777098e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.016320692881365,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1073"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44915",
            "epochyr": 22,
            "epochdays": 53.49732141,
            "ndot": -8.575141984624918e-11,
            "nddot": 0,
            "bstar": -0.00017126,
            "inclo": 0.9259547640483077,
            "nodeo": 2.32994473824235,
            "ecco": 0.0001296,
            "argpo": 1.2296717244926048,
            "mo": 5.055482314083231,
            "no": 0.06572469233100578,
            "a": 1.085801671967779,
            "alta": 0.08594239186446595,
            "altp": 0.08566095207109203,
            "jdsatepoch": 2459632.99732141,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346148307382787,
            "con41": 0.08386201208631128,
            "cc1": -7.852586546227455e-10,
            "cc4": 6.66766529677708e-8,
            "cc5": 0.0001390537504136542,
            "d2": 3.63823757525633e-17,
            "d3": -2.5189632965732683e-24,
            "d4": 2.0330117709188934e-31,
            "delmo": 1.0019304980060564,
            "eta": 0.0019116597750127625,
            "argpdot": 0.00003641730386417871,
            "omgcof": -9.448069555104066e-8,
            "sinmao": -0.9417185698423676,
            "t": 242592.28311941028,
            "t2cof": -1.1778879819341183e-9,
            "t3cof": 3.7615638061883145e-17,
            "t4cof": -1.9761417361135294e-24,
            "t5cof": 1.284521572641215e-31,
            "x1mth2": 0.6387126626378963,
            "x7thm1": 1.5290113615347263,
            "mdot": 0.06572849512670875,
            "nodedot": -0.000054427202133863784,
            "xlcof": 0.0017527938513093985,
            "xmcof": 0.029506952098787585,
            "nodecf": 1.4954523170800058e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.784188752299471,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1084"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44917",
            "epochyr": 22,
            "epochdays": 53.50099365,
            "ndot": -2.5180010562626526e-11,
            "nddot": 0,
            "bstar": -0.000036883,
            "inclo": 0.9259425467435436,
            "nodeo": 2.329812093219199,
            "ecco": 0.0001535,
            "argpo": 0.9833813324266771,
            "mo": 5.301784923453923,
            "no": 0.0657249412452172,
            "a": 1.0857989127575822,
            "alta": 0.08596558289069045,
            "altp": 0.085632242624474,
            "jdsatepoch": 2459633.00099365,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346062428732479,
            "con41": 0.08389722543469169,
            "cc1": -1.6914233815497272e-10,
            "cc4": 7.325680813789719e-8,
            "cc5": 0.00013907543296579048,
            "d2": 1.6880500887091595e-18,
            "d3": -2.5175079271363567e-26,
            "d4": 4.376668428640988e-34,
            "delmo": 1.0037806061752588,
            "eta": 0.002264274407997544,
            "argpdot": 0.00003642028713767625,
            "omgcof": -2.846469499697161e-8,
            "sinmao": -0.8312766012128276,
            "t": 242586.995094046,
            "t2cof": -2.537135072324591e-10,
            "t3cof": 1.7452683498222216e-18,
            "t4cof": -1.9749969208390884e-26,
            "t5cof": 2.7653135101101368e-34,
            "x1mth2": 0.6387009248551028,
            "x7thm1": 1.5290935260142806,
            "mdot": 0.06572874566908615,
            "nodedot": -0.000054428574365294924,
            "xlcof": 0.001752781305310086,
            "xmcof": 0.004530410065530675,
            "nodecf": 3.221239853892808e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.8073252884682205,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1098"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44918",
            "epochyr": 22,
            "epochdays": 53.71113269,
            "ndot": -2.0040985542865444e-10,
            "nddot": 0,
            "bstar": -0.00042603,
            "inclo": 0.9259425467435436,
            "nodeo": 2.3134234515429717,
            "ecco": 0.0001265,
            "argpo": 1.2514935761302899,
            "mo": 5.0336569717870425,
            "no": 0.06572347349036584,
            "a": 1.0858150795185464,
            "alta": 0.0859524351261054,
            "altp": 0.08567772391098716,
            "jdsatepoch": 2459633.21113269,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346062428732479,
            "con41": 0.08389722543469169,
            "cc1": -1.951989390082706e-9,
            "cc4": 6.577943425869372e-8,
            "cc5": 0.00013895392546247842,
            "d2": 2.247743103933409e-16,
            "d3": -3.8678362318421003e-23,
            "d4": 7.758480753280886e-30,
            "delmo": 1.0017683578227854,
            "eta": 0.0018656161927988447,
            "argpdot": 0.00003641839134125803,
            "omgcof": -2.257221816128412e-7,
            "sinmao": -0.9488357874037026,
            "t": 242284.3948765844,
            "t2cof": -2.927984085124059e-9,
            "t3cof": 2.323948355513318e-16,
            "t4cof": -3.03436369262877e-23,
            "t5cof": 4.902098296759522e-30,
            "x1mth2": 0.6387009248551028,
            "x7thm1": 1.5290935260142806,
            "mdot": 0.06572727771574655,
            "nodedot": -0.00005442573698469769,
            "xlcof": 0.001752781305310086,
            "xmcof": 0.07700068688969058,
            "nodecf": 3.7172823793536344e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.8480974874411444,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1099"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44920",
            "epochyr": 22,
            "epochdays": 53.72583146,
            "ndot": 1.287786340447205e-11,
            "nddot": 0,
            "bstar": 0.000047402,
            "inclo": 0.9259530187190556,
            "nodeo": 2.3121982304080717,
            "ecco": 0.0001338,
            "argpo": 0.9823899854115443,
            "mo": 5.302743109213267,
            "no": 0.06572548450685996,
            "a": 1.0857929441394183,
            "alta": 0.08593822323534406,
            "altp": 0.08564766504349253,
            "jdsatepoch": 2459633.22583146,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934613603908958,
            "con41": 0.08386704254944044,
            "cc1": 2.174512655282038e-10,
            "cc4": 6.787038893331722e-8,
            "cc5": 0.00013911879255930362,
            "d2": 2.790213643770184e-18,
            "d3": 5.350145823248429e-26,
            "d4": 1.1958620673267287e-33,
            "delmo": 1.0032998511810207,
            "eta": 0.001973829798209863,
            "argpdot": 0.00003641870699418945,
            "omgcof": 4.2049291775939386e-8,
            "sinmao": -0.8307436035239886,
            "t": 242263.22864726186,
            "t2cof": 3.261768982923057e-10,
            "t3cof": 2.884783749529819e-18,
            "t4cof": 4.197200562463209e-26,
            "t5cof": 7.555794145569416e-34,
            "x1mth2": 0.6387109858168531,
            "x7thm1": 1.5290230992820275,
            "mdot": 0.0657292876374185,
            "nodedot": -0.00005442886041178113,
            "xlcof": 0.0017527920590484664,
            "xmcof": -0.0076651520598487715,
            "nodecf": -4.141283862295482e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.9407054453050918,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1102"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44921",
            "epochyr": 22,
            "epochdays": 53.54890526,
            "ndot": 3.975472185098195e-11,
            "nddot": 0,
            "bstar": 0.00010698,
            "inclo": 0.9259547640483077,
            "nodeo": 2.325921754316503,
            "ecco": 0.0001442,
            "argpo": 1.3066791417490986,
            "mo": 4.97851154874103,
            "no": 0.06572528060218578,
            "a": 1.08579519251272,
            "alta": 0.08595176417948047,
            "altp": 0.08563862084595963,
            "jdsatepoch": 2459633.04890526,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346148307382787,
            "con41": 0.08386201208631128,
            "cc1": 4.906996193414017e-10,
            "cc4": 7.071136822614885e-8,
            "cc5": 0.0001391026656225926,
            "d2": 1.420799085140342e-17,
            "d3": 6.147552022602606e-25,
            "d4": 3.100695047726542e-32,
            "delmo": 1.0016792448554006,
            "eta": 0.002127191043257044,
            "argpdot": 0.00003641806371958361,
            "omgcof": 4.140977229740282e-8,
            "sinmao": -0.9647978818011422,
            "t": 242518.00237566233,
            "t2cof": 7.360494290121026e-10,
            "t3cof": 1.4689563084247014e-17,
            "t4cof": 4.8227735294154195e-25,
            "t5cof": 1.9591095491666125e-32,
            "x1mth2": 0.6387126626378963,
            "x7thm1": 1.5290113615347263,
            "mdot": 0.06572908347741566,
            "nodedot": -0.000054428339451056925,
            "xlcof": 0.0017527938513093985,
            "xmcof": -0.014892505134376727,
            "nodecf": -9.345114592743985e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.109187025842786,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1103"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44922",
            "epochyr": 22,
            "epochdays": 53.51574877,
            "ndot": -7.296445900698517e-11,
            "nddot": 0,
            "bstar": -0.00014291,
            "inclo": 0.9259617453653156,
            "nodeo": 2.328473425682919,
            "ecco": 0.0001547,
            "argpo": 1.1971684578327144,
            "mo": 5.088030959303673,
            "no": 0.06572450193586826,
            "a": 1.085803779108931,
            "alta": 0.08597175295355908,
            "altp": 0.08563580526430292,
            "jdsatepoch": 2459633.01574877,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346197380270909,
            "con41": 0.08384189028450095,
            "cc1": -6.551981553302658e-10,
            "cc4": 7.354133363667025e-8,
            "cc5": 0.0001390395635191885,
            "d2": 2.5327912138832222e-17,
            "d3": -1.463115238904914e-24,
            "d4": 9.852465791276922e-32,
            "delmo": 1.002513512998972,
            "eta": 0.0022818357566558836,
            "argpdot": 0.00003641553778849099,
            "omgcof": -7.204995875589116e-8,
            "sinmao": -0.9302722909379182,
            "t": 242565.74772119522,
            "t2cof": -9.827972329953987e-10,
            "t3cof": 2.618648138432859e-17,
            "t4cof": -1.1478239993462159e-24,
            "t5cof": 6.225110163610215e-32,
            "x1mth2": 0.6387193699051663,
            "x7thm1": 1.5289644106638356,
            "mdot": 0.06572830379476448,
            "nodedot": -0.00005442632613588423,
            "xlcof": 0.0017528010202708438,
            "xmcof": 0.017279153143752606,
            "nodecf": 1.247744144888778e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.900288271132396,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1104"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44923",
            "epochyr": 22,
            "epochdays": 53.60789767,
            "ndot": -1.2090041172669054e-11,
            "nddot": 0,
            "bstar": -0.0000078836,
            "inclo": 0.9259949066211035,
            "nodeo": 2.321343755688522,
            "ecco": 0.0001528,
            "argpo": 1.1275786898971967,
            "mo": 5.157608509934428,
            "no": 0.06572471371039582,
            "a": 1.0858014941707035,
            "alta": 0.08596740463901265,
            "altp": 0.08563558370239432,
            "jdsatepoch": 2459633.10789767,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346430470268721,
            "con41": 0.08374631283393097,
            "cc1": -3.614832805593776e-11,
            "cc4": 7.29964522834838e-8,
            "cc5": 0.00013905677442883912,
            "d2": 7.709803629560998e-20,
            "d3": -2.4572587177124238e-28,
            "d4": 9.129473293903402e-37,
            "delmo": 1.0029147647205578,
            "eta": 0.002253877196309113,
            "argpdot": 0.00003640858758767988,
            "omgcof": -4.728899718359518e-9,
            "sinmao": -0.902516145422389,
            "t": 242433.05330514908,
            "t2cof": -5.422249208390664e-11,
            "t3cof": 7.971143953808937e-20,
            "t4cof": -1.927733868510682e-28,
            "t5cof": 5.768291040755668e-37,
            "x1mth2": 0.6387512290553563,
            "x7thm1": 1.5287413966125056,
            "mdot": 0.06572851127011917,
            "nodedot": -0.000054424318370442456,
            "xlcof": 0.0017528350710398427,
            "xmcof": 0.0009771484538576565,
            "nodecf": 6.883751826349775e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.19767679704923324,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1106"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44924",
            "epochyr": 22,
            "epochdays": 53.53049409,
            "ndot": -2.9391829417265622e-12,
            "nddot": 0,
            "bstar": 0.000012405,
            "inclo": 0.9259774533285836,
            "nodeo": 2.32752047591133,
            "ecco": 0.0001439,
            "argpo": 1.1724545956244747,
            "mo": 5.112722132231638,
            "no": 0.06572494396714165,
            "a": 1.0857989329398294,
            "alta": 0.08595517940627961,
            "altp": 0.08564268647337947,
            "jdsatepoch": 2459633.03049409,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346307792603676,
            "con41": 0.08379661652707349,
            "cc1": 5.6887962627398616e-11,
            "cc4": 7.058684748837553e-8,
            "cc5": 0.0001390750999949957,
            "d2": 1.9095084959158405e-19,
            "d3": 9.578010937995139e-28,
            "d4": 5.6003651485954414e-36,
            "delmo": 1.0024838226006956,
            "eta": 0.0021226658697930064,
            "argpdot": 0.00003641268652616517,
            "omgcof": 7.14777295291547e-9,
            "sinmao": -0.9209312074509595,
            "t": 242544.51446011662,
            "t2cof": 8.533194394109793e-11,
            "t3cof": 1.9742333017537666e-19,
            "t4cof": 7.513994925272902e-28,
            "t5cof": 3.5384826050504794e-36,
            "x1mth2": 0.6387344611576422,
            "x7thm1": 1.528858771896505,
            "mdot": 0.06572874383571485,
            "nodedot": -0.00005442603515260761,
            "xlcof": 0.0017528171499527477,
            "xmcof": -0.0017338190002398816,
            "nodecf": -1.0833555137824172e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.9931895109879605,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1111"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44925",
            "epochyr": 22,
            "epochdays": 53.47887495,
            "ndot": 5.872305712439255e-11,
            "nddot": 0,
            "bstar": 0.00014895,
            "inclo": 0.9259704720115756,
            "nodeo": 2.3314352494235533,
            "ecco": 0.0001582,
            "argpo": 1.0728120032988664,
            "mo": 5.21237694186201,
            "no": 0.0657257115957459,
            "a": 1.0857904680110555,
            "alta": 0.08596224006309483,
            "altp": 0.08561869595901617,
            "jdsatepoch": 2459632.97887495,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346258720740483,
            "con41": 0.08381673814633084,
            "cc1": 6.833890812882907e-10,
            "cc4": 7.45591224431551e-8,
            "cc5": 0.00013913877057758158,
            "d2": 2.7558996999348286e-17,
            "d3": 1.660777582958968e-24,
            "d4": 1.166666861591661e-31,
            "delmo": 1.0033604118543935,
            "eta": 0.002333854751408767,
            "argpdot": 0.00003641519867247584,
            "omgcof": 9.618931841716996e-8,
            "sinmao": -0.8775883334020003,
            "t": 242618.84602166712,
            "t2cof": 1.0250836219324361e-9,
            "t3cof": 2.8493038272196394e-17,
            "t4cof": 1.3028816321502313e-24,
            "t5cof": 7.371318516090541e-32,
            "x1mth2": 0.638727753951223,
            "x7thm1": 1.5289057223414386,
            "mdot": 0.06572951247915465,
            "nodedot": -0.000054428027944279,
            "xlcof": 0.0017528099812875177,
            "xmcof": -0.01723094744957127,
            "nodecf": -1.3014710798479263e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.66796889587242,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1112"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44926",
            "epochyr": 22,
            "epochdays": 53.49233272,
            "ndot": -9.575070201913335e-12,
            "nddot": 0,
            "bstar": -0.0000025312,
            "inclo": 0.9250559194835306,
            "nodeo": 2.3305067342614922,
            "ecco": 0.000145,
            "argpo": 1.2619446076912322,
            "mo": 5.02324084681114,
            "no": 0.06568943923215445,
            "a": 1.086188848716758,
            "alta": 0.08634634609982195,
            "altp": 0.0860313513336941,
            "jdsatepoch": 2459632.99233272,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009339826369086648,
            "con41": 0.08645337031022604,
            "cc1": -1.136323178869289e-11,
            "cc4": 6.998872366757669e-8,
            "cc5": 0.00013620646238657447,
            "d2": 7.581217673016666e-21,
            "d3": -7.558236109500628e-30,
            "d4": 8.783900327121367e-39,
            "delmo": 1.0019542664453727,
            "eta": 0.002128350972106923,
            "argpdot": 0.00003656740977223969,
            "omgcof": -1.1032181601324787e-9,
            "sinmao": -0.9520733551636773,
            "t": 242599.4668328762,
            "t2cof": -1.7044847683039334e-11,
            "t3cof": 7.839463746383786e-21,
            "t4cof": -5.930786620590279e-30,
            "t5cof": 5.5513598805038306e-39,
            "x1mth2": 0.637848876563258,
            "x7thm1": 1.535057864057194,
            "mdot": 0.06569335445625712,
            "nodedot": -0.00005442450563191651,
            "xlcof": 0.0017518697481867188,
            "xmcof": 0.0003428123429082373,
            "nodecf": 2.16389692738816e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.752758069782814,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1113"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44927",
            "epochyr": 22,
            "epochdays": 53.48994887,
            "ndot": -1.6665470288140301e-12,
            "nddot": 0,
            "bstar": 0.000015218,
            "inclo": 0.9259634906945676,
            "nodeo": 2.3305137155785007,
            "ecco": 0.0001343,
            "argpo": 1.112708484670205,
            "mo": 5.172443808576379,
            "no": 0.06572502399037916,
            "a": 1.0857980314670401,
            "alta": 0.08594385414266625,
            "altp": 0.085652208791414,
            "jdsatepoch": 2459632.98994887,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346209648421764,
            "con41": 0.08383685984672495,
            "cc1": 6.979134407334338e-11,
            "cc4": 6.797294226742345e-8,
            "cc5": 0.00013908112830571302,
            "d2": 2.874013516700525e-19,
            "d3": 1.7685957933518884e-27,
            "d4": 1.2686904044733455e-35,
            "delmo": 1.00264110197655,
            "eta": 0.0019810785840408992,
            "argpdot": 0.000036415831199586606,
            "omgcof": 1.0712263967484255e-8,
            "sinmao": -0.8960281553068035,
            "t": 242602.8995769471,
            "t2cof": 1.0468701611001506e-10,
            "t3cof": 2.971430150851801e-19,
            "t4cof": 1.387471079607627e-27,
            "t5cof": 8.015970773971013e-36,
            "x1mth2": 0.6387210467177583,
            "x7thm1": 1.528952672975692,
            "mdot": 0.06572882569199674,
            "nodedot": -0.00005442720718400599,
            "xlcof": 0.0017528028124906352,
            "xmcof": -0.002442024878438607,
            "nodecf": -1.3291116830316856e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.7377388892968355,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1114"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44928",
            "epochyr": 22,
            "epochdays": 53.48625786,
            "ndot": 2.7270769562411402e-11,
            "nddot": 0,
            "bstar": 0.000079349,
            "inclo": 0.9259495280605516,
            "nodeo": 2.3310268423785865,
            "ecco": 0.0001553,
            "argpo": 1.1128725456198925,
            "mo": 5.172316399540984,
            "no": 0.0657248335675984,
            "a": 1.0858001087976066,
            "alta": 0.08596873355450296,
            "altp": 0.08563148404071041,
            "jdsatepoch": 2459632.98625786,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934611150241776,
            "con41": 0.0838771034909096,
            "cc1": 3.6386411103336994e-10,
            "cc4": 7.373718298556258e-8,
            "cc5": 0.0001390667306230502,
            "d2": 7.81182653230637e-18,
            "d3": 2.506215741560302e-25,
            "d4": 9.372848393762974e-33,
            "delmo": 1.0030536339921483,
            "eta": 0.0022907917548875703,
            "argpdot": 0.00003641862734624198,
            "omgcof": 4.8278912493471876e-8,
            "sinmao": -0.8960847172934694,
            "t": 242608.21463160217,
            "t2cof": 5.457961665500549e-10,
            "t3cof": 8.07662071490258e-18,
            "t4cof": 1.9661394694201777e-25,
            "t5cof": 5.922058033502331e-33,
            "x1mth2": 0.6387076321696968,
            "x7thm1": 1.529046574812122,
            "mdot": 0.06572863706577864,
            "nodedot": -0.00005442785750175339,
            "xlcof": 0.0017527884745019186,
            "xmcof": -0.009521494391958226,
            "nodecf": -6.929537743678651e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.714484092717996,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1119"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44929",
            "epochyr": 22,
            "epochdays": 53.53786111,
            "ndot": -1.0332591578646987e-11,
            "nddot": 0,
            "bstar": -0.0000040166,
            "inclo": 0.9259652360238195,
            "nodeo": 2.3267315870894287,
            "ecco": 0.0001314,
            "argpo": 1.055144035280928,
            "mo": 5.229996040660892,
            "no": 0.06572512957815456,
            "a": 1.085796870991764,
            "alta": 0.08593954470061216,
            "altp": 0.08565419728291568,
            "jdsatepoch": 2459633.03786111,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346221916544147,
            "con41": 0.08383182941402079,
            "cc1": -1.8421703853360046e-11,
            "cc4": 6.718096697771063e-8,
            "cc5": 0.0001390896189029544,
            "d2": 2.002403845375469e-20,
            "d3": -3.252565913862966e-29,
            "d4": 6.158682759330264e-38,
            "delmo": 1.0028800278151313,
            "eta": 0.0019383288144548326,
            "argpdot": 0.000036415587272256056,
            "omgcof": -3.2224307993760476e-9,
            "sinmao": -0.8690056981279466,
            "t": 242533.90595130622,
            "t2cof": -2.7632555780040068e-11,
            "t3cof": 2.070275679947649e-20,
            "t4cof": -2.5516504008458246e-29,
            "t5cof": 3.891239598057435e-38,
            "x1mth2": 0.6387227235286598,
            "x7thm1": 1.5289409352993815,
            "mdot": 0.06572893106625023,
            "nodedot": -0.00005442728394569873,
            "xlcof": 0.001752804604702198,
            "xmcof": 0.0006733384765564539,
            "nodecf": 3.5082483478884312e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.039604596171941,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1121"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44930",
            "epochyr": 22,
            "epochdays": 53.50468134,
            "ndot": -4.50573714881175e-11,
            "nddot": 0,
            "bstar": -0.000080983,
            "inclo": 0.9259373107557878,
            "nodeo": 2.329449064734784,
            "ecco": 0.0001527,
            "argpo": 1.14678254765689,
            "mo": 5.138408142833238,
            "no": 0.06572505028485134,
            "a": 1.0857977042271143,
            "alta": 0.08596350553654974,
            "altp": 0.08563190291767886,
            "jdsatepoch": 2459633.00468134,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346025623169588,
            "con41": 0.08391231694576384,
            "cc1": -3.7140581901278667e-10,
            "cc4": 7.304914127092317e-8,
            "cc5": 0.0001390843079383473,
            "d2": 8.139255510144308e-18,
            "d3": -2.665466348684773e-25,
            "d4": 1.0175341955070899e-32,
            "delmo": 1.00279514056144,
            "eta": 0.0022525078873677543,
            "argpdot": 0.000036421568526075585,
            "omgcof": -4.664340722770923e-8,
            "sinmao": -0.9106180380249469,
            "t": 242581.6848204285,
            "t2cof": -5.5710872851918e-10,
            "t3cof": 8.415140074937425e-18,
            "t4cof": -2.091069581439814e-25,
            "t5cof": 6.429088449414354e-33,
            "x1mth2": 0.638695894351412,
            "x7thm1": 1.5291287395401154,
            "mdot": 0.0657288554068193,
            "nodedot": -0.00005442916669032854,
            "xlcof": 0.0017527759283298174,
            "xmcof": 0.010052302713423016,
            "nodecf": 7.073333614229836e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.830559166727127,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1123"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44931",
            "epochyr": 22,
            "epochdays": 53.48594835,
            "ndot": 3.4285417510964997e-10,
            "nddot": 0,
            "bstar": 0.00069711,
            "inclo": 0.9259285841095277,
            "nodeo": 2.2949508867398642,
            "ecco": 0.0001467,
            "argpo": 2.5004145369431408,
            "mo": 3.784676669779624,
            "no": 0.0659008318823104,
            "a": 1.0838658704827575,
            "alta": 0.08402487360595723,
            "altp": 0.08370686735955757,
            "jdsatepoch": 2459632.98594835,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009345964279995375,
            "con41": 0.08393746956561599,
            "cc1": 3.5594493935378078e-9,
            "cc4": 8.160364658095461e-8,
            "cc5": 0.00015441938986715913,
            "d2": 7.663531885710942e-16,
            "d3": 2.465857030654354e-22,
            "d4": 9.249177878597133e-29,
            "delmo": 0.9946837025088963,
            "eta": 0.0022183672534565073,
            "argpdot": 0.00003665087469322505,
            "omgcof": -9.323259305308669e-7,
            "sinmao": -0.5996662737370405,
            "t": 242608.66032622755,
            "t2cof": 5.339174090306712e-9,
            "t3cof": 7.916925485414075e-16,
            "t4cof": 1.932354061878107e-22,
            "t5cof": 5.836506457839934e-29,
            "x1mth2": 0.6386875101447946,
            "x7thm1": 1.5291874289864373,
            "mdot": 0.06590466196373188,
            "nodedot": -0.00005477013334648132,
            "xlcof": 0.0017527669665314762,
            "xmcof": -0.10172138271554655,
            "nodecf": -6.821343117845815e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.712534058595722,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1128"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44932",
            "epochyr": 22,
            "epochdays": 53.49363286,
            "ndot": -2.5028506287279798e-11,
            "nddot": 0,
            "bstar": -0.000036562,
            "inclo": 0.9259460374020476,
            "nodeo": 2.3304334304329086,
            "ecco": 0.0001506,
            "argpo": 1.0663787196760153,
            "mo": 5.218796262850844,
            "no": 0.06572496272903444,
            "a": 1.0857986811423375,
            "alta": 0.08596220242371744,
            "altp": 0.08563515986095749,
            "jdsatepoch": 2459632.99363286,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934608696563206,
            "con41": 0.08388716445266031,
            "cc1": -1.6767219713226463e-10,
            "cc4": 7.245896504263889e-8,
            "cc5": 0.00013907701926882483,
            "d2": 1.6588384046069142e-18,
            "d3": -2.452447001090904e-26,
            "d4": 4.226515471806183e-34,
            "delmo": 1.0032360286896884,
            "eta": 0.00222150324217996,
            "argpdot": 0.000036419554415541815,
            "omgcof": -2.5080796423811383e-8,
            "sinmao": -0.8744927543063215,
            "t": 242597.5946315378,
            "t2cof": -2.515082956983969e-10,
            "t3cof": 1.7150663359892361e-18,
            "t4cof": -1.923956057413909e-26,
            "t5cof": 2.6704418472121633e-34,
            "x1mth2": 0.6387042785157799,
            "x7thm1": 1.529070050389541,
            "mdot": 0.06572876670023385,
            "nodedot": -0.000054428361375644125,
            "xlcof": 0.0017527848899224583,
            "xmcof": 0.004665651733818522,
            "nodecf": 3.193229290929491e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.7609494552129235,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1130"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44933",
            "epochyr": 22,
            "epochdays": 53.5194353,
            "ndot": -6.669218200763054e-11,
            "nddot": 0,
            "bstar": -0.00012895,
            "inclo": 0.9259739626700796,
            "nodeo": 2.3284193204761072,
            "ecco": 0.0001361,
            "argpo": 1.2056961365579588,
            "mo": 5.0794683739933895,
            "no": 0.06572457782724252,
            "a": 1.0858029607584847,
            "alta": 0.08595073854144397,
            "altp": 0.08565518297552543,
            "jdsatepoch": 2459633.0194353,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934628325672902,
            "con41": 0.08380667732656011,
            "cc1": -5.912184605996628e-10,
            "cc4": 6.843255501354738e-8,
            "cc5": 0.00013904471921737243,
            "d2": 2.0623132327960237e-17,
            "d3": -1.0750129740872337e-24,
            "d4": 6.532208615276833e-32,
            "delmo": 1.0021629844195201,
            "eta": 0.0020075057122051943,
            "argpdot": 0.00003641297405565438,
            "omgcof": -7.229142440717977e-8,
            "sinmao": -0.9333795041002394,
            "t": 242560.43911792338,
            "t2cof": -8.868276908994943e-10,
            "t3cof": 2.1322210864267907e-17,
            "t4cof": -8.433546953785572e-25,
            "t5cof": 4.1272608134261393e-32,
            "x1mth2": 0.6387311075578133,
            "x7thm1": 1.5288822470953067,
            "mdot": 0.06572837810191332,
            "nodedot": -0.000054425581760279654,
            "xlcof": 0.0017528135656365892,
            "xmcof": 0.0201446945188939,
            "nodecf": 1.1258874381445193e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.923514841179369,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1144"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44934",
            "epochyr": 22,
            "epochdays": 53.53233412,
            "ndot": -4.857227067616164e-11,
            "nddot": 0,
            "bstar": -0.000088763,
            "inclo": 0.9259774533285836,
            "nodeo": 1.9783115085138006,
            "ecco": 0.0001385,
            "argpo": 1.3292654475991572,
            "mo": 4.9559147709154585,
            "no": 0.06572466505746505,
            "a": 1.0858020049770913,
            "alta": 0.0859523885547806,
            "altp": 0.08565162139940208,
            "jdsatepoch": 2459633.03233412,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346307792603676,
            "con41": 0.08379661652707349,
            "cc1": -4.0698804164139146e-10,
            "cc4": 6.909145701882937e-8,
            "cc5": 0.00013905198347806036,
            "d2": 9.772985109174642e-18,
            "d3": -3.506915329676607e-25,
            "d4": 1.466934057273375e-32,
            "delmo": 1.0014785387544884,
            "eta": 0.0020429311086497064,
            "argpdot": 0.00003641232634264143,
            "omgcof": -3.2761009185151626e-8,
            "sinmao": -0.970493849477531,
            "t": 242541.8648171425,
            "t2cof": -6.104820624620872e-10,
            "t3cof": 1.0104263641252832e-17,
            "t4cof": -2.751196469387264e-25,
            "t5cof": 9.2685583032901e-33,
            "x1mth2": 0.6387344611576422,
            "x7thm1": 1.528858771896505,
            "mdot": 0.06572846488836474,
            "nodedot": -0.000054425495989354813,
            "xlcof": 0.0017528171499527477,
            "xmcof": 0.01339076546408359,
            "nodecf": 7.750468678128837e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.0047824131146825,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1071"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44937",
            "epochyr": 22,
            "epochdays": 53.51021874,
            "ndot": -3.160379183732788e-11,
            "nddot": 0,
            "bstar": -0.000051126,
            "inclo": 0.9259669813530716,
            "nodeo": 1.9800568377657948,
            "ecco": 0.0001519,
            "argpo": 1.252732759899206,
            "mo": 5.0324666572371815,
            "no": 0.06572456448258679,
            "a": 1.085803097710742,
            "alta": 0.08596803120128449,
            "altp": 0.08563816422019976,
            "jdsatepoch": 2459633.01021874,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346234184638063,
            "con41": 0.0838267989863859,
            "cc1": -2.344053815139845e-10,
            "cc4": 7.277149612405577e-8,
            "cc5": 0.00013904451295792527,
            "d2": 3.2418506524335425e-18,
            "d3": -6.69993919458348e-26,
            "d4": 1.614120604475479e-33,
            "delmo": 1.0021163980422718,
            "eta": 0.002240555107448972,
            "argpdot": 0.00003641447791171393,
            "omgcof": -2.2492983519132054e-8,
            "sinmao": -0.9492109806784399,
            "t": 242573.7109643966,
            "t2cof": -3.516080722709768e-10,
            "t3cof": 3.3517424181989757e-18,
            "t4cof": -5.256146470296061e-26,
            "t5cof": 1.0198537359689207e-33,
            "x1mth2": 0.6387244003378714,
            "x7thm1": 1.5289291976349002,
            "mdot": 0.06572836566659293,
            "nodedot": -0.00005442606529640846,
            "xlcof": 0.0017528063969055327,
            "xmcof": 0.006411788641043861,
            "nodecf": 4.463940456931782e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.865446935928432,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1079"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44938",
            "epochyr": 22,
            "epochdays": 53.54339649,
            "ndot": -6.423781274701352e-12,
            "nddot": 0,
            "bstar": 0.0000046711,
            "inclo": 0.9259739626700796,
            "nodeo": 1.9774161546075275,
            "ecco": 0.0001742,
            "argpo": 0.8789443206458404,
            "mo": 5.406234152539523,
            "no": 0.06572469531564243,
            "a": 1.0858016666819188,
            "alta": 0.08599081333225489,
            "altp": 0.0856125200315827,
            "jdsatepoch": 2459633.04339649,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934628325672902,
            "con41": 0.08380667732656011,
            "cc1": 2.141817807987718e-11,
            "cc4": 7.888576574270521e-8,
            "cc5": 0.00013905663125522057,
            "d2": 2.7066420380680162e-20,
            "d3": 5.111302476602357e-29,
            "d4": 1.125173800717287e-37,
            "delmo": 1.0049377357912819,
            "eta": 0.002569531415387571,
            "argpdot": 0.000036413126594980225,
            "omgcof": 3.6560288589293133e-9,
            "sinmao": -0.768792724416246,
            "t": 242525.93500413,
            "t2cof": 3.212726711981577e-11,
            "t3cof": 2.798389708520283e-20,
            "t4cof": 4.009847215891436e-29,
            "t5cof": 7.109206201079113e-38,
            "x1mth2": 0.6387311075578133,
            "x7thm1": 1.5288822470953067,
            "mdot": 0.0657284956062486,
            "nodedot": -0.00005442581009595703,
            "xlcof": 0.0017528135656365892,
            "xmcof": -0.0004454529850119383,
            "nodecf": -4.078789842101304e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.0744796383482225,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1082"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44939",
            "epochyr": 22,
            "epochdays": 53.48441838,
            "ndot": -2.95736345476817e-11,
            "nddot": 0,
            "bstar": -0.000046679,
            "inclo": 0.9259634906945676,
            "nodeo": 1.9820412771253126,
            "ecco": 0.0001553,
            "argpo": 1.0466023939216675,
            "mo": 5.238577824592948,
            "no": 0.0657247003626406,
            "a": 1.0858015960436134,
            "alta": 0.085970221031479,
            "altp": 0.08563297105574774,
            "jdsatepoch": 2459632.98441838,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346209648421764,
            "con41": 0.08383685984672495,
            "cc1": -2.1403443596154369e-10,
            "cc4": 7.371480322759005e-8,
            "cc5": 0.0001390558323028674,
            "d2": 2.702921191309297e-18,
            "d3": -5.100768073831631e-26,
            "d4": 1.1220831491914608e-33,
            "delmo": 1.0034554996848566,
            "eta": 0.002290749194677032,
            "argpdot": 0.00003641541380223254,
            "omgcof": -3.2151989724011174e-8,
            "sinmao": -0.864727466082629,
            "t": 242610.8634826541,
            "t2cof": -3.2105165394231556e-10,
            "t3cof": 2.7945426708640493e-18,
            "t4cof": -4.001582788125148e-26,
            "t5cof": 7.089678222859078e-34,
            "x1mth2": 0.6387210467177583,
            "x7thm1": 1.528952672975692,
            "mdot": 0.0657285020205683,
            "nodedot": -0.00005442658241817653,
            "xlcof": 0.0017528028124906352,
            "xmcof": 0.005600910697825609,
            "nodecf": 4.0760413273692176e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.702894655453221,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1083"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44940",
            "epochyr": 22,
            "epochdays": 53.56181378,
            "ndot": -1.6029152331684036e-11,
            "nddot": 0,
            "bstar": -0.000016601,
            "inclo": 0.9259547640483077,
            "nodeo": 1.9759273887555764,
            "ecco": 0.0001619,
            "argpo": 1.1818043244274083,
            "mo": 5.103405564684491,
            "no": 0.06572530424817923,
            "a": 1.0857949320679416,
            "alta": 0.08597072226744329,
            "altp": 0.08561914186843977,
            "jdsatepoch": 2459633.06181378,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346148307382787,
            "con41": 0.08386201208631128,
            "cc1": -7.614761126103443e-11,
            "cc4": 7.556832456522488e-8,
            "cc5": 0.0001391056558275896,
            "d2": 3.42148962431644e-19,
            "d3": -2.2973479224515585e-27,
            "d4": 1.7981487572365628e-35,
            "delmo": 1.00273323778244,
            "eta": 0.00238830350772384,
            "argpdot": 0.000036418094644760395,
            "omgcof": -8.314908812392938e-9,
            "sinmao": -0.9245220884294516,
            "t": 242499.41410660744,
            "t2cof": -1.1422141689155165e-10,
            "t3cof": 3.5374587983316726e-19,
            "t4cof": -1.8022762673401493e-27,
            "t5cof": 1.1361226260222408e-35,
            "x1mth2": 0.6387126626378963,
            "x7thm1": 1.5290113615347263,
            "mdot": 0.06572910712663581,
            "nodedot": -0.00005442838573909857,
            "xlcof": 0.0017527938513093985,
            "xmcof": 0.0018333312941920415,
            "nodecf": 1.4501921875912333e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.190515712737053,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1091"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44941",
            "epochyr": 22,
            "epochdays": 53.51758948,
            "ndot": -1.4756516418771502e-11,
            "nddot": 0,
            "bstar": -0.000013791,
            "inclo": 0.9259774533285836,
            "nodeo": 1.979428519235077,
            "ecco": 0.0001616,
            "argpo": 0.8916014483813033,
            "mo": 5.393561316840793,
            "no": 0.06572475244301919,
            "a": 1.085801042470353,
            "alta": 0.08597650791881617,
            "altp": 0.08562557702188989,
            "jdsatepoch": 2459633.01758948,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346307792603676,
            "con41": 0.08379661652707349,
            "cc1": -6.323708162123618e-11,
            "cc4": 7.543017319941792e-8,
            "cc5": 0.0001390604817204495,
            "d2": 2.359461368866979e-19,
            "d3": -1.3155470897512421e-27,
            "d4": 8.550415066900062e-36,
            "delmo": 1.0045098297129273,
            "eta": 0.0023836945195098006,
            "argpdot": 0.000036412439660960155,
            "omgcof": -1.1457545031338856e-8,
            "sinmao": -0.7768350275970596,
            "t": 242563.09709854424,
            "t2cof": -9.485562243185428e-11,
            "t3cof": 2.439439938706397e-19,
            "t4cof": -1.0320541540816007e-27,
            "t5cof": 5.4024221610764264e-36,
            "x1mth2": 0.6387344611576422,
            "x7thm1": 1.528858771896505,
            "mdot": 0.06572855228575927,
            "nodedot": -0.00005442566561775158,
            "xlcof": 0.0017528171499527477,
            "xmcof": 0.001528281807875561,
            "nodecf": 1.204257850744071e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.911885459605784,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1094"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44942",
            "epochyr": 22,
            "epochdays": 53.50284953,
            "ndot": -2.8967617446294778e-11,
            "nddot": 0,
            "bstar": -0.000045304,
            "inclo": 0.9259687266823236,
            "nodeo": 1.9805542566026133,
            "ecco": 0.0001641,
            "argpo": 1.113266990030843,
            "mo": 5.171937663093301,
            "no": 0.06572479711318835,
            "a": 1.0858005379120061,
            "alta": 0.08597871778027733,
            "altp": 0.08562235804373475,
            "jdsatepoch": 2459633.00284953,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346246452703508,
            "con41": 0.08382176856382328,
            "cc1": -2.07742415669082e-10,
            "cc4": 7.612789420187051e-8,
            "cc5": 0.00013906429496204984,
            "d2": 2.5463745993966396e-18,
            "d3": -4.664143404990845e-26,
            "d4": 9.958840361108886e-34,
            "delmo": 1.0032243661069005,
            "eta": 0.00242058606306341,
            "argpdot": 0.00003641439834416932,
            "omgcof": -2.6065249580557112e-8,
            "sinmao": -0.8962527677186221,
            "t": 242584.32262681425,
            "t2cof": -3.1161362350362297e-10,
            "t3cof": 2.632688421932691e-18,
            "t4cof": -3.659045937136157e-26,
            "t5cof": 6.292307695514101e-34,
            "x1mth2": 0.6387260771453922,
            "x7thm1": 1.5289174599822544,
            "mdot": 0.06572859810086272,
            "nodedot": -0.00005442638807540405,
            "xlcof": 0.0017528081891006392,
            "xmcof": 0.004868763610238184,
            "nodecf": 3.956203045376129e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.819018052865815,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1096"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44943",
            "epochyr": 22,
            "epochdays": 53.67977243,
            "ndot": -4.957219889345006e-11,
            "nddot": 0,
            "bstar": -0.000090966,
            "inclo": 0.9259355654265357,
            "nodeo": 1.966780118145874,
            "ecco": 0.0001684,
            "argpo": 1.2006695883122152,
            "mo": 5.084554263433701,
            "no": 0.06572503688164692,
            "a": 1.0857978493466987,
            "alta": 0.08598069770452854,
            "altp": 0.08561500098886876,
            "jdsatepoch": 2459633.17977243,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346013354591684,
            "con41": 0.08391734745959523,
            "cc1": -4.171891716359024e-10,
            "cc4": 7.735661284678624e-8,
            "cc5": 0.00013908419242436243,
            "d2": 1.0269576108793549e-17,
            "d3": -3.7776746200504125e-25,
            "d4": 1.619883813107953e-32,
            "delmo": 1.0027123500755417,
            "eta": 0.002484097047075775,
            "argpdot": 0.00003642193178723516,
            "omgcof": -4.1770403261451233e-8,
            "sinmao": -0.9315421608682463,
            "t": 242329.5536506176,
            "t2cof": -6.257837574538536e-10,
            "t3cof": 1.061766971865405e-17,
            "t4cof": -2.9636019045935604e-25,
            "t5cof": 1.0234916296029857e-32,
            "x1mth2": 0.6386942175134682,
            "x7thm1": 1.529140477405722,
            "mdot": 0.06572884222961747,
            "nodedot": -0.000054429268542213637,
            "xlcof": 0.001752774135986605,
            "xmcof": 0.009284147322428028,
            "nodecf": 7.945281141528966e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.6505156801587404,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1100"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44944",
            "epochyr": 22,
            "epochdays": 53.52864109,
            "ndot": -1.3211172810234855e-11,
            "nddot": 0,
            "bstar": -0.000010382,
            "inclo": 0.9259757079993315,
            "nodeo": 1.9785471279628197,
            "ecco": 0.0001461,
            "argpo": 1.1562596854952194,
            "mo": 5.128918787690145,
            "no": 0.06572499242755596,
            "a": 1.0857983966690108,
            "alta": 0.08595703181476422,
            "altp": 0.08563976152325736,
            "jdsatepoch": 2459633.02864109,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346295524680581,
            "con41": 0.08380164692428138,
            "cc1": -4.761214606467842e-11,
            "cc4": 7.119466931191745e-8,
            "cc5": 0.00013907918956682495,
            "d2": 1.3375785154574837e-19,
            "d3": -5.615304887557954e-28,
            "d4": 2.747987059660897e-36,
            "delmo": 1.0026181129888003,
            "eta": 0.002155132590569216,
            "argpdot": 0.0000364131293279856,
            "omgcof": -6.11821383631341e-9,
            "sinmao": -0.9144984470063185,
            "t": 242547.18278065324,
            "t2cof": -7.141821909701762e-11,
            "t3cof": 1.3829168445151693e-19,
            "t4cof": -4.405231935553056e-28,
            "t5cof": 1.7362619671545285e-36,
            "x1mth2": 0.6387327843585728,
            "x7thm1": 1.5288705094899897,
            "mdot": 0.06572879253045763,
            "nodedot": -0.000054426256082735506,
            "xlcof": 0.0017528153577987824,
            "xmcof": 0.0014077282638625497,
            "nodecf": 9.067136008882048e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.9815148894962675,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1108"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44945",
            "epochyr": 22,
            "epochdays": 53.6244823,
            "ndot": 2.457702354674654e-10,
            "nddot": 0,
            "bstar": 0.00056286,
            "inclo": 0.9259373107557878,
            "nodeo": 1.9709409830826283,
            "ecco": 0.0001968,
            "argpo": 1.0899703351752228,
            "mo": 5.195290168484985,
            "no": 0.06572504347889731,
            "a": 1.0857977791895426,
            "alta": 0.08601146419248717,
            "altp": 0.08558409418659796,
            "jdsatepoch": 2459633.1244823,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346025623169588,
            "con41": 0.08391231694576384,
            "cc1": 2.5814346316364912e-9,
            "cc4": 8.514495224566693e-8,
            "cc5": 0.00013908675120913753,
            "d2": 3.931960321305608e-16,
            "d3": 8.94972442184968e-23,
            "d4": 2.3746383982987302e-29,
            "delmo": 1.0040495289582323,
            "eta": 0.0029030329496532218,
            "argpdot": 0.00003642156085756772,
            "omgcof": 2.82776660105641e-7,
            "sinmao": -0.8856514835418108,
            "t": 242409.17143777013,
            "t2cof": 3.872151947454737e-9,
            "t3cof": 4.0652364164538525e-16,
            "t4cof": 7.021096816791238e-23,
            "t5cof": 1.5003683527418797e-29,
            "x1mth2": 0.638695894351412,
            "x7thm1": 1.5291287395401154,
            "mdot": 0.06572884860003309,
            "nodedot": -0.000054429155215251496,
            "xlcof": 0.0017527759283298174,
            "xmcof": -0.042062842010854515,
            "nodecf": -4.916278444697576e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.3021664033159581,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1109"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44946",
            "epochyr": 22,
            "epochdays": 53.41496697,
            "ndot": 3.493688589495594e-10,
            "nddot": 0,
            "bstar": 0.00071476,
            "inclo": 0.9250751181053024,
            "nodeo": 1.870165672072476,
            "ecco": 0.0001119,
            "argpo": 2.595046288986273,
            "mo": 3.6899820858834196,
            "no": 0.0658899391426538,
            "a": 1.0839841020217744,
            "alta": 0.08410539984279075,
            "altp": 0.08386280420075809,
            "jdsatepoch": 2459632.91496697,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009339961479662035,
            "con41": 0.0863980069135244,
            "cc1": 3.625451894370135e-9,
            "cc4": 7.116413265570966e-8,
            "cc5": 0.0001534091419983701,
            "d2": 7.938022154562307e-16,
            "d3": 2.597483230518105e-22,
            "d4": 9.908067446280926e-29,
            "delmo": 0.9956809521834353,
            "eta": 0.0016894996574247567,
            "argpdot": 0.00003682381807744957,
            "omgcof": -0.0000013238480864370301,
            "sinmao": -0.521313503153676,
            "t": 242710.8735128492,
            "t2cof": 5.438177841555202e-9,
            "t3cof": 8.200900183330147e-16,
            "t4cof": 2.0356404898212395e-22,
            "t5cof": 6.252776338100806e-29,
            "x1mth2": 0.6378673310288252,
            "x7thm1": 1.5349286827982236,
            "mdot": 0.06589387981456774,
            "nodedot": -0.000054811558211134496,
            "xlcof": 0.0017518895091080233,
            "xmcof": -0.17834209531386108,
            "nodecf": -6.95302947036463e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.26532381932013,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1110"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44947",
            "epochyr": 22,
            "epochdays": 53.64659114,
            "ndot": -6.717699568874008e-11,
            "nddot": 0,
            "bstar": -0.00013002,
            "inclo": 0.9259669813530716,
            "nodeo": 1.9691502752700822,
            "ecco": 0.0001666,
            "argpo": 0.9381895221047879,
            "mo": 5.346990696409828,
            "no": 0.06572484391576022,
            "a": 1.0858000198993798,
            "alta": 0.08598091418269505,
            "altp": 0.08561912561606455,
            "jdsatepoch": 2459633.14659114,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346234184638063,
            "con41": 0.0838267989863859,
            "cc1": -5.962269058136569e-10,
            "cc4": 7.681783965852337e-8,
            "cc5": 0.00013906828524133655,
            "d2": 2.0974804165797243e-17,
            "d3": -1.102647646744145e-24,
            "d4": 6.757139299125918e-32,
            "delmo": 1.0043771702504567,
            "eta": 0.0024574787972322844,
            "argpdot": 0.00003641483902239801,
            "omgcof": -9.862676392649734e-8,
            "sinmao": -0.8053078857111218,
            "t": 242377.33470842242,
            "t2cof": -8.943403587204854e-10,
            "t3cof": 2.1685777212229498e-17,
            "t4cof": -8.650328393960598e-25,
            "t5cof": 4.269371102685089e-32,
            "x1mth2": 0.6387244003378714,
            "x7thm1": 1.5289291976349002,
            "mdot": 0.06572864513754209,
            "nodedot": -0.00005442660582158373,
            "xlcof": 0.0017528063969055327,
            "xmcof": 0.013557162445518424,
            "nodecf": 1.1354465520136638e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.4414606746296599,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1116"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44949",
            "epochyr": 22,
            "epochdays": 53.53970628,
            "ndot": -3.2300711503922834e-11,
            "nddot": 0,
            "bstar": -0.000052701,
            "inclo": 0.9259565093775597,
            "nodeo": 1.9777896550674543,
            "ecco": 0.0001544,
            "argpo": 0.9990299545000583,
            "mo": 5.286141537368298,
            "no": 0.06572461053925621,
            "a": 1.0858025753702591,
            "alta": 0.08597022328789627,
            "altp": 0.08563492745262202,
            "jdsatepoch": 2459633.03970628,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346160575647522,
            "con41": 0.08385698162825261,
            "cc1": -2.4163376128594074e-10,
            "cc4": 7.347048106303583e-8,
            "cc5": 0.0001390484296474118,
            "d2": 3.444894020272071e-18,
            "d3": -7.339163447303871e-26,
            "d4": 1.8226551990290416e-33,
            "delmo": 1.0037130928005413,
            "eta": 0.0022774452324942408,
            "argpdot": 0.000036416818576267,
            "omgcof": -3.947045370856738e-8,
            "sinmao": -0.8398700522170242,
            "t": 242531.2489067763,
            "t2cof": -3.6245064192891114e-10,
            "t3cof": 3.561667769458453e-18,
            "t4cof": -5.75762045531226e-26,
            "t5cof": 1.1516122718859214e-33,
            "x1mth2": 0.6387143394572491,
            "x7thm1": 1.5289996237992565,
            "mdot": 0.06572841309616523,
            "nodedot": -0.00005442691762643007,
            "xlcof": 0.001752795643562102,
            "xmcof": 0.006397147651269371,
            "nodecf": 4.6016669894589486e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.051229882101708,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1122"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44950",
            "epochyr": 22,
            "epochdays": 53.55444848,
            "ndot": -1.424140188259262e-11,
            "nddot": 0,
            "bstar": -0.000012668,
            "inclo": 0.9259582547068116,
            "nodeo": 1.9765016020794823,
            "ecco": 0.0001433,
            "argpo": 1.1239606223578125,
            "mo": 5.161209124181292,
            "no": 0.06572493025008327,
            "a": 1.0857990564359807,
            "alta": 0.08595465144076786,
            "altp": 0.08564346143119361,
            "jdsatepoch": 2459633.05444848,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346172843883787,
            "con41": 0.083851951175265,
            "cc1": -5.8093688915242764e-11,
            "cc4": 7.044208057948016e-8,
            "cc5": 0.00013907394404970454,
            "d2": 1.991305590651285e-19,
            "d3": -1.0199981571612955e-27,
            "d4": 6.090432614654946e-36,
            "delmo": 1.0027540905340562,
            "eta": 0.0021138112381651284,
            "argpdot": 0.00003641685093840447,
            "omgcof": -8.165356700316317e-9,
            "sinmao": -0.900959672278874,
            "t": 242510.02013906837,
            "t2cof": -8.714053337286415e-11,
            "t3cof": 2.0588031244869049e-19,
            "t4cof": -8.001934517181645e-28,
            "t5cof": 3.848122653656791e-36,
            "x1mth2": 0.6387160162749117,
            "x7thm1": 1.5289878860756185,
            "mdot": 0.0657287326223965,
            "nodedot": -0.00005442740792184453,
            "xlcof": 0.0017527974358065772,
            "xmcof": 0.0017854246095865942,
            "nodecf": 1.1063446686737322e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.144111462261591,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1125"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44951",
            "epochyr": 22,
            "epochdays": 53.55873611,
            "ndot": 4.1924263073947126e-10,
            "nddot": 0,
            "bstar": 0.0008574,
            "inclo": 0.9250733727760505,
            "nodeo": 1.8703995461922431,
            "ecco": 0.0001138,
            "argpo": 2.5957793272721106,
            "mo": 3.689250792926834,
            "no": 0.06588343270889188,
            "a": 1.0840554711805228,
            "alta": 0.0841788366931433,
            "altp": 0.08393210566790232,
            "jdsatepoch": 2459633.05873611,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000933994919702471,
            "con41": 0.08640303992439125,
            "cc1": 4.331554704214075e-9,
            "cc4": 7.139835166553453e-8,
            "cc5": 0.00015281083658676018,
            "d2": 1.1320685549793474e-15,
            "d3": 4.421711961717298e-22,
            "d4": 2.0132772766329395e-28,
            "delmo": 0.995609835209293,
            "eta": 0.0017165932122879444,
            "argpdot": 0.000036815727729345005,
            "omgcof": -0.0000015543250670700285,
            "sinmao": -0.5206893038240382,
            "t": 242503.84595140815,
            "t2cof": 6.497332056321112e-9,
            "t3cof": 1.1695932872905455e-15,
            "t4cof": 3.4654242329169688e-22,
            "t5cof": 1.2705972238101535e-28,
            "x1mth2": 0.6378656533585363,
            "x7thm1": 1.5349404264902464,
            "mdot": 0.0658873727011449,
            "nodedot": -0.00005479905569225287,
            "xlcof": 0.0017518877127017404,
            "xmcof": -0.20621948994983003,
            "nodecf": -8.305325586619057e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.171125197299645,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1126"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44952",
            "epochyr": 22,
            "epochdays": 53.52127615,
            "ndot": -2.5573921678528027e-11,
            "nddot": 0,
            "bstar": -0.00003778,
            "inclo": 0.9259757079993315,
            "nodeo": 1.979144030567002,
            "ecco": 0.0001599,
            "argpo": 0.9290981020311495,
            "mo": 5.356068153849451,
            "no": 0.06572483471464222,
            "a": 1.0858001337852197,
            "alta": 0.08597375322661205,
            "altp": 0.08562651434382751,
            "jdsatepoch": 2459633.02127615,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346295524680581,
            "con41": 0.08380164692428138,
            "cc1": -1.7324448358298743e-10,
            "cc4": 7.497053295082173e-8,
            "cc5": 0.0001390671066564596,
            "d2": 1.77089595506546e-18,
            "d3": -2.7050741303887593e-26,
            "d4": 4.816732992425448e-34,
            "delmo": 1.0042525839302734,
            "eta": 0.0023586455905313664,
            "argpdot": 0.0000364129260246675,
            "omgcof": -3.022788133466909e-8,
            "sinmao": -0.7998931485148677,
            "t": 242557.78829410672,
            "t2cof": -2.5986672537448115e-10,
            "t3cof": 1.8309232572493323e-18,
            "t4cof": -2.1221449092268902e-26,
            "t5cof": 3.043362154021255e-34,
            "x1mth2": 0.6387327843585728,
            "x7thm1": 1.5288705094899897,
            "mdot": 0.06572863479626867,
            "nodedot": -0.000054425951758520684,
            "xlcof": 0.0017528153577987824,
            "xmcof": 0.004276336029715902,
            "nodecf": 3.2992054271260774e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.9351129098180735,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1117"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44953",
            "epochyr": 22,
            "epochdays": 53.53876663,
            "ndot": -7.514612057197808e-11,
            "nddot": 0,
            "bstar": -0.00014773,
            "inclo": 0.9259495280605516,
            "nodeo": 1.9777180965681225,
            "ecco": 0.0001447,
            "argpo": 1.0712743682278596,
            "mo": 5.213890142323488,
            "no": 0.06572476376385634,
            "a": 1.0858008776478951,
            "alta": 0.08595799303489082,
            "altp": 0.08564376226089943,
            "jdsatepoch": 2459633.03876663,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934611150241776,
            "con41": 0.0838771034909096,
            "cc1": -6.774021364579183e-10,
            "cc4": 7.082648757026366e-8,
            "cc5": 0.0001390604005692563,
            "d2": 2.7074661941869736e-17,
            "d3": -1.617081843887628e-24,
            "d4": 1.1258699611583693e-31,
            "delmo": 1.0030814681784062,
            "eta": 0.002134413004951941,
            "argpdot": 0.000036418536983357956,
            "omgcof": -1.0451964450626011e-7,
            "sinmao": -0.8768618779793015,
            "t": 242532.6020027697,
            "t2cof": -1.0161032046868773e-9,
            "t3cof": 2.799240925082524e-17,
            "t4cof": -1.2686097894303852e-24,
            "t5cof": 7.113601251223272e-32,
            "x1mth2": 0.6387076321696968,
            "x7thm1": 1.529046574812122,
            "mdot": 0.06572856725258286,
            "nodedot": -0.000054427722253645935,
            "xlcof": 0.0017527884745019186,
            "xmcof": 0.020418521426613604,
            "nodecf": 1.2900618341784103e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.045309722456679,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1124"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44954",
            "epochyr": 22,
            "epochdays": 53.48626072,
            "ndot": -2.8513104620254586e-11,
            "nddot": 0,
            "bstar": -0.000044314,
            "inclo": 0.9259582547068116,
            "nodeo": 1.6326665034488435,
            "ecco": 0.0001664,
            "argpo": 0.9420466997516953,
            "mo": 5.3431335187629205,
            "no": 0.06572477301706643,
            "a": 1.0858007882689793,
            "alta": 0.08598146552014718,
            "altp": 0.08562011101781142,
            "jdsatepoch": 2459632.98626072,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346172843883787,
            "con41": 0.083851951175265,
            "cc1": -2.0320021834470794e-10,
            "cc4": 7.67682555447037e-8,
            "cc5": 0.00013906247140491656,
            "d2": 2.4362329889034356e-18,
            "d3": -4.364816082836889e-26,
            "d4": 9.115916768447223e-34,
            "delmo": 1.0043488929940487,
            "eta": 0.002454504370454385,
            "argpdot": 0.00003641664844668544,
            "omgcof": -3.347546706418905e-8,
            "sinmao": -0.8075886435101339,
            "t": 242608.21051307023,
            "t2cof": -3.0480032751706193e-10,
            "t3cof": 2.5188136463741097e-18,
            "t4cof": -3.4242225356664306e-26,
            "t5cof": 5.759723133035732e-34,
            "x1mth2": 0.6387160162749117,
            "x7thm1": 1.5289878860756185,
            "mdot": 0.06572857536817332,
            "nodedot": -0.00005442710483747591,
            "xlcof": 0.0017527974358065772,
            "xmcof": 0.004631576146840772,
            "nodecf": 3.8697529655785156e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.714502112398279,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1066"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44955",
            "epochyr": 22,
            "epochdays": 53.82536998,
            "ndot": 5.184476302365101e-11,
            "nddot": 0,
            "bstar": 0.00013374,
            "inclo": 0.9259687266823236,
            "nodeo": 1.6065127446077085,
            "ecco": 0.0001706,
            "argpo": 1.0783830942712325,
            "mo": 5.206828540169919,
            "no": 0.06572492825700203,
            "a": 1.08579909343678,
            "alta": 0.0859843307621202,
            "altp": 0.08561385611143968,
            "jdsatepoch": 2459633.32536998,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346246452703508,
            "con41": 0.08382176856382328,
            "cc1": 6.133176175021732e-10,
            "cc4": 7.79180654419864e-8,
            "cc5": 0.00013907544888312954,
            "d2": 2.219477581186862e-17,
            "d3": 1.2002413939257703e-24,
            "d4": 7.566128620927593e-32,
            "delmo": 1.0035868239747174,
            "eta": 0.002516511493242493,
            "argpdot": 0.00003641456781812897,
            "omgcof": 7.922002043014303e-8,
            "sinmao": -0.8802347984668232,
            "t": 242119.89317849278,
            "t2cof": 9.199764262532598e-10,
            "t3cof": 2.2947092811745703e-17,
            "t4cof": 9.415951480975819e-25,
            "t5cof": 4.7805128481839e-32,
            "x1mth2": 0.6387260771453922,
            "x7thm1": 1.5289174599822544,
            "mdot": 0.06572872926240421,
            "nodedot": -0.000054426641752987574,
            "xlcof": 0.0017528081891006392,
            "xmcof": -0.013299297790351244,
            "nodecf": -1.1679946632591593e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.5678367519805292,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1069"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44956",
            "epochyr": 22,
            "epochdays": 53.8216845,
            "ndot": 1.9474359553068677e-10,
            "nddot": 0,
            "bstar": 0.00045007,
            "inclo": 0.9259530187190556,
            "nodeo": 1.606648880289364,
            "ecco": 0.0001652,
            "argpo": 1.3135260684046726,
            "mo": 4.971704764658251,
            "no": 0.06572496695554446,
            "a": 1.0857986446221026,
            "alta": 0.0859780185581942,
            "altp": 0.08561927068601105,
            "jdsatepoch": 2459633.3216845,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934613603908958,
            "con41": 0.08386704254944044,
            "cc1": 2.0640215690009232e-9,
            "cc4": 7.645628491237143e-8,
            "cc5": 0.00013907826254275677,
            "d2": 2.5136840509525187e-16,
            "d3": 4.5746689568989385e-23,
            "d4": 9.705008894079615e-30,
            "delmo": 1.0018757525355002,
            "eta": 0.0024368695348995764,
            "argpdot": 0.00003641803941349153,
            "omgcof": 1.481779156833405e-7,
            "sinmao": -0.9665656504690688,
            "t": 242125.2002696693,
            "t2cof": 3.096032353501385e-9,
            "t3cof": 2.598887751698539e-16,
            "t4cof": 3.588848939090024e-23,
            "t5cof": 6.1319214991368845e-30,
            "x1mth2": 0.6387109858168531,
            "x7thm1": 1.5290230992820275,
            "mdot": 0.0657287700162058,
            "nodedot": -0.00005442786121684533,
            "xlcof": 0.0017527920590484664,
            "xmcof": -0.0477301873783359,
            "nodecf": -3.9307852371709395e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.5446167977508125,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1070"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44957",
            "epochyr": 22,
            "epochdays": 53.51573703,
            "ndot": 9.514468491774644e-12,
            "nddot": 0,
            "bstar": 0.000039993,
            "inclo": 0.9259687266823236,
            "nodeo": 1.630690790735586,
            "ecco": 0.0001488,
            "argpo": 1.2474705922044431,
            "mo": 5.037723588944189,
            "no": 0.06572531265765726,
            "a": 1.0857948595086306,
            "alta": 0.08595642578372553,
            "altp": 0.08563329323353575,
            "jdsatepoch": 2459633.01573703,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346246452703508,
            "con41": 0.08382176856382328,
            "cc1": 1.8344483387871596e-10,
            "cc4": 7.196003936800313e-8,
            "cc5": 0.00013910555166906757,
            "d2": 1.9857023056179974e-18,
            "d3": 3.2119989731373783e-26,
            "d4": 6.056531166108616e-34,
            "delmo": 1.0021062694903713,
            "eta": 0.0021950585473381017,
            "argpdot": 0.00003641506360303641,
            "omgcof": 1.8258833637797735e-8,
            "sinmao": -0.9475438299130827,
            "t": 242565.7646264881,
            "t2cof": 2.751672508180739e-10,
            "t3cof": 2.0530063197715768e-18,
            "t4cof": 2.5198226004410087e-26,
            "t5cof": 3.8266921175644714e-34,
            "x1mth2": 0.6387260771453922,
            "x7thm1": 1.5289174599822544,
            "mdot": 0.06572911371494612,
            "nodedot": -0.00005442738386845649,
            "xlcof": 0.0017528081891006392,
            "xmcof": -0.005228537134738142,
            "nodecf": -3.493548911301475e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.900214305915526,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1074"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44959",
            "epochyr": 22,
            "epochdays": 53.79587936,
            "ndot": 2.219840642380288e-10,
            "nddot": 0,
            "bstar": 0.00051029,
            "inclo": 0.9259390560850397,
            "nodeo": 1.6086071397101016,
            "ecco": 0.0001674,
            "argpo": 0.9364738634500774,
            "mo": 5.348706355064539,
            "no": 0.06572512232315589,
            "a": 1.0857969132781793,
            "alta": 0.085978675681462,
            "altp": 0.08561515087489657,
            "jdsatepoch": 2459633.29587936,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346037891719022,
            "con41": 0.08390728643700318,
            "cc1": 2.3404160074649196e-9,
            "cc4": 7.70832176791784e-8,
            "cc5": 0.00013909111917600556,
            "d2": 3.2320476739773383e-16,
            "d3": 6.669833862621357e-23,
            "d4": 1.6044994242632076e-29,
            "delmo": 1.0044086497297302,
            "eta": 0.0024693753058248496,
            "argpdot": 0.00003642128168916445,
            "omgcof": 3.8620591516163476e-7,
            "sinmao": -0.8042895610702007,
            "t": 242162.35967181623,
            "t2cof": 3.5106240111973794e-9,
            "t3cof": 3.341598615737299e-16,
            "t4cof": 5.2325104150796057e-23,
            "t5cof": 1.013770682068387e-29,
            "x1mth2": 0.6386975711876656,
            "x7thm1": 1.5291170016863411,
            "mdot": 0.06572892722710579,
            "nodedot": -0.000054429179219228044,
            "xlcof": 0.0017527777206648016,
            "xmcof": -0.05270724091541338,
            "nodecf": -4.4572665180464657e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.382034398412678,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1076"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44961",
            "epochyr": 22,
            "epochdays": 53.60419739,
            "ndot": 3.3330940576280603e-12,
            "nddot": 0,
            "bstar": 0.000026256,
            "inclo": 0.9259652360238195,
            "nodeo": 1.6236798031303248,
            "ecco": 0.0001487,
            "argpo": 1.2086038550917813,
            "mo": 5.076585090069094,
            "no": 0.06572522438036556,
            "a": 1.0857958268069297,
            "alta": 0.08595728464637586,
            "altp": 0.08563436896748344,
            "jdsatepoch": 2459633.10419739,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346221916544147,
            "con41": 0.08383182941402079,
            "cc1": 1.2042788711367045e-10,
            "cc4": 7.193155015469267e-8,
            "cc5": 0.00013909832080549715,
            "d2": 8.557599441039973e-19,
            "d3": 9.087186163252955e-27,
            "d4": 1.1248489116750001e-34,
            "delmo": 1.0023458547462696,
            "eta": 0.0021935563631498476,
            "argpdot": 0.000036415710024020084,
            "omgcof": 1.3376251999951823e-8,
            "sinmao": -0.9344104073808706,
            "t": 242438.38170848787,
            "t2cof": 1.8064183067050567e-10,
            "t3cof": 8.847656960933232e-19,
            "t4cof": 7.128928085057358e-27,
            "t5cof": 7.107126319183698e-35,
            "x1mth2": 0.6387227235286598,
            "x7thm1": 1.5289409352993815,
            "mdot": 0.06572902588129677,
            "nodedot": -0.00005442746768444585,
            "xlcof": 0.001752804604702198,
            "xmcof": -0.0034370915831803215,
            "nodecf": -2.2934488761612286e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.17436359637317622,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1080"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44963",
            "epochyr": 22,
            "epochdays": 53.48904106,
            "ndot": 4.798746417332326e-10,
            "nddot": 0,
            "bstar": 0.00096825,
            "inclo": 0.9249913423012068,
            "nodeo": 1.517054148467487,
            "ecco": 0.0002296,
            "argpo": 1.25639446066989,
            "mo": 5.02895505478217,
            "no": 0.06590033203602487,
            "a": 1.083870001911516,
            "alta": 0.08411885846395473,
            "altp": 0.08362114535907694,
            "jdsatepoch": 2459632.98904106,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009339371880978196,
            "con41": 0.08663959711869484,
            "cc1": 4.943108887116402e-9,
            "cc4": 1.0865215695814684e-7,
            "cc5": 0.00015438002540820852,
            "d2": 1.4778578638520911e-15,
            "d3": 6.603251219322784e-22,
            "d4": 3.439372883575311e-28,
            "delmo": 1.0032457942901911,
            "eta": 0.003471716110585755,
            "argpdot": 0.00003685573091648631,
            "omgcof": 3.189320028739912e-7,
            "sinmao": -0.9503100175127365,
            "t": 242604.2068232596,
            "t2cof": 7.414663330674603e-9,
            "t3cof": 1.5267265147918694e-15,
            "t4cof": 5.174614322997675e-22,
            "t5cof": 2.170354450711263e-28,
            "x1mth2": 0.637786800960435,
            "x7thm1": 1.5354923932769546,
            "mdot": 0.06590428516784243,
            "nodedot": -0.0000548378810663758,
            "xlcof": 0.0017518032723325943,
            "xmcof": -0.0576651055742498,
            "nodecf": -9.484626341123835e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.732019334373419,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1085"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44964",
            "epochyr": 22,
            "epochdays": 53.50099657,
            "ndot": -2.827069777969982e-11,
            "nddot": 0,
            "bstar": -0.000043758,
            "inclo": 0.9259582547068116,
            "nodeo": 1.6315861446418591,
            "ecco": 0.0001519,
            "argpo": 1.3666748347864037,
            "mo": 4.918533308996244,
            "no": 0.06572526583165911,
            "a": 1.0857953602161747,
            "alta": 0.08596029253139159,
            "altp": 0.08563042790095787,
            "jdsatepoch": 2459633.00099657,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346172843883787,
            "con41": 0.083851951175265,
            "cc1": -2.0070938330523103e-10,
            "cc4": 7.281921485981464e-8,
            "cc5": 0.0001391019006147094,
            "d2": 2.3770355939011867e-18,
            "d3": -4.206842822062115e-26,
            "d4": 8.678890033019142e-34,
            "delmo": 1.0013766059525204,
            "eta": 0.0022407742978601377,
            "argpdot": 0.00003641728441154783,
            "omgcof": -1.2485171118432501e-8,
            "sinmao": -0.9788273958106725,
            "t": 242586.9908890128,
            "t2cof": -3.010640749578465e-10,
            "t3cof": 2.457604106994719e-18,
            "t4cof": -3.300281478062636e-26,
            "t5cof": 5.48357638856321e-34,
            "x1mth2": 0.6387160162749117,
            "x7thm1": 1.5289878860756185,
            "mdot": 0.06572906824933489,
            "nodedot": -0.00005442805673540619,
            "xlcof": 0.0017527974358065772,
            "xmcof": 0.0054895236108124116,
            "nodecf": 3.822384261731401e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.807343686621991,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1086"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44966",
            "epochyr": 22,
            "epochdays": 53.39041687,
            "ndot": 3.7845767981613155e-11,
            "nddot": 0,
            "bstar": 0.00010273,
            "inclo": 0.9259791986578355,
            "nodeo": 1.6403476974868707,
            "ecco": 0.0001469,
            "argpo": 1.258867592219966,
            "mo": 5.026323098270161,
            "no": 0.06572547099517145,
            "a": 1.0857931305824124,
            "alta": 0.08595263359329497,
            "altp": 0.08563362757152992,
            "jdsatepoch": 2459632.89041687,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346320060498297,
            "con41": 0.08379158613493731,
            "cc1": 4.712588551424228e-10,
            "cc4": 7.143607975344399e-8,
            "cc5": 0.00013911840257317294,
            "d2": 1.3104842572091936e-17,
            "d3": 5.445737861555535e-25,
            "d4": 2.6379646114496794e-32,
            "delmo": 1.0020089435288653,
            "eta": 0.002167078108107485,
            "argpdot": 0.00003641298679003628,
            "omgcof": 4.589507718736934e-8,
            "sinmao": -0.9511260665849344,
            "t": 242746.22565731406,
            "t2cof": 7.068882827136342e-10,
            "t3cof": 1.3549012389192231e-17,
            "t4cof": 4.272193076380718e-25,
            "t5cof": 1.666740676462037e-32,
            "x1mth2": 0.6387361379550209,
            "x7thm1": 1.528847034314854,
            "mdot": 0.06572927070713745,
            "nodedot": -0.00005442692653346051,
            "xlcof": 0.0017528189420984847,
            "xmcof": -0.013781209615384017,
            "nodecf": -8.974644609629435e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.110648659411183,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1088"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44967",
            "epochyr": 22,
            "epochdays": 53.54522826,
            "ndot": 2.508910799741849e-11,
            "nddot": 0,
            "bstar": 0.000074457,
            "inclo": 0.9259861799748436,
            "nodeo": 1.6284009187569695,
            "ecco": 0.0001375,
            "argpo": 1.110790367822263,
            "mo": 5.174367161412077,
            "no": 0.06572508641471268,
            "a": 1.0857973765069069,
            "alta": 0.08594667364617647,
            "altp": 0.08564807936763708,
            "jdsatepoch": 2459633.04522826,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346369131792081,
            "con41": 0.08377146461710683,
            "cc1": 3.4147992552408206e-10,
            "cc4": 6.882955606223592e-8,
            "cc5": 0.00013908640592223375,
            "d2": 6.880497150504329e-18,
            "d3": 2.0717006973076384e-25,
            "d4": 7.271457906914311e-33,
            "delmo": 1.002714612905918,
            "eta": 0.0020282999040195007,
            "argpdot": 0.000036410969331695286,
            "omgcof": 5.139442814692647e-8,
            "sinmao": -0.8951725351601257,
            "t": 242523.29725541174,
            "t2cof": 5.122198882861231e-10,
            "t3cof": 7.113714229576194e-18,
            "t4cof": 1.62525755950132e-25,
            "t5cof": 4.594325582350743e-33,
            "x1mth2": 0.638742845127631,
            "x7thm1": 1.528800084106583,
            "mdot": 0.06572888516360906,
            "nodedot": -0.000054425674185968366,
            "xlcof": 0.0017528261105991495,
            "xmcof": -0.011398746919184981,
            "nodecf": -6.502987987668704e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.086020499893877,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1089"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44968",
            "epochyr": 22,
            "epochdays": 53.5415518,
            "ndot": -2.202872163541454e-11,
            "nddot": 0,
            "bstar": -0.000029924,
            "inclo": 0.9259652360238195,
            "nodeo": 1.6285230918046092,
            "ecco": 0.0001743,
            "argpo": 1.063481473117705,
            "mo": 5.221735397311203,
            "no": 0.06572470072119733,
            "a": 1.0858015946020154,
            "alta": 0.08599084981995464,
            "altp": 0.08561233938407642,
            "jdsatepoch": 2459633.0415518,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346221916544147,
            "con41": 0.08383182941402079,
            "cc1": -1.3720972195589177e-10,
            "cc4": 7.892310657724222e-8,
            "cc5": 0.0001390570802826382,
            "d2": 1.1107999932104245e-18,
            "d3": -1.343814478191254e-26,
            "d4": 1.8950908413012078e-34,
            "delmo": 1.0037656398269517,
            "eta": 0.002571008400515326,
            "argpdot": 0.000036415034528551414,
            "omgcof": -1.7825818635577593e-8,
            "sinmao": -0.8730633856029665,
            "t": 242528.5913579911,
            "t2cof": -2.0581458293383765e-10,
            "t3cof": 1.1484530088088509e-18,
            "t4cof": -1.054230421083676e-26,
            "t5cof": 1.1973786651048318e-34,
            "x1mth2": 0.6387227235286598,
            "x7thm1": 1.5289409352993815,
            "mdot": 0.06572850215142945,
            "nodedot": -0.000054426456585568856,
            "xlcof": 0.001752804604702198,
            "xmcof": 0.0028503944215678935,
            "nodecf": 2.6129963967504394e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.062857374276447,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1090"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44969",
            "epochyr": 22,
            "epochdays": 53.40148265,
            "ndot": -4.05728449378543e-11,
            "nddot": 0,
            "bstar": -0.000071043,
            "inclo": 0.9259826893163396,
            "nodeo": 1.6394663062146135,
            "ecco": 0.0001454,
            "argpo": 1.101606445298269,
            "mo": 5.183563301240835,
            "no": 0.06572499290212641,
            "a": 1.0857984014743018,
            "alta": 0.08595627656187621,
            "altp": 0.08564052638672748,
            "jdsatepoch": 2459632.90148265,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934634459620213,
            "con41": 0.08378152536587868,
            "cc1": -3.258049618159877e-10,
            "cc4": 7.099518589935403e-8,
            "cc5": 0.00013907918868312892,
            "d2": 6.2632419194364016e-18,
            "d3": -1.7992570359071033e-25,
            "d4": 6.0252423088694554e-33,
            "delmo": 1.0029236403458703,
            "eta": 0.002144806977487539,
            "argpdot": 0.00003641160915698729,
            "omgcof": -4.7227653068556236e-8,
            "sinmao": -0.891035839757779,
            "t": 242730.29093384743,
            "t2cof": -4.887074427239815e-10,
            "t3cof": 6.475539665724236e-18,
            "t4cof": -1.411525231501552e-25,
            "t5cof": 3.8069316924844075e-33,
            "x1mth2": 0.6387394915447071,
            "x7thm1": 1.5288235591870505,
            "mdot": 0.06572879209397012,
            "nodedot": -0.00005442574813723336,
            "xlcof": 0.0017528225263652737,
            "xmcof": 0.009725922658956212,
            "nodecf": 6.2044893408458e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.180367369201505,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1092"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44970",
            "epochyr": 22,
            "epochdays": 53.57840074,
            "ndot": -5.3693115182881115e-11,
            "nddot": 0,
            "bstar": -0.00010012,
            "inclo": 0.9259390560850397,
            "nodeo": 1.6256363172218105,
            "ecco": 0.0001316,
            "argpo": 1.368174072613867,
            "mo": 4.9169956739252365,
            "no": 0.065725411616161,
            "a": 1.0857937269122178,
            "alta": 0.08593661736667935,
            "altp": 0.08565083645775617,
            "jdsatepoch": 2459633.07840074,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346037891719022,
            "con41": 0.08390728643700318,
            "cc1": -4.592692896376579e-10,
            "cc4": 6.727828440066182e-8,
            "cc5": 0.00013911271240235257,
            "d2": 1.244640633996912e-17,
            "d3": -5.040494796779745e-25,
            "d4": 2.3795217136082377e-32,
            "delmo": 1.0011838127111303,
            "eta": 0.0019413554588324285,
            "argpdot": 0.00003642165447833588,
            "omgcof": -3.273742307820473e-8,
            "sinmao": -0.9791409730709073,
            "t": 242475.52888445556,
            "t2cof": -6.889039344564869e-10,
            "t3cof": 1.2868262900777678e-17,
            "t4cof": -3.9542804855714305e-25,
            "t5cof": 1.5034497856859857e-32,
            "x1mth2": 0.6386975711876656,
            "x7thm1": 1.5291170016863411,
            "mdot": 0.06572921655916848,
            "nodedot": -0.00005442973715091302,
            "xlcof": 0.0017527777206648016,
            "xmcof": 0.01673519844631007,
            "nodecf": 8.74676392265766e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.011834689860869219,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1093"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44972",
            "epochyr": 22,
            "epochdays": 53.48258225,
            "ndot": -4.32090193288874e-11,
            "nddot": 0,
            "bstar": -0.000076887,
            "inclo": 0.9260036332673635,
            "nodeo": 1.6329719360679424,
            "ecco": 0.0001486,
            "argpo": 1.2421804992416483,
            "mo": 5.043011936577732,
            "no": 0.06572429031108146,
            "a": 1.0858061702580004,
            "alta": 0.08596752105490069,
            "altp": 0.08564481946109992,
            "jdsatepoch": 2459632.98258225,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346491808033587,
            "con41": 0.0837211611775529,
            "cc1": -3.524555858567117e-10,
            "cc4": 7.181266860734934e-8,
            "cc5": 0.00013902189388478525,
            "d2": 7.329089687488764e-18,
            "d3": -2.2774457676287987e-25,
            "d4": 8.24960776450514e-33,
            "delmo": 1.0021361022098332,
            "eta": 0.0021917956401243215,
            "argpdot": 0.000036406140056578955,
            "omgcof": -3.567757738182435e-8,
            "sinmao": -0.9458402953626825,
            "t": 242613.5075097531,
            "t2cof": -5.286833787850676e-10,
            "t3cof": 7.57753956749196e-18,
            "t4cof": -1.7866742780597631e-25,
            "t5cof": 5.212379991095871e-33,
            "x1mth2": 0.6387596129408157,
            "x7thm1": 1.5286827094142903,
            "mdot": 0.06572808667479571,
            "nodedot": -0.00005442286398737688,
            "xlcof": 0.0017528440312748249,
            "xmcof": 0.010074269739218914,
            "nodecf": 6.711658014182256e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.69132632429357,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1107"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "44973",
            "epochyr": 22,
            "epochdays": 53.46045986,
            "ndot": -1.9574352374797518e-11,
            "nddot": 0,
            "bstar": -0.000024466,
            "inclo": 0.9259896706333476,
            "nodeo": 1.635036660573052,
            "ecco": 0.0001433,
            "argpo": 1.1358724945026735,
            "mo": 5.149298997365682,
            "no": 0.06572494892041747,
            "a": 1.0857988959390437,
            "alta": 0.08595449092083163,
            "altp": 0.0856433009572557,
            "jdsatepoch": 2459632.96045986,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934639366726815,
            "con41": 0.08376140388862108,
            "cc1": -1.12198532707896e-10,
            "cc4": 7.040944591914326e-8,
            "cc5": 0.00013907547176234951,
            "d2": 7.427719406363988e-19,
            "d3": -7.348121372707737e-27,
            "d4": 8.473921476849481e-35,
            "delmo": 1.0026857332731054,
            "eta": 0.002113816742828147,
            "argpdot": 0.000036410031574001015,
            "omgcof": -1.537737368009317e-8,
            "sinmao": -0.9060634875609502,
            "t": 242645.36375150084,
            "t2cof": -1.68297799061844e-10,
            "t3cof": 7.679489621200084e-19,
            "t4cof": -5.7646358262443244e-27,
            "t5cof": 5.354083506200717e-35,
            "x1mth2": 0.638746198703793,
            "x7thm1": 1.5287766090734491,
            "mdot": 0.0657287471952036,
            "nodedot": -0.00005442515423403048,
            "xlcof": 0.001752829694800112,
            "xmcof": 0.003448261197744183,
            "nodecf": 2.1366373512362146e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.55194668096776,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1115"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45157",
            "epochyr": 22,
            "epochdays": 53.33328368,
            "ndot": 1.1665829201698211e-11,
            "nddot": 0,
            "bstar": 0.0010656,
            "inclo": 1.5340117674798641,
            "nodeo": 6.101491296059221,
            "ecco": 0.0001383,
            "argpo": 1.3685789890003295,
            "mo": 4.916845575609566,
            "no": 0.057208591090595846,
            "a": 1.191544674049761,
            "alta": 0.19170946467818206,
            "altp": 0.19137988342133982,
            "jdsatepoch": 2459632.83328368,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011686541781524972,
            "con41": -0.9959425191476151,
            "cc1": 1.313703461313182e-10,
            "cc4": -3.322955561102952e-9,
            "cc5": 0.000004376399055965874,
            "d2": 4.597052117962507e-19,
            "d3": 2.3928441639862477e-27,
            "d4": 1.4503578565998782e-35,
            "delmo": 1.0005610744854865,
            "eta": 0.0009209730628858814,
            "argpdot": -0.00003244702981710399,
            "omgcof": 4.250618576440187e-9,
            "sinmao": -0.9791714593279682,
            "t": 242828.49745072424,
            "t2cof": 1.970555191969773e-10,
            "t3cof": 4.942215474815754e-19,
            "t4cof": 1.9814760500735263e-27,
            "t5cof": 9.758674387541077e-36,
            "x1mth2": 0.9986475063825383,
            "x7thm1": -0.9905325446777684,
            "mdot": 0.05717600158901766,
            "nodedot": -0.000002401745730737113,
            "xlcof": 0.0017944354714147823,
            "xmcof": -0.010246437225755516,
            "nodecf": -1.1073239757634104e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.750687389915058,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ONEWEB-0053"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45158",
            "epochyr": 22,
            "epochdays": 53.36914386,
            "ndot": -3.908810303945634e-12,
            "nddot": 0,
            "bstar": -0.00040494,
            "inclo": 1.5339943141873442,
            "nodeo": 6.101318508463273,
            "ecco": 0.0001914,
            "argpo": 1.5196442170774467,
            "mo": 4.7658920486045755,
            "no": 0.05720822242993846,
            "a": 1.1915497874519565,
            "alta": 0.1917778500812748,
            "altp": 0.1913217248226382,
            "jdsatepoch": 2459632.86914386,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001168653427346286,
            "con41": -0.9959386696400853,
            "cc1": -4.99166354153412e-11,
            "cc4": -3.138768979066856e-9,
            "cc5": 0.0000043759396322597694,
            "d2": 6.636892591505475e-20,
            "d3": -1.3126141758982686e-28,
            "d4": 3.022979053899383e-37,
            "delmo": 1.0002044929999752,
            "eta": 0.0012745477848160756,
            "argpdot": -0.000032446334850582904,
            "omgcof": -2.970867610024805e-10,
            "sinmao": -0.9985690522443923,
            "t": 242776.85879163444,
            "t2cof": -7.487495312301179e-11,
            "t3cof": 7.135226689743094e-20,
            "t4cof": -1.086957431445084e-28,
            "t5cof": 2.0340049463965832e-37,
            "x1mth2": 0.9986462232133618,
            "x7thm1": -0.9905235624935325,
            "mdot": 0.05717563354324211,
            "nodedot": -0.0000024028488157736323,
            "xlcof": 0.0017944532809020888,
            "xmcof": 0.002032781522506542,
            "nodecf": 4.2094180628129575e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.976620440724602,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ONEWEB-0054"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45159",
            "epochyr": 22,
            "epochdays": 53.80859944,
            "ndot": 2.015006862111509e-11,
            "nddot": 0,
            "bstar": 0.001868,
            "inclo": 1.5339995501751,
            "nodeo": 6.099690116271162,
            "ecco": 0.0001652,
            "argpo": 1.2282475358229776,
            "mo": 5.057215426030461,
            "no": 0.05720835511386183,
            "a": 1.1915479469845744,
            "alta": 0.1917447907054164,
            "altp": 0.19135110326373272,
            "jdsatepoch": 2459633.30859944,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011686536526255285,
            "con41": -0.9959398246837338,
            "cc1": 2.3027597549746737e-10,
            "cc4": -3.2295737813244174e-9,
            "cc5": 0.000004376101056275275,
            "d2": 1.4124570218826577e-18,
            "d3": 1.2887085247900668e-26,
            "d4": 1.369178009077993e-34,
            "delmo": 1.0011160157376087,
            "eta": 0.001100089532145586,
            "argpdot": -0.00003244657227477065,
            "omgcof": 1.0431489607887339e-8,
            "sinmao": -0.94113413393902,
            "t": 242144.04275648296,
            "t2cof": 3.4541396324620105e-10,
            "t3cof": 1.5185110716652781e-18,
            "t4cof": 1.0671605816323767e-26,
            "t5cof": 9.212475501339891e-35,
            "x1mth2": 0.9986466082279113,
            "x7thm1": -0.9905262575953789,
            "mdot": 0.05717576601354938,
            "nodedot": -0.000002402520035105011,
            "xlcof": 0.0017944479381841185,
            "xmcof": -0.012587942927332323,
            "nodecf": -1.94162773633247e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.4621758396471236,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ONEWEB-0056"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45160",
            "epochyr": 22,
            "epochdays": 53.50940648,
            "ndot": 2.414978149026876e-11,
            "nddot": 0,
            "bstar": 0.0022469,
            "inclo": 1.5339995501751,
            "nodeo": 6.1003323974358965,
            "ecco": 0.0001406,
            "argpo": 1.2749316026553217,
            "mo": 5.0104894712960695,
            "no": 0.057208306834676634,
            "a": 1.1915486168508325,
            "alta": 0.19171614858636166,
            "altp": 0.19138108511530327,
            "jdsatepoch": 2459633.00940648,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011686536526255285,
            "con41": -0.9959398246837338,
            "cc1": 2.7697979803324843e-10,
            "cc4": -3.314603013331568e-9,
            "cc5": 0.000004376028244651781,
            "d2": 2.0434912680702195e-18,
            "d3": 2.242592238683361e-26,
            "d4": 2.865850920191854e-34,
            "delmo": 1.0008251899846836,
            "eta": 0.0009362717660960114,
            "argpdot": -0.000032446507979120804,
            "omgcof": 1.2797122171652057e-8,
            "sinmao": -0.955896108615576,
            "t": 242574.88061875105,
            "t2cof": 4.1546969704987267e-10,
            "t3cof": 2.1969268851072977e-18,
            "t4cof": 1.857058239403614e-26,
            "t5cof": 1.928280388722314e-34,
            "x1mth2": 0.9986466082279113,
            "x7thm1": -0.9905262575953789,
            "mdot": 0.05717571779888152,
            "nodedot": -0.000002402515275523434,
            "xlcof": 0.0017944479381841185,
            "xmcof": -0.020902871778552615,
            "nodecf": -2.3354177267933222e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.86032938288956,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ONEWEB-0057"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45161",
            "epochyr": 22,
            "epochdays": 53.80235654,
            "ndot": 1.9756157505213593e-11,
            "nddot": 0,
            "bstar": 0.0018323,
            "inclo": 1.5340152581383681,
            "nodeo": 6.0998070533310464,
            "ecco": 0.0001473,
            "argpo": 1.4517194932483315,
            "mo": 4.833726015312587,
            "no": 0.05720839673358078,
            "a": 1.1915473710822093,
            "alta": 0.19172288600996978,
            "altp": 0.19137185615444885,
            "jdsatepoch": 2459633.30235654,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011686543282710205,
            "con41": -0.9959432888303899,
            "cc1": 2.2587772661426881e-10,
            "cc4": -3.291561267270202e-9,
            "cc5": 0.00000437614826071369,
            "d2": 1.359020439952876e-18,
            "d3": 1.2162740121881156e-26,
            "d4": 1.2675427713752209e-34,
            "delmo": 1.0003562229828713,
            "eta": 0.0009808936613198338,
            "argpdot": -0.00003244681486693171,
            "omgcof": 4.058688641970542e-9,
            "sinmao": -0.9926476890959126,
            "t": 242153.0325320363,
            "t2cof": 3.3881658992140325e-10,
            "t3cof": 1.4610619347137366e-18,
            "t4cof": 1.0071783559678634e-26,
            "t5cof": 8.528622994277836e-35,
            "x1mth2": 0.9986477629434632,
            "x7thm1": -0.990534340604243,
            "mdot": 0.0571758074649563,
            "nodedot": -0.0000024014989204677126,
            "xlcof": 0.0017944319093707813,
            "xmcof": -0.015530787796031571,
            "nodecf": -1.903733402609332e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.4228431487364546,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ONEWEB-0058"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45162",
            "epochyr": 22,
            "epochdays": 53.34108785,
            "ndot": 1.9574352374797518e-11,
            "nddot": 0,
            "bstar": 0.0018145,
            "inclo": 1.534006531492108,
            "nodeo": 6.101327235109534,
            "ecco": 0.0001638,
            "argpo": 1.4412963869554214,
            "mo": 4.844180537532034,
            "no": 0.05720847780551272,
            "a": 1.191546245346648,
            "alta": 0.1917414206216359,
            "altp": 0.1913510700716603,
            "jdsatepoch": 2459632.84108785,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001168653952948013,
            "con41": -0.9959413644867459,
            "cc1": 2.236894226112144e-10,
            "cc4": -3.2345847312097008e-9,
            "cc5": 0.000004376260869242695,
            "d2": 1.332822732915723e-18,
            "d3": 1.181278262338486e-26,
            "d4": 1.2191518284105485e-34,
            "delmo": 1.0004300793143885,
            "eta": 0.0010907755652130617,
            "argpdot": -0.000032446817943994166,
            "omgcof": 3.929195794903939e-9,
            "sinmao": -0.991328055567995,
            "t": 242817.2594462335,
            "t2cof": 3.355341339168216e-10,
            "t3cof": 1.4328966484919999e-18,
            "t4cof": 9.781983855737828e-27,
            "t5cof": 8.203020974857136e-35,
            "x1mth2": 0.9986471214955819,
            "x7thm1": -0.9905298504690734,
            "mdot": 0.05717588849184408,
            "nodedot": -0.0000024020764087864923,
            "xlcof": 0.001794440814389196,
            "xmcof": -0.012437703016990752,
            "nodecf": -1.885743374170004e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.799856688351085,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ONEWEB-0059"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45163",
            "epochyr": 22,
            "epochdays": 53.52030194,
            "ndot": -6.96919666594958e-13,
            "nddot": 0,
            "bstar": -0.00010176,
            "inclo": 1.533996059516596,
            "nodeo": 6.10058023418968,
            "ecco": 0.0001738,
            "argpo": 1.25088096556284,
            "mo": 5.034602940241623,
            "no": 0.05720825036091992,
            "a": 1.1915494000802669,
            "alta": 0.19175649136600081,
            "altp": 0.19134230879453296,
            "jdsatepoch": 2459633.02030194,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011686535024429269,
            "con41": -0.9959390546728623,
            "cc1": -1.2543965510618273e-11,
            "cc4": -3.1996848293318644e-9,
            "cc5": 0.000004375967864802542,
            "d2": 4.191260774285288e-21,
            "d3": -2.0830866579997075e-30,
            "d4": 1.2055791825981612e-39,
            "delmo": 1.0010998880163946,
            "eta": 0.0011573501203137717,
            "argpdot": -0.0000324463922393253,
            "omgcof": -5.05701568681285e-10,
            "sinmao": -0.9485366545199753,
            "t": 242559.19115647674,
            "t2cof": -1.881594826592741e-11,
            "t3cof": 4.505962915748449e-21,
            "t4cof": -1.7249746013064957e-30,
            "t5cof": 8.111711853788331e-40,
            "x1mth2": 0.9986463515576208,
            "x7thm1": -0.9905244609033456,
            "mdot": 0.057175661424833754,
            "nodedot": -0.000002402737612138875,
            "xlcof": 0.0017944515000083107,
            "xmcof": 0.0006195329539834134,
            "nodecf": 1.057770647773559e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.928975008854124,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ONEWEB-0062"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45164",
            "epochyr": 22,
            "epochdays": 53.80392975,
            "ndot": 1.9756157505213593e-11,
            "nddot": 0,
            "bstar": 0.0018311,
            "inclo": 1.534048419394156,
            "nodeo": 6.09813851856614,
            "ecco": 0.0001576,
            "argpo": 1.3030994714532582,
            "mo": 4.982356509083173,
            "no": 0.05720837503979772,
            "a": 1.1915476754010568,
            "alta": 0.19173546331470015,
            "altp": 0.19135988748741362,
            "jdsatepoch": 2459633.30392975,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001168655753686785,
            "con41": -0.995950597180336,
            "cc1": 2.257284037750273e-10,
            "cc4": -3.2559306879411747e-9,
            "cc5": 0.000004376123945566259,
            "d2": 1.3572222546044593e-18,
            "d3": 1.2138599619337289e-26,
            "d4": 1.264188854141326e-34,
            "delmo": 1.0008399256151683,
            "eta": 0.0010494814654480808,
            "argpdot": -0.000032447182912328245,
            "omgcof": 8.440881088170203e-9,
            "sinmao": -0.9637795569747007,
            "t": 242150.76711013913,
            "t2cof": 3.3859260566254095e-10,
            "t3cof": 1.4591288791461029e-18,
            "t4cof": 1.005179457841725e-26,
            "t5cof": 8.506057660153379e-35,
            "x1mth2": 0.998650199060112,
            "x7thm1": -0.9905513934207838,
            "mdot": 0.05717578556084897,
            "nodedot": -0.0000023993325876975623,
            "xlcof": 0.0017943980675165284,
            "xmcof": -0.013558128042300008,
            "nodecf": -1.900758740019192e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.432754980095659,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ONEWEB-0065"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45178",
            "epochyr": 22,
            "epochdays": 53.66133351,
            "ndot": 4.942069461810333e-11,
            "nddot": 0,
            "bstar": 0.00012838,
            "inclo": 0.9260001426088595,
            "nodeo": 3.36424430626671,
            "ecco": 0.0001287,
            "argpo": 1.3919506930137855,
            "mo": 4.893213817537562,
            "no": 0.06572519608323771,
            "a": 1.08579618864336,
            "alta": 0.08593593061283844,
            "altp": 0.08565644667388161,
            "jdsatepoch": 2459633.16133351,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346467273013054,
            "con41": 0.08373122182488735,
            "cc1": 5.888218437841541e-10,
            "cc4": 6.640649316930572e-8,
            "cc5": 0.000139094924841791,
            "d2": 2.0458035710002927e-17,
            "d3": 1.0621761083546065e-24,
            "d4": 6.428600233184629e-32,
            "delmo": 1.0010246438913024,
            "eta": 0.0018985177515250732,
            "argpdot": 0.000036408069203139754,
            "omgcof": 3.793989936042178e-8,
            "sinmao": -0.9836956878791191,
            "t": 242356.10569529235,
            "t2cof": 8.832327656762312e-10,
            "t3cof": 2.1151458037437668e-17,
            "t4cof": 8.332808739535543e-25,
            "t5cof": 4.061779565825295e-32,
            "x1mth2": 0.6387562593917042,
            "x7thm1": 1.5287061842580707,
            "mdot": 0.06572899302468628,
            "nodedot": -0.00005442486816750855,
            "xlcof": 0.0017528404472055175,
            "xmcof": -0.02243464046914197,
            "nodecf": -1.1213090134015287e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.5343433285826436,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1138"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45179",
            "epochyr": 22,
            "epochdays": 53.53232749,
            "ndot": -2.2604437881732115e-11,
            "nddot": 0,
            "bstar": -0.00003119,
            "inclo": 0.9259512733898037,
            "nodeo": 3.3744911343051687,
            "ecco": 0.0001564,
            "argpo": 1.2212679641442523,
            "mo": 5.063938434309144,
            "no": 0.06572502819878326,
            "a": 1.0857979675567269,
            "alta": 0.08596778635885283,
            "altp": 0.08562814875460112,
            "jdsatepoch": 2459633.03232749,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346123770767906,
            "con41": 0.08387207301763966,
            "cc1": -1.430422344283572e-10,
            "cc4": 7.404788827144864e-8,
            "cc5": 0.00013908272320885593,
            "d2": 1.2072980739539709e-18,
            "d3": -1.5227102400477175e-26,
            "d4": 2.2387588474484874e-34,
            "delmo": 1.0023852433061664,
            "eta": 0.002307080211608114,
            "argpdot": 0.000036418498483697146,
            "omgcof": -1.459912610953749e-8,
            "sinmao": -0.9388402810802391,
            "t": 242541.87436446548,
            "t2cof": -2.1456335164253581e-10,
            "t3cof": 1.248220235614485e-18,
            "t4cof": -1.1945727639518113e-26,
            "t5cof": 1.4145156992546813e-34,
            "x1mth2": 0.6387093089941202,
            "x7thm1": 1.5290348370411588,
            "mdot": 0.06572883149548996,
            "nodedot": -0.000054428106474306,
            "xlcof": 0.0017527902667793067,
            "xmcof": 0.0036905173032212176,
            "nodecf": 2.7241519058838633e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.004740641005284,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1143"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45180",
            "epochyr": 22,
            "epochdays": 53.78939428,
            "ndot": 2.3604366099020535e-11,
            "nddot": 0,
            "bstar": 0.000071211,
            "inclo": 0.9259687266823236,
            "nodeo": 3.3542488056405384,
            "ecco": 0.0001544,
            "argpo": 1.2609043914570435,
            "mo": 5.024302006996352,
            "no": 0.06572522357059087,
            "a": 1.085795840742192,
            "alta": 0.08596348762000261,
            "altp": 0.08562819386438125,
            "jdsatepoch": 2459633.28939428,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346246452703508,
            "con41": 0.08382176856382328,
            "cc1": 3.266224710123552e-10,
            "cc4": 7.349143838938562e-8,
            "cc5": 0.00013909859088121973,
            "d2": 6.29491531455423e-18,
            "d3": 1.8129520040917592e-25,
            "d4": 6.086533518043553e-33,
            "delmo": 1.002098351881182,
            "eta": 0.0022776399745480093,
            "argpdot": 0.00003641494870780567,
            "omgcof": 3.0071293797139883e-8,
            "sinmao": -0.9517482423388791,
            "t": 242171.6981868446,
            "t2cof": 4.899337065185328e-10,
            "t3cof": 6.5082797916946636e-18,
            "t4cof": 1.4222669473237893e-25,
            "t5cof": 3.8456509458680824e-33,
            "x1mth2": 0.6387260771453922,
            "x7thm1": 1.5289174599822544,
            "mdot": 0.06572902461585514,
            "nodedot": -0.00005442721188757781,
            "xlcof": 0.0017528081891006392,
            "xmcof": -0.008646429579252097,
            "nodecf": -6.220224069287957e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3411758783051013,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1192"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45181",
            "epochyr": 22,
            "epochdays": 53.78299045,
            "ndot": 4.2615122569528217e-10,
            "nddot": 0,
            "bstar": 0.0009631,
            "inclo": 0.9260106145843715,
            "nodeo": 3.354727025855585,
            "ecco": 0.0002061,
            "argpo": 1.2070313134357344,
            "mo": 5.078264096809513,
            "no": 0.06572205405424199,
            "a": 1.0858308124503466,
            "alta": 0.08605460218079264,
            "altp": 0.08560702271990062,
            "jdsatepoch": 2459633.28299045,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346540877733003,
            "con41": 0.08370103994374989,
            "cc1": 4.409060859608854e-9,
            "cc4": 8.742178616291264e-8,
            "cc5": 0.00013884310095921398,
            "d2": 1.146563197917931e-15,
            "d3": 4.455554488690233e-22,
            "d4": 2.0183322236659047e-28,
            "delmo": 1.003265254107178,
            "eta": 0.0030389517944363078,
            "argpdot": 0.00003640173449173479,
            "omgcof": 3.5462746633361114e-7,
            "sinmao": -0.9338110313247212,
            "t": 242180.91970190406,
            "t2cof": 6.61359128941328e-9,
            "t3cof": 1.1854428332454007e-15,
            "t4cof": 3.4954666575673895e-22,
            "t5cof": 1.2752708423366056e-28,
            "x1mth2": 0.63876632001875,
            "x7thm1": 1.52863575986875,
            "mdot": 0.06572584920535224,
            "nodedot": -0.0000544180361051394,
            "xlcof": 0.0017528511993146986,
            "xmcof": -0.0655341969503392,
            "nodecf": -8.395237995546651e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3008292645983133,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1200"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45182",
            "epochyr": 22,
            "epochdays": 53.60419744,
            "ndot": 4.045164151757691e-11,
            "nddot": 0,
            "bstar": 0.00010849,
            "inclo": 0.9259687266823236,
            "nodeo": 3.020046179151656,
            "ecco": 0.0001668,
            "argpo": 1.1897700071335107,
            "mo": 5.0954503539539004,
            "no": 0.06572532081594011,
            "a": 1.0857947696504282,
            "alta": 0.08597588021800573,
            "altp": 0.08561365908285046,
            "jdsatepoch": 2459633.10419744,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346246452703508,
            "con41": 0.08382176856382328,
            "cc1": 4.976410370385843e-10,
            "cc4": 7.689860973361503e-8,
            "cc5": 0.00013910732546498729,
            "d2": 1.4612887324766872e-17,
            "d3": 6.412221117304503e-25,
            "d4": 3.279957722276263e-32,
            "delmo": 1.0027615641513008,
            "eta": 0.0024605926233166294,
            "argpdot": 0.000036415074548831114,
            "omgcof": 5.171738220543646e-8,
            "sinmao": -0.9275247595060039,
            "t": 242438.38163606822,
            "t2cof": 7.464615555578764e-10,
            "t3cof": 1.5108180528256547e-17,
            "t4cof": 5.030405987843911e-25,
            "t5cof": 2.072372333062987e-32,
            "x1mth2": 0.6387260771453922,
            "x7thm1": 1.5289174599822544,
            "mdot": 0.0657291218743635,
            "nodedot": -0.000054427400253370804,
            "xlcof": 0.0017528081891006392,
            "xmcof": -0.011287592417581267,
            "nodecf": -9.477147869541248e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.1743639132265784,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1201"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45183",
            "epochyr": 22,
            "epochdays": 53.75348295,
            "ndot": 3.33309405762806e-11,
            "nddot": 0,
            "bstar": 0.000092743,
            "inclo": 0.9259739626700796,
            "nodeo": 3.357205393393417,
            "ecco": 0.0001416,
            "argpo": 1.2313036073432198,
            "mo": 5.053874865842144,
            "no": 0.0657252006077269,
            "a": 1.0857961011875152,
            "alta": 0.08594984991544341,
            "altp": 0.08564235245958707,
            "jdsatepoch": 2459633.25348295,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934628325672902,
            "con41": 0.08380667732656011,
            "cc1": 4.25374973753482e-10,
            "cc4": 6.997330456666763e-8,
            "cc5": 0.00013909597394721213,
            "d2": 1.0676778952202378e-17,
            "d3": 4.0046184615260995e-25,
            "d4": 1.7509322183788313e-32,
            "delmo": 1.002100021105776,
            "eta": 0.0020888133898527266,
            "argpdot": 0.000036413778195181335,
            "omgcof": 4.6631914393861806e-8,
            "sinmao": -0.9422581013573372,
            "t": 242223.41050207615,
            "t2cof": 6.380624606302231e-10,
            "t3cof": 1.103866668879393e-17,
            "t4cof": 3.1416371079721983e-25,
            "t5cof": 1.106290672249519e-32,
            "x1mth2": 0.6387311075578133,
            "x7thm1": 1.5288822470953067,
            "mdot": 0.06572900096651875,
            "nodedot": -0.00005442678546709977,
            "xlcof": 0.0017528135656365892,
            "xmcof": -0.013388575497059994,
            "nodecf": -8.100811477767808e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.1149205620105462,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1202"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45184",
            "epochyr": 22,
            "epochdays": 53.74426394,
            "ndot": 2.0301572896461823e-11,
            "nddot": 0,
            "bstar": 0.000063849,
            "inclo": 0.9259809439870875,
            "nodeo": 3.0086683777579046,
            "ecco": 0.00015,
            "argpo": 1.1032522907828997,
            "mo": 5.181927927731716,
            "no": 0.06572548596892713,
            "a": 1.085792968165573,
            "alta": 0.0859558371107978,
            "altp": 0.08563009922034803,
            "jdsatepoch": 2459633.24426394,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346332328364449,
            "con41": 0.08378655574787275,
            "cc1": 2.929008520375474e-10,
            "cc4": 7.228545058651329e-8,
            "cc5": 0.00013911980751129296,
            "d2": 5.062382283417264e-18,
            "d3": 1.3075005591812489e-25,
            "d4": 3.936553324666165e-33,
            "delmo": 1.0030067388619281,
            "eta": 0.002212814126413413,
            "argpdot": 0.00003641262598943103,
            "omgcof": 4.102535576550649e-8,
            "sinmao": -0.891776997851168,
            "t": 242236.68587632477,
            "t2cof": 4.3935127805632104e-10,
            "t3cof": 5.2339641016659066e-18,
            "t4cof": 1.0257369076700075e-25,
            "t5cof": 2.4872254972483902e-33,
            "x1mth2": 0.6387378147507091,
            "x7thm1": 1.528835296745036,
            "mdot": 0.0657292854551363,
            "nodedot": -0.00005442682835859879,
            "xlcof": 0.0017528207342359936,
            "xmcof": -0.008215012124830428,
            "nodecf": -5.5779882404697174e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.0568372217905093,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1205"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45185",
            "epochyr": 22,
            "epochdays": 53.54708387,
            "ndot": -3.969412014084326e-11,
            "nddot": 0,
            "bstar": -0.000069083,
            "inclo": 0.9259774533285836,
            "nodeo": 3.37335492496212,
            "ecco": 0.0001236,
            "argpo": 1.4915077642060461,
            "mo": 4.793649765028293,
            "no": 0.06572498401708511,
            "a": 1.085798491813785,
            "alta": 0.08593269650737323,
            "altp": 0.08566428712019691,
            "jdsatepoch": 2459633.04708387,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346307792603676,
            "con41": 0.08379661652707349,
            "cc1": -3.1681271225987645e-10,
            "cc4": 6.5021466064791e-8,
            "cc5": 0.00013907732020903565,
            "d2": 5.922273494030401e-18,
            "d3": -1.6543479117809662e-25,
            "d4": 5.387068770452229e-33,
            "delmo": 1.0004440482965813,
            "eta": 0.0018232311821406541,
            "argpdot": 0.00003641273783630595,
            "omgcof": -9.463397811561374e-9,
            "sinmao": -0.9967001588634725,
            "t": 242520.6251771003,
            "t2cof": -4.752190683898147e-10,
            "t3cof": 6.123014083329319e-18,
            "t4cof": -1.2978434443193365e-25,
            "t5cof": 3.403714422627409e-33,
            "x1mth2": 0.6387344611576422,
            "x7thm1": 1.528858771896505,
            "mdot": 0.06572878389103576,
            "nodedot": -0.000054426111958722136,
            "xlcof": 0.0017528171499527477,
            "xmcof": 0.013087925327954636,
            "nodecf": 6.033284880494872e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.097711562663264,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1216"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45186",
            "epochyr": 22,
            "epochdays": 53.76086707,
            "ndot": 5.896546396494731e-11,
            "nddot": 0,
            "bstar": 0.00014952,
            "inclo": 0.9259757079993315,
            "nodeo": 3.3566137267769904,
            "ecco": 0.0001569,
            "argpo": 1.255774868785432,
            "mo": 5.029435020326467,
            "no": 0.06572474021779584,
            "a": 1.0858011746166836,
            "alta": 0.0859715368209808,
            "altp": 0.08563081241238613,
            "jdsatepoch": 2459633.26086707,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346295524680581,
            "con41": 0.08380164692428138,
            "cc1": 6.85601064810584e-10,
            "cc4": 7.414287628283514e-8,
            "cc5": 0.00013905919019857125,
            "d2": 2.773393281648194e-17,
            "d3": 1.676501349059553e-24,
            "d4": 1.181363712861508e-31,
            "delmo": 1.002166147701588,
            "eta": 0.002314362824197435,
            "argpdot": 0.00003641280395883615,
            "omgcof": 6.31054733970471e-8,
            "sinmao": -0.9501604923326056,
            "t": 242212.7773692459,
            "t2cof": 1.0284015972158759e-9,
            "t3cof": 2.867403045662075e-17,
            "t4cof": 1.3152249183346419e-24,
            "t5cof": 7.464229532328268e-32,
            "x1mth2": 0.6387327843585728,
            "x7thm1": 1.5288705094899897,
            "mdot": 0.06572854028665498,
            "nodedot": -0.000054425769038071886,
            "xlcof": 0.0017528153577987824,
            "xmcof": -0.017576862771478026,
            "nodecf": -1.3056295453840384e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.1614433839214584,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1224"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45187",
            "epochyr": 22,
            "epochdays": 53.56550183,
            "ndot": 2.045307717180855e-11,
            "nddot": 0,
            "bstar": 0.000064209,
            "inclo": 0.9259861799748436,
            "nodeo": 3.3717614393550495,
            "ecco": 0.0001368,
            "argpo": 1.123498110106034,
            "mo": 5.1616594191283065,
            "no": 0.06572496037527802,
            "a": 1.0857987647544656,
            "alta": 0.08594730202548395,
            "altp": 0.0856502274834472,
            "jdsatepoch": 2459633.06550183,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346369131792081,
            "con41": 0.08377146461710683,
            "cc1": 2.944573411877613e-10,
            "cc4": 6.863106742436216e-8,
            "cc5": 0.00013907605470462196,
            "d2": 5.115953646645408e-18,
            "d3": 1.3282607461135028e-25,
            "d4": 4.0200120819068766e-33,
            "delmo": 1.0026315284451304,
            "eta": 0.0020179385375727324,
            "argpdot": 0.000036410806608480514,
            "omgcof": 4.339714628939157e-8,
            "sinmao": -0.9007641966902672,
            "t": 242494.10331465304,
            "t2cof": 4.4168601178164195e-10,
            "t3cof": 5.28936389820414e-18,
            "t4cof": 1.0420267368581668e-25,
            "t5cof": 2.539966727613784e-33,
            "x1mth2": 0.638742845127631,
            "x7thm1": 1.528800084106583,
            "mdot": 0.06572875910715759,
            "nodedot": -0.00005442543059370537,
            "xlcof": 0.0017528261105991495,
            "xmcof": -0.009930144300579329,
            "nodecf": -5.6074862414609234e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.213751858868292,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1225"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45188",
            "epochyr": 22,
            "epochdays": 53.79403313,
            "ndot": -8.575141984624917e-12,
            "nddot": 0,
            "bstar": -9.4285e-8,
            "inclo": 0.9259791986578355,
            "nodeo": 2.6560490370019787,
            "ecco": 0.0001502,
            "argpo": 1.094515172547416,
            "mo": 5.190663300637948,
            "no": 0.06572484498623382,
            "a": 1.0858000256657507,
            "alta": 0.08596311282960567,
            "altp": 0.0856369385018958,
            "jdsatepoch": 2459633.29403313,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346320060498297,
            "con41": 0.08379158613493731,
            "cc1": -4.3235559564487173e-13,
            "cc4": 7.230739490197751e-8,
            "cc5": 0.0001390673616719752,
            "d2": 1.1029530011865265e-23,
            "d3": -4.204607162160771e-34,
            "d4": 1.8684484557805705e-44,
            "delmo": 1.003062249365538,
            "eta": 0.0022155664493143062,
            "argpdot": 0.0000364121786856701,
            "omgcof": -6.151542836128033e-11,
            "sinmao": -0.8877904846323994,
            "t": 242165.01824252307,
            "t2cof": -6.485333934673076e-13,
            "t3cof": 1.1403392734036128e-23,
            "t4cof": -3.2985362626586377e-34,
            "t5cof": 1.1805439297939055e-44,
            "x1mth2": 0.6387361379550209,
            "x7thm1": 1.528847034314854,
            "mdot": 0.06572864461367177,
            "nodedot": -0.000054425716862532403,
            "xlcof": 0.0017528189420984847,
            "xmcof": 0.000012095159109999097,
            "nodecf": 8.233588702320601e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3704024350455697,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1228"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45189",
            "epochyr": 22,
            "epochdays": 53.76822731,
            "ndot": 3.769426370626642e-11,
            "nddot": 0,
            "bstar": 0.00010238,
            "inclo": 0.9259774533285836,
            "nodeo": 3.3561005999769042,
            "ecco": 0.0001393,
            "argpo": 1.1617731806022695,
            "mo": 5.123394820607582,
            "no": 0.06572516589950761,
            "a": 1.0857964884921039,
            "alta": 0.08594773994295091,
            "altp": 0.08564523704125704,
            "jdsatepoch": 2459633.26822731,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346307792603676,
            "con41": 0.08379661652707349,
            "cc1": 4.69565644758927e-10,
            "cc4": 6.933679371532525e-8,
            "cc5": 0.0001390930076590487,
            "d2": 1.3010287919941143e-17,
            "d3": 5.386790312523673e-25,
            "d4": 2.599923242875939e-32,
            "delmo": 1.00246498509486,
            "eta": 0.0020548749755658876,
            "argpdot": 0.000036412972947910636,
            "omgcof": 6.249328213540076e-8,
            "sinmao": -0.9167194216567011,
            "t": 242202.1786236763,
            "t2cof": 7.043484671383906e-10,
            "t3cof": 1.3451271709416876e-17,
            "t4cof": 4.225956646929465e-25,
            "t5cof": 1.6427086795509127e-32,
            "x1mth2": 0.6387344611576422,
            "x7thm1": 1.528858771896505,
            "mdot": 0.06572896579804392,
            "nodedot": -0.00005442646390063047,
            "xlcof": 0.0017528171499527477,
            "xmcof": -0.01527164118975892,
            "nodecf": -8.942323019606223e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.207815752285704,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1230"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45190",
            "epochyr": 22,
            "epochdays": 53.78665831,
            "ndot": 9.39326507149726e-11,
            "nddot": 0,
            "bstar": 0.00022692,
            "inclo": 0.9259460374020476,
            "nodeo": 2.656560418472813,
            "ecco": 0.000178,
            "argpo": 0.722718153970576,
            "mo": 5.562427157959,
            "no": 0.06572513488250377,
            "a": 1.0857967849773638,
            "alta": 0.08599005680508975,
            "altp": 0.08560351314963777,
            "jdsatepoch": 2459633.28665831,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934608696563206,
            "con41": 0.08388716445266031,
            "cc1": 1.0407670751842042e-9,
            "cc4": 7.998378324773681e-8,
            "cc5": 0.00013909285974423487,
            "d2": 6.391451369980333e-17,
            "d3": 5.865404873339936e-24,
            "d4": 6.2745674795108765e-31,
            "delmo": 1.0059298916544221,
            "eta": 0.0026257441723345773,
            "argpdot": 0.000036419777363156964,
            "omgcof": 2.044084886111579e-7,
            "sinmao": -0.6599544633405223,
            "t": 242175.63798375428,
            "t2cof": 1.5611506127763064e-9,
            "t3cof": 6.60809059093783e-17,
            "t4cof": 4.6014324065650236e-24,
            "t5cof": 3.96445887159023e-31,
            "x1mth2": 0.6387042785157799,
            "x7thm1": 1.529070050389541,
            "mdot": 0.06572893887702796,
            "nodedot": -0.00005442869506095139,
            "xlcof": 0.0017527848899224583,
            "xmcof": -0.020730004973035877,
            "nodecf": -1.9820985875976363e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3239382049879609,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1234"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45191",
            "epochyr": 22,
            "epochdays": 53.77560512,
            "ndot": -3.8088174822167924e-11,
            "nddot": 0,
            "bstar": -0.000065523,
            "inclo": 0.9259861799748436,
            "nodeo": 3.355372797678823,
            "ecco": 0.0001503,
            "argpo": 1.1680336766291732,
            "mo": 5.117155268531702,
            "no": 0.0657249142611391,
            "a": 1.0857992726744627,
            "alta": 0.08596246830514587,
            "altp": 0.08563607704377962,
            "jdsatepoch": 2459633.27560512,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346369131792081,
            "con41": 0.08377146461710683,
            "cc1": -3.0047620701984863e-10,
            "cc4": 7.233117005086203e-8,
            "cc5": 0.00013907303576690132,
            "d2": 5.3272025743465095e-18,
            "d3": -1.4113698875735987e-25,
            "d4": 4.358828312991119e-33,
            "delmo": 1.0026215519175208,
            "eta": 0.002217062948855117,
            "argpdot": 0.00003641074735962381,
            "omgcof": -3.652555447431282e-8,
            "sinmao": -0.9191944589182829,
            "t": 242191.55457682908,
            "t2cof": -4.5071431052977295e-10,
            "t3cof": 5.507774476316579e-18,
            "t4cof": -1.1072265638896583e-25,
            "t5cof": 2.75404211340318e-33,
            "x1mth2": 0.638742845127631,
            "x7thm1": 1.528800084106583,
            "mdot": 0.06572871298681528,
            "nodedot": -0.000054425341900242575,
            "xlcof": 0.0017528261105991495,
            "xmcof": 0.008394570248539394,
            "nodecf": 5.72209691928608e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.2542988205688275,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1236"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45192",
            "epochyr": 22,
            "epochdays": 53.55075688,
            "ndot": 1.5574639505643844e-11,
            "nddot": 0,
            "bstar": 0.000053415,
            "inclo": 0.9259477827312996,
            "nodeo": 3.372972697855934,
            "ecco": 0.0001428,
            "argpo": 1.1272558039855778,
            "mo": 5.157912197224274,
            "no": 0.06572500475176327,
            "a": 1.0857982207953918,
            "alta": 0.08595327278132148,
            "altp": 0.0856431688094621,
            "jdsatepoch": 2459633.05075688,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346099234039144,
            "con41": 0.0838821339692497,
            "cc1": 2.449650569766239e-10,
            "cc4": 7.032009764734748e-8,
            "cc5": 0.00013908001247722363,
            "d2": 3.540729865395299e-18,
            "d3": 7.64775527749314e-26,
            "d4": 1.925583942513334e-33,
            "delmo": 1.0027256806107672,
            "eta": 0.002106457652013225,
            "argpdot": 0.00003641922831129011,
            "omgcof": 3.431391432260366e-8,
            "sinmao": -0.9023853190472259,
            "t": 242515.3360426426,
            "t2cof": 3.6744758546493584e-10,
            "t3cof": 3.6607456236744205e-18,
            "t4cof": 5.99969794446759e-26,
            "t5cof": 1.2166425074343558e-33,
            "x1mth2": 0.6387059553435834,
            "x7thm1": 1.5290583125949162,
            "mdot": 0.06572880850084599,
            "nodedot": -0.00005442831513256162,
            "xlcof": 0.0017527866822163026,
            "xmcof": -0.0075813668559521685,
            "nodecf": -4.66522750066855e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.120852951422805,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1237"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45193",
            "epochyr": 22,
            "epochdays": 53.7387403,
            "ndot": -2.402857806999138e-11,
            "nddot": 0,
            "bstar": -0.00003434,
            "inclo": 0.9259687266823236,
            "nodeo": 3.3583276401024493,
            "ecco": 0.0001907,
            "argpo": 1.1288911774946964,
            "mo": 5.156365835507007,
            "no": 0.06572576337176937,
            "a": 1.08578989523119,
            "alta": 0.08599695536421059,
            "altp": 0.08558283509816933,
            "jdsatepoch": 2459633.2387403,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346246452703508,
            "con41": 0.08382176856382328,
            "cc1": -1.5756042753193081e-10,
            "cc4": 8.348317189848998e-8,
            "cc5": 0.000139145218263757,
            "d2": 1.4649566516548765e-18,
            "d3": -2.0354249985170628e-26,
            "d4": 3.2966493701209974e-34,
            "delmo": 1.0036296507334552,
            "eta": 0.0028133332211896264,
            "argpdot": 0.000036415646548215854,
            "omgcof": -1.6471954959732724e-8,
            "sinmao": -0.9030506136567171,
            "t": 242244.63991820812,
            "t2cof": -2.363406412978962e-10,
            "t3cof": 1.5146072283029662e-18,
            "t4cof": -1.5967923785534287e-26,
            "t5cof": 2.0829119490052444e-34,
            "x1mth2": 0.6387260771453922,
            "x7thm1": 1.5289174599822544,
            "mdot": 0.06572956449002446,
            "nodedot": -0.000054428256452486927,
            "xlcof": 0.0017528081891006392,
            "xmcof": 0.002733951687989449,
            "nodecf": 3.00065073479695e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.0220361448238222,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1239"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45194",
            "epochyr": 22,
            "epochdays": 53.54339989,
            "ndot": 3.875479363369353e-11,
            "nddot": 0,
            "bstar": 0.00010473,
            "inclo": 0.9259634906945676,
            "nodeo": 3.373756350690079,
            "ecco": 0.000163,
            "argpo": 0.8080996609781386,
            "mo": 5.477045650951437,
            "no": 0.06572544743741758,
            "a": 1.0857933674804563,
            "alta": 0.08597035179935553,
            "altp": 0.08561638316155706,
            "jdsatepoch": 2459633.04339989,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346209648421764,
            "con41": 0.08383685984672495,
            "cc1": 4.804303595649436e-10,
            "cc4": 7.586846059858404e-8,
            "cc5": 0.00013911744576731403,
            "d2": 1.3619846744604793e-17,
            "d3": 5.769878022320569e-25,
            "d4": 2.8493667444524833e-32,
            "delmo": 1.0050023095765073,
            "eta": 0.00240457842664793,
            "argpdot": 0.00003641637854076843,
            "omgcof": 9.492271042385806e-8,
            "sinmao": -0.7216200832506502,
            "t": 242525.930108428,
            "t2cof": 7.206455393474155e-10,
            "t3cof": 1.4081473405388195e-17,
            "t4cof": 4.526482396085136e-25,
            "t5cof": 1.8003108312128706e-32,
            "x1mth2": 0.6387210467177583,
            "x7thm1": 1.528952672975692,
            "mdot": 0.06572924919629537,
            "nodedot": -0.00005442802645347954,
            "xlcof": 0.0017528028124906352,
            "xmcof": -0.01141102981803573,
            "nodecf": -9.149490054869504e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.074501058359985,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1240"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45195",
            "epochyr": 22,
            "epochdays": 53.5359215,
            "ndot": 3.631254471510425e-10,
            "nddot": 0,
            "bstar": 0.00082035,
            "inclo": 0.9259460374020476,
            "nodeo": 3.3741281058207533,
            "ecco": 0.0001994,
            "argpo": 1.0495013858092301,
            "mo": 5.235755627192473,
            "no": 0.06572867240606328,
            "a": 1.0857578231666778,
            "alta": 0.08597432327661725,
            "altp": 0.08554132305673834,
            "jdsatepoch": 2459633.0359215,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934608696563206,
            "con41": 0.08388716445266031,
            "cc1": 3.7706162224070435e-9,
            "cc4": 8.60824170009201e-8,
            "cc5": 0.00013938431061897295,
            "d2": 8.393274098624414e-16,
            "d3": 2.791925679457568e-22,
            "d4": 1.082589409124202e-28,
            "delmo": 1.004419031826813,
            "eta": 0.002942875608167723,
            "argpdot": 0.00003642434595157253,
            "omgcof": 4.391957743315486e-7,
            "sinmao": -0.866141444846295,
            "t": 242536.69898986816,
            "t2cof": 5.655924333610565e-9,
            "t3cof": 8.677625032557998e-16,
            "t4cof": 2.1902279288247553e-22,
            "t5cof": 6.839948188644336e-29,
            "x1mth2": 0.6387042785157799,
            "x7thm1": 1.529070050389541,
            "mdot": 0.06573247687888684,
            "nodedot": -0.000054435532839007945,
            "xlcof": 0.0017527848899224583,
            "xmcof": -0.05981648273776509,
            "nodecf": -7.181887249025411e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.027384299708885,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1241"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45196",
            "epochyr": 22,
            "epochdays": 53.79032296,
            "ndot": 7.772169325287249e-11,
            "nddot": 0,
            "bstar": 0.00019096,
            "inclo": 0.9259914159625995,
            "nodeo": 3.354096961995615,
            "ecco": 0.0001344,
            "argpo": 1.1275437833121567,
            "mo": 5.1576102552636796,
            "no": 0.06572581144288113,
            "a": 1.0857893983740994,
            "alta": 0.08593532846924101,
            "altp": 0.08564346827895797,
            "jdsatepoch": 2459633.29032296,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346405934963476,
            "con41": 0.08375637353198573,
            "cc1": 8.76176491604423e-10,
            "cc4": 6.801069853750085e-8,
            "cc5": 0.00013914558907295008,
            "d2": 4.530191681933267e-17,
            "d3": 3.50021142195575e-24,
            "d4": 3.1525305481337406e-31,
            "delmo": 1.002563874820349,
            "eta": 0.001982771475879366,
            "argpdot": 0.00003641076464265917,
            "omgcof": 1.3034570699360733e-7,
            "sinmao": -0.9025153937844659,
            "t": 242170.36088772118,
            "t2cof": 1.3142647374066345e-9,
            "t3cof": 4.6837287308213143e-17,
            "t4cof": 2.745917559502293e-24,
            "t5cof": 1.9918531010200832e-31,
            "x1mth2": 0.6387478754893381,
            "x7thm1": 1.5287648715746336,
            "mdot": 0.06572960960629792,
            "nodedot": -0.00005442669357999429,
            "xlcof": 0.0017528314868882503,
            "xmcof": -0.030608735144542785,
            "nodecf": -1.6685818864930596e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3470269223845648,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1244"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45197",
            "epochyr": 22,
            "epochdays": 53.58025182,
            "ndot": -1.7301788244596566e-11,
            "nddot": 0,
            "bstar": -0.000019448,
            "inclo": 0.9259722173408276,
            "nodeo": 3.3707543843766485,
            "ecco": 0.0001493,
            "argpo": 1.0819889445058528,
            "mo": 5.2031842926917555,
            "no": 0.06572509275131705,
            "a": 1.0857972866481835,
            "alta": 0.08595939618308002,
            "altp": 0.08563517711328683,
            "jdsatepoch": 2459633.08025182,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346270988748986,
            "con41": 0.08381170773390967,
            "cc1": -8.919461775290564e-11,
            "cc4": 7.208144040071013e-8,
            "cc5": 0.00013908758325418118,
            "d2": 4.694260046591111e-19,
            "d3": -3.6918852438043645e-27,
            "d4": 3.384671555684853e-35,
            "delmo": 1.0031173416721384,
            "eta": 0.002202366860519527,
            "argpdot": 0.00003641401930626205,
            "omgcof": -1.3076508917612842e-8,
            "sinmao": -0.8819582850413835,
            "t": 242472.86332927644,
            "t2cof": -1.3379192662935845e-10,
            "t3cof": 4.853373643312851e-19,
            "t4cof": -2.896298761554663e-27,
            "t5cof": 2.1385370862714082e-35,
            "x1mth2": 0.6387294307553635,
            "x7thm1": 1.528893984712456,
            "mdot": 0.06572889332333647,
            "nodedot": -0.00005442670448439915,
            "xlcof": 0.0017528117734661674,
            "xmcof": 0.002525303423470292,
            "nodecf": 1.6986135518015084e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.02349721216992151,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1269"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45198",
            "epochyr": 22,
            "epochdays": 53.63738105,
            "ndot": -1.5029224114395615e-11,
            "nddot": 0,
            "bstar": -0.000014384,
            "inclo": 0.9259547640483077,
            "nodeo": 3.0171855845076374,
            "ecco": 0.0001449,
            "argpo": 1.0986917454474385,
            "mo": 5.186476255762414,
            "no": 0.0657248547119829,
            "a": 1.085799883428624,
            "alta": 0.08595721583173277,
            "altp": 0.08564255102551521,
            "jdsatepoch": 2459633.13738105,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346148307382787,
            "con41": 0.08386201208631128,
            "cc1": -6.596007839513259e-11,
            "cc4": 7.08805904541211e-8,
            "cc5": 0.00013906785304591907,
            "d2": 2.5670702520591177e-19,
            "d3": -1.4929554324829196e-27,
            "d4": 1.0121461097369419e-35,
            "delmo": 1.0029301836945401,
            "eta": 0.0021373902396846205,
            "argpdot": 0.00003641751383179594,
            "omgcof": -9.649033816732522e-9,
            "sinmao": -0.8897097752068205,
            "t": 242390.59723824263,
            "t2cof": -9.894011759269888e-11,
            "t3cof": 2.6540848908969583e-19,
            "t4cof": -1.1712312574335878e-27,
            "t5cof": 6.395053919581483e-36,
            "x1mth2": 0.6387126626378963,
            "x7thm1": 1.5290113615347263,
            "mdot": 0.06572865752965536,
            "nodedot": -0.000054427516404262457,
            "xlcof": 0.0017527938513093985,
            "xmcof": 0.0019826848494349726,
            "nodecf": 1.2561557971365522e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.3834335322400406,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1154"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45199",
            "epochyr": 22,
            "epochdays": 53.77375478,
            "ndot": 6.572255464541148e-11,
            "nddot": 0,
            "bstar": 0.00016446,
            "inclo": 0.9259320747680317,
            "nodeo": 3.0064727535588958,
            "ecco": 0.0001275,
            "argpo": 1.202559779892125,
            "mo": 5.082589022695955,
            "no": 0.06572527947422928,
            "a": 1.0857951723306467,
            "alta": 0.085933611215119,
            "altp": 0.08565673344617464,
            "jdsatepoch": 2459633.27375478,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009345988817350469,
            "con41": 0.08392740850246616,
            "cc1": 7.543484530977985e-10,
            "cc4": 6.615426914836692e-8,
            "cc5": 0.00013910168990906557,
            "d2": 3.35772532664952e-17,
            "d3": 2.233422693827988e-24,
            "d4": 1.7317451584330495e-31,
            "delmo": 1.0020428617887946,
            "eta": 0.001880837831785675,
            "argpdot": 0.000036423004588805166,
            "omgcof": 9.927489162388178e-8,
            "sinmao": -0.9322549885652802,
            "t": 242194.21906650066,
            "t2cof": 1.1315226796466977e-9,
            "t3cof": 3.471533644387728e-17,
            "t4cof": 1.7521270066589958e-24,
            "t5cof": 1.0941670986662106e-31,
            "x1mth2": 0.6386908638325113,
            "x7thm1": 1.529163953172421,
            "mdot": 0.06572908531051545,
            "nodedot": -0.0000544299904824772,
            "xlcof": 0.0017527705512754965,
            "xmcof": -0.02928433573346938,
            "nodecf": -1.4366599874695624e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.2426409601258896,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1197"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45201",
            "epochyr": 22,
            "epochdays": 53.78113114,
            "ndot": 4.326962103902609e-11,
            "nddot": 0,
            "bstar": 0.00011472,
            "inclo": 0.9259233481217717,
            "nodeo": 3.0060870357942053,
            "ecco": 0.0001315,
            "argpo": 1.101903151271108,
            "mo": 5.1832439059877204,
            "no": 0.06572516551531063,
            "a": 1.0857964149714794,
            "alta": 0.08593919720004806,
            "altp": 0.08565363274291071,
            "jdsatepoch": 2459633.28113114,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009345927473749213,
            "con41": 0.08395256119836292,
            "cc1": 5.261649518070398e-10,
            "cc4": 6.725509432708811e-8,
            "cc5": 0.00013909256502040834,
            "d2": 1.633571271163191e-17,
            "d3": 7.578911360770454e-25,
            "d4": 4.0988578953857497e-32,
            "delmo": 1.0026423036306442,
            "eta": 0.0019398136741291764,
            "argpdot": 0.00003642475853326277,
            "omgcof": 8.428230951897193e-8,
            "sinmao": -0.8911807783392378,
            "t": 242183.5971084237,
            "t2cof": 7.892474277105598e-10,
            "t3cof": 1.688941182465212e-17,
            "t4cof": 5.945683618666298e-25,
            "t5cof": 2.5897800937432145e-32,
            "x1mth2": 0.6386824796005457,
            "x7thm1": 1.5292226427961801,
            "mdot": 0.06572897247513151,
            "nodedot": -0.000054430406383344184,
            "xlcof": 0.0017527615893537362,
            "xmcof": -0.019202615031226205,
            "nodecf": -1.0020910668887472e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.2891148894861075,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1199"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45202",
            "epochyr": 22,
            "epochdays": 53.74710117,
            "ndot": 4.885103854279962e-10,
            "nddot": 0,
            "bstar": 0.00098143,
            "inclo": 0.9246824190236038,
            "nodeo": 3.2105157057510496,
            "ecco": 0.0000743,
            "argpo": 1.9422652234723619,
            "mo": 4.342785840677607,
            "no": 0.06590657793989953,
            "a": 1.083801072097971,
            "alta": 0.083881598517628,
            "altp": 0.0837205456783141,
            "jdsatepoch": 2459633.24710117,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009337197169365818,
            "con41": 0.08753056124046288,
            "cc1": 5.0296657179650646e-9,
            "cc4": 6.074952057061913e-8,
            "cc5": 0.00015495083782706039,
            "d2": 1.5314337372342868e-15,
            "d3": 6.968693944794687e-22,
            "d4": 3.696589129959002e-28,
            "delmo": 0.9987818635403848,
            "eta": 0.0011244723707872601,
            "argpdot": 0.00003693164335439125,
            "omgcof": 0,
            "sinmao": -0.9324707829886321,
            "t": 242232.6002651453,
            "t2cof": 7.544498576947596e-9,
            "t3cof": 1.582028811703233e-15,
            "t4cof": 5.460779405515517e-22,
            "t5cof": 2.3325611210344653e-28,
            "x1mth2": 0.6374898129198457,
            "x7thm1": 1.5375713095610797,
            "mdot": 0.06591057255106889,
            "nodedot": -0.00005487264950732273,
            "xlcof": 0.0017514851105317022,
            "xmcof": 0,
            "nodecf": -9.656798312214214e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.0747128718150165,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1203"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45204",
            "epochyr": 22,
            "epochdays": 53.67426051,
            "ndot": 4.5672478846025224e-10,
            "nddot": 0,
            "bstar": 0.001031,
            "inclo": 0.9259983972796074,
            "nodeo": 3.0143110272296028,
            "ecco": 0.0001954,
            "argpo": 0.9143867217660893,
            "mo": 5.370833639321322,
            "no": 0.06572158874526814,
            "a": 1.0858359204055141,
            "alta": 0.08604809274436143,
            "altp": 0.08562374806666684,
            "jdsatepoch": 2459633.17426051,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346455005460079,
            "con41": 0.08373625215616343,
            "cc1": 4.718563670694989e-9,
            "cc4": 8.447639138753406e-8,
            "cc5": 0.00013880427603753064,
            "d2": 1.3130984101020548e-15,
            "d3": 5.460551179778292e-22,
            "d4": 2.647053980871402e-28,
            "delmo": 1.0052978583214744,
            "eta": 0.0028809930078506447,
            "argpdot": 0.000036403794604028724,
            "omgcof": 6.865643370963077e-7,
            "sinmao": -0.7909448814000951,
            "t": 242337.49081537127,
            "t2cof": 7.077845506042484e-9,
            "t3cof": 1.3576280963308599e-15,
            "t4cof": 4.2839179904487e-22,
            "t5cof": 1.6725304454463348e-28,
            "x1mth2": 0.6387545826146122,
            "x7thm1": 1.5287179216977145,
            "mdot": 0.0657253854278378,
            "nodedot": -0.000054418026894224084,
            "xlcof": 0.0017528386551585204,
            "xmcof": -0.0780314013463688,
            "nodecf": -8.984555952463754e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.6157884451905815,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1206"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45205",
            "epochyr": 22,
            "epochdays": 53.76269113,
            "ndot": 3.89972004742483e-11,
            "nddot": 0,
            "bstar": 0.00010531,
            "inclo": 0.9259547640483077,
            "nodeo": 3.0071953198692216,
            "ecco": 0.0001376,
            "argpo": 1.139157204154927,
            "mo": 5.146003815737917,
            "no": 0.06572524033415131,
            "a": 1.0857956360380436,
            "alta": 0.08594504151756244,
            "altp": 0.08564623055852483,
            "jdsatepoch": 2459633.26269113,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346148307382787,
            "con41": 0.08386201208631128,
            "cc1": 4.83026821785061e-10,
            "cc4": 6.889860412474891e-8,
            "cc5": 0.00013909900781295106,
            "d2": 1.3767062423188759e-17,
            "d3": 5.8635941503195595e-25,
            "d4": 2.9112119240188983e-32,
            "delmo": 1.0025606908167601,
            "eta": 0.0020298186095921954,
            "argpdot": 0.00003641801159079609,
            "omgcof": 6.845702533657327e-8,
            "sinmao": -0.9074528949053637,
            "t": 242210.1507228613,
            "t2cof": 7.245402326775915e-10,
            "t3cof": 1.4233692244316314e-17,
            "t4cof": 4.600008858960469e-25,
            "t5cof": 1.8393891205800512e-32,
            "x1mth2": 0.6387126626378963,
            "x7thm1": 1.5290113615347263,
            "mdot": 0.06572904320392833,
            "nodedot": -0.00005442826142685279,
            "xlcof": 0.0017527938513093985,
            "xmcof": -0.01609979710927775,
            "nodecf": -9.198977055721271e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.1729356697625448,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1208"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45206",
            "epochyr": 22,
            "epochdays": 53.5913068,
            "ndot": -5.266288611052335e-11,
            "nddot": 0,
            "bstar": -0.000097865,
            "inclo": 0.9259268387802757,
            "nodeo": 2.671915825231859,
            "ecco": 0.0001361,
            "argpo": 1.2463727801049387,
            "mo": 5.038796966434165,
            "no": 0.06572493369875476,
            "a": 1.0857989733043265,
            "alta": 0.08594675054459322,
            "altp": 0.0856511960640598,
            "jdsatepoch": 2459633.0913068,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009345952011275124,
            "con41": 0.08394250010479543,
            "cc1": -4.487968441218077e-10,
            "cc4": 6.850131751023543e-8,
            "cc5": 0.00013907383469572319,
            "d2": 1.1884469517727928e-17,
            "d3": -4.702862967396304e-25,
            "d4": 2.169362502962438e-32,
            "delmo": 1.001932415705707,
            "eta": 0.002007605358680049,
            "argpdot": 0.0000364236988411492,
            "omgcof": -4.899392136403929e-8,
            "sinmao": -0.9472002049244423,
            "t": 242456.94415792823,
            "t2cof": -6.731952661827115e-10,
            "t3cof": 1.2287306732315316e-17,
            "t4cof": -3.6894184988382916e-25,
            "t5cof": 1.3706699198739342e-32,
            "x1mth2": 0.6386858332984016,
            "x7thm1": 1.5291991669111895,
            "mdot": 0.06572874017164537,
            "nodedot": -0.000054429704083831816,
            "xlcof": 0.0017527651741471241,
            "xmcof": 0.01529106309158969,
            "nodecf": 8.547310476475738e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.09314787724101592,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1209"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45207",
            "epochyr": 22,
            "epochdays": 53.58577439,
            "ndot": 5.75716246317574e-12,
            "nddot": 0,
            "bstar": 0.000031661,
            "inclo": 0.9259495280605516,
            "nodeo": 3.0211282832878927,
            "ecco": 0.0001248,
            "argpo": 1.1807606175347158,
            "mo": 5.104381203736356,
            "no": 0.06572523650985236,
            "a": 1.085795670635921,
            "alta": 0.08593117793561644,
            "altp": 0.08566016333622573,
            "jdsatepoch": 2459633.08577439,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934611150241776,
            "con41": 0.0838771034909096,
            "cc1": 1.452191360282562e-10,
            "cc4": 6.539278009527149e-8,
            "cc5": 0.00013909804092940414,
            "d2": 1.2443606034344921e-18,
            "d3": 1.5933869027625475e-26,
            "d4": 2.378392519539204e-34,
            "delmo": 1.0021114344705027,
            "eta": 0.0018409972917643213,
            "argpdot": 0.00003641914701388184,
            "omgcof": 2.0623397217327313e-8,
            "sinmao": -0.9241498046596042,
            "t": 242464.91082832217,
            "t2cof": 2.1782870404238428e-10,
            "t3cof": 1.2865377983720786e-18,
            "t4cof": 1.250017285569534e-26,
            "t5cof": 1.5027382271713882e-34,
            "x1mth2": 0.6387076321696968,
            "x7thm1": 1.529046574812122,
            "mdot": 0.06572904006245067,
            "nodedot": -0.00005442863529646411,
            "xlcof": 0.0017527884745019186,
            "xmcof": -0.005884131268109601,
            "nodecf": -2.7656365120293763e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.05829154715424778,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1210"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45208",
            "epochyr": 22,
            "epochdays": 53.68230688,
            "ndot": -6.454082129770698e-12,
            "nddot": 0,
            "bstar": 0.0000045181,
            "inclo": 0.9250506834957746,
            "nodeo": 3.0134872318226615,
            "ecco": 0.0001268,
            "argpo": 1.2267552793125223,
            "mo": 5.058393523275557,
            "no": 0.06568954569788372,
            "a": 1.0861876674776032,
            "alta": 0.08632539607383949,
            "altp": 0.08604993888136714,
            "jdsatepoch": 2459633.18230688,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009339789520150439,
            "con41": 0.08646846952423914,
            "cc1": 2.0284152860799888e-11,
            "cc4": 6.513710031293467e-8,
            "cc5": 0.00013621402259463865,
            "d2": 2.4157689962878284e-20,
            "d3": 4.29930587008984e-29,
            "d4": 8.919217320861085e-38,
            "delmo": 1.0018948623745523,
            "eta": 0.0018612337371714193,
            "argpdot": 0.000036568687292158284,
            "omgcof": 2.4989539271052395e-9,
            "sinmao": -0.9407352447732064,
            "t": 242325.90404257178,
            "t2cof": 3.042622929119983e-11,
            "t3cof": 2.4980583677438876e-20,
            "t4cof": 3.373571348095423e-29,
            "t5cof": 5.636874886475462e-38,
            "x1mth2": 0.6378438434919202,
            "x7thm1": 1.535093095556558,
            "mdot": 0.06569346161962672,
            "nodedot": -0.00005442509183978047,
            "xlcof": 0.0017518643586718916,
            "xmcof": -0.0008002108906386594,
            "nodecf": -3.862746764769994e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.6664836989813452,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1211"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45209",
            "epochyr": 22,
            "epochdays": 53.40401374,
            "ndot": 2.841917196953961e-10,
            "nddot": 0,
            "bstar": 0.000061141,
            "inclo": 0.9258884415367319,
            "nodeo": 1.0263251586719975,
            "ecco": 0.0007261,
            "argpo": 5.304470985172743,
            "mo": 0.9792867900014984,
            "no": 0.06879449086590209,
            "a": 1.0532529477614199,
            "alta": 0.05401771472678951,
            "altp": 0.05248818079605044,
            "jdsatepoch": 2459632.90401374,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009345682092226911,
            "con41": 0.08405317324922501,
            "cc1": 2.95259014555519e-9,
            "cc4": 0.0000042141119137482735,
            "cc5": 0.001395702970460206,
            "d2": 8.943864258239597e-16,
            "d3": 4.055055172253647e-22,
            "d4": 2.1439298708676305e-28,
            "delmo": 1.0314784230040819,
            "eta": 0.018623243118161385,
            "argpdot": 0.00004052064979679776,
            "omgcof": 1.9454880173973505e-7,
            "sinmao": 0.8300998852519884,
            "t": 242726.64616450667,
            "t2cof": 4.428885218332785e-9,
            "t3cof": 9.11822002959219e-16,
            "t4cof": 3.121157577021815e-22,
            "t5cof": 1.325162150024636e-28,
            "x1mth2": 0.6386489422502584,
            "x7thm1": 1.5294574042481917,
            "mdot": 0.06879873119447769,
            "nodedot": -0.00006055101073365432,
            "xlcof": 0.001752725739609739,
            "xmcof": -0.001992713381985211,
            "nodecf": -6.255472014776663e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.196314217381243,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1218"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45210",
            "epochyr": 22,
            "epochdays": 53.78849068,
            "ndot": 4.2118188546390945e-12,
            "nddot": 0,
            "bstar": 0.000028212,
            "inclo": 0.9259774533285836,
            "nodeo": 3.005575654323371,
            "ecco": 0.0001229,
            "argpo": 1.1737566112464626,
            "mo": 5.111381719366105,
            "no": 0.06572554153106447,
            "a": 1.0857923511743448,
            "alta": 0.0859257950543042,
            "altp": 0.08565890729438541,
            "jdsatepoch": 2459633.28849068,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346307792603676,
            "con41": 0.08379661652707349,
            "cc1": 1.2942300407456566e-10,
            "cc4": 6.485654377710469e-8,
            "cc5": 0.0001391229156145482,
            "d2": 9.884164980629943e-19,
            "d3": 1.1280313022202831e-26,
            "d4": 1.5006853033649663e-34,
            "delmo": 1.0021145420534516,
            "eta": 0.0018130464260291048,
            "argpdot": 0.00003641345758163894,
            "omgcof": 1.898317182171769e-8,
            "sinmao": -0.9214527726101086,
            "t": 242172.99937069416,
            "t2cof": 1.941345061118485e-10,
            "t3cof": 1.0219171260303645e-18,
            "t4cof": 8.84942595390805e-27,
            "t5cof": 9.481749504522446e-35,
            "x1mth2": 0.6387344611576422,
            "x7thm1": 1.528858771896505,
            "mdot": 0.06572934148030317,
            "nodedot": -0.000054427189354227135,
            "xlcof": 0.0017528171499527477,
            "xmcof": -0.00540726698421303,
            "nodecf": -2.464741086288733e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.335482848278069,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1219"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45212",
            "epochyr": 22,
            "epochdays": 53.55628989,
            "ndot": -1.6695771143209646e-11,
            "nddot": 0,
            "bstar": -0.00001809,
            "inclo": 0.9259896706333476,
            "nodeo": 3.023467024485565,
            "ecco": 0.0001539,
            "argpo": 1.0831059552271292,
            "mo": 5.202077753945991,
            "no": 0.06572473732771225,
            "a": 1.0858012265141623,
            "alta": 0.0859683313229227,
            "altp": 0.08563412170540174,
            "jdsatepoch": 2459633.05628989,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934639366726815,
            "con41": 0.08376140388862108,
            "cc1": -8.294855614837779e-11,
            "cc4": 7.330495235155489e-8,
            "cc5": 0.00013905877230004928,
            "d2": 4.059625566715111e-19,
            "d3": -2.96903692423486e-27,
            "d4": 2.5312351332403684e-35,
            "delmo": 1.0032066691037997,
            "eta": 0.0022701102298815783,
            "argpdot": 0.000036409758656243265,
            "omgcof": -1.1772024524610293e-8,
            "sinmao": -0.8824792870946754,
            "t": 242507.36850857735,
            "t2cof": -1.2442283422256669e-10,
            "t3cof": 4.197234826057123e-19,
            "t4cof": -2.3292265281266457e-27,
            "t5cof": 1.5993144383120113e-35,
            "x1mth2": 0.638746198703793,
            "x7thm1": 1.5287766090734491,
            "mdot": 0.06572853557395421,
            "nodedot": -0.00005442474567730004,
            "xlcof": 0.001752829694800112,
            "xmcof": 0.0022102872167526727,
            "nodecf": 1.5796075781741044e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.155713060307264,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1231"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45213",
            "epochyr": 22,
            "epochdays": 53.78594321,
            "ndot": 9.25842626643867e-10,
            "nddot": 0,
            "bstar": 0.00099694,
            "inclo": 0.9260350491938993,
            "nodeo": 2.9010723200309587,
            "ecco": 0.0002861,
            "argpo": 0.6329384172479876,
            "mo": 5.652330813058479,
            "no": 0.06682246030692333,
            "a": 1.073876272048371,
            "alta": 0.07418350804980411,
            "altp": 0.0735690360469381,
            "jdsatepoch": 2459633.28594321,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346712618093571,
            "con41": 0.08363061626459856,
            "cc1": 9.327875758018709e-9,
            "cc4": 2.6471125153051413e-7,
            "cc5": 0.0002789053495553712,
            "d2": 6.0588190794790215e-15,
            "d3": 5.884320279706697e-21,
            "d4": 6.662664716186524e-27,
            "delmo": 1.0121144154358872,
            "eta": 0.004980584871013856,
            "argpdot": 0.00003783229371267491,
            "omgcof": 0.0000014772808647157768,
            "sinmao": -0.5898349975287764,
            "t": 242176.667727381,
            "t2cof": 1.3991813637028062e-8,
            "t3cof": 6.232837611793088e-15,
            "t4cof": 4.584816973682376e-21,
            "t5cof": 4.1765674287006255e-27,
            "x1mth2": 0.6387897945784672,
            "x7thm1": 1.5284714379507296,
            "mdot": 0.06682640223319367,
            "nodedot": -0.00005656631707838555,
            "xlcof": 0.0017528762864174566,
            "xmcof": -0.06055724578458334,
            "nodecf": -1.8462139231930986e-12,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.319432799094237,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1232"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45214",
            "epochyr": 22,
            "epochdays": 53.59683306,
            "ndot": 5.090543651650128e-11,
            "nddot": 0,
            "bstar": 0.00013168,
            "inclo": 0.9259983972796074,
            "nodeo": 3.0204458595503625,
            "ecco": 0.0001461,
            "argpo": 1.0459653487446898,
            "mo": 5.239199161806659,
            "no": 0.06572533105668923,
            "a": 1.0857946994937695,
            "alta": 0.08595333409936567,
            "altp": 0.08563606488817332,
            "jdsatepoch": 2459633.09683306,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346455005460079,
            "con41": 0.08373625215616343,
            "cc1": 6.040101637886952e-10,
            "cc4": 7.118837744005083e-8,
            "cc5": 0.00013910690257134932,
            "d2": 2.152745927675468e-17,
            "d3": 1.1465524157059893e-24,
            "d4": 7.118399418205825e-32,
            "delmo": 1.003254340904361,
            "eta": 0.002155234387202776,
            "argpdot": 0.00003640862397150005,
            "omgcof": 9.656640012913786e-8,
            "sinmao": -0.8644152379212648,
            "t": 242448.9863435179,
            "t2cof": 9.060152456830428e-10,
            "t3cof": 2.2257115832674772e-17,
            "t4cof": 8.994736243604266e-25,
            "t5cof": 4.497610691689466e-32,
            "x1mth2": 0.6387545826146122,
            "x7thm1": 1.5287179216977145,
            "mdot": 0.06572912824415858,
            "nodedot": -0.000054425256734337574,
            "xlcof": 0.0017528386551585204,
            "xmcof": -0.017857683853818085,
            "nodecf": -1.1502407196043177e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.12796546003041698,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1233"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45215",
            "epochyr": 22,
            "epochdays": 53.59315009,
            "ndot": -2.42406840554768e-12,
            "nddot": 0,
            "bstar": 0.000013544,
            "inclo": 0.9259791986578355,
            "nodeo": 3.0206308644510744,
            "ecco": 0.0001452,
            "argpo": 1.141623354387995,
            "mo": 5.143551628138865,
            "no": 0.06572530699994296,
            "a": 1.0857949368731943,
            "alta": 0.08595259429802815,
            "altp": 0.08563727944836041,
            "jdsatepoch": 2459633.09315009,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346320060498297,
            "con41": 0.08379158613493731,
            "cc1": 6.212492885918315e-11,
            "cc4": 7.096083087809101e-8,
            "cc5": 0.00013910488253060245,
            "d2": 2.2773754496790786e-19,
            "d3": 1.2475442731043575e-27,
            "d4": 7.966445691510703e-36,
            "delmo": 1.0026879438288279,
            "eta": 0.0021419506017814247,
            "argpdot": 0.00003641277503563547,
            "omgcof": 8.299356318803149e-9,
            "sinmao": -0.9084804615347866,
            "t": 242454.28982041776,
            "t2cof": 9.318739328877473e-11,
            "t3cof": 2.3545655853942497e-19,
            "t4cof": 9.78702170128599e-28,
            "t5cof": 5.03343173526767e-36,
            "x1mth2": 0.6387361379550209,
            "x7thm1": 1.528847034314854,
            "mdot": 0.06572910668976077,
            "nodedot": -0.00005442660955309049,
            "xlcof": 0.0017528189420984847,
            "xmcof": -0.0018595791177999778,
            "nodecf": -1.1830990664417419e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.10476131923601173,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1245"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45217",
            "epochyr": 22,
            "epochdays": 53.567338,
            "ndot": 2.7331371272550093e-11,
            "nddot": 0,
            "bstar": 0.000079437,
            "inclo": 0.9259774533285836,
            "nodeo": 3.0227636567970113,
            "ecco": 0.0001336,
            "argpo": 1.1928487679340287,
            "mo": 5.0923105066295635,
            "no": 0.06572517763527513,
            "a": 1.0857963592303606,
            "alta": 0.0859414216239538,
            "altp": 0.08565129683676753,
            "jdsatepoch": 2459633.067338,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346307792603676,
            "con41": 0.08379661652707349,
            "cc1": 3.643395578679026e-10,
            "cc4": 6.77738761675333e-8,
            "cc5": 0.00013909366528009636,
            "d2": 7.83263056568237e-18,
            "d3": 2.5162948667851883e-25,
            "d4": 9.423293418889282e-33,
            "delmo": 1.0021941966435608,
            "eta": 0.001970795018891198,
            "argpdot": 0.000036412987985890585,
            "omgcof": 4.6909627131202927e-8,
            "sinmao": -0.9286937402391495,
            "t": 242491.45922988653,
            "t2cof": 5.465093368018539e-10,
            "t3cof": 8.098117192537128e-18,
            "t4cof": 1.9740423558092927e-25,
            "t5cof": 5.9539159938095e-33,
            "x1mth2": 0.6387344611576422,
            "x7thm1": 1.528858771896505,
            "mdot": 0.0657289775353874,
            "nodedot": -0.000054426486410977065,
            "xlcof": 0.0017528171499527477,
            "xmcof": -0.012882052860222162,
            "nodecf": -6.938419375414711e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.225320442343602,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1271"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45219",
            "epochyr": 22,
            "epochdays": 53.56550316,
            "ndot": -8.469088991882206e-11,
            "nddot": 0,
            "bstar": -0.00016885,
            "inclo": 0.9259617453653156,
            "nodeo": 2.6738129981287773,
            "ecco": 0.0001322,
            "argpo": 1.1426513533174196,
            "mo": 5.142500939929164,
            "no": 0.06572480318277465,
            "a": 1.085800461026976,
            "alta": 0.08594400384792378,
            "altp": 0.08565691820602828,
            "jdsatepoch": 2459633.06550316,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346197380270909,
            "con41": 0.08384189028450095,
            "cc1": -7.742601818777178e-10,
            "cc4": 6.738767739278236e-8,
            "cc5": 0.0001390629520889509,
            "d2": 3.5370903780934484e-17,
            "d3": -2.414670493438245e-24,
            "d4": 1.9215729134508004e-31,
            "delmo": 1.0024413249598796,
            "eta": 0.0019500411239531982,
            "argpdot": 0.000036415926264981074,
            "omgcof": -1.133402174022161e-7,
            "sinmao": -0.9089190713129227,
            "t": 242494.1013995558,
            "t2cof": -1.1613902728165767e-9,
            "t3cof": 3.6569861439417117e-17,
            "t4cof": -1.894322098730901e-24,
            "t5cof": 1.2141099829772933e-31,
            "x1mth2": 0.6387193699051663,
            "x7thm1": 1.5289644106638356,
            "mdot": 0.06572860508233705,
            "nodedot": -0.00005442690760775861,
            "xlcof": 0.0017528010202708438,
            "xmcof": 0.02796009657524795,
            "nodecf": 1.4744988619056113e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.213760237941116,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1187"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45221",
            "epochyr": 22,
            "epochdays": 53.6355373,
            "ndot": 2.969483796795908e-12,
            "nddot": 0,
            "bstar": 0.000025458,
            "inclo": 0.9259861799748436,
            "nodeo": 2.6684443653496426,
            "ecco": 0.0001423,
            "argpo": 1.201306633489193,
            "mo": 5.083870094366919,
            "no": 0.06572505709712083,
            "a": 1.0857976994218308,
            "alta": 0.08595220843445861,
            "altp": 0.08564319040920298,
            "jdsatepoch": 2459633.1355373,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346369131792081,
            "con41": 0.08377146461710683,
            "cc1": 1.167553807411353e-10,
            "cc4": 7.014466499189442e-8,
            "cc5": 0.00013908426820164797,
            "d2": 8.043433880772243e-19,
            "d3": 8.280539491797695e-27,
            "d4": 9.93717772450559e-35,
            "delmo": 1.0022876335994637,
            "eta": 0.00209909742592461,
            "argpdot": 0.00003641093158200325,
            "omgcof": 1.381212692581634e-8,
            "sinmao": -0.9317907295069605,
            "t": 242393.25223825872,
            "t2cof": 1.7513307111170295e-10,
            "t3cof": 8.316070259412393e-19,
            "t4cof": 6.496117844936986e-27,
            "t5cof": 6.278608784883697e-35,
            "x1mth2": 0.638742845127631,
            "x7thm1": 1.528800084106583,
            "mdot": 0.06572885584206692,
            "nodedot": -0.00005442561767586514,
            "xlcof": 0.0017528261105991495,
            "xmcof": -0.003638862215189571,
            "nodecf": -2.2234339194648473e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.37181719161994664,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1189"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45222",
            "epochyr": 22,
            "epochdays": 53.57656537,
            "ndot": -1.1480993985775199e-10,
            "nddot": 0,
            "bstar": -0.00023573,
            "inclo": 0.9259303294387797,
            "nodeo": 2.6730328359531357,
            "ecco": 0.0001672,
            "argpo": 1.0573832927112365,
            "mo": 5.2278178697544035,
            "no": 0.06572439409121579,
            "a": 1.0858049218228205,
            "alta": 0.0859864684057492,
            "altp": 0.08562337523989161,
            "jdsatepoch": 2459633.07656537,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009345976548687157,
            "con41": 0.08393243903150616,
            "cc1": -1.08068770236435e-9,
            "cc4": 7.699579726016239e-8,
            "cc5": 0.00013903152489942543,
            "d2": 6.890455710251825e-17,
            "d3": -6.565201721329513e-24,
            "d4": 7.291811908332296e-31,
            "delmo": 1.0036512267607176,
            "eta": 0.002466174531365673,
            "argpdot": 0.000036422242291876935,
            "omgcof": -1.4795290537452483e-7,
            "sinmao": -0.8700813993001054,
            "t": 242478.1718172133,
            "t2cof": -1.621031553546525e-9,
            "t3cof": 7.124032892260133e-17,
            "t4cof": -5.1504495133416624e-24,
            "t5cof": 4.607208865611705e-31,
            "x1mth2": 0.638689186989498,
            "x7thm1": 1.5291756910735144,
            "mdot": 0.06572820003559963,
            "nodedot": -0.00005442840783768143,
            "xlcof": 0.0017527687589076002,
            "xmcof": 0.024398395935274094,
            "nodecf": 2.0581146480940155e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.00027114673971340153,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1191"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45223",
            "epochyr": 22,
            "epochdays": 53.53232585,
            "ndot": -1.36353847812057e-12,
            "nddot": 0,
            "bstar": 0.000015849,
            "inclo": 0.9259774533285836,
            "nodeo": 2.6765967982857077,
            "ecco": 0.0001485,
            "argpo": 1.058797009405352,
            "mo": 5.2263744824630045,
            "no": 0.06572537129708314,
            "a": 1.0857942261768825,
            "alta": 0.08595546661946996,
            "altp": 0.08563298573429523,
            "jdsatepoch": 2459633.03232585,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346307792603676,
            "con41": 0.08379661652707349,
            "cc1": 7.270064547329266e-11,
            "cc4": 7.187140322201266e-8,
            "cc5": 0.00013911033391006755,
            "d2": 3.118769327192126e-19,
            "d3": 1.9993133169024383e-27,
            "d4": 1.4940521852079591e-35,
            "delmo": 1.0032345929648212,
            "eta": 0.0021906509443601137,
            "argpdot": 0.00003641323831129531,
            "omgcof": 1.118069955194417e-8,
            "sinmao": -0.8707919499378369,
            "t": 242541.8767261505,
            "t2cof": 1.0905096820993899e-10,
            "t3cof": 3.224477004236794e-19,
            "t4cof": 1.5684665776716597e-27,
            "t5cof": 9.439851203055611e-36,
            "x1mth2": 0.6387344611576422,
            "x7thm1": 1.528858771896505,
            "mdot": 0.06572917122337234,
            "nodedot": -0.00005442686112662235,
            "xlcof": 0.0017528171499527477,
            "xmcof": -0.002080476067935155,
            "nodecf": -1.3845080130900267e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.004730307995871,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1212"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45224",
            "epochyr": 22,
            "epochdays": 53.75215233,
            "ndot": 2.463035305166859e-9,
            "nddot": 0,
            "bstar": 0.00049416,
            "inclo": 0.925865752256456,
            "nodeo": 0.5285886719297507,
            "ecco": 0.0002448,
            "argpo": 0.160976952899193,
            "mo": 6.124065384604515,
            "no": 0.0687968153359684,
            "a": 1.0532291875972029,
            "alta": 0.05348701810232659,
            "altp": 0.05297135709207912,
            "jdsatepoch": 2459633.25215233,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009345522588130885,
            "con41": 0.0841185721694423,
            "cc1": 2.388144224350842e-8,
            "cc4": 0.0000018254177412525433,
            "cc5": 0.0013961718008361308,
            "d2": 5.854383455334056e-14,
            "d3": 2.1480868519941382e-19,
            "d4": 9.191044391167149e-25,
            "delmo": 1.0187241654084231,
            "eta": 0.006282196041269597,
            "argpdot": 0.00004052930164290931,
            "omgcof": 0.000008272849736395778,
            "sinmao": -0.15844930858216982,
            "t": 242225.32659508288,
            "t2cof": 3.582216336526263e-8,
            "t3cof": 5.968448112060062e-14,
            "t4cof": 1.6533489786675306e-19,
            "t5cof": 5.6808868832636085e-25,
            "x1mth2": 0.6386271426101859,
            "x7thm1": 1.5296100017286989,
            "mdot": 0.06880105929071398,
            "nodedot": -0.000060557569348957645,
            "xlcof": 0.0017527024355113064,
            "xmcof": -0.1419425656395338,
            "nodecf": -5.060164164187475e-12,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.1065371386950105,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1214"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45225",
            "epochyr": 22,
            "epochdays": 53.55075976,
            "ndot": -1.0435614485882764e-10,
            "nddot": 0,
            "bstar": -0.00021253,
            "inclo": 0.9259617453653156,
            "nodeo": 2.674741513290838,
            "ecco": 0.0001546,
            "argpo": 0.8320909568760526,
            "mo": 5.453049119065767,
            "no": 0.06572460153711443,
            "a": 1.0858026820487612,
            "alta": 0.0859705471434058,
            "altp": 0.08563481695411634,
            "jdsatepoch": 2459633.05075976,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346197380270909,
            "con41": 0.08384189028450095,
            "cc1": -9.744429190719585e-10,
            "cc4": 7.351902833737228e-8,
            "cc5": 0.00013904770523679238,
            "d2": 5.602384350252395e-17,
            "d3": -4.8132878740954095e-24,
            "d4": 4.820566050296201e-31,
            "delmo": 1.0046233640753386,
            "eta": 0.002280392427909064,
            "argpdot": 0.00003641566638302683,
            "omgcof": -1.9780925516937477e-7,
            "sinmao": -0.738023274323224,
            "t": 242515.3318952769,
            "t2cof": -1.461664378607938e-9,
            "t3cof": 5.792292150758291e-17,
            "t4cof": -3.776055197265741e-24,
            "t5cof": 3.045789123738232e-31,
            "x1mth2": 0.6387193699051663,
            "x7thm1": 1.5289644106638356,
            "mdot": 0.0657284034094681,
            "nodedot": -0.00005442651861652573,
            "xlcof": 0.0017528010202708438,
            "xmcof": 0.025731291172811067,
            "nodecf": 1.8557130177493525e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.120871097260917,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1215"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45226",
            "epochyr": 22,
            "epochdays": 53.55813544,
            "ndot": -2.5664824243736065e-11,
            "nddot": 0,
            "bstar": -0.000038003,
            "inclo": 0.9259826893163396,
            "nodeo": 2.6743313609166193,
            "ecco": 0.0001508,
            "argpo": 1.1123943254048458,
            "mo": 5.17278589310977,
            "no": 0.06572458934906686,
            "a": 1.0858028463913696,
            "alta": 0.08596658546060532,
            "altp": 0.08563910732213387,
            "jdsatepoch": 2459633.05813544,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934634459620213,
            "con41": 0.08378152536587868,
            "cc1": -1.742405388593926e-10,
            "cc4": 7.245431973677757e-8,
            "cc5": 0.0001390464823689671,
            "d2": 1.791256439892909e-18,
            "d3": -2.751812010275781e-26,
            "d4": 4.92795828136771e-34,
            "delmo": 1.0029677755261641,
            "eta": 0.0022243376038727607,
            "argpdot": 0.00003641108830221512,
            "omgcof": -2.3831700092183848e-8,
            "sinmao": -0.895876218295297,
            "t": 242504.71091620624,
            "t2cof": -2.613608082890889e-10,
            "t3cof": 1.851975970656932e-18,
            "t4cof": -2.1588143293734767e-26,
            "t5cof": 3.1136432732004396e-34,
            "x1mth2": 0.6387394915447071,
            "x7thm1": 1.5288235591870505,
            "mdot": 0.0657283884864325,
            "nodedot": -0.00005442496844463403,
            "xlcof": 0.0017528225263652737,
            "xmcof": 0.0048358529390823725,
            "nodecf": 3.3181142288964956e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.167340743192128,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1217"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45227",
            "epochyr": 22,
            "epochdays": 53.64659621,
            "ndot": -5.060242796580782e-12,
            "nddot": 0,
            "bstar": 0.0000076581,
            "inclo": 0.9259600000360637,
            "nodeo": 2.6673814598351777,
            "ecco": 0.0001498,
            "argpo": 1.0313639242225052,
            "mo": 5.253804076987347,
            "no": 0.06572478436978273,
            "a": 1.0858006657333985,
            "alta": 0.08596331867312546,
            "altp": 0.08563801279367156,
            "jdsatepoch": 2459633.14659621,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346185112091584,
            "con41": 0.08384692072734745,
            "cc1": 3.511595807103285e-11,
            "cc4": 7.221490371370748e-8,
            "cc5": 0.00013906237875924648,
            "d2": 7.275790917890768e-20,
            "d3": 2.252726051276509e-28,
            "d4": 8.13062303713499e-37,
            "delmo": 1.0034201119252975,
            "eta": 0.0022096474573447093,
            "argpdot": 0.00003641628252933543,
            "omgcof": 5.6123250913339235e-9,
            "sinmao": -0.8569802707315669,
            "t": 242377.32740744948,
            "t2cof": 5.267393710654928e-11,
            "t3cof": 7.522417020140075e-20,
            "t4cof": 1.767276013082484e-28,
            "t5cof": 5.137183121197502e-37,
            "x1mth2": 0.6387176930908842,
            "x7thm1": 1.5289761483638107,
            "mdot": 0.06572858649461252,
            "nodedot": -0.000054426998998490374,
            "xlcof": 0.0017527992280428248,
            "xmcof": -0.0009876297614894063,
            "nodecf": -6.6874840340033125e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.4414926183536849,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1221"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45228",
            "epochyr": 22,
            "epochdays": 53.58392952,
            "ndot": -2.1937819070206504e-11,
            "nddot": 0,
            "bstar": -0.000029693,
            "inclo": 0.9259530187190556,
            "nodeo": 2.67224918311899,
            "ecco": 0.0001477,
            "argpo": 0.9909368627585605,
            "mo": 5.29422066647578,
            "no": 0.06572517976979274,
            "a": 1.0857963006060878,
            "alta": 0.08595667271968743,
            "altp": 0.08563592849248836,
            "jdsatepoch": 2459633.08392952,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934613603908958,
            "con41": 0.08386704254944044,
            "cc1": -1.3618878591444691e-10,
            "cc4": 7.166772180887299e-8,
            "cc5": 0.00013909461211628068,
            "d2": 1.0944043610852728e-18,
            "d3": -1.3142163160986373e-26,
            "d4": 1.839683818815307e-34,
            "delmo": 1.0035964006520397,
            "eta": 0.002178791249670646,
            "argpdot": 0.00003641831380077589,
            "omgcof": -2.3549182076861755e-8,
            "sinmao": -0.8354574394572638,
            "t": 242467.56744101644,
            "t2cof": -2.0428317887167037e-10,
            "t3cof": 1.1314991319029749e-18,
            "t4cof": -1.0310074039198614e-26,
            "t5cof": 1.1623667285742128e-34,
            "x1mth2": 0.6387109858168531,
            "x7thm1": 1.5290230992820275,
            "mdot": 0.0657289828591861,
            "nodedot": -0.000054428271903151844,
            "xlcof": 0.0017527920590484664,
            "xmcof": 0.003939750071168253,
            "nodecf": 2.5936400994325918e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.046668150616049786,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1222"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45229",
            "epochyr": 22,
            "epochdays": 53.54707558,
            "ndot": -1.933194553424275e-11,
            "nddot": 0,
            "bstar": -0.000023911,
            "inclo": 0.9259809439870875,
            "nodeo": 2.675275584041948,
            "ecco": 0.0001581,
            "argpo": 1.1651469020463745,
            "mo": 5.120056005748517,
            "no": 0.06572476371802752,
            "a": 1.0858009232984238,
            "alta": 0.08597258842439714,
            "altp": 0.08562925817245026,
            "jdsatepoch": 2459633.04707558,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346332328364449,
            "con41": 0.08378655574787275,
            "cc1": -1.0964176625331394e-10,
            "cc4": 7.446758075452387e-8,
            "cc5": 0.00013906118644051776,
            "d2": 7.09286937919878e-19,
            "d3": -6.856782578934734e-27,
            "d4": 7.726913811730616e-35,
            "delmo": 1.002776344525611,
            "eta": 0.0023320711397781576,
            "argpdot": 0.000036411693757457394,
            "omgcof": -1.275578422911508e-8,
            "sinmao": -0.918048271586937,
            "t": 242520.63711494207,
            "t2cof": -1.644626493799709e-10,
            "t3cof": 7.333295717341707e-19,
            "t4cof": -5.3791844482088465e-27,
            "t5cof": 4.882107674392822e-35,
            "x1mth2": 0.6387378147507091,
            "x7thm1": 1.528835296745036,
            "mdot": 0.06572856310672708,
            "nodedot": -0.00005442543286689753,
            "xlcof": 0.0017528207342359936,
            "xmcof": 0.0027683860046812717,
            "nodecf": 2.087958429677928e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.097659331386623,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1226"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45230",
            "epochyr": 22,
            "epochdays": 53.54338904,
            "ndot": -1.4483808723147389e-11,
            "nddot": 0,
            "bstar": -0.000013178,
            "inclo": 0.9259617453653156,
            "nodeo": 2.6754448809793914,
            "ecco": 0.0001437,
            "argpo": 1.1662115528900912,
            "mo": 5.118963429636769,
            "no": 0.0657249187952409,
            "a": 1.0857991876206472,
            "alta": 0.08595521696390818,
            "altp": 0.08564315827738622,
            "jdsatepoch": 2459633.04338904,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346197380270909,
            "con41": 0.08384189028450095,
            "cc1": -6.043204325103756e-11,
            "cc4": 7.05474731101566e-8,
            "cc5": 0.00013907302910340404,
            "d2": 2.1548342319399095e-19,
            "d3": -1.148187903844401e-27,
            "d4": 7.131803176814918e-36,
            "delmo": 1.0025169221674517,
            "eta": 0.0021197082317544907,
            "argpdot": 0.000036416075765595165,
            "omgcof": -7.71615549171823e-9,
            "sinmao": -0.9184808957026648,
            "t": 242525.9457322955,
            "t2cof": -9.064806487655633e-11,
            "t3cof": 2.227874868969815e-19,
            "t4cof": -9.007589879013328e-28,
            "t5cof": 4.5060929774114705e-36,
            "x1mth2": 0.6387193699051663,
            "x7thm1": 1.5289644106638356,
            "mdot": 0.06572872071044251,
            "nodedot": -0.00005442713138106676,
            "xlcof": 0.0017528010202708438,
            "xmcof": 0.0018469686597164063,
            "nodecf": 1.1508708196269218e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.074432699726842,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1227"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45231",
            "epochyr": 22,
            "epochdays": 53.35088692,
            "ndot": 3.7821527297557674e-10,
            "nddot": 0,
            "bstar": 0.000080079,
            "inclo": 0.925534139698577,
            "nodeo": 0.6521387843491773,
            "ecco": 0.0007008,
            "argpo": 5.297121403692594,
            "mo": 0.9866730233959384,
            "no": 0.06879352008817825,
            "a": 1.0532623322287065,
            "alta": 0.05400045847113222,
            "altp": 0.052524205986280714,
            "jdsatepoch": 2459632.85088692,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009343190825455166,
            "con41": 0.08507450019669693,
            "cc1": 3.863197214203967e-9,
            "cc4": 0.000004090426459643612,
            "cc5": 0.0013941581139078792,
            "d2": 1.5307770177011427e-15,
            "d3": 9.078755154467978e-22,
            "d4": 6.278889867130313e-28,
            "delmo": 1.0300255376290939,
            "eta": 0.017970173770225854,
            "argpdot": 0.00004060518827694342,
            "omgcof": 2.6072789847354497e-7,
            "sinmao": 0.834195876752355,
            "t": 242803.148785159,
            "t2cof": 5.79479582130595e-9,
            "t3cof": 1.5606256031328093e-15,
            "t4cof": 6.987918558312594e-22,
            "t5cof": 3.8810059393971682e-28,
            "x1mth2": 0.6383084999344344,
            "x7thm1": 1.5318405004589595,
            "mdot": 0.0687978117202694,
            "nodedot": -0.00006057774487868557,
            "xlcof": 0.0017523616784973308,
            "xmcof": -0.002799736813960319,
            "nodecf": -8.18830421792347e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.861594633559818,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1229"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45232",
            "epochyr": 22,
            "epochdays": 53.55445012,
            "ndot": -6.548014780485672e-11,
            "nddot": 0,
            "bstar": -0.0001263,
            "inclo": 0.9259722173408276,
            "nodeo": 2.6745582537193786,
            "ecco": 0.0001388,
            "argpo": 0.9607164867602788,
            "mo": 5.324421843852289,
            "no": 0.06572468199978997,
            "a": 1.0858018108417613,
            "alta": 0.08595252013310617,
            "altp": 0.08565110155041644,
            "jdsatepoch": 2459633.05445012,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346270988748986,
            "con41": 0.08381170773390967,
            "cc1": -5.791056192195514e-10,
            "cc4": 6.917994214907972e-8,
            "cc5": 0.00013905338571575072,
            "d2": 1.9787025976776293e-17,
            "d3": -1.010312503501329e-24,
            "d4": 6.01337378782119e-32,
            "delmo": 1.003532978965982,
            "eta": 0.002047361068155918,
            "argpdot": 0.000036413488788213326,
            "omgcof": -1.1141785387746461e-7,
            "sinmao": -0.8184817637051456,
            "t": 242510.01777738333,
            "t2cof": -8.686584288293271e-10,
            "t3cof": 2.0457752613199612e-17,
            "t4cof": -7.925962383735211e-25,
            "t5cof": 3.7994413220203107e-32,
            "x1mth2": 0.6387294307553635,
            "x7thm1": 1.528893984712456,
            "mdot": 0.06572848251631293,
            "nodedot": -0.000054425910364494314,
            "xlcof": 0.0017528117734661674,
            "xmcof": 0.018971460849278022,
            "nodecf": 1.1028269758536316e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.144121795271005,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1235"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45233",
            "epochyr": 22,
            "epochdays": 53.66686789,
            "ndot": -1.8907733563271904e-11,
            "nddot": 0,
            "bstar": -0.000023019,
            "inclo": 0.9259931612918515,
            "nodeo": 3.0149847243208727,
            "ecco": 0.0001388,
            "argpo": 1.1913041515460134,
            "mo": 5.09386559499309,
            "no": 0.06572510455835777,
            "a": 1.0857971866983955,
            "alta": 0.08594789534790936,
            "altp": 0.0856464780488817,
            "jdsatepoch": 2459633.16686789,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346418202630333,
            "con41": 0.08375134318042254,
            "cc1": -1.0557247006004765e-10,
            "cc4": 6.917965631795099e-8,
            "cc5": 0.00013908796061976625,
            "d2": 6.576456138039719e-19,
            "d3": -6.121892917952468e-27,
            "d4": 6.643039272311081e-35,
            "delmo": 1.0022885227500538,
            "eta": 0.0020474817392709087,
            "argpdot": 0.00003640947201486423,
            "omgcof": -1.3134370759971398e-8,
            "sinmao": -0.9281159167661717,
            "t": 242348.13618846238,
            "t2cof": -1.5835870509007147e-10,
            "t3cof": 6.799367066731313e-19,
            "t4cof": -4.802649161252844e-27,
            "t5cof": 4.1972712582165327e-35,
            "x1mth2": 0.6387495522731925,
            "x7thm1": 1.5287531340876526,
            "mdot": 0.06572890239858674,
            "nodedot": -0.00005442520044145971,
            "xlcof": 0.0017528332789681605,
            "xmcof": 0.0034583433737726105,
            "nodecf": 2.010456611299586e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.5692120688555846,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1238"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45234",
            "epochyr": 22,
            "epochdays": 53.3738317,
            "ndot": -9.73566473378087e-11,
            "nddot": 0,
            "bstar": -0.00019685,
            "inclo": 0.9259896706333476,
            "nodeo": 3.386725892361649,
            "ecco": 0.0001392,
            "argpo": 1.2713641496642454,
            "mo": 5.0138125781918665,
            "no": 0.06572576191624319,
            "a": 1.0857899413610839,
            "alta": 0.08594108332092132,
            "altp": 0.08563879940124641,
            "jdsatepoch": 2459632.8738317,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934639366726815,
            "con41": 0.08376140388862108,
            "cc1": -9.031759366749822e-10,
            "cc4": 6.932737268860641e-8,
            "cc5": 0.00013914178987979616,
            "d2": 4.813656555386942e-17,
            "d3": -3.83380968493933e-24,
            "d4": 3.559371537881827e-31,
            "delmo": 1.001830106893454,
            "eta": 0.002053570555197684,
            "argpdot": 0.000036411081003219534,
            "omgcof": -8.922493176112379e-8,
            "sinmao": -0.9549148192925545,
            "t": 242770.10830186307,
            "t2cof": -1.3547639050124734e-9,
            "t3cof": 4.976801909904688e-17,
            "t4cof": -3.0076264887315545e-24,
            "t5cof": 2.2489069211472397e-31,
            "x1mth2": 0.638746198703793,
            "x7thm1": 1.5287766090734491,
            "mdot": 0.06572956030076726,
            "nodedot": -0.000054426725226527707,
            "xlcof": 0.001752829694800112,
            "xmcof": 0.02941362759205603,
            "nodecf": 1.720000333768024e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.00615565282753,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1243"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45235",
            "epochyr": 22,
            "epochdays": 53.75716879,
            "ndot": 1.8453220737231716e-11,
            "nddot": 0,
            "bstar": 0.000059804,
            "inclo": 0.9259442920727957,
            "nodeo": 3.357023879151209,
            "ecco": 0.0001613,
            "argpo": 1.1817816351471324,
            "mo": 5.1034282539647675,
            "no": 0.06572527395694501,
            "a": 1.0857952506563175,
            "alta": 0.08597038943024837,
            "altp": 0.08562011188238672,
            "jdsatepoch": 2459633.25716879,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346074697196505,
            "con41": 0.08389219494114064,
            "cc1": 2.7431196668001196e-10,
            "cc4": 7.541322038153995e-8,
            "cc5": 0.0001391031388236325,
            "d2": 4.440075262025835e-18,
            "d3": 1.0739609841302706e-25,
            "d4": 3.0281262330850675e-33,
            "delmo": 1.0027232377373305,
            "eta": 0.0023794424218894694,
            "argpdot": 0.00003642033673571441,
            "omgcof": 3.006606089560031e-8,
            "sinmao": -0.92451344066088,
            "t": 242218.10289256275,
            "t2cof": 4.1146795002001797e-10,
            "t3cof": 4.5905693721535466e-18,
            "t4cof": 8.425257406092464e-26,
            "t5cof": 1.9132585476608985e-33,
            "x1mth2": 0.6387026016862865,
            "x7thm1": 1.5290817881959948,
            "mdot": 0.06572907819802523,
            "nodedot": -0.000054429090429218655,
            "xlcof": 0.0017527830976203863,
            "xmcof": -0.0066535872917799395,
            "nodecf": -5.2241977848237005e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.1381427841053195,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1246"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45236",
            "epochyr": 22,
            "epochdays": 53.53971174,
            "ndot": 8.302434289000803e-11,
            "nddot": 0,
            "bstar": 0.00020273,
            "inclo": 0.9259477827312996,
            "nodeo": 2.6757136616841986,
            "ecco": 0.0001677,
            "argpo": 0.9028012261913508,
            "mo": 5.382373756335508,
            "no": 0.06572551362112608,
            "a": 1.0857926159422802,
            "alta": 0.08597470336397373,
            "altp": 0.08561052852058659,
            "jdsatepoch": 2459633.03971174,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346099234039144,
            "con41": 0.0838821339692497,
            "cc1": 9.300285864177758e-10,
            "cc4": 7.717876270364907e-8,
            "cc5": 0.00013912316612894098,
            "d2": 5.103967944952324e-17,
            "d3": 4.185739804250957e-24,
            "d4": 4.001509286989723e-31,
            "delmo": 1.0046158335267572,
            "eta": 0.0024739357358227344,
            "argpdot": 0.00003641988594703169,
            "omgcof": 1.6012911830740982e-7,
            "sinmao": -0.7838311197112228,
            "t": 242531.24104455113,
            "t2cof": 1.3950428796266638e-9,
            "t3cof": 5.2769585792631734e-17,
            "t4cof": 3.2837210139158328e-24,
            "t5cof": 2.5282660031683664e-31,
            "x1mth2": 0.6387059553435834,
            "x7thm1": 1.5290583125949162,
            "mdot": 0.06572931743904287,
            "nodedot": -0.000054429299420563264,
            "xlcof": 0.0017527866822163026,
            "xmcof": -0.020868634609995995,
            "nodecf": -1.7712213358967322e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.051264281454152,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1247"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45237",
            "epochyr": 22,
            "epochdays": 53.62817362,
            "ndot": -4.869347409643902e-11,
            "nddot": 0,
            "bstar": -0.00008906,
            "inclo": 0.9259879253040956,
            "nodeo": 2.669156459684456,
            "ecco": 0.0001572,
            "argpo": 1.081603226741162,
            "mo": 5.203585718419714,
            "no": 0.0657248912790817,
            "a": 1.0857995283165407,
            "alta": 0.08597021600239207,
            "altp": 0.08562884063068932,
            "jdsatepoch": 2459633.12817362,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346381399544351,
            "con41": 0.08376643425032804,
            "cc1": -4.084077229278363e-10,
            "cc4": 7.422032382709486e-8,
            "cc5": 0.00013907156823886514,
            "d2": 9.841596033451117e-18,
            "d3": -3.543966681764231e-25,
            "d4": 1.4876508171311198e-32,
            "delmo": 1.0032848473270664,
            "eta": 0.00231883684874423,
            "argpdot": 0.00003641033765635967,
            "omgcof": -5.6906251803419324e-8,
            "sinmao": -0.8817690110134075,
            "t": 242403.8559371978,
            "t2cof": -6.126115843917544e-10,
            "t3cof": 1.0175189769745317e-17,
            "t4cof": -2.7802595543308817e-25,
            "t5cof": 9.399438072762398e-33,
            "x1mth2": 0.6387445219165573,
            "x7thm1": 1.5287883465840988,
            "mdot": 0.06572868977388899,
            "nodedot": -0.000054425170508153185,
            "xlcof": 0.001752827902703745,
            "xmcof": 0.01043027313615947,
            "nodecf": 7.777458558479772e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.32542315090645246,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1270"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45249",
            "epochyr": 22,
            "epochdays": 53.53194109,
            "ndot": 3.335215117482914e-10,
            "nddot": 0,
            "bstar": 0.0003432,
            "inclo": 0.6110921310007745,
            "nodeo": 1.7640426722342126,
            "ecco": 0.000803,
            "argpo": 1.9411412314340775,
            "mo": 4.344794714646652,
            "no": 0.06681607119707142,
            "a": 1.0734761939055095,
            "alta": 0.0743381952892157,
            "altp": 0.07261419252180334,
            "jdsatepoch": 2459633.03194109,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0006709835913342178,
            "con41": 1.0123905337111263,
            "cc1": 3.344662890212224e-9,
            "cc4": 0.0000014466912726553305,
            "cc5": 0.0002779912699500109,
            "d2": 7.781676573979896e-16,
            "d3": 2.707045991643036e-22,
            "d4": 1.0978957530463432e-28,
            "delmo": 0.985020146609633,
            "eta": 0.013964456168224258,
            "argpdot": 0.00011105344788633075,
            "omgcof": -5.8061307513267444e-8,
            "sinmao": -0.9331945974535344,
            "t": 242542.430780679,
            "t2cof": 5.016994335318336e-9,
            "t3cof": 8.005411970963152e-16,
            "t4cof": 2.1093011476635462e-22,
            "t5cof": 6.882600309767123e-29,
            "x1mth2": 0.32920315542962464,
            "x7thm1": 3.6955779119926273,
            "mdot": 0.06686375097228808,
            "nodedot": -0.0000773094811966848,
            "xlcof": 0.0013085884344107423,
            "xmcof": -0.002637401475622882,
            "nodecf": -9.01925093036933e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.002306170110771,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "XJS C"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45250",
            "epochyr": 22,
            "epochdays": 53.53657635,
            "ndot": 3.087354123015664e-10,
            "nddot": 0,
            "bstar": 0.00031752,
            "inclo": 0.6111095842932946,
            "nodeo": 1.7653237439051765,
            "ecco": 0.0007165,
            "argpo": 1.7749841413149652,
            "mo": 4.510857556986156,
            "no": 0.06681775757796023,
            "a": 1.0734581396129335,
            "alta": 0.07422727236996618,
            "altp": 0.07268900685590074,
            "jdsatepoch": 2459633.03657635,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000671000308017842,
            "con41": 1.0123413230870142,
            "cc1": 3.097430737414258e-9,
            "cc4": 0.0000013917573691613754,
            "cc5": 0.0002782415063259064,
            "d2": 6.675617877490937e-16,
            "d3": 2.15121269016842e-22,
            "d4": 8.081990428848254e-29,
            "delmo": 0.9925341244132962,
            "eta": 0.012463627618724426,
            "argpdot": 0.00011105607471386334,
            "omgcof": -3.3778633497521226e-8,
            "sinmao": -0.9797611818443309,
            "t": 242535.7560056448,
            "t2cof": 4.646146106121387e-9,
            "t3cof": 6.867499420952509e-16,
            "t4cof": 1.6761842343795581e-22,
            "t5cof": 5.066458879067042e-29,
            "x1mth2": 0.3292195589709953,
            "x7thm1": 3.6954630872030325,
            "mdot": 0.06686543783424101,
            "nodedot": -0.00007731306451987157,
            "xlcof": 0.0013086190054044705,
            "xmcof": -0.00306751960455608,
            "nodecf": -8.352950940690176e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.031510109828034,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "XJS D"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45251",
            "epochyr": 22,
            "epochdays": 53.53179241,
            "ndot": 2.6095096385720777e-10,
            "nddot": 0,
            "bstar": 0.00026852,
            "inclo": 0.6111148202810505,
            "nodeo": 1.7647425492642625,
            "ecco": 0.0005538,
            "argpo": 2.809657209799252,
            "mo": 3.4751442722676815,
            "no": 0.06681877085491092,
            "a": 1.073447284519725,
            "alta": 0.07404175962589199,
            "altp": 0.07285280941355787,
            "jdsatepoch": 2459633.03179241,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0006710053229830714,
            "con41": 1.0123265597780455,
            "cc1": 2.6204356836182058e-9,
            "cc4": 0.0000012857247298718695,
            "cc5": 0.00027832306451132084,
            "d2": 4.778672440278018e-16,
            "d3": 1.3029965545512027e-22,
            "d4": 4.142117574937797e-29,
            "delmo": 0.9729358846723276,
            "eta": 0.009635033141710473,
            "argpdot": 0.00011105879646525678,
            "omgcof": -1.7247119373080054e-7,
            "sinmao": -0.3274009592519632,
            "t": 242542.64487929642,
            "t2cof": 3.930653525427309e-9,
            "t3cof": 4.916006103717611e-16,
            "t4cof": 1.0152638698021831e-22,
            "t5cof": 2.596602408503845e-29,
            "x1mth2": 0.32922448007398486,
            "x7thm1": 3.695428639482106,
            "mdot": 0.06686645208888882,
            "nodedot": -0.00007731548605023421,
            "xlcof": 0.0013086281765908989,
            "xmcof": -0.0043446312582310015,
            "nodecf": -7.066844189036728e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.001369430956785,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "XJS E"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45253",
            "epochyr": 22,
            "epochdays": 53.53611207,
            "ndot": 2.339832028454898e-10,
            "nddot": 0,
            "bstar": 0.00024156,
            "inclo": 0.6110973669885306,
            "nodeo": 1.7644999484982353,
            "ecco": 0.0006144,
            "argpo": 1.9864587054621103,
            "mo": 4.299103740158693,
            "no": 0.06681508866079937,
            "a": 1.073486735422892,
            "alta": 0.07414628567313586,
            "altp": 0.0728271851726483,
            "jdsatepoch": 2459633.03611207,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0006709886063607666,
            "con41": 1.0123757705894443,
            "cc1": 2.351474901127303e-9,
            "cc4": 0.0000013214395636038252,
            "cc5": 0.0002776606426125804,
            "d2": 3.8457353202588667e-16,
            "d3": 9.404156409017565e-23,
            "d4": 2.681039789616565e-29,
            "delmo": 0.9871837201905029,
            "eta": 0.010682918408830878,
            "argpdot": 0.00011104840292372252,
            "omgcof": -5.953668258206202e-8,
            "sinmao": -0.9158063486255408,
            "t": 242536.42456904054,
            "t2cof": 3.5272123516909546e-9,
            "t3cof": 3.9563240044714997e-16,
            "t4cof": 7.327662390663133e-23,
            "t5cof": 1.680729277402615e-29,
            "x1mth2": 0.32920807647018524,
            "x7thm1": 3.6955434647087033,
            "mdot": 0.06686276608388944,
            "nodedot": -0.00007730649455593895,
            "xlcof": 0.0013085976057690006,
            "xmcof": -0.0031692485500424807,
            "nodecf": -6.34076788223285e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.028584964788408,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "XJS F"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45258",
            "epochyr": 22,
            "epochdays": 53.56940829,
            "ndot": 1.919195558382237e-9,
            "nddot": 0,
            "bstar": 0.00054025,
            "inclo": 0.9011850513040041,
            "nodeo": 2.606352531880692,
            "ecco": 0.0003417,
            "argpo": 1.300102741127584,
            "mo": 4.985480648444242,
            "no": 0.06844889539177258,
            "a": 1.056758756565315,
            "alta": 0.05711985103243311,
            "altp": 0.05639766209819652,
            "jdsatepoch": 2459633.06940829,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009169187730589764,
            "con41": 0.155735640198162,
            "cc1": 1.8761783309426463e-8,
            "cc4": 0.0000018616132928248085,
            "cc5": 0.0010040180416353744,
            "d2": 3.3357374056477665e-14,
            "d3": 8.87526306206556e-20,
            "d4": 2.7535672441307587e-25,
            "delmo": 1.006564391826151,
            "eta": 0.008095219163228145,
            "argpdot": 0.00004600650423904041,
            "omgcof": 0.0000011297047893179172,
            "sinmao": -0.9629416465606288,
            "t": 242488.47801223397,
            "t2cof": 2.8142674964139694e-8,
            "t3cof": 3.406138308237741e-14,
            "t4cof": 6.845851501793881e-20,
            "t5cof": 1.7061649362858887e-25,
            "x1mth2": 0.6147547866006127,
            "x7thm1": 1.6967164937957113,
            "mdot": 0.06845665487769535,
            "nodedot": -0.00006180574233272067,
            "xlcof": 0.0017265356064279894,
            "xmcof": -0.061823228551087135,
            "nodecf": -4.056311619553385e-12,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.238364073051727,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "PHOENIX"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45262",
            "epochyr": 22,
            "epochdays": 53.47009253,
            "ndot": 2.8315240036651755e-9,
            "nddot": 0,
            "bstar": 0.00059434,
            "inclo": 0.9012932617176278,
            "nodeo": 2.4793693568225925,
            "ecco": 0.0000719,
            "argpo": 1.1462170609792441,
            "mo": 5.138844475146236,
            "no": 0.06874444953321504,
            "a": 1.0537273925053507,
            "alta": 0.05380315550487191,
            "altp": 0.05365162950582958,
            "jdsatepoch": 2459632.97009253,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009169973125175764,
            "con41": 0.15541968259731553,
            "cc1": 2.740217710812123e-8,
            "cc4": 0.000001385769729660342,
            "cc5": 0.0013260788111864902,
            "d2": 7.612514069486708e-14,
            "d3": 3.165260167753772e-19,
            "d4": 1.534724672343995e-24,
            "delmo": 1.002263104757482,
            "eta": 0.0018223293481180142,
            "argpdot": 0.000046444322451614026,
            "omgcof": 0,
            "sinmao": -0.9104376374263574,
            "t": 242631.49270690978,
            "t2cof": 4.1103265662181846e-8,
            "t3cof": 7.762689931539677e-14,
            "t4cof": 2.4370393566425385e-19,
            "t5cof": 9.489499088098383e-25,
            "x1mth2": 0.6148601058008948,
            "x7thm1": 1.6959792593937366,
            "mdot": 0.06875227158765797,
            "nodedot": -0.00006242181312815799,
            "xlcof": 0.0017266538709539783,
            "xmcof": 0,
            "nodecf": -5.9834127844478896e-12,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.612636239490186,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "RADSAT-U"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45264",
            "epochyr": 22,
            "epochdays": 53.81426802,
            "ndot": 1.1389788412016467e-9,
            "nddot": 0,
            "bstar": 0.0004051,
            "inclo": 0.9012601004618398,
            "nodeo": 2.7287036031039986,
            "ecco": 0.0004882,
            "argpo": 2.0953096549212407,
            "mo": 4.190456994222045,
            "no": 0.06820389236510727,
            "a": 1.0592884735306105,
            "alta": 0.05980561816338814,
            "altp": 0.058771328897832875,
            "jdsatepoch": 2459633.31426802,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000916973245114846,
            "con41": 0.15551650659925792,
            "cc1": 1.1266089788914435e-8,
            "cc4": 0.0000017785852474232153,
            "cc5": 0.0008074622105897277,
            "d2": 1.1409743508044759e-14,
            "d3": 1.7289995698343687e-20,
            "d4": 3.05510928186777e-26,
            "delmo": 0.983679833858597,
            "eta": 0.010971531364335993,
            "argpdot": 0.00004560551948829372,
            "omgcof": -8.398128521950812e-7,
            "sinmao": -0.8668575951263875,
            "t": 242135.88000118732,
            "t2cof": 1.689913468337165e-8,
            "t3cof": 1.1663593066308523e-14,
            "t4cof": 1.3356701223143457e-20,
            "t5cof": 1.896310933782676e-26,
            "x1mth2": 0.6148278311335806,
            "x7thm1": 1.696205182064935,
            "mdot": 0.06821157633478939,
            "nodedot": -0.00006128477878608547,
            "xlcof": 0.0017266176318862646,
            "xmcof": -0.019200755833380732,
            "nodecf": -2.4152140073461685e-12,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.4978900940269781,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SORTIE"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45360",
            "epochyr": 22,
            "epochdays": 52.92322932,
            "ndot": -3.311883459079518e-11,
            "nddot": 0,
            "bstar": -0.000054446,
            "inclo": 0.9259687266823236,
            "nodeo": 4.9930728306904175,
            "ecco": 0.0002175,
            "argpo": 0.7570173644307685,
            "mo": 5.528192524681131,
            "no": 0.06572513169124992,
            "a": 1.0857968527317223,
            "alta": 0.0860330135471914,
            "altp": 0.08556069191625326,
            "jdsatepoch": 2459632.42322932,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346246452703508,
            "con41": 0.08382176856382328,
            "cc1": -2.497195562771629e-10,
            "cc4": 9.079463996738908e-8,
            "cc5": 0.00013909563979884628,
            "d2": 3.6795720822727465e-18,
            "d3": -8.102044750475736e-26,
            "d4": 2.0795973327696178e-33,
            "delmo": 1.007026246886282,
            "eta": 0.0032084219284872675,
            "argpdot": 0.000036414831789517886,
            "omgcof": -3.8900846248953766e-8,
            "sinmao": -0.6852834123386179,
            "t": 243418.97572919726,
            "t2cof": -3.7457933441574434e-10,
            "t3cof": 3.804291795847273e-18,
            "t4cof": -6.356085014100904e-26,
            "t5cof": 1.3139516487765257e-33,
            "x1mth2": 0.6387260771453922,
            "x7thm1": 1.5289174599822544,
            "mdot": 0.06572893272423685,
            "nodedot": -0.00005442703688111505,
            "xlcof": 0.0017528081891006392,
            "xmcof": 0.0033312977851479445,
            "nodecf": 4.7556635020107914e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 2.1671857798759646,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1279"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45361",
            "epochyr": 22,
            "epochdays": 53.50838461,
            "ndot": 1.9422848099450786e-11,
            "nddot": 0,
            "bstar": 0.000061925,
            "inclo": 0.9259652360238195,
            "nodeo": 5.121750720452204,
            "ecco": 0.0001464,
            "argpo": 1.2386723874451395,
            "mo": 5.0465148123864845,
            "no": 0.06572515754326427,
            "a": 1.0857965629737953,
            "alta": 0.08595552359061465,
            "altp": 0.08563760235697604,
            "jdsatepoch": 2459633.00838461,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346221916544147,
            "con41": 0.08383182941402079,
            "cc1": 2.84018509266009e-10,
            "cc4": 7.129705747285853e-8,
            "cc5": 0.00013909271868376701,
            "d2": 4.759781966152174e-18,
            "d3": 1.1920103950223563e-25,
            "d4": 3.47984835918579e-33,
            "delmo": 1.0021261928089433,
            "eta": 0.002159607650985551,
            "argpdot": 0.000036415623680927774,
            "omgcof": 2.9485183029622126e-8,
            "sinmao": -0.9446973482382963,
            "t": 242576.35211147368,
            "t2cof": 4.260277638990135e-10,
            "t3cof": 4.921114993363546e-18,
            "t4cof": 9.351365511940497e-26,
            "t5cof": 2.198671619811212e-33,
            "x1mth2": 0.6387227235286598,
            "x7thm1": 1.5289409352993815,
            "mdot": 0.06572895903516186,
            "nodedot": -0.000054427338443686995,
            "xlcof": 0.001752804604702198,
            "xmcof": -0.008362863636011318,
            "nodecf": -5.408883278222551e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.853891205635975,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1301"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45362",
            "epochyr": 22,
            "epochdays": 53.42175262,
            "ndot": 2.1210598548542201e-13,
            "nddot": 0,
            "bstar": 0.0000194,
            "inclo": 0.9259931612918515,
            "nodeo": 5.477572740385539,
            "ecco": 0.000159,
            "argpo": 1.126177190507845,
            "mo": 5.159022226628543,
            "no": 0.06572510002107824,
            "a": 1.0857972366732866,
            "alta": 0.08596987843391779,
            "altp": 0.0856245949126555,
            "jdsatepoch": 2459632.92175262,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346418202630333,
            "con41": 0.08375134318042254,
            "cc1": 8.897495361063516e-11,
            "cc4": 7.472012112772396e-8,
            "cc5": 0.00013908876031915276,
            "d2": 4.671171666438449e-19,
            "d3": 3.664683226920167e-27,
            "d4": 3.3514623341916766e-35,
            "delmo": 1.0030423098461037,
            "eta": 0.002345456703980024,
            "argpdot": 0.000036409466594786005,
            "omgcof": 1.1219430799527132e-8,
            "sinmao": -0.901906418138874,
            "t": 242701.1021771282,
            "t2cof": 1.3346243041595273e-10,
            "t3cof": 4.829502513838742e-19,
            "t4cof": 2.8749585398640493e-27,
            "t5cof": 2.117554392224733e-35,
            "x1mth2": 0.6387495522731925,
            "x7thm1": 1.5287531340876526,
            "mdot": 0.06572889786072915,
            "nodedot": -0.000054425192328212934,
            "xlcof": 0.0017528332789681605,
            "xmcof": -0.0022210951696470796,
            "nodecf": -1.694383544184394e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.308076046600419,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1306"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45364",
            "epochyr": 22,
            "epochdays": 53.11858595,
            "ndot": 3.736095430050362e-11,
            "nddot": 0,
            "bstar": 0.0001017,
            "inclo": 0.9259634906945676,
            "nodeo": 4.977848323625271,
            "ecco": 0.0001666,
            "argpo": 1.1890963100422407,
            "mo": 5.096124051045171,
            "no": 0.06572514195868605,
            "a": 1.0857967321193611,
            "alta": 0.0859776258549323,
            "altp": 0.08561583838378994,
            "jdsatepoch": 2459632.61858595,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346209648421764,
            "con41": 0.08383685984672495,
            "cc1": 4.664453145240311e-10,
            "cc4": 7.683903980042487e-8,
            "cc5": 0.000139092674096182,
            "d2": 1.2837909143637258e-17,
            "d3": 5.280079054666997e-25,
            "d4": 2.531476174406245e-32,
            "delmo": 1.0027627958664262,
            "eta": 0.0024575809599921825,
            "argpdot": 0.000036415984216649935,
            "omgcof": 4.861356443415812e-8,
            "sinmao": -0.9272727468572236,
            "t": 243137.66218163073,
            "t2cof": 6.996679717860466e-10,
            "t3cof": 1.3273051606520103e-17,
            "t4cof": 4.142241895087319e-25,
            "t5cof": 1.5994620662272967e-32,
            "x1mth2": 0.6387210467177583,
            "x7thm1": 1.528952672975692,
            "mdot": 0.0657289436762977,
            "nodedot": -0.00005442743622339951,
            "xlcof": 0.0017528028124906352,
            "xmcof": -0.010605691873465812,
            "nodecf": -8.88305745793059e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 3.3980083682076128,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1313"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45365",
            "epochyr": 22,
            "epochdays": 53.79419917,
            "ndot": -5.8056438312866937e-11,
            "nddot": 0,
            "bstar": -0.00011235,
            "inclo": 0.9250087955937267,
            "nodeo": 5.099653106792704,
            "ecco": 0.0001597,
            "argpo": 1.1217492901955355,
            "mo": 5.1634483816116,
            "no": 0.06568918541691911,
            "a": 1.0861915791421928,
            "alta": 0.08636504393738176,
            "altp": 0.0860181143470038,
            "jdsatepoch": 2459633.29419917,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009339494719442843,
            "con41": 0.08658926486875818,
            "cc1": -5.042974438979483e-10,
            "cc4": 7.395099133038609e-8,
            "cc5": 0.0001361870603071955,
            "d2": 1.4931157179813344e-17,
            "d3": -6.606090165743043e-25,
            "d4": 3.4070693215094587e-32,
            "delmo": 1.0030685685320744,
            "eta": 0.002344039135808666,
            "argpdot": 0.000036577338796784686,
            "omgcof": -6.348125628242458e-8,
            "sinmao": -0.8999857941185885,
            "t": 242164.77914504707,
            "t2cof": -7.564461658469225e-10,
            "t3cof": 1.543978900365735e-17,
            "t4cof": -5.183666227921955e-25,
            "t5cof": 2.1532464941943747e-32,
            "x1mth2": 0.6378035783770806,
            "x7thm1": 1.5353749513604358,
            "mdot": 0.06569310675134,
            "nodedot": -0.00005442744330125456,
            "xlcof": 0.0017518212398895284,
            "xmcof": 0.012542348315881175,
            "nodecf": 9.603835603872587e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.371448550934609,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1317"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45366",
            "epochyr": 22,
            "epochdays": 53.40701402,
            "ndot": -1.5120126679603653e-11,
            "nddot": 0,
            "bstar": -0.000014612,
            "inclo": 0.9259739626700796,
            "nodeo": 5.478625173924493,
            "ecco": 0.0001715,
            "argpo": 1.164944443853143,
            "mo": 5.120281153222025,
            "no": 0.06572469352692618,
            "a": 1.0858016863837612,
            "alta": 0.08598790137297607,
            "altp": 0.08561547139454628,
            "jdsatepoch": 2459632.90701402,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934628325672902,
            "con41": 0.08380667732656011,
            "cc1": -6.699958134602451e-11,
            "cc4": 7.814564541645305e-8,
            "cc5": 0.00013905630328048753,
            "d2": 2.6485601599798894e-19,
            "d3": -1.5645882224486232e-27,
            "d4": 1.0774014123776907e-35,
            "delmo": 1.0030134358646312,
            "eta": 0.0025297045223802578,
            "argpdot": 0.00003641312421788327,
            "omgcof": -7.188958248176495e-9,
            "sinmao": -0.9179589844097572,
            "t": 242722.32576146722,
            "t2cof": -1.0049937201903677e-10,
            "t3cof": 2.7383390379907407e-19,
            "t4cof": -1.2274287868080464e-27,
            "t5cof": 6.807365134074929e-36,
            "x1mth2": 0.6387311075578133,
            "x7thm1": 1.5288822470953067,
            "mdot": 0.06572849381728545,
            "nodedot": -0.00005442580653759692,
            "xlcof": 0.0017528135656365892,
            "xmcof": 0.001437672839783957,
            "nodecf": 1.2759124197736542e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.215217145083827,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1262"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45367",
            "epochyr": 22,
            "epochdays": 53.49548499,
            "ndot": -6.757090680464158e-11,
            "nddot": 0,
            "bstar": -0.0001309,
            "inclo": 0.9259600000360637,
            "nodeo": 5.472040046656718,
            "ecco": 0.0001437,
            "argpo": 1.258234037701492,
            "mo": 5.0269514168008795,
            "no": 0.06572440926181836,
            "a": 1.0858047973639289,
            "alta": 0.08596082751331013,
            "altp": 0.08564876721454762,
            "jdsatepoch": 2459632.99548499,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346185112091584,
            "con41": 0.08384692072734745,
            "cc1": -6.001002833536048e-10,
            "cc4": 7.052242382544957e-8,
            "cc5": 0.0001390313443924114,
            "d2": 2.124692618946386e-17,
            "d3": -1.124140987705751e-24,
            "d4": 6.933183765758526e-32,
            "delmo": 1.0019686664241787,
            "eta": 0.002119557595633355,
            "argpdot": 0.00003641579808576035,
            "omgcof": -5.985047668203089e-8,
            "sinmao": -0.9509318522945668,
            "t": 242594.92756426334,
            "t2cof": -9.001504250304071e-10,
            "t3cof": 2.1967166889626015e-17,
            "t4cof": -8.81896870869697e-25,
            "t5cof": 4.3806152185140287e-32,
            "x1mth2": 0.6387176930908842,
            "x7thm1": 1.5289761483638107,
            "mdot": 0.06572821133595211,
            "nodedot": -0.00005442627388771918,
            "xlcof": 0.0017527992280428248,
            "xmcof": 0.018342059546630467,
            "nodecf": 1.142815925930448e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.7726185933537835,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1273"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45368",
            "epochyr": 22,
            "epochdays": 53.66503158,
            "ndot": -3.945171330028849e-11,
            "nddot": 0,
            "bstar": -0.000068571,
            "inclo": 0.9259826893163396,
            "nodeo": 5.458393317235374,
            "ecco": 0.000144,
            "argpo": 1.6541270719313659,
            "mo": 4.6310723452050215,
            "no": 0.06572473144337942,
            "a": 1.0858012812948414,
            "alta": 0.08595763667934775,
            "altp": 0.0856449259103349,
            "jdsatepoch": 2459633.16503158,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934634459620213,
            "con41": 0.08378152536587868,
            "cc1": -3.1441849602992346e-10,
            "cc4": 7.059755298200393e-8,
            "cc5": 0.00013905771695844936,
            "d2": 5.832894653493164e-18,
            "d3": -1.6170097923868963e-25,
            "d4": 5.225507051358414e-33,
            "delmo": 0.9994824915360998,
            "eta": 0.0021240780039751207,
            "argpdot": 0.00003641127159420132,
            "omgcof": 8.471054378815012e-9,
            "sinmao": -0.9966956238437598,
            "t": 242350.7804750651,
            "t2cof": -4.716277440448852e-10,
            "t3cof": 6.030612634784602e-18,
            "t4cof": -1.2685535206026879e-25,
            "t5cof": 3.301640815506672e-33,
            "x1mth2": 0.6387394915447071,
            "x7thm1": 1.5288235591870505,
            "mdot": 0.06572853059991896,
            "nodedot": -0.000054425242823060604,
            "xlcof": 0.0017528225263652737,
            "xmcof": 0.009569774638637086,
            "nodecf": 5.987594810883794e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.5576426022972996,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1276"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45369",
            "epochyr": 22,
            "epochdays": 53.0005993,
            "ndot": -6.551044865992605e-11,
            "nddot": 0,
            "bstar": -0.00012638,
            "inclo": 0.9259477827312996,
            "nodeo": 5.5107723934169766,
            "ecco": 0.000163,
            "argpo": 1.2096999218620337,
            "mo": 5.075516948566874,
            "no": 0.06572416318015092,
            "a": 1.0858074902970996,
            "alta": 0.0859844769180178,
            "altp": 0.08563050367618108,
            "jdsatepoch": 2459632.5005993,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346099234039144,
            "con41": 0.0838821339692497,
            "cc1": -5.792973610277904e-10,
            "cc4": 7.581269248612359e-8,
            "cc5": 0.00013901236933559443,
            "d2": 1.979869842615108e-17,
            "d3": -1.0111697553001004e-24,
            "d4": 6.020031220471738e-32,
            "delmo": 1.0025640478842386,
            "eta": 0.0024041477452411567,
            "argpdot": 0.00003641814210175723,
            "omgcof": -5.851830512274585e-8,
            "sinmao": -0.934790344391641,
            "t": 243307.56295792758,
            "t2cof": -8.689460415416856e-10,
            "t3cof": 2.0469869291138605e-17,
            "t4cof": -7.93271327113846e-25,
            "t5cof": 3.8036619385377985e-32,
            "x1mth2": 0.6387059553435834,
            "x7thm1": 1.5290583125949162,
            "mdot": 0.06572796681550545,
            "nodedot": -0.000054426689397556874,
            "xlcof": 0.0017527866822163026,
            "xmcof": 0.013761826531640306,
            "nodecf": 1.1032076518246691e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 2.6546466814001377,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1277"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45370",
            "epochyr": 22,
            "epochdays": 53.45492602,
            "ndot": -3.984562441618999e-11,
            "nddot": 0,
            "bstar": -0.000069409,
            "inclo": 0.9260053785966155,
            "nodeo": 5.474998379738848,
            "ecco": 0.000168,
            "argpo": 1.1032889426971915,
            "mo": 5.181922691743961,
            "no": 0.06572491362472394,
            "a": 1.08579930727263,
            "alta": 0.08598172155625172,
            "altp": 0.08561689298900821,
            "jdsatepoch": 2459632.95492602,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346504075501147,
            "con41": 0.08371613086149332,
            "cc1": -3.1829789936708134e-10,
            "cc4": 7.716492108520615e-8,
            "cc5": 0.00013907408023465303,
            "d2": 5.9778710329040215e-18,
            "d3": -1.6776904104983302e-25,
            "d4": 5.488635413579007e-33,
            "delmo": 1.0033676480572575,
            "eta": 0.0024781539743510923,
            "argpdot": 0.00003640656488644549,
            "omgcof": -3.979996847093628e-8,
            "sinmao": -0.8917793669934319,
            "t": 242653.33248116076,
            "t2cof": -4.77446849050622e-10,
            "t3cof": 6.180498138387015e-18,
            "t4cof": -1.316156318922944e-25,
            "t5cof": 3.4678890880995745e-33,
            "x1mth2": 0.6387612897128355,
            "x7thm1": 1.5286709720101515,
            "mdot": 0.06572870984479519,
            "nodedot": -0.00005442394195983164,
            "xlcof": 0.001752845823297136,
            "xmcof": 0.007117373425915865,
            "nodecf": 6.061328184390034e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.517081341026298,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1281"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45371",
            "epochyr": 22,
            "epochdays": 53.4180726,
            "ndot": -5.208716986420577e-11,
            "nddot": 0,
            "bstar": -0.000096573,
            "inclo": 0.9260071239258675,
            "nodeo": 5.477841521090347,
            "ecco": 0.0001448,
            "argpo": 1.3023943584354527,
            "mo": 4.982794586725424,
            "no": 0.0657249356225252,
            "a": 1.0857990674881672,
            "alta": 0.08595629119313952,
            "altp": 0.08564184378319495,
            "jdsatepoch": 2459632.9180726,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346516342940237,
            "con41": 0.08371110055050646,
            "cc1": -4.428694989021389e-10,
            "cc4": 7.080156078243737e-8,
            "cc5": 0.00013907446776284649,
            "d2": 1.1572624734023636e-17,
            "d3": -4.518980707169232e-25,
            "d4": 2.0570099171205812e-32,
            "delmo": 1.0017126479877343,
            "eta": 0.002135939264805003,
            "argpdot": 0.00003640621256850521,
            "omgcof": -3.7807546800225904e-8,
            "sinmao": -0.9636626291287549,
            "t": 242706.40140607953,
            "t2cof": -6.643042483532083e-10,
            "t3cof": 1.1964891520139299e-17,
            "t4cof": -3.5451619433226475e-25,
            "t5cof": 1.2996820841582355e-32,
            "x1mth2": 0.6387629664831646,
            "x7thm1": 1.528659234617848,
            "mdot": 0.06572873161774666,
            "nodedot": -0.000054423856466963774,
            "xlcof": 0.0017528476153112185,
            "xmcof": 0.013330471562746516,
            "nodecf": 8.433524782465697e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.2848904917304225,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1287"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45372",
            "epochyr": 22,
            "epochdays": 53.43281425,
            "ndot": -1.3120270245026819e-11,
            "nddot": 0,
            "bstar": -0.000010144,
            "inclo": 0.9260018879381114,
            "nodeo": 5.47691649658679,
            "ecco": 0.0001532,
            "argpo": 1.1461105958948723,
            "mo": 5.139080094595256,
            "no": 0.06572477325639157,
            "a": 1.0858008483354529,
            "alta": 0.08596719302541778,
            "altp": 0.08563450364548797,
            "jdsatepoch": 2459632.93281425,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346479540537554,
            "con41": 0.08372619149868421,
            "cc1": -4.651448363701669e-11,
            "cc4": 7.31019495253548e-8,
            "cc5": 0.00013906166998503788,
            "d2": 1.2765766661446804e-19,
            "d3": -5.235498983222201e-28,
            "d4": 2.5029751071125032e-36,
            "delmo": 1.0028083484142825,
            "eta": 0.0022597961665000964,
            "argpdot": 0.00003640714372294805,
            "omgcof": -5.83124232949747e-9,
            "sinmao": -0.9103401490284531,
            "t": 242685.1734302938,
            "t2cof": -6.977172545552503e-11,
            "t3cof": 1.3198486099050463e-19,
            "t4cof": -4.107278115912982e-28,
            "t5cof": 1.5814584497803246e-36,
            "x1mth2": 0.6387579361671053,
            "x7thm1": 1.5286944468302628,
            "mdot": 0.06572856991304847,
            "nodedot": -0.00005442392461098046,
            "xlcof": 0.0017528422392442853,
            "xmcof": 0.0012507953464633297,
            "nodecf": 8.857722704610874e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.37776860700653,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1288"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45373",
            "epochyr": 22,
            "epochdays": 53.74612109,
            "ndot": -3.060386362003946e-11,
            "nddot": 0,
            "bstar": -0.000048921,
            "inclo": 0.9259809439870875,
            "nodeo": 5.452146783842486,
            "ecco": 0.0001466,
            "argpo": 1.3945826495257931,
            "mo": 4.890616767610595,
            "no": 0.06572469731721092,
            "a": 1.0858016546686007,
            "alta": 0.0859608331911752,
            "altp": 0.08564247614602616,
            "jdsatepoch": 2459633.24612109,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346332328364449,
            "con41": 0.08378655574787275,
            "cc1": -2.2431299861115936e-10,
            "cc4": 7.13105434263925e-8,
            "cc5": 0.000139055072038543,
            "d2": 2.968757853014238e-18,
            "d3": -5.871479825772867e-26,
            "d4": 1.3536539020860813e-33,
            "delmo": 1.001150539010123,
            "eta": 0.002162419119731076,
            "argpdot": 0.000036411607781256944,
            "omgcof": -1.2502479328150927e-8,
            "sinmao": -0.9841594261217169,
            "t": 242234.01158049703,
            "t2cof": -3.3646949791673903e-10,
            "t3cof": 3.069390495706098e-18,
            "t4cof": -4.6062108134077125e-26,
            "t5cof": 8.552816080249105e-34,
            "x1mth2": 0.6387378147507091,
            "x7thm1": 1.528835296745036,
            "mdot": 0.0657284966969246,
            "nodedot": -0.00005442530416557173,
            "xlcof": 0.0017528207342359936,
            "xmcof": 0.00658729016660182,
            "nodecf": 4.271685203810605e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.0685379867874403,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1295"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45374",
            "epochyr": 22,
            "epochdays": 53.4107008,
            "ndot": -6.405600761659745e-11,
            "nddot": 0,
            "bstar": -0.0001231,
            "inclo": 0.9259879253040956,
            "nodeo": 5.478469839621065,
            "ecco": 0.0001391,
            "argpo": 1.53215299182649,
            "mo": 4.753035953334385,
            "no": 0.06572471633340717,
            "a": 1.0858014552475699,
            "alta": 0.08595249022999485,
            "altp": 0.08565042026514491,
            "jdsatepoch": 2459632.9107008,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346381399544351,
            "con41": 0.08376643425032804,
            "cc1": -5.644438355890513e-10,
            "cc4": 6.924749165847764e-8,
            "cc5": 0.00013905621082045756,
            "d2": 1.8797864480755954e-17,
            "d3": -9.355107042220591e-25,
            "d4": 5.427205647618367e-32,
            "delmo": 1.0002501498585814,
            "eta": 0.0020517960255546047,
            "argpdot": 0.000036410111425831566,
            "omgcof": -7.307201498368208e-9,
            "sinmao": -0.9991740255257034,
            "t": 242717.01679810882,
            "t2cof": -8.466657533835769e-10,
            "t3cof": 1.9435058167824914e-17,
            "t4cof": -7.339136194126755e-25,
            "t5cof": 3.429080749043483e-32,
            "x1mth2": 0.6387445219165573,
            "x7thm1": 1.5287883465840988,
            "mdot": 0.06572851480456714,
            "nodedot": -0.00005442483184379571,
            "xlcof": 0.001752827902703745,
            "xmcof": 0.018411407597241084,
            "nodecf": 1.0748844854660561e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.238445290615729,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1300"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45375",
            "epochyr": 22,
            "epochdays": 53.42544482,
            "ndot": -1.333843640152611e-10,
            "nddot": 0,
            "bstar": -0.00027699,
            "inclo": 0.9259460374020476,
            "nodeo": 5.47750292721546,
            "ecco": 0.0001591,
            "argpo": 1.209703412520538,
            "mo": 5.07550473126211,
            "no": 0.06572428528353769,
            "a": 1.0858061428673518,
            "alta": 0.085978894624682,
            "altp": 0.08563339111002155,
            "jdsatepoch": 2459632.92544482,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934608696563206,
            "con41": 0.08388716445266031,
            "cc1": -1.269751644610472e-9,
            "cc4": 7.475238091276949e-8,
            "cc5": 0.00013902211117909784,
            "d2": 9.512145924419338e-17,
            "d3": -1.0648552890589801e-23,
            "d4": 1.3896003943616977e-30,
            "delmo": 1.0025026104979549,
            "eta": 0.002346665153647402,
            "argpdot": 0.000036418679862322434,
            "omgcof": -1.3141071970994972e-7,
            "sinmao": -0.9347946839080477,
            "t": 242695.7854092121,
            "t2cof": -1.904627466915708e-9,
            "t3cof": 9.834599772217538e-17,
            "t4cof": -8.353874509675948e-24,
            "t5cof": 8.779963557893687e-31,
            "x1mth2": 0.6387042785157799,
            "x7thm1": 1.529070050389541,
            "mdot": 0.0657280891631696,
            "nodedot": -0.000054427052437995,
            "xlcof": 0.0017527848899224583,
            "xmcof": 0.03166073602738015,
            "nodecf": 2.4181174397755106e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.331338339176384,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1302"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45376",
            "epochyr": 22,
            "epochdays": 53.44387796,
            "ndot": -3.4815682474678555e-11,
            "nddot": 0,
            "bstar": -0.000058287,
            "inclo": 0.9259757079993315,
            "nodeo": 5.476036850643785,
            "ecco": 0.0001684,
            "argpo": 1.2157108358059023,
            "mo": 5.069516506598518,
            "no": 0.06572485670281347,
            "a": 1.0857998915976468,
            "alta": 0.08598274029939179,
            "altp": 0.08561704289590177,
            "jdsatepoch": 2459632.94387796,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346295524680581,
            "con41": 0.08380164692428138,
            "cc1": -2.6728606972431516e-10,
            "cc4": 7.730320501686724e-8,
            "cc5": 0.00013906944885731473,
            "d2": 4.215297183746749e-18,
            "d3": -9.934192485868152e-26,
            "d4": 2.729129981400182e-33,
            "delmo": 1.0026074024933174,
            "eta": 0.0024840346191118815,
            "argpdot": 0.00003641295461450052,
            "omgcof": -2.572134570367292e-8,
            "sinmao": -0.936904859697884,
            "t": 242669.24168743193,
            "t2cof": -4.0092910458647274e-10,
            "t3cof": 4.358180869884092e-18,
            "t4cof": -7.79342528185213e-26,
            "t5cof": 1.7243491790374114e-33,
            "x1mth2": 0.6387327843585728,
            "x7thm1": 1.5288705094899897,
            "mdot": 0.0657286567874254,
            "nodedot": -0.000054425994554977004,
            "xlcof": 0.0017528153577987824,
            "xmcof": 0.005948380072684857,
            "nodecf": 5.0901034446988335e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.447474275843362,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1304"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45377",
            "epochyr": 22,
            "epochdays": 53.80140112,
            "ndot": 9.032684896172043e-11,
            "nddot": 0,
            "bstar": 0.00021892,
            "inclo": 0.9259600000360637,
            "nodeo": 5.447772988736989,
            "ecco": 0.0001673,
            "argpo": 1.1509887911541965,
            "mo": 5.1342280792747115,
            "no": 0.06572527351962393,
            "a": 1.0857952780462792,
            "alta": 0.08597693159629638,
            "altp": 0.08561362449626198,
            "jdsatepoch": 2459633.30140112,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346185112091584,
            "con41": 0.08384692072734745,
            "cc1": 1.004153330502646e-9,
            "cc4": 7.704235611293575e-8,
            "cc5": 0.0001391034868880938,
            "d2": 5.949779399538075e-17,
            "d3": 5.2681033782409444e-24,
            "d4": 5.43744669802512e-31,
            "delmo": 1.0030344920554297,
            "eta": 0.0024679522188411364,
            "argpdot": 0.00003641691449456649,
            "omgcof": 1.1403459628272343e-7,
            "sinmao": -0.912337484775474,
            "t": 242154.40833695233,
            "t2cof": 1.506229995753969e-9,
            "t3cof": 6.151444181769987e-17,
            "t4cof": 4.132843537208815e-24,
            "t5cof": 3.4355375583776055e-31,
            "x1mth2": 0.6387176930908842,
            "x7thm1": 1.5289761483638107,
            "mdot": 0.06572907571058158,
            "nodedot": -0.00005442794491876695,
            "xlcof": 0.0017527992280428248,
            "xmcof": -0.022640594754172075,
            "nodecf": -1.9123431017105158e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.4168236314300415,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1305"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45378",
            "epochyr": 22,
            "epochdays": 53.45861626,
            "ndot": -1.4514109578216734e-11,
            "nddot": 0,
            "bstar": -0.000013265,
            "inclo": 0.9259617453653156,
            "nodeo": 5.474930311898021,
            "ecco": 0.0001473,
            "argpo": 1.3031204154042824,
            "mo": 4.982075511073602,
            "no": 0.06572469756093004,
            "a": 1.0858016243950408,
            "alta": 0.08596156297431423,
            "altp": 0.08564168581576737,
            "jdsatepoch": 2459632.95861626,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346197380270909,
            "con41": 0.08384189028450095,
            "cc1": -6.082295405207003e-11,
            "cc4": 7.152301266056929e-8,
            "cc5": 0.00013905513201170226,
            "d2": 2.182734569666568e-19,
            "d3": -1.1705414764702045e-27,
            "d4": 7.317453248159992e-36,
            "delmo": 1.0017376539891292,
            "eta": 0.002172744523628458,
            "argpdot": 0.00003641579020103462,
            "omgcof": -5.0904245815589364e-9,
            "sinmao": -0.9638544611327118,
            "t": 242648.0185355991,
            "t2cof": -9.123443107810504e-11,
            "t3cof": 2.2567232044589725e-19,
            "t4cof": -9.18296742601056e-28,
            "t5cof": 4.623399792283243e-36,
            "x1mth2": 0.6387193699051663,
            "x7thm1": 1.5289644106638356,
            "mdot": 0.06572849944624541,
            "nodedot": -0.000054426703947386206,
            "xlcof": 0.0017528010202708438,
            "xmcof": 0.0017692174662623664,
            "nodecf": 1.158306247900694e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.54033128504345,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1310"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45379",
            "epochyr": 22,
            "epochdays": 53.19690646,
            "ndot": -1.1484024071282134e-11,
            "nddot": 0,
            "bstar": -0.0000065736,
            "inclo": 0.9259879253040956,
            "nodeo": 5.49520754714769,
            "ecco": 0.0001443,
            "argpo": 1.2085410232387095,
            "mo": 5.076640940605158,
            "no": 0.06572506613755405,
            "a": 1.085797602355117,
            "alta": 0.08595428294913687,
            "altp": 0.08564092176109717,
            "jdsatepoch": 2459632.69690646,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346381399544351,
            "con41": 0.08376643425032804,
            "cc1": -3.014799715471861e-11,
            "cc4": 7.069185057221022e-8,
            "cc5": 0.00013908511958267528,
            "d2": 5.362967513076549e-20,
            "d3": -1.4256220819616235e-28,
            "d4": 4.4176463857038465e-37,
            "delmo": 1.0022766722859147,
            "eta": 0.0021286025334626814,
            "argpdot": 0.0000364105631029014,
            "omgcof": -3.4512844071175052e-9,
            "sinmao": -0.9343905120605421,
            "t": 243024.8806475848,
            "t2cof": -4.5221995732077914e-11,
            "t3cof": 5.544747859564733e-20,
            "t4cof": -1.1184064194398304e-28,
            "t5cof": 2.7912021265564978e-37,
            "x1mth2": 0.6387445219165573,
            "x7thm1": 1.5287883465840988,
            "mdot": 0.06572886465594413,
            "nodedot": -0.00005442550799778163,
            "xlcof": 0.001752827902703745,
            "xmcof": 0.0009137419069670575,
            "nodecf": 5.741229657962711e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 3.8914579757733208,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1319"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45380",
            "epochyr": 22,
            "epochdays": 53.06237701,
            "ndot": -6.602556319610494e-11,
            "nddot": 0,
            "bstar": -0.00012748,
            "inclo": 0.9259320747680317,
            "nodeo": 5.156627634894806,
            "ecco": 0.0001495,
            "argpo": 1.2132883188041341,
            "mo": 5.071902371685994,
            "no": 0.06572479398908215,
            "a": 1.0858005196518103,
            "alta": 0.0859628468294984,
            "altp": 0.0856381924741223,
            "jdsatepoch": 2459632.56237701,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009345988817350469,
            "con41": 0.08392740850246616,
            "cc1": -5.845604625126535e-10,
            "cc4": 7.216320481611486e-8,
            "cc5": 0.00013906314830913977,
            "d2": 2.016186142164816e-17,
            "d3": -1.0391644892747761e-24,
            "d4": 6.243458707534992e-32,
            "delmo": 1.0023293251627843,
            "eta": 0.0022052252208580006,
            "argpdot": 0.00003642237809630384,
            "omgcof": -6.377591759883242e-8,
            "sinmao": -0.9360681325728296,
            "t": 243218.60305555165,
            "t2cof": -8.768406937689802e-10,
            "t3cof": 2.0845283290314173e-17,
            "t4cof": -8.152302248238945e-25,
            "t5cof": 3.9448131241251733e-32,
            "x1mth2": 0.6386908638325113,
            "x7thm1": 1.529163953172421,
            "mdot": 0.06572859975973942,
            "nodedot": -0.00005442905287692485,
            "xlcof": 0.0017527705512754965,
            "xmcof": 0.01650662744093221,
            "nodecf": 1.1132788222521885e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 3.043870230165723,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1207"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45381",
            "epochyr": 22,
            "epochdays": 53.07342808,
            "ndot": 3.172499525760526e-11,
            "nddot": 0,
            "bstar": 0.000089175,
            "inclo": 0.9259791986578355,
            "nodeo": 5.155704355720502,
            "ecco": 0.0001365,
            "argpo": 0.725468792871719,
            "mo": 5.559624159180297,
            "no": 0.06572501718343061,
            "a": 1.0857981290143788,
            "alta": 0.0859463404589893,
            "altp": 0.08564991756976825,
            "jdsatepoch": 2459632.57342808,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346320060498297,
            "con41": 0.08379158613493731,
            "cc1": 4.0896375102485e-10,
            "cc4": 6.855884092826525e-8,
            "cc5": 0.0001390806872568029,
            "d2": 9.868585327224181e-18,
            "d3": 3.558586454291913e-25,
            "d4": 1.4958478714121117e-32,
            "delmo": 1.004533970355164,
            "eta": 0.0020135291882044486,
            "argpdot": 0.000036412400705316736,
            "omgcof": 1.0448934700427481e-7,
            "sinmao": -0.6620577767012303,
            "t": 243202.6895148307,
            "t2cof": 6.13445626537275e-10,
            "t3cof": 1.0203088026528812e-17,
            "t4cof": 2.791726644383791e-25,
            "t5cof": 9.451221011964649e-33,
            "x1mth2": 0.6387361379550209,
            "x7thm1": 1.528847034314854,
            "mdot": 0.06572881683409881,
            "nodedot": -0.000054426049208651284,
            "xlcof": 0.0017528189420984847,
            "xmcof": -0.013852271274921444,
            "nodecf": -7.788172341598007e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 3.1134962597320026,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1258"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45382",
            "epochyr": 22,
            "epochdays": 53.38305432,
            "ndot": 2.921002428684954e-11,
            "nddot": 0,
            "bstar": 0.000083627,
            "inclo": 0.9259757079993315,
            "nodeo": 5.131795090297431,
            "ecco": 0.0001391,
            "argpo": 1.422026206684152,
            "mo": 4.8631609931474715,
            "no": 0.06572529699013505,
            "a": 1.085795042108244,
            "alta": 0.08594607619860128,
            "altp": 0.08564400801788685,
            "jdsatepoch": 2459632.88305432,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346295524680581,
            "con41": 0.08380164692428138,
            "cc1": 3.8358548250626667e-10,
            "cc4": 6.929075336463142e-8,
            "cc5": 0.000139103725610985,
            "d2": 8.682135183802889e-18,
            "d3": 2.9365914163524056e-25,
            "d4": 1.1578380201720491e-32,
            "delmo": 1.0009249079901457,
            "eta": 0.0020519622087200123,
            "argpdot": 0.000036413522380399955,
            "omgcof": 1.9053469568101814e-8,
            "sinmao": -0.9886554151463877,
            "t": 242756.82772949338,
            "t2cof": 5.753782237594e-10,
            "t3cof": 8.97641082858202e-18,
            "t4cof": 2.3037647909891197e-25,
            "t5cof": 7.315557378543912e-33,
            "x1mth2": 0.6387327843585728,
            "x7thm1": 1.5288705094899897,
            "mdot": 0.06572909713415709,
            "nodedot": -0.000054426844442641704,
            "xlcof": 0.0017528153577987824,
            "xmcof": -0.012510976551210784,
            "nodecf": -7.304983344346193e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.064261736235878,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1264"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45383",
            "epochyr": 22,
            "epochdays": 53.39779918,
            "ndot": 1.1241617230727367e-11,
            "nddot": 0,
            "bstar": 0.000043817,
            "inclo": 0.9259809439870875,
            "nodeo": 5.130381373603316,
            "ecco": 0.0001587,
            "argpo": 1.3552516548321007,
            "mo": 4.929968706255312,
            "no": 0.06572487810895505,
            "a": 1.0857996633455935,
            "alta": 0.08597197975216653,
            "altp": 0.08562734693902052,
            "jdsatepoch": 2459632.89779918,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346332328364449,
            "con41": 0.08378655574787275,
            "cc1": 2.009328895056074e-10,
            "cc4": 7.463866104904282e-8,
            "cc5": 0.0001390705828411928,
            "d2": 2.382203751684069e-18,
            "d3": 4.22045508521209e-26,
            "d4": 8.716195042670827e-34,
            "delmo": 1.0015167738462771,
            "eta": 0.002340958854311777,
            "argpdot": 0.00003641184144705048,
            "omgcof": 1.2622341764565995e-8,
            "sinmao": -0.9764227660570047,
            "t": 242735.5951309204,
            "t2cof": 3.013993342584111e-10,
            "t3cof": 2.4629518038542143e-18,
            "t4cof": 3.3109683563047234e-26,
            "t5cof": 5.507162189893117e-34,
            "x1mth2": 0.6387378147507091,
            "x7thm1": 1.528835296745036,
            "mdot": 0.06572867751310155,
            "nodedot": -0.000054425653948847223,
            "xlcof": 0.0017528207342359936,
            "xmcof": -0.005035055182877756,
            "nodecf": -3.826472690435145e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.157160077451792,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1266"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45384",
            "epochyr": 22,
            "epochdays": 53.85116103,
            "ndot": 1.88198610835708e-10,
            "nddot": 0,
            "bstar": 0.00043547,
            "inclo": 0.9259757079993315,
            "nodeo": 5.094867413983735,
            "ecco": 0.0001533,
            "argpo": 1.2597315301997032,
            "mo": 5.02547312292444,
            "no": 0.06572535597429581,
            "a": 1.0857943924383904,
            "alta": 0.0859608447187512,
            "altp": 0.08562794015802955,
            "jdsatepoch": 2459633.35116103,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346295524680581,
            "con41": 0.08380164692428138,
            "cc1": 1.9975213670135703e-9,
            "cc4": 7.31894788868559e-8,
            "cc5": 0.000139109361787816,
            "d2": 2.354445595936951e-16,
            "d3": 4.1470426237877456e-23,
            "d4": 8.5148233357126e-30,
            "delmo": 1.0020910016066353,
            "eta": 0.0022614550302614994,
            "argpdot": 0.00003641359883231048,
            "omgcof": 1.8590972974590113e-7,
            "sinmao": -0.9513881977954657,
            "t": 242082.7540665865,
            "t2cof": 2.9962820505203555e-9,
            "t3cof": 2.4342474281704665e-16,
            "t4cof": 3.253366202714127e-23,
            "t5cof": 5.3799107548873576e-30,
            "x1mth2": 0.6387327843585728,
            "x7thm1": 1.5288705094899897,
            "mdot": 0.06572915612630753,
            "nodedot": -0.000054426958884007756,
            "xlcof": 0.0017528153577987824,
            "xmcof": -0.05363949040454416,
            "nodecf": -3.8040779950372034e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.7303303760501407,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1267"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45386",
            "epochyr": 22,
            "epochdays": 53.39042889,
            "ndot": -2.5058807142349145e-11,
            "nddot": 0,
            "bstar": -0.000036652,
            "inclo": 0.9259861799748436,
            "nodeo": 5.131151063803445,
            "ecco": 0.0001487,
            "argpo": 1.3582117332434833,
            "mo": 4.926989429222156,
            "no": 0.06572510299309031,
            "a": 1.085797193906312,
            "alta": 0.08595865194904584,
            "altp": 0.0856357358635782,
            "jdsatepoch": 2459632.89042889,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346369131792081,
            "con41": 0.08377146461710683,
            "cc1": -1.6809828043583524e-10,
            "cc4": 7.190266283689e-8,
            "cc5": 0.00013908838658619087,
            "d2": 1.6673125118149412e-18,
            "d3": -2.4712876735213605e-26,
            "d4": 4.269891965518415e-34,
            "delmo": 1.0014020309296467,
            "eta": 0.002193519223034887,
            "argpdot": 0.0000364109909662953,
            "omgcof": -1.1117923978844101e-8,
            "sinmao": -0.977061559434788,
            "t": 242746.20834834874,
            "t2cof": -2.521474206537529e-10,
            "t3cof": 1.7238265755859106e-18,
            "t4cof": -1.9387349546141367e-26,
            "t5cof": 2.697845713431292e-34,
            "x1mth2": 0.638742845127631,
            "x7thm1": 1.528800084106583,
            "mdot": 0.06572890174424315,
            "nodedot": -0.000054425706572765433,
            "xlcof": 0.0017528261105991495,
            "xmcof": 0.004797732385802125,
            "nodecf": 3.201188894553503e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.1107243908085564,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1272"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45387",
            "epochyr": 22,
            "epochdays": 53.81062264,
            "ndot": -2.42406840554768e-13,
            "nddot": 0,
            "bstar": 0.000018382,
            "inclo": 0.9259774533285836,
            "nodeo": 5.098098018429177,
            "ecco": 0.0001571,
            "argpo": 1.3072463737559967,
            "mo": 4.977968751343659,
            "no": 0.06572493833919016,
            "a": 1.0857989949281657,
            "alta": 0.08596957395026883,
            "altp": 0.08562841590606252,
            "jdsatepoch": 2459633.31062264,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346307792603676,
            "con41": 0.08379661652707349,
            "cc1": 8.429792389632361e-11,
            "cc4": 7.420691648867154e-8,
            "cc5": 0.00013907541281126266,
            "d2": 4.1928975528682426e-19,
            "d3": 3.1164785437147437e-27,
            "d4": 2.700233449916938e-35,
            "delmo": 1.0018258272477942,
            "eta": 0.00231737697272012,
            "argpdot": 0.00003641267954913695,
            "omgcof": 6.515745007065353e-9,
            "sinmao": -0.9649404913019063,
            "t": 242141.12934842706,
            "t2cof": 1.2644688584448543e-10,
            "t3cof": 4.33502035233285e-19,
            "t4cof": 2.4448922575477385e-27,
            "t5cof": 1.7060904470632443e-35,
            "x1mth2": 0.6387344611576422,
            "x7thm1": 1.528858771896505,
            "mdot": 0.06572873820702604,
            "nodedot": -0.000054426024709089745,
            "xlcof": 0.0017528171499527477,
            "xmcof": -0.002155598372077324,
            "nodecf": -1.605341421132941e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.4749227850926658,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1274"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45388",
            "epochyr": 22,
            "epochdays": 53.77928329,
            "ndot": -2.893731659122543e-11,
            "nddot": 0,
            "bstar": -0.000045194,
            "inclo": 0.9259774533285836,
            "nodeo": 5.449506100684219,
            "ecco": 0.0001496,
            "argpo": 1.3205667266072174,
            "mo": 4.9646344358584225,
            "no": 0.0657251654632171,
            "a": 1.085796493297374,
            "alta": 0.08595892845277131,
            "altp": 0.08563405814197678,
            "jdsatepoch": 2459633.27928329,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346307792603676,
            "con41": 0.08379661652707349,
            "cc1": -2.0728283544475472e-10,
            "cc4": 7.216223779784085e-8,
            "cc5": 0.00013909355123849354,
            "d2": 2.535250828667914e-18,
            "d3": -4.633733958955347e-26,
            "d4": 9.872532025575008e-34,
            "delmo": 1.0016532338789788,
            "eta": 0.00220681462768893,
            "argpdot": 0.00003641297260086229,
            "omgcof": -1.599356518637338e-8,
            "sinmao": -0.9683544449417156,
            "t": 242186.2580126524,
            "t2cof": -3.109242531671321e-10,
            "t3cof": 2.6211831764079485e-18,
            "t4cof": -3.6351812009024923e-26,
            "t5cof": 6.237758804243711e-34,
            "x1mth2": 0.6387344611576422,
            "x7thm1": 1.528858771896505,
            "mdot": 0.0657289653617115,
            "nodedot": -0.00005442646338148916,
            "xlcof": 0.0017528171499527477,
            "xmcof": 0.005845078209159384,
            "nodecf": 3.947456694205315e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.277472716335204,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1280"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45389",
            "epochyr": 22,
            "epochdays": 53.82537078,
            "ndot": -1.242335057843186e-11,
            "nddot": 0,
            "bstar": -0.0000086597,
            "inclo": 0.9260001426088595,
            "nodeo": 5.096799493465693,
            "ecco": 0.0001626,
            "argpo": 1.0650208535179637,
            "mo": 5.22017507295992,
            "no": 0.06572479506048562,
            "a": 1.08580060566695,
            "alta": 0.08597715684543128,
            "altp": 0.08562405448846855,
            "jdsatepoch": 2459633.32537078,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346467273013054,
            "con41": 0.08373122182488735,
            "cc1": -3.97090137108375e-11,
            "cc4": 7.56827419077644e-8,
            "cc5": 0.0001390640316432436,
            "d2": 9.303578252233897e-20,
            "d3": -3.2573424140617e-28,
            "d4": 1.3294257549092602e-36,
            "delmo": 1.003502790439195,
            "eta": 0.002398459361169735,
            "argpdot": 0.000036407552268134096,
            "omgcof": -5.515022059488742e-9,
            "sinmao": -0.8738231471663238,
            "t": 242119.892026484,
            "t2cof": -5.956352056625625e-11,
            "t3cof": 9.618939406211393e-20,
            "t4cof": -2.5554029205080115e-28,
            "t5cof": 8.399729013418484e-37,
            "x1mth2": 0.6387562593917042,
            "x7thm1": 1.5287061842580707,
            "mdot": 0.06572859194787721,
            "nodedot": -0.000054424094280747305,
            "xlcof": 0.0017528404472055175,
            "xmcof": 0.000947895928283339,
            "nodecf": 7.561784941998603e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.5678417923201309,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1283"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45390",
            "epochyr": 22,
            "epochdays": 53.40147664,
            "ndot": 3.0300855069346005e-11,
            "nddot": 0,
            "bstar": 0.000086032,
            "inclo": 0.9259565093775597,
            "nodeo": 5.130329013725755,
            "ecco": 0.0001777,
            "argpo": 0.940626001740572,
            "mo": 5.344571670066564,
            "no": 0.06572515797521881,
            "a": 1.0857965456748209,
            "alta": 0.08598949172098735,
            "altp": 0.0856035996286546,
            "jdsatepoch": 2459632.90147664,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346160575647522,
            "con41": 0.08385698162825261,
            "cc1": 3.9459017171011057e-10,
            "cc4": 7.989200148229081e-8,
            "cc5": 0.000139094728870158,
            "d2": 9.187266742223253e-18,
            "d3": 3.1965312592589797e-25,
            "d4": 1.2964592741510804e-32,
            "delmo": 1.0046540835447673,
            "eta": 0.0026213272042493805,
            "argpdot": 0.000036417525968948754,
            "omgcof": 6.099382195800319e-8,
            "sinmao": -0.8067396643739116,
            "t": 242730.29958866537,
            "t2cof": 5.918852575651658e-10,
            "t3cof": 9.498669549443682e-18,
            "t4cof": 2.5076905553747e-25,
            "t5cof": 8.191414996313945e-33,
            "x1mth2": 0.6387143394572491,
            "x7thm1": 1.5289996237992565,
            "mdot": 0.06572896060615271,
            "nodedot": -0.00005442797642886468,
            "xlcof": 0.001752795643562102,
            "xmcof": -0.007885993288098574,
            "nodecf": -7.514710947040833e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.180329502040351,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1284"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45391",
            "epochyr": 22,
            "epochdays": 53.08448712,
            "ndot": -1.1181015520588674e-11,
            "nddot": 0,
            "bstar": -0.0000058596,
            "inclo": 0.9259896706333476,
            "nodeo": 5.155056838568012,
            "ecco": 0.0001437,
            "argpo": 1.3546774415081948,
            "mo": 4.930514994311185,
            "no": 0.06572494809149701,
            "a": 1.0857989050691075,
            "alta": 0.08595493437176582,
            "altp": 0.08564287576644913,
            "jdsatepoch": 2459632.58448712,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934639366726815,
            "con41": 0.08376140388862108,
            "cc1": -2.687150656931274e-11,
            "cc4": 7.051924234267324e-8,
            "cc5": 0.00013907542627928838,
            "d2": 4.260544605259414e-20,
            "d3": -1.0094637702958304e-28,
            "d4": 2.7880697801917987e-37,
            "delmo": 1.0013767542299954,
            "eta": 0.002119716893404205,
            "argpdot": 0.000036410030512279496,
            "omgcof": -1.8691704394411836e-9,
            "sinmao": -0.976304694776275,
            "t": 243186.7644969374,
            "t2cof": -4.030725985396911e-11,
            "t3cof": 4.4049601783203376e-20,
            "t4cof": -7.919290864291236e-29,
            "t5cof": 1.7615880149846032e-37,
            "x1mth2": 0.638746198703793,
            "x7thm1": 1.5287766090734491,
            "mdot": 0.06572874636617189,
            "nodedot": -0.00005442515264465024,
            "xlcof": 0.001752829694800112,
            "xmcof": 0.0008212659806810265,
            "nodecf": 5.117238305286686e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 3.1831725050109725,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1289"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45392",
            "epochyr": 22,
            "epochdays": 53.79489111,
            "ndot": 2.982513164475727e-10,
            "nddot": 0,
            "bstar": 0.00061852,
            "inclo": 0.9249267651188829,
            "nodeo": 4.995837432225577,
            "ecco": 0.0002175,
            "argpo": 1.2468981242097887,
            "mo": 5.038426956632743,
            "no": 0.06587538306118998,
            "a": 1.0841435761182037,
            "alta": 0.08437937734600931,
            "altp": 0.08390777489039802,
            "jdsatepoch": 2459633.29489111,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009338917353922576,
            "con41": 0.08682583082236661,
            "cc1": 3.1094708213571068e-9,
            "cc4": 1.029645064821116e-7,
            "cc5": 0.00015208205177272483,
            "d2": 5.827202874748826e-16,
            "d3": 1.6320022246906662e-22,
            "d4": 5.32814902988117e-29,
            "delmo": 1.0031521718802299,
            "eta": 0.0032770754209056783,
            "argpdot": 0.000036837375066528454,
            "omgcof": 2.1706967339213806e-7,
            "sinmao": -0.9473187810419306,
            "t": 242163.7827513367,
            "t2cof": 4.66420623203566e-9,
            "t3cof": 6.020579050526252e-16,
            "t4cof": 1.279111842415636e-22,
            "t5cof": 3.362837461475665e-29,
            "x1mth2": 0.6377247230592111,
            "x7thm1": 1.535926938585522,
            "mdot": 0.06587934117614797,
            "nodedot": -0.00005479417100715848,
            "xlcof": 0.0017517367852238,
            "xmcof": -0.04057239170451271,
            "nodecf": -5.961561521992998e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3758080419658185,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1290"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45393",
            "epochyr": 22,
            "epochdays": 53.37937411,
            "ndot": 3.41187628080836e-11,
            "nddot": 0,
            "bstar": 0.000094509,
            "inclo": 0.9259739626700796,
            "nodeo": 5.131866648796763,
            "ecco": 0.0001714,
            "argpo": 1.1859948599614467,
            "mo": 5.099234227772225,
            "no": 0.06572465613828309,
            "a": 1.0858020982005234,
            "alta": 0.085988204680155,
            "altp": 0.08561599172089185,
            "jdsatepoch": 2459632.87937411,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934628325672902,
            "con41": 0.08380667732656011,
            "cc1": 4.333369947653639e-10,
            "cc4": 7.811605567597824e-8,
            "cc5": 0.00013905323778046062,
            "d2": 1.1079366620881167e-17,
            "d3": 4.233080749979945e-25,
            "d4": 1.8853215852282265e-32,
            "delmo": 1.002864180551709,
            "eta": 0.0025282162918812503,
            "argpdot": 0.00003641307594572436,
            "omgcof": 4.4234078595408426e-8,
            "sinmao": -0.9261038557053897,
            "t": 242762.12723135948,
            "t2cof": 6.500054921480459e-10,
            "t3cof": 1.1454928522945722e-17,
            "t4cof": 3.320877856371711e-25,
            "t5cof": 1.1912065215886275e-32,
            "x1mth2": 0.6387311075578133,
            "x7thm1": 1.5288822470953067,
            "mdot": 0.06572845642359249,
            "nodedot": -0.00005442573427958899,
            "xlcof": 0.0017528135656365892,
            "xmcof": -0.009309422334566388,
            "nodecf": -8.252280216473208e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.041074987279373,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1291"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45394",
            "epochyr": 22,
            "epochdays": 53.07711567,
            "ndot": -6.754060594957223e-11,
            "nddot": 0,
            "bstar": -0.00013082,
            "inclo": 0.9259722173408276,
            "nodeo": 5.155610107940894,
            "ecco": 0.0001476,
            "argpo": 1.5434068748433496,
            "mo": 4.741799523610045,
            "no": 0.06572498224323056,
            "a": 1.0857985038270157,
            "alta": 0.0859587676861806,
            "altp": 0.0856382399678508,
            "jdsatepoch": 2459632.57711567,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346270988748986,
            "con41": 0.08381170773390967,
            "cc1": -5.999410822657008e-10,
            "cc4": 7.160944261591623e-8,
            "cc5": 0.0001390784419477477,
            "d2": 2.12373516101813e-17,
            "d3": -1.1234264385782973e-24,
            "d4": 6.927494779047009e-32,
            "delmo": 1.0001920874602044,
            "eta": 0.00217725611570715,
            "argpdot": 0.000036413876598365224,
            "omgcof": -5.1886395801122465e-9,
            "sinmao": -0.9995675411472997,
            "t": 243197.37938538194,
            "t2cof": -8.999116233985512e-10,
            "t3cof": 2.1957210214561578e-17,
            "t4cof": -8.81333148999869e-25,
            "t5cof": 4.3770026332735414e-32,
            "x1mth2": 0.6387294307553635,
            "x7thm1": 1.528893984712456,
            "mdot": 0.06572878280032099,
            "nodedot": -0.0000544264908683623,
            "xlcof": 0.0017528117734661674,
            "xmcof": 0.017379514381776963,
            "nodecf": 1.1425174296187907e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 3.136729507216316,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1292"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45395",
            "epochyr": 22,
            "epochdays": 53.37199879,
            "ndot": 2.636174391033102e-11,
            "nddot": 0,
            "bstar": 0.000077296,
            "inclo": 0.9259861799748436,
            "nodeo": 5.132632848338388,
            "ecco": 0.0001483,
            "argpo": 1.382292040933249,
            "mo": 4.902910866861642,
            "no": 0.06572510787935501,
            "a": 1.0857971400872042,
            "alta": 0.08595816380307908,
            "altp": 0.08563611637132929,
            "jdsatepoch": 2459632.87199879,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346369131792081,
            "con41": 0.08377146461710683,
            "cc1": 3.5450620066543633e-10,
            "cc4": 7.17932176740879e-8,
            "cc5": 0.0001390887633306713,
            "d2": 7.41546578111015e-18,
            "d3": 2.317958152087488e-25,
            "d4": 8.446174256764472e-33,
            "delmo": 1.0012433327950405,
            "eta": 0.002187620191553719,
            "argpdot": 0.00003641099726554579,
            "omgcof": 2.0880692808090136e-8,
            "sinmao": -0.9819055384863724,
            "t": 242772.74769209325,
            "t2cof": 5.317593009981545e-10,
            "t3cof": 7.666815073730635e-18,
            "t4cof": 1.8184472831069787e-25,
            "t5cof": 5.336545841016959e-33,
            "x1mth2": 0.638742845127631,
            "x7thm1": 1.528800084106583,
            "mdot": 0.06572890663116682,
            "nodedot": -0.0000544257160025583,
            "xlcof": 0.0017528261105991495,
            "xmcof": -0.010172693767912985,
            "nodecf": -6.751059596823137e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.994607609220495,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1297"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45396",
            "epochyr": 22,
            "epochdays": 53.81801036,
            "ndot": 5.307800782497338e-10,
            "nddot": 0,
            "bstar": 0.0011947,
            "inclo": 0.9259722173408276,
            "nodeo": 5.0974330479841665,
            "ecco": 0.0001089,
            "argpo": 1.9108475516072119,
            "mo": 4.374269835054332,
            "no": 0.06572158441400774,
            "a": 1.0858359304974974,
            "alta": 0.08595417803032857,
            "altp": 0.0857176829646662,
            "jdsatepoch": 2459633.31801036,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346270988748986,
            "con41": 0.08381170773390967,
            "cc1": 5.46760447434599e-9,
            "cc4": 6.083957951094972e-8,
            "cc5": 0.0001387988140628049,
            "d2": 1.7630781143094357e-15,
            "d3": 8.495672613481857e-22,
            "d4": 4.772117092031508e-28,
            "delmo": 0.9984030250751665,
            "eta": 0.0016056292175147863,
            "argpdot": 0.0000364094892727555,
            "omgcof": -7.801594696857956e-7,
            "sinmao": -0.9433802383623462,
            "t": 242130.49103155732,
            "t2cof": 8.201406711518985e-9,
            "t3cof": 1.8228675116852124e-15,
            "t4cof": 6.665035183411613e-22,
            "t5cof": 3.0152431468202313e-28,
            "x1mth2": 0.6387294307553635,
            "x7thm1": 1.528893984712456,
            "mdot": 0.06572538451212026,
            "nodedot": -0.00005441992358723926,
            "xlcof": 0.0017528117734661674,
            "xmcof": -0.2911133359270482,
            "nodecf": -1.0411155388849325e-12,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.5214682885572515,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1303"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45397",
            "epochyr": 22,
            "epochdays": 53.82903067,
            "ndot": 1.6050362930232579e-10,
            "nddot": 0,
            "bstar": 0.00037404,
            "inclo": 0.9259565093775597,
            "nodeo": 5.096532458090137,
            "ecco": 0.0001473,
            "argpo": 1.2293942171415377,
            "mo": 5.055794728019338,
            "no": 0.06572625371983298,
            "a": 1.0857844769247973,
            "alta": 0.08594441297824829,
            "altp": 0.0856245408713463,
            "jdsatepoch": 2459633.32903067,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346160575647522,
            "con41": 0.08385698162825261,
            "cc1": 1.7166702255086541e-9,
            "cc4": 7.16121717094528e-8,
            "cc5": 0.00013918251488938163,
            "d2": 1.7391375394960048e-16,
            "d3": 2.6328965972793432e-23,
            "d4": 4.6464474127381034e-30,
            "delmo": 1.002196745803363,
            "eta": 0.002173216209549854,
            "argpdot": 0.00003641894006204051,
            "omgcof": 1.8191353212627238e-7,
            "sinmao": -0.9416134272932353,
            "t": 242114.62178483605,
            "t2cof": 2.5750053382629812e-9,
            "t3cof": 1.7980766727589636e-16,
            "t4cof": 2.065502955112895e-23,
            "t5cof": 2.9357403563445052e-30,
            "x1mth2": 0.6387143394572491,
            "x7thm1": 1.5289996237992565,
            "mdot": 0.06573005649879206,
            "nodedot": -0.000054430092994644814,
            "xlcof": 0.001752795643562102,
            "xmcof": -0.04992318075285793,
            "nodecf": -3.2694129670942793e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.590900519936575,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1307"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45398",
            "epochyr": 22,
            "epochdays": 53.35724587,
            "ndot": -2.7543477258035512e-11,
            "nddot": 0,
            "bstar": -0.000042114,
            "inclo": 0.9259722173408276,
            "nodeo": 5.133444426440566,
            "ecco": 0.0001422,
            "argpo": 1.3874355262388764,
            "mo": 4.897755164251252,
            "no": 0.06572499040155477,
            "a": 1.0857984139680592,
            "alta": 0.08595281450252545,
            "altp": 0.08564401343359296,
            "jdsatepoch": 2459632.85724587,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346270988748986,
            "con41": 0.08381170773390967,
            "cc1": -1.931355897290153e-10,
            "cc4": 7.01287713803754e-8,
            "cc5": 0.00013907880492926509,
            "d2": 2.200940323448562e-18,
            "d3": -3.748061893564814e-26,
            "d4": 7.440335601464102e-34,
            "delmo": 1.0011602536537276,
            "eta": 0.0020976027910807795,
            "argpdot": 0.00003641388701743353,
            "omgcof": -1.154347210463635e-8,
            "sinmao": -0.9828688264775819,
            "t": 242793.99189725518,
            "t2cof": -2.8970338459352296e-10,
            "t3cof": 2.275543035488511e-18,
            "t4cof": -2.940371447220045e-26,
            "t5cof": 4.70103084041397e-34,
            "x1mth2": 0.6387294307553635,
            "x7thm1": 1.528893984712456,
            "mdot": 0.06572879095973819,
            "nodedot": -0.000054426506464222784,
            "xlcof": 0.0017528117734661674,
            "xmcof": 0.006027887436044313,
            "nodecf": 3.678041854993284e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.901658486047765,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1312"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45399",
            "epochyr": 22,
            "epochdays": 53.00062956,
            "ndot": -1.6029152331684036e-11,
            "nddot": 0,
            "bstar": -0.000016626,
            "inclo": 0.9259634906945676,
            "nodeo": 4.986903091784618,
            "ecco": 0.0001732,
            "argpo": 1.111205756184238,
            "mo": 5.174016350232426,
            "no": 0.06572512930674093,
            "a": 1.0857968714722916,
            "alta": 0.08598493149043085,
            "altp": 0.08560881145415267,
            "jdsatepoch": 2459632.50062956,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346209648421764,
            "con41": 0.08383685984672495,
            "cc1": -7.625447887503938e-11,
            "cc4": 7.864865673281345e-8,
            "cc5": 0.0001390920752634095,
            "d2": 3.4310162613995895e-19,
            "d3": -2.3069211824310015e-27,
            "d4": 1.8081315685465856e-35,
            "delmo": 1.0034178353376275,
            "eta": 0.0025549356008678402,
            "argpdot": 0.00003641596804445949,
            "omgcof": -9.103231744895191e-9,
            "sinmao": -0.8953288435589112,
            "t": 243307.51938343048,
            "t2cof": -1.1438171831255907e-10,
            "t3cof": 3.547311172369666e-19,
            "t4cof": -1.809788494909675e-27,
            "t5cof": 1.1424314982201406e-35,
            "x1mth2": 0.6387210467177583,
            "x7thm1": 1.528952672975692,
            "mdot": 0.06572893102265602,
            "nodedot": -0.00005442741201689488,
            "xlcof": 0.0017528028124906352,
            "xmcof": 0.001604196355202165,
            "nodecf": 1.4522015624319125e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 2.6548373315639964,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1255"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45400",
            "epochyr": 22,
            "epochdays": 53.81154253,
            "ndot": -5.884426054466994e-11,
            "nddot": 0,
            "bstar": -0.0001115,
            "inclo": 0.9259320747680317,
            "nodeo": 4.923668067655611,
            "ecco": 0.0001795,
            "argpo": 1.1657228606995327,
            "mo": 5.119518444338903,
            "no": 0.0657248516643781,
            "a": 1.0857998843896852,
            "alta": 0.08599478546893313,
            "altp": 0.08560498331043731,
            "jdsatepoch": 2459633.31154253,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009345988817350469,
            "con41": 0.08392740850246616,
            "cc1": -5.11307667741357e-10,
            "cc4": 8.039377745275572e-8,
            "cc5": 0.0001390697881772762,
            "d2": 1.542552146124042e-17,
            "d3": -6.954243622024541e-25,
            "d4": 3.6546620594937617e-32,
            "delmo": 1.0031486475520905,
            "eta": 0.002647766631735824,
            "argpdot": 0.00003642245329279501,
            "omgcof": -5.2321719480989773e-8,
            "sinmao": -0.9182612651646418,
            "t": 242139.804706648,
            "t2cof": -7.669615016120355e-10,
            "t3cof": 1.5948392523422632e-17,
            "t4cof": -5.455640188371311e-25,
            "t5cof": 2.309129207471603e-32,
            "x1mth2": 0.6386908638325113,
            "x7thm1": 1.529163953172421,
            "mdot": 0.06572865744289264,
            "nodedot": -0.00005442916541689717,
            "xlcof": 0.0017527705512754965,
            "xmcof": 0.010015119567061208,
            "nodecf": 9.737729555883997e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.4807184498796673,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1213"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45401",
            "epochyr": 22,
            "epochdays": 53.34343002,
            "ndot": 1.9574352374797518e-11,
            "nddot": 0,
            "bstar": 0.000062263,
            "inclo": 0.9259774533285836,
            "nodeo": 4.9601855915950885,
            "ecco": 0.0001716,
            "argpo": 1.1110888191243542,
            "mo": 5.174129796633806,
            "no": 0.06572501595222888,
            "a": 1.0857981400665415,
            "alta": 0.08598446302737695,
            "altp": 0.08561181710570609,
            "jdsatepoch": 2459632.84343002,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346307792603676,
            "con41": 0.08379661652707349,
            "cc1": 2.8554653855590313e-10,
            "cc4": 7.818816920755228e-8,
            "cc5": 0.00013908269150661803,
            "d2": 4.811040299742489e-18,
            "d3": 1.2113053213247993e-25,
            "d4": 3.555130449740926e-33,
            "delmo": 1.003386945659966,
            "eta": 0.002531293401901401,
            "argpdot": 0.00003641278009431164,
            "omgcof": 3.4414229031055765e-8,
            "sinmao": -0.8952783081206264,
            "t": 242813.8867212832,
            "t2cof": 4.283198078338547e-10,
            "t3cof": 4.974113951105005e-18,
            "t4cof": 9.502743320853851e-26,
            "t5cof": 2.246239376844146e-33,
            "x1mth2": 0.6387344611576422,
            "x7thm1": 1.528858771896505,
            "mdot": 0.06572881583057312,
            "nodedot": -0.00005442617521695461,
            "xlcof": 0.0017528171499527477,
            "xmcof": -0.0061198165329262606,
            "nodecf": -5.4378676255325506e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.814613269005733,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1256"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45402",
            "epochyr": 22,
            "epochdays": 53.80417367,
            "ndot": -3.772456456133577e-11,
            "nddot": 0,
            "bstar": -0.000064698,
            "inclo": 0.9259739626700796,
            "nodeo": 4.923963028299198,
            "ecco": 0.0001587,
            "argpo": 1.434929425844146,
            "mo": 4.8502961712310215,
            "no": 0.06572494578031707,
            "a": 1.0857989079522854,
            "alta": 0.0859712242389774,
            "altp": 0.08562659166559339,
            "jdsatepoch": 2459633.30417367,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934628325672902,
            "con41": 0.08380667732656011,
            "cc1": -2.9669986859962625e-10,
            "cc4": 7.464995816963325e-8,
            "cc5": 0.00013907612003932965,
            "d2": 5.194163931541296e-18,
            "d3": -1.3588342024655871e-25,
            "d4": 4.143855181284559e-33,
            "delmo": 1.0009657580363835,
            "eta": 0.0023409809501769834,
            "argpdot": 0.00003641344957713435,
            "omgcof": -1.1803634887580876e-8,
            "sinmao": -0.9905058646090662,
            "t": 242150.4158654809,
            "t2cof": -4.4504980289943934e-10,
            "t3cof": 5.370225555595367e-18,
            "t4cof": -1.0660118527874156e-25,
            "t5cof": 2.6182148656286264e-33,
            "x1mth2": 0.6387311075578133,
            "x7thm1": 1.5288822470953067,
            "mdot": 0.0657287461047213,
            "nodedot": -0.00005442629356337221,
            "xlcof": 0.0017528135656365892,
            "xmcof": 0.00743474265817095,
            "nodecf": 5.650280617879761e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.4342917701370865,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1257"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45403",
            "epochyr": 22,
            "epochdays": 53.35448153,
            "ndot": 1.2011258949488756e-10,
            "nddot": 0,
            "bstar": 0.00028481,
            "inclo": 0.9259704720115756,
            "nodeo": 4.959440336004486,
            "ecco": 0.0001643,
            "argpo": 1.2814434260945127,
            "mo": 5.003782170980656,
            "no": 0.06572563834540696,
            "a": 1.0857912748054532,
            "alta": 0.08596967031190372,
            "altp": 0.08561287929900274,
            "jdsatepoch": 2459632.85448153,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346258720740483,
            "con41": 0.08381673814633084,
            "cc1": 1.306665797623128e-9,
            "cc4": 7.622910587104306e-8,
            "cc5": 0.00013913315674218835,
            "d2": 1.0075159855121162e-16,
            "d3": 1.1608926071982616e-23,
            "d4": 1.559263321911394e-30,
            "delmo": 1.0020904511461444,
            "eta": 0.0024238205914894157,
            "argpdot": 0.00003641510424352289,
            "omgcof": 1.05784467143013e-7,
            "sinmao": -0.9578445597246963,
            "t": 242797.97254689038,
            "t2cof": 1.959998696434692e-9,
            "t3cof": 1.0416634956456779e-16,
            "t4cof": 9.107217980580823e-24,
            "t5cof": 9.851854928916465e-31,
            "x1mth2": 0.638727753951223,
            "x7thm1": 1.5289057223414386,
            "mdot": 0.06572943921893246,
            "nodedot": -0.00005442788659725652,
            "xlcof": 0.0017528099812875177,
            "xmcof": -0.030545491110619345,
            "nodecf": -2.4884555141790556e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.8842420710538335,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1259"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45404",
            "epochyr": 22,
            "epochdays": 53.82997917,
            "ndot": 1.5817046346198613e-11,
            "nddot": 0,
            "bstar": 0.00005397,
            "inclo": 0.9259600000360637,
            "nodeo": 4.921804056014482,
            "ecco": 0.0001805,
            "argpo": 1.1746798904207674,
            "mo": 5.11056315994692,
            "no": 0.06572498693152132,
            "a": 1.085798434630812,
            "alta": 0.08599442124826284,
            "altp": 0.08560244801336125,
            "jdsatepoch": 2459633.32997917,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346185112091584,
            "con41": 0.08384692072734745,
            "cc1": 2.4751077473464325e-10,
            "cc4": 8.06463247822715e-8,
            "cc5": 0.00013908092668002382,
            "d2": 3.614694980877925e-18,
            "d3": 7.888632625594122e-26,
            "d4": 2.0068693068997836e-33,
            "delmo": 1.0031003184985678,
            "eta": 0.002662567654979362,
            "argpdot": 0.00003641654480142454,
            "omgcof": 2.466124042408299e-8,
            "sinmao": -0.9217704663427028,
            "t": 242113.25594499707,
            "t2cof": 3.7126616210196484e-10,
            "t3cof": 3.7372181480974115e-18,
            "t4cof": 6.188667981244728e-26,
            "t5cof": 1.2680012362294458e-33,
            "x1mth2": 0.6387176930908842,
            "x7thm1": 1.5289761483638107,
            "mdot": 0.06572878908378006,
            "nodedot": -0.00005442739156610385,
            "xlcof": 0.0017527992280428248,
            "xmcof": -0.004794409746825056,
            "nodecf": -4.713629828615772e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.5968764373402777,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1260"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45405",
            "epochyr": 22,
            "epochdays": 53.35080194,
            "ndot": 1.5453436085366463e-11,
            "nddot": 0,
            "bstar": 0.000053122,
            "inclo": 0.9259530187190556,
            "nodeo": 4.959501422528307,
            "ecco": 0.0001415,
            "argpo": 1.3373951912549469,
            "mo": 4.947790263247425,
            "no": 0.06572474371443181,
            "a": 1.085801103497926,
            "alta": 0.08595474435407091,
            "altp": 0.08564746264178114,
            "jdsatepoch": 2459632.85080194,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934613603908958,
            "con41": 0.08386704254944044,
            "cc1": 2.4358267067316036e-10,
            "cc4": 6.994435841974687e-8,
            "cc5": 0.0001390585820032297,
            "d2": 3.50075308162585e-18,
            "d3": 7.518462619988851e-26,
            "d4": 1.8822784999992426e-33,
            "delmo": 1.0014611278392156,
            "eta": 0.0020872052220291884,
            "argpdot": 0.00003641775063821167,
            "omgcof": 1.8557607176519254e-8,
            "sinmao": -0.972420827134369,
            "t": 242803.27115625143,
            "t2cof": 3.653740060097405e-10,
            "t3cof": 3.619418116530388e-18,
            "t4cof": 5.898276893753252e-26,
            "t5cof": 1.1892830514725098e-33,
            "x1mth2": 0.6387109858168531,
            "x7thm1": 1.5290230992820275,
            "mdot": 0.06572854674487914,
            "nodedot": -0.000054427428993889876,
            "xlcof": 0.0017527920590484664,
            "xmcof": -0.007678036912326784,
            "nodecf": -4.638825412577099e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.8610592270601245,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1263"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45406",
            "epochyr": 22,
            "epochdays": 53.35816699,
            "ndot": 1.696847883883376e-11,
            "nddot": 0,
            "bstar": 0.000056528,
            "inclo": 0.9259722173408276,
            "nodeo": 4.958805036156761,
            "ecco": 0.0001486,
            "argpo": 1.2791500634573922,
            "mo": 5.006045863020492,
            "no": 0.06572511521940588,
            "a": 1.0857970391763945,
            "alta": 0.08595838861641591,
            "altp": 0.08563568973637281,
            "jdsatepoch": 2459632.85816699,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346270988748986,
            "con41": 0.08381170773390967,
            "cc1": 2.5925856555298457e-10,
            "cc4": 7.189079983612599e-8,
            "cc5": 0.00013908938134978677,
            "d2": 3.966043157339614e-18,
            "d3": 9.066388312650093e-26,
            "d4": 2.4160086611231655e-33,
            "delmo": 1.0019047022841314,
            "eta": 0.0021920478306595914,
            "argpdot": 0.000036414048298526034,
            "omgcof": 2.3383405761048742e-8,
            "sinmao": -0.9571917769264703,
            "t": 242792.66548454762,
            "t2cof": 3.8888784832947683e-10,
            "t3cof": 4.100473164964797e-18,
            "t4cof": 7.112616948823522e-26,
            "t5cof": 1.5265065457592337e-33,
            "x1mth2": 0.6387294307553635,
            "x7thm1": 1.528893984712456,
            "mdot": 0.06572891579445882,
            "nodedot": -0.0000544267478821882,
            "xlcof": 0.0017528117734661674,
            "xmcof": -0.0074094968439137425,
            "nodecf": -4.937298630123729e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.907461899118445,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1265"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45407",
            "epochyr": 22,
            "epochdays": 53.83640207,
            "ndot": -4.2936311633263284e-11,
            "nddot": 0,
            "bstar": -0.000076297,
            "inclo": 0.9259896706333476,
            "nodeo": 4.921482915432115,
            "ecco": 0.000154,
            "argpo": 1.4020683666875968,
            "mo": 4.883145013082807,
            "no": 0.06572462852108062,
            "a": 1.0858024249632265,
            "alta": 0.08596963853667083,
            "altp": 0.08563521138978225,
            "jdsatepoch": 2459633.33640207,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000934639366726815,
            "con41": 0.08376140388862108,
            "cc1": -3.498236728414748e-10,
            "cc4": 7.33266144021511e-8,
            "cc5": 0.00013904987669167615,
            "d2": 7.22038103552408e-18,
            "d3": -2.227016759104618e-25,
            "d4": 8.007079111390647e-33,
            "delmo": 1.0011584434514789,
            "eta": 0.0022715508123462473,
            "argpdot": 0.00003640961819962472,
            "omgcof": -1.7780185583731863e-8,
            "sinmao": -0.9854565778609686,
            "t": 242104.0069694817,
            "t2cof": -5.247355092622122e-10,
            "t3cof": 7.465134239684679e-18,
            "t4cof": -1.7471086315335624e-25,
            "t5cof": 5.059129875587379e-33,
            "x1mth2": 0.638746198703793,
            "x7thm1": 1.5287766090734491,
            "mdot": 0.06572842675263538,
            "nodedot": -0.000054424535414145995,
            "xlcof": 0.001752829694800112,
            "xmcof": 0.009309614876612705,
            "nodecf": 6.66174332376316e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.6373431979456186,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1275"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45408",
            "epochyr": 22,
            "epochdays": 53.78296896,
            "ndot": 2.5119408852487835e-11,
            "nddot": 0,
            "bstar": 0.000074565,
            "inclo": 0.9259617453653156,
            "nodeo": 5.449158780163072,
            "ecco": 0.0001749,
            "argpo": 1.1365880794959913,
            "mo": 5.14864100823768,
            "no": 0.06572534856823409,
            "a": 1.0857944539455537,
            "alta": 0.08598435939554872,
            "altp": 0.08560454849555876,
            "jdsatepoch": 2459633.28296896,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346197380270909,
            "con41": 0.08384189028450095,
            "cc1": 3.420349736943244e-10,
            "cc4": 7.912988559655887e-8,
            "cc5": 0.00013911013589368572,
            "d2": 6.903135137917391e-18,
            "d3": 2.081971818501176e-25,
            "d4": 7.31965514963968e-33,
            "delmo": 1.003274185489532,
            "eta": 0.0025800918212029256,
            "argpdot": 0.00003641663138131652,
            "omgcof": 3.8349916821680876e-8,
            "sinmao": -0.906341714084391,
            "t": 242180.95064789057,
            "t2cof": 5.130524605414866e-10,
            "t3cof": 7.137110984377545e-18,
            "t4cof": 1.633312622266174e-25,
            "t5cof": 4.6247693009281524e-33,
            "x1mth2": 0.6387193699051663,
            "x7thm1": 1.5289644106638356,
            "mdot": 0.06572915054156203,
            "nodedot": -0.00005442796302940572,
            "xlcof": 0.0017528010202708438,
            "xmcof": -0.007056098559358335,
            "nodecf": -6.513830399339414e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3006938675618116,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1278"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45409",
            "epochyr": 22,
            "epochdays": 53.84471227,
            "ndot": 7.784289667314988e-11,
            "nddot": 0,
            "bstar": 0.00019132,
            "inclo": 0.9259565093775597,
            "nodeo": 4.920784783731317,
            "ecco": 0.0001556,
            "argpo": 1.2470255332451845,
            "mo": 5.038180865208211,
            "no": 0.0657254090506684,
            "a": 1.0857937802503788,
            "alta": 0.08596272976258579,
            "altp": 0.08562483073817173,
            "jdsatepoch": 2459633.34471227,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346160575647522,
            "con41": 0.08385698162825261,
            "cc1": 8.776246607814945e-10,
            "cc4": 7.384397352931582e-8,
            "cc5": 0.00013911384453933694,
            "d2": 4.544924197429082e-17,
            "d3": 3.517200253340217e-24,
            "d4": 3.1728888110021986e-31,
            "delmo": 1.002205611851162,
            "eta": 0.002295401225642657,
            "argpdot": 0.000036417849616240365,
            "omgcof": 8.364637597235272e-8,
            "sinmao": -0.9473975735325665,
            "t": 242092.04028122127,
            "t2cof": 1.3164369911722418e-9,
            "t3cof": 4.6989692064714484e-17,
            "t4cof": 2.7592522379516255e-24,
            "t5cof": 2.0047218161213674e-31,
            "x1mth2": 0.6387143394572491,
            "x7thm1": 1.5289996237992565,
            "mdot": 0.06572921171549086,
            "nodedot": -0.00005442846085233738,
            "xlcof": 0.001752795643562102,
            "xmcof": -0.022875072524664194,
            "nodecf": -1.6713934749800913e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.6897006842638334,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1282"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45410",
            "epochyr": 22,
            "epochdays": 53.77228462,
            "ndot": 2.480427995976664e-10,
            "nddot": 0,
            "bstar": 0.00005392,
            "inclo": 0.9258884415367319,
            "nodeo": 2.970173395775918,
            "ecco": 0.0003831,
            "argpo": 0.15917926376963884,
            "mo": 6.125906706965369,
            "no": 0.06879443245180746,
            "a": 1.0532535440538622,
            "alta": 0.05365704548658923,
            "altp": 0.05285004262113513,
            "jdsatepoch": 2459633.27228462,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009345682092226911,
            "con41": 0.08405317324922501,
            "cc1": 2.6003576234036733e-9,
            "cc4": 0.000002506392523667536,
            "cc5": 0.0013934048018874937,
            "d2": 6.937116177111533e-16,
            "d3": 2.7699656108012503e-22,
            "d4": 1.289769264742125e-28,
            "delmo": 1.029396811697849,
            "eta": 0.009825733222840687,
            "argpdot": 0.000040520538869903647,
            "omgcof": 5.752659933236844e-7,
            "sinmao": -0.1566309798566714,
            "t": 242196.33609719574,
            "t2cof": 3.9005364351055096e-9,
            "t3cof": 7.072353372503405e-16,
            "t4cof": 2.132030738247711e-22,
            "t5cof": 7.972061699333117e-29,
            "x1mth2": 0.6386489422502584,
            "x7thm1": 1.5294574042481917,
            "mdot": 0.06879867276954628,
            "nodedot": -0.00006055084465785879,
            "xlcof": 0.001752725739609739,
            "xmcof": -0.006312648253262589,
            "nodecf": -5.509205518896332e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.233378380276143,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1285"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45411",
            "epochyr": 22,
            "epochdays": 53.32868413,
            "ndot": 6.0601710138692e-13,
            "nddot": 0,
            "bstar": 0.00002026,
            "inclo": 0.9259722173408276,
            "nodeo": 4.961101889452386,
            "ecco": 0.0001537,
            "argpo": 1.3772061514929377,
            "mo": 4.908007228277466,
            "no": 0.06572510330912927,
            "a": 1.0857971703604516,
            "alta": 0.08596405738553603,
            "altp": 0.08563028333536726,
            "jdsatepoch": 2459632.82868413,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346270988748986,
            "con41": 0.08381170773390967,
            "cc1": 9.291943897048649e-11,
            "cc4": 7.328912715474088e-8,
            "cc5": 0.00013908870678105897,
            "d2": 5.094524376051558e-19,
            "d3": 4.1740078900066865e-27,
            "d4": 3.986485391154701e-35,
            "delmo": 1.0013226745505432,
            "eta": 0.002267275853681683,
            "argpdot": 0.00003641403303379006,
            "omgcof": 5.4213770601849455e-9,
            "sinmao": -0.9809276863121343,
            "t": 242835.1208024472,
            "t2cof": 1.3937915845572974e-10,
            "t3cof": 5.267204818823357e-19,
            "t4cof": 3.27452569279121e-27,
            "t5cof": 2.518780940246506e-35,
            "x1mth2": 0.6387294307553635,
            "x7thm1": 1.528893984712456,
            "mdot": 0.06572890388258232,
            "nodedot": -0.00005442672503296277,
            "xlcof": 0.0017528117734661674,
            "xmcof": -0.0024822873143610226,
            "nodecf": -1.7695493473352607e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.721708441033499,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1293"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45412",
            "epochyr": 22,
            "epochdays": 53.36185362,
            "ndot": -4.3996841560690396e-11,
            "nddot": 0,
            "bstar": -0.000078615,
            "inclo": 0.9259373107557878,
            "nodeo": 4.958887066631604,
            "ecco": 0.0001533,
            "argpo": 1.220126518813448,
            "mo": 5.065072898322939,
            "no": 0.06572494243804702,
            "a": 1.0857988920948063,
            "alta": 0.08596534506496445,
            "altp": 0.08563243912464813,
            "jdsatepoch": 2459632.86185362,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346025623169588,
            "con41": 0.08391231694576384,
            "cc1": -3.605222374931541e-10,
            "cc4": 7.320784832562115e-8,
            "cc5": 0.00013907551862773465,
            "d2": 7.66910806135768e-18,
            "d3": -2.4378679359106685e-25,
            "d4": 9.0336399138273e-33,
            "delmo": 1.0023451359181383,
            "eta": 0.0022613245895590915,
            "argpdot": 0.00003642142927500919,
            "omgcof": -3.765616865238927e-8,
            "sinmao": -0.9384490210319091,
            "t": 242787.35673710704,
            "t2cof": -5.407833562397312e-10,
            "t3cof": 7.92906062881182e-18,
            "t4cof": -1.9125189553844832e-25,
            "t5cof": 5.7077310496515716e-33,
            "x1mth2": 0.638695894351412,
            "x7thm1": 1.5291287395401154,
            "mdot": 0.06572874754543197,
            "nodedot": -0.00005442895828266146,
            "xlcof": 0.0017527759283298174,
            "xmcof": 0.00968165006530674,
            "nodecf": 6.866032160748529e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.930689099954563,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1296"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45413",
            "epochyr": 22,
            "epochdays": 53.78943012,
            "ndot": 2.8119193504353085e-11,
            "nddot": 0,
            "bstar": 0.000081159,
            "inclo": 0.9259442920727957,
            "nodeo": 4.92521617470213,
            "ecco": 0.000171,
            "argpo": 1.420741644354684,
            "mo": 4.8645083873300115,
            "no": 0.06572541181934945,
            "a": 1.0857937321979811,
            "alta": 0.08597940292618689,
            "altp": 0.08560806146977518,
            "jdsatepoch": 2459633.28943012,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346074697196505,
            "con41": 0.08389219494114064,
            "cc1": 3.722965299249243e-10,
            "cc4": 7.80825279204979e-8,
            "cc5": 0.00013911505052085468,
            "d2": 8.178754122075778e-18,
            "d3": 2.6849607551675723e-25,
            "d4": 1.0274862960236177e-32,
            "delmo": 1.0011472047279784,
            "eta": 0.0025225820126843694,
            "argpdot": 0.00003642051498782385,
            "omgcof": 1.517151951993327e-8,
            "sinmao": -0.9884521372347428,
            "t": 242171.64657711983,
            "t2cof": 5.584447948873864e-10,
            "t3cof": 8.455963534464058e-18,
            "t4cof": 2.1063582710171023e-25,
            "t5cof": 6.491951892907473e-33,
            "x1mth2": 0.6387026016862865,
            "x7thm1": 1.5290817881959948,
            "mdot": 0.06572921607908686,
            "nodedot": -0.00005442935721620086,
            "xlcof": 0.0017527830976203863,
            "xmcof": -0.008034637939726879,
            "nodecf": -7.090322219325903e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3414016847611023,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1298"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45414",
            "epochyr": 22,
            "epochdays": 53.37661015,
            "ndot": -5.326890321191027e-11,
            "nddot": 0,
            "bstar": -0.000099169,
            "inclo": 0.9259582547068116,
            "nodeo": 4.957534436461309,
            "ecco": 0.0001453,
            "argpo": 1.3353618826763733,
            "mo": 4.9498305531430065,
            "no": 0.06572462084490052,
            "a": 1.0858024643669808,
            "alta": 0.08596023146505338,
            "altp": 0.08564469726890822,
            "jdsatepoch": 2459632.87661015,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346172843883787,
            "con41": 0.083851951175265,
            "cc1": -4.5469056970623235e-10,
            "cc4": 7.097425106470525e-8,
            "cc5": 0.00013904874204478547,
            "d2": 1.219812713728015e-17,
            "d3": -4.890157074057527e-25,
            "d4": 2.2852816265832485e-32,
            "delmo": 1.0015131267522794,
            "eta": 0.002143220647185078,
            "argpdot": 0.000036416451492134625,
            "omgcof": -3.4023037114848716e-8,
            "sinmao": -0.9719429400945774,
            "t": 242766.10733382404,
            "t2cof": -6.820358545593486e-10,
            "t3cof": 1.2611614165639706e-17,
            "t4cof": -3.836359115021251e-25,
            "t5cof": 1.443914445038428e-32,
            "x1mth2": 0.6387160162749117,
            "x7thm1": 1.5289878860756185,
            "mdot": 0.06572842317540653,
            "nodedot": -0.00005442681003936589,
            "xlcof": 0.0017527974358065772,
            "xmcof": 0.013592798229732082,
            "nodecf": 8.659098290646113e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.023660966315603,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1309"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45415",
            "epochyr": 22,
            "epochdays": 53.33606398,
            "ndot": -3.678523805418605e-11,
            "nddot": 0,
            "bstar": -0.000062643,
            "inclo": 0.9259861799748436,
            "nodeo": 4.960573054689031,
            "ecco": 0.0001344,
            "argpo": 1.5089854913355174,
            "mo": 4.7761947271790985,
            "no": 0.06572479271534684,
            "a": 1.0858006114333287,
            "alta": 0.08594654303550553,
            "altp": 0.08565467983115216,
            "jdsatepoch": 2459632.83606398,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346369131792081,
            "con41": 0.08377146461710683,
            "cc1": -2.8724648047133e-10,
            "cc4": 6.796444501891765e-8,
            "cc5": 0.00013906220981962933,
            "d2": 4.8683422787142376e-18,
            "d3": -1.2329912010864306e-25,
            "d4": 3.640207368008425e-33,
            "delmo": 1.0003792732179846,
            "eta": 0.0019824897460127763,
            "argpdot": 0.000036410590123033575,
            "omgcof": -6.1537481944273976e-9,
            "sinmao": -0.9979651038464684,
            "t": 242824.4938185811,
            "t2cof": -4.3086972070699497e-10,
            "t3cof": 5.03336335980057e-18,
            "t4cof": -9.672883479328564e-26,
            "t5cof": 2.299997261853419e-33,
            "x1mth2": 0.638742845127631,
            "x7thm1": 1.528800084106583,
            "mdot": 0.06572859142458815,
            "nodedot": -0.00005442510652078722,
            "xlcof": 0.0017528261105991495,
            "xmcof": 0.010036272314332401,
            "nodecf": 5.4701339496915e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.768204359567264,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1316"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45416",
            "epochyr": 22,
            "epochdays": 53.8336531,
            "ndot": 2.369526866422857e-11,
            "nddot": 0,
            "bstar": 0.000071359,
            "inclo": 0.9259879253040956,
            "nodeo": 4.921957644988657,
            "ecco": 0.0001482,
            "argpo": 1.4718850274258741,
            "mo": 4.813321371027522,
            "no": 0.06572535407810914,
            "a": 1.0857944308803664,
            "alta": 0.08595534561502283,
            "altp": 0.0856335161457098,
            "jdsatepoch": 2459633.3336531,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346381399544351,
            "con41": 0.08376643425032804,
            "cc1": 3.2732566855360097e-10,
            "cc4": 7.177720930083325e-8,
            "cc5": 0.00013910890719446547,
            "d2": 6.322164690053391e-18,
            "d3": 1.8247533054716307e-25,
            "d4": 6.139454940176736e-33,
            "delmo": 1.0006610034629406,
            "eta": 0.0021862201359422223,
            "argpdot": 0.00003641093489708529,
            "omgcof": 1.0167241873873698e-8,
            "sinmao": -0.9949106490434355,
            "t": 242107.96548619866,
            "t2cof": 4.909885028304015e-10,
            "t3cof": 6.536448876641515e-18,
            "t4cof": 1.4315239415529966e-25,
            "t5cof": 3.879084604744685e-33,
            "x1mth2": 0.6387445219165573,
            "x7thm1": 1.5287883465840988,
            "mdot": 0.06572915263537643,
            "nodedot": -0.00005442606456825831,
            "xlcof": 0.001752827902703745,
            "xmcof": -0.009405084063007694,
            "nodecf": -6.23348555773901e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.62002362042508,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1318"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45417",
            "epochyr": 22,
            "epochdays": 53.44018273,
            "ndot": -2.302864985270296e-12,
            "nddot": 0,
            "bstar": 0.000013783,
            "inclo": 0.9259652360238195,
            "nodeo": 5.476368463201664,
            "ecco": 0.0001611,
            "argpo": 1.396771292407794,
            "mo": 4.888457795325878,
            "no": 0.06572506470423083,
            "a": 1.0857975855366295,
            "alta": 0.08597250752765939,
            "altp": 0.08562266354559944,
            "jdsatepoch": 2459632.94018273,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346221916544147,
            "con41": 0.08383182941402079,
            "cc1": 6.321240025582799e-11,
            "cc4": 7.532425019557702e-8,
            "cc5": 0.0001390860010221913,
            "d2": 2.3577226238169557e-19,
            "d3": 1.3141220029343916e-27,
            "d4": 8.538192680000698e-36,
            "delmo": 1.0012492862598028,
            "eta": 0.0023764227275369417,
            "argpdot": 0.000036415504144558,
            "omgcof": 3.1668491663738014e-9,
            "sinmao": -0.9845398871028223,
            "t": 242674.56281863153,
            "t2cof": 9.481860038374198e-11,
            "t3cof": 2.4376387747390157e-19,
            "t4cof": 1.030934155522349e-27,
            "t5cof": 5.394687517078424e-36,
            "x1mth2": 0.6387227235286598,
            "x7thm1": 1.5289409352993815,
            "mdot": 0.06572886618361166,
            "nodedot": -0.00005442715951896164,
            "xlcof": 0.001752804604702198,
            "xmcof": -0.0015371113210853869,
            "nodecf": -1.2038207307316519e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.424192892733501,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1286"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45418",
            "epochyr": 22,
            "epochdays": 53.49330053,
            "ndot": 2.6646571947982873e-10,
            "nddot": 0,
            "bstar": 0.00067138,
            "inclo": 0.9250594101420346,
            "nodeo": 5.8303020368843415,
            "ecco": 0.0001827,
            "argpo": 1.760604373607784,
            "mo": 4.52466136604018,
            "no": 0.06556304074606717,
            "a": 1.0875845529946422,
            "alta": 0.08778325469247439,
            "altp": 0.08738585129680998,
            "jdsatepoch": 2459632.99330053,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009339850934901869,
            "con41": 0.08644330419274548,
            "cc1": 2.7950107886615856e-9,
            "cc4": 7.290392071020387e-8,
            "cc5": 0.00012656252501955158,
            "d2": 4.507602495210986e-16,
            "d3": 1.086233414720327e-22,
            "d4": 3.051263097066214e-29,
            "delmo": 0.9985251797190261,
            "eta": 0.0026354646145320885,
            "argpdot": 0.0000364028984560328,
            "omgcof": -1.3104081038506498e-7,
            "sinmao": -0.9824308595872837,
            "t": 242598.07318657637,
            "t2cof": 4.192516182992379e-9,
            "t3cof": 4.663844201385679e-16,
            "t4cof": 8.530173254235795e-23,
            "t5cof": 1.9301359883779684e-29,
            "x1mth2": 0.6378522319357515,
            "x7thm1": 1.5350343764497398,
            "mdot": 0.0655669379431783,
            "nodedot": -0.00005418017372388349,
            "xlcof": 0.0017518733411554964,
            "xmcof": -0.05408251931155134,
            "nodecf": -5.298640204572555e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.758855647949915,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1299"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "45419",
            "epochyr": 22,
            "epochdays": 53.43650691,
            "ndot": -2.136210282388893e-11,
            "nddot": 0,
            "bstar": -0.00002843,
            "inclo": 0.9260141052428754,
            "nodeo": 5.476453984335011,
            "ecco": 0.0001628,
            "argpo": 1.1739992120124896,
            "mo": 5.111212422428663,
            "no": 0.06572474758320833,
            "a": 1.0858011486679464,
            "alta": 0.08597791709494951,
            "altp": 0.08562438024094332,
            "jdsatepoch": 2459632.93650691,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009346565412411883,
            "con41": 0.08369097935728309,
            "cc1": -1.3036168990254058e-10,
            "cc4": 7.572006031246308e-8,
            "cc5": 0.00013906015986827358,
            "d2": 1.0026951212261003e-18,
            "d3": -1.1524983066764492e-26,
            "d4": 1.5441836934395795e-34,
            "delmo": 1.0028002408833396,
            "eta": 0.0024013935936524596,
            "argpdot": 0.000036404449527864306,
            "omgcof": -1.442469538071193e-8,
            "sinmao": -0.9215185296389894,
            "t": 242679.8559998721,
            "t2cof": -1.9554253485381087e-10,
            "t3cof": 1.0366834616145927e-18,
            "t4cof": -9.041414863316103e-27,
            "t5cof": 9.756640389328744e-35,
            "x1mth2": 0.6387696735475723,
            "x7thm1": 1.5286122851669939,
            "mdot": 0.06572854264199757,
            "nodedot": -0.0000544229848476406,
            "xlcof": 0.0017528547832852642,
            "xmcof": 0.0031042557031482963,
            "nodecf": 2.482426551626098e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.401033798214868,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "STARLINK-1308"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "   11",
            "epochyr": 22,
            "epochdays": 53.8319756,
            "ndot": 2.5664824243736065e-11,
            "nddot": 0,
            "bstar": 0.00045179,
            "inclo": 0.5735972226801804,
            "nodeo": 4.6190295733662605,
            "ecco": 0.1466352,
            "argpo": 2.1997396853850693,
            "mo": 4.337448623825008,
            "no": 0.05171617928917521,
            "a": 1.273507233648044,
            "alta": 0.4602482215554715,
            "altp": 0.08676624574061642,
            "jdsatepoch": 2459633.3319756,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0006346077325340402,
            "con41": 1.1165699585045323,
            "cc1": 3.3040462110019744e-10,
            "cc4": 0.0000011641498500593253,
            "cc5": 0.00003307428379764334,
            "d2": 2.1252184947142127e-18,
            "d3": 2.027058739662971e-26,
            "d4": 2.249725155845533e-34,
            "delmo": 0.40300471093268125,
            "eta": 0.7136571242702118,
            "argpdot": 0.00006847729303527957,
            "omgcof": -3.6401350025452347e-13,
            "sinmao": -0.930529466010964,
            "t": 242110.38108564913,
            "t2cof": 4.956069316502961e-10,
            "t3cof": 2.343552922002943e-18,
            "t4cof": 1.7399659961627652e-26,
            "t5cof": 1.5790514105721607e-34,
            "x1mth2": 0.2944766804984892,
            "x7thm1": 3.9386632365105756,
            "mdot": 0.05174605506935999,
            "nodedot": -0.00004552078093632457,
            "xlcof": 0.0012416152685791393,
            "xmcof": -1.152577632425172e-9,
            "nodecf": -5.1365355341484895e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.6094547218027841,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "VANGUARD 2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00020",
            "epochyr": 22,
            "epochdays": 53.60170665,
            "ndot": 2.5210311417695873e-11,
            "nddot": 0,
            "bstar": 0.00032375,
            "inclo": 0.5821371187101887,
            "nodeo": 2.621472319190719,
            "ecco": 0.1666456,
            "argpo": 5.069970292204037,
            "mo": 0.916262950711983,
            "no": 0.050415243585708265,
            "a": 1.2953443753911267,
            "alta": 0.5112078160348064,
            "altp": 0.079480934747447,
            "jdsatepoch": 2459633.10170665,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000642973064471945,
            "con41": 1.0931258891012603,
            "cc1": 3.2178762488260146e-10,
            "cc4": 0.0000015801484783827856,
            "cc5": 0.000045955107942538584,
            "d2": 1.8925619127295163e-18,
            "d3": 1.64933709997842e-26,
            "d4": 1.6722011044012865e-34,
            "delmo": 3.134999630281082,
            "eta": 0.7614568173740511,
            "argpdot": 0.00006434103299066891,
            "omgcof": 9.037832490665604e-14,
            "sinmao": 0.7933320900253102,
            "t": 242441.96837380528,
            "t2cof": 4.826814373239022e-10,
            "t3cof": 2.099656463784688e-18,
            "t4cof": 1.4280337837997378e-26,
            "t5cof": 1.1857586930287207e-34,
            "x1mth2": 0.30229137029957986,
            "x7thm1": 3.883960407902941,
            "mdot": 0.05044307005442258,
            "nodedot": -0.00004320223459871227,
            "xlcof": 0.0012570939012684758,
            "xmcof": -4.944550240087636e-10,
            "nodecf": -4.717901669710316e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.1586709689519452,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "VANGUARD 3"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00022",
            "epochyr": 22,
            "epochdays": 53.4975063,
            "ndot": 2.939182941726562e-11,
            "nddot": 0,
            "bstar": 0.000093426,
            "inclo": 0.8776056531095606,
            "nodeo": 1.6492593486475535,
            "ecco": 0.0136813,
            "argpo": 1.5717230966277056,
            "mo": 4.740478309366287,
            "no": 0.0652731848796538,
            "a": 1.0907333793949485,
            "alta": 0.10565602997846457,
            "altp": 0.07581072881143247,
            "jdsatepoch": 2459632.9975063,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0008995503016789087,
            "con41": 0.22494280377232473,
            "cc1": 4.0001795993861574e-10,
            "cc4": 0.0000031924490162531088,
            "cc5": 0.00013507467204380204,
            "d2": 8.881213673481977e-18,
            "d3": 2.945873410883683e-25,
            "d4": 1.138989802517094e-32,
            "delmo": 1.0160805050969468,
            "eta": 0.18983693455478298,
            "argpdot": 0.00004635263718274359,
            "omgcof": -9.30691283903159e-13,
            "sinmao": -0.9996055207370586,
            "t": 242592.01687797904,
            "t2cof": 6.000269399079236e-10,
            "t3cof": 9.201242410028881e-18,
            "t4cof": 2.3175846229550588e-25,
            "t5cof": 7.220010052540544e-33,
            "x1mth2": 0.5916857320758917,
            "x7thm1": 1.8581998754687579,
            "mdot": 0.06528321675821998,
            "nodedot": -0.0000569853139032608,
            "xlcof": 0.001700033049615002,
            "xmcof": -0.0000011804601238562377,
            "nodecf": -7.970876718063353e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.785353630319534,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "EXPLORER 7"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "   29",
            "epochyr": 22,
            "epochdays": 53.73599453,
            "ndot": 2.27256413020095e-12,
            "nddot": 0,
            "bstar": 0.000041992,
            "inclo": 0.8443745841515887,
            "nodeo": 4.96732747889425,
            "ecco": 0.002416,
            "argpo": 6.005857725025443,
            "mo": 0.27759112687119414,
            "no": 0.06432472743340352,
            "a": 1.1013827564417233,
            "alta": 0.10404369718128659,
            "altp": 0.0987218157021601,
            "jdsatepoch": 2459633.23599453,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000874225669036233,
            "con41": 0.3234807181540234,
            "cc1": 8.928817519272384e-11,
            "cc4": 3.0042274003044747e-7,
            "cc5": 0.00006547819814049437,
            "d2": 3.9331153041707296e-19,
            "d3": 2.587080876190699e-27,
            "d4": 1.9833438718248763e-35,
            "delmo": 1.0884588129991966,
            "eta": 0.02979790440704712,
            "argpdot": 0.000051873920918202,
            "omgcof": 1.2441494436099947e-9,
            "sinmao": 0.2740397883825021,
            "t": 242248.59382689,
            "t2cof": 1.3393226278908576e-10,
            "t3cof": 4.0925628687556604e-19,
            "t4cof": 2.047444461402707e-27,
            "t5cof": 1.2659090182264973e-35,
            "x1mth2": 0.5588397606153255,
            "x7thm1": 2.0881216756927214,
            "mdot": 0.06433866421926814,
            "nodedot": -0.000057240601387412065,
            "xlcof": 0.0016602509753142456,
            "xmcof": -0.000011491209419267735,
            "nodecf": -1.7869402929344838e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.0047367287053461,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TIROS 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "   45",
            "epochyr": 22,
            "epochdays": 53.78590077,
            "ndot": 6.090471868938545e-12,
            "nddot": 0,
            "bstar": 0.000076203,
            "inclo": 1.1640264006665941,
            "nodeo": 3.4770466811523555,
            "ecco": 0.0260624,
            "argpo": 3.993180683539874,
            "mo": 2.2522566425775787,
            "no": 0.06258203418798598,
            "a": 1.1221535033665186,
            "alta": 0.1513995168326583,
            "altp": 0.092907489900379,
            "jdsatepoch": 2459633.28590077,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010740227239653016,
            "con41": -0.5303953732351127,
            "cc1": 1.0052059995888348e-10,
            "cc4": 0.0000012822970777195927,
            "cc5": 0.000045843455140675414,
            "d2": 4.134688154677806e-19,
            "d3": 2.5372120270803518e-27,
            "d4": 1.814234229716114e-35,
            "delmo": 0.5760359465767625,
            "eta": 0.26661650462368053,
            "argpdot": -0.000008831341259608881,
            "omgcof": -6.138276617585934e-11,
            "sinmao": 0.7766536536048839,
            "t": 242176.72884084284,
            "t2cof": 1.507808999383252e-10,
            "t3cof": 4.3367759749996833e-19,
            "t4cof": 2.0301346691134867e-27,
            "t5cof": 1.1728027512038013e-35,
            "x1mth2": 0.8434651244117042,
            "x7thm1": 0.09574412911807051,
            "mdot": 0.06256060803446799,
            "nodedot": -0.00003193758026525109,
            "xlcof": 0.0019155037989988068,
            "xmcof": -9.503400852548445e-8,
            "nodecf": -1.1247045411152139e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3191654112389628,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TRANSIT 2A"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00046",
            "epochyr": 22,
            "epochdays": 53.5685936,
            "ndot": 4.5451282604019e-12,
            "nddot": 0,
            "bstar": 0.000052806,
            "inclo": 1.1639653141427742,
            "nodeo": 3.2153502677790735,
            "ecco": 0.0206083,
            "argpo": 0.5366573290617205,
            "mo": 5.769203295759776,
            "no": 0.06326972140075363,
            "a": 1.1140110424627407,
            "alta": 0.13696891622912544,
            "altp": 0.09105316869635582,
            "jdsatepoch": 2459633.0685936,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001073994458140472,
            "con41": -0.5302621865350483,
            "cc1": 8.522851341796265e-11,
            "cc4": 0.0000013569028514279528,
            "cc5": 0.00005462463368229324,
            "d2": 3.187499712794189e-19,
            "d3": 1.7791056179763683e-27,
            "d4": 1.157210795209272e-35,
            "delmo": 1.7145101787241037,
            "eta": 0.22608018715112418,
            "argpdot": -0.000009046310647364138,
            "omgcof": 1.0434803856376814e-10,
            "sinmao": -0.49164864592931085,
            "t": 242489.65116620064,
            "t2cof": 1.2784277012694397e-10,
            "t3cof": 3.3327777027829056e-19,
            "t4cof": 1.4173767004846518e-27,
            "t5cof": 7.443150388413945e-36,
            "x1mth2": 0.8434207288450161,
            "x7thm1": 0.09605489808488743,
            "mdot": 0.06324775589342577,
            "nodedot": -0.000032749681767514555,
            "xlcof": 0.0019154843193132578,
            "xmcof": -1.3373174732904324e-7,
            "nodecf": -9.781238161511492e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.233231208269373,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SOLRAD 1 (GREB)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00058",
            "epochyr": 22,
            "epochdays": 53.5700759,
            "ndot": 3.1209880721426384e-12,
            "nddot": 0,
            "bstar": 0.000027843,
            "inclo": 0.4943714919444018,
            "nodeo": 3.7344548205534873,
            "ecco": 0.0164896,
            "argpo": 2.127247434903485,
            "mo": 4.185090106772163,
            "no": 0.058698628658574614,
            "a": 1.17023599207209,
            "alta": 0.18953271548696193,
            "altp": 0.15093926865721796,
            "jdsatepoch": 2459633.0700759,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0005548766303643248,
            "con41": 1.3246104874097409,
            "cc1": 6.316997827026484e-12,
            "cc4": 1.1913410362373868e-7,
            "cc5": 0.000007665563125496143,
            "d2": 1.1782152929722973e-21,
            "d3": 3.2715143425118438e-31,
            "d4": 1.0579937509806852e-40,
            "delmo": 0.8272791219081811,
            "eta": 0.12171758584112162,
            "argpdot": 0.00010036150759322508,
            "omgcof": -2.1757149052785745e-12,
            "sinmao": -0.8641694307475448,
            "t": 242487.5166542083,
            "t2cof": 9.475496740539725e-12,
            "t3cof": 1.2580242160656119e-21,
            "t4cof": 2.6832211701701164e-31,
            "t5cof": 7.039220372827622e-41,
            "x1mth2": 0.22512983753008642,
            "x7thm1": 4.424091137289395,
            "mdot": 0.05874475999975308,
            "nodedot": -0.0000614722950709795,
            "xlcof": 0.0010920863585823458,
            "xmcof": -2.7469583618598915e-8,
            "nodecf": -1.3536571424882362e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.242570273509429,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COURIER 1B"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00107",
            "epochyr": 22,
            "epochdays": 53.36462913,
            "ndot": 3.339154228641929e-11,
            "nddot": 0,
            "bstar": 0.00012806,
            "inclo": 0.5024907636246795,
            "nodeo": 5.363955296739213,
            "ecco": 0.0544222,
            "argpo": 5.685916183854607,
            "mo": 0.5389925796008889,
            "no": 0.0614535440285911,
            "a": 1.134965187761842,
            "alta": 0.19673249020325478,
            "altp": 0.07319788532042959,
            "jdsatepoch": 2459632.86462913,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0005632164239513346,
            "con41": 1.3041557129180208,
            "cc1": 3.1205292960743047e-10,
            "cc4": 0.0000036418704480678018,
            "cc5": 0.00008958107411268815,
            "d2": 3.585588530259039e-18,
            "d3": 6.142638375994303e-26,
            "d4": 1.2260589380291522e-33,
            "delmo": 2.92392358452889,
            "eta": 0.5009795799760703,
            "argpdot": 0.00011098863870087341,
            "omgcof": 1.7729334868646592e-11,
            "sinmao": 0.5132716576799471,
            "t": 242783.36000293493,
            "t2cof": 4.680793944111457e-10,
            "t3cof": 3.780342592012198e-18,
            "t4cof": 4.950243500506344e-26,
            "t5cof": 7.991903468139924e-34,
            "x1mth2": 0.2319480956939931,
            "x7thm1": 4.376363330142048,
            "mdot": 0.06150430177142674,
            "nodedot": -0.00006849569123720178,
            "xlcof": 0.0011078807983788703,
            "xmcof": -2.542359956713918e-8,
            "nodecf": -7.429417018029904e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.948175889131036,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "EXPLORER 11"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00116",
            "epochyr": 22,
            "epochdays": 53.59491362,
            "ndot": -1.5150427534673e-13,
            "nddot": 0,
            "bstar": 0.000054851,
            "inclo": 1.1660562185866636,
            "nodeo": 2.520128030844416,
            "ecco": 0.0081903,
            "argpo": 5.162067826173273,
            "mo": 1.1082770936993913,
            "no": 0.060749436707470475,
            "a": 1.1446008713914193,
            "alta": 0.15397549590837656,
            "altp": 0.13522624687446227,
            "jdsatepoch": 2459633.09491362,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010749596771414429,
            "con41": -0.5348122185627823,
            "cc1": 2.3906520442766006e-11,
            "cc4": 1.175760355557493e-7,
            "cc5": 0.000014596445061706782,
            "d2": 1.9800975844719725e-20,
            "d3": 2.444294387166688e-29,
            "d4": 3.5151513307038297e-38,
            "delmo": 1.0979993162896067,
            "eta": 0.07094040649570646,
            "argpdot": -0.000008504412846922281,
            "omgcof": 3.551777535414043e-11,
            "sinmao": 0.8949312465318345,
            "t": 242451.75033710897,
            "t2cof": 3.585978066414901e-11,
            "t3cof": 2.0944019284080503e-20,
            "t4cof": 1.9786482944393243e-29,
            "t5cof": 2.303271216497026e-38,
            "x1mth2": 0.844937406187594,
            "x7thm1": 0.08543815668684118,
            "mdot": 0.06072929778918462,
            "nodedot": -0.00002962261680583257,
            "xlcof": 0.001916144210165676,
            "xmcof": -3.883869684150149e-7,
            "nodecf": -2.482358136004453e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.11587224312929578,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TRANSIT 4A"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "  117",
            "epochyr": 22,
            "epochdays": 53.79061784,
            "ndot": -1.484741898397954e-12,
            "nddot": 0,
            "bstar": 0.000022091,
            "inclo": 1.1660562185866636,
            "nodeo": 4.27154324594045,
            "ecco": 0.0082529,
            "argpo": 5.517652481328337,
            "mo": 0.7560085641231158,
            "no": 0.06066509051991287,
            "a": 1.1456610943139842,
            "alta": 0.1551161207592482,
            "altp": 0.13620606786872025,
            "jdsatepoch": 2459633.29061784,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010749596771414429,
            "con41": -0.5348122185627823,
            "cc1": 9.322312326547197e-12,
            "cc4": 1.1398086079204201e-7,
            "cc5": 0.000014150817186978727,
            "d2": 2.989726452853653e-21,
            "d3": 1.4289468138249316e-30,
            "d4": 7.95645596724235e-40,
            "delmo": 1.1630677483871537,
            "eta": 0.07097914235307423,
            "argpdot": -0.000008476830889928324,
            "omgcof": 2.259351579986775e-11,
            "sinmao": 0.686022828544939,
            "t": 242169.9362605065,
            "t2cof": 1.3983468489820795e-11,
            "t3cof": 3.1635374670810407e-21,
            "t4cof": 1.1573490023625514e-30,
            "t5cof": 5.216657274042126e-40,
            "x1mth2": 0.844937406187594,
            "x7thm1": 0.08543815668684118,
            "mdot": 0.06064501673851639,
            "nodedot": -0.000029526885343164888,
            "xlcof": 0.001916144210165676,
            "xmcof": -1.502670474133148e-7,
            "nodecf": -9.648598145410499e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3488847808922841,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SOLRAD 3/INJUN 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00162",
            "epochyr": 22,
            "epochdays": 53.46597274,
            "ndot": -2.12105985485422e-12,
            "nddot": 0,
            "bstar": 0.000026849,
            "inclo": 0.8360284196685518,
            "nodeo": 5.73051632756007,
            "ecco": 0.0044533,
            "argpo": 2.8438045766145206,
            "mo": 3.443571266099104,
            "no": 0.06299738457863593,
            "a": 1.1167918984537664,
            "alta": 0.1217653078151506,
            "altp": 0.11181848909238212,
            "jdsatepoch": 2459632.96597274,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0008677124600003748,
            "con41": 0.3483686716515017,
            "cc1": 3.017638545588338e-11,
            "cc4": 2.3719397932105683e-7,
            "cc5": 0.00003542756319832475,
            "d2": 3.8846779279781006e-20,
            "d3": 7.462182364829346e-29,
            "d4": 1.6704036094923123e-37,
            "delmo": 0.8700394829237121,
            "eta": 0.04749441495721641,
            "argpdot": 0.000051119798685865555,
            "omgcof": -1.8805807407810336e-10,
            "sinmao": -0.2974098676890295,
            "t": 242637.42520406842,
            "t2cof": 4.526457818382507e-11,
            "t3cof": 4.066800775814511e-20,
            "t4cof": 5.955183150772692e-29,
            "t5cof": 1.076541981122586e-37,
            "x1mth2": 0.5505437761161662,
            "x7thm1": 2.146193567186837,
            "mdot": 0.06301168074827362,
            "nodedot": -0.00005503686800364963,
            "xlcof": 0.0016498219265573468,
            "xmcof": -0.000001322588716028996,
            "nodecf": -5.806381401651527e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.586679965538153,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TIROS 3"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00202",
            "epochyr": 22,
            "epochdays": 53.4444053,
            "ndot": 2.27256413020095e-12,
            "nddot": 0,
            "bstar": 0.000064572,
            "inclo": 0.5661673560544406,
            "nodeo": 5.818596113591215,
            "ecco": 0.0101119,
            "argpo": 2.2272652730182716,
            "mo": 4.073109781964207,
            "no": 0.059455807809751744,
            "a": 1.1603567553250265,
            "alta": 0.17209016679919764,
            "altp": 0.1486233438508553,
            "jdsatepoch": 2459632.9444053,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000627292069398719,
            "con41": 1.1368206573847623,
            "cc1": 1.814379391815135e-11,
            "cc4": 1.0052045650186743e-7,
            "cc5": 0.000009312660855736096,
            "d2": 1.0282951020754842e-20,
            "d3": 8.679565594756973e-30,
            "d4": 8.533566147592351e-39,
            "delmo": 0.8652184938580973,
            "eta": 0.07896494425503518,
            "argpdot": 0.00009205518165941817,
            "omgcof": -1.505826304787181e-11,
            "sinmao": -0.8025260088980439,
            "t": 242668.48231785,
            "t2cof": 2.721569087722702e-11,
            "t3cof": 1.0941345536243534e-20,
            "t4cof": 7.084321646648124e-30,
            "t5cof": 5.6456150134393676e-39,
            "x1mth2": 0.2877264475384125,
            "x7thm1": 3.985914867231113,
            "mdot": 0.05949658625719951,
            "nodedot": -0.00006067674965910104,
            "xlcof": 0.0012280432673770602,
            "xmcof": -2.0756475638803824e-7,
            "nodecf": -3.840160734150816e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.450796722431207,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TRANSIT 4B"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "  205",
            "epochyr": 22,
            "epochdays": 53.8187102,
            "ndot": 1.4544410433286078e-12,
            "nddot": 0,
            "bstar": 0.000029606,
            "inclo": 0.5662057532979845,
            "nodeo": 1.9437976225556126,
            "ecco": 0.0102305,
            "argpo": 4.769730027629711,
            "mo": 1.4941187767670299,
            "no": 0.05940636257039955,
            "a": 1.1610011624014318,
            "alta": 0.1728787847933797,
            "altp": 0.1491235400094839,
            "jdsatepoch": 2459633.3187102,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0006273299658081179,
            "con41": 1.1367163602401296,
            "cc1": 8.177710895799843e-12,
            "cc4": 9.946020656053367e-8,
            "cc5": 0.000009164103819571007,
            "d2": 2.0810782795185397e-21,
            "d3": 7.887218829289815e-31,
            "d4": 3.4818412415521516e-40,
            "delmo": 1.0184022421139227,
            "eta": 0.07959060002707585,
            "argpdot": 0.00009187050997736249,
            "omgcof": 6.266009294317848e-13,
            "sinmao": 0.9970617167074989,
            "t": 242129.48326192796,
            "t2cof": 1.2266566343699765e-11,
            "t3cof": 2.2148281905091065e-21,
            "t4cof": 6.439639918915543e-31,
            "t5cof": 2.3043584242855907e-40,
            "x1mth2": 0.28776121325329007,
            "x7thm1": 3.9856715072269697,
            "mdot": 0.059447058289410076,
            "nodedot": -0.000060557650738205606,
            "xlcof": 0.001228113656650612,
            "xmcof": -9.172494346208649e-8,
            "nodecf": -1.7274298258514716e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.525877552297196,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TRAAC"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00226",
            "epochyr": 22,
            "epochdays": 53.55470977,
            "ndot": -2.211962420062258e-12,
            "nddot": 0,
            "bstar": 0.000026949,
            "inclo": 0.8429346875186934,
            "nodeo": 5.142099514201206,
            "ecco": 0.0078438,
            "argpo": 4.296833066801848,
            "mo": 1.9735415236681,
            "no": 0.06306915470199564,
            "a": 1.1159542241458522,
            "alta": 0.12470754588920752,
            "altp": 0.10720090240249713,
            "jdsatepoch": 2459633.05470977,
            "isimp": 0,
            "method": "n",
            "aycof": 0.00087310633162261,
            "con41": 0.32777111925418184,
            "cc1": 3.2114183520973036e-11,
            "cc4": 4.246686592297559e-7,
            "cc5": 0.00003773535422696286,
            "d2": 4.432140111469214e-20,
            "d3": 9.127877611677217e-29,
            "d4": 2.1906584379804487e-37,
            "delmo": 0.9041462267222222,
            "eta": 0.08427256866152198,
            "argpdot": 0.00004984332079807763,
            "omgcof": -4.747845648465832e-11,
            "sinmao": 0.919988494725528,
            "t": 242509.64388146996,
            "t2cof": 4.817127528145956e-11,
            "t3cof": 4.6384042681129614e-20,
            "t4cof": 7.281191897774398e-29,
            "t5cof": 1.4110944263797089e-37,
            "x1mth2": 0.5574096269152728,
            "x7thm1": 2.0981326115930905,
            "mdot": 0.06308264230967114,
            "nodedot": -0.000054761320967718244,
            "xlcof": 0.001658464131171413,
            "xmcof": -4.3879964563068974e-7,
            "nodecf": -6.148432763624869e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.145757690658158,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TIROS 4"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00309",
            "epochyr": 22,
            "epochdays": 53.49776455,
            "ndot": 1.575644463605992e-12,
            "nddot": 0,
            "bstar": 0.000045126,
            "inclo": 1.0138739797882699,
            "nodeo": 4.087615213377532,
            "ecco": 0.0187097,
            "argpo": 4.525862152565551,
            "mo": 1.7222629805999725,
            "no": 0.0635804789011153,
            "a": 1.110200164823738,
            "alta": 0.13097167684754085,
            "altp": 0.08942865279993528,
            "jdsatepoch": 2459632.99776455,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009927256115782805,
            "con41": -0.16182182715218085,
            "cc1": 8.258889723855179e-11,
            "cc4": 0.0000014776010843780587,
            "cc5": 0.000060597282105592734,
            "d2": 3.094045916602734e-19,
            "d3": 1.7301759863534738e-27,
            "d4": 1.1275333627743349e-35,
            "delmo": 0.906998745511026,
            "eta": 0.21217306614596587,
            "argpdot": 0.000016552412749778908,
            "omgcof": -2.3620003363079973e-11,
            "sinmao": 0.9885508405496194,
            "t": 242591.64499774575,
            "t2cof": 1.2388334585782768e-10,
            "t3cof": 3.2304644355443353e-19,
            "t4cof": 1.3757004737226924e-27,
            "t5cof": 7.235823732371033e-36,
            "x1mth2": 0.7206072757173936,
            "x7thm1": 0.9557490699782445,
            "mdot": 0.06357370078545677,
            "nodedot": -0.000044294345960021054,
            "xlcof": 0.001832369364292057,
            "xmcof": -1.5517165037232337e-7,
            "nodecf": -1.2805708275445572e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.786980706562119,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TIROS 5"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "  369",
            "epochyr": 22,
            "epochdays": 53.83720329,
            "ndot": 1.5241330099881037e-11,
            "nddot": 0,
            "bstar": 0.000063534,
            "inclo": 1.718700763596652,
            "nodeo": 0.04293509959906051,
            "ecco": 0.0091774,
            "argpo": 3.1078990723800426,
            "mo": 3.178052581663955,
            "no": 0.06479620696504516,
            "a": 1.0966531563282285,
            "alta": 0.10671758100511508,
            "altp": 0.08658873165134184,
            "jdsatepoch": 2459633.33720329,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001156677350329244,
            "con41": -0.9348499863247604,
            "cc1": 1.7798825673086303e-10,
            "cc4": 0.0000011927551908999337,
            "cc5": 0.00009095450250651335,
            "d2": 1.6544124049727864e-18,
            "d3": 2.2968650787442897e-26,
            "d4": 3.71677660879211e-34,
            "delmo": 0.6820808434785735,
            "eta": 0.11981763650088148,
            "argpdot": -0.00003894897945677476,
            "omgcof": -9.346656218681692e-10,
            "sinmao": -0.036451850753833955,
            "t": 242102.85321258008,
            "t2cof": 2.6698238509629454e-10,
            "t3cof": 1.7177720440409696e-18,
            "t4cof": 1.8123982619838287e-26,
            "t5cof": 2.3642013303732474e-34,
            "x1mth2": 0.9782833287749202,
            "x7thm1": -0.8479833014244411,
            "mdot": 0.06475529814081152,
            "nodedot": 0.000012867885544316687,
            "xlcof": 0.0015351006957518526,
            "xmcof": -0.000001457318503462777,
            "nodecf": 8.039710367266644e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.6423911953399042,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "FTV 3502"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "  397",
            "epochyr": 22,
            "epochdays": 53.72178655,
            "ndot": 1.2241545448015786e-11,
            "nddot": 0,
            "bstar": 0.000065962,
            "inclo": 1.0176142203752938,
            "nodeo": 3.31428251109912,
            "ecco": 0.0013697,
            "argpo": 2.1258127742583453,
            "mo": 4.1615281618702396,
            "no": 0.06496594458015624,
            "a": 1.0943666138275008,
            "alta": 0.09586556777846011,
            "altp": 0.09286765987654122,
            "jdsatepoch": 2459633.22178655,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009950306579074592,
            "con41": -0.171872710559127,
            "cc1": 1.9365308018151795e-10,
            "cc4": 1.8306477651901633e-7,
            "cc5": 0.00009098125485294796,
            "d2": 2.0005389125313502e-18,
            "d3": 3.087080338839177e-26,
            "d4": 5.552607087835836e-34,
            "delmo": 0.9715896259267041,
            "eta": 0.018266849449990914,
            "argpdot": 0.000016653694270323497,
            "omgcof": -3.3173648802173082e-9,
            "sinmao": -0.8520742674071982,
            "t": 242269.053318277,
            "t2cof": 2.904796202722769e-10,
            "t3cof": 2.075541943458929e-18,
            "t4cof": 2.4333489818550464e-26,
            "t5cof": 3.5276111372880047e-34,
            "x1mth2": 0.7239575701863756,
            "x7thm1": 0.9322970086953701,
            "mdot": 0.06495837791517733,
            "nodedot": -0.000046264770548417495,
            "xlcof": 0.0018352675109415302,
            "xmcof": -0.00007290740158003749,
            "nodecf": -3.137473467235897e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.9152209397881492,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TIROS 6"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00424",
            "epochyr": 22,
            "epochdays": 53.41475221,
            "ndot": 1.424140188259262e-12,
            "nddot": 0,
            "bstar": 0.000044206,
            "inclo": 1.4043599839954652,
            "nodeo": 0.2639513787668584,
            "ecco": 0.0022989,
            "argpo": 6.023721169919606,
            "mo": 0.2602792060206624,
            "no": 0.059775558588946044,
            "a": 1.1571729417553578,
            "alta": 0.1598331666311592,
            "altp": 0.15451271687955637,
            "jdsatepoch": 2459632.91475221,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001153285200661012,
            "con41": -0.9176613513205277,
            "cc1": 1.2966071264011441e-11,
            "cc4": 1.2003619180824043e-8,
            "cc5": 0.00000999563379901091,
            "d2": 5.382729145176909e-21,
            "d3": 3.3286114461691775e-30,
            "d4": 2.3976939318586683e-39,
            "delmo": 1.054298356391859,
            "eta": 0.0184011856716138,
            "argpdot": -0.00003123675828177289,
            "omgcof": 1.5288339008187066e-10,
            "sinmao": 0.2573503637683664,
            "t": 242711.18276752532,
            "t2cof": 1.9449106896017164e-11,
            "t3cof": 5.718967153223755e-21,
            "t4cof": 2.7112867411680946e-30,
            "t5cof": 1.5824809448819978e-39,
            "x1mth2": 0.9725537837735092,
            "x7thm1": -0.8078764864145646,
            "mdot": 0.05974229155698146,
            "nodedot": -0.000011987033871999444,
            "xlcof": 0.0018938367682227483,
            "xmcof": -0.0000030033093734091865,
            "nodecf": -5.454319705319136e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.2639707467573515,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ALOUETTE 1 (S-27)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "  446",
            "epochyr": 22,
            "epochdays": 53.81766611,
            "ndot": -3.605801753252174e-12,
            "nddot": 0,
            "bstar": 0.000014384,
            "inclo": 0.8751290309009807,
            "nodeo": 5.045062698448825,
            "ecco": 0.0070306,
            "argpo": 0.344725216549156,
            "mo": 1.7943031908052904,
            "no": 0.05825479610830529,
            "a": 1.1766818126201843,
            "alta": 0.18495459177199192,
            "altp": 0.16840903346837677,
            "jdsatepoch": 2459633.31766611,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0008976968408799184,
            "con41": 0.2322500316529985,
            "cc1": 2.5741863300520773e-12,
            "cc4": 3.833075545165714e-8,
            "cc5": 0.000006136392479888506,
            "d2": 1.8954649078395883e-22,
            "d3": 2.0772830277179726e-32,
            "d4": 2.6513114377939727e-42,
            "delmo": 0.9669394816567468,
            "eta": 0.0502768647640225,
            "argpdot": 0.00003596020017583131,
            "omgcof": 6.276020517063507e-12,
            "sinmao": 0.9751261484543332,
            "t": 242130.98675139248,
            "t2cof": 3.861279495078116e-12,
            "t3cof": 2.027993613076128e-22,
            "t4cof": 1.7086050862010947e-32,
            "t5cof": 1.769903669279575e-42,
            "x1mth2": 0.5892499894490004,
            "x7thm1": 1.8752500738569973,
            "mdot": 0.05826273639670456,
            "nodedot": -0.000043815141930580386,
            "xlcof": 0.0016971654761431402,
            "xmcof": -6.955989236257863e-8,
            "nodecf": -3.9447939562725206e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.5192993806787385,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ANNA 1B"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00506",
            "epochyr": 22,
            "epochdays": 53.30995854,
            "ndot": -3.3027932025587137e-12,
            "nddot": 0,
            "bstar": 0.00002305,
            "inclo": 0.9076200802561072,
            "nodeo": 4.827256079775444,
            "ecco": 0.0276698,
            "argpo": 5.414730415338232,
            "mo": 0.8283367536550128,
            "no": 0.060435940544366365,
            "a": 1.1482372387599746,
            "alta": 0.18000873350901525,
            "altp": 0.11646574401093401,
            "jdsatepoch": 2459632.80995854,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009215706397764612,
            "con41": 0.13697490555081004,
            "cc1": 1.1865563452933974e-11,
            "cc4": 4.5676809681391826e-7,
            "cc5": 0.000017888725557066128,
            "d2": 4.752499464379845e-21,
            "d3": 2.8364720768311094e-30,
            "d4": 1.972156551945645e-39,
            "delmo": 1.5523193968059328,
            "eta": 0.2335024130764955,
            "argpdot": 0.00003330181564694389,
            "omgcof": 4.832301525154259e-12,
            "sinmao": 0.736807866284083,
            "t": 242862.0856525004,
            "t2cof": 1.779834517940096e-11,
            "t3cof": 5.03408265649105e-21,
            "t4cof": 2.300703738528827e-30,
            "t5cof": 1.2952467858719998e-39,
            "x1mth2": 0.6210083648163967,
            "x7thm1": 1.6529414462852232,
            "mdot": 0.06044104996849196,
            "nodedot": -0.00004591068549341925,
            "xlcof": 0.0017335146532926917,
            "xmcof": -1.3044311424737709e-8,
            "nodecf": -1.9044005217673173e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.603729954662796,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "EXPLORER 16"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00614",
            "epochyr": 22,
            "epochdays": 53.5136597,
            "ndot": 6.120166706906505e-10,
            "nddot": null,
            "bstar": 0.00034773,
            "inclo": 1.4307563436026274,
            "nodeo": 3.9952488987034878,
            "ecco": 0.0502466,
            "argpo": 1.5336504843247014,
            "mo": 4.851879184862581,
            "no": 0.06430696463457779,
            "a": 1.1022086197541494,
            "alta": 0.15759085538748807,
            "altp": 0.04682638412081053,
            "jdsatepoch": 2459633.0136597,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001157996896624251,
            "con41": -0.9415500041139079,
            "cc1": 6.234479122929369e-9,
            "cc4": 0.000030248103381372137,
            "cc5": 0.0007474119258963106,
            "d2": 1.913568003728349e-15,
            "d3": 8.770293390798884e-22,
            "d4": 4.684875998484537e-28,
            "delmo": 1.2807723555103574,
            "eta": 0.6184295590491589,
            "argpdot": -0.0000389338993316597,
            "omgcof": 2.50441415768911e-11,
            "sinmao": -0.9902870059901978,
            "t": 242568.75598222017,
            "t2cof": 9.351718684394055e-9,
            "t3cof": 1.9913054635968334e-15,
            "t4cof": 6.941681193318409e-22,
            "t5cof": 2.9906022164838645e-28,
            "x1mth2": 0.9805166680379693,
            "x7thm1": -0.8636166762657851,
            "mdot": 0.06426633625321274,
            "nodedot": -0.000012033219551382831,
            "xlcof": 0.0018788335283847458,
            "xmcof": -2.1846722398233443e-7,
            "nodecf": -2.627030757665329e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.8871263183722675,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "HITCH HIKER 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00670",
            "epochyr": 22,
            "epochdays": 53.30437135,
            "ndot": 1.999856434576836e-12,
            "nddot": 0,
            "bstar": 0.000097197,
            "inclo": 1.571300726948723,
            "nodeo": 5.828823743007902,
            "ecco": 0.003986,
            "argpo": 3.9018284051612393,
            "mo": 2.3778627528558545,
            "no": 0.0586939006474039,
            "a": 1.1713740781515651,
            "alta": 0.17604317522707724,
            "altp": 0.16670498107605303,
            "jdsatepoch": 2459632.80437135,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001169445130606153,
            "con41": -0.9999992367415191,
            "cc1": 1.955612233267523e-11,
            "cc4": 1.7712485769349963e-8,
            "cc5": 0.000006984524979515402,
            "d2": 1.1288075185643723e-20,
            "d3": 9.699875456727959e-30,
            "d4": 9.707832145855392e-39,
            "delmo": 0.9376137691979692,
            "eta": 0.029412484128787234,
            "argpdot": -0.00003467878488379077,
            "omgcof": -9.066991539519154e-11,
            "sinmao": 0.6916202130233097,
            "t": 242870.1312059909,
            "t2cof": 2.933418349901284e-11,
            "t3cof": 1.205295902702484e-20,
            "t4cof": 7.955857232704043e-30,
            "t5cof": 6.459205724091184e-39,
            "x1mth2": 0.9999997455805064,
            "x7thm1": -0.9999982190635448,
            "mdot": 0.05865916167271069,
            "nodedot": 3.496843519921299e-8,
            "xlcof": 0.001753577529950685,
            "xmcof": -0.0000016390601157247048,
            "nodecf": 2.400206404349519e-18,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.56852848975943,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TRANSIT 5B-1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "  671",
            "epochyr": 22,
            "epochdays": 53.84386399,
            "ndot": 2.514970970755718e-12,
            "nddot": 0,
            "bstar": 0.00012579,
            "inclo": 1.571314689582739,
            "nodeo": 5.828263492318013,
            "ecco": 0.0039918,
            "argpo": 3.156394790975957,
            "mo": 3.1286876891005475,
            "no": 0.05871668393276929,
            "a": 1.1710712859165038,
            "alta": 0.1757459682756255,
            "altp": 0.16639660355738228,
            "jdsatepoch": 2459633.34386399,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694451222560422,
            "con41": -0.9999991939001327,
            "cc1": 2.550628532420593e-11,
            "cc4": 1.790914739128457e-8,
            "cc5": 0.000007036538050445162,
            "d2": 1.9233852765805752e-20,
            "d3": 2.1592350212404435e-29,
            "d4": 2.823219576450522e-38,
            "delmo": 0.9140807662625385,
            "eta": 0.029503982553157723,
            "argpdot": -0.00003471016059485375,
            "omgcof": -1.6328738716020776e-10,
            "sinmao": 0.012904606297499056,
            "t": 242093.26180413365,
            "t2cof": 3.825942798630889e-11,
            "t3cof": 2.0534993947885358e-20,
            "t4cof": 1.7707499166685047e-29,
            "t5cof": 1.8781371918226515e-38,
            "x1mth2": 0.9999997313000443,
            "x7thm1": -0.9999981191003098,
            "mdot": 0.05868191349633149,
            "nodedot": 3.59689272868707e-8,
            "xlcof": 0.0017535611721845872,
            "xmcof": -0.0000021277814235482982,
            "nodecf": 3.2200674036185677e-18,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.6843561923025376,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "RADIATION SAT (5E 1)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00704",
            "epochyr": 22,
            "epochdays": 53.62734081,
            "ndot": 1.151432492635148e-12,
            "nddot": 0,
            "bstar": 0.000046921,
            "inclo": 1.5690475068843983,
            "nodeo": 1.4744209908290216,
            "ecco": 0.0035849,
            "argpo": 2.537183388294905,
            "mo": 5.691063159818738,
            "no": 0.058803540569558825,
            "a": 1.169918740571339,
            "alta": 0.17411278226441307,
            "altp": 0.1657246988782648,
            "jdsatepoch": 2459633.12734081,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694434910726453,
            "con41": -0.9999908248961155,
            "cc1": 9.791025563795671e-12,
            "cc4": 1.5884279843690878e-8,
            "cc5": 0.000007230463329983058,
            "d2": 2.8521571836262533e-21,
            "d3": 1.2369553032548249e-30,
            "d4": 6.248136895905521e-40,
            "delmo": 1.06785475705703,
            "eta": 0.026664542788294946,
            "argpdot": -0.00003482922140555451,
            "omgcof": -5.797419594694328e-11,
            "sinmao": -0.5581231473703092,
            "t": 242405.05518369377,
            "t2cof": 1.4686538345693507e-11,
            "t3cof": 3.043885546808054e-21,
            "t4cof": 1.0138396307631851e-30,
            "t5cof": 4.1538460897251965e-40,
            "x1mth2": 0.9999969416320386,
            "x7thm1": -0.9999785914242697,
            "mdot": 0.05876865049895183,
            "nodedot": -1.2176749270969023e-7,
            "xlcof": 0.00175620681128327,
            "xmcof": -0.0000010068833825096607,
            "nodecf": -4.1845962405163966e-18,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.3201761242827601,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TRANSIT 5B-2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00705",
            "epochyr": 22,
            "epochdays": 53.56100324,
            "ndot": 1.06052992742711e-12,
            "nddot": 0,
            "bstar": 0.000041584,
            "inclo": 1.5690544882014061,
            "nodeo": 1.473373793277825,
            "ecco": 0.0035881,
            "argpo": 1.8719563798850223,
            "mo": 0.042006584436999526,
            "no": 0.05882519991570707,
            "a": 1.169631775138978,
            "alta": 0.17382853091135408,
            "altp": 0.16543501936660188,
            "jdsatepoch": 2459633.06100324,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694435053219742,
            "con41": -0.9999908980041478,
            "cc1": 8.741927957983871e-12,
            "cc4": 1.60473897935965e-8,
            "cc5": 0.0000072818921151474125,
            "d2": 2.2772914089423796e-21,
            "d3": 8.83223138606632e-31,
            "d4": 3.989692823100249e-40,
            "delmo": 1.0822799031907642,
            "eta": 0.026730600079929532,
            "argpdot": -0.000034859127468781217,
            "omgcof": -1.8682409022293825e-11,
            "sinmao": 0.04199423171851737,
            "t": 242500.58128461242,
            "t2cof": 1.3112891936975806e-11,
            "t3cof": 2.4301340177875397e-21,
            "t4cof": 7.23811280108197e-31,
            "t5cof": 2.6519713422340213e-40,
            "x1mth2": 0.9999969660013827,
            "x7thm1": -0.9999787620096783,
            "mdot": 0.05879027985888669,
            "nodedot": -1.2138549207834455e-7,
            "xlcof": 0.0017561986968628765,
            "xmcof": -8.958822046656017e-7,
            "nodecf": -3.724505454956988e-18,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.185408994399424,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TRANSIT 5E 3"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00716",
            "epochyr": 22,
            "epochdays": 53.50793386,
            "ndot": 2.72707695624114e-12,
            "nddot": 0,
            "bstar": 0.000045917,
            "inclo": 1.020928600624831,
            "nodeo": 1.685459222663168,
            "ecco": 0.0027319,
            "argpo": 0.7301829271813557,
            "mo": 5.558447807264453,
            "no": 0.06413478695953297,
            "a": 1.1038041966933962,
            "alta": 0.10681967937834291,
            "altp": 0.10078871400844958,
            "jdsatepoch": 2459633.00793386,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009970616220710193,
            "con41": -0.18074780855773298,
            "cc1": 8.72366874332458e-11,
            "cc4": 2.3449718256119224e-7,
            "cc5": 0.000059667305029620455,
            "d2": 3.672480507555894e-19,
            "d3": 2.308376061458478e-27,
            "d4": 1.6910574714124648e-35,
            "delmo": 1.0758668151543458,
            "eta": 0.0329583888966485,
            "argpdot": 0.000015530357384562067,
            "omgcof": 9.397514689352425e-10,
            "sinmao": -0.6629389386567147,
            "t": 242577.00119130313,
            "t2cof": 1.3085503114986872e-10,
            "t3cof": 3.8246853002424106e-19,
            "t4cof": 1.8290542865772404e-27,
            "t5cof": 1.0808433200970552e-35,
            "x1mth2": 0.726915936185911,
            "x7thm1": 0.911588446698623,
            "mdot": 0.06412706472967074,
            "nodedot": -0.00004465386356243227,
            "xlcof": 0.0018378015998213113,
            "xmcof": -0.000009125345221049707,
            "nodecf": -1.3641724285578234e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.8510513064433525,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TIROS 8"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00728",
            "epochyr": 22,
            "epochdays": 53.58217419,
            "ndot": 2.72707695624114e-13,
            "nddot": 0,
            "bstar": 0.000044901,
            "inclo": 1.2201631707277398,
            "nodeo": 6.1991826102811,
            "ecco": 0.0015643,
            "argpo": 3.926479435516407,
            "mo": 2.356424873653608,
            "no": 0.060989696649504155,
            "a": 1.141646916517016,
            "alta": 0.14343279478852367,
            "altp": 0.13986103824550855,
            "jdsatepoch": 2459633.08217419,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010982908687066442,
            "con41": -0.646038690397194,
            "cc1": 2.086956792759185e-11,
            "cc4": 1.3381612670695343e-8,
            "cc5": 0.00001546510090431015,
            "d2": 1.540060112663937e-20,
            "d3": 1.6940068925809894e-29,
            "d4": 2.170847819943791e-38,
            "delmo": 0.9709448842770533,
            "eta": 0.013828364269862444,
            "argpdot": -0.00001560634170836039,
            "omgcof": -2.851516991460145e-10,
            "sinmao": 0.7069438567148658,
            "t": 242470.0951165706,
            "t2cof": 3.1304351891387776e-11,
            "t3cof": 1.6271678857608112e-20,
            "t4cof": 1.3691987138217695e-29,
            "t5cof": 1.4198992188050512e-38,
            "x1mth2": 0.8820128967990646,
            "x7thm1": -0.17409027759345252,
            "mdot": 0.060965147971541525,
            "nodedot": -0.000026066519583056912,
            "xlcof": 0.0019282377834822283,
            "xmcof": -0.000009363486718763491,
            "nodecf": -1.907642740261377e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.035608888830346075,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "GGSE 1 (GGRS)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00729",
            "epochyr": 22,
            "epochdays": 53.44564916,
            "ndot": -1.424140188259262e-12,
            "nddot": 0,
            "bstar": 0.0000050977,
            "inclo": 1.2199834018147844,
            "nodeo": 1.2599339883929346,
            "ecco": 0.0016708,
            "argpo": 5.099035260237498,
            "mo": 1.1829824216725044,
            "no": 0.06088987508129442,
            "a": 1.1428934705108156,
            "alta": 0.14480301692134523,
            "altp": 0.14098392410028615,
            "jdsatepoch": 2459632.94564916,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010982186385624442,
            "con41": -0.6456906633364333,
            "cc1": 2.2794045889192513e-12,
            "cc4": 1.4544456430261773e-8,
            "cc5": 0.0000149002959274708,
            "d2": 1.821600963746069e-22,
            "d3": 2.1697757883846085e-32,
            "d4": 3.0109790644427764e-42,
            "delmo": 1.0167063298050105,
            "eta": 0.01464451138885692,
            "argpdot": -0.000015524894229437378,
            "omgcof": 1.537122218621058e-11,
            "sinmao": 0.9257379770678256,
            "t": 242666.69115945697,
            "t2cof": 3.419106883378877e-12,
            "t3cof": 1.9255146693457918e-22,
            "t4cof": 1.754857576384177e-32,
            "t5cof": 1.9708649894789797e-42,
            "x1mth2": 0.8818968877788111,
            "x7thm1": -0.1732782144516778,
            "mdot": 0.060865433184083814,
            "nodedot": -0.000025979997724232557,
            "xlcof": 0.0019282136784387546,
            "xmcof": -9.043758081149787e-7,
            "nodecf": -2.076627713867337e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.458633523147384,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SECOR 1B"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00730",
            "epochyr": 22,
            "epochdays": 53.44938698,
            "ndot": -5.75716246317574e-13,
            "nddot": 0,
            "bstar": 0.000025671,
            "inclo": 1.2200846309114,
            "nodeo": 1.0433159389401623,
            "ecco": 0.0016843,
            "argpo": 4.5149870059963755,
            "mo": 3.6610392908975977,
            "no": 0.060921850567256054,
            "a": 1.1424938356861596,
            "alta": 0.14441813805360582,
            "altp": 0.14056953331871336,
            "jdsatepoch": 2459632.94938698,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001098259316213379,
            "con41": -0.6458866579601243,
            "cc1": 1.1622247203201408e-11,
            "cc4": 1.4976507613220667e-8,
            "cc5": 0.000015079694664517177,
            "d2": 4.748678174567376e-21,
            "d3": 2.891962647649811e-30,
            "d4": 2.0518501018916097e-39,
            "delmo": 0.961941895793505,
            "eta": 0.014803076309953964,
            "argpdot": -0.00001555627759388263,
            "omgcof": -4.057749898713274e-11,
            "sinmao": -0.496399843035741,
            "t": 242661.3086988777,
            "t2cof": 1.7433370804802112e-11,
            "t3cof": 5.018831434672022e-21,
            "t4cof": 2.3384676556017746e-30,
            "t5cof": 1.3427399956839875e-39,
            "x1mth2": 0.8819622193200415,
            "x7thm1": -0.17373553524029028,
            "mdot": 0.06089737129085536,
            "nodedot": -0.000026004599360840168,
            "xlcof": 0.0019282272654856842,
            "xmcof": -0.000004524617025329517,
            "nodecf": -1.059837327839178e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.48218323881558,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SOLRAD 7A"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "  731",
            "epochyr": 22,
            "epochdays": 53.76509136,
            "ndot": -1.8180513041607598e-13,
            "nddot": 0,
            "bstar": 0.000035146,
            "inclo": 1.220088121569904,
            "nodeo": 0.8843077174372189,
            "ecco": 0.0016844,
            "argpo": 4.4519544400606,
            "mo": 1.8299044168874707,
            "no": 0.06093170703095644,
            "a": 1.1423706931096993,
            "alta": 0.1442949023051734,
            "altp": 0.1404464839142252,
            "jdsatepoch": 2459633.26509136,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010982607186902705,
            "con41": -0.6458934155577334,
            "cc1": 1.5973063700962798e-11,
            "cc4": 1.504485221817732e-8,
            "cc5": 0.000015135408262030968,
            "d2": 8.97705656921498e-21,
            "d3": 7.520025849766119e-30,
            "d4": 7.339023047550147e-39,
            "delmo": 0.9886544698012265,
            "eta": 0.014816402110383672,
            "argpdot": -0.000015562580183668433,
            "omgcof": -7.329483069760622e-11,
            "sinmao": 0.9666188864121772,
            "t": 242206.69439144433,
            "t2cof": 2.3959595551444197e-11,
            "t3cof": 9.48733409720501e-21,
            "t4cof": 6.080381045930934e-30,
            "t5cof": 4.802339384812209e-39,
            "x1mth2": 0.8819644718525778,
            "x7thm1": -0.17375130296804453,
            "mdot": 0.06090721825874587,
            "nodedot": -0.000026014157844263405,
            "xlcof": 0.0019282277333915357,
            "xmcof": -0.000006212204050983078,
            "nodecf": -1.4571260373215133e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.188058051238066,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "GREB"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "  734",
            "epochyr": 22,
            "epochdays": 53.85166267,
            "ndot": 2.42406840554768e-13,
            "nddot": 0,
            "bstar": 0.000022243,
            "inclo": 1.7296719032746886,
            "nodeo": 4.708744732906526,
            "ecco": 0.0015536,
            "argpo": 1.2879796841432314,
            "mo": 5.000246133916114,
            "no": 0.06238580259853932,
            "a": 1.1246938102057804,
            "alta": 0.12644113450931616,
            "altp": 0.12294648590224466,
            "jdsatepoch": 2459633.35166267,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011547170520861039,
            "con41": -0.924910643913588,
            "cc1": 1.820826259449478e-11,
            "cc4": 1.3579165231865074e-8,
            "cc5": 0.000026892261963395836,
            "d2": 1.3309623941055121e-20,
            "d3": 1.451254551235897e-29,
            "d4": 1.8438836145840887e-38,
            "delmo": 1.0133386819064225,
            "eta": 0.0155922212959502,
            "argpdot": -0.000034989912814856864,
            "omgcof": 1.227238458252518e-10,
            "sinmao": -0.9588544267325525,
            "t": 242082.031705454,
            "t2cof": 2.7312393891742168e-11,
            "t3cof": 1.3972705594475276e-20,
            "t4cof": 1.1626536473611177e-29,
            "t5cof": 1.193687863020295e-38,
            "x1mth2": 0.9749702146378627,
            "x7thm1": -0.8247915024650389,
            "mdot": 0.06234875810825207,
            "nodedot": 0.000012645344817829814,
            "xlcof": 0.0015150557721733738,
            "xmcof": -0.000007309742798903737,
            "nodecf": 8.08161935621281e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.7334909006905477,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 3367 A"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "  735",
            "epochyr": 22,
            "epochdays": 53.80410084,
            "ndot": 2.72707695624114e-13,
            "nddot": 0,
            "bstar": 0.000022927,
            "inclo": 1.730054130380875,
            "nodeo": 4.604068611018166,
            "ecco": 0.0016656,
            "argpo": 3.122238697514428,
            "mo": 3.163074166023339,
            "no": 0.062339922385112136,
            "a": 1.1252449602378911,
            "alta": 0.1271191682436632,
            "altp": 0.1233707522321188,
            "jdsatepoch": 2459633.30410084,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011546462497403255,
            "con41": -0.9245519687118131,
            "cc1": 1.840449136773026e-11,
            "cc4": 1.70729647815094e-8,
            "cc5": 0.00002638785203314977,
            "d2": 1.3538057850385379e-20,
            "d3": 1.4854523777079586e-29,
            "d4": 1.8992001865707914e-38,
            "delmo": 0.9509098499578742,
            "eta": 0.01664253377947645,
            "argpdot": -0.00003490622040373324,
            "omgcof": -4.121532014649043e-10,
            "sinmao": -0.021479860345096767,
            "t": 242150.52074052393,
            "t2cof": 2.760673705159539e-11,
            "t3cof": 1.4215508455395096e-20,
            "t4cof": 1.1903961206604399e-29,
            "t5cof": 1.229913012389789e-38,
            "x1mth2": 0.974850656237271,
            "x7thm1": -0.823954593660897,
            "mdot": 0.06230295572058767,
            "nodedot": 0.00001265382785325852,
            "xlcof": 0.0015143476446776239,
            "xmcof": -0.000006456257055056775,
            "nodecf": 8.174159418312274e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.4338329135581702,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 3367 B"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "  801",
            "epochyr": 22,
            "epochdays": 53.71494511,
            "ndot": 6.696488970325466e-12,
            "nddot": 0,
            "bstar": 0.00010805,
            "inclo": 1.5798179336984555,
            "nodeo": 1.7927201771737316,
            "ecco": 0.0050726,
            "argpo": 1.2235770347446406,
            "mo": 5.071202494655943,
            "no": 0.0617719221403528,
            "a": 1.1321627886582482,
            "alta": 0.137905797619996,
            "altp": 0.1264197796965003,
            "jdsatepoch": 2459633.21494511,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001169397689474158,
            "con41": -0.999755838450794,
            "cc1": 6.89230947380835e-11,
            "cc4": 9.709361884216608e-8,
            "cc5": 0.000021217432164811617,
            "d2": 1.800148814537958e-19,
            "d3": 7.011146170571994e-28,
            "d4": 3.181623190779648e-36,
            "delmo": 1.051485928924065,
            "eta": 0.048056207660944726,
            "argpdot": -0.000039049856680469664,
            "omgcof": 1.6189671379752796e-10,
            "sinmao": -0.9363141331767116,
            "t": 242278.90499152243,
            "t2cof": 1.0338464210712525e-10,
            "t3cof": 1.8951566743034548e-19,
            "t4cof": 5.63876040443949e-28,
            "t5cof": 2.0690340648229188e-36,
            "x1mth2": 0.9999186128169314,
            "x7thm1": -0.9994302897185195,
            "mdot": 0.061732793590086175,
            "nodedot": 7.045255594884048e-7,
            "xlcof": 0.0017434507906389687,
            "xmcof": -0.000002728654787581135,
            "nodecf": 1.7046427375814492e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.8721172141823885,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 4412 (TRANSIT 9)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00812",
            "epochyr": 22,
            "epochdays": 53.5774978,
            "ndot": 9.39326507149726e-13,
            "nddot": 0,
            "bstar": 0.000036729,
            "inclo": 1.741784488283529,
            "nodeo": 0.12199327872664766,
            "ecco": 0.0005579,
            "argpo": 3.0315775695195826,
            "mo": 3.253782417907989,
            "no": 0.0621665708429573,
            "a": 1.127328694897824,
            "alta": 0.12795763157670748,
            "altp": 0.12669975821894064,
            "jdsatepoch": 2459633.0774978,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011523913831287212,
            "con41": -0.9131406199372472,
            "cc1": 2.7352104106503172e-11,
            "cc4": -1.7849397006267853e-8,
            "cc5": 0.000024521920119812835,
            "d2": 2.941081854046871e-20,
            "d3": 4.7168580501788116e-29,
            "d4": 8.814523682023306e-38,
            "delmo": 0.9837431674228306,
            "eta": 0.005483047398131557,
            "argpdot": -0.0000339286892030621,
            "omgcof": -1.7790075842050074e-9,
            "sinmao": -0.11195456549780836,
            "t": 242476.8291181326,
            "t2cof": 4.1028156159754757e-11,
            "t3cof": 3.0907093738574686e-20,
            "t4cof": 3.7840936531808423e-29,
            "t5cof": 5.715522057207807e-38,
            "x1mth2": 0.9710468733124158,
            "x7thm1": -0.7973281131869103,
            "mdot": 0.062130296666996356,
            "nodedot": 0.000013489695847354742,
            "xlcof": 0.0014922937923161942,
            "xmcof": -0.00008707574100698223,
            "nodecf": 1.2950053304116787e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.00614581709773887,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 4467 A"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00813",
            "epochyr": 22,
            "epochdays": 53.5951848,
            "ndot": 6.96919666594958e-13,
            "nddot": 0,
            "bstar": 0.000033908,
            "inclo": 1.7419206239651845,
            "nodeo": 0.09084438756630485,
            "ecco": 0.0004557,
            "argpo": 4.599246266294905,
            "mo": 1.6850839768739891,
            "no": 0.06213071276510827,
            "a": 1.1277620009166236,
            "alta": 0.12827592206044147,
            "altp": 0.12724807977280594,
            "jdsatepoch": 2459633.0951848,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001152364283036196,
            "con41": -0.913003608409344,
            "cc1": 2.4869358426957734e-11,
            "cc4": -2.056598675915282e-8,
            "cc5": 0.000024162220073018094,
            "d2": 2.4231642231780238e-20,
            "d3": 3.5214543020456433e-29,
            "d4": 5.962929673474031e-38,
            "delmo": 0.9984737476199177,
            "eta": 0.004463471049871479,
            "argpdot": -0.00003387407502600837,
            "omgcof": -2.2398841943163677e-10,
            "sinmao": 0.9934762720563934,
            "t": 242451.35983765125,
            "t2cof": 3.73040376404366e-11,
            "t3cof": 2.5468612208917226e-20,
            "t4cof": 2.825723676530618e-29,
            "t5cof": 3.8675085457319954e-38,
            "x1mth2": 0.9710012028031147,
            "x7thm1": -0.7970084196218029,
            "mdot": 0.06209449281118106,
            "nodedot": 0.000013482199901459173,
            "xlcof": 0.0014920341793553816,
            "xmcof": -0.00011908604629602689,
            "nodecf": 1.1768007358548992e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.11758078351081025,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 4467 B"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "  870",
            "epochyr": 22,
            "epochdays": 53.83422166,
            "ndot": 2.211962420062258e-12,
            "nddot": 0,
            "bstar": 0.000048959,
            "inclo": 1.3945058550387053,
            "nodeo": 3.3553937416298467,
            "ecco": 0.0098085,
            "argpo": 1.7833896469925699,
            "mo": 4.521024099879023,
            "no": 0.06073691144482318,
            "a": 1.1449343872441446,
            "alta": 0.15616447618142892,
            "altp": 0.13370429830686037,
            "jdsatepoch": 2459633.33422166,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011513200907141887,
            "con41": -0.9077268778790948,
            "cc1": 2.1311696781610614e-11,
            "cc4": 1.3604115575899293e-7,
            "cc5": 0.000014736190022063274,
            "d2": 1.5719284797377392e-20,
            "d3": 1.72799020436977e-29,
            "d4": 2.212955522010056e-38,
            "delmo": 0.9523525332529091,
            "eta": 0.08486709383358812,
            "argpdot": -0.00003180613366706007,
            "omgcof": -1.3678184503312356e-11,
            "sinmao": -0.9817455506861172,
            "t": 242107.14675933123,
            "t2cof": 3.196754517241592e-11,
            "t3cof": 1.6627661636800017e-20,
            "t4cof": 1.3989139241156258e-29,
            "t5cof": 1.450153787224901e-38,
            "x1mth2": 0.9692422926263649,
            "x7thm1": -0.7846960483845542,
            "mdot": 0.06070275198789518,
            "nodedot": -0.000013172918750581981,
            "xlcof": 0.001898769086935542,
            "xmcof": -2.408223965929093e-7,
            "nodecf": -9.85129334889473e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.623605771144092,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "EXPLORER 20"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00876",
            "epochyr": 22,
            "epochdays": 53.07740883,
            "ndot": 0,
            "nddot": 0,
            "bstar": 0.000023374,
            "inclo": 1.1355286646400309,
            "nodeo": 5.154189409929771,
            "ecco": 0.0133852,
            "argpo": 2.923974530475628,
            "mo": 3.367012398460373,
            "no": 0.06389215308082034,
            "a": 1.1067363316915555,
            "alta": 0.12155021883851336,
            "altp": 0.09192244454459764,
            "jdsatepoch": 2459632.57740883,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001060402943680751,
            "con41": -0.46662593650640605,
            "cc1": 4.4187811380400416e-11,
            "cc4": 0.0000011303150785411525,
            "cc5": 0.00006170779722636944,
            "d2": 9.166541818496295e-20,
            "d3": 2.838828654319966e-28,
            "d4": 1.0246247570374538e-36,
            "delmo": 0.6073836826904214,
            "eta": 0.15709610393775214,
            "argpdot": -0.000004768289078170722,
            "omgcof": -1.1664669093539062e-10,
            "sinmao": -0.22351550729196293,
            "t": 243196.95723451674,
            "t2cof": 6.628171707060062e-11,
            "t3cof": 9.557054353414264e-20,
            "t4cof": 2.2527933037851844e-28,
            "t5cof": 6.560492352676956e-37,
            "x1mth2": 0.8222086455021353,
            "x7thm1": 0.24453948148505256,
            "mdot": 0.06387238397385184,
            "nodedot": -0.00003569283920544416,
            "xlcof": 0.0019051130703814988,
            "xmcof": -1.7636692301789875e-7,
            "nodecf": -5.527303760919742e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 3.1385765310300684,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 44"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00897",
            "epochyr": 22,
            "epochdays": 53.50155365,
            "ndot": 1.6968478838833761e-12,
            "nddot": 0,
            "bstar": 0.000069242,
            "inclo": 1.5739414101069904,
            "nodeo": 0.7267760444814627,
            "ecco": 0.0021561,
            "argpo": 1.3789724246959558,
            "mo": 0.5697993862278408,
            "no": 0.059091841111362745,
            "a": 1.1661133959057775,
            "alta": 0.1686276529986901,
            "altp": 0.16359913881286503,
            "jdsatepoch": 2459633.00155365,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694394955631025,
            "con41": -0.9999703254507226,
            "cc1": 1.5916161072185424e-11,
            "cc4": 7.335421671670762e-9,
            "cc5": 0.00000792609998488698,
            "d2": 7.698788792338934e-21,
            "d3": 5.545113953187478e-30,
            "d4": 4.651902843562491e-39,
            "delmo": 1.0419536152629305,
            "eta": 0.016381537582115774,
            "argpdot": -0.00003522663698568197,
            "omgcof": 3.743803095815476e-11,
            "sinmao": 0.5394631409457055,
            "t": 242586.18869394064,
            "t2cof": 2.3874241608278136e-11,
            "t3cof": 8.205437158890436e-21,
            "t4cof": 4.536520823590657e-30,
            "t5cof": 3.085978204926166e-39,
            "x1mth2": 0.9999901084835742,
            "x7thm1": -0.9999307593850194,
            "mdot": 0.059056551905128395,
            "nodedot": 2.2149243256140927e-7,
            "xlcof": 0.0017504696607405998,
            "xmcof": -0.000004435554634839635,
            "nodecf": 1.2373792135453177e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.810853506253281,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 5798 (TRANSIT 5B-4)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00899",
            "epochyr": 22,
            "epochdays": 53.51089747,
            "ndot": 2.999784651865254e-12,
            "nddot": 0,
            "bstar": 0.000082208,
            "inclo": 1.3908441542680212,
            "nodeo": 0.872617502107361,
            "ecco": 0.0119566,
            "argpo": 5.139059150644231,
            "mo": 1.1244301159265988,
            "no": 0.06034392410146248,
            "a": 1.1498944158193416,
            "alta": 0.16364324339152714,
            "altp": 0.13614558824715606,
            "jdsatepoch": 2459633.01089747,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011505613742668302,
            "con41": -0.9038957742535987,
            "cc1": 3.132403853291843e-11,
            "cc4": 1.43206037918145e-7,
            "cc5": 0.000013010662165510187,
            "d2": 3.2872528382410374e-20,
            "d3": 5.140311725505964e-29,
            "d4": 9.363693572086063e-38,
            "delmo": 1.135381419312648,
            "eta": 0.10014408874577407,
            "argpdot": -0.0000310959039881334,
            "omgcof": 3.051882122443766e-11,
            "sinmao": 0.9020217269688948,
            "t": 242572.73359291255,
            "t2cof": 4.6986057799377647e-11,
            "t3cof": 3.483491916243389e-20,
            "t4cof": 4.171827648398259e-29,
            "t5cof": 6.153966739370355e-38,
            "x1mth2": 0.9679652580845329,
            "x7thm1": -0.7757568065917304,
            "mdot": 0.0603104175385448,
            "nodedot": -0.000013243204957441498,
            "xlcof": 0.0019005099374611127,
            "xmcof": -2.42601295724812e-7,
            "nodecf": -1.455555888033211e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.869723199586971,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "EXPLORER 22"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00900",
            "epochyr": 22,
            "epochdays": 53.46035986,
            "ndot": 1.1362820651004751e-11,
            "nddot": 0,
            "bstar": 0.00039125,
            "inclo": 1.573754659877027,
            "nodeo": 0.6773535560527393,
            "ecco": 0.0028042,
            "argpo": 0.2145044557286071,
            "mo": 1.9050216425640547,
            "no": 0.05997501027931917,
            "a": 1.1546464630308553,
            "alta": 0.15788432264248642,
            "altp": 0.15140860341922413,
            "jdsatepoch": 2459632.96035986,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694401620373606,
            "con41": -0.9999737448727182,
            "cc1": 1.2329079376152985e-10,
            "cc4": 1.744646348268802e-8,
            "cc5": 0.000010727159587445268,
            "d2": 4.943825479504646e-19,
            "d3": 2.9533120093395466e-27,
            "d4": 2.0551172986079918e-35,
            "delmo": 0.9777288242909704,
            "eta": 0.02280083899209917,
            "argpdot": -0.00003646605384291347,
            "omgcof": 1.2478205319316758e-9,
            "sinmao": 0.9446647185115195,
            "t": 242645.50775125623,
            "t2cof": 1.8493619064229478e-10,
            "t3cof": 5.247837876031608e-19,
            "t4cof": 2.4025276984907853e-27,
            "t5cof": 1.3543662256056553e-35,
            "x1mth2": 0.9999912482909061,
            "x7thm1": -0.9999387380363427,
            "mdot": 0.059938478311317336,
            "nodedot": 2.1566769391069697e-7,
            "xlcof": 0.0017506903896161038,
            "xmcof": -0.00001889302828312295,
            "nodecf": 9.333504824764914e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.551316643239645,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "CALSPHERE 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00902",
            "epochyr": 22,
            "epochdays": 53.51688094,
            "ndot": 5.75716246317574e-13,
            "nddot": 0,
            "bstar": 0.00001499,
            "inclo": 1.5739588633995103,
            "nodeo": 0.7296994709785533,
            "ecco": 0.0020104,
            "argpo": 2.068096481224145,
            "mo": 0.03669554752318078,
            "no": 0.05905820860147497,
            "a": 1.1665557206857746,
            "alta": 0.16890096430664148,
            "altp": 0.164210477064908,
            "jdsatepoch": 2459633.01688094,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001169439431191833,
            "con41": -0.999969995186706,
            "cc1": 3.4050591996823323e-12,
            "cc4": 6.183477700669306e-9,
            "cc5": 0.000007836417270158165,
            "d2": 3.5148687576179223e-22,
            "d3": 5.402434882494436e-32,
            "d4": 9.671641322161542e-42,
            "delmo": 1.0463774534973145,
            "eta": 0.015236396432968332,
            "argpdot": -0.00003517987500062767,
            "omgcof": -2.1427033779690975e-11,
            "sinmao": 0.03668731259861047,
            "t": 242564.11739610136,
            "t2cof": 5.1075887995234985e-12,
            "t3cof": 3.746757320684748e-22,
            "t4cof": 4.420746176397062e-32,
            "t5cof": 6.41758610449179e-42,
            "x1mth2": 0.9999899983955687,
            "x7thm1": -0.9999299887689808,
            "mdot": 0.05902296626902711,
            "nodedot": 2.224261204560223e-7,
            "xlcof": 0.0017504490245669531,
            "xmcof": -0.0000010945498557805125,
            "nodecf": 2.658369657884673e-18,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.907421382810227,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "CALSPHERE 2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00932",
            "epochyr": 22,
            "epochdays": 53.53084652,
            "ndot": 1.3726287346413737e-11,
            "nddot": 0,
            "bstar": 0.00016203,
            "inclo": 1.4197258627300235,
            "nodeo": 2.581535695246585,
            "ecco": 0.1131379,
            "argpo": 4.065316886854052,
            "mo": 2.0300448128721644,
            "no": 0.05518764929286165,
            "a": 1.2204171791642078,
            "alta": 0.3584926159387698,
            "altp": 0.08234174238964553,
            "jdsatepoch": 2459633.03084652,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001156125933001893,
            "con41": -0.9320524189885441,
            "cc1": 1.6426759691016534e-10,
            "cc4": 0.0000016479242181592525,
            "cc5": 0.00004576350507682221,
            "d2": 6.337916937006311e-19,
            "d3": 3.633322492057819e-27,
            "d4": 2.424767606499281e-35,
            "delmo": 0.3511705714945417,
            "eta": 0.6643406965237446,
            "argpdot": -0.00002734383220704082,
            "omgcof": -1.0701620730229563e-12,
            "sinmao": 0.8963858776442803,
            "t": 242544.00696136057,
            "t2cof": 2.46401395365248e-10,
            "t3cof": 6.877593804899122e-19,
            "t4cof": 3.0484076122154373e-27,
            "t5cof": 1.6567842301427253e-35,
            "x1mth2": 0.9773508063295148,
            "x7thm1": -0.841455644306603,
            "mdot": 0.055159056702059464,
            "nodedot": -0.000009275363650233514,
            "xlcof": 0.0018854217776459055,
            "xmcof": -1.450189008297525e-9,
            "nodecf": -5.277615961180507e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.995409954816225,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "EXPLORER 25 (INJUN-4)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00959",
            "epochyr": 22,
            "epochdays": 53.44930219,
            "ndot": 3.727005173529558e-12,
            "nddot": 0,
            "bstar": 0.00014811,
            "inclo": 1.570717786978557,
            "nodeo": 3.26691078454149,
            "ecco": 0.0040356,
            "argpo": 4.767019531301365,
            "mo": 2.6800804754726886,
            "no": 0.05945176746836724,
            "a": 1.1614059070514136,
            "alta": 0.16609287672991013,
            "altp": 0.15671893737291676,
            "jdsatepoch": 2459632.94930219,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694452757641369,
            "con41": -0.9999999814944918,
            "cc1": 3.877249540246803e-11,
            "cc4": 2.46064753670596e-8,
            "cc5": 0.00000898525929207547,
            "d2": 4.6943461892697206e-20,
            "d3": 8.464787779951435e-29,
            "d4": 1.7779074826106536e-37,
            "delmo": 0.9177386241925202,
            "eta": 0.031504727653597256,
            "argpdot": -0.00003573121096344335,
            "omgcof": 1.4408260637865908e-11,
            "sinmao": 0.44530258984352733,
            "t": 242661.4307963848,
            "t2cof": 5.8158743103702044e-11,
            "t3cof": 4.9950074692166014e-20,
            "t4cof": 6.909197118204788e-29,
            "t5cof": 1.1762590021127773e-37,
            "x1mth2": 0.9999999938314973,
            "x7thm1": -0.9999999568204808,
            "mdot": 0.059415973188485086,
            "nodedot": -5.610103412933559e-9,
            "xlcof": 0.0017542597544501287,
            "xmcof": -0.0000029858123362464304,
            "nodecf": -7.63493460567025e-19,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.481649029312777,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 6582 (TRANSIT 5E-5)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "  965",
            "epochyr": 22,
            "epochdays": 53.82091714,
            "ndot": 1.605945318675338e-12,
            "nddot": 0,
            "bstar": 0.000061878,
            "inclo": 1.571260584375927,
            "nodeo": 3.404828447363334,
            "ecco": 0.0040356,
            "argpo": 3.5197863038751924,
            "mo": 4.845063674133542,
            "no": 0.05923570550051203,
            "a": 1.1642260808135314,
            "alta": 0.1689244315852625,
            "altp": 0.15952773004180032,
            "jdsatepoch": 2459633.32091714,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694451533427487,
            "con41": -0.9999993533947419,
            "cc1": 1.5010762241378533e-11,
            "cc4": 2.24778797619522e-8,
            "cc5": 0.000008353087276087188,
            "d2": 6.92189635021168e-21,
            "d3": 4.7531954095726425e-30,
            "d4": 3.801774510907812e-39,
            "delmo": 1.0123504159257724,
            "eta": 0.030993292972896398,
            "argpdot": -0.00003542932749054656,
            "omgcof": -9.292302823038552e-11,
            "sinmao": -0.9912116156891433,
            "t": 242126.30526803434,
            "t2cof": 2.2516143362067798e-11,
            "t3cof": 7.372542316346072e-21,
            "t4cof": 3.885061052612812e-30,
            "t5cof": 2.5193079776209168e-39,
            "x1mth2": 0.9999997844649139,
            "x7thm1": -0.9999984912543975,
            "mdot": 0.059200213927190416,
            "nodedot": 3.288187373248079e-8,
            "xlcof": 0.0017536245540820524,
            "xmcof": -0.0000011761800880994815,
            "nodecf": 1.7324629015023688e-18,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.5397821320958869,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 6582 (TRANSIT 5B-5)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "00978",
            "epochyr": 22,
            "epochdays": 53.47621103,
            "ndot": 6.9388958108802344e-12,
            "nddot": 0,
            "bstar": 0.0003086,
            "inclo": 1.6822757421075303,
            "nodeo": 3.992379577413209,
            "ecco": 0.1158468,
            "argpo": 3.5130423516454865,
            "mo": 2.6809077615381343,
            "no": 0.05286254507051318,
            "a": 1.2559354586267255,
            "alta": 0.4014315625151639,
            "altp": 0.11043935473828692,
            "jdsatepoch": 2459632.97621103,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011621860677798336,
            "con41": -0.9628712109242109,
            "cc1": 9.325766936816366e-11,
            "cc4": 4.691005161478491e-7,
            "cc5": 0.000013743131887384083,
            "d2": 1.7953065288655262e-19,
            "d3": 5.128417252463135e-28,
            "d4": 1.704897854523216e-36,
            "delmo": 0.10020465072705768,
            "eta": 0.5978518060083504,
            "argpdot": -0.000026194259369668718,
            "omgcof": -1.345811255024623e-12,
            "sinmao": 0.44456170202801926,
            "t": 242622.6820667088,
            "t2cof": 1.3988650405224547e-10,
            "t3cof": 1.9692463867851607e-19,
            "t4cof": 4.368867779597459e-28,
            "t5cof": 1.1859948107607925e-36,
            "x1mth2": 0.9876237369747369,
            "x7thm1": -0.9133661588231586,
            "mdot": 0.052835804061559674,
            "nodedot": 0.000006209426740162431,
            "xlcof": 0.0015978035011323989,
            "xmcof": -1.594422131016515e-9,
            "nodecf": 2.004439122294453e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.651185164945147,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TIROS 9"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01208",
            "epochyr": 22,
            "epochdays": 53.44415196,
            "ndot": -5.45415391248228e-13,
            "nddot": 0,
            "bstar": 0.00002543,
            "inclo": 1.2231197584806182,
            "nodeo": 5.218679325790961,
            "ecco": 0.0020406,
            "argpo": 6.099738985490219,
            "mo": 3.2030247526014897,
            "no": 0.06092085503399651,
            "a": 1.1425090482873728,
            "alta": 0.14484045225130782,
            "altp": 0.1401776443234377,
            "jdsatepoch": 2459632.94415196,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010994737152378775,
            "con41": -0.6517412655271362,
            "cc1": 1.1513586731305723e-11,
            "cc4": 2.0764584493606575e-8,
            "cc5": 0.000015084202583024323,
            "d2": 4.6599037312735176e-21,
            "d3": 2.8111261206104495e-30,
            "d4": 1.9756803090647138e-39,
            "delmo": 0.9472578175311975,
            "eta": 0.01793302533505589,
            "argpdot": -0.00001592432444717151,
            "omgcof": 1.6643290658885116e-10,
            "sinmao": -0.06139346650721726,
            "t": 242668.84712778032,
            "t2cof": 1.7270380096958585e-11,
            "t3cof": 4.925029090112116e-21,
            "t4cof": 2.2731168875335664e-30,
            "t5cof": 1.2929036698846482e-39,
            "x1mth2": 0.883913755175712,
            "x7thm1": -0.18739628622998428,
            "mdot": 0.06089615483346039,
            "nodedot": -0.000025787370225365273,
            "xlcof": 0.0019286186689828923,
            "xmcof": -0.000003052664369314037,
            "nodecf": -1.0411747332321624e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.4492005806645665,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SECOR 3"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01244",
            "epochyr": 22,
            "epochdays": 53.41356298,
            "ndot": 2.72707695624114e-13,
            "nddot": 0,
            "bstar": 0.000044716,
            "inclo": 1.2231180131513661,
            "nodeo": 5.266232566590798,
            "ecco": 0.0021011,
            "argpo": 6.160701590933128,
            "mo": 0.12389394228206949,
            "no": 0.060923375940302595,
            "a": 1.1424775468943524,
            "alta": 0.1448780064681321,
            "altp": 0.14007708732057278,
            "jdsatepoch": 2459632.91356298,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010994730198154383,
            "con41": -0.6517379110498619,
            "cc1": 2.026742933034297e-11,
            "cc4": 2.1794801386072615e-8,
            "cc5": 0.000015100349732059335,
            "d2": 1.4442631236774833e-20,
            "d3": 1.5340222165437968e-29,
            "d4": 1.8982354012006876e-38,
            "delmo": 1.0559951377445316,
            "eta": 0.018468674163628816,
            "argpdot": -0.000015925659688999334,
            "omgcof": 2.8727257435120944e-10,
            "sinmao": 0.12357722946017267,
            "t": 242712.8952587396,
            "t2cof": 3.040114399551445e-11,
            "t3cof": 1.5264168620095727e-20,
            "t4cof": 1.2404124711458455e-29,
            "t5cof": 1.242199808559107e-38,
            "x1mth2": 0.8839126370166207,
            "x7thm1": -0.1873884591163446,
            "mdot": 0.06089867347326212,
            "nodedot": -0.000025789994761224626,
            "xlcof": 0.0019286184527986987,
            "xmcof": -0.000005066940871806784,
            "nodecf": -1.8329717979646895e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.256478136161988,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "GGSE 2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01271",
            "epochyr": 22,
            "epochdays": 53.40533134,
            "ndot": -3.93911115901498e-13,
            "nddot": 0,
            "bstar": 0.000028909,
            "inclo": 1.2230988145295942,
            "nodeo": 4.821077614223385,
            "ecco": 0.0021667,
            "argpo": 5.86444940369961,
            "mo": 3.4477129324140865,
            "no": 0.060944526911000545,
            "a": 1.1422133236987293,
            "alta": 0.14468815730718743,
            "altp": 0.1397384900902714,
            "jdsatepoch": 2459632.90533134,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001099465369947562,
            "con41": -0.6517010108736395,
            "cc1": 1.3212828614500147e-11,
            "cc4": 2.3111381058127133e-8,
            "cc5": 0.00001522258547791287,
            "d2": 6.149280163322306e-21,
            "d3": 4.265750105629546e-30,
            "d4": 3.447472302088383e-39,
            "delmo": 0.9464088578532112,
            "eta": 0.019079696786512005,
            "argpdot": -0.000015936254607389863,
            "omgcof": 1.6753463535358575e-10,
            "sinmao": -0.3013615610906773,
            "t": 242724.74882014096,
            "t2cof": 1.9819242921750218e-11,
            "t3cof": 6.4984378433146136e-21,
            "t4cof": 3.4488274346551966e-30,
            "t5cof": 2.255662695725059e-39,
            "x1mth2": 0.8839003369578798,
            "x7thm1": -0.18730235870515888,
            "mdot": 0.06091980582274342,
            "nodedot": -0.000025812252829763872,
            "xlcof": 0.0019286160740969833,
            "xmcof": -0.0000031000228959149037,
            "nodecf": -1.1959906761201689e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.204615610342827,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 4988 (GREB 6)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 1272",
            "epochyr": 22,
            "epochdays": 53.84055333,
            "ndot": -3.0300855069346e-14,
            "nddot": 0,
            "bstar": 0.000038285,
            "inclo": 1.22316513704117,
            "nodeo": 6.204362747501018,
            "ecco": 0.0021002,
            "argpo": 0.3836268602468576,
            "mo": 5.903050850765969,
            "no": 0.06086013149702797,
            "a": 1.143268516227291,
            "alta": 0.14566960876507173,
            "altp": 0.14086742368951044,
            "jdsatepoch": 2459633.34055333,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010994917950457235,
            "con41": -0.6518284770103441,
            "cc1": 1.6931749257195357e-11,
            "cc4": 2.115747542395721e-8,
            "cc5": 0.00001474796060473279,
            "d2": 1.0025756801663041e-20,
            "d3": 8.84820710262177e-30,
            "d4": 9.097520357756389e-39,
            "delmo": 1.0520301546084843,
            "eta": 0.01836175429490068,
            "argpdot": -0.00001589277740926321,
            "omgcof": 2.2279921120280986e-10,
            "sinmao": -0.3710453309761114,
            "t": 242098.02915506065,
            "t2cof": 2.5397623885793036e-11,
            "t3cof": 1.0599125067480112e-20,
            "t4cof": 7.157551287440525e-30,
            "t5cof": 5.956180587427534e-39,
            "x1mth2": 0.8839428256701147,
            "x7thm1": -0.187599779690803,
            "mdot": 0.06083548538481873,
            "nodedot": -0.000025724285022173794,
            "xlcof": 0.001928624286178985,
            "xmcof": -0.00000426063543815002,
            "nodecf": -1.5273900549154749e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.663497747134123,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "PORCUPINE 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 1291",
            "epochyr": 22,
            "epochdays": 53.84038263,
            "ndot": -4.84813681109536e-13,
            "nddot": 0,
            "bstar": 0.000027042,
            "inclo": 1.223158155724162,
            "nodeo": 6.012257847392506,
            "ecco": 0.001982,
            "argpo": 0.37541508611622426,
            "mo": 5.911143942507468,
            "no": 0.06087673971900584,
            "a": 1.1430606768570966,
            "alta": 0.1453262231186272,
            "altp": 0.1407951305955657,
            "jdsatepoch": 2459633.34038263,
            "isimp": 0,
            "method": "n",
            "aycof": 0.00109948901368419,
            "con41": -0.6518150604765891,
            "cc1": 1.2034281503185086e-11,
            "cc4": 1.9395832348718415e-8,
            "cc5": 0.00001483594068689864,
            "d2": 5.0718454331870395e-21,
            "d3": 3.185946963725227e-30,
            "d4": 2.331533302855188e-39,
            "delmo": 1.0492851228187141,
            "eta": 0.017352791003682498,
            "argpdot": -0.000015902046052886688,
            "omgcof": 1.6868501962360494e-10,
            "sinmao": -0.3635178972931142,
            "t": 242098.27496275306,
            "t2cof": 1.8051422254777628e-11,
            "t3cof": 5.361493295782845e-21,
            "t4cof": 2.5769253997388626e-30,
            "t5cof": 1.526275788789177e-39,
            "x1mth2": 0.8839383534921964,
            "x7thm1": -0.18756847444537472,
            "mdot": 0.06085207844001025,
            "nodedot": -0.000025741121943142697,
            "xlcof": 0.0019286234224453716,
            "xmcof": -0.000003395869901611974,
            "nodecf": -1.0863079360511698e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.6624222722322415,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SOLRAD 7B"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01292",
            "epochyr": 22,
            "epochdays": 53.56056613,
            "ndot": 1.21203420277384e-12,
            "nddot": 0,
            "bstar": 0.00006224,
            "inclo": 1.2230656532738062,
            "nodeo": 1.6800766272500176,
            "ecco": 0.0022649,
            "argpo": 4.219680787217439,
            "mo": 2.0614485221032988,
            "no": 0.061141512985445276,
            "a": 1.139759976148031,
            "alta": 0.14234141851800852,
            "altp": 0.13717853377805334,
            "jdsatepoch": 2459633.06056613,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001099452155584902,
            "con41": -0.6516372702062082,
            "cc1": 3.0737220290903356e-11,
            "cc4": 2.7139576440989024e-8,
            "cc5": 0.000016401278498188786,
            "d2": 3.384736893773669e-20,
            "d3": 5.556153607510603e-29,
            "d4": 1.0625968910174218e-37,
            "delmo": 0.9715976270312222,
            "eta": 0.020285456075852783,
            "argpdot": -0.000016052738395308803,
            "omgcof": -1.97192261287983e-10,
            "sinmao": 0.8820257309816224,
            "t": 242501.21072262526,
            "t2cof": 4.6105830436355034e-11,
            "t3cof": 3.5736922360159736e-20,
            "t4cof": 4.4864873686995156e-29,
            "t5cof": 6.942387098410474e-38,
            "x1mth2": 0.8838790900687361,
            "x7thm1": -0.18715363048115252,
            "mdot": 0.061116607521307285,
            "nodedot": -0.00002600953451876868,
            "xlcof": 0.0019286119625131122,
            "xmcof": -0.000006482273546040983,
            "nodecf": -2.8035390265803814e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.1826550334630355,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "GGSE 3"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 1293",
            "epochyr": 22,
            "epochdays": 53.84710079,
            "ndot": 1.1181015520588674e-11,
            "nddot": 0,
            "bstar": 0.00025508,
            "inclo": 1.2230028214207347,
            "nodeo": 3.8323014690787933,
            "ecco": 0.0015031,
            "argpo": 1.7893359837541145,
            "mo": 4.4987257733555435,
            "no": 0.06139812620029061,
            "a": 1.1365836800816111,
            "alta": 0.13829207901114193,
            "altp": 0.13487528115208058,
            "jdsatepoch": 2459633.34710079,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001099427114529506,
            "con41": -0.6515164845234884,
            "cc1": 1.3934976612088417e-10,
            "cc4": 1.4717804875543205e-8,
            "cc5": 0.000018070387331673064,
            "d2": 7.115066685062376e-19,
            "d3": 5.416278762157904e-27,
            "d4": 4.80376705868577e-35,
            "delmo": 0.9912669214359019,
            "eta": 0.013768745418586447,
            "argpdot": -0.000016202638169521315,
            "omgcof": -6.360303509170985e-10,
            "sinmao": -0.9772607225285975,
            "t": 242088.60081218183,
            "t2cof": 2.0902464918132627e-10,
            "t3cof": 7.503433831421279e-19,
            "t4cof": 4.366418794044578e-27,
            "t5cof": 3.1325538630456265e-35,
            "x1mth2": 0.8838388281744962,
            "x7thm1": -0.18687179722147318,
            "mdot": 0.06137298098559953,
            "nodedot": -0.000026269087148461816,
            "xlcof": 0.00192860416201023,
            "xmcof": -0.00006525581820562933,
            "nodecf": -1.2837086701549698e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.7047492882931223,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OSCAR 3"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01314",
            "epochyr": 22,
            "epochdays": 53.50655189,
            "ndot": 3.0300855069346e-13,
            "nddot": 0,
            "bstar": 0.00000936,
            "inclo": 1.5756204168474088,
            "nodeo": 5.772128467586119,
            "ecco": 0.0032027,
            "argpo": 1.385744302193694,
            "mo": 1.633781768840868,
            "no": 0.05639548576066134,
            "a": 1.2029635591699037,
            "alta": 0.20681629056085704,
            "altp": 0.19911082777895017,
            "jdsatepoch": 2459633.00655189,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694316718228474,
            "con41": -0.9999301850070729,
            "cc1": 8.995141712806041e-13,
            "cc4": 5.431853157701327e-9,
            "cc5": 0.000003458703105039033,
            "d2": 2.04532702388816e-23,
            "d3": 6.9147101018935745e-34,
            "d4": 2.721850459316455e-44,
            "delmo": 0.996182985064766,
            "eta": 0.020239650342584684,
            "argpdot": -0.000031592412463026134,
            "omgcof": 1.0691937308733339e-12,
            "sinmao": 0.9980170727253148,
            "t": 242578.99122811854,
            "t2cof": 1.3492712569209062e-12,
            "t3cof": 2.2071521727550862e-23,
            "t4cof": 5.75616827112178e-34,
            "t5cof": 1.8427137064971607e-44,
            "x1mth2": 0.999976728335691,
            "x7thm1": -0.9998370983498366,
            "mdot": 0.056363839843790065,
            "nodedot": 3.047148355650342e-7,
            "xlcof": 0.0017484787393772727,
            "xmcof": -1.3806192575318498e-7,
            "nodecf": 9.618997249469303e-19,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.842344359040382,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 4682 (SNAPSHOT)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01315",
            "epochyr": 22,
            "epochdays": 53.55793323,
            "ndot": -6.36317956456266e-13,
            "nddot": 0,
            "bstar": -0.00010398,
            "inclo": 1.5754476292514614,
            "nodeo": 5.936559427075008,
            "ecco": 0.0031126,
            "argpo": 6.244098658581173,
            "mo": 3.1195020212473006,
            "no": 0.05643272622820123,
            "a": 1.2024346674046447,
            "alta": 0.20617736555040822,
            "altp": 0.19869196925888089,
            "jdsatepoch": 2459633.05793323,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694326291448833,
            "con41": -0.9999350966244279,
            "cc1": -1.0105158893820975e-11,
            "cc4": 5.26844042176196e-9,
            "cc5": 0.0000034954135005521616,
            "d2": 2.5873260094462495e-21,
            "d3": -9.849737462657412e-31,
            "d4": 4.36595614023971e-40,
            "delmo": 0.942023139538058,
            "eta": 0.019716425523074003,
            "argpdot": -0.00003164127083570699,
            "omgcof": -6.734610016414443e-11,
            "sinmao": 0.022088835696156967,
            "t": 242505.00209882855,
            "t2cof": -1.5157738340731465e-11,
            "t3cof": 2.791554481984988e-21,
            "t4cof": -8.19746032463074e-31,
            "t5cof": 2.9549493324714234e-40,
            "x1mth2": 0.9999783655414759,
            "x7thm1": -0.9998485587903316,
            "mdot": 0.05640103141811699,
            "nodedot": 2.942525999335998e-7,
            "xlcof": 0.001748684160200397,
            "xmcof": 0.0000016381462098063123,
            "nodecf": -1.0435011347799125e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.166066740730841,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SECOR 4 (EGRS 4)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 1328",
            "epochyr": 22,
            "epochdays": 53.80963938,
            "ndot": -2.3937675504783338e-12,
            "nddot": 0,
            "bstar": 0.000010993,
            "inclo": 0.7187876724950848,
            "nodeo": 4.834617878560357,
            "ecco": 0.0257724,
            "argpo": 0.5582784678354261,
            "mo": 5.753036310898553,
            "no": 0.058386245574243496,
            "a": 1.174699137914164,
            "alta": 0.20497395397614282,
            "altp": 0.144424321852185,
            "jdsatepoch": 2459633.30963938,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0007700478524378467,
            "con41": 0.6992409011847701,
            "cc1": 2.477710758408001e-12,
            "cc4": 1.6722214406659382e-7,
            "cc5": 0.000007883954600294484,
            "d2": 1.7724451374593822e-22,
            "d3": 1.8872550790918635e-32,
            "d4": 2.3403507887250232e-42,
            "delmo": 1.5628662951232573,
            "eta": 0.18602292121242356,
            "argpdot": 0.00006306898642629514,
            "omgcof": 1.0699954134687754e-12,
            "sinmao": -0.5056618906377347,
            "t": 242142.54524298012,
            "t2cof": 3.716566137612001e-12,
            "t3cof": 1.8952261495059972e-22,
            "t4cof": 1.550992198822981e-32,
            "t5cof": 1.5607766895986046e-42,
            "x1mth2": 0.4335863662717433,
            "x7thm1": 2.964895436097797,
            "mdot": 0.05841030076755018,
            "nodedot": -0.00005185519431770787,
            "xlcof": 0.0014857462167517078,
            "xmcof": -4.092495467415634e-9,
            "nodecf": -4.485017235762441e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.4687278648135802,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "EXPLORER 27"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01420",
            "epochyr": 22,
            "epochdays": 53.61192285,
            "ndot": 1.878653014299452e-12,
            "nddot": 0,
            "bstar": 0.000080272,
            "inclo": 1.5693197782477095,
            "nodeo": 5.291459555599124,
            "ecco": 0.0072953,
            "argpo": 5.55025348642634,
            "mo": 1.7851821001343682,
            "no": 0.05900232058806549,
            "a": 1.1672917187474194,
            "alta": 0.17580746202319752,
            "altp": 0.15877597547164135,
            "jdsatepoch": 2459633.11192285,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694440045614983,
            "con41": -0.9999934594179166,
            "cc1": 1.8162661847609224e-11,
            "cc4": 4.386456691689177e-8,
            "cc5": 0.000007836246188923147,
            "d2": 9.959091273919881e-21,
            "d3": 8.130974439716018e-30,
            "d4": 7.732012950289497e-39,
            "delmo": 0.965267830548995,
            "eta": 0.05506097310181456,
            "argpdot": -0.00003510716303304602,
            "omgcof": 4.8054667679682455e-11,
            "sinmao": 0.9771072535829589,
            "t": 242427.25704610348,
            "t2cof": 2.7243992771413836e-11,
            "t3cof": 1.061885584470108e-20,
            "t4cof": 6.655860502137725e-30,
            "t5cof": 5.132698736858467e-39,
            "x1mth2": 0.9999978198059722,
            "x7thm1": -0.9999847386418055,
            "mdot": 0.058967152579099714,
            "nodedot": -1.0362946187162587e-7,
            "xlcof": 0.0017558902012050042,
            "xmcof": -4.385135147898994e-7,
            "nodecf": -6.6060960653334566e-18,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.22303699255385112,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 8480 (TRANSIT 5B-6)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 1430",
            "epochyr": 22,
            "epochdays": 53.81490283,
            "ndot": 2.27256413020095e-12,
            "nddot": 0,
            "bstar": 0.000036366,
            "inclo": 1.7166534923840626,
            "nodeo": 3.0362428346101633,
            "ecco": 0.0057333,
            "argpo": 2.3056340470913215,
            "mo": 3.9881698432573987,
            "no": 0.06288527454942379,
            "a": 1.1187409908493662,
            "alta": 0.1251550685722027,
            "altp": 0.11232691312652943,
            "jdsatepoch": 2459633.31490283,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001157027745039572,
            "con41": -0.9366283762474724,
            "cc1": 3.775729304199333e-11,
            "cc4": 2.0759724903773096e-7,
            "cc5": 0.00003403494830856859,
            "d2": 6.01269676334097e-20,
            "d3": 1.4286791561168993e-28,
            "d4": 3.955841434420936e-37,
            "delmo": 0.884590395179554,
            "eta": 0.06045222310065042,
            "argpdot": -0.00003644105700470064,
            "omgcof": -1.7342533243035905e-10,
            "sinmao": -0.7490170115627335,
            "t": 242134.96587485075,
            "t2cof": 5.6635939562989994e-11,
            "t3cof": 6.297819398912761e-20,
            "t4cof": 1.1409619955505311e-28,
            "t5cof": 2.551555264671375e-37,
            "x1mth2": 0.9788761254158241,
            "x7thm1": -0.852132877910769,
            "mdot": 0.06284705502420256,
            "nodedot": 0.000011834966351977758,
            "xlcof": 0.0015387813235220927,
            "xmcof": -0.0000010395013090581915,
            "nodecf": 1.5684944142701364e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.5018896431148718,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TIROS 10"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01506",
            "epochyr": 22,
            "epochdays": 53.57605197,
            "ndot": -6.0601710138692e-14,
            "nddot": 0,
            "bstar": 0.0002208,
            "inclo": 1.2083455463624861,
            "nodeo": 1.9284439611258186,
            "ecco": 0.0786147,
            "argpo": 5.835677650980484,
            "mo": 2.277153764357278,
            "no": 0.05144426733638588,
            "a": 1.2787490474417536,
            "alta": 0.3792775201816727,
            "altp": 0.1782205747018344,
            "jdsatepoch": 2459633.07605197,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010934671997022162,
            "con41": -0.6228470452284457,
            "cc1": 1.2346085754935608e-11,
            "cc4": 6.996534045373432e-8,
            "cc5": 0.000002406218644225611,
            "d2": 2.927641420363563e-21,
            "d3": 1.0293041282117012e-30,
            "d4": 4.210689271115135e-40,
            "delmo": 0.4303432444421547,
            "eta": 0.37748793418511256,
            "argpdot": -0.000009622501189884984,
            "omgcof": 8.006101251273009e-13,
            "sinmao": 0.7607311848837027,
            "t": 242478.91111314297,
            "t2cof": 1.851912863240341e-11,
            "t3cof": 3.232493087300011e-21,
            "t4cof": 8.851174882934716e-31,
            "t5cof": 2.9617275229962382e-40,
            "x1mth2": 0.8742823484094819,
            "x7thm1": -0.11997643886637332,
            "mdot": 0.05142820710698476,
            "nodedot": -0.000018321165657971074,
            "xlcof": 0.001926423086119379,
            "xmcof": -1.855838722562447e-9,
            "nodecf": -7.8796378360126905e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.280221834979258,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SECOR 5 (EGRS 5)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01510",
            "epochyr": 22,
            "epochdays": 53.55894276,
            "ndot": 7.27220521664304e-11,
            "nddot": 0,
            "bstar": 0.0017328,
            "inclo": 1.5714403532888825,
            "nodeo": 0.29230599779475835,
            "ecco": 0.0041006,
            "argpo": 2.0653912208835536,
            "mo": 4.227082728575146,
            "no": 0.06094988672042278,
            "a": 1.1423113272348207,
            "alta": 0.14699548906327964,
            "altp": 0.13762716540636144,
            "jdsatepoch": 2459633.05894276,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001169445036845526,
            "con41": -0.9999987556897972,
            "cc1": 7.914873216963864e-10,
            "cc4": 4.8757872014972285e-8,
            "cc5": 0.000015347396353568764,
            "d2": 2.2075950145038513e-17,
            "d3": 9.17780361010454e-25,
            "d4": 4.4452137942125913e-32,
            "delmo": 0.9502912070225327,
            "eta": 0.03612591830475362,
            "argpdot": -0.000037864368159102625,
            "omgcof": -2.940138410755049e-9,
            "sinmao": -0.8845321304701477,
            "t": 242503.54837574065,
            "t2cof": 1.1872309825445797e-9,
            "t3cof": 2.332885450585075e-17,
            "t4cof": 7.419933471165402e-25,
            "t5cof": 2.9083641992283504e-32,
            "x1mth2": 0.9999995852299324,
            "x7thm1": -0.9999970966095267,
            "mdot": 0.06091195322636668,
            "nodedot": 4.874857188621202e-8,
            "xlcof": 0.0017534139163699809,
            "xmcof": -0.00005196145207255457,
            "nodecf": 1.3544362195692185e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.17242717104493,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "DODECAPOLE 2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01512",
            "epochyr": 22,
            "epochdays": 53.50623625,
            "ndot": 8.18123086872342e-13,
            "nddot": 0,
            "bstar": 0.000036381,
            "inclo": 1.5691260467007382,
            "nodeo": 3.833299797410934,
            "ecco": 0.0069715,
            "argpo": 6.193121081788923,
            "mo": 1.1615654864212823,
            "no": 0.058216607009620745,
            "a": 1.1777627586497663,
            "alta": 0.18597353172169306,
            "altp": 0.16955198557783935,
            "jdsatepoch": 2459633.00623625,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694436480913471,
            "con41": -0.9999916305010043,
            "cc1": 6.294079994215484e-12,
            "cc4": 3.0180073677131674e-8,
            "cc5": 0.000006060672630539172,
            "d2": 1.130145199084553e-21,
            "d3": 3.0201689906055905e-31,
            "d4": 9.399640385596267e-41,
            "delmo": 1.0605339563548308,
            "eta": 0.04972055506656658,
            "argpdot": -0.00003402700800565116,
            "omgcof": 2.1711985831422773e-11,
            "sinmao": 0.9174271457008402,
            "t": 242579.44574989378,
            "t2cof": 9.441119991323226e-12,
            "t3cof": 1.2093760850317202e-21,
            "t4cof": 2.484757040774746e-31,
            "t5cof": 6.276605593837839e-41,
            "x1mth2": 0.9999972101670015,
            "x7thm1": -0.9999804711690101,
            "mdot": 0.05818252196902904,
            "nodedot": -1.136207322227238e-7,
            "xlcof": 0.0017561155125632453,
            "xmcof": -1.7718564560959e-7,
            "nodecf": -2.5098746390205977e-18,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.840355703785846,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TEMPSAT 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 1514",
            "epochyr": 22,
            "epochdays": 53.7567648,
            "ndot": 1.848352159230106e-12,
            "nddot": 0,
            "bstar": 0.00010224,
            "inclo": 1.568831086057151,
            "nodeo": 4.12753787468765,
            "ecco": 0.0068395,
            "argpo": 4.8529159104382655,
            "mo": 1.6076419726337488,
            "no": 0.058284675139314214,
            "a": 1.1768463209555033,
            "alta": 0.1848953613676787,
            "altp": 0.1687972805433282,
            "jdsatepoch": 2459633.2567648,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001169443021072813,
            "con41": -0.9999884135014445,
            "cc1": 1.8084431987209002e-11,
            "cc4": 3.0308779812514544e-8,
            "cc5": 0.000006189498810984471,
            "d2": 9.374753700002264e-21,
            "d3": 7.23312827688881e-30,
            "d4": 6.499490308492428e-39,
            "delmo": 0.9945932127934356,
            "eta": 0.0490133609308859,
            "argpdot": -0.000034119480349213046,
            "omgcof": 9.00412473292914e-12,
            "sinmao": 0.9993212759829734,
            "t": 242218.6846382171,
            "t2cof": 2.7126647980813505e-11,
            "t3cof": 1.002884706060224e-20,
            "t4cof": 5.948243628336507e-30,
            "t5cof": 4.3378110037764546e-39,
            "x1mth2": 0.9999961378338148,
            "x7thm1": -0.9999729648367037,
            "mdot": 0.058250497273070044,
            "nodedot": -1.340493243656109e-7,
            "xlcof": 0.0017564582594708068,
            "xmcof": -5.264692210477347e-7,
            "nodecf": -8.508134978722494e-18,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.135597490073586,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 8464 (TRANSIT 5B-7)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01515",
            "epochyr": 22,
            "epochdays": 53.43511465,
            "ndot": 9.120557375873147e-12,
            "nddot": 0,
            "bstar": 0.00046167,
            "inclo": 1.5696321921838163,
            "nodeo": 3.7985904345765227,
            "ecco": 0.0056795,
            "argpo": 3.1981483026714175,
            "mo": 4.020800518952685,
            "no": 0.05889564160203533,
            "a": 1.1686997231988918,
            "alta": 0.1753373532767999,
            "altp": 0.16206209312098374,
            "jdsatepoch": 2459632.93511465,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694444869494761,
            "con41": -0.9999959343736585,
            "cc1": 1.0002226526392861e-10,
            "cc4": 3.079201377416008e-8,
            "cc5": 0.000007505540204333662,
            "d2": 2.996670783111143e-19,
            "d3": 1.336714393148565e-27,
            "d4": 6.944793666746193e-36,
            "delmo": 0.9208151221990255,
            "eta": 0.04253003832274382,
            "argpdot": -0.000034958116028328275,
            "omgcof": -4.5493082580648476e-10,
            "sinmao": -0.7702339276508023,
            "t": 242681.86085388064,
            "t2cof": 1.5003339789589292e-10,
            "t3cof": 3.196759854081697e-19,
            "t4cof": 1.0949576051211547e-27,
            "t5cof": 4.6138078127709534e-36,
            "x1mth2": 0.9999986447912195,
            "x7thm1": -0.9999905135385364,
            "mdot": 0.058860622739428325,
            "nodedot": -8.135603000897194e-8,
            "xlcof": 0.0017555265379211003,
            "xmcof": -0.000004044600760888453,
            "nodecf": -2.856108153512885e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.39226202160755,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "NAVSPASUR ROD 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01520",
            "epochyr": 22,
            "epochdays": 53.53714337,
            "ndot": 2.060458144715528e-12,
            "nddot": 0,
            "bstar": 0.00011396,
            "inclo": 1.5708294880506846,
            "nodeo": 2.2726961934476844,
            "ecco": 0.0068507,
            "argpo": 3.9442311793384413,
            "mo": 4.225784203611663,
            "no": 0.0583225819899168,
            "a": 1.1763367408079102,
            "alta": 0.184395470918163,
            "altp": 0.16827801069765735,
            "jdsatepoch": 2459633.03714337,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694452787279989,
            "con41": -0.9999999967009934,
            "cc1": 2.041528683630978e-11,
            "cc4": 3.0824730092605e-8,
            "cc5": 0.000006265115414782363,
            "d2": 1.1979084758915787e-20,
            "d3": 1.04619386036643e-29,
            "d4": 1.0641176939244248e-38,
            "delmo": 0.9325202466930824,
            "eta": 0.04922521524319886,
            "argpdot": -0.00003417187818613119,
            "omgcof": -5.0516985376135996e-11,
            "sinmao": -0.8839256499278081,
            "t": 242534.93949696422,
            "t2cof": 3.062293025446467e-11,
            "t3cof": 1.2812652632133394e-20,
            "t4cof": 8.601395215954011e-30,
            "t5cof": 7.099981942604696e-39,
            "x1mth2": 0.9999999989003311,
            "x7thm1": -0.9999999923023178,
            "mdot": 0.058288351849682514,
            "nodedot": 2.2653641627974674e-9,
            "xlcof": 0.0017541291365319423,
            "xmcof": -5.906415463757271e-7,
            "nodecf": 1.6231527290345228e-19,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.035082555365463,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "CALSPHERE 4(A)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01570",
            "epochyr": 22,
            "epochdays": 53.42817994,
            "ndot": -3.090687217073292e-12,
            "nddot": 0,
            "bstar": -0.000037058,
            "inclo": 0.9783600201686894,
            "nodeo": 1.150245280892847,
            "ecco": 0.0101339,
            "argpo": 6.053114259852442,
            "mo": 2.8414605994290922,
            "no": 0.05466419439298139,
            "a": 1.2278002410342417,
            "alta": 0.2402426458968585,
            "altp": 0.21535783617162485,
            "jdsatepoch": 2459632.92817994,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009701516288868506,
            "con41": -0.0646226090003229,
            "cc1": -2.2064586646141956e-12,
            "cc4": 1.4180088267015492e-8,
            "cc5": 0.0000021873630354952177,
            "d2": 1.1092676894260675e-22,
            "d3": -8.283458114116098e-33,
            "d4": 7.200538179312874e-43,
            "delmo": 0.8435223017825212,
            "eta": 0.057724661445443436,
            "argpdot": 0.00001641206106468757,
            "omgcof": -3.0525893950082127e-12,
            "sinmao": 0.29564636024254626,
            "t": 242691.8468360603,
            "t2cof": -3.3096879969212934e-12,
            "t3cof": 1.2066368861990887e-22,
            "t4cof": -6.973714715486082e-33,
            "t5cof": 4.9397440829106486e-43,
            "x1mth2": 0.688207536333441,
            "x7thm1": 1.1825472456659134,
            "mdot": 0.05466229394080266,
            "nodedot": -0.00003288455651221153,
            "xlcof": 0.00180284203650127,
            "xmcof": 3.6791125739001775e-8,
            "nodecf": 2.5396872789040736e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.348570658218179,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 80"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 1571",
            "epochyr": 22,
            "epochdays": 53.68714169,
            "ndot": -2.87858123158787e-12,
            "nddot": 0,
            "bstar": 0.0000044863,
            "inclo": 0.9784211066925091,
            "nodeo": 2.1660600668093344,
            "ecco": 0.0090071,
            "argpo": 2.254082256975165,
            "mo": 0.6361550590594132,
            "no": 0.054492711420937145,
            "a": 1.2303746872740047,
            "alta": 0.24145679511975038,
            "altp": 0.21929257942825897,
            "jdsatepoch": 2459633.18714169,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009701915165336829,
            "con41": -0.06479238582279445,
            "cc1": 2.533816327951976e-13,
            "cc4": 1.1851448006373826e-8,
            "cc5": 0.0000020798417070628,
            "d2": 1.4485992509441768e-24,
            "d3": 1.2300254517524697e-35,
            "d4": 1.2157597453573572e-46,
            "delmo": 1.127684094673461,
            "eta": 0.05080693410143249,
            "argpdot": 0.000016283410180773495,
            "omgcof": -2.5328001073239547e-13,
            "sinmao": 0.5941070238082912,
            "t": 242318.94191645086,
            "t2cof": 3.8007244919279634e-13,
            "t3cof": 1.5770037546200975e-24,
            "t4cof": 1.0367005397053507e-35,
            "t5cof": 8.351407883646883e-47,
            "x1mth2": 0.6882641286075981,
            "x7thm1": 1.1821510997468128,
            "mdot": 0.0544908199367395,
            "nodedot": -0.000032639990638733605,
            "xlcof": 0.0018028959142096707,
            "xmcof": -5.429421837066721e-9,
            "nodecf": -2.8948554309969723e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.696944877142549,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 81"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01572",
            "epochyr": 22,
            "epochdays": 53.59885359,
            "ndot": -2.3331658403396422e-12,
            "nddot": 0,
            "bstar": 0.00011414,
            "inclo": 0.9784158707047532,
            "nodeo": 2.632769835438878,
            "ecco": 0.0073814,
            "argpo": 5.517963149935192,
            "mo": 2.4954787458185006,
            "no": 0.0543293909125136,
            "a": 1.232839098789908,
            "alta": 0.24193917731371606,
            "altp": 0.22373902026610026,
            "jdsatepoch": 2459633.09885359,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009701880977343817,
            "con41": -0.06477783385401759,
            "cc1": 6.126356830587698e-12,
            "cc4": 9.148477095565384e-9,
            "cc5": 0.000001980743142478384,
            "d2": 8.390582317241757e-22,
            "d3": 1.7066110512833033e-31,
            "d4": 4.0405003266925556e-41,
            "delmo": 0.9044037934602429,
            "eta": 0.04125401993680187,
            "argpdot": 0.000016169804534223195,
            "omgcof": 8.466430169797251e-12,
            "sinmao": 0.6020881887897769,
            "t": 242446.07678040862,
            "t2cof": 9.189535245881548e-12,
            "t3cof": 9.141227277555528e-22,
            "t4cof": 1.4399177909379603e-31,
            "t5cof": 2.779027486354827e-41,
            "x1mth2": 0.6882592779513392,
            "x7thm1": 1.1821850543406258,
            "mdot": 0.05432751311655342,
            "nodedot": -0.00003241073393604691,
            "xlcof": 0.0018028912965334326,
            "xmcof": -1.98466860887061e-7,
            "nodecf": -6.950309670006459e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.14069558279984307,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 82"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01573",
            "epochyr": 22,
            "epochdays": 53.5924805,
            "ndot": -2.57557268089441e-12,
            "nddot": 0,
            "bstar": 0.000058474,
            "inclo": 0.9782936976571136,
            "nodeo": 3.5824907479115926,
            "ecco": 0.0069494,
            "argpo": 2.5102285233271044,
            "mo": 3.7827847328704616,
            "no": 0.05415151485222373,
            "a": 1.2355370900910005,
            "alta": 0.24412333154487897,
            "altp": 0.22695084863712212,
            "jdsatepoch": 2459633.0924805,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009701083181999333,
            "con41": -0.06443827033664296,
            "cc1": 2.982560779073787e-12,
            "cc4": 8.106480417479325e-9,
            "cc5": 0.0000018880366416205884,
            "d2": 1.9689534655044637e-22,
            "d3": 1.9301476786867953e-32,
            "d4": 2.202384806488695e-42,
            "delmo": 0.910369978412709,
            "eta": 0.03845423407580015,
            "argpdot": 0.000016062870854910397,
            "omgcof": -4.83589261774828e-12,
            "sinmao": -0.5981511785468786,
            "t": 242455.25402963161,
            "t2cof": 4.473841168610681e-12,
            "t3cof": 2.1468668415218486e-22,
            "t4cof": 1.6304194286934228e-32,
            "t5cof": 1.516861496745914e-42,
            "x1mth2": 0.6881460901122143,
            "x7thm1": 1.1829773692144996,
            "mdot": 0.054149661159033885,
            "nodedot": -0.000032169165718759946,
            "xlcof": 0.0018027835287684588,
            "xmcof": -1.1035850971948464e-7,
            "nodecf": -3.358490423358266e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.1005426440616688,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 83"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01574",
            "epochyr": 22,
            "epochdays": 53.47373271,
            "ndot": -2.757377811310486e-12,
            "nddot": 0,
            "bstar": 0.0000096108,
            "inclo": 0.9782779896938457,
            "nodeo": 4.486981452818874,
            "ecco": 0.0062414,
            "argpo": 5.61161926292646,
            "mo": 1.8870063540249693,
            "no": 0.053976585775183945,
            "a": 1.2382049549062073,
            "alta": 0.2459330873117589,
            "altp": 0.2304768225006557,
            "jdsatepoch": 2459632.97373271,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009700980597806487,
            "con41": -0.06439460972474209,
            "cc1": 4.66148499806654e-13,
            "cc4": 6.855907851370516e-9,
            "cc5": 0.0000018005923033684133,
            "d2": 4.763033614740508e-24,
            "d3": 7.226182276312003e-35,
            "d4": 1.2760607209473156e-45,
            "delmo": 0.9684306957634088,
            "eta": 0.034202440027354154,
            "argpdot": 0.00001594404773480604,
            "omgcof": 8.061576242459344e-13,
            "sinmao": 0.9504207965772936,
            "t": 242626.25084772706,
            "t2cof": 6.99222749709981e-13,
            "t3cof": 5.197622462484497e-24,
            "t4cof": 6.111043866872059e-35,
            "t5cof": 8.800551307560671e-46,
            "x1mth2": 0.688131536574914,
            "x7thm1": 1.1830792439756022,
            "mdot": 0.05397474728734657,
            "nodedot": -0.00003192738588778814,
            "xlcof": 0.001802769669853962,
            "xmcof": -2.165312602577764e-8,
            "nodecf": -5.2096240074592996e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.635570786155242,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 84"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01577",
            "epochyr": 22,
            "epochdays": 53.43897473,
            "ndot": 2.27256413020095e-12,
            "nddot": 0,
            "bstar": 0.00012751,
            "inclo": 1.5697927624749999,
            "nodeo": 3.735175641534561,
            "ecco": 0.0068803,
            "argpo": 3.9705559804462722,
            "mo": 2.76585468156195,
            "no": 0.05832131751964589,
            "a": 1.1763537291977688,
            "alta": 0.18444739576076818,
            "altp": 0.16826006263476945,
            "jdsatepoch": 2459632.93897473,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694446904727041,
            "con41": -0.9999969785769818,
            "cc1": 2.2835681821308797e-11,
            "cc4": 3.0971546044223413e-8,
            "cc5": 0.00000626345354633348,
            "d2": 1.498655480897521e-20,
            "d3": 1.4638942486536955e-29,
            "d4": 1.665353752128328e-38,
            "delmo": 0.8682920029511372,
            "eta": 0.0494334844270316,
            "argpdot": -0.000034170008305392805,
            "omgcof": -5.469784917393486e-11,
            "sinmao": 0.36695911788388286,
            "t": 242676.30233846605,
            "t2cof": 3.4253522731963195e-11,
            "t3cof": 1.6029491537463318e-20,
            "t4cof": 1.2035661670663194e-29,
            "t5cof": 1.1111641134692128e-38,
            "x1mth2": 0.999998992858994,
            "x7thm1": -0.9999929500129576,
            "mdot": 0.05828708919278463,
            "nodedot": -6.855365544984958e-8,
            "xlcof": 0.0017553394718626144,
            "xmcof": -6.549819944992143e-7,
            "nodecf": -5.494273321971506e-18,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.416582024631154,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "PORCUPINE 2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01580",
            "epochyr": 22,
            "epochdays": 53.54930182,
            "ndot": 1.999856434576836e-12,
            "nddot": 0,
            "bstar": 0.000034348,
            "inclo": 1.71632711581394,
            "nodeo": 4.438333890578036,
            "ecco": 0.0234868,
            "argpo": 0.37710631016140683,
            "mo": 5.925097849877162,
            "no": 0.062331289903182464,
            "a": 1.1253550779048178,
            "alta": 0.1517860675485525,
            "altp": 0.0989240882610829,
            "jdsatepoch": 2459633.04930182,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011570831569273129,
            "con41": -0.9369096625332615,
            "cc1": 3.681955587412435e-11,
            "cc4": 9.207582612167958e-7,
            "cc5": 0.00003730095966658769,
            "d2": 5.413840429459494e-20,
            "d3": 1.1874085243788206e-28,
            "d4": 3.0346181755598346e-37,
            "delmo": 1.8141067128240183,
            "eta": 0.23448346222448094,
            "argpdot": -0.000035752946989771565,
            "omgcof": 4.0611873572379623e-11,
            "sinmao": -0.35048364745289945,
            "t": 242517.43132933974,
            "t2cof": 5.522933381118653e-11,
            "t3cof": 5.684976368413046e-20,
            "t4cof": 9.516048414466614e-29,
            "t5cof": 1.96532895413935e-37,
            "x1mth2": 0.9789698875110872,
            "x7thm1": -0.8527892125776101,
            "mdot": 0.06229381072360067,
            "nodedot": 0.000011579725241898975,
            "xlcof": 0.001539366355589236,
            "xmcof": -4.850508625887613e-8,
            "nodecf": 1.4957306611453336e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.111685507410968,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 8068"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01584",
            "epochyr": 22,
            "epochdays": 53.55549549,
            "ndot": -2.787678666379832e-12,
            "nddot": 0,
            "bstar": 0.000019275,
            "inclo": 0.9784071440584932,
            "nodeo": 1.5834412372255957,
            "ecco": 0.021133,
            "argpo": 5.422699588702837,
            "mo": 3.6082779876098092,
            "no": 0.054625482018241904,
            "a": 1.228380302208205,
            "alta": 0.25433966313477097,
            "altp": 0.2024209412816389,
            "jdsatepoch": 2459633.05549549,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009701823996764389,
            "con41": -0.06475358043508928,
            "cc1": 1.2091447580775923e-12,
            "cc4": 3.0586372049531594e-8,
            "cc5": 0.000002330708173393352,
            "d2": 3.3238346290094375e-23,
            "d3": 1.357143540608713e-33,
            "d4": 6.450417607630632e-44,
            "delmo": 0.7114829820873525,
            "eta": 0.12011132972805579,
            "argpdot": 0.00001638981781491498,
            "omgcof": 5.027566269223265e-13,
            "sinmao": -0.44992855178599234,
            "t": 242508.51244457066,
            "t2cof": 1.8137171371163886e-12,
            "t3cof": 3.616240838206741e-23,
            "t4cof": 1.1428470899465442e-33,
            "t5cof": 4.42645956076087e-44,
            "x1mth2": 0.688251193478363,
            "x7thm1": 1.1822416456514584,
            "mdot": 0.05462357987192888,
            "nodedot": -0.000032850527937685294,
            "xlcof": 0.0018028836002342613,
            "xmcof": -4.362948451159179e-9,
            "nodecf": -1.3898369065387045e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.150708032041095,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 86"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 1585",
            "epochyr": 22,
            "epochdays": 53.81663904,
            "ndot": -2.666475246102448e-12,
            "nddot": 0,
            "bstar": 0.000048234,
            "inclo": 0.9784141253755012,
            "nodeo": 3.4504862605955053,
            "ecco": 0.0204843,
            "argpo": 1.2778829544204442,
            "mo": 1.2976854601135719,
            "no": 0.054431375625245484,
            "a": 1.2312987723634734,
            "alta": 0.2565210658061985,
            "altp": 0.20607647892074832,
            "jdsatepoch": 2459633.31663904,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009701869581287038,
            "con41": -0.06477298318399483,
            "cc1": 2.845654553115072e-12,
            "cc4": 2.7645278865423448e-8,
            "cc5": 0.0000021972781648936868,
            "d2": 1.820758412451949e-22,
            "d3": 1.7302152747006284e-32,
            "d4": 1.913868725986754e-42,
            "delmo": 1.0960982450444439,
            "eta": 0.11514606620694864,
            "argpdot": 0.00001625266164682127,
            "omgcof": 5.355532232382551e-13,
            "sinmao": 0.9629364683264026,
            "t": 242132.46573217213,
            "t2cof": 4.268481829672608e-12,
            "t3cof": 1.9827134091652397e-22,
            "t4cof": 1.4588597896934263e-32,
            "t5cof": 1.3153125976722668e-42,
            "x1mth2": 0.6882576610613316,
            "x7thm1": 1.1821963725706786,
            "mdot": 0.05442948871063088,
            "nodedot": -0.000032576725650816875,
            "xlcof": 0.001802889757290809,
            "xmcof": -1.1135555860772568e-8,
            "nodecf": -3.243726416904668e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.5128284411631725,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 87"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01586",
            "epochyr": 22,
            "epochdays": 53.60050543,
            "ndot": -2.72707695624114e-12,
            "nddot": 0,
            "bstar": 0.000017549,
            "inclo": 0.9784123800462492,
            "nodeo": 4.611369323279257,
            "ecco": 0.0186214,
            "argpo": 4.004406641288702,
            "mo": 2.5237740236518325,
            "no": 0.054251852567923614,
            "a": 1.234013446481745,
            "alta": 0.2569925044740602,
            "altp": 0.21103438848942968,
            "jdsatepoch": 2459633.10050543,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009701858185200706,
            "con41": -0.06476813250709057,
            "cc1": 9.70514798824997e-13,
            "cc4": 2.3423457915702773e-8,
            "cc5": 0.0000020615796656382543,
            "d2": 2.0965215193525732e-23,
            "d3": 6.7255852398253475e-34,
            "d4": 2.5113912531165323e-44,
            "delmo": 0.7674030237454522,
            "eta": 0.10362089477621003,
            "argpdot": 0.000016125966121245436,
            "omgcof": -4.524100387538399e-13,
            "sinmao": 0.5792584094546381,
            "t": 242443.69813106954,
            "t2cof": 1.4557721982374954e-12,
            "t3cof": 2.2849013143002382e-23,
            "t4cof": 5.677453650394573e-34,
            "t5cof": 1.728348722708602e-44,
            "x1mth2": 0.6882560441690302,
            "x7thm1": 1.1822076908167887,
            "mdot": 0.05424998047586806,
            "nodedot": -0.000032321972252985875,
            "xlcof": 0.0018028882180395802,
            "xmcof": -4.7143705994728294e-9,
            "nodecf": -1.0977057953937535e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.15110281473712206,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 88"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01587",
            "epochyr": 22,
            "epochdays": 53.56368059,
            "ndot": -2.363466695408988e-12,
            "nddot": 0,
            "bstar": 0.00010897,
            "inclo": 0.9784263426802652,
            "nodeo": 6.152706237629742,
            "ecco": 0.0170134,
            "argpo": 0.49126829653435594,
            "mo": 5.80932317927537,
            "no": 0.05406174355770418,
            "a": 1.2369045875027362,
            "alta": 0.25794854001175516,
            "altp": 0.21586063499371733,
            "jdsatepoch": 2459633.06368059,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009701949353063859,
            "con41": -0.06480693772963575,
            "cc1": 5.652159418533805e-12,
            "cc4": 1.9929250348353155e-8,
            "cc5": 0.0000019367018876299793,
            "d2": 7.035816949747948e-22,
            "d3": 1.3004735506914582e-31,
            "d4": 2.797890741854736e-41,
            "delmo": 1.271477317330058,
            "eta": 0.09367352173804663,
            "argpdot": 0.000015990959951539036,
            "omgcof": 3.893878204447783e-12,
            "sinmao": -0.45632624995428783,
            "t": 242496.7259001732,
            "t2cof": 8.478239127800707e-12,
            "t3cof": 7.674755071598356e-22,
            "t4cof": 1.099172065291483e-31,
            "t5cof": 1.9283418576128812e-41,
            "x1mth2": 0.688268979243212,
            "x7thm1": 1.1821171452975165,
            "mdot": 0.054059885770362005,
            "nodedot": -0.00003205399145579181,
            "xlcof": 0.0018029005318084604,
            "xmcof": -3.36532885569636e-8,
            "nodecf": -6.340260028592574e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.202277340406383,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 89"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01588",
            "epochyr": 22,
            "epochdays": 53.43402809,
            "ndot": -3.1209880721426384e-12,
            "nddot": 0,
            "bstar": -0.000091486,
            "inclo": 0.9783582748394374,
            "nodeo": 1.482929470932494,
            "ecco": 0.0158239,
            "argpo": 3.017059920801494,
            "mo": 5.277311916682459,
            "no": 0.05387000876175059,
            "a": 1.239837567872266,
            "alta": 0.2594566335625199,
            "altp": 0.220218502182012,
            "jdsatepoch": 2459632.93402809,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000970150489186603,
            "con41": -0.06461775811011872,
            "cc1": -4.4658905161890825e-12,
            "cc4": 1.730418392483531e-8,
            "cc5": 0.0000018267658859221242,
            "d2": 4.346070987510771e-22,
            "d3": -6.279502388529278e-32,
            "d4": 1.0560499257413377e-41,
            "delmo": 1.144938073494068,
            "eta": 0.08620534817921265,
            "argpdot": 0.00001586691192091151,
            "omgcof": 3.693699573447957e-12,
            "sinmao": -0.8446298590403999,
            "t": 242683.4255003929,
            "t2cof": -6.698835774283624e-12,
            "t3cof": 4.744954549562523e-22,
            "t4cof": -5.314166236531608e-32,
            "t5cof": 7.289205833722895e-42,
            "x1mth2": 0.6882059193700396,
            "x7thm1": 1.1825585644097232,
            "mdot": 0.053868171793805215,
            "nodedot": -0.00003179012974787003,
            "xlcof": 0.0018028404969832803,
            "xmcof": 3.134011080837497e-8,
            "nodecf": 4.96852357862951e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.3854162714164175,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 90"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01613",
            "epochyr": 22,
            "epochdays": 53.52506585,
            "ndot": 1.184460424660735e-10,
            "nddot": 0,
            "bstar": 0.00038936,
            "inclo": 2.517412298528313,
            "nodeo": 0.09304350242381772,
            "ecco": 0.1218318,
            "argpo": 0.8740050388626964,
            "mo": 5.586580769477349,
            "no": 0.05583780740297854,
            "a": 1.2100608439074976,
            "alta": 0.3574847346302672,
            "altp": 0.06263695318472795,
            "jdsatepoch": 2459633.02506585,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0006834616816568813,
            "con41": 0.9753163983503369,
            "cc1": 1.2485288562604946e-9,
            "cc4": 0.000005266249981970595,
            "cc5": 0.0001373096591529391,
            "d2": 3.806713854131202e-17,
            "d3": 1.7251347861867272e-24,
            "d4": 9.102120431908291e-32,
            "delmo": 3.8736664913901993,
            "eta": 0.7437958201437419,
            "argpdot": 0.00007324387790646836,
            "omgcof": 1.9209510839457625e-12,
            "sinmao": -0.6416169857750328,
            "t": 242552.33112595975,
            "t2cof": 1.872793284390742e-9,
            "t3cof": 4.1184787151142294e-17,
            "t4cof": 1.4413004452886446e-24,
            "t5cof": 6.188429406740225e-32,
            "x1mth2": 0.3415612005498877,
            "x7thm1": 3.6090715961507858,
            "mdot": 0.05586870094851914,
            "nodedot": 0.00005187649020781356,
            "xlcof": -0.001916029981187565,
            "xmcof": -3.4847393250014177e-9,
            "nodecf": 2.2273261713546353e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.958989491231861,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OV1-2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01641",
            "epochyr": 22,
            "epochdays": 53.3186128,
            "ndot": 4.302721419847132e-12,
            "nddot": 0,
            "bstar": 0.000026007,
            "inclo": 0.5637064418091285,
            "nodeo": 0.7477845726877186,
            "ecco": 0.0019357,
            "argpo": 4.930286356179174,
            "mo": 1.350244305208129,
            "no": 0.06336504432273393,
            "a": 1.1120791795212286,
            "alta": 0.1142318311890278,
            "altp": 0.10992652785342938,
            "jdsatepoch": 2459632.8186128,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0006248613274124268,
            "con41": 1.1434972955873683,
            "cc1": 3.5135960449470346e-11,
            "cc4": 2.015919449900787e-7,
            "cc5": 0.00004129051507275741,
            "d2": 5.47209918864833e-20,
            "d3": 1.2719339482243746e-28,
            "d4": 3.445397791095634e-37,
            "delmo": 1.0141439395794503,
            "eta": 0.02145005255036844,
            "argpdot": 0.00010727655060746889,
            "omgcof": 8.47545983857441e-11,
            "sinmao": 0.9757768331823576,
            "t": 242849.6235179901,
            "t2cof": 5.270394067420552e-11,
            "t3cof": 5.719006331989678e-20,
            "t4cof": 1.0127151143215506e-28,
            "t5cof": 2.214527831741152e-37,
            "x1mth2": 0.28550090147087726,
            "x7thm1": 4.001493689703859,
            "mdot": 0.06341263116495047,
            "nodedot": -0.00007051448865467911,
            "xlcof": 0.0012235265718384598,
            "xmcof": -0.000007725083567141996,
            "nodecf": -8.640466349221173e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.658255151869909,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OV2-1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01726",
            "epochyr": 22,
            "epochdays": 53.50335098,
            "ndot": -2.848280376518524e-12,
            "nddot": 0,
            "bstar": -0.00013241,
            "inclo": 1.0365126455158884,
            "nodeo": 5.777516298987026,
            "ecco": 0.0711889,
            "argpo": 4.725997312562489,
            "mo": 4.7039293695002735,
            "no": 0.052237223585517266,
            "a": 1.2656075425252653,
            "alta": 0.3557047513093423,
            "altp": 0.17551033374118852,
            "jdsatepoch": 2459633.00335098,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010064639209230028,
            "con41": -0.22207066925467533,
            "cc1": -8.287032442080171e-12,
            "cc4": 7.574805449726453e-8,
            "cc5": 0.0000026243283903931142,
            "d2": 1.372520974607441e-21,
            "d3": -3.3718964034224255e-31,
            "d4": 9.639660490789428e-41,
            "delmo": 0.9910002130450579,
            "eta": 0.3556912674145495,
            "argpdot": 0.000007890959932335186,
            "omgcof": -9.601379103110699e-15,
            "sinmao": -0.9999642177052396,
            "t": 242583.6005385965,
            "t2cof": -1.2430548663120257e-11,
            "t3cof": 1.5098707879996196e-21,
            "t4cof": -2.884373857380723e-31,
            "t5cof": 6.738455833602692e-41,
            "x1mth2": 0.7406902230848917,
            "x7thm1": 0.8151684384057574,
            "mdot": 0.052231299460847876,
            "nodedot": -0.00002723380314377589,
            "xlcof": 0.001849284993789016,
            "xmcof": 1.592739173084924e-9,
            "nodecf": 7.863249241969083e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.822177383434266,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "EXPLORER 29 (GEOS 1)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01738",
            "epochyr": 22,
            "epochdays": 53.58230455,
            "ndot": -1.908953869368798e-12,
            "nddot": 0,
            "bstar": 0.000026752,
            "inclo": 1.0420854818175063,
            "nodeo": 3.4604014760760853,
            "ecco": 0.0137859,
            "argpo": 0.6452028459017517,
            "mo": 5.656203698668655,
            "no": 0.06285459099672303,
            "a": 1.1187663606429692,
            "alta": 0.1341895618141571,
            "altp": 0.1033431594717813,
            "jdsatepoch": 2459633.08230455,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010097669571390087,
            "con41": -0.23667948600898758,
            "cc1": 3.06642244181601e-11,
            "cc4": 6.481494582020205e-7,
            "cc5": 0.00003755231765336548,
            "d2": 3.9535320275189223e-20,
            "d3": 7.605510171250587e-29,
            "d4": 1.7049379123754914e-37,
            "delmo": 1.3949712297102446,
            "eta": 0.144909355399403,
            "argpdot": 0.000011022871848669466,
            "omgcof": 5.4216018365030684e-11,
            "sinmao": -0.586703134536894,
            "t": 242469.90739814937,
            "t2cof": 4.599633662724015e-11,
            "t3cof": 4.1415909593523795e-20,
            "t4cof": 6.075036960058587e-29,
            "t5cof": 1.0999483586374106e-37,
            "x1mth2": 0.7455598286696625,
            "x7thm1": 0.7810811993123623,
            "mdot": 0.06284494000270248,
            "nodedot": -0.000041130226067282665,
            "xlcof": 0.0018532175053770081,
            "xmcof": -1.3086415502178103e-7,
            "nodecf": -4.416658949636348e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.03643020751874104,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "EXPLORER 30"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01778",
            "epochyr": 22,
            "epochdays": 53.35498299,
            "ndot": 3.848208593806942e-12,
            "nddot": 0,
            "bstar": 0.000030141,
            "inclo": 0.5979550377210133,
            "nodeo": 4.940798474263936,
            "ecco": 0.0751443,
            "argpo": 4.338574361192544,
            "mo": 1.80307172496731,
            "no": 0.05874079753626454,
            "a": 1.1697989594473388,
            "alta": 0.25770268339573743,
            "altp": 0.08189523549894018,
            "jdsatepoch": 2459632.85498299,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0006583433291495947,
            "con41": 1.0492500241003757,
            "cc1": 3.872935350534167e-11,
            "cc4": 0.0000019884570681645423,
            "cc5": 0.00005073845321473705,
            "d2": 4.4423512720148817e-20,
            "d3": 7.58587802748215e-29,
            "d4": 1.5087291397537414e-37,
            "delmo": 0.6628870793823028,
            "eta": 0.556376084100182,
            "argpdot": 0.00008530615443836017,
            "omgcof": -4.318438323266185e-13,
            "sinmao": 0.9731451352655494,
            "t": 242797.25044459105,
            "t2cof": 5.8094030258012506e-11,
            "t3cof": 4.742343836603226e-20,
            "t4cof": 6.220079846641563e-29,
            "t5cof": 1.0034954557737421e-37,
            "x1mth2": 0.31691665863320806,
            "x7thm1": 3.781583389567544,
            "mdot": 0.05877769119204268,
            "nodedot": -0.00005839682439757869,
            "xlcof": 0.0012854162466256049,
            "xmcof": -1.4479086220701447e-9,
            "nodecf": -7.847466445694622e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.8874014632278175,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "A-1 (ASTERIX)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 1804",
            "epochyr": 22,
            "epochdays": 53.78518506,
            "ndot": 1.8604725012578444e-11,
            "nddot": 0,
            "bstar": 0.00019849,
            "inclo": 1.392807649676515,
            "nodeo": 3.0333071908083094,
            "ecco": 0.1343893,
            "argpo": 3.13710017609516,
            "mo": 3.1497328692210944,
            "no": 0.05350377063361064,
            "a": 1.2458650892089669,
            "alta": 0.41329602644219765,
            "altp": 0.07843415197573611,
            "jdsatepoch": 2459633.28518506,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011509701358526803,
            "con41": -0.9059594831910956,
            "cc1": 2.277455206242392e-10,
            "cc4": 0.0000018718692110557037,
            "cc5": 0.000053431973844928564,
            "d2": 1.107905510120244e-18,
            "d3": 8.000275782313742e-27,
            "d4": 6.723820135440667e-35,
            "delmo": 0.022517017131523685,
            "eta": 0.717641813578628,
            "argpdot": -0.00002445437053904937,
            "omgcof": -9.91208338916326e-13,
            "sinmao": -0.008140125732264344,
            "t": 242177.75946356356,
            "t2cof": 3.4161828093635883e-10,
            "t3cof": 1.2116415544490557e-18,
            "t4cof": 6.786700162628657e-27,
            "t5cof": 4.6541591172002696e-35,
            "x1mth2": 0.9686531610636986,
            "x7thm1": -0.78057212744589,
            "mdot": 0.05347770817007142,
            "nodedot": -0.000010261324714695225,
            "xlcof": 0.0018995826319421756,
            "xmcof": -8.718642419800024e-10,
            "nodecf": -8.050552905335031e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3146561590630412,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ALOUETTE 2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01806",
            "epochyr": 22,
            "epochdays": 53.4731592,
            "ndot": 1.7392690809804604e-11,
            "nddot": 0,
            "bstar": 0.00020034,
            "inclo": 1.3929699652969505,
            "nodeo": 3.572512700577941,
            "ecco": 0.1435647,
            "argpo": 5.887716387957947,
            "mo": 0.29651922260907265,
            "no": 0.05263517062510835,
            "a": 1.2595268863337359,
            "alta": 0.44035048591217274,
            "altp": 0.07870328675529903,
            "jdsatepoch": 2459632.9731592,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001151003728259483,
            "con41": -0.9061291133050673,
            "cc1": 2.198099411065642e-10,
            "cc4": 0.0000017873417863108954,
            "cc5": 0.0000517308515671261,
            "d2": 9.8562034426733e-19,
            "d3": 6.557016067335146e-27,
            "d4": 5.076440850472565e-35,
            "delmo": 4.91475759481159,
            "eta": 0.7321543986078464,
            "argpdot": -0.000023669328041636847,
            "omgcof": 6.39587762976133e-13,
            "sinmao": 0.2921931094923573,
            "t": 242627.0767018944,
            "t2cof": 3.297149116598463e-10,
            "t3cof": 1.0822531646858725e-18,
            "t4cof": 5.594260568188311e-27,
            "t5cof": 3.53762288635774e-35,
            "x1mth2": 0.9687097044350224,
            "x7thm1": -0.7809679310451569,
            "mdot": 0.05260998176285144,
            "nodedot": -0.000009919750314766623,
            "xlcof": 0.001899505335140453,
            "xmcof": -6.429722571573022e-10,
            "nodecf": -7.491597353717596e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.631957451598666,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "EXPLORER 31 (ISIS-X)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 1814",
            "epochyr": 22,
            "epochdays": 53.79866075,
            "ndot": 1.1574926636490172e-11,
            "nddot": 0,
            "bstar": 0.000071231,
            "inclo": 1.3241568688785699,
            "nodeo": 3.1113338803479675,
            "ecco": 0.0006128,
            "argpo": 0.3831713293120871,
            "mo": 5.902527251990372,
            "no": 0.0640386457276206,
            "a": 1.1052220433375737,
            "alta": 0.10589932340573105,
            "altp": 0.10454476326941653,
            "jdsatepoch": 2459633.29866075,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011340559478951967,
            "con41": -0.8211774633935833,
            "cc1": 1.2560433507980684e-10,
            "cc4": -4.035396834136707e-8,
            "cc5": 0.00005654894456020947,
            "d2": 7.529974121254583e-19,
            "d3": 6.739797463009776e-27,
            "d4": 7.030721736751947e-35,
            "delmo": 1.0205047209122742,
            "eta": 0.007312114633945592,
            "argpdot": -0.00002986582026461192,
            "omgcof": 8.653236432715183e-9,
            "sinmao": -0.37153150164028576,
            "t": 242158.35446991026,
            "t2cof": 1.8840650261971026e-10,
            "t3cof": 7.845503101071391e-19,
            "t4cof": 5.343541291021369e-27,
            "t5cof": 4.496847565371032e-35,
            "x1mth2": 0.9403924877978611,
            "x7thm1": -0.5827474145850277,
            "mdot": 0.06400368515518327,
            "nodedot": -0.00002074669972805276,
            "xlcof": 0.001923626675554277,
            "xmcof": -0.0002711244717729816,
            "nodecf": -9.14436945854846e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.399558236197798,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "FR 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01864",
            "epochyr": 22,
            "epochdays": 53.46120593,
            "ndot": 3.151288927211984e-12,
            "nddot": 0,
            "bstar": 0.000087877,
            "inclo": 1.5547026457622568,
            "nodeo": 0.5326343451358735,
            "ecco": 0.01093,
            "argpo": 5.4412768732610655,
            "mo": 0.8277049444657908,
            "no": 0.06017673066727291,
            "a": 1.152066490026073,
            "alta": 0.16465857676205808,
            "altp": 0.1394744032900881,
            "jdsatepoch": 2459632.96120593,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001169293835634959,
            "con41": -0.9992230473745451,
            "cc1": 3.1087247829993414e-11,
            "cc4": 1.1802579662340222e-7,
            "cc5": 0.000012108471600610043,
            "d2": 3.1942045516534133e-20,
            "d3": 4.889952425576995e-29,
            "d4": 8.72044688553594e-38,
            "delmo": 1.1947411846795464,
            "eta": 0.09031467926687542,
            "argpdot": -0.00003671483632761462,
            "omgcof": 5.389865463582797e-11,
            "sinmao": 0.7363805516769475,
            "t": 242644.28941078484,
            "t2cof": 4.663087174499012e-11,
            "t3cof": 3.387487947182099e-20,
            "t4cof": 3.972872215756353e-29,
            "t5cof": 5.738341624554205e-38,
            "x1mth2": 0.9997410157915151,
            "x7thm1": -0.9981871105406054,
            "mdot": 0.06013993293229484,
            "nodedot": -0.0000011826870366689831,
            "xlcof": 0.001772460150738655,
            "xmcof": -2.957861255109673e-7,
            "nodecf": -1.29043954066714e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.556647211149922,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 1509 (TRANSIT 10)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 1952",
            "epochyr": 22,
            "epochdays": 53.76478598,
            "ndot": 5.181446216858166e-12,
            "nddot": 0,
            "bstar": 0.00016216,
            "inclo": 1.5742834946403812,
            "nodeo": 5.663352567284824,
            "ecco": 0.0220252,
            "argpo": 0.6275383685423171,
            "mo": 5.683141110343936,
            "no": 0.059695476992207216,
            "a": 1.1582456083487165,
            "alta": 0.18375619952171873,
            "altp": 0.13273501717571445,
            "jdsatepoch": 2459633.26478598,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694381689523455,
            "con41": -0.9999635191291258,
            "cc1": 5.44588152428053e-11,
            "cc4": 2.2255243836064436e-7,
            "cc5": 0.00001184381545295967,
            "d2": 9.436546442178684e-20,
            "d3": 2.4355970165342798e-28,
            "d4": 7.3225681222359606e-37,
            "delmo": 1.4995322762518628,
            "eta": 0.17520099692586544,
            "argpdot": -0.0000361050148204472,
            "omgcof": 4.790544995120379e-11,
            "sinmao": -0.5646789500660773,
            "t": 242207.13413894176,
            "t2cof": 8.168822286420794e-11,
            "t3cof": 1.0029698953708684e-19,
            "t4cof": 1.9849065020476652e-28,
            "t5cof": 4.835790116972028e-37,
            "x1mth2": 0.9999878397097086,
            "x7thm1": -0.9999148779679604,
            "mdot": 0.05965931544496478,
            "nodedot": 2.5170846747044477e-7,
            "xlcof": 0.0017500649640424535,
            "xmcof": -1.173771080859711e-7,
            "nodecf": 4.8092907945337455e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.18613403741724,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 1593 (TRANSIT 11)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "01982",
            "epochyr": 22,
            "epochdays": 53.57213496,
            "ndot": 2.666475246102448e-12,
            "nddot": 0,
            "bstar": 0.000034813,
            "inclo": 1.709193955161039,
            "nodeo": 2.920190656657305,
            "ecco": 0.0080228,
            "argpo": 4.883057746620207,
            "mo": 1.3864110179679556,
            "no": 0.06317617363125212,
            "a": 1.1153099869138625,
            "alta": 0.12425789587687497,
            "altp": 0.10636207795085006,
            "jdsatepoch": 2459633.07213496,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011582634234561023,
            "con41": -0.9429042257518617,
            "cc1": 4.2119951793100736e-11,
            "cc4": 3.7186903571242925e-7,
            "cc5": 0.00003970528400783951,
            "d2": 7.709171229126242e-20,
            "d3": 2.1056787953839186e-28,
            "d4": 6.702406539496548e-37,
            "delmo": 1.0487083191827407,
            "eta": 0.08715612950415512,
            "argpdot": -0.00003726651942285847,
            "omgcof": 3.563481219720062e-11,
            "sinmao": 0.9830491352347004,
            "t": 242484.5516075939,
            "t2cof": 6.317992768965111e-11,
            "t3cof": 8.063989296936868e-20,
            "t4cof": 1.6785401876875439e-28,
            "t5cof": 4.313920605009648e-37,
            "x1mth2": 0.9809680752506206,
            "x7thm1": -0.8667765267543441,
            "mdot": 0.06313727993335726,
            "nodedot": 0.000011355581095560217,
            "xlcof": 0.0015520336986321217,
            "xmcof": -5.626863671373934e-7,
            "nodecf": 1.6788622707985191e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.255543151568801,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ESSA 1 (OT-3)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 2016",
            "epochyr": 22,
            "epochdays": 53.6344677,
            "ndot": 1.1877935187183632e-11,
            "nddot": 0,
            "bstar": 0.00011843,
            "inclo": 0.5950001952973869,
            "nodeo": 2.4440491287499837,
            "ecco": 0.1185385,
            "argpo": 0.06387381463523648,
            "mo": 6.2340717420284655,
            "no": 0.0549536582475958,
            "a": 1.2229782463957413,
            "alta": 0.3679482532561229,
            "altp": 0.07800823953535962,
            "jdsatepoch": 2459633.1344677,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0006554845061351732,
            "con41": 1.057489264466657,
            "cc1": 1.494524591200005e-10,
            "cc4": 0.0000020325020853026735,
            "cc5": 0.00005429561630630096,
            "d2": 5.1749334950894005e-19,
            "d3": 2.6620246703307804e-27,
            "d4": 1.5940957448757418e-35,
            "delmo": 4.7905964321496715,
            "eta": 0.6865909554135069,
            "argpdot": 0.0000746814957359301,
            "omgcof": 6.424024458019321e-13,
            "sinmao": -0.04909382271449747,
            "t": 242394.7924619168,
            "t2cof": 2.2417868868000074e-10,
            "t3cof": 5.621654245829709e-19,
            "t4cof": 2.2368859030774152e-27,
            "t5cof": 1.0911613630120623e-35,
            "x1mth2": 0.314170245177781,
            "x7thm1": 3.800808283755533,
            "mdot": 0.054985892118117295,
            "nodedot": -0.00005093521163559244,
            "xlcof": 0.0012801602254194824,
            "xmcof": -9.162948221319872e-10,
            "nodecf": -2.6194845731799228e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.3650782979977052,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "DIAPASON (D1-A)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02091",
            "epochyr": 22,
            "epochdays": 53.59879163,
            "ndot": -9.39326507149726e-13,
            "nddot": 0,
            "bstar": 0.000064304,
            "inclo": 1.7669573720850433,
            "nodeo": 5.924752274685267,
            "ecco": 0.0038438,
            "argpo": 3.7158199401299434,
            "mo": 5.601967592162932,
            "no": 0.05541444612363287,
            "a": 1.2170587846414802,
            "alta": 0.2217369151978852,
            "altp": 0.21238065408507545,
            "jdsatepoch": 2459633.09879163,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011470177006498573,
            "con41": -0.8860356026666483,
            "cc1": 4.626563779459719e-12,
            "cc4": 5.249382681116258e-9,
            "cc5": 0.0000026285486060721776,
            "d2": 5.095557449891959e-22,
            "d3": 8.339556274020827e-32,
            "d4": 1.588971977856054e-41,
            "delmo": 1.0542630294973871,
            "eta": 0.022875752361790416,
            "argpdot": -0.000024586602887894103,
            "omgcof": -1.8803955344805092e-11,
            "sinmao": -0.6297394195641476,
            "t": 242446.1660027504,
            "t2cof": 6.9398456691895785e-12,
            "t3cof": 5.52365929800013e-22,
            "t4cof": 6.986672857835121e-32,
            "t5cof": 1.0838229132483592e-41,
            "x1mth2": 0.9620118675555495,
            "x7thm1": -0.7340830728888461,
            "mdot": 0.05538752743765194,
            "nodedot": 0.000011821748339921901,
            "xlcof": 0.0014428448876089312,
            "xmcof": -5.248159314808457e-7,
            "nodecf": 1.9187103477153004e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.14030521100462323,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ESSA 2 (OT-2)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02119",
            "epochyr": 22,
            "epochdays": 53.55089386,
            "ndot": 3.242191492420022e-12,
            "nddot": 0,
            "bstar": 0.000091711,
            "inclo": 1.5653369368946584,
            "nodeo": 2.5909063680005424,
            "ecco": 0.0148908,
            "argpo": 2.0802823700615694,
            "mo": 4.231098731183986,
            "no": 0.06001667219335623,
            "a": 1.154112606470404,
            "alta": 0.17129826647083357,
            "altp": 0.1369269464699745,
            "jdsatepoch": 2459633.05089386,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694278517922145,
            "con41": -0.9999105860740823,
            "cc1": 3.1710231161215476e-11,
            "cc4": 1.5855121881974112e-7,
            "cc5": 0.000011945647931359778,
            "d2": 3.281232902024692e-20,
            "d3": 5.058226704696443e-29,
            "d4": 9.083284220777871e-38,
            "delmo": 0.8406047872795666,
            "eta": 0.12147762181490326,
            "argpdot": -0.00003653686244912569,
            "omgcof": -2.8037656484862206e-11,
            "sinmao": -0.8863983744232599,
            "t": 242515.13879165053,
            "t2cof": 4.756534674182321e-11,
            "t3cof": 3.482340654084236e-20,
            "t4cof": 4.113787456605949e-29,
            "t5cof": 5.984222269773732e-38,
            "x1mth2": 0.9999701953580274,
            "x7thm1": -0.9997913675061921,
            "mdot": 0.05998007158578597,
            "nodedot": -3.9881221587759056e-7,
            "xlcof": 0.0017604914434483246,
            "xmcof": -1.5891467269360187e-7,
            "nodecf": -4.438187177041022e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.121715977668302,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 1117 (TRANSIT 12)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 2121",
            "epochyr": 22,
            "epochdays": 53.83340751,
            "ndot": 1.0181087303300257e-11,
            "nddot": 0,
            "bstar": 0.000056952,
            "inclo": 2.5220845449359017,
            "nodeo": 0.12361119894324639,
            "ecco": 0.008414,
            "argpo": 4.94625437350567,
            "mo": 1.3217727491203457,
            "no": 0.06048055417617138,
            "a": 1.1472704849078446,
            "alta": 0.1569236187678591,
            "altp": 0.13761735104783002,
            "jdsatepoch": 2459633.33340751,
            "isimp": 0,
            "method": "n",
            "aycof": 0.00067902056800051,
            "con41": 0.9885898595666088,
            "cc1": 2.3140130940140043e-11,
            "cc4": 1.3231837780933995e-7,
            "cc5": 0.000013233538951753432,
            "d2": 1.814135004248665e-20,
            "d3": 2.1193693760443475e-29,
            "d4": 2.884380764304555e-38,
            "delmo": 1.0536228489354131,
            "eta": 0.07126569016505266,
            "argpdot": 0.00008650786667542236,
            "omgcof": 1.0603876075477782e-11,
            "sinmao": 0.9691535305406949,
            "t": 242108.31913545728,
            "t2cof": 3.4710196410210064e-11,
            "t3cof": 1.92122813623403e-20,
            "t4cof": 1.7185626830286412e-29,
            "t5cof": 1.8937379110650373e-38,
            "x1mth2": 0.33713671347779706,
            "x7thm1": 3.6400430056554205,
            "mdot": 0.060517453574512985,
            "nodedot": 0.00006088969156562465,
            "xlcof": -0.001956321718346797,
            "xmcof": -3.5310083294645895e-7,
            "nodecf": 4.916757662782224e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.6184763096108767,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OV1-4"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02122",
            "epochyr": 22,
            "epochdays": 53.42025368,
            "ndot": 8.847849680249032e-12,
            "nddot": 0,
            "bstar": 0.000043165,
            "inclo": 2.5243307836832187,
            "nodeo": 3.6646975010097775,
            "ecco": 0.0047424,
            "argpo": 3.064838309074839,
            "mo": 3.220244171001666,
            "no": 0.059562199123997434,
            "a": 1.1590397030992348,
            "alta": 0.1645363329872127,
            "altp": 0.15354307321125682,
            "jdsatepoch": 2459632.92025368,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0006768801669491483,
            "con41": 0.9949561213967826,
            "cc1": 1.2234215432527412e-11,
            "cc4": 5.328987611591228e-8,
            "cc5": 0.000009353802540676525,
            "d2": 4.7136234047960126e-21,
            "d3": 2.7048891237971326e-30,
            "d4": 1.8080161463555036e-39,
            "delmo": 0.8924397085073346,
            "eta": 0.03733712078962948,
            "argpdot": 0.00008384632867787753,
            "omgcof": -3.9716253939395173e-11,
            "sinmao": -0.07857045197314196,
            "t": 242703.26065063477,
            "t2cof": 1.8351323148791117e-11,
            "t3cof": 5.012975459294996e-21,
            "t4cof": 2.2062472173602205e-30,
            "t5cof": 1.195193160854394e-39,
            "x1mth2": 0.3350146262010725,
            "x7thm1": 3.6548976165924927,
            "mdot": 0.05959803041662179,
            "nodedot": 0.00005884005426926432,
            "xlcof": -0.0019758578475073617,
            "xmcof": -6.49537192039766e-7,
            "nodecf": 2.51221677372244e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.298632143265806,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OV1-5"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 2125",
            "epochyr": 22,
            "epochdays": 53.79738644,
            "ndot": 7.514612057197807e-12,
            "nddot": 0,
            "bstar": 0.000056373,
            "inclo": 1.7106530504157063,
            "nodeo": 4.519163578896397,
            "ecco": 0.0156152,
            "argpo": 2.360800414088358,
            "mo": 3.946676385620486,
            "no": 0.06360871051369242,
            "a": 1.1102518922788842,
            "alta": 0.1275886976271976,
            "altp": 0.09291508693057082,
            "jdsatepoch": 2459633.29738644,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011580267914336477,
            "con41": -0.94170188398863,
            "cc1": 9.48463800259271e-11,
            "cc4": 0.000001102583597785029,
            "cc5": 0.00005638670553609502,
            "d2": 4.0931364461955904e-19,
            "d3": 2.6366753971999514e-27,
            "d4": 1.9794028728269981e-35,
            "delmo": 0.6742893225598251,
            "eta": 0.177624252006837,
            "argpdot": -0.00003779382162555883,
            "omgcof": -1.6072406061494892e-10,
            "sinmao": -0.720888676083344,
            "t": 242160.1894763857,
            "t2cof": 1.4226957003889066e-10,
            "t3cof": 4.273053162276042e-19,
            "t4cof": 2.0961053565154133e-27,
            "t5cof": 1.26999877939364e-35,
            "x1mth2": 0.9805672946628766,
            "x7thm1": -0.8639710626401365,
            "mdot": 0.06356923262331686,
            "nodedot": 0.000011662572227885005,
            "xlcof": 0.0015494610546144746,
            "xmcof": -2.811921582229439e-7,
            "nodecf": 3.88208909745041e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3915295883135954,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 0340"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02142",
            "epochyr": 22,
            "epochdays": 53.35595793,
            "ndot": 2.0907589997848738e-12,
            "nddot": 0,
            "bstar": 0.000031149,
            "inclo": 0.6116663443246808,
            "nodeo": 5.219236085822348,
            "ecco": 0.0007321,
            "argpo": 3.318902397629149,
            "mo": 2.965225387346514,
            "no": 0.06252555500243298,
            "a": 1.1220851574924438,
            "alta": 0.12290663603624408,
            "altp": 0.12126367894864343,
            "jdsatepoch": 2459632.85595793,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0006715334629388498,
            "con41": 1.0107711769119492,
            "cc1": 2.8473439461138352e-11,
            "cc4": 7.438150888043146e-8,
            "cc5": 0.000028486147547814073,
            "d2": 3.2991878991783954e-20,
            "d3": 5.702789126313203e-29,
            "d4": 1.1486485036014174e-37,
            "delmo": 0.9781636136588042,
            "eta": 0.007447964603941965,
            "argpdot": 0.00009498737681368444,
            "omgcof": -8.085017027625118e-10,
            "sinmao": 0.1754543577892807,
            "t": 242795.8465307951,
            "t2cof": 4.271015919170753e-11,
            "t3cof": 3.4613352501278174e-20,
            "t4cof": 4.564680641465734e-29,
            "t5cof": 7.42845978698178e-38,
            "x1mth2": 0.3297429410293503,
            "x7thm1": 3.6917994127945475,
            "mdot": 0.06256632459196974,
            "nodedot": -0.0000661722337861812,
            "xlcof": 0.0013095939194596418,
            "xmcof": -0.00004830333872763567,
            "nodecf": -6.573983980808178e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.893543964459624,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OAO 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02150",
            "epochyr": 22,
            "epochdays": 53.51309835,
            "ndot": 2.0322783495010364e-10,
            "nddot": 0,
            "bstar": 0.00041368,
            "inclo": 1.4378284177317087,
            "nodeo": 2.2328904691974496,
            "ecco": 0.1605397,
            "argpo": 5.803581046036308,
            "mo": 0.3475509046081348,
            "no": 0.05300304872891208,
            "a": 1.2537175235119185,
            "alta": 0.45498895862126476,
            "altp": 0.052446088402572144,
            "jdsatepoch": 2459633.01309835,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011591223342925013,
            "con41": -0.9472704683259564,
            "cc1": 2.5518650090160026e-9,
            "cc4": 0.000010311546042725985,
            "cc5": 0.0002986725274083397,
            "d2": 1.354244768005299e-16,
            "d3": 1.0665031732882275e-23,
            "d4": 9.77475540071852e-31,
            "delmo": 5.684981265217285,
            "eta": 0.834649674382107,
            "argpdot": -0.000026281420972450524,
            "omgcof": 1.297632183104145e-12,
            "sinmao": 0.34059616801133497,
            "t": 242569.5643262565,
            "t2cof": 3.827797513524004e-9,
            "t3cof": 1.4844850684901038e-16,
            "t4cof": 9.077073208992784e-24,
            "t5cof": 6.792293382456754e-31,
            "x1mth2": 0.9824234894419855,
            "x7thm1": -0.8769644260938985,
            "mdot": 0.052976072685766776,
            "nodedot": -0.000007635607776907717,
            "xlcof": 0.0018743673280677327,
            "xmcof": -1.1460037161792678e-9,
            "nodecf": -6.660384964757276e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.88358959536383,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 1527 (OV3-1)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02173",
            "epochyr": 22,
            "epochdays": 53.39981144,
            "ndot": -8.18123086872342e-13,
            "nddot": 0,
            "bstar": 0.000040259,
            "inclo": 1.754089059510089,
            "nodeo": 3.573769337639377,
            "ecco": 0.0055444,
            "argpo": 0.42616227944721147,
            "mo": 0.5094476460231289,
            "no": 0.05821910756536033,
            "a": 1.1776832830711352,
            "alta": 0.18421283026579482,
            "altp": 0.17115373587647564,
            "jdsatepoch": 2459632.89981144,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011498557422931846,
            "con41": -0.9003349848722176,
            "cc1": 6.9476480670307856e-12,
            "cc4": 2.3336515782650827e-8,
            "cc5": 0.000006029191304025988,
            "d2": 1.377278011654189e-21,
            "d3": 4.0635071569248425e-31,
            "d4": 1.3962512654485917e-40,
            "delmo": 1.1071992490091602,
            "eta": 0.03954945973625499,
            "argpdot": -0.00002839543699966395,
            "omgcof": 2.7186769939835892e-11,
            "sinmao": 0.48769510853763337,
            "t": 242732.6974761486,
            "t2cof": 1.0421472100546178e-11,
            "t3cof": 1.4738176389808222e-21,
            "t4cof": 3.343079697096476e-31,
            "t5cof": 9.323286146982483e-41,
            "x1mth2": 0.9667783282907392,
            "x7thm1": -0.7674482980351743,
            "mdot": 0.05818841519523983,
            "nodedot": 0.00001240305959915655,
            "xlcof": 0.0014684868179765944,
            "xmcof": -3.1019784350827903e-7,
            "nodecf": 3.023534919370886e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.169838098041893,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "NIMBUS 2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 2176",
            "epochyr": 22,
            "epochdays": 53.53222836,
            "ndot": 2.57557268089441e-12,
            "nddot": 0,
            "bstar": 0.000046756,
            "inclo": 1.5739414101069904,
            "nodeo": 0.8084871240720812,
            "ecco": 0.007815,
            "argpo": 0.8811381995155972,
            "mo": 5.416105734788803,
            "no": 0.061259490161120186,
            "a": 1.1384624916529784,
            "alta": 0.1473595760252464,
            "altp": 0.12956540728071042,
            "jdsatepoch": 2459633.03222836,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694394955631025,
            "con41": -0.9999703254507226,
            "cc1": 2.4602294086876612e-11,
            "cc4": 1.308282450893041e-7,
            "cc5": 0.000017677745357602895,
            "d2": 2.190853970820701e-20,
            "d3": 2.9084928046076487e-29,
            "d4": 4.498564319805307e-38,
            "delmo": 1.1436532724512927,
            "eta": 0.07071820210311593,
            "argpdot": -0.00003831559870354189,
            "omgcof": 6.520929261076021e-11,
            "sinmao": -0.7624425110114481,
            "t": 242542.01711162925,
            "t2cof": 3.690344113031492e-11,
            "t3cof": 2.3119085456881337e-20,
            "t4cof": 2.3467924798446462e-29,
            "t5cof": 2.93653640758592e-38,
            "x1mth2": 0.9999901084835742,
            "x7thm1": -0.9999307593850194,
            "mdot": 0.061221104257325534,
            "nodedot": 2.409093577349757e-7,
            "xlcof": 0.0017504696607405998,
            "xmcof": -4.2400130663628613e-7,
            "nodecf": 2.0805185914368355e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.0041160836885155,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 0082 (TRANSIT 13)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02389",
            "epochyr": 22,
            "epochdays": 53.53314118,
            "ndot": 3.4349049306610627e-10,
            "nddot": 0,
            "bstar": 0.00061231,
            "inclo": 1.4203855971872772,
            "nodeo": 3.912771619571244,
            "ecco": 0.1214122,
            "argpo": 2.2771502736987737,
            "mo": 4.204206698069257,
            "no": 0.05669466397066344,
            "a": 1.1987100798132255,
            "alta": 0.34424810776552484,
            "altp": 0.05317205186092622,
            "jdsatepoch": 2459633.03314118,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011562417929478896,
            "con41": -0.9326401135414242,
            "cc1": 4.019680484120238e-9,
            "cc4": 0.000011231251377543875,
            "cc5": 0.00030416195932056093,
            "d2": 4.1626596276156137e-16,
            "d3": 6.410311555754137e-23,
            "d4": 1.1494330479485933e-29,
            "delmo": 0.23775315202245983,
            "eta": 0.7819701437013071,
            "argpdot": -0.000029262706008285727,
            "omgcof": -7.239656096989212e-12,
            "sinmao": -0.8736304337558437,
            "t": 242540.70265084505,
            "t2cof": 6.029520726180357e-9,
            "t3cof": 4.485816251503956e-16,
            "t4cof": 5.325947846509931e-23,
            "t5cof": 7.764087769459639e-30,
            "x1mth2": 0.977546704513808,
            "x7thm1": -0.8428269315966561,
            "mdot": 0.056664107744497,
            "nodedot": -0.000009872105254089363,
            "xlcof": 0.0018850406370020697,
            "xmcof": -6.747271224535603e-9,
            "nodecf": -1.3719755882886707e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.009867203884298,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OV3-3"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 2401",
            "epochyr": 22,
            "epochdays": 53.55643535,
            "ndot": 1.6665470288140301e-12,
            "nddot": 0,
            "bstar": 0.000062833,
            "inclo": 1.5507739096160176,
            "nodeo": 4.315532524407715,
            "ecco": 0.0032221,
            "argpo": 3.3962606260652937,
            "mo": 3.8133890813041824,
            "no": 0.059089623641656604,
            "a": 1.166142006609126,
            "alta": 0.16989943276862096,
            "altp": 0.16238458044963067,
            "jdsatepoch": 2459633.05643535,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011692108735392153,
            "con41": -0.9987974691409108,
            "cc1": 1.4458414811882697e-11,
            "cc4": 1.5173445700194355e-8,
            "cc5": 0.000007937562709720388,
            "d2": 6.352072365250745e-21,
            "d3": 4.155407849738383e-30,
            "d4": 3.1662400735585567e-39,
            "delmo": 0.9436199340103084,
            "eta": 0.024476713230714937,
            "argpdot": -0.00003515535440078917,
            "omgcof": -1.1525849603348438e-10,
            "sinmao": -0.6223930632349582,
            "t": 242507.1590461582,
            "t2cof": 2.1687622217824045e-11,
            "t3cof": 6.770163882995683e-21,
            "t4cof": 3.399634754560571e-30,
            "t5cof": 2.100454440220911e-39,
            "x1mth2": 0.9995991563803036,
            "x7thm1": -0.9971940946621253,
            "mdot": 0.059054378581296675,
            "nodedot": -0.000001409884066480098,
            "xlcof": 0.0017767657024231366,
            "xmcof": -0.0000018012226519400589,
            "nodecf": -7.154934834660458e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.15662951484812,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 2366 (TRANSIT 14)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02418",
            "epochyr": 22,
            "epochdays": 53.45522473,
            "ndot": 3.363394912697406e-12,
            "nddot": 0,
            "bstar": 0.000043539,
            "inclo": 1.7135520423032689,
            "nodeo": 4.121256434709722,
            "ecco": 0.0119984,
            "argpo": 2.0771250694447114,
            "mo": 4.229232974213604,
            "no": 0.06295173317905589,
            "a": 1.117955471004148,
            "alta": 0.13136914792744414,
            "altp": 0.10454179408085174,
            "jdsatepoch": 2459632.95522473,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011575493261765397,
            "con41": -0.9392766017756974,
            "cc1": 4.9796684520724093e-11,
            "cc4": 5.36757278956262e-7,
            "cc5": 0.00003799837692167782,
            "d2": 1.0529266258992266e-19,
            "d3": 3.322065636178629e-28,
            "d4": 1.2214075611086949e-36,
            "delmo": 0.8327803130458358,
            "eta": 0.12736807834251737,
            "argpdot": -0.00003671857363307445,
            "omgcof": -7.46012539839105e-11,
            "sinmao": -0.8855331298735943,
            "t": 242652.9023386538,
            "t2cof": 7.469502678108614e-11,
            "t3cof": 1.102520821684357e-19,
            "t4cof": 2.651933025326058e-28,
            "t5cof": 7.87436093844493e-37,
            "x1mth2": 0.9797588672585659,
            "x7thm1": -0.8583120708099607,
            "mdot": 0.06291330472026385,
            "nodedot": 0.000011616060495884293,
            "xlcof": 0.0015443214427920161,
            "xmcof": -2.907922659045242e-7,
            "nodecf": 2.0301671272328275e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.518963330429344,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 6026 (DMSP 4A F1)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02435",
            "epochyr": 22,
            "epochdays": 53.59902483,
            "ndot": -8.484239419416881e-13,
            "nddot": 0,
            "bstar": 0.00007684,
            "inclo": 1.7619186065345358,
            "nodeo": 0.6030426724905767,
            "ecco": 0.0063681,
            "argpo": 5.3728268053271,
            "mo": 3.0001982948979764,
            "no": 0.054866751948733895,
            "a": 1.225142021111455,
            "alta": 0.2329438480160948,
            "altp": 0.21734019420681516,
            "jdsatepoch": 2459633.09902483,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011481516270565046,
            "con41": -0.8917446158390905,
            "cc1": 4.742794851295828e-12,
            "cc4": 8.14836344496334e-9,
            "cc5": 0.000002278367605556479,
            "d2": 5.185349902726678e-22,
            "d3": 8.42182349371756e-32,
            "d4": 1.5922971211478712e-41,
            "delmo": 0.8949127892320411,
            "eta": 0.03669942597109092,
            "argpdot": -0.00002430630684064414,
            "omgcof": 8.090382175746643e-12,
            "sinmao": 0.14092369482556247,
            "t": 242445.8301948756,
            "t2cof": 7.114192276943743e-12,
            "t3cof": 5.635231962756243e-22,
            "t4cof": 7.080830373887735e-32,
            "t5cof": 1.0906570347656249e-41,
            "x1mth2": 0.9639148719463635,
            "x7thm1": -0.7474041036245446,
            "mdot": 0.05484027937393211,
            "nodedot": 0.000011258632206947247,
            "xlcof": 0.001452976414704987,
            "xmcof": -2.020501837020452e-7,
            "nodecf": 1.8731439194455478e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.14177446096541502,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ESSA 3 (TOS-A)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02657",
            "epochyr": 22,
            "epochdays": 53.53752145,
            "ndot": -1.21203420277384e-12,
            "nddot": 0,
            "bstar": 0.000037693,
            "inclo": 1.7790333051795921,
            "nodeo": 2.8243877886860838,
            "ecco": 0.0073418,
            "argpo": 2.3349206719397864,
            "mo": 4.152885291414363,
            "no": 0.0554341695386698,
            "a": 1.2167639552851541,
            "alta": 0.2256971928920668,
            "altp": 0.20783071767824168,
            "jdsatepoch": 2459633.03752145,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011441816522688823,
            "con41": -0.8717815631731505,
            "cc1": 2.7496117645982452e-12,
            "cc4": 1.1725081646728623e-8,
            "cc5": 0.000002667459163026826,
            "d2": 1.8018882777596138e-22,
            "d3": 1.7547176420974045e-32,
            "d4": 1.989343741843157e-42,
            "delmo": 0.9319498458449227,
            "eta": 0.04374492372258618,
            "argpdot": -0.000023889589573117284,
            "omgcof": -4.779087697868673e-12,
            "sinmao": -0.8475186402215291,
            "t": 242534.39506217837,
            "t2cof": 4.124417646897368e-12,
            "t3cof": 1.9530955748799554e-22,
            "t4cof": 1.4698700448218285e-32,
            "t5cof": 1.3567081130624973e-42,
            "x1mth2": 0.9572605210577168,
            "x7thm1": -0.7008236474040175,
            "mdot": 0.05540766014234942,
            "nodedot": 0.000012551125828844774,
            "xlcof": 0.0014180835906783544,
            "xmcof": -8.470125630472709e-8,
            "nodecf": 1.2105716218926772e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.037464604287763,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ESSA 4 (TOS-B)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 2669",
            "epochyr": 22,
            "epochdays": 53.78734844,
            "ndot": 1.605945318675338e-12,
            "nddot": 0,
            "bstar": 0.000040653,
            "inclo": 1.7268060726429137,
            "nodeo": 6.0118424590305315,
            "ecco": 0.0048654,
            "argpo": 4.443009627644129,
            "mo": 1.8328487873355852,
            "no": 0.062306514001315344,
            "a": 1.1256483053430293,
            "alta": 0.1311250346078452,
            "altp": 0.12017157607821338,
            "jdsatepoch": 2459633.28734844,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011552425330461323,
            "con41": -0.9275733474231769,
            "cc1": 3.2525118319989413e-11,
            "cc4": 1.2341051555940386e-7,
            "cc5": 0.000026376752950242607,
            "d2": 4.21457139297366e-20,
            "d3": 8.146104277381065e-29,
            "d4": 1.8346548300706655e-37,
            "delmo": 0.9628089751635479,
            "eta": 0.04845897282380299,
            "argpdot": -0.00003506412456632685,
            "omgcof": -6.541640036549811e-11,
            "sinmao": 0.9658602953127088,
            "t": 242174.6441964805,
            "t2cof": 4.8787677479984117e-11,
            "t3cof": 4.426148057319522e-20,
            "t4cof": 6.529418452761328e-29,
            "t5cof": 1.188405442171266e-37,
            "x1mth2": 0.9758577824743924,
            "x7thm1": -0.8310044773207463,
            "mdot": 0.0622694717898383,
            "nodedot": 0.000012382801399214633,
            "xlcof": 0.0015203441036881456,
            "xmcof": -0.0000013268763419133635,
            "nodecf": 1.4136089522272337e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3282862921561431,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 6073 (DMSP 4A F2)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02674",
            "epochyr": 22,
            "epochdays": 53.54649796,
            "ndot": 3.0937173025802266e-11,
            "nddot": 0,
            "bstar": 0.00016268,
            "inclo": 0.6967982692492082,
            "nodeo": 2.21187845033269,
            "ecco": 0.0264217,
            "argpo": 6.265583661673223,
            "mo": 0.01798387261254957,
            "no": 0.06349105313485655,
            "a": 1.1107903687411067,
            "alta": 0.14013933862687367,
            "altp": 0.08144139885533974,
            "jdsatepoch": 2459633.04649796,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0007505097171300628,
            "con41": 0.7644108567524289,
            "cc1": 3.718274181797704e-10,
            "cc4": 0.0000024894248548236006,
            "cc5": 0.0000760947277832385,
            "d2": 6.2111891293432954e-18,
            "d3": 1.5486233352417696e-25,
            "d4": 4.499743096835966e-33,
            "delmo": 2.180328381722,
            "eta": 0.296751345880685,
            "argpdot": 0.00008128173831860121,
            "omgcof": 2.3276993091573525e-10,
            "sinmao": 0.017982903238522068,
            "t": 242521.4688874036,
            "t2cof": 5.577411272696555e-10,
            "t3cof": 6.487700387163763e-18,
            "t4cof": 1.2320373948036892e-25,
            "t5cof": 2.8895471855492834e-33,
            "x1mth2": 0.41186304774919036,
            "x7thm1": 3.116958665755668,
            "mdot": 0.06352303708566286,
            "nodedot": -0.00006428689542510807,
            "xlcof": 0.0014515137826569863,
            "xmcof": -2.71473432945057e-7,
            "nodecf": -8.340267676622139e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.094020102700981,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "DIADEME 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 2680",
            "epochyr": 22,
            "epochdays": 53.75095891,
            "ndot": 1.0393193288785679e-11,
            "nddot": 0,
            "bstar": 0.00018019,
            "inclo": 0.6883054971090037,
            "nodeo": 4.405411744897667,
            "ecco": 0.0712979,
            "argpo": 1.3577823822474926,
            "mo": 5.064343350695607,
            "no": 0.058363367178211306,
            "a": 1.1749622121739434,
            "alta": 0.2587345504812999,
            "altp": 0.09118987386658683,
            "jdsatepoch": 2459633.25095891,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0007428660119071618,
            "con41": 0.7894508647612279,
            "cc1": 1.5219753168111567e-10,
            "cc4": 0.0000012655660312588096,
            "cc5": 0.00003335974675697084,
            "d2": 6.6770081271437575e-19,
            "d3": 4.3599984529779814e-27,
            "d4": 3.3157519272657816e-35,
            "delmo": 1.63102885115465,
            "eta": 0.5137873811321902,
            "argpdot": 0.0000688163418120516,
            "omgcof": 1.5095303612832302e-12,
            "sinmao": -0.9387007699832182,
            "t": 242227.04511925578,
            "t2cof": 2.282962975216735e-10,
            "t3cof": 7.140289900140242e-19,
            "t4cof": 3.5836798793136595e-27,
            "t5cof": 2.2116505030290756e-35,
            "x1mth2": 0.4035163784129241,
            "x7thm1": 3.175385351109531,
            "mdot": 0.05839068348971066,
            "nodedot": -0.00005365315575130781,
            "xlcof": 0.001438016943670686,
            "xmcof": -8.713453469316699e-9,
            "nodecf": -2.837142389985278e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.0990181322714747,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "DIADEME 2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02754",
            "epochyr": 22,
            "epochdays": 53.61232213,
            "ndot": 3.363394912697406e-12,
            "nddot": 0,
            "bstar": 0.00014293,
            "inclo": 1.574391705054005,
            "nodeo": 0.02139773662945048,
            "ecco": 0.0021515,
            "argpo": 1.3217273705597938,
            "mo": 1.7026105732225165,
            "no": 0.05923983302629885,
            "a": 1.1641720193272256,
            "alta": 0.16667673542680816,
            "altp": 0.161667303227643,
            "jdsatepoch": 2459633.11232213,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694377208187853,
            "con41": -0.9999612199326222,
            "cc1": 3.459232897247318e-11,
            "cc4": 7.739328986939597e-9,
            "cc5": 0.000008326837684405324,
            "d2": 3.677172366112235e-20,
            "d3": 5.820863116994778e-29,
            "d4": 1.0732505595520756e-37,
            "delmo": 0.993496948823005,
            "eta": 0.016528587528902603,
            "argpdot": -0.00003543201221091435,
            "omgcof": 1.069862876853756e-10,
            "sinmao": 0.9913250737060318,
            "t": 242426.68208308518,
            "t2cof": 5.188849345870977e-11,
            "t3cof": 3.9164982108601966e-20,
            "t4cof": 4.757601754218631e-29,
            "t5cof": 7.111850672999856e-38,
            "x1mth2": 0.9999870733108741,
            "x7thm1": -0.9999095131761185,
            "mdot": 0.05920433765731348,
            "nodedot": 2.5468400126111533e-7,
            "xlcof": 0.0017499368478248773,
            "xmcof": -0.000009569285652172695,
            "nodecf": 3.092368270679933e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.22555261071206445,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 0100 (TRANSIT 15)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02757",
            "epochyr": 22,
            "epochdays": 53.57423478,
            "ndot": -9.39326507149726e-13,
            "nddot": 0,
            "bstar": 0.000083295,
            "inclo": 1.7766823466771557,
            "nodeo": 2.9124937546560097,
            "ecco": 0.0043183,
            "argpo": 2.023185668911827,
            "mo": 4.467835190924497,
            "no": 0.05537553962092867,
            "a": 1.217623345361129,
            "alta": 0.22288140825340186,
            "altp": 0.212365282468856,
            "jdsatepoch": 2459633.07423478,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011447468707035024,
            "con41": -0.8746195475049687,
            "cc1": 5.930810431549433e-12,
            "cc4": 6.0492996902988494e-9,
            "cc5": 0.000002602996040886844,
            "d2": 8.354052986414207e-22,
            "d3": 1.7485941257574724e-31,
            "d4": 4.260892548418582e-41,
            "delmo": 0.9814910803048285,
            "eta": 0.02564023249750703,
            "argpdot": -0.000023971909036269017,
            "omgcof": -1.110161361544205e-11,
            "sinmao": -0.9702454595786267,
            "t": 242481.52786687016,
            "t2cof": 8.89621564732415e-12,
            "t3cof": 9.057543233913719e-22,
            "t4cof": 1.4652998422336846e-31,
            "t5cof": 2.9071798556744076e-41,
            "x1mth2": 0.9582065158349896,
            "x7thm1": -0.7074456108449272,
            "mdot": 0.05534901093906533,
            "nodedot": 0.000012379914048259988,
            "xlcof": 0.0014229574466510506,
            "xmcof": -5.338928821333288e-7,
            "nodecf": 2.575640114246758e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.268772832180204,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ESSA 5"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02801",
            "epochyr": 22,
            "epochdays": 53.48832509,
            "ndot": -3.6361026083215196e-13,
            "nddot": 0,
            "bstar": 0.000004759,
            "inclo": 1.2922138529085696,
            "nodeo": 1.4094877613378247,
            "ecco": 0.0058151,
            "argpo": 5.481702189395758,
            "mo": 0.7951528085868447,
            "no": 0.0627156289259462,
            "a": 1.12067701401697,
            "alta": 0.12719386292117996,
            "altp": 0.11416016511275995,
            "jdsatepoch": 2459632.98832509,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243587362908594,
            "con41": -0.7731364670447214,
            "cc1": 4.601351910629337e-12,
            "cc4": 2.014588364922258e-7,
            "cc5": 0.000031619012981010035,
            "d2": 8.778977490492612e-22,
            "d3": 2.4989632685785907e-31,
            "d4": 8.289064764686499e-41,
            "delmo": 1.132038190652495,
            "eta": 0.060279582134283034,
            "argpdot": -0.0000252161391211167,
            "omgcof": 2.0478270201445672e-11,
            "sinmao": 0.7139706061255846,
            "t": 242605.23782014847,
            "t2cof": 6.902027865944006e-12,
            "t3cof": 9.202426278601657e-22,
            "t4cof": 1.9978434920944674e-31,
            "t5cof": 5.35317684339206e-41,
            "x1mth2": 0.9243788223482405,
            "x7thm1": -0.4706517564376833,
            "mdot": 0.0626842755062679,
            "nodedot": -0.000022263335626774633,
            "xlcof": 0.0019290420446363191,
            "xmcof": -1.2474639403455026e-7,
            "nodecf": -3.5938959107633945e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.727508445107034,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 158"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02807",
            "epochyr": 22,
            "epochdays": 53.54759561,
            "ndot": 1.575644463605992e-12,
            "nddot": 0,
            "bstar": 0.000064789,
            "inclo": 1.5646545131571286,
            "nodeo": 0.7073679831992858,
            "ecco": 0.0020513,
            "argpo": 2.9202604698273844,
            "mo": 5.520439772143773,
            "no": 0.05895249143458306,
            "a": 1.1679487838587939,
            "alta": 0.17034459719912332,
            "altp": 0.1655529705184644,
            "jdsatepoch": 2459633.04759561,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694232226061513,
            "con41": -0.9998868357986496,
            "cc1": 1.4190479261287017e-11,
            "cc4": 6.219846168781826e-9,
            "cc5": 0.000007568136944021293,
            "d2": 6.056986485276141e-21,
            "d3": 3.8493459169301415e-30,
            "d4": 2.8493223574867122e-39,
            "delmo": 1.0338290907107663,
            "eta": 0.015425230651028765,
            "argpdot": -0.00003502848622523661,
            "omgcof": -1.771157237592879e-10,
            "sinmao": -0.6909089087426673,
            "t": 242519.88827168941,
            "t2cof": 2.1285718891930526e-11,
            "t3cof": 6.459725888606175e-21,
            "t4cof": 3.152007892451549e-30,
            "t5cof": 1.8921554796397503e-39,
            "x1mth2": 0.9999622785995498,
            "x7thm1": -0.9997359501968487,
            "mdot": 0.05891739897989319,
            "nodedot": -4.3016243406648046e-7,
            "xlcof": 0.001761273325242982,
            "xmcof": -0.00000441748343542331,
            "nodecf": -2.1425517833863032e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.100935722443339,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7218 (TRANSIT 16)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02826",
            "epochyr": 22,
            "epochdays": 53.5635526,
            "ndot": 4.951159718331136e-11,
            "nddot": 0,
            "bstar": 0.00043686,
            "inclo": 1.2204581313713267,
            "nodeo": 3.464836357705403,
            "ecco": 0.0006108,
            "argpo": 3.1601751741357766,
            "mo": 3.1249666471352953,
            "no": 0.06329669493289189,
            "a": 1.1137510293282524,
            "alta": 0.11443130845696614,
            "altp": 0.11307075019953872,
            "jdsatepoch": 2459633.0635526,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010984093053482027,
            "con41": -0.6466094041166599,
            "cc1": 5.416183155143384e-10,
            "cc4": -1.2364464998118292e-8,
            "cc5": 0.000039920231100684275,
            "d2": 1.2909200652830711e-17,
            "d3": 4.591958556939571e-25,
            "d4": 1.9035187772856808e-32,
            "delmo": 0.9799787252130618,
            "eta": 0.006719728153427463,
            "argpdot": -0.000017058811087015447,
            "omgcof": -3.521524843633519e-8,
            "sinmao": 0.016625240493632072,
            "t": 242496.910206154,
            "t2cof": 8.124274732715075e-10,
            "t3cof": 1.349590145223189e-17,
            "t4cof": 3.6576968018048936e-25,
            "t5cof": 1.2240970621952191e-32,
            "x1mth2": 0.8822031347055533,
            "x7thm1": -0.17542194293887314,
            "mdot": 0.06326990177063692,
            "nodedot": -0.00002839956565852467,
            "xlcof": 0.0019282770996312427,
            "xmcof": -0.0012716583799044065,
            "nodecf": -5.394480154000895e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.2014709520630475,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 5712 (P/L 160)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02828",
            "epochyr": 22,
            "epochdays": 53.60708598,
            "ndot": 2.72707695624114e-13,
            "nddot": 0,
            "bstar": 0.000044452,
            "inclo": 1.2212103682789364,
            "nodeo": 3.5925595523663483,
            "ecco": 0.0005431,
            "argpo": 0.7793017283202321,
            "mo": 5.506574876565929,
            "no": 0.06100217267004154,
            "a": 1.141492295108593,
            "alta": 0.1421122395740666,
            "altp": 0.14087235064311954,
            "jdsatepoch": 2459633.10708598,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010987109211696936,
            "con41": -0.6480630860256158,
            "cc1": 2.0741942034194e-11,
            "cc4": -4.18424905807828e-9,
            "cc5": 0.000015520674199057033,
            "d2": 1.5229096992866218e-20,
            "d3": 1.6666910784021484e-29,
            "d4": 2.125071049207471e-38,
            "delmo": 1.0103198288997202,
            "eta": 0.004806125771337345,
            "argpdot": -0.000015741579800281626,
            "omgcof": 8.230664643169784e-10,
            "sinmao": -0.7008656930015832,
            "t": 242434.22213874757,
            "t2cof": 3.1112913051291e-11,
            "t3cof": 1.6089553311565947e-20,
            "t4cof": 1.3470135648050343e-29,
            "t5cof": 1.3898293810211696e-38,
            "x1mth2": 0.882687695341872,
            "x7thm1": -0.17881386739310356,
            "mdot": 0.0609775354202616,
            "nodedot": -0.000026003997242341583,
            "xlcof": 0.0019283760459542008,
            "xmcof": -0.00007719407093244959,
            "nodecf": -1.891445586938312e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.19256283504468996,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "GGSE 4"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02834",
            "epochyr": 22,
            "epochdays": 53.34573442,
            "ndot": -8.787247970110339e-13,
            "nddot": 0,
            "bstar": 0.000017564,
            "inclo": 1.2212225855837004,
            "nodeo": 4.6484296446161055,
            "ecco": 0.0004643,
            "argpo": 1.6690670903284373,
            "mo": 4.616970084848908,
            "no": 0.06093012765503646,
            "a": 1.1423914608210353,
            "alta": 0.14292187317629446,
            "altp": 0.14186104846577607,
            "jdsatepoch": 2459632.84573442,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010987158146722432,
            "con41": -0.648086674272661,
            "cc1": 7.968377336015707e-12,
            "cc4": -5.332892554920718e-9,
            "cc5": 0.000015106388720821218,
            "d2": 2.2337717421227824e-21,
            "d3": 9.333552081547641e-31,
            "d4": 4.543479555411149e-40,
            "delmo": 0.9988332840346604,
            "eta": 0.004083548348188958,
            "argpdot": -0.000015699691330072446,
            "omgcof": -5.06119558870741e-11,
            "sinmao": -0.99545107017081,
            "t": 242810.56838482618,
            "t2cof": 1.1952566004023561e-11,
            "t3cof": 2.36076181686104e-21,
            "t4cof": 7.5467989552916765e-31,
            "t5cof": 2.9730913570957947e-40,
            "x1mth2": 0.8826955580908871,
            "x7thm1": -0.17886890663620902,
            "mdot": 0.06090555733637005,
            "nodedot": -0.00002593159757352978,
            "xlcof": 0.001928377637299852,
            "xmcof": -0.00004083953605956204,
            "nodecf": -7.2460651771708475e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.829131885333865,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "GGSE 5"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 2847",
            "epochyr": 22,
            "epochdays": 53.85043914,
            "ndot": 3.0300855069346e-12,
            "nddot": 0,
            "bstar": 0.00010145,
            "inclo": 1.2211597537306285,
            "nodeo": 0.29074741877272736,
            "ecco": 0.000849,
            "argpo": 5.363869775605865,
            "mo": 0.9198984715438873,
            "no": 0.06119288383060757,
            "a": 1.1391206089633688,
            "alta": 0.1400877223603787,
            "altp": 0.1381534955663588,
            "jdsatepoch": 2459633.35043914,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010986906463406477,
            "con41": -0.6479653559858612,
            "cc1": 5.1035120295387056e-11,
            "cc4": 1.1231205999443613e-9,
            "cc5": 0.000016686366651540864,
            "d2": 9.372891143193414e-20,
            "d3": 2.5661325487262957e-28,
            "d4": 8.185257715129317e-37,
            "delmo": 1.0139480721195648,
            "eta": 0.0076380586086801155,
            "argpdot": -0.000015850516171384842,
            "omgcof": 1.1273302983622163e-9,
            "sinmao": 0.795540107950744,
            "t": 242083.79358820617,
            "t2cof": 7.655268044308058e-11,
            "t3cof": 9.89380784390634e-20,
            "t4cof": 2.07142653045785e-28,
            "t5cof": 5.345737857347919e-37,
            "x1mth2": 0.8826551186619538,
            "x7thm1": -0.1785858306336764,
            "mdot": 0.06116807025775695,
            "nodedot": -0.000026197540177605435,
            "xlcof": 0.0019283694478995522,
            "xmcof": -0.0000763807286875141,
            "nodecf": -4.6885350007033046e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.725782188798938,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TIMATION 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02872",
            "epochyr": 22,
            "epochdays": 53.58850407,
            "ndot": 6.96919666594958e-13,
            "nddot": 0,
            "bstar": 0.000053122,
            "inclo": 1.2212923987537803,
            "nodeo": 2.642957322282769,
            "ecco": 0.0006531,
            "argpo": 6.004656938500071,
            "mo": 0.28009916500631,
            "no": 0.061062488444832586,
            "a": 1.1407409622438172,
            "alta": 0.14148598016625868,
            "altp": 0.13999594432137585,
            "jdsatepoch": 2459633.08850407,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010987437743978652,
            "con41": -0.6482214511056078,
            "cc1": 2.5381227302787506e-11,
            "cc4": -2.3801895058806967e-9,
            "cc5": 0.000015878496408936993,
            "d2": 2.2922030683930016e-20,
            "d3": 3.0857730062686134e-29,
            "d4": 4.839667568151411e-38,
            "delmo": 1.0168433065511813,
            "eta": 0.005809617570616764,
            "argpdot": -0.000015787971617282568,
            "omgcof": 1.1393804750608098e-9,
            "sinmao": 0.2764509502737628,
            "t": 242460.98008923233,
            "t2cof": 3.807184095418126e-11,
            "t3cof": 2.421044408272155e-20,
            "t4cof": 2.4929542251773848e-29,
            "t5cof": 3.1638049904761034e-38,
            "x1mth2": 0.8827404837018693,
            "x7thm1": -0.17918338591308502,
            "mdot": 0.061037788295217374,
            "nodedot": -0.000026058093493735045,
            "xlcof": 0.001928386721092703,
            "xmcof": -0.0000649634997658035,
            "nodecf": -2.3193208580045206e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.07548959005466571,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SURCAL 159"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02873",
            "epochyr": 22,
            "epochdays": 53.59016745,
            "ndot": 7.5752137673365e-13,
            "nddot": 0,
            "bstar": 0.000055382,
            "inclo": 1.2212749454612601,
            "nodeo": 3.4006920170361075,
            "ecco": 0.0005846,
            "argpo": 0.46525416403338044,
            "mo": 0.896296384069168,
            "no": 0.0610197396613322,
            "a": 1.1412733785739717,
            "alta": 0.14194056699108604,
            "altp": 0.14060619015685738,
            "jdsatepoch": 2459633.09016745,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010987367849684992,
            "con41": -0.6481877589958777,
            "cc1": 2.6020596051580895e-11,
            "cc4": -3.5070816249656207e-9,
            "cc5": 0.000015623956229634384,
            "d2": 2.400295572232273e-20,
            "d3": 3.300445481647974e-29,
            "d4": 5.287114858142973e-38,
            "delmo": 1.0097384984427855,
            "eta": 0.0051811845560144005,
            "argpdot": -0.000015760046041893637,
            "omgcof": 1.2073655891003525e-9,
            "sinmao": 0.7810193379576007,
            "t": 242458.5848222673,
            "t2cof": 3.903089407737134e-11,
            "t3cof": 2.5357098560081825e-20,
            "t4cof": 2.667109926176527e-29,
            "t5cof": 3.4574054385832723e-38,
            "x1mth2": 0.8827292529986259,
            "x7thm1": -0.17910477099038125,
            "mdot": 0.06099508111504977,
            "nodedot": -0.000026016837696304402,
            "xlcof": 0.0019283844516781595,
            "xmcof": -0.00008344522388509243,
            "nodecf": -2.373977157928446e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.08596952858456319,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 5712 (P/L 152)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02874",
            "epochyr": 22,
            "epochdays": 53.6005563,
            "ndot": -9.090256520803799e-14,
            "nddot": 0,
            "bstar": 0.000036128,
            "inclo": 1.2212348028884643,
            "nodeo": 4.383356019140215,
            "ecco": 0.0004573,
            "argpo": 1.3680798248342592,
            "mo": 4.917931170404306,
            "no": 0.06095357134321568,
            "a": 1.142098689644216,
            "alta": 0.1426209713749904,
            "altp": 0.14157640791344162,
            "jdsatepoch": 2459633.1005563,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010987207080107955,
            "con41": -0.6481102618342406,
            "cc1": 1.654060299763694e-11,
            "cc4": -5.518280386414723e-9,
            "cc5": 0.00001523948540678768,
            "d2": 9.644303582604917e-21,
            "d3": 8.381759364878394e-30,
            "d4": 8.486609952844368e-39,
            "delmo": 1.0024695993864494,
            "eta": 0.004030040463800507,
            "argpdot": -0.000015715285099975472,
            "omgcof": 2.1944635279905693e-10,
            "sinmao": -0.978950468535207,
            "t": 242443.6248779297,
            "t2cof": 2.481090449645541e-11,
            "t3cof": 1.019148667765579e-20,
            "t4cof": 6.776200736832281e-30,
            "t5cof": 5.5523716880580385e-39,
            "x1mth2": 0.8827034206114135,
            "x7thm1": -0.17892394427989455,
            "mdot": 0.06092897807138963,
            "nodedot": -0.000025953986812799122,
            "xlcof": 0.0019283792281445161,
            "xmcof": -0.00008720659577946408,
            "nodecf": -1.5054244010977346e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.15142331696656441,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 5712 (P/L 153)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02909",
            "epochyr": 22,
            "epochdays": 53.50572629,
            "ndot": 8.472119077389142e-11,
            "nddot": 0,
            "bstar": 0.00055618,
            "inclo": 1.2208211598557417,
            "nodeo": 3.3794827759658723,
            "ecco": 0.0005734,
            "argpo": 3.766141273123444,
            "mo": 2.51836350297065,
            "no": 0.06386883038644525,
            "a": 1.1070938666597443,
            "alta": 0.1077286742828869,
            "altp": 0.10645905903660169,
            "jdsatepoch": 2459633.00572629,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010985549423334882,
            "con41": -0.647311273202796,
            "cc1": 9.066999712427025e-10,
            "cc4": -2.123303205325495e-8,
            "cc5": 0.00005209866573432658,
            "d2": 3.8494123459441126e-17,
            "d3": 2.439779029983318e-24,
            "d4": 1.8021765579094132e-31,
            "delmo": 0.9837380754342367,
            "eta": 0.006712200614622253,
            "argpdot": -0.000017470334825038657,
            "omgcof": -5.4957554653434526e-8,
            "sinmao": 0.5836602627477325,
            "t": 242580.18009245396,
            "t2cof": 1.3600499568640538e-9,
            "t3cof": 4.013833313514416e-17,
            "t4cof": 1.9364056404706494e-24,
            "t5cof": 1.1540980950667866e-31,
            "x1mth2": 0.8824370910675987,
            "x7thm1": -0.17705963747319087,
            "mdot": 0.06384143919614803,
            "nodedot": -0.000028972561650467176,
            "xlcof": 0.0019283250880511014,
            "xmcof": -0.0022667888114132643,
            "nodecf": -9.213118076677836e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.837142757151398,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SURCAL 150B"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02920",
            "epochyr": 22,
            "epochdays": 53.58094936,
            "ndot": 3.33309405762806e-13,
            "nddot": 0,
            "bstar": 0.000027999,
            "inclo": 1.7244027542629177,
            "nodeo": 4.951008650388102,
            "ecco": 0.0038188,
            "argpo": 3.151483434460845,
            "mo": 3.133684566749007,
            "no": 0.06176799995103479,
            "a": 1.1321772392868983,
            "alta": 0.13650079772828705,
            "altp": 0.12785368084550952,
            "jdsatepoch": 2459633.08094936,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011556758929035927,
            "con41": -0.9297701687678906,
            "cc1": 1.776621131091879e-11,
            "cc4": 6.715567517677351e-8,
            "cc5": 0.000021046469708151153,
            "d2": 1.1956739451523641e-20,
            "d3": 1.1999599815663195e-29,
            "d4": 1.4031356445801695e-38,
            "delmo": 0.8953842079112704,
            "eta": 0.036165130923166214,
            "argpdot": -0.00003450378741359261,
            "omgcof": -1.6149973803462077e-10,
            "sinmao": 0.007908004415269062,
            "t": 242471.85887150466,
            "t2cof": 2.6649316966378187e-11,
            "t3cof": 1.2588015980212078e-20,
            "t4cof": 9.650996981058878e-30,
            "t5cof": 9.124962941254571e-39,
            "x1mth2": 0.9765900562559636,
            "x7thm1": -0.836130393791745,
            "mdot": 0.06173161477678849,
            "nodedot": 0.000011949163104507253,
            "xlcof": 0.0015247504158828864,
            "xmcof": -0.0000012460428083482573,
            "nodecf": 7.451031791723397e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.027891985636550487,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7202 (DMSP 4A F3)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 2965",
            "epochyr": 22,
            "epochdays": 53.80832441,
            "ndot": 2.060458144715528e-12,
            "nddot": 0,
            "bstar": 0.000084407,
            "inclo": 1.557681922795411,
            "nodeo": 2.3080356201420655,
            "ecco": 0.0045817,
            "argpo": 5.397957801226566,
            "mo": 3.0150458108446925,
            "no": 0.05907099860087627,
            "a": 1.166387247206814,
            "alta": 0.17173128365734125,
            "altp": 0.16104321075628647,
            "jdsatepoch": 2459633.30832441,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011693447157733797,
            "con41": -0.9994840668022683,
            "cc1": 1.9362228316788463e-11,
            "cc4": 2.5018299548669534e-8,
            "cc5": 0.000007920447290349603,
            "d2": 1.137583121578561e-20,
            "d3": 9.95199088230716e-30,
            "d4": 1.0140695139467068e-38,
            "delmo": 0.900088921267385,
            "eta": 0.03475674708122197,
            "argpdot": -0.000035170416887717744,
            "omgcof": 7.06551863990147e-11,
            "sinmao": 0.12620935738045064,
            "t": 242144.43879939616,
            "t2cof": 2.9043342475182693e-11,
            "t3cof": 1.21256229865685e-20,
            "t4cof": 8.142924534930174e-30,
            "t5cof": 6.728181208576764e-39,
            "x1mth2": 0.9998280222674228,
            "x7thm1": -0.9987961558719597,
            "mdot": 0.059035754691780414,
            "nodedot": -9.228293978862171e-7,
            "xlcof": 0.0017691533949595164,
            "xmcof": -0.0000011907288422640457,
            "nodecf": -6.271538743188357e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.4604430451664925,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 4947 (TRANSIT 17)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "02980",
            "epochyr": 22,
            "epochdays": 53.56774536,
            "ndot": 4.8178359560260145e-12,
            "nddot": 0,
            "bstar": 0.00004384,
            "inclo": 1.7314119965389267,
            "nodeo": 5.112179334834266,
            "ecco": 0.009804,
            "argpo": 3.7043478909565852,
            "mo": 2.570423183899137,
            "no": 0.06372275072809577,
            "a": 1.1089188743751464,
            "alta": 0.1197907150195201,
            "altp": 0.09804703373077239,
            "jdsatepoch": 2459633.06774536,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011543933595631025,
            "con41": -0.9232710405081795,
            "cc1": 7.056701571083435e-11,
            "cc4": 6.563636755333733e-7,
            "cc5": 0.00005275766018945347,
            "d2": 2.2942236360087847e-19,
            "d3": 1.1134254739849744e-27,
            "d4": 6.297521405582059e-36,
            "delmo": 0.7412246110543855,
            "eta": 0.11292121908189176,
            "argpdot": -0.000036654914971073155,
            "omgcof": -2.5345685086050576e-10,
            "sinmao": 0.5406162571661591,
            "t": 242490.87263144553,
            "t2cof": 1.0585052356625153e-10,
            "t3cof": 2.3938177101354473e-19,
            "t4cof": 8.845165671728509e-28,
            "t5cof": 4.037174184163833e-36,
            "x1mth2": 0.9744236801693932,
            "x7thm1": -0.8209657611857523,
            "mdot": 0.06368389155135382,
            "nodedot": 0.000013432481431298313,
            "xlcof": 0.001511826675441476,
            "xmcof": -5.786529820391082e-7,
            "nodecf": 3.3269775892453712e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.22788696861646,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 1264 (DMSP 4A F4)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03035",
            "epochyr": 22,
            "epochdays": 53.3830073,
            "ndot": -1.7271487389527223e-12,
            "nddot": 0,
            "bstar": -0.000058234,
            "inclo": 1.782394809318933,
            "nodeo": 1.967089041423477,
            "ecco": 0.0048553,
            "argpo": 4.3064515763095885,
            "mo": 2.1758915064858186,
            "no": 0.054751384000620205,
            "a": 1.2268507058371183,
            "alta": 0.23280743406916926,
            "altp": 0.22089397760506735,
            "jdsatepoch": 2459632.8830073,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001143362493261036,
            "con41": -0.8676710207029734,
            "cc1": -3.4680126042693467e-12,
            "cc4": 5.684704343188221e-9,
            "cc5": 0.00000220071448125817,
            "d2": 2.754099755615663e-22,
            "d3": -3.248888224871652e-32,
            "d4": 4.461418662776414e-42,
            "delmo": 0.9533124315459949,
            "eta": 0.027795494846452336,
            "argpdot": -0.000023006222722668023,
            "omgcof": 4.940801210915307e-12,
            "sinmao": 0.8224479593082407,
            "t": 242756.89543783665,
            "t2cof": -5.2020189064040204e-12,
            "t3cof": 2.994641984083084e-22,
            "t4cof": -2.733631292132747e-32,
            "t5cof": 3.058592703768339e-42,
            "x1mth2": 0.9558903402343244,
            "x7thm1": -0.6912323816402712,
            "mdot": 0.05472575255139783,
            "nodedot": 0.00001238712438018995,
            "xlcof": 0.001411069803571883,
            "xmcof": 2.5675873466308496e-7,
            "nodecf": -1.5068839715499112e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.063965493984526,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ESSA 6 (TOS-D)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03047",
            "epochyr": 22,
            "epochdays": 53.58103265,
            "ndot": 3.3330940576280603e-12,
            "nddot": 0,
            "bstar": 0.000031825,
            "inclo": 1.2917618126323032,
            "nodeo": 2.2701794286663084,
            "ecco": 0.0009265,
            "argpo": 5.537224603560202,
            "mo": 0.7467321391487659,
            "no": 0.0635505219214303,
            "a": 1.1108463685359071,
            "alta": 0.11187556769635565,
            "altp": 0.1098171693754586,
            "jdsatepoch": 2459633.08103265,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124213250092802,
            "con41": -0.7724188544787416,
            "cc1": 4.431979194169274e-11,
            "cc4": -4.53932490693051e-9,
            "cc5": 0.00004486422811393422,
            "d2": 8.881175177381534e-20,
            "d3": 2.656407227630871e-28,
            "d4": 9.259614039596503e-37,
            "delmo": 1.023235910897903,
            "eta": 0.010472742921465819,
            "argpdot": -0.00002595452016733532,
            "omgcof": 1.481383498327051e-9,
            "sinmao": 0.6792440672913101,
            "t": 242471.73893384635,
            "t2cof": 6.64796879125391e-11,
            "t3cof": 9.274023968932521e-20,
            "t4cof": 2.1125653436291965e-28,
            "t5cof": 5.9435567727716576e-37,
            "x1mth2": 0.9241396181595806,
            "x7thm1": -0.46897732711706375,
            "mdot": 0.063518217851473,
            "nodedot": -0.000022994878587186677,
            "xlcof": 0.0019290928775123632,
            "xmcof": -0.000044139329293161354,
            "nodecf": -3.5756118272756454e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.028416745212915373,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 192"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03081",
            "epochyr": 22,
            "epochdays": 53.50896277,
            "ndot": -2.3937675504783338e-12,
            "nddot": 0,
            "bstar": 0.0000080737,
            "inclo": 1.1369406360048944,
            "nodeo": 1.4670260307883218,
            "ecco": 0.0041831,
            "argpo": 4.985674379991214,
            "mo": 1.2913184990022966,
            "no": 0.06080876465227747,
            "a": 1.143825853030231,
            "alta": 0.1486105909560418,
            "altp": 0.1390411151044202,
            "jdsatepoch": 2459633.00896277,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010610981298422172,
            "con41": -0.4698611714049481,
            "cc1": 3.533402066890173e-12,
            "cc4": 5.7131009835481936e-8,
            "cc5": 0.000014563227091106168,
            "d2": 4.347217500058903e-22,
            "d3": 7.971505581964806e-32,
            "d4": 1.7029275808687807e-41,
            "delmo": 1.0304381885082998,
            "eta": 0.0364135907895914,
            "argpdot": -0.000004446744029264644,
            "omgcof": 6.459870219700977e-12,
            "sinmao": 0.9611996125207336,
            "t": 242575.51956117153,
            "t2cof": 5.3001031003352595e-12,
            "t3cof": 4.5969161033849775e-22,
            "t4cof": 6.450471774985132e-32,
            "t5cof": 1.1153374352902843e-41,
            "x1mth2": 0.8232870571349827,
            "x7thm1": 0.23699060005512096,
            "mdot": 0.06079103213731613,
            "nodedot": -0.000031698101136213953,
            "xlcof": 0.0019056890312403947,
            "xmcof": -2.2304910954103274e-7,
            "nodecf": -3.9254496353895334e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.85753383759986,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 198"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03093",
            "epochyr": 22,
            "epochdays": 53.59793726,
            "ndot": -1.7271487389527223e-12,
            "nddot": 0,
            "bstar": 0.000059804,
            "inclo": 1.8465583486100006,
            "nodeo": 0.20636598542655754,
            "ecco": 0.0318484,
            "argpo": 2.4937002553107184,
            "mo": 5.532946801563564,
            "no": 0.05602964591532346,
            "a": 1.2080913792972736,
            "alta": 0.24656715678168473,
            "altp": 0.16961560181286228,
            "jdsatepoch": 2459633.09793726,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011252612902586583,
            "con41": -0.7775904012145716,
            "cc1": 6.403343058471556e-12,
            "cc4": 8.069677158973044e-8,
            "cc5": 0.000004006967619698113,
            "d2": 1.0131452982224842e-21,
            "d3": 2.382892519687529e-31,
            "d4": 6.525218569113791e-41,
            "delmo": 1.4968728845750183,
            "eta": 0.19673689898414418,
            "argpdot": -0.000019655032761246516,
            "omgcof": -2.4852380915488037e-12,
            "sinmao": -0.6818132525386011,
            "t": 242447.3962958157,
            "t2cof": 9.605014587707334e-12,
            "t3cof": 1.0951509028714359e-21,
            "t4cof": 1.988358772384586e-31,
            "t5cof": 4.4299396742790437e-41,
            "x1mth2": 0.9258634670715239,
            "x7thm1": -0.48104426950066703,
            "mdot": 0.05600536776928863,
            "nodedot": 0.000016983981623952235,
            "xlcof": 0.0012668693908564727,
            "xmcof": -8.188092229703042e-9,
            "nodecf": 3.8104140947208685e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.13492234726540886,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "EXPLORER 36 (GEOS 2)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03129",
            "epochyr": 22,
            "epochdays": 53.17350872,
            "ndot": 3.423996622836098e-12,
            "nddot": 0,
            "bstar": 0.00033754,
            "inclo": 1.2924616896623529,
            "nodeo": 5.259797537638695,
            "ecco": 0.0011544,
            "argpo": 1.707939063428855,
            "mo": 0.3193010053353546,
            "no": 0.05754446734806646,
            "a": 1.186805777577168,
            "alta": 0.1881758261668034,
            "altp": 0.18543572898753302,
            "jdsatepoch": 2459632.67350872,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011244384034134799,
            "con41": -0.7735294655118812,
            "cc1": 4.647401151902528e-11,
            "cc4": 1.1553225292880308e-9,
            "cc5": 0.000004844520239860954,
            "d2": 5.883333613074303e-20,
            "d3": 1.10807852614571e-28,
            "d4": 2.4303147339309978e-37,
            "delmo": 1.0225596682711084,
            "eta": 0.007861392495374698,
            "argpdot": -0.000020650853106974807,
            "omgcof": -1.2118910307806398e-10,
            "sinmao": 0.3139029733298251,
            "t": 243058.57339315116,
            "t2cof": 6.971101727853792e-11,
            "t3cof": 6.315300362408402e-20,
            "t4cof": 9.155949323011162e-29,
            "t5cof": 1.631081787635928e-37,
            "x1mth2": 0.9245098218372938,
            "x7thm1": -0.47156875286105615,
            "mdot": 0.057518804286840676,
            "nodedot": -0.000018201021688283318,
            "xlcof": 0.0019290138711182668,
            "xmcof": -0.000050602317770792746,
            "nodecf": -2.9668650255030528e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 3.74404313327652,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 203"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03133",
            "epochyr": 22,
            "epochdays": 53.61157238,
            "ndot": 1.878653014299452e-12,
            "nddot": 0,
            "bstar": 0.000080234,
            "inclo": 1.5707561842221007,
            "nodeo": 4.739900605383877,
            "ecco": 0.0073682,
            "argpo": 4.066929571082895,
            "mo": 3.1373113609346515,
            "no": 0.058989259364305935,
            "a": 1.1674638848680374,
            "alta": 0.17606599226452202,
            "altp": 0.1588617774715526,
            "jdsatepoch": 2459633.11157238,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694452784287628,
            "con41": -0.9999999951657215,
            "cc1": 1.8077956915918584e-11,
            "cc4": 4.415975760000433e-8,
            "cc5": 0.000007805402453545125,
            "d2": 9.856891036082772e-21,
            "d3": 8.002213240420208e-30,
            "d4": 7.566702321273523e-39,
            "delmo": 0.8424172906471794,
            "eta": 0.055557497569463724,
            "argpdot": -0.000035089512529932614,
            "omgcof": -3.8270669459566794e-11,
            "sinmao": 0.004281279576185168,
            "t": 242427.7617225051,
            "t2cof": 2.7116935373877876e-11,
            "t3cof": 1.0510516088590389e-20,
            "t4cof": 6.551007541663778e-30,
            "t5cof": 5.0234527047473217e-39,
            "x1mth2": 0.9999999983885739,
            "x7thm1": -0.9999999887200169,
            "mdot": 0.05895410922521696,
            "nodedot": -2.8159037630287545e-9,
            "xlcof": 0.0017542148603009527,
            "xmcof": -4.2817970175850153e-7,
            "nodecf": -1.7866870129579842e-19,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.22082889727712285,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7034 (TRANSIT 18)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 3158",
            "epochyr": 22,
            "epochdays": 53.5625486,
            "ndot": -1.848352159230106e-12,
            "nddot": 0,
            "bstar": 0.000019721,
            "inclo": 1.1402951588272274,
            "nodeo": 6.260223755540348,
            "ecco": 0.0036121,
            "argpo": 3.246645766596584,
            "mo": 3.0376582966335306,
            "no": 0.06100653618221027,
            "a": 1.1413570619391062,
            "alta": 0.1454797577825364,
            "altp": 0.13723436609567607,
            "jdsatepoch": 2459633.0625486,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010627412483936323,
            "con41": -0.4775162915688832,
            "cc1": 9.303376713030651e-12,
            "cc4": 5.253830307119774e-8,
            "cc5": 0.00001564818190901838,
            "d2": 3.06491987508879e-21,
            "d3": 1.5050637392562495e-30,
            "d4": 8.610498263844726e-40,
            "delmo": 0.907589077021361,
            "eta": 0.03197699769569823,
            "argpdot": -0.000004964918992331882,
            "omgcof": -7.439894396248914e-11,
            "sinmao": 0.10374733543867216,
            "t": 242498.35596576333,
            "t2cof": 1.3955065069545976e-11,
            "t3cof": 3.238025511617912e-21,
            "t4cof": 1.216353200706529e-30,
            "t5cof": 5.631217351924696e-40,
            "x1mth2": 0.8258387638562944,
            "x7thm1": 0.2191286530059391,
            "mdot": 0.060988377895710454,
            "nodedot": -0.00003170653939284703,
            "xlcof": 0.001907031959504606,
            "xmcof": -7.752330154331062e-7,
            "nodecf": -1.0338726098187662e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.1951453641199095,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 209"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 3229",
            "epochyr": 22,
            "epochdays": 53.68279922,
            "ndot": 1.1726430911836904e-11,
            "nddot": 0,
            "bstar": 0.000060237,
            "inclo": 1.2920113947153382,
            "nodeo": 0.6706881436393729,
            "ecco": 0.0037496,
            "argpo": 6.0544843433152575,
            "mo": 0.22904304839771986,
            "no": 0.06445155830916999,
            "a": 1.100476226971767,
            "alta": 0.10460257263242023,
            "altp": 0.09634988131111366,
            "jdsatepoch": 2459633.18279922,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242936048543734,
            "con41": -0.7728151939057412,
            "cc1": 1.327571052877502e-10,
            "cc4": 3.1420336397025874e-7,
            "cc5": 0.00007039826155034556,
            "d2": 8.8263448675231e-19,
            "d3": 8.763223164475647e-27,
            "d4": 1.0140705326527438e-34,
            "delmo": 1.1435235380666726,
            "eta": 0.046945102662549316,
            "argpdot": -0.000026850054454343994,
            "omgcof": 1.628128630455576e-9,
            "sinmao": 0.22704566767468462,
            "t": 242325.19507303834,
            "t2cof": 1.991356579316253e-10,
            "t3cof": 9.178833847610755e-19,
            "t4cof": 6.929794798902146e-27,
            "t5cof": 6.466546420316105e-35,
            "x1mth2": 0.9242717313019138,
            "x7thm1": -0.4699021191133961,
            "mdot": 0.06441815799072854,
            "nodedot": -0.000023741612589683195,
            "xlcof": 0.0019290648999648581,
            "xmcof": -0.000007196435210384082,
            "nodecf": -1.1058707284880898e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.6695856317611728,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 220"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03266",
            "epochyr": 22,
            "epochdays": 53.54780504,
            "ndot": -1.21203420277384e-13,
            "nddot": 0,
            "bstar": 0.00001979,
            "inclo": 1.722728983510255,
            "nodeo": 4.815215053265936,
            "ecco": 0.0053566,
            "argpo": 2.4551005535736117,
            "mo": 3.836956262193862,
            "no": 0.06179180883906034,
            "a": 1.131887355145572,
            "alta": 0.13795042295214466,
            "altp": 0.1258242873389992,
            "jdsatepoch": 2459633.04780504,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011559737596286972,
            "con41": -0.9312806156229487,
            "cc1": 1.2767953925703773e-11,
            "cc4": 1.0756174037976973e-7,
            "cc5": 0.000021424600663608127,
            "d2": 6.1888790567392636e-21,
            "d3": 4.473467814590843e-30,
            "d4": 3.767530877424437e-39,
            "delmo": 0.8874056446796305,
            "eta": 0.050839188277856356,
            "argpdot": -0.0000346338507647333,
            "omgcof": -6.376000729392288e-11,
            "sinmao": -0.640664668126283,
            "t": 242519.5866921544,
            "t2cof": 1.915193088855566e-11,
            "t3cof": 6.514920351637052e-21,
            "t4cof": 3.597362429176647e-30,
            "t5cof": 2.4496952871163114e-39,
            "x1mth2": 0.9770935385409829,
            "x7thm1": -0.8396547697868804,
            "mdot": 0.06175533104682287,
            "nodedot": 0.00001183086317861677,
            "xlcof": 0.001527803797574059,
            "xmcof": -4.5102097364752657e-7,
            "nodecf": 5.301739371274685e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.102255214191629,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7869 (DMSP 4B F1)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03338",
            "epochyr": 22,
            "epochdays": 53.5364365,
            "ndot": 2.363466695408988e-12,
            "nddot": 0,
            "bstar": 0.000084289,
            "inclo": 1.4078087545974063,
            "nodeo": 3.6862907145154513,
            "ecco": 0.1131879,
            "argpo": 4.989009704191775,
            "mo": 1.0835492688571355,
            "no": 0.053386490074744844,
            "a": 1.2476913037277408,
            "alta": 0.3889148622449461,
            "altp": 0.10646774521053559,
            "jdsatepoch": 2459633.0364365,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011539465084080412,
            "con41": -0.9210083555916125,
            "cc1": 2.9851539341254275e-11,
            "cc4": 5.535785189217272e-7,
            "cc5": 0.000016002248563755513,
            "d2": 1.8914279227358447e-20,
            "d3": 1.7788251043398326e-29,
            "d4": 1.947056515879971e-38,
            "delmo": 2.1030809280360665,
            "eta": 0.6006152361733453,
            "argpdot": -0.00002478558925419802,
            "omgcof": 1.3132775993176084e-13,
            "sinmao": 0.8836251193152542,
            "t": 242535.95738992095,
            "t2cof": 4.477730901188141e-11,
            "t3cof": 2.069650802944335e-20,
            "t4cof": 1.5101552175450316e-29,
            "t5cof": 1.3489566041966535e-38,
            "x1mth2": 0.9736694518638708,
            "x7thm1": -0.8156861630470957,
            "mdot": 0.05336033999693801,
            "nodedot": -0.000009257188026245552,
            "xlcof": 0.0018920250359910548,
            "xmcof": -5.091303935855523e-10,
            "nodecf": -9.570543569683573e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.030628999342682,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "EXPLORER 40 (INJUN-5)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03345",
            "epochyr": 22,
            "epochdays": 53.57562618,
            "ndot": -1.121131637565802e-12,
            "nddot": 0,
            "bstar": 0.00003591,
            "inclo": 1.7693100759167315,
            "nodeo": 0.9640535562900918,
            "ecco": 0.002677,
            "argpo": 0.08696277530986946,
            "mo": 1.8460330045051505,
            "no": 0.05469758412422383,
            "a": 1.2276614356450863,
            "alta": 0.23094788530830823,
            "altp": 0.22437498598186445,
            "jdsatepoch": 2459633.07562618,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011464782719200833,
            "con41": -0.8833217048015207,
            "cc1": 2.099306441654409e-12,
            "cc4": 2.4834027055803626e-9,
            "cc5": 0.000002161586012166002,
            "d2": 1.0060687899831944e-22,
            "d3": 7.161804209967082e-33,
            "d4": 5.9346777591658596e-43,
            "delmo": 0.9875951882968037,
            "eta": 0.015277925210255613,
            "argpdot": -0.00002371836201861861,
            "omgcof": 1.3706115083160815e-11,
            "sinmao": 0.962360901565805,
            "t": 242479.52425070107,
            "t2cof": 3.1489596624816136e-12,
            "t3cof": 1.0942105407026283e-22,
            "t4cof": 6.028096733076065e-33,
            "t5cof": 4.0702889777698254e-43,
            "x1mth2": 0.9611072349338402,
            "x7thm1": -0.7277506445368815,
            "mdot": 0.05467155098250182,
            "nodedot": 0.000011604095846809979,
            "xlcof": 0.001438073974504544,
            "xmcof": -5.146759292892655e-7,
            "nodecf": 8.545533525463458e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.27753919291392,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ESSA 7 (TOS-E)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03504",
            "epochyr": 22,
            "epochdays": 53.60402371,
            "ndot": -6.36317956456266e-13,
            "nddot": 0,
            "bstar": 0.000027891,
            "inclo": 1.0879998584497212,
            "nodeo": 4.137266339938266,
            "ecco": 0.1026447,
            "argpo": 1.0238799523899536,
            "mo": 5.429246318727069,
            "no": 0.056552651580295474,
            "a": 1.200446640575623,
            "alta": 0.3236661258635154,
            "altp": 0.07722715528773016,
            "jdsatepoch": 2459633.10402371,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010357778071555448,
            "con41": -0.3533940299218463,
            "cc1": 3.891026895271546e-11,
            "cc4": 0.000002269260004825908,
            "cc5": 0.000060851349002385264,
            "d2": 3.865331686564556e-20,
            "d3": 5.709575543796469e-29,
            "d4": 9.81994395719499e-38,
            "delmo": 2.926906976696738,
            "eta": 0.6551410914885354,
            "argpdot": 0.0000024767262089652014,
            "omgcof": 2.6469700745298583e-13,
            "sinmao": -0.753874236121348,
            "t": 242438.6318077147,
            "t2cof": 5.836540342907319e-11,
            "t3cof": 4.1681334925590864e-20,
            "t4cof": 4.748112569032661e-29,
            "t5cof": 6.640243080385477e-38,
            "x1mth2": 0.7844646766406155,
            "x7thm1": 0.5087472635156916,
            "mdot": 0.0565412113605816,
            "nodedot": -0.000030199209921778247,
            "xlcof": 0.0018820705888835043,
            "xmcof": -4.156993377953446e-10,
            "nodecf": -4.073307401926562e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.17326934484403722,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 249"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03510",
            "epochyr": 22,
            "epochdays": 53.3681322,
            "ndot": 1.484741898397954e-12,
            "nddot": 0,
            "bstar": 0.000036967,
            "inclo": 1.7167267962126465,
            "nodeo": 3.5309948083315,
            "ecco": 0.0029031,
            "argpo": 4.824542092788594,
            "mo": 1.454936135059757,
            "no": 0.06231324532150778,
            "a": 1.125571613396434,
            "alta": 0.128839260347285,
            "altp": 0.12230396644558272,
            "jdsatepoch": 2459632.8681322,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011570152826392804,
            "con41": -0.9365651154632892,
            "cc1": 2.941576174234213e-11,
            "cc4": 5.754935754889442e-8,
            "cc5": 0.000026191828493320593,
            "d2": 3.449500326294492e-20,
            "d3": 6.033868954234129e-29,
            "d4": 1.2298262857188475e-37,
            "delmo": 1.0100677683069408,
            "eta": 0.028933301746324983,
            "argpdot": -0.000035667294297055146,
            "omgcof": 4.2144138126012585e-11,
            "sinmao": 0.9932957126522074,
            "t": 242778.31558182836,
            "t2cof": 4.412364261351319e-11,
            "t3cof": 3.62255773407094e-20,
            "t4cof": 4.836174024204452e-29,
            "t5cof": 7.965857852063467e-38,
            "x1mth2": 0.978855038487763,
            "x7thm1": -0.8519852694143414,
            "mdot": 0.06227583568507625,
            "nodedot": 0.000011590918498897766,
            "xlcof": 0.0015386498603716097,
            "xmcof": -0.000003396497669414386,
            "nodecf": 1.1967631905937375e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.970246591005363,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 4078 (DMSP 4B F2)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 3530",
            "epochyr": 22,
            "epochdays": 53.75303474,
            "ndot": -2.0907589997848738e-12,
            "nddot": 0,
            "bstar": 0.000015936,
            "inclo": 1.0876385752945583,
            "nodeo": 1.0261384084420342,
            "ecco": 0.101851,
            "argpo": 1.5819193101178564,
            "mo": 4.906511481108508,
            "no": 0.056189344545261435,
            "a": 1.2056137796984303,
            "alta": 0.32840674877449505,
            "altp": 0.08282081062236535,
            "jdsatepoch": 2459633.25303474,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010355815902244815,
            "con41": -0.35250246415991066,
            "cc1": 1.66509136086074e-11,
            "cc4": 0.000001683137380657407,
            "cc5": 0.0000455057509971539,
            "d2": 6.91872242245993e-21,
            "d3": 4.273859657434116e-30,
            "d4": 3.0738434919197215e-39,
            "delmo": 1.4146383946667462,
            "eta": 0.6354115109771071,
            "argpdot": 0.000002486985705624767,
            "omgcof": -2.8277685653781622e-15,
            "sinmao": -0.9812173218161633,
            "t": 242224.05592404306,
            "t2cof": 2.49763704129111e-11,
            "t3cof": 7.473228270462544e-21,
            "t4cof": 3.562545177303731e-30,
            "t5cof": 2.0842813858211718e-39,
            "x1mth2": 0.7841674880533036,
            "x7thm1": 0.510827583626875,
            "mdot": 0.0561781062422765,
            "nodedot": -0.000029759531231211934,
            "xlcof": 0.0018818685577176363,
            "xmcof": -2.2143559189773243e-10,
            "nodecf": -1.7179794982283386e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.1120966669488084,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 252"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03576",
            "epochyr": 22,
            "epochdays": 53.60551823,
            "ndot": -7.241904361573694e-12,
            "nddot": 0,
            "bstar": -0.00057118,
            "inclo": 1.292391876492273,
            "nodeo": 5.109526434371236,
            "ecco": 0.0034358,
            "argpo": 4.411045667723105,
            "mo": 2.1274743277062442,
            "no": 0.057482561278410595,
            "a": 1.1876571639493732,
            "alta": 0.19173771643327053,
            "altp": 0.183576611465476,
            "jdsatepoch": 2459633.10551823,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011244159689577566,
            "con41": -0.773418793369986,
            "cc1": -7.730798386053531e-11,
            "cc4": 9.916831514792689e-9,
            "cc5": 0.000004769542631510019,
            "d2": 1.6212337490225803e-19,
            "d3": -5.058081065057425e-28,
            "d4": 1.837669172127735e-36,
            "delmo": 0.9635191053724402,
            "eta": 0.023300477716509817,
            "argpdot": -0.000020593421902004433,
            "omgcof": 1.4582515324042647e-10,
            "sinmao": 0.8490150328202509,
            "t": 242436.47969909012,
            "t2cof": -1.1596197579080296e-10,
            "t3cof": 1.740764236394196e-19,
            "t4cof": -4.1811145625395555e-28,
            "t5cof": 1.2339102638820402e-36,
            "x1mth2": 0.9244729311233286,
            "x7thm1": -0.4713105178633006,
            "mdot": 0.05745696583126862,
            "nodedot": -0.00001816024258916577,
            "xlcof": 0.0019290218290878775,
            "xmcof": 0.000009519405703512678,
            "nodecf": 4.9241567009630435e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.18268540009844259,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 256"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 3597",
            "epochyr": 22,
            "epochdays": 53.7625358,
            "ndot": 2.9391829417265622e-12,
            "nddot": 0,
            "bstar": 0.000031989,
            "inclo": 0.6107308478456118,
            "nodeo": 3.7595456738801576,
            "ecco": 0.000639,
            "argpo": 4.514325526209869,
            "mo": 1.7688109117506612,
            "no": 0.06304847709572867,
            "a": 1.1158654880489665,
            "alta": 0.11657852609582986,
            "altp": 0.11515245000210328,
            "jdsatepoch": 2459633.2625358,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0006706375100850034,
            "con41": 1.0134090533198785,
            "cc1": 3.703967830020077e-11,
            "cc4": 9.534000080806653e-8,
            "cc5": 0.000035720499713527275,
            "d2": 5.883423776487474e-20,
            "d3": 1.3945303791711369e-28,
            "d4": 3.851884561609645e-37,
            "delmo": 0.9959623583168351,
            "eta": 0.0068507258114561395,
            "argpdot": 0.00009703649773591681,
            "omgcof": -2.558985233299823e-10,
            "sinmao": 0.9804590870119848,
            "t": 242210.37439763546,
            "t2cof": 5.555951745030116e-11,
            "t3cof": 6.157811330203948e-20,
            "t4cof": 1.112544224913712e-28,
            "t5cof": 2.4815349244344757e-37,
            "x1mth2": 0.32886364889337383,
            "x7thm1": 3.697954457746383,
            "mdot": 0.0630901558278983,
            "nodedot": -0.00006751788118074501,
            "xlcof": 0.001307955486224694,
            "xmcof": -0.0000779154977409132,
            "nodecf": -8.725298966267634e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.1719570323486082,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OAO 2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03605",
            "epochyr": 22,
            "epochdays": 53.55495541,
            "ndot": 7.272205216643039e-13,
            "nddot": 0,
            "bstar": 0.00010293,
            "inclo": 1.402637344023747,
            "nodeo": 5.836316441486714,
            "ecco": 0.0054366,
            "argpo": 3.9587069401544825,
            "mo": 5.339976218146063,
            "no": 0.0550272642967682,
            "a": 1.2227706415876534,
            "alta": 0.22941835645770858,
            "altp": 0.21612292671759792,
            "jdsatepoch": 2459633.05495541,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011529497439564532,
            "con41": -0.9159642746273873,
            "cc1": 6.636558183859245e-12,
            "cc4": 7.08013207594474e-9,
            "cc5": 0.000002373324265358067,
            "d2": 1.0248172449109783e-21,
            "d3": 2.351113158370026e-31,
            "d4": 6.279137474895435e-41,
            "delmo": 1.0567505808478295,
            "eta": 0.0316248155869831,
            "argpdot": -0.000025673104061417425,
            "omgcof": -1.5088542701333915e-11,
            "sinmao": -0.809446621224779,
            "t": 242509.2901597917,
            "t2cof": 9.954837275788869e-12,
            "t3cof": 1.1129050539664765e-21,
            "t4cof": 1.9746801453638093e-31,
            "t5cof": 4.295655845123692e-41,
            "x1mth2": 0.9719880915424625,
            "x7thm1": -0.8039166407972371,
            "mdot": 0.05499988763755859,
            "nodedot": -0.000009986475471685621,
            "xlcof": 0.0018947250890682626,
            "xmcof": -3.8487140845306665e-7,
            "nodecf": -2.325104056602456e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.147305318333039,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7684"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03615",
            "epochyr": 22,
            "epochdays": 53.51136211,
            "ndot": -6.36317956456266e-13,
            "nddot": 0,
            "bstar": 0.00013576,
            "inclo": 1.7711130010340417,
            "nodeo": 0.19135091787165032,
            "ecco": 0.0031907,
            "argpo": 2.7445302487610834,
            "mo": 3.5430114002314808,
            "no": 0.0548387522894407,
            "a": 1.2255540786534258,
            "alta": 0.2294644540521853,
            "altp": 0.2216437032546663,
            "jdsatepoch": 2459633.01136211,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011460606016104793,
            "con41": -0.8812212576581899,
            "cc1": 8.266503147185938e-12,
            "cc4": 3.3635580256741234e-9,
            "cc5": 0.000002246119776116261,
            "d2": 1.5727142405978e-21,
            "d3": 4.444831400042928e-31,
            "d4": 1.4623422318802353e-40,
            "delmo": 0.9501550726586055,
            "eta": 0.018358285917475223,
            "argpdot": -0.000023758105802406172,
            "omgcof": -4.2368817749655585e-11,
            "sinmao": -0.3907247021435623,
            "t": 242572.06451185048,
            "t2cof": 1.2399754720778907e-11,
            "t3cof": 1.70938438916267e-21,
            "t4cof": 3.737771269283445e-31,
            "t5cof": 1.0018585938749814e-40,
            "x1mth2": 0.9604070858860634,
            "x7thm1": -0.7228496012024435,
            "mdot": 0.054812624280073004,
            "nodedot": 0.000011778749545336088,
            "xlcof": 0.0014344005270408332,
            "xmcof": -0.0000014131577520170852,
            "nodecf": 3.415645518124965e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.872650609552167,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ESSA 8 (TOS-F)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03669",
            "epochyr": 22,
            "epochdays": 53.4616871,
            "ndot": 1.151432492635148e-12,
            "nddot": 0,
            "bstar": 0.000019206,
            "inclo": 1.5433667322705535,
            "nodeo": 5.559074380465919,
            "ecco": 0.171148,
            "argpo": 3.262315332620989,
            "mo": 2.976039447391871,
            "no": 0.04930896834141509,
            "a": 1.3155600912669683,
            "alta": 0.5407155697671275,
            "altp": 0.09040461276680922,
            "jdsatepoch": 2459632.9616871,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011690053717810726,
            "con41": -0.9977434180555663,
            "cc1": 1.0909627875427152e-11,
            "cc4": 9.049044873274529e-7,
            "cc5": 0.000027883614288276263,
            "d2": 2.0670320549393885e-21,
            "d3": 5.7993969255936645e-31,
            "d4": 1.892642051640812e-40,
            "delmo": 0.019049951229388955,
            "eta": 0.7430861629459027,
            "argpdot": -0.000024425849046656977,
            "omgcof": -1.8941250709208498e-14,
            "sinmao": 0.16479799857691624,
            "t": 242643.5965257883,
            "t2cof": 1.6364441813140728e-11,
            "t3cof": 2.3050720156999826e-21,
            "t4cof": 5.0585258023665375e-31,
            "t5cof": 1.353888978391898e-40,
            "x1mth2": 0.9992478060185221,
            "x7thm1": -0.9947346421296548,
            "mdot": 0.049284831467548834,
            "nodedot": -0.0000013443604826504508,
            "xlcof": 0.0017847135340327777,
            "xmcof": -2.248794987529725e-11,
            "nodecf": -4.994745694976015e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.559678769754484,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ISIS 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03673",
            "epochyr": 22,
            "epochdays": 53.47233687,
            "ndot": -1.8180513041607598e-13,
            "nddot": 0,
            "bstar": -0.000068724,
            "inclo": 1.4031382535190693,
            "nodeo": 0.559571756811154,
            "ecco": 0.0023165,
            "argpo": 3.606377324054387,
            "mo": 4.805497059990831,
            "no": 0.05515544527999454,
            "a": 1.220876893360793,
            "alta": 0.22370505468426338,
            "altp": 0.21804873203732256,
            "jdsatepoch": 2459632.97233687,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011530476409378717,
            "con41": -0.9164594847981473,
            "cc1": -4.576302116446547e-12,
            "cc4": 2.2356201815099137e-9,
            "cc5": 0.0000024436924782589414,
            "d2": 4.909640442753162e-22,
            "d3": -7.825995425085395e-32,
            "d4": 1.4522332368616944e-41,
            "delmo": 1.0037915925223013,
            "eta": 0.013576650097658155,
            "argpdot": -0.000025836170722392316,
            "omgcof": 3.239337421992342e-11,
            "sinmao": -0.995668573249037,
            "t": 242628.26085694134,
            "t2cof": -6.86445317466982e-12,
            "t3cof": 5.328491263973025e-22,
            "t4cof": -6.56749635603423e-32,
            "t5cof": 9.925201096764957e-42,
            "x1mth2": 0.9721531615993824,
            "x7thm1": -0.8050721311956768,
            "mdot": 0.055127905760703214,
            "nodedot": -0.000010010640683556408,
            "xlcof": 0.0018944679243278208,
            "xmcof": 0.00000145661893796077,
            "nodecf": 1.607230027028183e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.626776454122975,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 2644"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03764",
            "epochyr": 22,
            "epochdays": 53.39704637,
            "ndot": -1.605945318675338e-12,
            "nddot": 0,
            "bstar": -0.000061119,
            "inclo": 1.771978684343031,
            "nodeo": 1.7306039090952534,
            "ecco": 0.0050619,
            "argpo": 5.089922896212835,
            "mo": 1.3722180004907376,
            "no": 0.054560273736082646,
            "a": 1.229717657353712,
            "alta": 0.2359423651634709,
            "altp": 0.2234929495439535,
            "jdsatepoch": 2459632.89704637,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011458587312884866,
            "con41": -0.8802063342990573,
            "cc1": -3.4486391805622343e-12,
            "cc4": 5.596379137205844e-9,
            "cc5": 0.0000020924943152739323,
            "d2": 2.6937808957263036e-22,
            "d3": -3.125259340144467e-32,
            "d4": 4.2206726727346105e-42,
            "delmo": 1.0170595976528114,
            "eta": 0.028662912804908403,
            "argpdot": -0.000023429147408348158,
            "omgcof": -4.3394302400073e-12,
            "sinmao": 0.9803480302742568,
            "t": 242736.67917720973,
            "t2cof": -5.1729587708433515e-12,
            "t3cof": 2.9316431396804827e-22,
            "t4cof": -2.6328946185098637e-32,
            "t5cof": 2.897797274657686e-42,
            "x1mth2": 0.9600687780996858,
            "x7thm1": -0.7204814466978005,
            "mdot": 0.05453448330446365,
            "nodedot": 0.000011689849157816067,
            "xlcof": 0.0014326313318567907,
            "xmcof": 2.3769805357547474e-7,
            "nodecf": -1.4141449619528867e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.152417082780104,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ESSA 9 (TOS-G)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03818",
            "epochyr": 22,
            "epochdays": 53.56887865,
            "ndot": 1.21203420277384e-12,
            "nddot": 0,
            "bstar": 0.00015396,
            "inclo": 1.2913691135506042,
            "nodeo": 1.9334966893103422,
            "ecco": 0.0020014,
            "argpo": 4.282950717931485,
            "mo": 3.8724998924107266,
            "no": 0.05752923926218703,
            "a": 1.1870142877528007,
            "alta": 0.18938997814830905,
            "altp": 0.18463859735729216,
            "jdsatepoch": 2459633.06887865,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124086676001238,
            "con41": -0.7717946016632888,
            "cc1": 2.1109901452755557e-11,
            "cc4": 4.472810989445881e-9,
            "cc5": 0.000004826108287600537,
            "d2": 1.2126364639056905e-20,
            "d3": 1.0363468405259383e-29,
            "d4": 1.0313918230198694e-38,
            "delmo": 0.969894336128938,
            "eta": 0.013615453636209498,
            "argpdot": -0.000020542714404111478,
            "omgcof": -9.646472898414404e-11,
            "sinmao": -0.6675454116128596,
            "t": 242489.2406936735,
            "t2cof": 3.1664852179133335e-11,
            "t3cof": 1.3017620517747006e-20,
            "t4cof": 8.564078296186972e-30,
            "t5cof": 6.922880547631585e-39,
            "x1mth2": 0.923931533887763,
            "x7thm1": -0.4675207372143405,
            "mdot": 0.057503649434238455,
            "nodedot": -0.000018259521670441514,
            "xlcof": 0.001929136456545544,
            "xmcof": -0.000007649914322759036,
            "nodecf": -1.3519601722858335e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.235027136205119,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 272"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03890",
            "epochyr": 22,
            "epochdays": 53.51049113,
            "ndot": -8.787247970110339e-13,
            "nddot": 0,
            "bstar": 0.000025798,
            "inclo": 1.743105702527289,
            "nodeo": 5.57395331233917,
            "ecco": 0.003904,
            "argpo": 3.6352223806020976,
            "mo": 5.671707458414121,
            "no": 0.058611319865201204,
            "a": 1.1724325484727212,
            "alta": 0.17700972514195845,
            "altp": 0.16785537180348364,
            "jdsatepoch": 2459633.01049113,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011521274711580305,
            "con41": -0.9118064817975062,
            "cc1": 5.054129488126936e-12,
            "cc4": 1.7247915421067486e-8,
            "cc5": 0.000006798606229994412,
            "d2": 7.4947255945931615e-22,
            "d3": 1.6544532799116633e-31,
            "d4": 4.2536179699933084e-41,
            "delmo": 1.0720037944516494,
            "eta": 0.02863603109468953,
            "argpdot": -0.00002950135710983803,
            "omgcof": -2.8378105669934752e-11,
            "sinmao": -0.5740781498891007,
            "t": 242573.31872284412,
            "t2cof": 7.581194232190405e-12,
            "t3cof": 8.005610092248247e-22,
            "t4cof": 1.3577054963386884e-31,
            "t5cof": 2.831942152280229e-41,
            "x1mth2": 0.9706021605991688,
            "x7thm1": -0.7942151241941815,
            "mdot": 0.058579746746947416,
            "nodedot": 0.000011850653409599512,
            "xlcof": 0.0014897706485194494,
            "xmcof": -4.437907599733456e-7,
            "nodecf": 2.1016852522928411e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.86716309842852,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "NIMBUS 3"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "03891",
            "epochyr": 22,
            "epochdays": 53.60241912,
            "ndot": -9.39326507149726e-13,
            "nddot": 0,
            "bstar": 0.000020999,
            "inclo": 1.7426047930319666,
            "nodeo": 5.516423769534933,
            "ecco": 0.0039909,
            "argpo": 2.539269056751038,
            "mo": 4.88049560327828,
            "no": 0.058625785153142,
            "a": 1.1722400564437712,
            "alta": 0.17691834928503258,
            "altp": 0.16756176360250974,
            "jdsatepoch": 2459633.10241912,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001152227764340569,
            "con41": -0.91231345182845,
            "cc1": 4.134957008409685e-12,
            "cc4": 1.7874397404634904e-8,
            "cc5": 0.000006832138018556217,
            "d2": 5.021782504474746e-22,
            "d3": 9.078992421913473e-32,
            "d4": 1.9117162116319982e-41,
            "delmo": 1.0147813127614085,
            "eta": 0.02930398995377447,
            "argpdot": -0.00002954750628640322,
            "omgcof": -2.1279045880672022e-11,
            "sinmao": -0.9859033261052167,
            "t": 242440.9424174577,
            "t2cof": 6.2024355126145276e-12,
            "t3cof": 5.363739893702674e-22,
            "t4cof": 7.449864698072283e-32,
            "t5cof": 1.27263007847773e-41,
            "x1mth2": 0.9707711506094834,
            "x7thm1": -0.7953980542663835,
            "mdot": 0.058594176268512974,
            "nodedot": 0.000011823338314650309,
            "xlcof": 0.0014907281794948849,
            "xmcof": -3.4698702053570917e-7,
            "nodecf": 1.715500413499862e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.16315980448521117,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SECOR 13 (EGRS 13)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04047",
            "epochyr": 22,
            "epochdays": 53.60282342,
            "ndot": 5.45415391248228e-13,
            "nddot": 0,
            "bstar": 0.000024437,
            "inclo": 1.7216556060202786,
            "nodeo": 4.915972910983568,
            "ecco": 0.0043967,
            "argpo": 3.5708877990443346,
            "mo": 2.7107005318696773,
            "no": 0.06237740027653705,
            "a": 1.124798262192902,
            "alta": 0.12974366271228566,
            "altp": 0.11985286167351838,
            "jdsatepoch": 2459633.10282342,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011561630752054415,
            "con41": -0.9322408147921197,
            "cc1": 2.0110133301654143e-11,
            "cc4": 1.1140104659644851e-7,
            "cc5": 0.000027096235396752756,
            "d2": 1.6222076240396823e-20,
            "d3": 1.9519851019300148e-29,
            "d4": 2.7368954635544735e-38,
            "delmo": 0.8845695979220888,
            "eta": 0.04409033326443826,
            "argpdot": -0.000035466679983624125,
            "omgcof": -1.547079408465394e-10,
            "sinmao": 0.41768154451997414,
            "t": 242440.36022521555,
            "t2cof": 3.016519995248121e-11,
            "t3cof": 1.7030911163217422e-20,
            "t4cof": 1.5638904833993233e-29,
            "t5cof": 1.7719125630650623e-38,
            "x1mth2": 0.9774136049307066,
            "x7thm1": -0.8418952345149462,
            "mdot": 0.062340073165928024,
            "nodedot": 0.000012008648898976066,
            "xlcof": 0.0015297552817719832,
            "xmcof": -9.999279404839498e-7,
            "nodecf": 8.476383283503248e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.16570705245353423,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 1127 (DMSP 4B F3)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4070",
            "epochyr": 22,
            "epochdays": 53.68047289,
            "ndot": 3.48459833297479e-12,
            "nddot": 0,
            "bstar": 0.000034088,
            "inclo": 1.2923796591875092,
            "nodeo": 0.749447871464869,
            "ecco": 0.0009347,
            "argpo": 0.6120712607111434,
            "mo": 5.674213751219985,
            "no": 0.06346116220456731,
            "a": 1.1118886845157632,
            "alta": 0.11292796686918005,
            "altp": 0.11084940216234629,
            "jdsatepoch": 2459633.18047289,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011244120423645621,
            "con41": -0.7733994231926749,
            "cc1": 4.5498701028942227e-11,
            "cc4": -3.7464617544637834e-9,
            "cc5": 0.000043050217729009744,
            "d2": 9.270377987294932e-20,
            "d3": 2.8192049955855096e-28,
            "d4": 9.991372852347581e-37,
            "delmo": 1.0259713480658197,
            "eta": 0.010464336527158969,
            "argpdot": -0.000025937309656607104,
            "omgcof": 1.6606108323703285e-9,
            "sinmao": -0.572024195169792,
            "t": 242328.5449884832,
            "t2cof": 6.824805154341335e-11,
            "t3cof": 9.684404346359146e-20,
            "t4cof": 2.243295501321043e-28,
            "t5cof": 6.4174431035067925e-37,
            "x1mth2": 0.9244664743975584,
            "x7thm1": -0.47126532078290806,
            "mdot": 0.06342892313376763,
            "nodedot": -0.000022870109026286154,
            "xlcof": 0.0019290232199772443,
            "xmcof": -0.0000449623402311006,
            "nodecf": -3.650800673836494e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.6549288488396527,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 292"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4132",
            "epochyr": 22,
            "epochdays": 53.81649236,
            "ndot": 1.7604796795290026e-11,
            "nddot": 0,
            "bstar": 0.00027144,
            "inclo": 1.221625756640911,
            "nodeo": 3.91875460824708,
            "ecco": 0.0008455,
            "argpo": 2.741198415219026,
            "mo": 3.544604885838552,
            "no": 0.06221118722127711,
            "a": 1.1266631930613626,
            "alta": 0.1276157867910961,
            "altp": 0.1257105993316292,
            "jdsatepoch": 2459633.31649236,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010988772082496272,
            "con41": -0.6488647017948503,
            "cc1": 2.0746280190827932e-10,
            "cc4": 1.1105312425252708e-9,
            "cc5": 0.0000249828442831413,
            "d2": 1.6991987105249373e-18,
            "d3": 2.0758112049548538e-26,
            "d4": 2.9548420826198195e-34,
            "delmo": 0.9771475109250477,
            "eta": 0.008344826516793429,
            "argpdot": -0.000016532657298613396,
            "omgcof": -7.852797812019873e-9,
            "sinmao": -0.39219102104145565,
            "t": 242132.6769514382,
            "t2cof": 3.11194202862419e-10,
            "t3cof": 1.785280338876205e-18,
            "t4cof": 1.6648469033377946e-26,
            "t5cof": 1.9153530998884737e-34,
            "x1mth2": 0.8829549005982835,
            "x7thm1": -0.1806843041879842,
            "mdot": 0.06218536394643223,
            "nodedot": -0.000027190016957720705,
            "xlcof": 0.0019284298706304902,
            "xmcof": -0.00028431022470001697,
            "nodecf": -1.9782315569590553e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.5119042999441703,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SOICAL (CONE)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4138",
            "epochyr": 22,
            "epochdays": 53.79299943,
            "ndot": -4.2421197097084403e-13,
            "nddot": 0,
            "bstar": 0.0000037469,
            "inclo": 1.2922278155425855,
            "nodeo": 5.083931180890739,
            "ecco": 0.001363,
            "argpo": 5.639342072765138,
            "mo": 0.644225461520635,
            "no": 0.06312734462372638,
            "a": 1.1158022566511572,
            "alta": 0.11732309512697281,
            "altp": 0.11428141817534154,
            "jdsatepoch": 2459633.29299943,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243632264152997,
            "con41": -0.7731586161191895,
            "cc1": 4.283417488030767e-12,
            "cc4": 1.944186399089296e-8,
            "cc5": 0.000037035683386854715,
            "d2": 7.932513706314893e-22,
            "d3": 2.1922219144744967e-31,
            "d4": 7.060083214864818e-41,
            "delmo": 1.0357558129638471,
            "eta": 0.01473214160995872,
            "argpdot": -0.00002560380491115454,
            "omgcof": 1.002777447028315e-10,
            "sinmao": 0.6005793247251509,
            "t": 242166.5067706257,
            "t2cof": 6.425126232046151e-12,
            "t3cof": 8.299467013850249e-22,
            "t4cof": 1.748066007425376e-31,
            "t5cof": 4.5457580752986817e-41,
            "x1mth2": 0.9243862053730632,
            "x7thm1": -0.47070343761144207,
            "mdot": 0.06309550959982174,
            "nodedot": -0.00002260283649734349,
            "xlcof": 0.0019290404631149452,
            "xmcof": -0.0000020623196730657935,
            "nodecf": -3.3967696480214164e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3638897234133296,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 304"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4166",
            "epochyr": 22,
            "epochdays": 53.8255188,
            "ndot": 5.383855928721397e-10,
            "nddot": 0,
            "bstar": 0.0012528,
            "inclo": 1.221044561999997,
            "nodeo": 4.171310732327668,
            "ecco": 0.0003881,
            "argpo": 4.260380120044695,
            "mo": 2.024135128024912,
            "no": 0.06569789953152211,
            "a": 1.086461337108563,
            "alta": 0.08688299275349465,
            "altp": 0.08603968146363106,
            "jdsatepoch": 2459633.3255188,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010986444931341223,
            "con41": -0.6477428920458173,
            "cc1": 5.486327800702448e-9,
            "cc4": -1.313794998496641e-7,
            "cc5": 0.00013690810297712085,
            "d2": 1.7693309787211207e-15,
            "d3": 8.526734407934916e-22,
            "d4": 4.79007464618331e-28,
            "delmo": 0.9925250361463248,
            "eta": 0.005703339544951709,
            "argpdot": -0.000018693302241804523,
            "omgcof": -3.4704547210575944e-7,
            "sinmao": 0.8989898226860384,
            "t": 242119.67887803912,
            "t2cof": 8.229491701053673e-9,
            "t3cof": 1.829530564194642e-15,
            "t4cof": 6.690393131309417e-22,
            "t5cof": 3.027106846802854e-28,
            "x1mth2": 0.8825809640152724,
            "x7thm1": -0.17806674810690692,
            "mdot": 0.0656686240143265,
            "nodedot": -0.00003092421279844196,
            "xlcof": 0.0019283543995860393,
            "xmcof": -0.023776100233750798,
            "nodecf": -5.950745189576917e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.5687743742102143,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SOICAL (CYLINDER)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4168",
            "epochyr": 22,
            "epochdays": 53.84821549,
            "ndot": -2.72707695624114e-13,
            "nddot": 0,
            "bstar": 0.000032254,
            "inclo": 1.2219468972232779,
            "nodeo": 3.8783572173804197,
            "ecco": 0.0019044,
            "argpo": 0.20559629522642803,
            "mo": 6.080289036305994,
            "no": 0.06091846727372944,
            "a": 1.1425378174509857,
            "alta": 0.1447136664705393,
            "altp": 0.14036196843143212,
            "jdsatepoch": 2459633.34821549,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010990056363713722,
            "con41": -0.6494838949042248,
            "cc1": 1.458708942234128e-11,
            "cc4": 1.8527769067244627e-8,
            "cc5": 0.000015066643056415091,
            "d2": 7.478329402035667e-21,
            "d3": 5.7144844085244765e-30,
            "d4": 5.087241305024527e-39,
            "delmo": 1.0499785722470196,
            "eta": 0.01673267908141852,
            "argpdot": -0.000015780743875202966,
            "omgcof": 2.2484348910816368e-10,
            "sinmao": -0.20150703185335495,
            "t": 242086.99564419687,
            "t2cof": 2.188063413351192e-11,
            "t3cof": 7.903895757666429e-21,
            "t4cof": 4.62088420365092e-30,
            "t5cof": 3.329197150168245e-39,
            "x1mth2": 0.8831612983014083,
            "x7thm1": -0.18212908810985795,
            "mdot": 0.06089385486631809,
            "nodedot": -0.000025868593660546873,
            "xlcof": 0.0019284710859494279,
            "xmcof": -0.0000044422724721326715,
            "nodecf": -1.3232583910273174e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.711772330841221,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TEMPSAT 2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4221",
            "epochyr": 22,
            "epochdays": 53.80097496,
            "ndot": 2.0171279219663632e-10,
            "nddot": 0,
            "bstar": 0.00029376,
            "inclo": 1.7924391791641605,
            "nodeo": 0.1404693341882596,
            "ecco": 0.0594014,
            "argpo": 2.3779098767456586,
            "mo": 3.992301037596869,
            "no": 0.06258795158567289,
            "a": 1.1222412132986772,
            "alta": 0.18890391250631722,
            "altp": 0.0555785140910372,
            "jdsatepoch": 2459633.30097496,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001140837856936376,
            "con41": -0.8550209059594722,
            "cc1": 2.2105871928723644e-9,
            "cc4": 0.000012373170595060766,
            "cc5": 0.00031207499062360893,
            "d2": 2.0007861181990215e-16,
            "d3": 2.701602035320199e-23,
            "d4": 4.2507444246873415e-30,
            "delmo": 0.21496148242951915,
            "eta": 0.608025867124404,
            "argpdot": -0.00003079424976874589,
            "omgcof": -1.213121744013799e-10,
            "sinmao": -0.7517477381074623,
            "t": 242155.02200759947,
            "t2cof": 3.3158807893085464e-9,
            "t3cof": 2.098520032944848e-16,
            "t4cof": 2.1615895083002564e-23,
            "t5cof": 2.747753419712849e-30,
            "x1mth2": 0.9516736353198241,
            "x7thm1": -0.6617154472387684,
            "mdot": 0.06255326215470436,
            "nodedot": 0.000017832863737634514,
            "xlcof": 0.0013897958683657616,
            "xmcof": -7.066475217964043e-8,
            "nodecf": 1.3785209831708112e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.414138656954627,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "AZUR (GRS A)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4237",
            "epochyr": 22,
            "epochdays": 53.86244598,
            "ndot": 4.5451282604019e-13,
            "nddot": 0,
            "bstar": 0.000049871,
            "inclo": 1.22195736919879,
            "nodeo": 3.9774727202719258,
            "ecco": 0.0019447,
            "argpo": 0.2792439536728327,
            "mo": 1.4582243353705144,
            "no": 0.06091755900576918,
            "a": 1.1425491776024064,
            "alta": 0.14477109298808966,
            "altp": 0.14032726221672287,
            "jdsatepoch": 2459633.36244598,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010990098223367546,
            "con41": -0.6495040780017808,
            "cc1": 2.254798842387933e-11,
            "cc4": 1.918804414974891e-8,
            "cc5": 0.00001506270733509662,
            "d2": 1.7866903679357484e-20,
            "d3": 2.1102168712663864e-29,
            "d4": 2.9036058382689756e-38,
            "delmo": 1.0057689069379674,
            "eta": 0.017085445704594266,
            "argpdot": -0.00001578146999638809,
            "omgcof": 3.341510398661585e-10,
            "sinmao": 0.993670461842154,
            "t": 242066.50373898447,
            "t2cof": 3.3821982635818995e-11,
            "t3cof": 1.8883727243284276e-20,
            "t4cof": 1.7063873903931743e-29,
            "t5cof": 1.9001931933810187e-38,
            "x1mth2": 0.8831680260005935,
            "x7thm1": -0.18217618200415497,
            "mdot": 0.06089294668407983,
            "nodedot": -0.00002586695641546819,
            "xlcof": 0.0019284724240971839,
            "xmcof": -0.0000065851050361197306,
            "nodecf": -2.0452964716923443e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.8014299389771153,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7613 (P/L 4)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4247",
            "epochyr": 22,
            "epochdays": 53.82039947,
            "ndot": 1.5150427534673e-13,
            "nddot": 0,
            "bstar": 0.000042461,
            "inclo": 1.221955623869538,
            "nodeo": 3.953936955308782,
            "ecco": 0.0019444,
            "argpo": 0.25731040096302005,
            "mo": 6.028787860738145,
            "no": 0.06091711802918698,
            "a": 1.142554686946348,
            "alta": 0.14477627027964646,
            "altp": 0.14033310361304974,
            "jdsatepoch": 2459633.32039947,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010990091246842269,
            "con41": -0.6495007141872038,
            "cc1": 1.9194433969003724e-11,
            "cc4": 1.9179221067488432e-8,
            "cc5": 0.000015060214699499801,
            "d2": 1.2946965521761143e-20,
            "d3": 1.3016579383797568e-29,
            "d4": 1.5246090817273413e-38,
            "delmo": 1.0504216189407598,
            "eta": 0.017082168180907013,
            "argpdot": -0.000015780991491491168,
            "omgcof": 2.8620368436981884e-10,
            "sinmao": -0.2516622939158883,
            "t": 242127.05071292818,
            "t2cof": 2.8791650953505588e-11,
            "t3cof": 1.3683818112542032e-20,
            "t4cof": 1.0525642897765705e-29,
            "t5cof": 9.977460515260876e-39,
            "x1mth2": 0.8831669047290679,
            "x7thm1": -0.18216833310347536,
            "mdot": 0.06089250625057439,
            "nodedot": -0.000025866644309234888,
            "xlcof": 0.0019284722010981298,
            "xmcof": -0.000005607657955673824,
            "nodecf": -1.7410791850676092e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.5365206097714221,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7613 (P/L 5)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04254",
            "epochyr": 22,
            "epochdays": 53.47269743,
            "ndot": -9.39326507149726e-13,
            "nddot": 0,
            "bstar": -0.000024959,
            "inclo": 1.2919572895085265,
            "nodeo": 5.668405295469348,
            "ecco": 0.0022708,
            "argpo": 2.767154951854686,
            "mo": 0.2557396046362251,
            "no": 0.05793324551686268,
            "a": 1.1814930147434013,
            "alta": 0.18417594908128065,
            "altp": 0.17881008040552193,
            "jdsatepoch": 2459632.97269743,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242761912359464,
            "con41": -0.7727293010898122,
            "cc1": -3.900930027480679e-12,
            "cc4": 6.425731725429238e-9,
            "cc5": 0.000005465863440424188,
            "d2": 4.25640109297462e-22,
            "d3": -6.911050117789247e-32,
            "d4": 1.3068102163349143e-41,
            "delmo": 1.0467995425374799,
            "eta": 0.01587907206581951,
            "argpdot": -0.000020933132592475717,
            "omgcof": 3.6447936548388976e-11,
            "sinmao": 0.25296102783791524,
            "t": 242627.7416510135,
            "t2cof": -5.851395041221018e-12,
            "t3cof": 4.560746194560629e-22,
            "t4cof": -5.696245635138192e-32,
            "t5cof": 8.744850390649995e-42,
            "x1mth2": 0.9242431003632707,
            "x7thm1": -0.4697017025428951,
            "mdot": 0.057907202992962974,
            "nodedot": -0.0000185217026490141,
            "xlcof": 0.0019290709835463663,
            "xmcof": 0.0000010659443189580197,
            "nodecf": 2.534233635188066e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.629048119987075,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 312"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04256",
            "epochyr": 22,
            "epochdays": 53.53536718,
            "ndot": 1.302936767981878e-12,
            "nddot": 0,
            "bstar": 0.000067175,
            "inclo": 1.2218927920164662,
            "nodeo": 1.8773023233838806,
            "ecco": 0.0021109,
            "argpo": 5.585833768557496,
            "mo": 0.6965696311171968,
            "no": 0.0610426889080389,
            "a": 1.1409880374090733,
            "alta": 0.14339654905723997,
            "altp": 0.13857952576090637,
            "jdsatepoch": 2459633.03536718,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010989840069636316,
            "con41": -0.6493796075345438,
            "cc1": 3.190147841860918e-11,
            "cc4": 2.3251498175294326e-8,
            "cc5": 0.000015793128210244104,
            "d2": 3.615004474248899e-20,
            "d3": 6.106222490590365e-29,
            "d4": 1.2016444971340745e-37,
            "delmo": 1.043759065748552,
            "eta": 0.018745407568389612,
            "argpdot": -0.000015849405447920504,
            "omgcof": 3.5196691578894903e-10,
            "sinmao": 0.6415902111540863,
            "t": 242537.49721057713,
            "t2cof": 4.7852217627913774e-11,
            "t3cof": 3.818545339307496e-20,
            "t4cof": 4.9337553977405185e-29,
            "t5cof": 7.856584881761724e-38,
            "x1mth2": 0.883126535844848,
            "x7thm1": -0.18188575091393577,
            "mdot": 0.061017963205085644,
            "nodedot": -0.0000259956250770757,
            "xlcof": 0.0019284641663198639,
            "xmcof": -0.000007816804247268479,
            "nodecf": -2.908144961343607e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.023891868968732,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7613 (P/L 1)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04257",
            "epochyr": 22,
            "epochdays": 53.58376199,
            "ndot": 9.39326507149726e-13,
            "nddot": 0,
            "bstar": 0.000061231,
            "inclo": 1.221962605186546,
            "nodeo": 3.808640040409506,
            "ecco": 0.0019769,
            "argpo": 0.16760920405677146,
            "mo": 0.9609224356120141,
            "no": 0.06093282542240345,
            "a": 1.142358437198341,
            "alta": 0.14461676559283854,
            "altp": 0.14010010880384383,
            "jdsatepoch": 2459633.08376199,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001099011915274251,
            "con41": -0.6495141693614734,
            "cc1": 2.7850498686193538e-11,
            "cc4": 1.9859686876380044e-8,
            "cc5": 0.000015149964833020887,
            "d2": 2.729385624442642e-20,
            "d3": 3.986912645606635e-29,
            "d4": 6.784879644492871e-38,
            "delmo": 1.0301814072596052,
            "eta": 0.017390964073864514,
            "argpdot": -0.00001579134485945003,
            "omgcof": 4.171198978603199e-10,
            "sinmao": 0.8197202549654374,
            "t": 242467.80868425965,
            "t2cof": 4.177574802929031e-11,
            "t3cof": 2.8845156798565756e-20,
            "t4cof": 3.223629298203561e-29,
            "t5cof": 4.439695132595609e-38,
            "x1mth2": 0.8831713897871578,
            "x7thm1": -0.18219972851010469,
            "mdot": 0.06090819832284097,
            "nodedot": -0.000025881701155172224,
            "xlcof": 0.0019284730930329732,
            "xmcof": -0.000007859732749542346,
            "nodecf": -2.5277211788296505e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.0456126464133817,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TIMATION 2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04259",
            "epochyr": 22,
            "epochdays": 53.60387427,
            "ndot": -7.272205216643039e-13,
            "nddot": 0,
            "bstar": 0.000021456,
            "inclo": 1.221953878540286,
            "nodeo": 4.459663559366659,
            "ecco": 0.0018953,
            "argpo": 0.5838335787431271,
            "mo": 0.4642471090549797,
            "no": 0.06088347798479622,
            "a": 1.142975285067323,
            "alta": 0.14514156612511098,
            "altp": 0.1408090040095349,
            "jdsatepoch": 2459633.10387427,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010990084270283515,
            "con41": -0.6494973503586206,
            "cc1": 9.572523627528739e-12,
            "cc4": 1.8087346835080508e-8,
            "cc5": 0.000014870761300905475,
            "d2": 3.2109028816167383e-21,
            "d3": 1.6052998623465097e-30,
            "d4": 9.35009629795535e-40,
            "delmo": 1.0452022199676994,
            "eta": 0.016603217121099034,
            "argpdot": -0.000015760435280170247,
            "omgcof": 1.2588553578669736e-10,
            "sinmao": 0.4477497242529466,
            "t": 242438.84700134397,
            "t2cof": 1.4358785441293108e-11,
            "t3cof": 3.39416929881593e-21,
            "t4cof": 1.2983771304957762e-30,
            "t5cof": 6.120484466593442e-40,
            "x1mth2": 0.8831657834528734,
            "x7thm1": -0.18216048417011443,
            "mdot": 0.060858898033369184,
            "nodedot": -0.000025833477852734292,
            "xlcof": 0.0019284719780888473,
            "xmcof": -0.0000029524758112307548,
            "nodecf": -8.67185300568053e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.17232781471934544,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7613 (P/L 3)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04295",
            "epochyr": 22,
            "epochdays": 53.55811819,
            "ndot": 0,
            "nddot": 0,
            "bstar": 0.000039116,
            "inclo": 1.221911990638238,
            "nodeo": 4.056427924973645,
            "ecco": 0.001881,
            "argpo": 0.5696074000101213,
            "mo": 5.717527587266728,
            "no": 0.06090234569463961,
            "a": 1.1427392970925871,
            "alta": 0.1448887897104183,
            "altp": 0.140589804474756,
            "jdsatepoch": 2459633.05811819,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010989916822830154,
            "con41": -0.6494166142708329,
            "cc1": 1.7579374839521265e-11,
            "cc4": 1.80094497760376e-8,
            "cc5": 0.000014975460989680224,
            "d2": 1.0846208160271854e-20,
            "d3": 9.974362848669807e-30,
            "d4": 1.0686225553593975e-38,
            "delmo": 1.0423859952637669,
            "eta": 0.016504405533598682,
            "argpdot": -0.00001576675957376631,
            "omgcof": 2.355864299168454e-10,
            "sinmao": -0.5359712029025758,
            "t": 242504.73575614393,
            "t2cof": 2.63690622592819e-11,
            "t3cof": 1.146427699976864e-20,
            "t4cof": 8.066362392770712e-30,
            "t5cof": 6.994124578518157e-39,
            "x1mth2": 0.883138871423611,
            "x7thm1": -0.18197209996527686,
            "mdot": 0.060877751029122004,
            "nodedot": -0.000025855121940161397,
            "xlcof": 0.0019284666227974358,
            "xmcof": -0.000005495657026036915,
            "nodecf": -1.5938698844614532e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.167232061769411,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7613 (P/L 6)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04320",
            "epochyr": 22,
            "epochdays": 53.1982699,
            "ndot": -1.81805130416076e-12,
            "nddot": 0,
            "bstar": -0.00010484,
            "inclo": 1.7733452771473424,
            "nodeo": 2.0915170544566566,
            "ecco": 0.0028804,
            "argpo": 2.417085537135923,
            "mo": 5.063177470755274,
            "no": 0.05465761817753604,
            "a": 1.2282573513663804,
            "alta": 0.23179522384125617,
            "altp": 0.22471947889150456,
            "jdsatepoch": 2459632.6982699,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011455383052116927,
            "con41": -0.8785957270702975,
            "cc1": -6.061568663326513e-12,
            "cc4": 2.7410167394101e-9,
            "cc5": 0.0000021392531556253682,
            "d2": 8.368570589956853e-22,
            "d3": -1.7161319532107715e-31,
            "d4": 4.096638503919363e-41,
            "delmo": 1.01700365851449,
            "eta": 0.016401140031963975,
            "argpdot": -0.00002344725732419575,
            "omgcof": 2.7525876540474954e-11,
            "sinmao": -0.9391020492441139,
            "t": 243022.91729405522,
            "t2cof": -9.09235299498977e-12,
            "t3cof": 9.103422883161292e-22,
            "t4cof": -1.4448469076836606e-31,
            "t5cof": 2.810535506673944e-41,
            "x1mth2": 0.9595319090234325,
            "x7thm1": -0.7167233631640277,
            "mdot": 0.05463176831949807,
            "nodedot": 0.000011816797659292635,
            "xlcof": 0.0014298313288950112,
            "xmcof": 0.0000012864880804279425,
            "nodecf": -2.5126390994939467e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 3.900048176616494,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ITOS 1 (TIROS M)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4321",
            "epochyr": 22,
            "epochdays": 53.7828159,
            "ndot": -1.878653014299452e-12,
            "nddot": 0,
            "bstar": -0.0001188,
            "inclo": 1.7715004641279846,
            "nodeo": 1.8833411625957812,
            "ecco": 0.0028121,
            "argpo": 1.7565848803404411,
            "mo": 0.3286472434797843,
            "no": 0.05466172179614999,
            "a": 1.228196872920169,
            "alta": 0.23165068534650812,
            "altp": 0.2247430604938303,
            "jdsatepoch": 2459633.2828159,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011459703545308292,
            "con41": -0.8807675092853819,
            "cc1": -6.876007470222966e-12,
            "cc4": 2.6466434580721145e-9,
            "cc5": 0.0000021414071056674694,
            "d2": 1.0770998190256544e-21,
            "d3": -2.506165288047593e-31,
            "d4": 6.787991368801263e-41,
            "delmo": 1.0461693138059482,
            "eta": 0.016015999342671033,
            "argpdot": -0.000023557413115979225,
            "omgcof": 7.8959524151522e-12,
            "sinmao": 0.32276296734532023,
            "t": 242181.1710537225,
            "t2cof": -1.0314011205334449e-11,
            "t3cof": 1.1716587764867785e-21,
            "t4cof": -2.1099357093130708e-31,
            "t5cof": 4.656815409034959e-41,
            "x1mth2": 0.9602558364284606,
            "x7thm1": -0.7217908549992244,
            "mdot": 0.05463580354816631,
            "nodedot": 0.000011712600447128927,
            "xlcof": 0.001433609100578675,
            "xmcof": 0.0000015308490469095171,
            "nodecf": -2.8251249188111833e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.2997295326505522,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OSCAR 5"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04327",
            "epochyr": 22,
            "epochdays": 53.60483183,
            "ndot": -1.5150427534673e-13,
            "nddot": 0,
            "bstar": 0.000047742,
            "inclo": 1.7301553594774908,
            "nodeo": 1.2313751658425514,
            "ecco": 0.0004698,
            "argpo": 6.2250623524296715,
            "mo": 1.938168935717931,
            "no": 0.05930906508715928,
            "a": 1.1632314948317,
            "alta": 0.16377798098797203,
            "altp": 0.16268500867542812,
            "jdsatepoch": 2459633.10483183,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011546274701796145,
            "con41": -0.9244568376625799,
            "cc1": 1.1838307411863843e-11,
            "cc4": -4.873386205540954e-9,
            "cc5": 0.000008507785713909748,
            "d2": 4.329125282303378e-21,
            "d3": 2.3575796566552856e-30,
            "d4": 1.4954668409014002e-39,
            "delmo": 0.9960958842293082,
            "eta": 0.003628055722221985,
            "argpdot": -0.00003107235841203656,
            "omgcof": 6.75111129200924e-10,
            "sinmao": 0.9332742316604512,
            "t": 242437.46811456978,
            "t2cof": 1.7757461117795763e-11,
            "t3cof": 4.609416327058959e-21,
            "t4cof": 1.926081004681363e-30,
            "t5cof": 9.904522693760456e-40,
            "x1mth2": 0.9748189458875267,
            "x7thm1": -0.8237326212126866,
            "mdot": 0.059276158980269764,
            "nodedot": 0.000011273720270688665,
            "xlcof": 0.0015141599935260394,
            "xmcof": -0.0000683070793757446,
            "nodecf": 4.683558991387433e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.1783608159832042,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SERT 2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4331",
            "epochyr": 22,
            "epochdays": 53.83800769,
            "ndot": 3.3027932025587137e-12,
            "nddot": 0,
            "bstar": 0.00005585,
            "inclo": 1.7249472969895399,
            "nodeo": 2.846460967736056,
            "ecco": 0.0057721,
            "argpo": 4.5617234327062794,
            "mo": 1.7121086550118694,
            "no": 0.06255759633376716,
            "a": 1.1226375542475984,
            "alta": 0.12911753047447094,
            "altp": 0.1161575780207258,
            "jdsatepoch": 2459633.33800769,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011555782872230687,
            "con41": -0.9292753066062619,
            "cc1": 5.0111702339856185e-11,
            "cc4": 1.7588103830320353e-7,
            "cc5": 0.000029523684167870024,
            "d2": 1.0251055452563833e-19,
            "d3": 3.128373688044137e-28,
            "d4": 1.1124742170705736e-36,
            "delmo": 0.9753162623956366,
            "eta": 0.05890662287252977,
            "argpdot": -0.00003550873648500249,
            "omgcof": -4.911796664979277e-11,
            "sinmao": 0.9900320172208484,
            "t": 242101.69487647712,
            "t2cof": 7.516755350978428e-11,
            "t3cof": 1.0753291994843503e-19,
            "t4cof": 2.503535608899439e-28,
            "t5cof": 7.192824327538682e-37,
            "x1mth2": 0.9764251022020872,
            "x7thm1": -0.8349757154146109,
            "mdot": 0.0625201359079227,
            "nodedot": 0.000012351794617457594,
            "xlcof": 0.001523754314766577,
            "xmcof": -0.0000014083542617495773,
            "nodecf": 2.1725284713052213e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.6474592279784233,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 0054 (DMSP 5A F1)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4362",
            "epochyr": 22,
            "epochdays": 53.72764681,
            "ndot": -6.66618811525612e-13,
            "nddot": 0,
            "bstar": 0.000038103,
            "inclo": 1.7446031950254999,
            "nodeo": 5.76373692454253,
            "ecco": 0.0006885,
            "argpo": 4.103101519830477,
            "mo": 3.1067192298056945,
            "no": 0.05870208494804128,
            "a": 1.1712238491517986,
            "alta": 0.17203023677193974,
            "altp": 0.1704174615316576,
            "jdsatepoch": 2459633.22764681,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011518259161474014,
            "con41": -0.9102824231414514,
            "cc1": 7.664451977322828e-12,
            "cc4": -2.213192681511951e-9,
            "cc5": 0.000006964375774301038,
            "d2": 1.7348990920842742e-21,
            "d3": 5.846263721298941e-31,
            "d4": 2.2945254509356874e-40,
            "delmo": 0.984836311737587,
            "eta": 0.005083419588962515,
            "argpdot": -0.00002951923524003416,
            "omgcof": -1.6063083300203218e-10,
            "sinmao": 0.034866355628471304,
            "t": 242260.61454355717,
            "t2cof": 1.1496677965984242e-11,
            "t3cof": 1.8523867403096496e-21,
            "t4cof": 4.7948652947495325e-31,
            "t5cof": 1.5265923485040363e-40,
            "x1mth2": 0.9700941410471504,
            "x7thm1": -0.790658987330053,
            "mdot": 0.05867045129918767,
            "nodedot": 0.000011995478176000999,
            "xlcof": 0.0014869012419828926,
            "xmcof": -0.0000215825211757059,
            "nodecf": 3.226149576136431e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.9521428535455456,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "NIMBUS 4"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4363",
            "epochyr": 22,
            "epochdays": 53.72922285,
            "ndot": -8.484239419416881e-13,
            "nddot": 0,
            "bstar": 0.000028399,
            "inclo": 1.7441232294812015,
            "nodeo": 5.677974935758033,
            "ecco": 0.0001245,
            "argpo": 4.369648203195052,
            "mo": 3.039780617003956,
            "no": 0.05878817042505413,
            "a": 1.1700812425972542,
            "alta": 0.17022691771195775,
            "altp": 0.1699355674825509,
            "jdsatepoch": 2459633.22922285,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001151922849690023,
            "con41": -0.9107722816379132,
            "cc1": 5.881460118068237e-12,
            "cc4": -5.957516122070087e-9,
            "cc5": 0.00000716070613566365,
            "d2": 1.0280173348985507e-21,
            "d3": 2.6751450333021207e-31,
            "d4": 8.107917939378263e-41,
            "delmo": 0.9972419238169637,
            "eta": 0.0009249952130630997,
            "argpdot": -0.000029648543514315224,
            "omgcof": -4.037482576786842e-10,
            "sinmao": 0.10163623571039845,
            "t": 242258.3450460434,
            "t2cof": 8.822190177102356e-12,
            "t3cof": 1.0972004811394052e-21,
            "t4cof": 2.1928322875964753e-31,
            "t5cof": 5.390874747455951e-41,
            "x1mth2": 0.9702574272126377,
            "x7thm1": -0.7918019904884643,
            "mdot": 0.05875641141294485,
            "nodedot": 0.000012003571237138875,
            "xlcof": 0.001487822037386529,
            "xmcof": -0.0005032302209123699,
            "nodecf": 2.4773333563972377e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.9620725168289468,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TOPO 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04369",
            "epochyr": 22,
            "epochdays": 53.58656617,
            "ndot": 3.363394912697406e-12,
            "nddot": 0,
            "bstar": 0.000034664,
            "inclo": 1.2922225795548297,
            "nodeo": 6.187029882699463,
            "ecco": 0.0007223,
            "argpo": 4.452656062419901,
            "mo": 1.8311610539489067,
            "no": 0.06336971561020598,
            "a": 1.1129572676304056,
            "alta": 0.11376115666481512,
            "altp": 0.11215337859599628,
            "jdsatepoch": 2459633.08656617,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243615426443222,
            "con41": -0.7731503103326111,
            "cc1": 4.4307557532426096e-11,
            "cc4": -1.5993049976113296e-8,
            "cc5": 0.00004127236772177473,
            "d2": 8.706049852336839e-20,
            "d3": 2.5531365336550215e-28,
            "d4": 8.72552147497287e-37,
            "delmo": 0.9938281833267497,
            "eta": 0.008007983194289584,
            "argpdot": -0.000025833028571145275,
            "omgcof": -6.489816437891038e-10,
            "sinmao": 0.966296149601103,
            "t": 242463.77066485584,
            "t2cof": 6.646133629863914e-11,
            "t3cof": 9.098681783234689e-20,
            "t4cof": 2.032750111888457e-28,
            "t5cof": 5.608133474435631e-37,
            "x1mth2": 0.9243834367775371,
            "x7thm1": -0.4706840574427593,
            "mdot": 0.06333759515945563,
            "nodedot": -0.000022805920402450984,
            "xlcof": 0.0019290410562654815,
            "xmcof": -0.00007407361361475274,
            "nodecf": -3.5452273389457323e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.06328006960497845,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 332"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4382",
            "epochyr": 22,
            "epochdays": 53.86230823,
            "ndot": 3.302793202558714e-11,
            "nddot": 0,
            "bstar": 0.00016933,
            "inclo": 1.194236304689364,
            "nodeo": 0.33589385053406473,
            "ecco": 0.1052795,
            "argpo": 5.454693219221146,
            "mo": 0.6830188948047129,
            "no": 0.05710660249396164,
            "a": 1.192784293699388,
            "alta": 0.3183600277479126,
            "altp": 0.06720855965086336,
            "jdsatepoch": 2459633.36230823,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010875082088736391,
            "con41": -0.5943378518244913,
            "cc1": 4.212112958007849e-10,
            "cc4": 0.000004131743181234481,
            "cc5": 0.0001100853237235371,
            "d2": 4.694319091689737e-18,
            "d3": 7.781682858856768e-26,
            "d4": 1.5020845667764323e-33,
            "delmo": 3.6535042674899185,
            "eta": 0.6963962289645056,
            "argpdot": -0.000010822784133935835,
            "omgcof": 2.6667497608203532e-12,
            "sinmao": 0.6311375653723449,
            "t": 242066.70209906995,
            "t2cof": 6.318169437011773e-10,
            "t3cof": 5.04915700311009e-18,
            "t4cof": 6.448134929455051e-26,
            "t5cof": 1.0114518830427818e-33,
            "x1mth2": 0.8647792839414971,
            "x7thm1": -0.05345498759047962,
            "mdot": 0.05708690452859871,
            "nodedot": -0.00002448038458570575,
            "xlcof": 0.0019236477845730896,
            "xmcof": -2.7407308142672043e-9,
            "nodecf": -3.574898306985512e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.8005620601481027,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "DFH-1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04383",
            "epochyr": 22,
            "epochdays": 53.61938397,
            "ndot": -6.36317956456266e-13,
            "nddot": 0,
            "bstar": -0.000035423,
            "inclo": 1.2920166307030945,
            "nodeo": 4.866131543534367,
            "ecco": 0.0014663,
            "argpo": 5.791316617382544,
            "mo": 1.581123439978947,
            "no": 0.054460516199212786,
            "a": 1.23117074537127,
            "alta": 0.2329760110352077,
            "altp": 0.2293654797073319,
            "jdsatepoch": 2459633.11938397,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242952898685898,
            "con41": -0.7728235053227988,
            "cc1": -1.9376299675201233e-12,
            "cc4": 8.7393159665003e-10,
            "cc5": 0.0000020278425600625056,
            "d2": 8.455639961637036e-23,
            "d3": -5.4803329107047924e-33,
            "d4": 4.134598219544235e-43,
            "delmo": 0.9997442456173633,
            "eta": 0.008255961146759746,
            "argpdot": -0.00001812684453095935,
            "omgcof": -1.9644314914907787e-11,
            "sinmao": 0.9999466758405596,
            "t": 242416.51303343475,
            "t2cof": -2.9064449512801847e-12,
            "t3cof": 9.206521939843444e-23,
            "t4cof": -4.619953367343497e-33,
            "t5cof": 2.8408793538270647e-43,
            "x1mth2": 0.9242745017742662,
            "x7thm1": -0.4699215124198637,
            "mdot": 0.054437968090584266,
            "nodedot": -0.000016033230911737177,
            "xlcof": 0.0019290643106870948,
            "xmcof": 0.000001606241637025541,
            "nodecf": 1.0894745448404552e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.27004494363168163,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 336"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04384",
            "epochyr": 22,
            "epochdays": 53.45812295,
            "ndot": -3.33309405762806e-13,
            "nddot": 0,
            "bstar": 0.00003116,
            "inclo": 1.292070735909906,
            "nodeo": 5.387866307491535,
            "ecco": 0.0052958,
            "argpo": 1.824602106619912,
            "mo": 1.1811236460191306,
            "no": 0.054093405496908345,
            "a": 1.236731767099809,
            "alta": 0.24328125119201638,
            "altp": 0.2301822830076019,
            "jdsatepoch": 2459632.95812295,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243126998772808,
            "con41": -0.772909381792328,
            "cc1": 1.5453205796406354e-12,
            "cc4": 5.196662661351042e-9,
            "cc5": 0.00000185195522898728,
            "d2": 5.268506819334806e-23,
            "d3": 2.667172805575705e-33,
            "d4": 1.5716610213769377e-43,
            "delmo": 1.0336593879619738,
            "eta": 0.02920935411517739,
            "argpdot": -0.000017848128737256633,
            "omgcof": -1.193922541837211e-12,
            "sinmao": 0.9250334532857968,
            "t": 242648.7289018929,
            "t2cof": 2.317980869460953e-12,
            "t3cof": 5.74610995810698e-23,
            "t4cof": 2.253851189029202e-33,
            "t5cof": 1.0829443431238458e-43,
            "x1mth2": 0.9243031272641093,
            "x7thm1": -0.47012189084876543,
            "mdot": 0.05407120702964938,
            "nodedot": -0.00001578029104245193,
            "xlcof": 0.0019290582158613691,
            "xmcof": -1.0000209076930585e-7,
            "nodecf": -8.551454239917618e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.537223241048579,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 337"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04385",
            "epochyr": 22,
            "epochdays": 53.62339995,
            "ndot": -5.15114536178882e-13,
            "nddot": 0,
            "bstar": -0.000008964,
            "inclo": 1.2920358293248662,
            "nodeo": 2.067202872647124,
            "ecco": 0.0032781,
            "argpo": 4.227194429647274,
            "mo": 4.758182929298517,
            "no": 0.054273232780912804,
            "a": 1.2339998862469628,
            "alta": 0.238045061274069,
            "altp": 0.22995471121985656,
            "jdsatepoch": 2459633.12339995,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243014679903397,
            "con41": -0.7728539793244765,
            "cc1": -4.659755158425265e-13,
            "cc4": 3.0382232148638637e-9,
            "cc5": 0.000001934019513687618,
            "d2": 4.838851591609734e-24,
            "d3": -7.462087776325909e-35,
            "d4": 1.3394706839095824e-45,
            "delmo": 1.0025102611449643,
            "eta": 0.018263260482299096,
            "argpdot": -0.000017983549668855398,
            "omgcof": 1.099440626464958e-12,
            "sinmao": -0.9989516403489918,
            "t": 242410.73002181947,
            "t2cof": -6.989632737637898e-13,
            "t3cof": 5.273117954339151e-24,
            "t4cof": -6.298296428738402e-35,
            "t5cof": 9.216768887333309e-46,
            "x1mth2": 0.9242846597748254,
            "x7thm1": -0.4699926184237784,
            "mdot": 0.05425086396851206,
            "nodedot": -0.000015904223069968136,
            "xlcof": 0.0019290621491805122,
            "xmcof": 7.806800676548681e-8,
            "nodecf": 2.598921327179016e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.2953471780430377,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 338"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04386",
            "epochyr": 22,
            "epochdays": 53.56172285,
            "ndot": -7.272205216643039e-13,
            "nddot": 0,
            "bstar": -0.000054348,
            "inclo": 1.2920079040568344,
            "nodeo": 1.4233788368544475,
            "ecco": 0.0015144,
            "argpo": 0.10251889493289493,
            "mo": 1.8860150070098365,
            "no": 0.05464441242562791,
            "a": 1.2284085205287663,
            "alta": 0.2302688223922551,
            "altp": 0.2265482186652774,
            "jdsatepoch": 2459633.06172285,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242924814944385,
            "con41": -0.7728096528834923,
            "cc1": -3.1311724983561374e-12,
            "cc4": 9.909050502377397e-10,
            "cc5": 0.000002128984667029564,
            "d2": 2.231346222874508e-22,
            "d3": -2.3618745900181573e-32,
            "d4": 2.910204424692079e-42,
            "delmo": 0.9920073641487592,
            "eta": 0.008616553402767964,
            "argpdot": -0.000018269266335740863,
            "omgcof": -3.5214078328647674e-11,
            "sinmao": 0.9507286054480393,
            "t": 242499.54504601657,
            "t2cof": -4.696758747534206e-12,
            "t3cof": 2.427431047163744e-22,
            "t4cof": -1.9886825329493763e-32,
            "t5cof": 1.996774372069827e-42,
            "x1mth2": 0.9242698842944975,
            "x7thm1": -0.46988919006148233,
            "mdot": 0.05462168671065312,
            "nodedot": -0.000016160194173362876,
            "xlcof": 0.0019290652927633596,
            "xmcof": 0.0000024055928514567777,
            "nodecf": 1.774526780432366e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.189942817542416,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 339"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04387",
            "epochyr": 22,
            "epochdays": 53.55138096,
            "ndot": -2.42406840554768e-13,
            "nddot": 0,
            "bstar": 0.000046697,
            "inclo": 1.2919956867520703,
            "nodeo": 4.036091348529407,
            "ecco": 0.0039312,
            "argpo": 2.2137424619738195,
            "mo": 5.046109896000021,
            "no": 0.05483915988244457,
            "a": 1.22550015337858,
            "alta": 0.23031783958154195,
            "altp": 0.22068246717561824,
            "jdsatepoch": 2459633.05138096,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242885496267857,
            "con41": -0.7727902588170953,
            "cc1": 2.8504452184529207e-12,
            "cc4": 4.627587311886499e-9,
            "cc5": 0.0000022489923745478766,
            "d2": 1.8700007296329611e-22,
            "d3": 1.8224198697117753e-32,
            "d4": 2.067489864626525e-42,
            "delmo": 1.0223928144821182,
            "eta": 0.022619423193905246,
            "argpdot": -0.000018421027888015216,
            "omgcof": -7.545079114302796e-12,
            "sinmao": -0.9448300604749434,
            "t": 242514.4373678416,
            "t2cof": 4.2756678276793814e-12,
            "t3cof": 2.0325014885009836e-22,
            "t4cof": 1.5325149353212828e-32,
            "t5cof": 1.4164440884632717e-42,
            "x1mth2": 0.9242634196056984,
            "x7thm1": -0.4698439372398888,
            "mdot": 0.05481624490891107,
            "nodedot": -0.000016295868617249887,
            "xlcof": 0.0019290666672220705,
            "xmcof": -3.202349733596902e-7,
            "nodecf": -1.628986894588973e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.124784895877767,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 340"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4388",
            "epochyr": 22,
            "epochdays": 53.85363133,
            "ndot": -6.0601710138692e-14,
            "nddot": 0,
            "bstar": 0.00007813,
            "inclo": 1.2920236120201023,
            "nodeo": 3.647444921353814,
            "ecco": 0.0080644,
            "argpo": 0.775348557564465,
            "mo": 1.0921886486545076,
            "no": 0.05518906543083119,
            "a": 1.2203177199395747,
            "alta": 0.2301588501602556,
            "altp": 0.21047658971889405,
            "jdsatepoch": 2459633.35363133,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242975365062643,
            "con41": -0.7728345869950821,
            "cc1": 5.3248560775646365e-12,
            "cc4": 1.2176988911014292e-8,
            "cc5": 0.000002500248858109576,
            "d2": 6.660313636366019e-22,
            "d3": 1.2377832405471498e-31,
            "d4": 2.67795557676955e-41,
            "delmo": 1.0668683821434206,
            "eta": 0.04735774365622249,
            "argpdot": -0.000018700421121854914,
            "omgcof": 8.34464602240016e-12,
            "sinmao": 0.8876370080656013,
            "t": 242079.1968344897,
            "t2cof": 7.987284116346956e-12,
            "t3cof": 7.22739548130156e-22,
            "t4cof": 1.038507601556235e-31,
            "t5cof": 1.8297615172091105e-41,
            "x1mth2": 0.9242781956650273,
            "x7thm1": -0.46994736965519146,
            "mdot": 0.05516580487529298,
            "nodedot": -0.00001653925467490359,
            "xlcof": 0.001929063524834056,
            "xmcof": -1.3767573875208468e-7,
            "nodecf": -3.0884258037354076e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.7458942251916127,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 341"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04389",
            "epochyr": 22,
            "epochdays": 53.34788302,
            "ndot": -4.2421197097084403e-13,
            "nddot": 0,
            "bstar": 0.000014505,
            "inclo": 1.2920846985439223,
            "nodeo": 0.3104085527964435,
            "ecco": 0.0101644,
            "argpo": 3.2131371902875445,
            "mo": 5.014988930107711,
            "no": 0.055363112444442815,
            "a": 1.2177603079422532,
            "alta": 0.23013811081630164,
            "altp": 0.205382505068205,
            "jdsatepoch": 2459632.84788302,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243171922484748,
            "con41": -0.7729315410423627,
            "cc1": 1.0479487543060879e-12,
            "cc4": 1.6759215433752063e-8,
            "cc5": 0.0000026462357242195752,
            "d2": 2.6063246891869115e-23,
            "d3": 9.632135134192042e-34,
            "d4": 4.144151904306028e-44,
            "delmo": 1.0548900698793395,
            "eta": 0.060307341308827145,
            "argpdot": -0.000018844593700261812,
            "omgcof": -1.8321477304808155e-12,
            "sinmao": -0.9545649234011426,
            "t": 242807.47440107167,
            "t2cof": 1.5719231314591317e-12,
            "t3cof": 2.825964007517248e-23,
            "t4cof": 8.072261107804332e-34,
            "t5cof": 2.8277972516422175e-44,
            "x1mth2": 0.9243105136807875,
            "x7thm1": -0.470173595765513,
            "mdot": 0.055339676128053635,
            "nodedot": -0.000016658786701576498,
            "xlcof": 0.0019290566413388466,
            "xmcof": -1.6733738836921123e-8,
            "nodecf": -6.121868651835594e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.84266889813118,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 342"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04390",
            "epochyr": 22,
            "epochdays": 53.42391015,
            "ndot": -7.272205216643039e-13,
            "nddot": 0,
            "bstar": -0.000040775,
            "inclo": 1.2920375746541184,
            "nodeo": 0.6202324202934689,
            "ecco": 0.0060817,
            "argpo": 4.432059431917117,
            "mo": 4.789663433016739,
            "no": 0.05501925098856944,
            "a": 1.2228259881751544,
            "alta": 0.2302628489874392,
            "altp": 0.21538912736286964,
            "jdsatepoch": 2459632.92391015,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243020296172227,
            "con41": -0.7728567495952103,
            "cc1": -2.631527212376573e-12,
            "cc4": 8.321142377519924e-9,
            "cc5": 0.0000023721662941018763,
            "d2": 1.6105465713359737e-22,
            "d3": -1.4644020903964718e-32,
            "d4": 1.5500520215266173e-42,
            "delmo": 1.0082116878065635,
            "eta": 0.035360838834039475,
            "argpdot": -0.00001856654042783012,
            "omgcof": 2.1003237205346705e-12,
            "sinmao": -0.9970158148942556,
            "t": 242697.9953341931,
            "t2cof": -3.9472908185648595e-12,
            "t3cof": 1.749045280725542e-22,
            "t4cof": -1.230003270708437e-32,
            "t5cof": 1.0604798936750462e-42,
            "x1mth2": 0.9242855831984035,
            "x7thm1": -0.46999908238882415,
            "mdot": 0.0549961573564715,
            "nodedot": -0.000016419167780210467,
            "xlcof": 0.001929061952615904,
            "xmcof": 1.216170857354386e-7,
            "nodecf": 1.515238309237356e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.321669321780448,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 343"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04419",
            "epochyr": 22,
            "epochdays": 53.56381684,
            "ndot": 3.757306028598904e-12,
            "nddot": 0,
            "bstar": 0.000056622,
            "inclo": 1.4175686357745583,
            "nodeo": 6.088959832029901,
            "ecco": 0.0038447,
            "argpo": 4.046942060489056,
            "mo": 2.2322394613864556,
            "no": 0.06179903760912288,
            "a": 1.1317985895534957,
            "alta": 0.1361500155907518,
            "altp": 0.1274471635162393,
            "jdsatepoch": 2459633.06381684,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011557435768494153,
            "con41": -0.9301133518582713,
            "cc1": 3.63954950559727e-11,
            "cc4": 6.887302506559448e-8,
            "cc5": 0.00002131192994913076,
            "d2": 5.032135533920725e-20,
            "d3": 1.0375292616353467e-28,
            "d4": 2.4924643209172916e-37,
            "delmo": 0.9342110114348026,
            "eta": 0.03651401031670387,
            "argpdot": -0.00003456651289005225,
            "omgcof": -2.0361744933003592e-10,
            "sinmao": 0.7891065990331774,
            "t": 242496.52970060706,
            "t2cof": 5.459324258395905e-11,
            "t3cof": 5.297061945994592e-20,
            "t4cof": 8.342963314003527e-29,
            "t5cof": 1.620544873197009e-37,
            "x1mth2": 0.9767044506194237,
            "x7thm1": -0.8369311543359661,
            "mdot": 0.06176259632745044,
            "nodedot": -0.000011933882312540548,
            "xlcof": 0.0018866566143487505,
            "xmcof": -0.000002510661713998516,
            "nodecf": -1.52445522702072e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.2031357663840225,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "METEOR 1-5"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04507",
            "epochyr": 22,
            "epochdays": 53.59789834,
            "ndot": 2.0301572896461823e-12,
            "nddot": 0,
            "bstar": 0.000082514,
            "inclo": 1.5692115678340857,
            "nodeo": 4.1937643931545745,
            "ecco": 0.0172156,
            "argpo": 6.235607631770221,
            "mo": 0.04791801461350431,
            "no": 0.05897488301923694,
            "a": 1.1676536203203338,
            "alta": 0.18775547798632064,
            "altp": 0.147551762654347,
            "jdsatepoch": 2459633.09789834,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011694438108632232,
            "con41": -0.9999924656234159,
            "cc1": 1.9948692984760093e-11,
            "cc4": 1.1945551580184657e-7,
            "cc5": 0.0000084984942118108,
            "d2": 1.1989715986597092e-20,
            "d3": 1.0729499776792016e-29,
            "d4": 1.118344524323891e-38,
            "delmo": 1.441066519778055,
            "eta": 0.12967079536751186,
            "argpdot": -0.000035086096488820015,
            "omgcof": 2.7792928558839107e-11,
            "sinmao": 0.047899679004622206,
            "t": 242447.45234057307,
            "t2cof": 2.992303947714014e-11,
            "t3cof": 1.2785616690197525e-20,
            "t4cof": 8.784508795645396e-30,
            "t5cof": 7.425368849512522e-39,
            "x1mth2": 0.9999974885411386,
            "x7thm1": -0.9999824197879702,
            "mdot": 0.05893974037206054,
            "nodedot": -1.1115749876013813e-7,
            "xlcof": 0.0017560160697145872,
            "xmcof": -8.035403667022626e-8,
            "nodecf": -7.780895280540141e-18,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.1346771363470438,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "NNSS 19 (TRANSIT 19)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04512",
            "epochyr": 22,
            "epochdays": 53.58852451,
            "ndot": 2.605873535963756e-12,
            "nddot": 0,
            "bstar": 0.000045626,
            "inclo": 1.7258967561026246,
            "nodeo": 5.255378363972645,
            "ecco": 0.0065181,
            "argpo": 0.7675678797590743,
            "mo": 5.526689796195164,
            "no": 0.06264220886533291,
            "a": 1.1216268034597021,
            "alta": 0.1289376791273329,
            "altp": 0.11431592779207156,
            "jdsatepoch": 2459633.08852451,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001155407283386588,
            "con41": -0.9284084155303247,
            "cc1": 4.272130797779837e-11,
            "cc4": 2.1456703945609834e-7,
            "cc5": 0.00003081182882610731,
            "d2": 7.512741672013172e-20,
            "d3": 1.9710276306466374e-28,
            "d4": 6.025773117469143e-37,
            "delmo": 1.153598195211687,
            "eta": 0.0670765013131363,
            "argpdot": -0.0000355633028948924,
            "omgcof": 1.7862403703718988e-10,
            "sinmao": -0.6863770400018341,
            "t": 242460.95065534115,
            "t2cof": 6.408196196669756e-11,
            "t3cof": 7.877763703079952e-20,
            "t4cof": 1.576506245529278e-28,
            "t5cof": 3.8936120031421905e-37,
            "x1mth2": 0.9761361385101082,
            "x7thm1": -0.8329529695707576,
            "mdot": 0.06260466467125628,
            "nodedot": 0.000012466715968706086,
            "xlcof": 0.001522014329914959,
            "xmcof": -9.284306252661983e-7,
            "nodecf": 1.8693472493257862e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.07561837125935966,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 0203 (DMSP 5A F2)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04564",
            "epochyr": 22,
            "epochdays": 53.51140505,
            "ndot": -1.96955557950749e-12,
            "nddot": 0,
            "bstar": 0.000019947,
            "inclo": 1.1393020664828424,
            "nodeo": 1.7403986968574456,
            "ecco": 0.0071877,
            "argpo": 5.391795043637774,
            "mo": 0.8820806773116742,
            "no": 0.06016369738835104,
            "a": 1.1519866631518538,
            "alta": 0.1602667976905905,
            "altp": 0.14370652861311717,
            "jdsatepoch": 2459633.01140505,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010622560553673428,
            "con41": -0.4752545947984037,
            "cc1": 6.922112029621942e-12,
            "cc4": 7.845434126464552e-8,
            "cc5": 0.000011692838766497115,
            "d2": 1.5820499794323686e-21,
            "d3": 5.387163455911141e-31,
            "d4": 2.136936351826176e-40,
            "delmo": 1.1174395008154276,
            "eta": 0.05932980252103969,
            "argpdot": -0.000004667328256533808,
            "omgcof": 1.584602064746377e-11,
            "sinmao": 0.7720629155245247,
            "t": 242572.0026782155,
            "t2cof": 1.0383168044432912e-11,
            "t3cof": 1.6778812493336423e-21,
            "t4cof": 4.3771983425835835e-31,
            "t5cof": 1.406310887257125e-40,
            "x1mth2": 0.8250848649328012,
            "x7thm1": 0.2244059454703915,
            "mdot": 0.06014620118305393,
            "nodedot": -0.000030763576997323554,
            "xlcof": 0.0019066381232587305,
            "xmcof": -1.5467640963085095e-7,
            "nodecf": -7.463149052599296e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.872921148370025,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 367"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04578",
            "epochyr": 22,
            "epochdays": 53.35323823,
            "ndot": 2.454369260617026e-12,
            "nddot": 0,
            "bstar": 0.000025985,
            "inclo": 1.2915104852200159,
            "nodeo": 4.935949949601896,
            "ecco": 0.0003798,
            "argpo": 4.9031534676276705,
            "mo": 1.3813129112228801,
            "no": 0.06347607157971545,
            "a": 1.1117140154474792,
            "alta": 0.11213624443054604,
            "altp": 0.11129178646441207,
            "jdsatepoch": 2459632.85323823,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011241322626449441,
            "con41": -0.7720194230721567,
            "cc1": 3.4913268876788396e-11,
            "cc4": -3.8656079380581996e-8,
            "cc5": 0.00004332096267324294,
            "d2": 5.467320117942865e-20,
            "d3": 1.277887791765879e-28,
            "d4": 3.480815647902434e-37,
            "delmo": 1.002408392670305,
            "eta": 0.004258811773867582,
            "argpdot": -0.00002585597520081886,
            "omgcof": 7.280705453717269e-10,
            "sinmao": 0.9821016656485996,
            "t": 242799.76289860904,
            "t2cof": 5.236990331518259e-11,
            "t3cof": 5.711107386675449e-20,
            "t4cof": 1.0167443753261232e-28,
            "t5cof": 2.235479035322643e-37,
            "x1mth2": 0.9240064743573855,
            "x7thm1": -0.46804532050169867,
            "mdot": 0.0634438724026543,
            "nodedot": -0.0000229522690976403,
            "xlcof": 0.0019291208302932117,
            "xmcof": -0.00020871747708315946,
            "nodecf": -2.8114850947183742e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.876408799759176,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 371"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04588",
            "epochyr": 22,
            "epochdays": 53.60781303,
            "ndot": 1.333237623051224e-12,
            "nddot": 0,
            "bstar": 0.000024184,
            "inclo": 1.2924965962473927,
            "nodeo": 3.937525624352279,
            "ecco": 0.0012889,
            "argpo": 0.32920923949892644,
            "mo": 0.8104994886996307,
            "no": 0.0626914028513278,
            "a": 1.1209657131444515,
            "alta": 0.12241052585212331,
            "altp": 0.11952090043677965,
            "jdsatepoch": 2459633.10781303,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124449618586207,
            "con41": -0.7735847922724213,
            "cc1": 2.270983296934085e-11,
            "cc4": 1.2657478376977238e-8,
            "cc5": 0.00003059693002697099,
            "d2": 2.1333131226866192e-20,
            "d3": 2.989833998003141e-29,
            "d4": 4.882789234509745e-38,
            "delmo": 1.0278096491903215,
            "eta": 0.013328643657569526,
            "argpdot": -0.000025221951131979727,
            "omgcof": 6.300316196543417e-10,
            "sinmao": 0.7246314806806691,
            "t": 242433.17518673837,
            "t2cof": 3.4064749454011273e-11,
            "t3cof": 2.2364604253856913e-20,
            "t4cof": 2.3906451250843216e-29,
            "t5cof": 3.153923713018605e-38,
            "x1mth2": 0.9245282640908071,
            "x7thm1": -0.4716978486356498,
            "mdot": 0.06266006102981797,
            "nodedot": -0.000022219855721485287,
            "xlcof": 0.001929009885730949,
            "xmcof": -0.000012797642435943098,
            "nodecf": -1.7703492593446236e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.19714353225676717,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 372"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04594",
            "epochyr": 22,
            "epochdays": 53.40755695,
            "ndot": -1.151432492635148e-12,
            "nddot": 0,
            "bstar": 0.000030741,
            "inclo": 1.0989360915427175,
            "nodeo": 6.189166165703903,
            "ecco": 0.089321,
            "argpo": 4.8399847660102395,
            "mo": 1.2694512688040596,
            "no": 0.0565182674338411,
            "a": 1.200944923994539,
            "alta": 0.308214525550655,
            "altp": 0.0936753224384228,
            "jdsatepoch": 2459632.90755695,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010416532939694961,
            "con41": -0.3801691809705279,
            "cc1": 2.05989232362855e-11,
            "cc4": 0.0000010418436189108302,
            "cc5": 0.00002849782319189608,
            "d2": 1.0809379137140479e-20,
            "d3": 8.43418615296997e-30,
            "d4": 7.662522483694373e-39,
            "delmo": 1.5968556256858222,
            "eta": 0.5688598688787819,
            "argpdot": 0.0000010196864693736776,
            "omgcof": 8.139021560429758e-14,
            "sinmao": 0.9549381332418567,
            "t": 242721.54394179583,
            "t2cof": 3.089838485442825e-11,
            "t3cof": 1.1658010414129244e-20,
            "t4cof": 7.015475441124319e-30,
            "t5cof": 5.182748733459565e-39,
            "x1mth2": 0.793389726990176,
            "x7thm1": 0.4462719110687683,
            "mdot": 0.056506025342209686,
            "nodedot": -0.000029371375980793947,
            "xlcof": 0.001887995892761866,
            "xmcof": -6.001433820687435e-10,
            "nodecf": -2.1028423773917395e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.218637816859356,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 374"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4598",
            "epochyr": 22,
            "epochdays": 53.79047051,
            "ndot": -2.57557268089441e-12,
            "nddot": 0,
            "bstar": 0.0000095331,
            "inclo": 1.096344277603506,
            "nodeo": 3.846946526832278,
            "ecco": 0.0959015,
            "argpo": 0.16369792120305218,
            "mo": 6.1501406036293105,
            "no": 0.056567916547106786,
            "a": 1.2002397555807394,
            "alta": 0.3153445485005657,
            "altp": 0.08513496266091303,
            "jdsatepoch": 2459633.29047051,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001040272080924372,
            "con41": -0.37386124502778445,
            "cc1": 9.142707297148123e-12,
            "cc4": 0.0000015245476546693543,
            "cc5": 0.000041328101796684487,
            "d2": 2.136135395764137e-21,
            "d3": 7.4213164805888e-31,
            "d4": 3.002079142423713e-40,
            "delmo": 4.152170391125318,
            "eta": 0.6126953056444807,
            "argpdot": 0.0000013651287850441723,
            "omgcof": 1.856212140512847e-13,
            "sinmao": -0.13265254910529695,
            "t": 242170.1484158635,
            "t2cof": 1.3714060945722184e-11,
            "t3cof": 2.303313589206788e-21,
            "t4cof": 6.170994946671976e-31,
            "t5cof": 2.0297696688274273e-40,
            "x1mth2": 0.7912870816759281,
            "x7thm1": 0.4609904282685031,
            "mdot": 0.05655583063965469,
            "nodedot": -0.000029654223838759435,
            "xlcof": 0.0018866250129020883,
            "xmcof": -1.6336038407616881e-10,
            "nodecf": -9.411513214027235e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.3479565440440169,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 375"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4783",
            "epochyr": 22,
            "epochdays": 53.5966774,
            "ndot": 3.0300855069346e-14,
            "nddot": 0,
            "bstar": 0.000024242,
            "inclo": 1.29209167986093,
            "nodeo": 1.8438600695864173,
            "ecco": 0.0029592,
            "argpo": 1.936952441229291,
            "mo": 4.3537203284413515,
            "no": 0.06001595044967712,
            "a": 1.154015337081136,
            "alta": 0.15743029926662655,
            "altp": 0.15060037489564526,
            "jdsatepoch": 2459633.0966774,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124319438351875,
            "con41": -0.7729426202951337,
            "cc1": 7.792770434487e-12,
            "cc4": 2.2413652251142367e-8,
            "cc5": 0.000010886854883310247,
            "d2": 1.981513727431882e-21,
            "d3": 7.50629623543517e-31,
            "d4": 3.3123609475838004e-40,
            "delmo": 0.9747939198726854,
            "eta": 0.024139465356135162,
            "argpdot": -0.000022743745269858592,
            "omgcof": -2.6311248382590163e-11,
            "sinmao": -0.936364993722611,
            "t": 242449.21049371362,
            "t2cof": 1.16891556517305e-11,
            "t3cof": 2.1029682695211113e-21,
            "t4cof": 6.104797466355305e-31,
            "t5cof": 2.1822515017924116e-40,
            "x1mth2": 0.9243142067650446,
            "x7thm1": -0.47019944735531216,
            "mdot": 0.05998766354169147,
            "nodedot": -0.000020101361131118176,
            "xlcof": 0.0019290558538215393,
            "xmcof": -0.0000010634320568377836,
            "nodecf": -5.494885221175825e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.1269847425075099,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 381"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4793",
            "epochyr": 22,
            "epochdays": 53.77319078,
            "ndot": -1.575644463605992e-12,
            "nddot": 0,
            "bstar": -0.000052302,
            "inclo": 1.7727797904696965,
            "nodeo": 2.101598076216176,
            "ecco": 0.0031882,
            "argpo": 3.227155674839563,
            "mo": 5.120110110955329,
            "no": 0.05474216748403082,
            "a": 1.2269934223352439,
            "alta": 0.23090532276433318,
            "altp": 0.2230815219061546,
            "jdsatepoch": 2459633.27319078,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011456711548196161,
            "con41": -0.879263434971236,
            "cc1": -3.098404769400507e-12,
            "cc4": 3.2573078916095153e-9,
            "cc5": 0.0000021888579659341115,
            "d2": 2.197173828579731e-22,
            "d3": -2.3144325546741602e-32,
            "d4": 2.837966103649106e-42,
            "delmo": 1.0218572622374311,
            "eta": 0.018242051541514558,
            "argpdot": -0.00002356471668457975,
            "omgcof": 1.7027884147850965e-11,
            "sinmao": -0.9180268192262333,
            "t": 242195.03122664988,
            "t2cof": -4.647607154100761e-12,
            "t3cof": 2.389176070880607e-22,
            "t4cof": -1.9474926903868303e-32,
            "t5cof": 1.945748064478237e-42,
            "x1mth2": 0.9597544783237454,
            "x7thm1": -0.7182813482662175,
            "mdot": 0.054716204475393375,
            "nodedot": 0.000011826803983316108,
            "xlcof": 0.001430991005602083,
            "xmcof": 5.337308400906214e-7,
            "nodecf": -1.2854429461565349e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.239087540591889,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "NOAA 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04799",
            "epochyr": 22,
            "epochdays": 53.58218892,
            "ndot": 3.0300855069346e-14,
            "nddot": 0,
            "bstar": 0.000024084,
            "inclo": 1.2919206375942347,
            "nodeo": 2.345678881449079,
            "ecco": 0.0002975,
            "argpo": 0.8734604961360742,
            "mo": 0.9100164173190953,
            "no": 0.060102481663940416,
            "a": 1.1529079896717676,
            "alta": 0.15325097979869495,
            "altp": 0.15256499954484015,
            "jdsatepoch": 2459633.08218892,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242643930438744,
            "con41": -0.7726711071665286,
            "cc1": 7.966982665823586e-12,
            "cc4": -7.044097940228084e-9,
            "cc5": 0.0000111814435784609,
            "d2": 2.085443843296403e-21,
            "d3": 8.132929757152151e-31,
            "d4": 3.69473804969873e-40,
            "delmo": 1.0045059823036684,
            "eta": 0.0024436428607619107,
            "argpdot": -0.0000228033593083485,
            "omgcof": 4.857394209695397e-10,
            "sinmao": 0.7895138156433659,
            "t": 242470.07390499115,
            "t2cof": 1.195047399873538e-11,
            "t3cof": 2.21238946889147e-21,
            "t4cof": 6.610780336349568e-31,
            "t5cof": 2.432602530194826e-40,
            "x1mth2": 0.9242237023888429,
            "x7thm1": -0.4695659167219003,
            "mdot": 0.0600741098637098,
            "nodedot": -0.00002018068626885737,
            "xlcof": 0.001929075098857597,
            "xmcof": -0.00010712861699481671,
            "nodecf": -5.639964398787726e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.03570169520494204,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 385"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04922",
            "epochyr": 22,
            "epochdays": 53.40421931,
            "ndot": 2.9967545663583195e-11,
            "nddot": 0,
            "bstar": 0.000040113,
            "inclo": 1.1488594894667634,
            "nodeo": 5.117094182007883,
            "ecco": 0.0002952,
            "argpo": 2.775474936398943,
            "mo": 3.5099147216259126,
            "no": 0.06681321573656399,
            "a": 1.0742678086870794,
            "alta": 0.07458493254420384,
            "altp": 0.07395068482995493,
            "jdsatepoch": 2459632.90421931,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010668819608877981,
            "con41": -0.49685998018175215,
            "cc1": 3.6234796792071537e-10,
            "cc4": -2.575407165408587e-7,
            "cc5": 0.0002771493451207317,
            "d2": 9.128877414510734e-18,
            "d3": 3.4388236388921898e-25,
            "d4": 1.5102376734486457e-32,
            "delmo": 0.9857073412778801,
            "eta": 0.005131237032099564,
            "argpdot": -0.000007658020279709478,
            "omgcof": -7.553005282113284e-8,
            "sinmao": -0.36005054178905344,
            "t": 242726.35014384985,
            "t2cof": 5.43521951881073e-10,
            "t3cof": 9.391469514223278e-18,
            "t4cof": 2.6795420060070365e-25,
            "t5cof": 9.467725135155552e-33,
            "x1mth2": 0.832286660060584,
            "x7thm1": 0.17399337957591166,
            "mdot": 0.06678985849124802,
            "nodedot": -0.00003845669797863961,
            "xlcof": 0.0019102977562407315,
            "xmcof": -0.002277480799684304,
            "nodecf": -4.8852714110753924e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.197609387531358,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 394"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "04952",
            "epochyr": 22,
            "epochdays": 53.56274312,
            "ndot": 2.363466695408988e-12,
            "nddot": 0,
            "bstar": 0.000018137,
            "inclo": 0.5177781025428978,
            "nodeo": 2.0434698854785047,
            "ecco": 0.0079761,
            "argpo": 1.4347077690291425,
            "mo": 0.49651475626585084,
            "no": 0.05923076183562658,
            "a": 1.1632370217080819,
            "alta": 0.17251511651692764,
            "altp": 0.15395892689923607,
            "jdsatepoch": 2459633.06274312,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0005788177686367287,
            "con41": 1.2650713908529099,
            "cc1": 4.6507632888188415e-12,
            "cc4": 7.465418696550976e-8,
            "cc5": 0.000008493680850638497,
            "d2": 6.642119542715878e-22,
            "d3": 1.4126227461001168e-31,
            "d4": 3.4993351199368233e-41,
            "delmo": 1.1703703325891357,
            "eta": 0.06123346215484195,
            "argpdot": 0.00009889907186030475,
            "omgcof": 9.935206694067297e-13,
            "sinmao": 0.4763640439014312,
            "t": 242498.0758573115,
            "t2cof": 6.976144933228263e-12,
            "t3cof": 7.074711526088379e-22,
            "t4cof": 1.154654690406848e-31,
            "t5cof": 2.318977285458478e-41,
            "x1mth2": 0.24497620304903,
            "x7thm1": 4.28516657865679,
            "mdot": 0.05927574200083775,
            "nodedot": -0.00006193763993086176,
            "xlcof": 0.0011373375093603469,
            "xmcof": -8.813679348652017e-8,
            "nodecf": -1.004483357850741e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.196370914087694,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TANSEI 1 (MS-T1)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4953",
            "epochyr": 22,
            "epochdays": 53.79324133,
            "ndot": 3.18158978228133e-12,
            "nddot": 0,
            "bstar": 0.00004676,
            "inclo": 1.722109391625797,
            "nodeo": 4.454722532254262,
            "ecco": 0.0039283,
            "argpo": 1.794715088508761,
            "mo": 4.498212646555457,
            "no": 0.06289205288293154,
            "a": 1.1186583425133316,
            "alta": 0.12305276808022692,
            "altp": 0.11426391694643656,
            "jdsatepoch": 2459633.29324133,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011560832018737471,
            "con41": -0.9318356820593325,
            "cc1": 4.820405736761829e-11,
            "cc4": 1.2505188769960063e-7,
            "cc5": 0.00003370965362251206,
            "d2": 9.806922386515674e-20,
            "d3": 2.9770108341286914e-28,
            "d4": 1.0530941794326326e-36,
            "delmo": 0.9738033366720399,
            "eta": 0.041448632311599,
            "argpdot": -0.00003612468947619081,
            "omgcof": -1.0812032550811054e-10,
            "sinmao": -0.9771517898432485,
            "t": 242166.15843482316,
            "t2cof": 7.230608605142743e-11,
            "t3cof": 1.02716486158558e-19,
            "t4cof": 2.3773783716197517e-28,
            "t5cof": 6.792220131145161e-37,
            "x1mth2": 0.9772785606864441,
            "x7thm1": -0.8409499248051091,
            "mdot": 0.06285402023420229,
            "nodedot": 0.0000122771787364661,
            "xlcof": 0.0015289308957300663,
            "xmcof": -0.0000028537946532103743,
            "nodecf": 2.0772965419070108e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.36541378643701,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 5268 (DMSP 5A F3)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 4964",
            "epochyr": 22,
            "epochdays": 53.78956106,
            "ndot": 1.181733347704494e-12,
            "nddot": 0,
            "bstar": 0.000055959,
            "inclo": 1.1470513283616972,
            "nodeo": 3.830205328647148,
            "ecco": 0.1023843,
            "argpo": 2.6186169605344563,
            "mo": 3.7760756872257955,
            "no": 0.055615112152438306,
            "a": 1.2139596558445547,
            "alta": 0.3382500654364402,
            "altp": 0.08966924625266914,
            "jdsatepoch": 2459633.28956106,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010660142513209386,
            "con41": -0.4928001716380773,
            "cc1": 4.1939016408574387e-11,
            "cc4": 0.0000011898251418906495,
            "cc5": 0.000032805320227996066,
            "d2": 4.2377015833011106e-20,
            "d3": 6.363696761499261e-29,
            "d4": 1.1125572208839888e-37,
            "delmo": 0.12751484202555532,
            "eta": 0.6166905069316451,
            "argpdot": -0.000004877596846613879,
            "omgcof": -6.354896307687795e-13,
            "sinmao": -0.5927612401220722,
            "t": 242171.45802386105,
            "t2cof": 6.290852461286157e-11,
            "t3cof": 4.589477802764845e-20,
            "t4cof": 5.324389115634862e-29,
            "t5cof": 7.577019718852613e-38,
            "x1mth2": 0.8309333905460258,
            "x7thm1": 0.18346626617781947,
            "mdot": 0.05559977068738053,
            "nodedot": -0.00002571130506548256,
            "xlcof": 0.0019096277850307968,
            "xmcof": -6.738106480934623e-10,
            "nodecf": -3.739444512510103e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.342226656082083,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 397"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05050",
            "epochyr": 22,
            "epochdays": 53.53327764,
            "ndot": -2.3937675504783338e-12,
            "nddot": 0,
            "bstar": 0.0000010423,
            "inclo": 1.1488490174912516,
            "nodeo": 1.881618522624063,
            "ecco": 0.0012867,
            "argpo": 4.199087647373157,
            "mo": 3.865338806489794,
            "no": 0.05988934957335752,
            "a": 1.1555108103457326,
            "alta": 0.15699760610540459,
            "altp": 0.15402401458606074,
            "jdsatepoch": 2459633.03327764,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010668769455822976,
            "con41": -0.49683650525834266,
            "cc1": 3.2085506088278515e-13,
            "cc4": 7.248495229561275e-9,
            "cc5": 0.000010382682189109645,
            "d2": 3.325676812392746e-24,
            "d3": 5.135049281459704e-35,
            "d4": 9.236034462682988e-46,
            "delmo": 0.9768213567904839,
            "eta": 0.010391531641164343,
            "argpdot": -0.00000592440113654166,
            "omgcof": -3.191321894786158e-12,
            "sinmao": -0.662196417811336,
            "t": 242540.5061481893,
            "t2cof": 4.812825913241778e-13,
            "t3cof": 3.531572752580938e-24,
            "t4cof": 4.179662876232876e-35,
            "t5cof": 6.090628013854845e-46,
            "x1mth2": 0.8322788350861142,
            "x7thm1": 0.17404815439720034,
            "mdot": 0.059871254296277765,
            "nodedot": -0.000029800156734677794,
            "xlcof": 0.0019102939062464995,
            "xmcof": -2.3336154917995813e-7,
            "nodecf": -3.3513471998646155e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.01072695596342,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 400"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05104",
            "epochyr": 22,
            "epochdays": 53.4390131,
            "ndot": 7.87822231802996e-13,
            "nddot": 0,
            "bstar": 0.000076281,
            "inclo": 1.5389824651895438,
            "nodeo": 3.623631649039603,
            "ecco": 0.0045145,
            "argpo": 1.1895186797212232,
            "mo": 5.233348818153973,
            "no": 0.0553504627808863,
            "a": 1.2180451797143508,
            "alta": 0.22354404467817113,
            "altp": 0.21254631475053043,
            "jdsatepoch": 2459632.9390131,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001168853518759802,
            "con41": -0.9969646588815536,
            "cc1": 5.385047254923403e-12,
            "cc4": 6.1180791537223824e-9,
            "cc5": 0.0000025862084014573552,
            "d2": 6.877034879542412e-22,
            "d3": 1.3050147706980933e-31,
            "d4": 2.8830218737044207e-41,
            "delmo": 1.0404990245176187,
            "eta": 0.02676528398647604,
            "argpdot": -0.000030096572123677323,
            "omgcof": 8.373772002754607e-12,
            "sinmao": -0.8673418556718683,
            "t": 242676.2470856309,
            "t2cof": 8.077570882385104e-12,
            "t3cof": 7.457009558297574e-22,
            "t4cof": 1.0937645402385415e-31,
            "t5cof": 1.9674448399661078e-41,
            "x1mth2": 0.9989882196271845,
            "x7thm1": -0.9929175373902918,
            "mdot": 0.05532025716007966,
            "nodedot": -0.0000019235789328017357,
            "xlcof": 0.001789313584532775,
            "xmcof": -4.4482834955132955e-7,
            "nodecf": -3.634889755028044e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.4168237706802955,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ISIS 2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05105",
            "epochyr": 22,
            "epochdays": 53.44288684,
            "ndot": -2.302864985270296e-12,
            "nddot": 0,
            "bstar": 0.000010819,
            "inclo": 1.1341446185431994,
            "nodeo": 5.157580584666396,
            "ecco": 0.0030513,
            "argpo": 0.7733187396443955,
            "mo": 2.2351332172862626,
            "no": 0.059928183288356356,
            "a": 1.1549961350889446,
            "alta": 0.1585203747959416,
            "altp": 0.15147189538194783,
            "jdsatepoch": 2459632.94288684,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010597194547744967,
            "con41": -0.46344720498460423,
            "cc1": 3.3895126802658416e-12,
            "cc4": 2.6411399723329555e-8,
            "cc5": 0.000010559166698469246,
            "d2": 3.7227779086654854e-22,
            "d3": 6.091154548652445e-32,
            "d4": 1.160942229468354e-41,
            "delmo": 0.9549740674511248,
            "eta": 0.024718238589559963,
            "argpdot": -0.0000039077455062431175,
            "omgcof": 2.0589363511804615e-11,
            "sinmao": 0.7873257898674992,
            "t": 242670.6689002365,
            "t2cof": 5.0842690203987626e-12,
            "t3cof": 3.952553832859144e-22,
            "t4cof": 4.956653354414817e-32,
            "t5cof": 7.653525494370874e-42,
            "x1mth2": 0.8211490683282014,
            "x7thm1": 0.2519565217025903,
            "mdot": 0.05991127818550645,
            "nodedot": -0.00003082304091357644,
            "xlcof": 0.0019045423559127814,
            "xmcof": -4.354619545440771e-7,
            "nodecf": -3.6615052011846866e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.4412298351712,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 402"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 5117",
            "epochyr": 22,
            "epochdays": 53.6896742,
            "ndot": 2.4246744226490666e-10,
            "nddot": 0,
            "bstar": 0.00020105,
            "inclo": 1.418273748792364,
            "nodeo": 2.2511483585025625,
            "ecco": 0.0008542,
            "argpo": 6.222477519807468,
            "mo": 2.0730985948603604,
            "no": 0.0672300165172715,
            "a": 1.0700445807408763,
            "alta": 0.0709586128217452,
            "altp": 0.06913054866000734,
            "jdsatepoch": 2459633.1896742,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001155869145875485,
            "con41": -0.9307500873326695,
            "cc1": 2.392989247033006e-9,
            "cc4": -4.262170129440916e-7,
            "cc5": 0.00037256068611135005,
            "d2": 4.2722796405200757e-16,
            "d3": 1.140707622708867e-22,
            "d4": 3.551018891017983e-29,
            "delmo": 0.9771645330559752,
            "eta": 0.015932273500594927,
            "argpdot": -0.00004211260692634857,
            "omgcof": 2.21428938596484e-7,
            "sinmao": 0.8764764709730903,
            "t": 242315.29510192573,
            "t2cof": 3.589483870549509e-9,
            "t3cof": 4.3868075912483877e-16,
            "t4cof": 8.865438549451199e-23,
            "t5cof": 2.2195047321916991e-29,
            "x1mth2": 0.9769166957775565,
            "x7thm1": -0.8384168704428955,
            "mdot": 0.06718563467825231,
            "nodedot": -0.000014454142269650737,
            "xlcof": 0.0018862549201720488,
            "xmcof": -0.0017124853510798298,
            "nodecf": -1.2144259637221547e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.712900673556895,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 405"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05174",
            "epochyr": 22,
            "epochdays": 53.58398166,
            "ndot": 1.424140188259262e-12,
            "nddot": 0,
            "bstar": 0.000026419,
            "inclo": 1.2923011193711695,
            "nodeo": 1.9380101107559995,
            "ecco": 0.0019451,
            "argpo": 5.509985249924326,
            "mo": 0.7724914535789502,
            "no": 0.06257267693015296,
            "a": 1.1223821267163332,
            "alta": 0.1245652721910091,
            "altp": 0.12019898124165729,
            "jdsatepoch": 2459633.08398166,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243867959723336,
            "con41": -0.7732748824710425,
            "cc1": 2.3572061307448273e-11,
            "cc4": 3.700510465204648e-8,
            "cc5": 0.000029125437796560292,
            "d2": 2.271581619015324e-20,
            "d3": 3.2657524515757873e-29,
            "d4": 5.470918827677596e-38,
            "delmo": 1.0433235063438753,
            "eta": 0.01987994435471536,
            "argpdot": -0.000025090045321843055,
            "omgcof": 3.225960783606502e-10,
            "sinmao": 0.697921717310811,
            "t": 242467.4923592806,
            "t2cof": 3.535809196117241e-11,
            "t3cof": 2.3827100338717442e-20,
            "t4cof": 2.61322632950674e-29,
            "t5cof": 3.536891273407681e-38,
            "x1mth2": 0.9244249608236808,
            "x7thm1": -0.4709747257657656,
            "mdot": 0.06254148578233433,
            "nodedot": -0.000022137175390487752,
            "xlcof": 0.001929032148924662,
            "xmcof": -0.00000589653582606982,
            "nodecf": -1.8307101691406525e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.04699665345210491,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 407"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05180",
            "epochyr": 22,
            "epochdays": 53.55219764,
            "ndot": 6.7570906804641574e-12,
            "nddot": 0,
            "bstar": 0.000623,
            "inclo": 1.2915349198295438,
            "nodeo": 3.9439536719873747,
            "ecco": 0.0022208,
            "argpo": 0.9731467216929822,
            "mo": 6.277898704875295,
            "no": 0.0575246750260252,
            "a": 1.1870771586370696,
            "alta": 0.18971341959097066,
            "altp": 0.1844408976831684,
            "jdsatepoch": 2459633.05219764,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011241401395407945,
            "con41": -0.7720582707869958,
            "cc1": 8.531659704290582e-11,
            "cc4": 5.322037262930509e-9,
            "cc5": 0.000004820788838014078,
            "d2": 1.980122150791501e-19,
            "d3": 6.837218024496681e-28,
            "d4": 2.74922742594088e-36,
            "delmo": 1.0459972949608227,
            "eta": 0.015103388369189013,
            "argpdot": -0.000020553463558612816,
            "omgcof": 4.745551262566882e-10,
            "sinmao": -0.005286577679187478,
            "t": 242513.26134860516,
            "t2cof": 1.2797489556435872e-10,
            "t3cof": 2.1257005854111325e-19,
            "t4cof": 5.650250690082667e-28,
            "t5cof": 1.845392662967638e-36,
            "x1mth2": 0.9240194235956654,
            "x7thm1": -0.46813596516965705,
            "mdot": 0.05749908116124378,
            "nodedot": -0.000018245616515415338,
            "xlcof": 0.0019291181223674116,
            "xmcof": -0.000025112727599528854,
            "nodecf": -5.459843333547952e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.129930296989571,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 409"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05210",
            "epochyr": 22,
            "epochdays": 53.38174296,
            "ndot": -6.66618811525612e-13,
            "nddot": 0,
            "bstar": -0.000027055,
            "inclo": 1.291775775266319,
            "nodeo": 4.850093713037791,
            "ecco": 0.0112588,
            "argpo": 4.546486708336369,
            "mo": 4.782041580173279,
            "no": 0.05521730136514619,
            "a": 1.2199017606576896,
            "alta": 0.2336363906005825,
            "altp": 0.20616713071479675,
            "jdsatepoch": 2459632.88174296,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242177473133818,
            "con41": -0.7724410356869171,
            "cc1": -1.8817038697317523e-12,
            "cc4": 1.7858634726648443e-8,
            "cc5": 0.000002555771328991947,
            "d2": 8.331127509038993e-23,
            "d3": -5.480577054762335e-33,
            "d4": 4.197196516249162e-43,
            "delmo": 1.01389123600061,
            "eta": 0.0662267340520598,
            "argpdot": -0.000018705358555687692,
            "omgcof": 4.836299499906591e-13,
            "sinmao": -0.9975752382170708,
            "t": 242758.71608778834,
            "t2cof": -2.8225558045976282e-12,
            "t3cof": 9.039289399711684e-23,
            "t4cof": -4.597391124387313e-33,
            "t5cof": 2.8671903666634204e-43,
            "x1mth2": 0.924147011895639,
            "x7thm1": -0.4690290832694731,
            "mdot": 0.05519402273963783,
            "nodedot": -0.00001657537979870492,
            "xlcof": 0.0019290913180951216,
            "xmcof": 2.461536543787763e-8,
            "nodecf": 1.0937084752827461e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.0559996597552725,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 411"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05211",
            "epochyr": 22,
            "epochdays": 53.62433154,
            "ndot": -1.5150427534673e-13,
            "nddot": 0,
            "bstar": 0.000079735,
            "inclo": 1.2918770043629346,
            "nodeo": 0.00009599310885968812,
            "ecco": 0.003607,
            "argpo": 4.440843674042404,
            "mo": 4.903610743891693,
            "no": 0.05412095911676992,
            "a": 1.2363120623217243,
            "alta": 0.24077143993051875,
            "altp": 0.23185268471292986,
            "jdsatepoch": 2459633.12433154,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124250345607918,
            "con41": -0.7726018197698656,
            "cc1": 3.974302530361145e-12,
            "cc4": 3.2747343338205115e-9,
            "cc5": 0.0000018595533915786558,
            "d2": 3.4901060074114673e-22,
            "d3": 4.5511142539550115e-32,
            "d4": 6.907845537857529e-42,
            "delmo": 1.0114039462351436,
            "eta": 0.019925210711608594,
            "argpdot": -0.000017854117007902366,
            "omgcof": -4.8388540131707304e-12,
            "sinmao": -0.9817727613470713,
            "t": 242409.38853241503,
            "t2cof": 5.9614537955417174e-12,
            "t3cof": 3.806007619468167e-22,
            "t4cof": 3.8451514117625557e-32,
            "t5cof": 4.7588018766545505e-42,
            "x1mth2": 0.9242006065899552,
            "x7thm1": -0.46940424612968645,
            "mdot": 0.054098743604896256,
            "nodedot": -0.000015809264838225105,
            "xlcof": 0.0019290799919037987,
            "xmcof": -5.549073320648632e-7,
            "nodecf": -2.2033613100344665e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.3012165557312514,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 412"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05212",
            "epochyr": 22,
            "epochdays": 53.61868969,
            "ndot": -9.090256520803799e-14,
            "nddot": 0,
            "bstar": 0.000092565,
            "inclo": 1.2918176631683669,
            "nodeo": 3.126841130751937,
            "ecco": 0.0021341,
            "argpo": 0.24379980722333192,
            "mo": 6.242445831779534,
            "no": 0.05429427027852899,
            "a": 1.233681125595788,
            "alta": 0.2363139244859218,
            "altp": 0.231048326705654,
            "jdsatepoch": 2459633.11868969,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124231237660086,
            "con41": -0.7725075733577199,
            "cc1": 4.834884108771917e-12,
            "cc4": 1.6518715462416094e-9,
            "cc5": 0.000001942189407540668,
            "d2": 5.215567154191856e-22,
            "d3": 8.355280373694028e-32,
            "d4": 1.55803271139797e-41,
            "delmo": 1.0361077263356455,
            "eta": 0.011903760459150318,
            "argpdot": -0.000017982924669832166,
            "omgcof": 3.656080267432656e-11,
            "sinmao": -0.040728207084339024,
            "t": 242417.5127966702,
            "t2cof": 7.252326163157876e-12,
            "t3cof": 5.6830892410969595e-22,
            "t4cof": 7.051215351687537e-32,
            "t5cof": 1.0718936564513735e-41,
            "x1mth2": 0.9241691911192399,
            "x7thm1": -0.4691843378346796,
            "mdot": 0.05427189147353643,
            "nodedot": -0.00001593054601364915,
            "xlcof": 0.0019290866357473792,
            "xmcof": -0.0000019108281501314682,
            "nodecf": -2.7010774807191664e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.2656707100187745,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 413"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05213",
            "epochyr": 22,
            "epochdays": 53.6043041,
            "ndot": 0,
            "nddot": 0,
            "bstar": 0.00010704,
            "inclo": 1.2917932285588392,
            "nodeo": 3.5738775480530007,
            "ecco": 0.0043138,
            "argpo": 5.071991383477846,
            "mo": 2.4879773206934286,
            "no": 0.05461272539302636,
            "a": 1.228883229011023,
            "alta": 0.23418438548433085,
            "altp": 0.22358207253771512,
            "jdsatepoch": 2459633.1043041,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242233685308958,
            "con41": -0.7724687608017469,
            "cc1": 6.130255347630722e-12,
            "cc4": 4.817660173915106e-9,
            "cc5": 0.0000021186176630120666,
            "d2": 8.537355616365887e-22,
            "d3": 1.7659984501377987e-31,
            "d4": 4.25238113507436e-41,
            "delmo": 0.9427766014982796,
            "eta": 0.024500009741388544,
            "argpdot": -0.000018228533956664344,
            "omgcof": 8.513646058162442e-12,
            "sinmao": 0.6080605523313416,
            "t": 242438.2280460745,
            "t2cof": 9.195383021446084e-12,
            "t3cof": 9.288956228908988e-22,
            "t4cof": 1.4872667269618115e-31,
            "t5cof": 2.918390647520582e-41,
            "x1mth2": 0.9241562536005823,
            "x7thm1": -0.4690937752040759,
            "mdot": 0.054590039859166606,
            "nodedot": -0.0000161510051123928,
            "xlcof": 0.0019290893678635696,
            "xmcof": -5.798476356000653e-7,
            "nodecf": -3.472154185507199e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.1750359108492816,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 414"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05214",
            "epochyr": 22,
            "epochdays": 53.56682083,
            "ndot": -3.33309405762806e-13,
            "nddot": 0,
            "bstar": 0.000033537,
            "inclo": 1.2918560604119107,
            "nodeo": 0.2212396813120532,
            "ecco": 0.0031521,
            "argpo": 2.619733971255733,
            "mo": 3.6684394869260535,
            "no": 0.05445331582303956,
            "a": 1.2312791070932483,
            "alta": 0.23516022196671704,
            "altp": 0.22739799221977974,
            "jdsatepoch": 2459633.06682083,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124243602078382,
            "con41": -0.7725685583770436,
            "cc1": 1.8333357447594472e-12,
            "cc4": 3.058658631703111e-9,
            "cc5": 0.000002027349316526551,
            "d2": 7.566788397537344e-23,
            "d3": 4.6383575643810996e-33,
            "d4": 3.3096521217292655e-43,
            "delmo": 0.9546971939410492,
            "eta": 0.01774057013830972,
            "argpdot": -0.000018109186990237688,
            "omgcof": -8.486159162809618e-12,
            "sinmao": -0.5028102581006272,
            "t": 242492.20395460725,
            "t2cof": 2.750003617139171e-12,
            "t3cof": 8.23901238813988e-23,
            "t4cof": 3.9103472359336185e-33,
            "t5cof": 2.274185462193481e-43,
            "x1mth2": 0.9241895194590146,
            "x7thm1": -0.4693266362131019,
            "mdot": 0.05443078183815115,
            "nodedot": -0.00001603754176184762,
            "xlcof": 0.0019290823381978275,
            "xmcof": -3.285569499710903e-7,
            "nodecf": -1.0311009811104379e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.222062070974445,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 415"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05215",
            "epochyr": 22,
            "epochdays": 53.62771573,
            "ndot": -3.33309405762806e-13,
            "nddot": 0,
            "bstar": 0.000032748,
            "inclo": 1.2917565766445473,
            "nodeo": 4.241083759834645,
            "ecco": 0.0077864,
            "argpo": 4.799992291530041,
            "mo": 2.615290362980155,
            "no": 0.05491496027255796,
            "a": 1.2243726532371817,
            "alta": 0.2339061084643479,
            "altp": 0.21483919801001572,
            "jdsatepoch": 2459633.12771573,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242115635785794,
            "con41": -0.7724105362698586,
            "cc1": 2.060328151589901e-12,
            "cc4": 1.0658277152163737e-8,
            "cc5": 0.0000023185006327293594,
            "d2": 9.812854857722925e-23,
            "d3": 6.943053090147199e-33,
            "d4": 5.718713545122322e-43,
            "delmo": 0.8877558594378719,
            "eta": 0.04499863096450492,
            "argpdot": -0.000018463381535449806,
            "omgcof": 4.0085193190531587e-13,
            "sinmao": 0.5023394825799857,
            "t": 242404.51529860497,
            "t2cof": 3.0904922273848515e-12,
            "t3cof": 1.0661845276169697e-22,
            "t4cof": 5.8356858366798165e-33,
            "t5cof": 3.91563154517801e-43,
            "x1mth2": 0.9241368454232862,
            "x7thm1": -0.46895791796300335,
            "mdot": 0.05489198108019211,
            "nodedot": -0.000016363561386809268,
            "xlcof": 0.0019290934621178301,
            "xmcof": -5.821832581919447e-8,
            "nodecf": -1.1822878655720164e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.3225382670581425,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 416"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05216",
            "epochyr": 22,
            "epochdays": 53.54372571,
            "ndot": -7.272205216643039e-13,
            "nddot": 0,
            "bstar": -0.00004427,
            "inclo": 1.2917687939493112,
            "nodeo": 1.4747211874603647,
            "ecco": 0.0094687,
            "argpo": 1.6529158134304818,
            "mo": 0.32418443658243473,
            "no": 0.05506260396928755,
            "a": 1.2221842480256597,
            "alta": 0.23375674401494018,
            "altp": 0.21061175203637927,
            "jdsatepoch": 2459633.04372571,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242154987304884,
            "con41": -0.7724299452068628,
            "cc1": -2.9224927835149895e-12,
            "cc4": 1.3962705270043053e-8,
            "cc5": 0.000002429047133259416,
            "d2": 1.9914253113283142e-22,
            "d3": -2.0160756423517973e-32,
            "d4": 2.3760252496260586e-42,
            "delmo": 1.1653102612193538,
            "eta": 0.05519344388848052,
            "argpdot": -0.000018581420224280094,
            "omgcof": 4.4124054109819775e-13,
            "sinmao": 0.3185358104844802,
            "t": 242525.46092770994,
            "t2cof": -4.3837391752724845e-12,
            "t3cof": 2.162244592722258e-22,
            "t4cof": -1.6928947412663184e-32,
            "t5cof": 1.6250357028225116e-42,
            "x1mth2": 0.9241433150689543,
            "x7thm1": -0.46900320548268004,
            "mdot": 0.05503947881246446,
            "nodedot": -0.000016466533232271273,
            "xlcof": 0.0019290920978890752,
            "xmcof": 5.500349964646685e-8,
            "nodecf": 1.6875443930893075e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.076553850446018,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 417"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05217",
            "epochyr": 22,
            "epochdays": 53.45360186,
            "ndot": -4.5451282604019e-13,
            "nddot": 0,
            "bstar": 0.0000050999,
            "inclo": 1.291801955205099,
            "nodeo": 0.796285527271389,
            "ecco": 0.0059131,
            "argpo": 1.835737307247636,
            "mo": 0.1350012176417614,
            "no": 0.05476259575067733,
            "a": 1.226641382224249,
            "alta": 0.23389463538147903,
            "altp": 0.21938812906701877,
            "jdsatepoch": 2459632.95360186,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242261790112313,
            "con41": -0.7724826227777394,
            "cc1": 3.056967159591806e-13,
            "cc4": 7.3840637831737325e-9,
            "cc5": 0.00000221284884425448,
            "d2": 2.1413126607051368e-24,
            "d3": 2.2280669949131278e-35,
            "d4": 2.698734577182911e-46,
            "delmo": 1.1041120130104602,
            "eta": 0.03387300847183389,
            "argpdot": -0.000018346709336186374,
            "omgcof": -2.3261112422634384e-13,
            "sinmao": 0.13459151757009083,
            "t": 242655.23927159607,
            "t2cof": 4.585450739387709e-13,
            "t3cof": 2.328213625001593e-24,
            "t4cof": 1.8745697970250373e-35,
            "t5cof": 1.8499988402409683e-46,
            "x1mth2": 0.9241608742592464,
            "x7thm1": -0.4691261198147252,
            "mdot": 0.05473976375927583,
            "nodedot": -0.000016254529732430854,
            "xlcof": 0.001929088392347791,
            "xmcof": -1.5198114253327965e-8,
            "nodecf": -1.7425376098544926e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.5087386189810985,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 418"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05238",
            "epochyr": 22,
            "epochdays": 53.6049411,
            "ndot": -1.8180513041607598e-13,
            "nddot": 0,
            "bstar": 0.000017731,
            "inclo": 1.2918420977778948,
            "nodeo": 4.499451830324373,
            "ecco": 0.0015324,
            "argpo": 3.7377849087662924,
            "mo": 3.495557643199007,
            "no": 0.05989798538807161,
            "a": 1.1555288713248575,
            "alta": 0.1572996037672758,
            "altp": 0.1537581388824394,
            "jdsatepoch": 2459633.1049411,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242391061180533,
            "con41": -0.7725463828746899,
            "cc1": 5.446752480523717e-12,
            "cc4": 6.4451200336036815e-9,
            "cc5": 0.000010417090322466197,
            "d2": 9.5903189036875e-22,
            "d3": 2.5154977257755097e-31,
            "d4": 7.685845346727415e-41,
            "delmo": 0.9655537519919241,
            "eta": 0.012384256006001943,
            "argpdot": -0.000022615361658312245,
            "omgcof": -8.127107632608093e-11,
            "sinmao": -0.3466197053727756,
            "t": 242437.3107661307,
            "t2cof": 8.170128720785576e-12,
            "t3cof": 1.0183661155369326e-21,
            "t4cof": 2.047371309641087e-31,
            "t5cof": 5.068042377017333e-41,
            "x1mth2": 0.9241821276248967,
            "x7thm1": -0.4692748933742765,
            "mdot": 0.05986984270272136,
            "nodedot": -0.000020026627503437884,
            "xlcof": 0.0019290839015404734,
            "xmcof": -0.000002805650914079308,
            "nodecf": -3.8263654156014167e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.17904925782308823,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 422"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 5398",
            "epochyr": 22,
            "epochdays": 53.77840636,
            "ndot": 1.0787104404687175e-11,
            "nddot": 0,
            "bstar": 0.00011786,
            "inclo": 1.5292295653293995,
            "nodeo": 0.9531888816964272,
            "ecco": 0.0064939,
            "argpo": 0.788562445331314,
            "mo": 5.505878490194384,
            "no": 0.06261528746587681,
            "a": 1.121980029228612,
            "alta": 0.12926605534041946,
            "altp": 0.11469400311680422,
            "jdsatepoch": 2459633.27840636,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001168435143587508,
            "con41": -0.994819597614008,
            "cc1": 1.088263012362404e-10,
            "cc4": 2.0716343745202997e-7,
            "cc5": 0.000030448533262561483,
            "d2": 4.862084628984329e-19,
            "d3": 3.2407477290794444e-27,
            "d4": 2.517052686994417e-35,
            "delmo": 1.1494038342135804,
            "eta": 0.06665003498366844,
            "argpdot": -0.000039974227307846815,
            "omgcof": 4.518675926950889e-10,
            "sinmao": -0.701362250725557,
            "t": 242187.5207912922,
            "t2cof": 1.632394518543606e-10,
            "t3cof": 5.098947905799548e-19,
            "t4cof": 2.5925197220398782e-27,
            "t5cof": 1.626739339837898e-35,
            "x1mth2": 0.9982731992046693,
            "x7thm1": -0.9879123944326851,
            "mdot": 0.06257509982536116,
            "nodedot": -0.0000033494872375681635,
            "xlcof": 0.0017992696389476975,
            "xmcof": -0.0000023942678000471003,
            "nodecf": -1.2796592416555594e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.271947719441549,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "RIGIDSPHERE 2 (LCS 4)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 5435",
            "epochyr": 22,
            "epochdays": 53.76307659,
            "ndot": 9.665972767121374e-12,
            "nddot": 0,
            "bstar": 0.00010957,
            "inclo": 0.8751063416207048,
            "nodeo": 3.716284197710974,
            "ecco": 0.0109943,
            "argpo": 3.453502189542952,
            "mo": 2.824530905684747,
            "no": 0.06349711070269867,
            "a": 1.11097947508892,
            "alta": 0.12319391673188984,
            "altp": 0.09876503344594978,
            "jdsatepoch": 2459633.26307659,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0008976798351484216,
            "con41": 0.2323170065942124,
            "cc1": 1.6629323292591145e-10,
            "cc4": 7.646062141911942e-7,
            "cc5": 0.00004826333810982474,
            "d2": 1.2431507544945822e-18,
            "d3": 1.387113910589066e-26,
            "d4": 1.8037305081442305e-34,
            "delmo": 0.6875245805144122,
            "eta": 0.12356123395256684,
            "argpdot": 0.00004397400299911533,
            "omgcof": -4.3055205037730997e-10,
            "sinmao": 0.3117761137967644,
            "t": 242209.59566049278,
            "t2cof": 2.4943984938886715e-10,
            "t3cof": 1.2984576331284851e-18,
            "t4cof": 1.1035033452919406e-26,
            "t5cof": 1.158229213076406e-34,
            "x1mth2": 0.5892276644685959,
            "x7thm1": 1.875406348719829,
            "mdot": 0.06350682411917444,
            "nodedot": -0.00005358604876671546,
            "xlcof": 0.0016971391320662174,
            "xmcof": -0.0000010583512058227924,
            "nodecf": -3.1161646858263206e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.1753642172272052,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "EOLE 1 (CAS-A)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05485",
            "epochyr": 22,
            "epochdays": 53.50542683,
            "ndot": 6.66618811525612e-13,
            "nddot": 0,
            "bstar": 0.000018011,
            "inclo": 0.5594356211294984,
            "nodeo": 1.4046584352975562,
            "ecco": 0.0640111,
            "argpo": 1.0752118310203587,
            "mo": 5.318990379220083,
            "no": 0.05555961769116682,
            "a": 1.2140261507133334,
            "alta": 0.2917373000492598,
            "altp": 0.13631500137740726,
            "jdsatepoch": 2459633.00542683,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0006206338957027211,
            "con41": 1.1550472457788694,
            "cc1": 3.2200410604326994e-12,
            "cc4": 2.292922525058164e-7,
            "cc5": 0.000007016471117275597,
            "d2": 2.4898182750546833e-22,
            "d3": 2.861062563281968e-32,
            "d4": 3.827521111373992e-42,
            "delmo": 1.8116802773851388,
            "eta": 0.38427322932694485,
            "argpdot": 0.00008014713770659944,
            "omgcof": 1.0237844168665658e-13,
            "sinmao": -0.8215902284510008,
            "t": 242580.61131455004,
            "t2cof": 4.830061590649049e-12,
            "t3cof": 2.6971915636721343e-22,
            "t4cof": 2.3946633161245444e-32,
            "t5cof": 2.607820923382563e-42,
            "x1mth2": 0.28165091807371023,
            "x7thm1": 4.0284435734840285,
            "mdot": 0.055595199576146385,
            "nodedot": -0.00005242891554743263,
            "xlcof": 0.0012156629538712298,
            "xmcof": -5.478460611742436e-10,
            "nodecf": -5.866567249405145e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.835256044262152,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "SHINSEI (MS-F2)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05547",
            "epochyr": 22,
            "epochdays": 53.52788241,
            "ndot": -7.272205216643039e-13,
            "nddot": 0,
            "bstar": -0.000036773,
            "inclo": 1.2920044133983304,
            "nodeo": 1.2801937703500847,
            "ecco": 0.012083,
            "argpo": 4.75735389790382,
            "mo": 1.5035453000570511,
            "no": 0.05509247340596469,
            "a": 1.2217428962637535,
            "alta": 0.2365052156793086,
            "altp": 0.2069805768481987,
            "jdsatepoch": 2459633.02788241,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242913581208046,
            "con41": -0.7728041117992082,
            "cc1": -2.475441851956167e-12,
            "cc4": 1.84995244507543e-8,
            "cc5": 0.0000024804739092596706,
            "d2": 1.4312701899436799e-22,
            "d3": -1.2295042796692483e-32,
            "d4": 1.229537126879667e-42,
            "delmo": 1.0142916124026282,
            "eta": 0.07055551264574988,
            "argpdot": -0.000018625664831726674,
            "omgcof": -1.5915675950631747e-13,
            "sinmao": 0.9977395018570712,
            "t": 242548.27527925372,
            "t2cof": -3.713162777934251e-12,
            "t3cof": 1.5538264371920034e-22,
            "t4cof": -1.0322112544369662e-32,
            "t5cof": 8.407252641839004e-43,
            "x1mth2": 0.9242680372664027,
            "x7thm1": -0.46987626086481893,
            "mdot": 0.05506930580723509,
            "nodedot": -0.000016475636490403847,
            "xlcof": 0.001929065685519189,
            "xmcof": 2.824530122564685e-8,
            "nodecf": 1.4301157677240523e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.976734913671336,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 444"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05548",
            "epochyr": 22,
            "epochdays": 53.57723102,
            "ndot": -3.93911115901498e-13,
            "nddot": 0,
            "bstar": 0.000018486,
            "inclo": 1.2919817241180545,
            "nodeo": 4.447310118921043,
            "ecco": 0.0102864,
            "argpo": 2.1921911363701936,
            "mo": 5.190377066640621,
            "no": 0.054921846740763475,
            "a": 1.2242705426198492,
            "alta": 0.23686387912945417,
            "altp": 0.21167720611024432,
            "jdsatepoch": 2459633.07723102,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242840558582671,
            "con41": -0.7727680932392711,
            "cc1": 1.1753612469027222e-12,
            "cc4": 1.4589623240612473e-8,
            "cc5": 0.0000023463602073696573,
            "d2": 3.194764626824952e-23,
            "d3": 1.2900429908199388e-33,
            "d4": 6.064048289719935e-44,
            "delmo": 1.0843332895058757,
            "eta": 0.05947022059941463,
            "argpdot": -0.00001848812346930497,
            "omgcof": -1.142699327667556e-12,
            "sinmao": -0.887922186835457,
            "t": 242477.2132808715,
            "t2cof": 1.7630418703540833e-12,
            "t3cof": 3.471059438969097e-23,
            "t4cof": 1.0842416468617558e-33,
            "t5cof": 4.1518646432078166e-44,
            "x1mth2": 0.9242560310797571,
            "x7thm1": -0.46979221755829925,
            "mdot": 0.05489884863184582,
            "nodedot": -0.00001635694147932018,
            "xlcof": 0.001929068237391945,
            "xmcof": -1.8859507883176647e-8,
            "nodecf": -6.741607686767019e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.004465001570814309,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 445"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05549",
            "epochyr": 22,
            "epochdays": 53.47357903,
            "ndot": -6.96919666594958e-13,
            "nddot": 0,
            "bstar": -0.000042561,
            "inclo": 1.2920061587275824,
            "nodeo": 1.212098004254274,
            "ecco": 0.0083951,
            "argpo": 5.688075156139323,
            "mo": 0.587565092683891,
            "no": 0.05475733083000446,
            "a": 1.2267201262035936,
            "alta": 0.23701856433508528,
            "altp": 0.21642168807210194,
            "jdsatepoch": 2459632.97357903,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242919198093339,
            "con41": -0.7728068823491048,
            "cc1": -2.5642501850693163e-12,
            "cc4": 1.0994882187991254e-8,
            "cc5": 0.0000022270139162263527,
            "d2": 1.506217632816404e-22,
            "d3": -1.314233760431712e-32,
            "d4": 1.3348761329745918e-42,
            "delmo": 1.1249085434178943,
            "eta": 0.04807649728972129,
            "argpdot": -0.000018359811723483173,
            "omgcof": -4.315944673730533e-12,
            "sinmao": 0.5543361121047667,
            "t": 242626.4721467346,
            "t2cof": -3.846375277603975e-12,
            "t3cof": 1.6377252130489645e-22,
            "t4cof": -1.105760114846775e-32,
            "t5cof": 9.151026363088111e-43,
            "x1mth2": 0.9242689607830349,
            "x7thm1": -0.4698827254812443,
            "mdot": 0.05473449316492223,
            "nodedot": -0.00001624044076997154,
            "xlcof": 0.001929065489146608,
            "xmcof": 6.285103215280293e-8,
            "nodecf": 1.460360496568814e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.634602543363528,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 446"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05550",
            "epochyr": 22,
            "epochdays": 53.60270064,
            "ndot": -5.75716246317574e-13,
            "nddot": 0,
            "bstar": -0.000023004,
            "inclo": 1.2919799787888024,
            "nodeo": 4.285390688225773,
            "ecco": 0.0066165,
            "argpo": 3.049556206144376,
            "mo": 4.2243861948808155,
            "no": 0.05458981866650517,
            "a": 1.2292269303018886,
            "alta": 0.23736011028623105,
            "altp": 0.22109375031754608,
            "jdsatepoch": 2459633.10270064,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242834941217908,
            "con41": -0.7727653224722555,
            "cc1": -1.3149824133983457e-12,
            "cc4": 7.93288531081292e-9,
            "cc5": 0.0000021172257637953184,
            "d2": 3.9231796002954006e-23,
            "d3": -1.7384930580371506e-33,
            "d4": 8.967704640820001e-44,
            "delmo": 0.9481355976327361,
            "eta": 0.037528968393491534,
            "argpdot": -0.00001822607175814067,
            "omgcof": 3.3476086849396698e-12,
            "sinmao": -0.883271039078274,
            "t": 242440.5370283872,
            "t2cof": -1.9724736200975187e-12,
            "t3cof": 4.269015349804788e-23,
            "t4cof": -1.464321758004227e-33,
            "t5cof": 6.155580204386373e-44,
            "x1mth2": 0.9242551074907518,
            "x7thm1": -0.46978575243526277,
            "mdot": 0.05456714577000229,
            "nodedot": -0.000016125499720286583,
            "xlcof": 0.0019290684336151732,
            "xmcof": 5.270415341247144e-8,
            "nodecf": 7.436061479550439e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.16493349092447573,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 447"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05551",
            "epochyr": 22,
            "epochdays": 53.49449177,
            "ndot": -7.272205216643039e-13,
            "nddot": 0,
            "bstar": -0.000054217,
            "inclo": 1.2920113947153382,
            "nodeo": 1.0827307094379504,
            "ecco": 0.0048554,
            "argpo": 0.4329498649082174,
            "mo": 1.5526710825129355,
            "no": 0.05442131441206715,
            "a": 1.2317615957378738,
            "alta": 0.23774229098981947,
            "altp": 0.22578090048592814,
            "jdsatepoch": 2459632.99449177,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242936048543734,
            "con41": -0.7728151939057412,
            "cc1": -2.9444977737335002e-12,
            "cc4": 5.219329655645746e-9,
            "cc5": 0.0000020161402025142638,
            "d2": 1.9483329676433742e-22,
            "d3": -1.9146541120532045e-32,
            "d4": 2.19018635909032e-42,
            "delmo": 1.0014838902323384,
            "eta": 0.0272775739185847,
            "argpdot": -0.000018096796876273116,
            "omgcof": -9.218658883403446e-12,
            "sinmao": 0.9998357422568243,
            "t": 242596.35780125856,
            "t2cof": -4.41674666060025e-12,
            "t3cof": 2.121734310433805e-22,
            "t4cof": -1.6144786949590387e-32,
            "t5cof": 1.5053293229540913e-42,
            "x1mth2": 0.9242717313019138,
            "x7thm1": -0.4699021191133961,
            "mdot": 0.05439880366579485,
            "nodedot": -0.000016007322795446657,
            "xlcof": 0.0019290648999648581,
            "xmcof": 2.2229540796023264e-7,
            "nodecf": 1.652894098389616e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.7663609210325575,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 448"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 5552",
            "epochyr": 22,
            "epochdays": 53.81186454,
            "ndot": -5.15114536178882e-13,
            "nddot": 0,
            "bstar": -0.000011937,
            "inclo": 1.2919887054350623,
            "nodeo": 1.1288300909708764,
            "ecco": 0.0036786,
            "argpo": 2.3762867205413034,
            "mo": 0.6912027436673144,
            "no": 0.05407072421208078,
            "a": 1.237077341126589,
            "alta": 0.24162805383365726,
            "altp": 0.23252662841952065,
            "jdsatepoch": 2459633.31186454,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242863027699245,
            "con41": -0.7727791761522503,
            "cc1": -5.867989434903622e-13,
            "cc4": 3.303421455031699e-9,
            "cc5": 0.000001835628685683835,
            "d2": 7.587193086149151e-24,
            "d3": -1.4566728351988688e-34,
            "d4": 3.255259958869913e-45,
            "delmo": 1.0475741032235868,
            "eta": 0.020263994795815303,
            "argpdot": -0.00001782395563743162,
            "omgcof": 1.8758288200668174e-12,
            "sinmao": 0.6374643328539542,
            "t": 242139.34101238847,
            "t2cof": -8.801984152355434e-13,
            "t3cof": 8.275859086311962e-24,
            "t4cof": -1.2311206890258587e-34,
            "t5cof": 2.2434111747932914e-45,
            "x1mth2": 0.9242597253840835,
            "x7thm1": -0.4698180776885843,
            "mdot": 0.05404855166820569,
            "nodedot": -0.000015768941020900056,
            "xlcof": 0.0019290674523923512,
            "xmcof": 7.900880689819707e-8,
            "nodecf": 3.2449192194515783e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.482747237242755,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 449"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 5553",
            "epochyr": 22,
            "epochdays": 53.84324351,
            "ndot": -4.5451282604019e-13,
            "nddot": 0,
            "bstar": 0.0000039817,
            "inclo": 1.2919764881302984,
            "nodeo": 4.290309026057893,
            "ecco": 0.0043291,
            "argpo": 4.561903201619234,
            "mo": 3.592926071509267,
            "no": 0.054243916548258296,
            "a": 1.2344441767129974,
            "alta": 0.2397882089984058,
            "altp": 0.2291001444275893,
            "jdsatepoch": 2459633.34324351,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124282370638564,
            "con41": -0.7727597808916993,
            "cc1": 2.055835095315627e-13,
            "cc4": 4.284117840450766e-9,
            "cc5": 0.0000019224346845847696,
            "d2": 9.40325613920113e-25,
            "d3": 6.387043904585935e-36,
            "d4": 5.049804962149075e-47,
            "delmo": 0.9363945472814734,
            "eta": 0.024079049607542948,
            "argpdot": -0.0000179566641383964,
            "omgcof": -1.1762011137288432e-13,
            "sinmao": -0.43616581937221477,
            "t": 242094.15529556572,
            "t2cof": 3.0837526429734406e-13,
            "t3cof": 1.0248547727027413e-24,
            "t4cof": 5.3919514992761594e-36,
            "t5cof": 3.475506833196887e-47,
            "x1mth2": 0.9242532602972331,
            "x7thm1": -0.46977282208063154,
            "mdot": 0.05422157836561795,
            "nodedot": -0.00001588775820831795,
            "xlcof": 0.0019290688260296268,
            "xmcof": -1.97569555928582e-8,
            "nodecf": -1.1454187691738781e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.6804469264763142,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 450"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05554",
            "epochyr": 22,
            "epochdays": 53.59011034,
            "ndot": -6.96919666594958e-13,
            "nddot": 0,
            "bstar": -0.00006617,
            "inclo": 1.2919869601058105,
            "nodeo": 4.591716915901802,
            "ecco": 0.00528,
            "argpo": 0.38626056208811704,
            "mo": 0.647272806394617,
            "no": 0.05387756678861009,
            "a": 1.240030682827566,
            "alta": 0.24657804483289558,
            "altp": 0.23348332082223644,
            "jdsatepoch": 2459633.09011034,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242857410471475,
            "con41": -0.7727764054472684,
            "cc1": -3.0911988811334345e-12,
            "cc4": 4.826535495787925e-9,
            "cc5": 0.0000017511789084876108,
            "d2": 2.083124735132229e-22,
            "d3": -2.0842275677395404e-32,
            "d4": 2.4272038554759847e-42,
            "delmo": 1.0704603219665085,
            "eta": 0.028776323816884396,
            "argpdot": -0.000017676165089341833,
            "omgcof": -8.685448041891604e-12,
            "sinmao": 0.6030130832212851,
            "t": 242458.6670601368,
            "t2cof": -4.636798321700152e-12,
            "t3cof": 2.274234945586641e-22,
            "t4cof": -1.7637357571788421e-32,
            "t5cof": 1.6752386189812687e-42,
            "x1mth2": 0.9242588018157561,
            "x7thm1": -0.46981161271029304,
            "mdot": 0.05385557818026768,
            "nodedot": -0.000015638502734479993,
            "xlcof": 0.0019290676486582521,
            "xmcof": 2.039251721222715e-7,
            "nodecf": 1.695211526450164e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.08560971573856335,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 451"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05557",
            "epochyr": 22,
            "epochdays": 53.56719996,
            "ndot": 2.27256413020095e-12,
            "nddot": 0,
            "bstar": 0.000049654,
            "inclo": 1.730757498069429,
            "nodeo": 1.288093130544611,
            "ecco": 0.0052041,
            "argpo": 2.365715261261974,
            "mo": 3.926847699988578,
            "no": 0.06231322601830619,
            "a": 1.1255657681423712,
            "alta": 0.131423324956361,
            "altp": 0.11970821132838139,
            "jdsatepoch": 2459633.06719996,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001154515519671804,
            "con41": -0.9238897654860938,
            "cc1": 3.991781768010972e-11,
            "cc4": 1.3544175446345536e-7,
            "cc5": 0.000026509288792150543,
            "d2": 6.35226735134111e-20,
            "d3": 1.5078367843668794e-28,
            "d4": 4.170499876124023e-37,
            "delmo": 0.8939472343480322,
            "eta": 0.051865769971089645,
            "argpdot": -0.000034829230840210026,
            "omgcof": -2.0096936017029214e-10,
            "sinmao": -0.7070055749449865,
            "t": 242491.65800772607,
            "t2cof": 5.987672652016458e-11,
            "t3cof": 6.670953785009606e-20,
            "t4cof": 1.2085383416405418e-28,
            "t5cof": 2.7013257305832157e-37,
            "x1mth2": 0.974629921828698,
            "x7thm1": -0.8224094528008856,
            "mdot": 0.06227632135729302,
            "nodedot": 0.000012697203750712805,
            "xlcof": 0.0015130428358930677,
            "xmcof": -0.0000014197154453425083,
            "nodecf": 1.778935307925347e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.224450735714001,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 4311 (DMSP 5B F1)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 5560",
            "epochyr": 22,
            "epochdays": 53.8477718,
            "ndot": 7.090400086226964e-12,
            "nddot": 0,
            "bstar": 0.000062929,
            "inclo": 1.6181523453892588,
            "nodeo": 0.6141970717400725,
            "ecco": 0.0017172,
            "argpo": 0.45887149495883717,
            "mo": 5.827930134430881,
            "no": 0.0632309687362342,
            "a": 1.11469047522585,
            "alta": 0.11660462170990793,
            "altp": 0.11277632874179222,
            "jdsatepoch": 2459633.3477718,
            "isimp": 0,
            "method": "n",
            "aycof": 0.00116813422980632,
            "con41": -0.9932772502262212,
            "cc1": 7.502876558770018e-11,
            "cc4": 2.4450399031441326e-8,
            "cc5": 0.00003883002933532592,
            "d2": 2.460204627485003e-19,
            "d3": 1.2039043845020498e-27,
            "d4": 6.865463725234431e-36,
            "delmo": 1.0514095526211003,
            "eta": 0.018761887044827893,
            "argpdot": -0.00004078719174390449,
            "omgcof": 1.6548420025039808e-9,
            "sinmao": -0.4396915112315975,
            "t": 242087.6345577836,
            "t2cof": 1.1254314838155028e-10,
            "t3cof": 2.572790940797284e-19,
            "t4cof": 9.593600247782779e-28,
            "t5cof": 4.417100049156044e-36,
            "x1mth2": 0.9977590834087403,
            "x7thm1": -0.9843135838611825,
            "mdot": 0.06318991950388111,
            "nodedot": 0.000003903337177629032,
            "xlcof": 0.001694156066104456,
            "xmcof": -0.000022638153119800563,
            "nodecf": 1.0282018024932447e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.7089769117020737,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "ASTEX 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 5580",
            "epochyr": 22,
            "epochdays": 53.72823533,
            "ndot": 1.1999138607461017e-11,
            "nddot": 0,
            "bstar": 0.000084091,
            "inclo": 1.431859391689888,
            "nodeo": 3.9343316718211296,
            "ecco": 0.0528231,
            "argpo": 0.685724155145304,
            "mo": 5.6642601384958615,
            "no": 0.060897652544297395,
            "a": 1.1429385324754047,
            "alta": 0.20331208887020602,
            "altp": 0.08256497608060309,
            "jdsatepoch": 2459633.22823533,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011581762474351244,
            "con41": -0.9424612504825818,
            "cc1": 1.2297604610485445e-10,
            "cc4": 0.0000020933358426999107,
            "cc5": 0.00005764350798666895,
            "d2": 5.30565140205403e-19,
            "d3": 3.411838868903224e-27,
            "d4": 2.556053871576922e-35,
            "delmo": 2.613008658133612,
            "eta": 0.4632992043372434,
            "argpdot": -0.00003436805419301279,
            "omgcof": 1.742717634275665e-11,
            "sinmao": -0.5801600430288837,
            "t": 242259.76707480848,
            "t2cof": 1.8446406915728166e-10,
            "t3cof": 5.608113560365696e-19,
            "t4cof": 2.7592690111486914e-27,
            "t5cof": 1.672993004917845e-35,
            "x1mth2": 0.9808204168275272,
            "x7thm1": -0.8657429177926905,
            "mdot": 0.06086182287203039,
            "nodedot": -0.000010521813944671855,
            "xlcof": 0.0018781494092918111,
            "xmcof": -1.4960117707967396e-8,
            "nodecf": -4.528854582658704e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.9558507577250097,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "PROSPERO (BLACK ARROW)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05614",
            "epochyr": 22,
            "epochdays": 53.59448685,
            "ndot": 1.0120485593161564e-11,
            "nddot": 0,
            "bstar": 0.00092871,
            "inclo": 1.292137058421482,
            "nodeo": 3.672198926134849,
            "ecco": 0.0022485,
            "argpo": 1.1362023617313004,
            "mo": 0.06397155307334816,
            "no": 0.05744928400148174,
            "a": 1.1881152906990342,
            "alta": 0.19078676793017113,
            "altp": 0.1854438134678975,
            "jdsatepoch": 2459633.09448685,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243340366882707,
            "con41": -0.773014629388987,
            "cc1": 1.2415683473888775e-10,
            "cc4": 5.277295748100497e-9,
            "cc5": 0.000004711992283196828,
            "d2": 4.1722479940014317e-19,
            "d3": 2.085837412672642e-27,
            "d4": 1.214312011710252e-35,
            "delmo": 1.0462456818712478,
            "eta": 0.015214642454214037,
            "argpdot": -0.000020543170668519756,
            "omgcof": 5.069551874452634e-10,
            "sinmao": 0.06392792956720632,
            "t": 242452.36488617957,
            "t2cof": 1.8623525210833163e-10,
            "t3cof": 4.480546386249022e-19,
            "t4cof": 1.7245666599758178e-27,
            "t5cof": 8.155596020090863e-36,
            "x1mth2": 0.9243382097963291,
            "x7thm1": -0.4703674685743032,
            "mdot": 0.057423736715524226,
            "nodedot": -0.000018151694480455002,
            "xlcof": 0.001929050730798251,
            "xmcof": -0.00003584363272166286,
            "nodecf": -7.904518104447417e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.1131834253184465,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 457"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05678",
            "epochyr": 22,
            "epochdays": 53.37030286,
            "ndot": -1.090830782496456e-12,
            "nddot": 0,
            "bstar": 0.000014491,
            "inclo": 1.2215681607755953,
            "nodeo": 0.5700280243598521,
            "ecco": 0.0008616,
            "argpo": 5.901879734837881,
            "mo": 0.382570936049401,
            "no": 0.05997522321424175,
            "a": 1.1544791953339415,
            "alta": 0.15547389460864114,
            "altp": 0.15348449605924186,
            "jdsatepoch": 2459632.87030286,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010988541629595374,
            "con41": -0.6487536007274923,
            "cc1": 4.587417886183052e-12,
            "cc4": 1.0129694926747399e-9,
            "cc5": 0.000010694820933700253,
            "d2": 6.844563729913812e-22,
            "d3": 1.5213775633489061e-31,
            "d4": 3.939211852708255e-41,
            "delmo": 1.0196248772261192,
            "eta": 0.007005753677394864,
            "argpdot": -0.000015171736008828287,
            "omgcof": 1.342782932856954e-10,
            "sinmao": 0.37330677833414,
            "t": 242775.18983133137,
            "t2cof": 6.8811268292745786e-12,
            "t3cof": 7.265451787163256e-22,
            "t4cof": 1.2376432814972425e-31,
            "t5cof": 2.5960206917668013e-41,
            "x1mth2": 0.8829178669091641,
            "x7thm1": -0.18042506836414873,
            "mdot": 0.05995151741161222,
            "nodedot": -0.00002497049899683429,
            "xlcof": 0.0019284224421337495,
            "xmcof": -0.000007412731550981348,
            "nodecf": -4.016814653892626e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.983922591866232,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7898 (P/L 1)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05680",
            "epochyr": 22,
            "epochdays": 53.305959,
            "ndot": -7.87822231802996e-13,
            "nddot": 0,
            "bstar": 0.000025681,
            "inclo": 1.221592595385123,
            "nodeo": 0.2512418911538357,
            "ecco": 0.0008945,
            "argpo": 5.701725376219171,
            "mo": 0.582384955463972,
            "no": 0.059999187971911956,
            "a": 1.1541719457022823,
            "alta": 0.15520435250771314,
            "altp": 0.1531395388968515,
            "jdsatepoch": 2459632.805959,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001098863940194468,
            "con41": -0.6488007363753588,
            "cc1": 8.201637887012206e-12,
            "cc4": 1.3757958014334325e-9,
            "cc5": 0.000010785365696517923,
            "d2": 2.1919773846422097e-21,
            "d3": 8.727522761374118e-31,
            "d4": 4.047886514842296e-40,
            "delmo": 1.0183688956803445,
            "eta": 0.007287108589221227,
            "argpdot": -0.000015188759282592315,
            "omgcof": 2.0870243830619723e-10,
            "sinmao": 0.5500173024852232,
            "t": 242867.84499026835,
            "t2cof": 1.230245683051831e-11,
            "t3cof": 2.3265111127015576e-21,
            "t4cof": 7.098768675505409e-31,
            "t5cof": 2.667163633988669e-40,
            "x1mth2": 0.8829335787917864,
            "x7thm1": -0.18053505154250415,
            "mdot": 0.05997545834157381,
            "nodedot": -0.00002499208362518958,
            "xlcof": 0.0019284255949773485,
            "xmcof": -0.00001227106829507956,
            "nodecf": -7.187697571377905e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.578531299721746,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7898 (P/L 2)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 5681",
            "epochyr": 22,
            "epochdays": 53.59200176,
            "ndot": -9.69627362219072e-13,
            "nddot": 0,
            "bstar": 0.000019392,
            "inclo": 1.2215803780803591,
            "nodeo": 0.2835496809375028,
            "ecco": 0.000924,
            "argpo": 5.733226823888417,
            "mo": 0.5509009610872462,
            "no": 0.05999471656162785,
            "a": 1.1542292507601266,
            "alta": 0.15529575858782896,
            "altp": 0.15316274293242427,
            "jdsatepoch": 2459633.09200176,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001098859051659012,
            "con41": -0.6487771688943644,
            "cc1": 6.183133132981058e-12,
            "cc4": 1.694119600526633e-9,
            "cc5": 0.000010768705133775064,
            "d2": 1.2453685856436329e-21,
            "d3": 3.7368494307879785e-31,
            "d4": 1.3061572407219468e-40,
            "delmo": 1.0193580758857181,
            "eta": 0.007524760662323922,
            "argpdot": -0.000015184686533822788,
            "omgcof": 1.5531769722756462e-10,
            "sinmao": 0.523455108106376,
            "t": 242455.9434156865,
            "t2cof": 9.274699699471586e-12,
            "t3cof": 1.3218308563239693e-21,
            "t4cof": 3.0395551710218226e-31,
            "t5cof": 8.60659269358834e-41,
            "x1mth2": 0.8829257229647881,
            "x7thm1": -0.18048006075351697,
            "mdot": 0.05997099191601197,
            "nodedot": -0.000024988585434756312,
            "xlcof": 0.0019284240188060973,
            "xmcof": -0.000008672832346238924,
            "nodecf": -5.41797347596703e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.09752639426837817,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7898 (P/L 3)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05682",
            "epochyr": 22,
            "epochdays": 53.31295478,
            "ndot": -8.18123086872342e-13,
            "nddot": 0,
            "bstar": 0.000024935,
            "inclo": 1.2215838687388632,
            "nodeo": 0.29945486641092706,
            "ecco": 0.0009206,
            "argpo": 5.730814778862161,
            "mo": 0.5533112607842503,
            "no": 0.05999511650744286,
            "a": 1.1542241269797706,
            "alta": 0.15528670571106806,
            "altp": 0.15316154824847295,
            "jdsatepoch": 2459632.81295478,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010988604484001646,
            "con41": -0.648783902530351,
            "cc1": 7.95166248643215e-12,
            "cc4": 1.6573823049789056e-9,
            "cc5": 0.00001077018718788318,
            "d2": 2.0597303821390264e-21,
            "d3": 7.948428848771747e-31,
            "d4": 3.5730113792024746e-40,
            "delmo": 1.0192582095576028,
            "eta": 0.007497310174792544,
            "argpdot": -0.000015185331768290611,
            "omgcof": 2.0019204765698162e-10,
            "sinmao": 0.5255072893036749,
            "t": 242857.77106650174,
            "t2cof": 1.1927493729648225e-11,
            "t3cof": 2.186188254735291e-21,
            "t4cof": 6.465239439953866e-31,
            "t5cof": 2.3543384455125895e-40,
            "x1mth2": 0.882927967510117,
            "x7thm1": -0.18049577257081917,
            "mdot": 0.059971391246950445,
            "nodedot": -0.000024988733360374417,
            "xlcof": 0.001928424469191873,
            "xmcof": -0.000011235665668815588,
            "nodecf": -6.967689743636519e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.622607431262097,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7898 (P/L 4)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05683",
            "epochyr": 22,
            "epochdays": 53.43868167,
            "ndot": -4.5451282604019e-13,
            "nddot": 0,
            "bstar": 0.0000082026,
            "inclo": 1.2920236120201023,
            "nodeo": 0.7611119068559472,
            "ecco": 0.0026829,
            "argpo": 2.5301671647018873,
            "mo": 5.658755370035071,
            "no": 0.05998913447198796,
            "a": 1.1543589513893204,
            "alta": 0.1574559810200027,
            "altp": 0.15126192175863795,
            "jdsatepoch": 2459632.93868167,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242975365062643,
            "con41": -0.7728345869950821,
            "cc1": 2.6095255329679052e-12,
            "cc4": 1.915187683780453e-8,
            "cc5": 0.000010777364857168841,
            "d2": 2.217233391119731e-22,
            "d3": 2.8065858555945857e-32,
            "d4": 4.138349031093095e-42,
            "delmo": 1.0541010562732436,
            "eta": 0.021839002768418513,
            "argpdot": -0.000022713422829707026,
            "omgcof": -2.2176633712021435e-11,
            "sinmao": -0.58463487794389,
            "t": 242676.7243451625,
            "t2cof": 3.914288299451858e-12,
            "t3cof": 2.3534258612639596e-22,
            "t4cof": 2.2829596776992096e-32,
            "t5cof": 2.726973712089204e-42,
            "x1mth2": 0.9242781956650273,
            "x7thm1": -0.46994736965519146,
            "mdot": 0.05996088105121372,
            "nodedot": -0.000020085157713651578,
            "xlcof": 0.001929063524834056,
            "xmcof": -4.344500867085359e-7,
            "nodecf": -1.8385609324642434e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.414735631606547,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 465"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05705",
            "epochyr": 22,
            "epochdays": 53.59989055,
            "ndot": 1.181733347704494e-12,
            "nddot": 0,
            "bstar": 0.000022456,
            "inclo": 1.2918333711316348,
            "nodeo": 4.508197675206118,
            "ecco": 0.001588,
            "argpo": 5.596272582813675,
            "mo": 0.6869074883781563,
            "no": 0.06267871840926728,
            "a": 1.121116335174279,
            "alta": 0.12289666791453557,
            "altp": 0.1193360024340222,
            "jdsatepoch": 2459633.09989055,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242362960315474,
            "con41": -0.7725325226817858,
            "cc1": 2.0980000659439976e-11,
            "cc4": 2.470344527658717e-8,
            "cc5": 0.00003044897301623889,
            "d2": 1.8184059147645065e-20,
            "d3": 2.351391932179032e-29,
            "d4": 3.543129017021592e-38,
            "delmo": 1.0385287892276531,
            "eta": 0.01640100069837662,
            "argpdot": -0.000025139375621026864,
            "omgcof": 3.8512854201166887e-10,
            "sinmao": 0.6341490549589428,
            "t": 242444.58355776966,
            "t2cof": 3.147000098915996e-11,
            "t3cof": 1.9064380002985268e-20,
            "t4cof": 1.880303062522635e-29,
            "t5cof": 2.2888143656650341e-38,
            "x1mth2": 0.9241775075605952,
            "x7thm1": -0.46924255292416683,
            "mdot": 0.06264743392966461,
            "nodedot": -0.000022261041604441808,
            "xlcof": 0.0019290848782829472,
            "xmcof": -0.000007794651228776881,
            "nodecf": -1.6385235561387038e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.14722883428580502,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 468"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05721",
            "epochyr": 22,
            "epochdays": 53.56414545,
            "ndot": -2.3937675504783338e-12,
            "nddot": 0,
            "bstar": 0.000012103,
            "inclo": 1.1255226920383474,
            "nodeo": 2.295210940798411,
            "ecco": 0.0066572,
            "argpo": 4.61698055682442,
            "mo": 1.6547815704008637,
            "no": 0.06005719416163304,
            "a": 1.1533327511105107,
            "alta": 0.1610107179012037,
            "altp": 0.1456547843198177,
            "jdsatepoch": 2459633.06414545,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001055415995343278,
            "con41": -0.44347999699349694,
            "cc1": 4.02860588615449e-12,
            "cc4": 6.912084042627817e-8,
            "cc5": 0.000011220238918109449,
            "d2": 5.313114370669013e-22,
            "d3": 1.0439428452642296e-31,
            "d4": 2.3894056957998464e-41,
            "delmo": 0.9863510787547969,
            "eta": 0.05448427947722687,
            "argpdot": -0.000002709991360010635,
            "omgcof": -1.4870185073050249e-12,
            "sinmao": 0.9964753119475731,
            "t": 242496.0565019399,
            "t2cof": 6.0429088292317355e-12,
            "t3cof": 5.637707678388184e-22,
            "t4cof": 8.488050385682445e-32,
            "t5cof": 1.5737064863638066e-41,
            "x1mth2": 0.8144933323311656,
            "x7thm1": 0.2985466736818403,
            "mdot": 0.06004093511713866,
            "nodedot": -0.00003155316010345343,
            "xlcof": 0.0019008504533942327,
            "xmcof": -1.0613880612147636e-7,
            "nodecf": -4.454569086102051e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.205206138078594,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 469"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05729",
            "epochyr": 22,
            "epochdays": 53.63722235,
            "ndot": 8.011546080335083e-11,
            "nddot": 0,
            "bstar": 0.00020263,
            "inclo": 1.2907652296294143,
            "nodeo": 4.973795669102141,
            "ecco": 0.0795046,
            "argpo": 1.61892378091864,
            "mo": 4.825350180232267,
            "no": 0.06015534462081836,
            "a": 1.1522354805241866,
            "alta": 0.24384350150906964,
            "altp": 0.06062745953930326,
            "jdsatepoch": 2459633.13722235,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011238916949336535,
            "con41": -0.7708331089068874,
            "cc1": 9.001982523331251e-10,
            "cc4": 0.000007433954804025644,
            "cc5": 0.00019026476010831957,
            "d2": 2.6737929502320623e-17,
            "d3": 1.183242565197028e-24,
            "d4": 6.099732860762935e-32,
            "delmo": 1.238572333345479,
            "eta": 0.6558185680136759,
            "argpdot": -0.00002302791146762201,
            "omgcof": -1.174240730315013e-12,
            "sinmao": -0.9936266650935835,
            "t": 242390.82576580346,
            "t2cof": 1.3502973784996876e-9,
            "t3cof": 2.835864328932785e-17,
            "t4cof": 9.614639407730022e-25,
            "t5cof": 4.014463797555242e-32,
            "x1mth2": 0.9236110363022958,
            "x7thm1": -0.46527725411607057,
            "mdot": 0.06012671130981793,
            "nodedot": -0.000020562306958738972,
            "xlcof": 0.0019292024180239556,
            "xmcof": -1.2811803996742231e-8,
            "nodecf": -6.452292043864716e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.3824336625777036,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "AUREOLE 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 5731",
            "epochyr": 22,
            "epochdays": 53.68698388,
            "ndot": 1.272635912912532e-12,
            "nddot": 0,
            "bstar": 0.000016153,
            "inclo": 1.4182266249025601,
            "nodeo": 2.015418953740452,
            "ecco": 0.0022975,
            "argpo": 3.618720292524491,
            "mo": 2.6644021828020232,
            "no": 0.06162546190101558,
            "a": 1.1339214370010513,
            "alta": 0.13652662150256134,
            "altp": 0.13131625249954149,
            "jdsatepoch": 2459633.18698388,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011558607718054489,
            "con41": -0.9307076219417125,
            "cc1": 9.624296238442103e-12,
            "cc4": 2.6892548053800895e-8,
            "cc5": 0.000019782219824668486,
            "d2": 3.4636678925450085e-21,
            "d3": 1.858686527942777e-30,
            "d4": 1.1621100571668416e-39,
            "delmo": 0.9438490451483492,
            "eta": 0.021477998517330576,
            "argpdot": -0.00003437836368311171,
            "omgcof": -1.2768528257268061e-10,
            "sinmao": 0.45928531815806606,
            "t": 242319.16916258633,
            "t2cof": 1.4436444357663155e-11,
            "t3cof": 3.64892204871559e-21,
            "t4cof": 1.496249669663369e-30,
            "t5cof": 7.565456639911456e-40,
            "x1mth2": 0.9769025406472376,
            "x7thm1": -0.8383177845306629,
            "mdot": 0.06158923630878039,
            "nodedot": -0.000011805183098765873,
            "xlcof": 0.0018862818243666915,
            "xmcof": -0.000001898612341281474,
            "nodecf": -3.9877442844807987e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.6959506140493872,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "METEOR 1-10"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05846",
            "epochyr": 22,
            "epochdays": 53.58392449,
            "ndot": 1.8180513041607598e-13,
            "nddot": 0,
            "bstar": 0.000028766,
            "inclo": 1.292365696553493,
            "nodeo": 3.981347351211353,
            "ecco": 0.0022051,
            "argpo": 2.259534665558395,
            "mo": 5.088168840314581,
            "no": 0.06007678625836927,
            "a": 1.1532368330828424,
            "alta": 0.15577983562347342,
            "altp": 0.15069383054221142,
            "jdsatepoch": 2459633.08392449,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011244075546239733,
            "con41": -0.7733772849162177,
            "cc1": 9.442586207316277e-12,
            "cc4": 1.449810343861003e-8,
            "cc5": 0.000011103840247510491,
            "d2": 2.923483008512508e-21,
            "d3": 1.3484908461326502e-30,
            "d4": 7.245729652807832e-40,
            "delmo": 1.020033174142528,
            "eta": 0.0180753599706536,
            "argpdot": -0.000022823844291777246,
            "omgcof": -7.654322114553257e-11,
            "sinmao": -0.9302216977136627,
            "t": 242467.57468432188,
            "t2cof": 1.4163879310974415e-11,
            "t3cof": 3.101807877077707e-21,
            "t4cof": 1.096288665530418e-30,
            "t5cof": 4.7714750019306446e-40,
            "x1mth2": 0.9244590949720726,
            "x7thm1": -0.471213664804508,
            "mdot": 0.060048416648662103,
            "nodedot": -0.000020129398644655114,
            "xlcof": 0.0019290248089248673,
            "xmcof": -0.0000023120764542403805,
            "nodecf": -6.667554812831661e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.04663645920768289,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 475"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05903",
            "epochyr": 22,
            "epochdays": 53.58918017,
            "ndot": 2.151360709923566e-12,
            "nddot": 0,
            "bstar": 0.00005031,
            "inclo": 1.7272179703463844,
            "nodeo": 3.074085063451905,
            "ecco": 0.0050458,
            "argpo": 5.266316342394894,
            "mo": 1.0103519053577454,
            "no": 0.062179487315394855,
            "a": 1.127179450671185,
            "alta": 0.13286697274338155,
            "altp": 0.12149192859898839,
            "jdsatepoch": 2459633.08918017,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011551675909001308,
            "con41": -0.9271935284559661,
            "cc1": 3.815262335913428e-11,
            "cc4": 1.21270470907651e-7,
            "cc5": 0.00002504653654129985,
            "d2": 5.729355971121962e-20,
            "d3": 1.2832744585826286e-28,
            "d4": 3.3491479654185185e-37,
            "delmo": 1.081285766787429,
            "eta": 0.04965088990970108,
            "argpdot": -0.000034872844203051974,
            "omgcof": 1.4394192185271996e-10,
            "sinmao": 0.8470189568168599,
            "t": 242460.0065050274,
            "t2cof": 5.722893503870142e-11,
            "t3cof": 6.020480504958753e-20,
            "t4cof": 1.0294212276602182e-28,
            "t5cof": 2.171451525446473e-37,
            "x1mth2": 0.9757311761519887,
            "x7thm1": -0.8301182330639209,
            "mdot": 0.06214263599936536,
            "nodedot": 0.000012356402106846653,
            "xlcof": 0.00151958630652391,
            "xmcof": -0.0000014642989362642095,
            "nodecf": 1.6546391531703282e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.07974928334547116,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 5058 (DMSP 5B F2)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "05905",
            "epochyr": 22,
            "epochdays": 53.59491058,
            "ndot": 1.5150427534673e-13,
            "nddot": 0,
            "bstar": -0.00002153,
            "inclo": 1.4481188790014672,
            "nodeo": 4.7195256316960945,
            "ecco": 0.0019788,
            "argpo": 1.3338172662883585,
            "mo": 5.990387126535766,
            "no": 0.057622025179159035,
            "a": 1.1858240409464849,
            "alta": 0.18817054955870982,
            "altp": 0.18347753233426012,
            "jdsatepoch": 2459633.09491058,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011606563770698477,
            "con41": -0.9550767725655807,
            "cc1": -3.0322499019040543e-12,
            "cc4": 3.7069664325999334e-9,
            "cc5": 0.00000496433917738187,
            "d2": 2.5177102299778385e-22,
            "d3": -3.110275720905713e-32,
            "d4": 4.474467567933406e-42,
            "delmo": 1.0394158567676044,
            "eta": 0.013546205931894621,
            "argpdot": -0.00003074137158531095,
            "omgcof": -8.253333557080403e-12,
            "sinmao": -0.2886324415945226,
            "t": 242451.75471447408,
            "t2cof": -4.548374852856081e-12,
            "t3cof": 2.7016010193297815e-22,
            "t4cof": -2.568706623965147e-32,
            "t5cof": 3.001237246690892e-42,
            "x1mth2": 0.9850255908551936,
            "x7thm1": -0.895179135986355,
            "mdot": 0.05759024256263009,
            "nodedot": -0.000008127787898709895,
            "xlcof": 0.001867528831839282,
            "xmcof": 0.000001119890874289437,
            "nodecf": 8.648648178098976e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.11585309098258989,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 480"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 5917",
            "epochyr": 22,
            "epochdays": 53.850722,
            "ndot": 3.5148991880441356e-12,
            "nddot": 0,
            "bstar": 0.000059548,
            "inclo": 1.417659392895662,
            "nodeo": 0.33772993690716274,
            "ecco": 0.0031322,
            "argpo": 1.678008412086404,
            "mo": 4.613449755747635,
            "no": 0.061504075622627205,
            "a": 1.135411499617696,
            "alta": 0.1389678355167987,
            "altp": 0.1318551637185934,
            "jdsatepoch": 2459633.350722,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011557597714211211,
            "con41": -0.9301954674143295,
            "cc1": 3.384450501955682e-11,
            "cc4": 4.3839135266530265e-8,
            "cc5": 0.000018909813128221,
            "d2": 4.2367991778700636e-20,
            "d3": 7.907910831478186e-29,
            "d4": 1.719690468998333e-37,
            "delmo": 0.9914416719917725,
            "eta": 0.02896349984787368,
            "argpdot": -0.00003418816315131665,
            "omgcof": -3.9045571093282753e-11,
            "sinmao": -0.9951095062755773,
            "t": 242083.38626995683,
            "t2cof": 5.0766757529335226e-11,
            "t3cof": 4.465889281873825e-20,
            "t4cof": 6.37080203820408e-29,
            "t5cof": 1.1205394688062799e-37,
            "x1mth2": 0.9767318224714431,
            "x7thm1": -0.8371227573001019,
            "mdot": 0.061468035832428145,
            "nodedot": -0.000011794556007459377,
            "xlcof": 0.0018866050159567797,
            "xmcof": -0.0000036255066764957137,
            "nodecf": -1.4010367218762609e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.7275643159165597,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "METEOR 1-11"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6019",
            "epochyr": 22,
            "epochdays": 53.82500332,
            "ndot": -2.1210598548542201e-13,
            "nddot": 0,
            "bstar": 0.000016608,
            "inclo": 1.291868277716675,
            "nodeo": 1.170876817980672,
            "ecco": 0.0024668,
            "argpo": 6.004499858867392,
            "mo": 3.3112194582618697,
            "no": 0.060065805248386575,
            "a": 1.15337692457221,
            "alta": 0.15622207476974492,
            "altp": 0.15053177437467546,
            "jdsatepoch": 2459633.32500332,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242475358638762,
            "con41": -0.7725879611275466,
            "cc1": 5.432196156989192e-12,
            "cc4": 1.737418086225641e-8,
            "cc5": 0.000011066846737026745,
            "d2": 9.666935561427674e-22,
            "d3": 2.5629339697343527e-31,
            "d4": 7.915386039076154e-41,
            "delmo": 0.9414430878913899,
            "eta": 0.020202814869527106,
            "argpdot": -0.000022766128114565318,
            "omgcof": 5.944053026183398e-11,
            "sinmao": -0.16881452166383587,
            "t": 242120.4211693257,
            "t2cof": 8.148294235483788e-12,
            "t3cof": 1.0257110663187837e-21,
            "t4cof": 2.0837459815703784e-31,
            "t5cof": 5.212884620712515e-41,
            "x1mth2": 0.9241959870425156,
            "x7thm1": -0.46937190929760875,
            "mdot": 0.06003747661027882,
            "nodedot": -0.000020155931283412975,
            "xlcof": 0.0019290809697129867,
            "xmcof": -0.0000010633466868565096,
            "nodecf": -3.8407972074619287e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.5655266497862144,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 489"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6059",
            "epochyr": 22,
            "epochdays": 53.57033037,
            "ndot": 1.242335057843186e-12,
            "nddot": 0,
            "bstar": 0.000023296,
            "inclo": 1.2924826336133768,
            "nodeo": 1.5918432522446961,
            "ecco": 0.0011713,
            "argpo": 4.567154897338486,
            "mo": 1.7157249772220016,
            "no": 0.06267330295246755,
            "a": 1.1211813696782935,
            "alta": 0.12249460941659773,
            "altp": 0.1198681299399893,
            "jdsatepoch": 2459633.07033037,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011244451326815285,
            "con41": -0.773562662313066,
            "cc1": 2.1697893230893424e-11,
            "cc4": 7.830318833817826e-9,
            "cc5": 0.000030354108600825,
            "d2": 1.9439347762058174e-20,
            "d3": 2.5983245642408014e-29,
            "d4": 4.0469941318775493e-38,
            "delmo": 0.9947706197179259,
            "eta": 0.012090790761012344,
            "argpdot": -0.000025203468740590263,
            "omgcof": -1.0109584313409393e-10,
            "sinmao": 0.9895162128268631,
            "t": 242487.15021684766,
            "t2cof": 3.2546839846340136e-11,
            "t3cof": 2.0380944903376674e-20,
            "t4cof": 2.07783512512626e-29,
            "t5cof": 2.614408379306885e-38,
            "x1mth2": 0.9245208874376887,
            "x7thm1": -0.47164621206382074,
            "mdot": 0.06264198314334106,
            "nodedot": -0.000022205984091985013,
            "xlcof": 0.0019290114803980866,
            "xmcof": -0.00001483578150481916,
            "nodecf": -1.6904061612632102e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.2441735357173656,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 494"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6073",
            "epochyr": 22,
            "epochdays": 53.76033611,
            "ndot": 1.3727802389167205e-9,
            "nddot": 1.3353418490977064e-14,
            "bstar": 0.00016,
            "inclo": 0.9080825925078857,
            "nodeo": 0.9951239076340949,
            "ecco": 0.1202925,
            "argpo": 3.0999874948807524,
            "mo": 3.1961254660683562,
            "no": 0.05859784352342945,
            "a": 1.1721273310996805,
            "alta": 0.3131254580759888,
            "altp": 0.031129204123372167,
            "jdsatepoch": 2459633.26033611,
            "isimp": 1,
            "method": "n",
            "aycof": 0.0009219035210488476,
            "con41": 0.1356287728887759,
            "cc1": 1.6338819704668192e-8,
            "cc4": 0.00017503515087841838,
            "cc5": 0.00445069797178135,
            "d2": 0,
            "d3": 0,
            "d4": 0,
            "delmo": 0.0017200216551711202,
            "eta": 0.8814953517072575,
            "argpdot": 0.00003177461795225449,
            "omgcof": -5.155480385870638e-12,
            "sinmao": -0.054505787966377645,
            "t": 242213.54195170105,
            "t2cof": 2.450822955700229e-8,
            "t3cof": 0,
            "t4cof": 0,
            "t5cof": 0,
            "x1mth2": 0.6214570757037414,
            "x7thm1": 1.6498004700738105,
            "mdot": 0.05860264944837206,
            "nodedot": -0.000043888343353887786,
            "xlcof": 0.0017340120359070578,
            "xmcof": -2.8888419424486143e-9,
            "nodecf": -2.4724782838300793e-12,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.1580981296002832,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 482 DESCENT CRAFT"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06079",
            "epochyr": 22,
            "epochdays": 53.56743935,
            "ndot": 3.969412014084326e-12,
            "nddot": 0,
            "bstar": 0.00007654,
            "inclo": 1.4176314676276303,
            "nodeo": 1.1681349057257888,
            "ecco": 0.0010637,
            "argpo": 3.4105060034200716,
            "mo": 2.87415410697745,
            "no": 0.061259522549842564,
            "a": 1.1384288922942456,
            "alta": 0.13963983910697908,
            "altp": 0.13721794548151212,
            "jdsatepoch": 2459633.06743935,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011557547894899206,
            "con41": -0.9301702061080943,
            "cc1": 3.928593398243276e-11,
            "cc4": -1.39665289779724e-9,
            "cc5": 0.000017120531445901262,
            "d2": 5.586471879670822e-20,
            "d3": 1.1842813670604804e-28,
            "d4": 2.9249844080791388e-37,
            "delmo": 0.9724078149265702,
            "eta": 0.009625484963771639,
            "argpdot": -0.0000338699878361461,
            "omgcof": -1.1744264971566057e-9,
            "sinmao": 0.2642619101431049,
            "t": 242491.31328620017,
            "t2cof": 5.892890097364913e-11,
            "t3cof": 5.895148801445235e-20,
            "t4cof": 9.55567787579541e-29,
            "t5cof": 1.909347191481134e-37,
            "x1mth2": 0.9767234020360315,
            "x7thm1": -0.8370638142522202,
            "mdot": 0.061223817557598474,
            "nodedot": -0.000011687504560908068,
            "xlcof": 0.0018866208956831857,
            "xmcof": -0.00003746642522368242,
            "nodecf": -1.6115207227245075e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.225958985309646,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "METEOR 1-12"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06117",
            "epochyr": 22,
            "epochdays": 53.57370463,
            "ndot": -5.15114536178882e-13,
            "nddot": 0,
            "bstar": 0.0000022794,
            "inclo": 1.2920724812391582,
            "nodeo": 0.20506222447531777,
            "ecco": 0.0112719,
            "argpo": 4.45632998049535,
            "mo": 3.9625972790571775,
            "no": 0.05515741106122707,
            "a": 1.2207843660967546,
            "alta": 0.23454492539296035,
            "altp": 0.20702380680054855,
            "jdsatepoch": 2459633.07370463,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243132614356672,
            "con41": -0.7729121517528681,
            "cc1": 1.5579740918378966e-13,
            "cc4": 1.7513839807745563e-8,
            "cc5": 0.0000025141969410009315,
            "d2": 5.691030809534365e-25,
            "d3": 3.0887092176594884e-36,
            "d4": 1.9515069730310437e-47,
            "delmo": 0.8709123432642423,
            "eta": 0.06607050251683277,
            "argpdot": -0.000018681600116039157,
            "omgcof": -6.104463484134589e-14,
            "sinmao": -0.7318308374482416,
            "t": 242482.2912825644,
            "t2cof": 2.336961137756845e-13,
            "t3cof": 6.176487463701988e-25,
            "t4cof": 2.5919803810815835e-36,
            "t5cof": 1.3337256737977255e-47,
            "x1mth2": 0.9243040505842893,
            "x7thm1": -0.4701283540900254,
            "mdot": 0.05513417712470864,
            "nodedot": -0.000016516375113544656,
            "xlcof": 0.0019290580190833941,
            "xmcof": -2.04136273615061e-9,
            "nodecf": -9.023207043481207e-18,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.2654326827582025,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 504"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06118",
            "epochyr": 22,
            "epochdays": 53.62959731,
            "ndot": -6.0601710138692e-14,
            "nddot": 0,
            "bstar": 0.000080122,
            "inclo": 1.2920271026786063,
            "nodeo": 3.246354296611501,
            "ecco": 0.0091837,
            "argpo": 1.6961737989411612,
            "mo": 4.804299764123963,
            "no": 0.05499136372259198,
            "a": 1.2232391527313848,
            "alta": 0.234473014138324,
            "altp": 0.21200529132444568,
            "jdsatepoch": 2459633.12959731,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242986598045527,
            "con41": -0.7728401277381695,
            "cc1": 5.176192944601641e-12,
            "cc4": 1.3167967845403779e-8,
            "cc5": 0.000002379572888115246,
            "d2": 6.221175819954231e-22,
            "d3": 1.1108343685928037e-31,
            "d4": 2.3089970725346335e-41,
            "delmo": 1.014750562086467,
            "eta": 0.053310070820900335,
            "argpdot": -0.000018545528565486684,
            "omgcof": -1.222591270685247e-12,
            "sinmao": -0.995779176487964,
            "t": 242401.80582359433,
            "t2cof": 7.764289416902462e-12,
            "t3cof": 6.757035287949106e-22,
            "t4cof": 9.331989356006394e-32,
            "t5cof": 1.5800556972546957e-41,
            "x1mth2": 0.9242800425793898,
            "x7thm1": -0.4699602980557287,
            "mdot": 0.05496829624486841,
            "nodedot": -0.00001640192893320286,
            "xlcof": 0.001929063131843527,
            "xmcof": -1.0415062336703706e-7,
            "nodecf": -2.9771877731293387e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.33439295046368755,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 505"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6119",
            "epochyr": 22,
            "epochdays": 53.86613365,
            "ndot": -3.93911115901498e-13,
            "nddot": 0,
            "bstar": 0.000024154,
            "inclo": 1.292088189202426,
            "nodeo": 6.116939205268623,
            "ecco": 0.0073621,
            "argpo": 4.934164477777105,
            "mo": 2.304494347089769,
            "no": 0.05483357008711568,
            "a": 1.2255834761366404,
            "alta": 0.234606344246306,
            "altp": 0.21656060802697485,
            "jdsatepoch": 2459633.36613365,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243183153070246,
            "con41": -0.7729370806997687,
            "cc1": 1.4827901209163055e-12,
            "cc4": 9.729235895092067e-9,
            "cc5": 0.0000022649683610772873,
            "d2": 5.058659776340607e-23,
            "d3": 2.563701634476027e-33,
            "d4": 1.5124723399521987e-43,
            "delmo": 0.9173210640558799,
            "eta": 0.04234652960821798,
            "argpdot": -0.000018425303835012905,
            "omgcof": 7.629982050416994e-13,
            "sinmao": 0.7427032152652784,
            "t": 242061.1934942007,
            "t2cof": 2.2241851813744583e-12,
            "t3cof": 5.498393084878006e-23,
            "t4cof": 2.15595455067177e-33,
            "t5cof": 1.0362442130461357e-43,
            "x1mth2": 0.9243123602332562,
            "x7thm1": -0.47018652163279373,
            "mdot": 0.0548106548800138,
            "nodedot": -0.000016287986230835495,
            "xlcof": 0.0019290562476015304,
            "xmcof": -4.717118846946588e-8,
            "nodecf": -8.469499391392664e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.824663691092745,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 506"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06120",
            "epochyr": 22,
            "epochdays": 53.53246106,
            "ndot": -9.090256520803799e-14,
            "nddot": 0,
            "bstar": 0.000080308,
            "inclo": 1.2920428106418742,
            "nodeo": 2.6589061409874932,
            "ecco": 0.0053361,
            "argpo": 1.8659733912091856,
            "mo": 4.621912857290556,
            "no": 0.054678572236284154,
            "a": 1.227897165835738,
            "alta": 0.23444934790235417,
            "altp": 0.22134498376912193,
            "jdsatepoch": 2459633.03246106,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243037144773227,
            "con41": -0.7728650603143544,
            "cc1": 4.694440270545986e-12,
            "cc4": 6.363218984872578e-9,
            "cc5": 0.0000021606758075454387,
            "d2": 5.025394557634046e-22,
            "d3": 7.990883237552293e-32,
            "d4": 1.479102302611364e-41,
            "delmo": 0.9917769142663625,
            "eta": 0.0304205105186584,
            "argpdot": -0.0000182995839928769,
            "omgcof": -4.37300744461277e-12,
            "sinmao": -0.9959098268728164,
            "t": 242541.68202325702,
            "t2cof": 7.041660405818979e-12,
            "t3cof": 5.466149946708523e-22,
            "t4cof": 6.726768613865559e-32,
            "t5cof": 1.0145880360661843e-41,
            "x1mth2": 0.9242883534381181,
            "x7thm1": -0.47001847406682695,
            "mdot": 0.05465581084328413,
            "nodedot": -0.000016182618767525362,
            "xlcof": 0.0019290613628580708,
            "xmcof": -2.884716003298915e-7,
            "nodecf": -2.6641033366131006e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.005582185633486,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 507"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06121",
            "epochyr": 22,
            "epochdays": 53.4795616,
            "ndot": -1.8180513041607598e-13,
            "nddot": 0,
            "bstar": 0.000069056,
            "inclo": 1.2920672452514022,
            "nodeo": 5.6066729998263085,
            "ecco": 0.0034412,
            "argpo": 5.200604696057307,
            "mo": 4.102454002677987,
            "no": 0.0545146784024083,
            "a": 1.2303556269982268,
            "alta": 0.23458952678185296,
            "altp": 0.22612172721460033,
            "jdsatepoch": 2459632.9795616,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124311576750234,
            "con41": -0.7729038418247189,
            "cc1": 3.84210476243704e-12,
            "cc4": 3.5039098373336104e-9,
            "cc5": 0.000002061291901118677,
            "d2": 3.334865685481896e-22,
            "d3": 4.299179661996266e-32,
            "d4": 6.451518725669648e-42,
            "delmo": 0.96697209765598,
            "eta": 0.01943523806762654,
            "argpdot": -0.000018173176180361902,
            "omgcof": 8.85604659900838e-12,
            "sinmao": -0.8196852652687702,
            "t": 242617.8572461009,
            "t2cof": 5.76315714365556e-12,
            "t3cof": 3.6301010655927234e-22,
            "t4cof": 3.622950912215082e-32,
            "t5cof": 4.430987592399198e-42,
            "x1mth2": 0.9243012806082397,
            "x7thm1": -0.47010896425767756,
            "mdot": 0.054492075271850196,
            "nodedot": -0.000016067885150437152,
            "xlcof": 0.0019290586093853152,
            "xmcof": -5.753199530051606e-7,
            "nodecf": -2.164961389313065e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.6722950554580365,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 508"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6122",
            "epochyr": 22,
            "epochdays": 53.71383432,
            "ndot": -2.72707695624114e-13,
            "nddot": 0,
            "bstar": 0.000043361,
            "inclo": 1.2920305933371103,
            "nodeo": 2.373733303845636,
            "ecco": 0.0015545,
            "argpo": 2.9063414690427294,
            "mo": 5.404851851771944,
            "no": 0.05434421805478078,
            "a": 1.2329256546702734,
            "alta": 0.2348422376004582,
            "altp": 0.23100907174008833,
            "jdsatepoch": 2459633.21383432,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124299783089142,
            "con41": -0.7728456684192202,
            "cc1": 2.2958220326282254e-12,
            "cc4": 9.537303213402815e-10,
            "cc5": 0.0000019668943744025625,
            "d2": 1.1793065129322038e-22,
            "d3": 8.996455837082999e-33,
            "d4": 7.988683745415189e-43,
            "delmo": 1.0167466304006179,
            "eta": 0.008695228379993107,
            "argpdot": -0.000018037760500460495,
            "omgcof": -2.3991652396860782e-11,
            "sinmao": -0.7696759682830006,
            "t": 242280.50452888012,
            "t2cof": 3.443733048942338e-12,
            "t3cof": 1.2847224890422278e-22,
            "t4cof": 7.589837280563816e-33,
            "t5cof": 5.4939329498141775e-43,
            "x1mth2": 0.9242818894730733,
            "x7thm1": -0.4699732263115136,
            "mdot": 0.05432178145628114,
            "nodedot": -0.000015952774432524994,
            "xlcof": 0.0019290627388103261,
            "xmcof": -0.0000017054919388521113,
            "nodecf": -1.284390563329691e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.8651188071463807,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 509"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06123",
            "epochyr": 22,
            "epochdays": 53.50323064,
            "ndot": -2.72707695624114e-13,
            "nddot": 0,
            "bstar": 0.000051033,
            "inclo": 1.2920532826173863,
            "nodeo": 5.428289878296976,
            "ecco": 0.0008545,
            "argpo": 2.2169189612124494,
            "mo": 0.7989942782704842,
            "no": 0.05417295205150921,
            "a": 1.2355214444211287,
            "alta": 0.23657719749538653,
            "altp": 0.23446569134687079,
            "jdsatepoch": 2459633.00323064,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124307084105052,
            "con41": -0.7728816813338865,
            "cc1": 2.575177951326973e-12,
            "cc4": 7.940864320539409e-11,
            "cc5": 0.000001880140505418093,
            "d2": 1.469573214917783e-22,
            "d3": 1.2453442412550537e-32,
            "d4": 1.2283905230019371e-42,
            "delmo": 1.0099376208440207,
            "eta": 0.004734006097017485,
            "argpdot": -0.000017907106086562217,
            "omgcof": -2.990066050444387e-11,
            "sinmao": 0.7166550351466804,
            "t": 242583.77382807434,
            "t2cof": 3.8627669269904594e-12,
            "t3cof": 1.6022040445377946e-22,
            "t4cof": 1.0518099070200951e-32,
            "t5cof": 8.45896905242316e-43,
            "x1mth2": 0.9242938937779621,
            "x7thm1": -0.47005725644573504,
            "mdot": 0.0541506790706061,
            "nodedot": -0.000015834533006572223,
            "xlcof": 0.00192906018305436,
            "xmcof": -0.000006400039556341177,
            "nodecf": -1.4299878231835618e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.821419195254222,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 510"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06124",
            "epochyr": 22,
            "epochdays": 53.60849069,
            "ndot": -2.1210598548542201e-13,
            "nddot": 0,
            "bstar": 0.00006663,
            "inclo": 1.2920288480078583,
            "nodeo": 2.3753739133425102,
            "ecco": 0.0031899,
            "argpo": 5.932585312368218,
            "mo": 2.3003980593353384,
            "no": 0.053989906006532036,
            "a": 1.2383109171539606,
            "alta": 0.24226100514859006,
            "altp": 0.2343608291593311,
            "jdsatepoch": 2459633.10849069,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242992214485598,
            "con41": -0.7728428980864493,
            "cc1": 3.20105013344492e-12,
            "cc4": 2.67387015479557e-9,
            "cc5": 0.000001796353926899672,
            "d2": 2.2477096515951625e-22,
            "d3": 2.3434577772782744e-32,
            "d4": 2.8438848811466237e-42,
            "delmo": 0.9654245997460176,
            "eta": 0.01749332383525302,
            "argpdot": -0.000017764782728015962,
            "omgcof": 1.5276784942358407e-11,
            "sinmao": 0.7454399357145867,
            "t": 242432.1993561834,
            "t2cof": 4.80157520016738e-12,
            "t3cof": 2.4526440907317174e-22,
            "t4cof": 1.9816443390360487e-32,
            "t5cof": 1.9611279121950885e-42,
            "x1mth2": 0.9242809660288165,
            "x7thm1": -0.4699667622017152,
            "mdot": 0.053967808984174956,
            "nodedot": -0.000015711750344424438,
            "xlcof": 0.0019290629353322607,
            "xmcof": -5.763510882513334e-7,
            "nodecf": -1.7637170394654347e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.2014130539402217,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 511"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6126",
            "epochyr": 22,
            "epochdays": 53.8114092,
            "ndot": 0,
            "nddot": 0,
            "bstar": 0.000032847,
            "inclo": 1.7333126600943485,
            "nodeo": 0.5794859635764094,
            "ecco": 0.0007297,
            "argpo": 3.8235887854528374,
            "mo": 2.4607048058017655,
            "no": 0.061016015783938435,
            "a": 1.1414492861586036,
            "alta": 0.14228220170271344,
            "altp": 0.1406163706144936,
            "jdsatepoch": 2459633.3114092,
            "isimp": 0,
            "method": "n",
            "aycof": 0.00115403580363913,
            "con41": -0.9214604427657419,
            "cc1": 1.5317121421505117e-11,
            "cc4": -6.733923542354729e-9,
            "cc5": 0.000015603602905410874,
            "d2": 8.314682001781744e-21,
            "d3": 6.727808368013415e-30,
            "d4": 6.342196902643786e-39,
            "delmo": 0.985005141575131,
            "eta": 0.006465106580544579,
            "argpdot": -0.00003300778465730235,
            "omgcof": -5.22443906171486e-10,
            "sinmao": 0.6294831423156588,
            "t": 242139.9967018515,
            "t2cof": 2.2975682132257675e-11,
            "t3cof": 8.783910419064007e-21,
            "t4cof": 5.4369112932199604e-30,
            "t5cof": 4.1474700308599194e-39,
            "x1mth2": 0.9738201475885807,
            "x7thm1": -0.8167410331200646,
            "mdot": 0.06098097202746566,
            "nodedot": 0.000012280802267262976,
            "xlcof": 0.0015082839624244008,
            "xmcof": -0.000031730000845507755,
            "nodecf": 6.601816367417896e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.4798784191235868,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "LANDSAT 1 (ERTS 1)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06148",
            "epochyr": 22,
            "epochdays": 53.49030432,
            "ndot": 1.302936767981878e-12,
            "nddot": 0,
            "bstar": 0.000026095,
            "inclo": 1.4480577924776474,
            "nodeo": 0.5750720258981156,
            "ecco": 0.0008617,
            "argpo": 4.900978787379685,
            "mo": 3.393108561436192,
            "no": 0.060328762077226136,
            "a": 1.150110883626317,
            "alta": 0.15110193417473772,
            "altp": 0.14911983307789622,
            "jdsatepoch": 2459632.99030432,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011606476331184436,
            "con41": -0.95503224784513,
            "cc1": 9.354722591060313e-12,
            "cc4": -3.4996480135771935e-9,
            "cc5": 0.000012123148194120196,
            "d2": 2.92821653113882e-21,
            "d3": 1.3657552176978816e-30,
            "d4": 7.420669750966915e-40,
            "delmo": 0.9792011645836755,
            "eta": 0.007208376516823644,
            "argpdot": -0.00003420948992006999,
            "omgcof": 6.098253428067255e-11,
            "sinmao": -0.24887245637032965,
            "t": 242602.38772898912,
            "t2cof": 1.4032083886590468e-11,
            "t3cof": 3.1032382006502083e-21,
            "t4cof": 1.108540972236622e-30,
            "t5cof": 4.8775303285166426e-40,
            "x1mth2": 0.9850107492817101,
            "x7thm1": -0.8950752449719702,
            "mdot": 0.060293389391664065,
            "nodedot": -0.000009049603139323024,
            "xlcof": 0.0018675706189039169,
            "xmcof": -0.000014761815700433102,
            "nodecf": -2.9712895811619177e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.739978362068015,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 514"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6153",
            "epochyr": 22,
            "epochdays": 53.74804444,
            "ndot": 4.302721419847132e-12,
            "nddot": 0,
            "bstar": 0.000034866,
            "inclo": 0.6109961378919149,
            "nodeo": 0.8997311920370928,
            "ecco": 0.0006897,
            "argpo": 5.970781843048113,
            "mo": 3.228489106388087,
            "no": 0.06357633872310683,
            "a": 1.1096752645799173,
            "alta": 0.11044060760989804,
            "altp": 0.1089099215499365,
            "jdsatepoch": 2459633.24804444,
            "isimp": 0,
            "method": "n",
            "aycof": 0.000670891645920893,
            "con41": 1.0126611809821888,
            "cc1": 5.1826493159567614e-11,
            "cc4": 1.333983815965779e-7,
            "cc5": 0.000045391048535413596,
            "d2": 1.2178453984607283e-19,
            "d3": 4.271594063883493e-28,
            "d4": 1.7460760936972076e-36,
            "delmo": 0.9768163710603682,
            "eta": 0.007817875456796748,
            "argpdot": 0.00009889314128299673,
            "omgcof": 1.7124631313553096e-9,
            "sinmao": -0.08678713498752294,
            "t": 242231.24195627868,
            "t2cof": 7.773973973935142e-11,
            "t3cof": 1.2715651063251025e-19,
            "t4cof": 3.396525646641036e-28,
            "t5cof": 1.1205593554441782e-36,
            "x1mth2": 0.3291129396726037,
            "x7thm1": 3.6962094222917745,
            "mdot": 0.06361880540208432,
            "nodedot": -0.00006883372887653147,
            "xlcof": 0.001308420283707643,
            "xmcof": -0.00008809286304838067,
            "nodecf": -1.24460942872326e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.0806558391861003,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OAO 3 (COPERNICUS)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06154",
            "epochyr": 22,
            "epochdays": 53.42256134,
            "ndot": -2.242263275131604e-12,
            "nddot": 0,
            "bstar": 0.000014443,
            "inclo": 1.1311618508515409,
            "nodeo": 5.181023847179183,
            "ecco": 0.0076954,
            "argpo": 3.554342077735428,
            "mo": 2.7244991049359446,
            "no": 0.06012983261473224,
            "a": 1.1524102132306298,
            "alta": 0.16127847078552482,
            "altp": 0.1435419556757347,
            "jdsatepoch": 2459632.92256134,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010582395631158787,
            "con41": -0.4565716316423297,
            "cc1": 4.964952346586676e-12,
            "cc4": 8.359766636533576e-8,
            "cc5": 0.000011590736627652484,
            "d2": 8.116940779890401e-22,
            "d3": 1.9770608512543403e-31,
            "d4": 5.609669975053191e-41,
            "delmo": 0.8361171754578984,
            "eta": 0.06334807410188777,
            "argpdot": -0.0000035185878676357323,
            "omgcof": -1.5316774713385386e-11,
            "sinmao": 0.4051048859474924,
            "t": 242699.93762031198,
            "t2cof": 7.447428519880014e-12,
            "t3cof": 8.609955815967933e-22,
            "t4cof": 1.6067560561577657e-31,
            "t5cof": 3.692635587511389e-41,
            "x1mth2": 0.8188572105474432,
            "x7thm1": 0.26799952616789713,
            "mdot": 0.06011304600412481,
            "nodedot": -0.00003126755254527873,
            "xlcof": 0.0019032917499828947,
            "xmcof": -9.67669605746373e-8,
            "nodecf": -5.440366206417824e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.313171296544553,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 516"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06173",
            "epochyr": 22,
            "epochdays": 53.43844774,
            "ndot": 7.847921462960614e-12,
            "nddot": 0,
            "bstar": 0.000063497,
            "inclo": 1.569797998462756,
            "nodeo": 3.6994714410265126,
            "ecco": 0.005349,
            "argpo": 0.40239613102280464,
            "mo": 0.681118231249291,
            "no": 0.06327449519404424,
            "a": 1.114182942327935,
            "alta": 0.12014270688644713,
            "altp": 0.10822317776942292,
            "jdsatepoch": 2459632.93844774,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001169444696601699,
            "con41": -0.9999970100226171,
            "cc1": 7.851022535667244e-11,
            "cc4": 2.3083142946495844e-7,
            "cc5": 0.00004040248880520186,
            "d2": 2.7061423252433047e-19,
            "d3": 1.3920745325004373e-27,
            "d4": 8.34514263498809e-36,
            "delmo": 1.1431652036167013,
            "eta": 0.05870982590218013,
            "argpdot": -0.000041315600141469526,
            "omgcof": 5.651620220635055e-10,
            "sinmao": 0.6296621368156732,
            "t": 242677.06120446324,
            "t2cof": 1.1776533803500864e-10,
            "t3cof": 2.829419434954415e-19,
            "t4cof": 1.1090036667240447e-27,
            "t5cof": 5.367387202503307e-36,
            "x1mth2": 0.9999990033408723,
            "x7thm1": -0.9999930233861065,
            "mdot": 0.0632331004758342,
            "nodedot": -8.245285262030967e-8,
            "xlcof": 0.0017553333701068037,
            "xmcof": -0.000002391027375313012,
            "nodecf": -2.2727189448584722e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.413261781377898,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "TRIAD 1"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06206",
            "epochyr": 22,
            "epochdays": 53.62719428,
            "ndot": -2.060458144715528e-12,
            "nddot": 0,
            "bstar": 0.000012782,
            "inclo": 1.1488996320395592,
            "nodeo": 3.4828586275614963,
            "ecco": 0.0005271,
            "argpo": 3.0991113395962513,
            "mo": 4.542118149218626,
            "no": 0.05990267852596786,
            "a": 1.1553395170936636,
            "alta": 0.1559484965531237,
            "altp": 0.1547305376342034,
            "jdsatepoch": 2459633.12719428,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010669011851417013,
            "con41": -0.49694996333722874,
            "cc1": 3.951930606987281e-12,
            "cc4": -6.206390501183002e-10,
            "cc5": 0.000010424881461348882,
            "d2": 5.050531279801786e-22,
            "d3": 9.615268219178369e-32,
            "d4": 2.1323713217717565e-41,
            "delmo": 0.9978352946558172,
            "eta": 0.004261391839816562,
            "argpdot": -0.00000593435057806929,
            "omgcof": -1.9559049548390312e-10,
            "sinmao": -0.9855389109111609,
            "t": 242405.266187042,
            "t2cof": 5.927895910480921e-12,
            "t3cof": 5.3628863902506425e-22,
            "t4cof": 7.825661710285033e-32,
            "t5cof": 1.4060353792138442e-41,
            "x1mth2": 0.8323166544457429,
            "x7thm1": 0.17378341887979976,
            "mdot": 0.05988456975623165,
            "nodedot": -0.00002981216805597953,
            "xlcof": 0.0019103125112967913,
            "xmcof": -0.000017117101932080756,
            "nodecf": -4.129483903710174e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.3192529277668186,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 521"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6217",
            "epochyr": 22,
            "epochdays": 53.65154245,
            "ndot": 6.484382984840044e-12,
            "nddot": 0,
            "bstar": 0.000047973,
            "inclo": 1.7208073760038092,
            "nodeo": 5.2212903383519444,
            "ecco": 0.0008786,
            "argpo": 4.836429530323927,
            "mo": 1.4471100786938145,
            "no": 0.06404380906572109,
            "a": 1.1052173970080366,
            "alta": 0.10618844101304781,
            "altp": 0.10424635300302532,
            "jdsatepoch": 2459633.15154245,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011563117384436555,
            "con41": -0.9329949375450092,
            "cc1": 8.452645610002134e-11,
            "cc4": -2.987940314249554e-8,
            "cc5": 0.000056711962270538947,
            "d2": 3.412124166886462e-19,
            "d3": 2.056471492817983e-27,
            "d4": 1.4445099349693905e-35,
            "delmo": 1.003887473229314,
            "eta": 0.010489884648379796,
            "argpdot": -0.00003776594540594585,
            "omgcof": 5.546840914996855e-10,
            "sinmao": 0.9923606026112373,
            "t": 242370.20482219756,
            "t2cof": 1.26789684150032e-10,
            "t3cof": 3.5550186025030385e-19,
            "t4cof": 1.6303878437234174e-27,
            "t5cof": 9.238734047300455e-36,
            "x1mth2": 0.9776649791816697,
            "x7thm1": -0.8436548542716881,
            "mdot": 0.06400408355055517,
            "nodedot": 0.000012697512501309758,
            "xlcof": 0.0015312937694021884,
            "xmcof": -0.00008900427791252474,
            "nodecf": 3.767613576831494e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.4726558484554957,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 8180 (STP RADSAT)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06235",
            "epochyr": 22,
            "epochdays": 53.59360817,
            "ndot": -5.75716246317574e-13,
            "nddot": 0,
            "bstar": 0.00016845,
            "inclo": 1.7792095834340433,
            "nodeo": 0.6137397954760501,
            "ecco": 0.000387,
            "argpo": 5.182215907058295,
            "mo": 3.0170843554110216,
            "no": 0.05470437632705553,
            "a": 1.2275546954911303,
            "alta": 0.22802975915828516,
            "altp": 0.22707963182397517,
            "jdsatepoch": 2459633.09360817,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001144139016472997,
            "con41": -0.8715675439900075,
            "cc1": 9.855242942023576e-12,
            "cc4": -7.238078220574522e-10,
            "cc5": 0.0000021621828313847714,
            "d2": 2.2180939293633135e-21,
            "d3": 7.415443403894851e-31,
            "d4": 2.8858559436668406e-40,
            "delmo": 0.9934371878209939,
            "eta": 0.002209511354924602,
            "argpdot": -0.000023149782575694234,
            "omgcof": 2.0220215510152794e-10,
            "sinmao": 0.1241868529335438,
            "t": 242453.63018542528,
            "t2cof": 1.4782864413035364e-11,
            "t3cof": 2.4123455562559245e-21,
            "t4cof": 6.241308151370607e-31,
            "t5cof": 1.9791562987380607e-40,
            "x1mth2": 0.9571891813300024,
            "x7thm1": -0.7003242693100172,
            "mdot": 0.05467868226411231,
            "nodedot": 0.000012178293694517483,
            "xlcof": 0.0014177171003229205,
            "xmcof": -0.00011569534243786192,
            "nodecf": 4.2101329976221495e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.10764740010304052,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "NOAA 2 (ITOS-D)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06236",
            "epochyr": 22,
            "epochdays": 53.56279654,
            "ndot": -8.484239419416881e-13,
            "nddot": 0,
            "bstar": 0.00011286,
            "inclo": 1.779607518503498,
            "nodeo": 0.685439666477229,
            "ecco": 0.000399,
            "argpo": 4.778228035757671,
            "mo": 3.4498125635042354,
            "no": 0.05470533222561422,
            "a": 1.2275401913844173,
            "alta": 0.22802997992077967,
            "altp": 0.2270504028480549,
            "jdsatepoch": 2459633.06279654,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011440426386141892,
            "con41": -0.871083784812289,
            "cc1": 6.604766106781718e-12,
            "cc4": -7.064482144789848e-10,
            "cc5": 0.0000021627374110525897,
            "d2": 9.962858804783644e-22,
            "d3": 2.2323142683842535e-31,
            "d4": 5.822467638757176e-41,
            "delmo": 0.9935017544103866,
            "eta": 0.0022781483143363055,
            "argpdot": -0.000023127054616662752,
            "omgcof": 1.9100156630339257e-11,
            "sinmao": -0.3033629144701537,
            "t": 242497.9989322275,
            "t2cof": 9.907149160172577e-12,
            "t3cof": 1.0835317511289495e-21,
            "t4cof": 1.8788457398875211e-31,
            "t5cof": 3.9930922136630845e-41,
            "x1mth2": 0.957027928270763,
            "x7thm1": -0.699195497895341,
            "mdot": 0.05467965137006733,
            "nodedot": 0.000012201720107226817,
            "xlcof": 0.0014168892409166802,
            "xmcof": -0.00007293781685770632,
            "nodecf": 2.8269622826251086e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.19670748206083,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OSCAR 6"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06256",
            "epochyr": 22,
            "epochdays": 53.59025463,
            "ndot": -3.0300855069346e-13,
            "nddot": 0,
            "bstar": -0.00001262,
            "inclo": 1.4184116298032718,
            "nodeo": 4.181238165113011,
            "ecco": 0.0023786,
            "argpo": 5.346591016011121,
            "mo": 0.9348035833559188,
            "no": 0.061513631863624595,
            "a": 1.1352943169397913,
            "alta": 0.13799472800206414,
            "altp": 0.1325939058775183,
            "jdsatepoch": 2459633.09025463,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011558936330417027,
            "con41": -0.9308742649265919,
            "cc1": -7.186562200364658e-12,
            "cc4": 2.7305369892615493e-8,
            "cc5": 0.00001893658672559149,
            "d2": 1.9119435745220263e-21,
            "d3": -7.584123005318841e-31,
            "d4": 3.5051032735654736e-40,
            "delmo": 1.0397421087498335,
            "eta": 0.022013754396746233,
            "argpdot": -0.00003424387936931519,
            "omgcof": -6.064471510023189e-11,
            "sinmao": 0.8044824267697028,
            "t": 242458.45928281546,
            "t2cof": -1.0779843300546987e-11,
            "t3cof": 2.0152369270414468e-21,
            "t4cof": -6.109580347930396e-31,
            "t5cof": 2.2837421082604847e-40,
            "x1mth2": 0.9769580883088639,
            "x7thm1": -0.8387066181620475,
            "mdot": 0.061477552942613874,
            "nodedot": -0.000011741196703854751,
            "xlcof": 0.0018861761525248153,
            "xmcof": 0.00000133631978951918,
            "nodecf": 2.9615307393080246e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.08651879752246572,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "METEOR 1-13"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06262",
            "epochyr": 22,
            "epochdays": 53.55704994,
            "ndot": -5.15114536178882e-13,
            "nddot": 0,
            "bstar": -0.0000063839,
            "inclo": 1.292142294409238,
            "nodeo": 2.091412334701537,
            "ecco": 0.0064775,
            "argpo": 2.6256104948471974,
            "mo": 5.503522295704191,
            "no": 0.05506970405249059,
            "a": 1.2220794925652896,
            "alta": 0.22999551247838124,
            "altp": 0.21416347265219793,
            "jdsatepoch": 2459633.05704994,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243357209627177,
            "con41": -0.7730229374558555,
            "cc1": -4.1843497121135973e-13,
            "cc4": 9.10469875916733e-9,
            "cc5": 0.000002407533197483641,
            "d2": 4.084072048686203e-24,
            "d3": -5.922332346884382e-35,
            "d4": 9.997559596608988e-46,
            "delmo": 1.0827716587346876,
            "eta": 0.03777329559511369,
            "argpdot": -0.000018614726962220515,
            "omgcof": 9.889885487738469e-13,
            "sinmao": -0.7030398095679982,
            "t": 242506.27403654158,
            "t2cof": -6.276524568170396e-13,
            "t3cof": 4.434247698951506e-24,
            "t4cof": -4.972740548465637e-35,
            "t5cof": 6.837262073525814e-46,
            "x1mth2": 0.9243409791519518,
            "x7thm1": -0.47038685406366276,
            "mdot": 0.05504655584321366,
            "nodedot": -0.000016448416388134793,
            "xlcof": 0.0019290501392160851,
            "xmcof": 1.6975517722890744e-8,
            "nodecf": 2.413643388284002e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.160501670438336,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 528"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06264",
            "epochyr": 22,
            "epochdays": 53.48575257,
            "ndot": -3.93911115901498e-13,
            "nddot": 0,
            "bstar": 0.00002108,
            "inclo": 1.29219639961605,
            "nodeo": 5.5640084262613065,
            "ecco": 0.0041741,
            "argpo": 0.3075881007252207,
            "mo": 2.7218898377042127,
            "no": 0.05487757698860059,
            "a": 1.2249286050211623,
            "alta": 0.23004157951138104,
            "altp": 0.21981563053094355,
            "jdsatepoch": 2459632.98575257,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243531233270602,
            "con41": -0.7731087793054883,
            "cc1": 1.301424378335627e-12,
            "cc4": 5.051696513537625e-9,
            "cc5": 0.0000022732837189734026,
            "d2": 3.906784163790823e-23,
            "d3": 1.7422356162208432e-33,
            "d4": 9.044507047490268e-44,
            "delmo": 0.9354947613447381,
            "eta": 0.024070460626555844,
            "argpdot": -0.000018466926135988906,
            "omgcof": 5.172135972096036e-12,
            "sinmao": 0.40748907952907676,
            "t": 242608.9422491938,
            "t2cof": 1.9521365675034405e-12,
            "t3cof": 4.245525246296078e-23,
            "t4cof": 1.4647188104991724e-33,
            "t5cof": 6.194595115734611e-44,
            "x1mth2": 0.9243695931018294,
            "x7thm1": -0.47058715171280585,
            "mdot": 0.05485461502642467,
            "nodedot": -0.000016311093324113052,
            "xlcof": 0.0019290440205777923,
            "xmcof": -1.2932470212183344e-7,
            "nodecf": -7.444400067337396e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.711300569641409,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 529"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06265",
            "epochyr": 22,
            "epochdays": 53.61525414,
            "ndot": -6.0601710138692e-13,
            "nddot": 0,
            "bstar": -0.000016614,
            "inclo": 1.2921545117140019,
            "nodeo": 5.142485231965896,
            "ecco": 0.0087416,
            "argpo": 5.2346141818616685,
            "mo": 1.291829880473131,
            "no": 0.0552469794117325,
            "a": 1.219465329647767,
            "alta": 0.23012540777341606,
            "altp": 0.20880525152211815,
            "jdsatepoch": 2459633.11525414,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243396508165548,
            "con41": -0.7730423224023141,
            "cc1": -1.1541059005668603e-12,
            "cc4": 1.3603211508426374e-8,
            "cc5": 0.0000025469067484052223,
            "d2": 3.139445115670095e-23,
            "d3": -1.26892915304267e-33,
            "d4": 5.970821721616637e-44,
            "delmo": 1.0431582206294268,
            "eta": 0.05151011398447475,
            "argpdot": -0.00001875706150269917,
            "omgcof": -1.1683633778311161e-12,
            "sinmao": 0.961340553341372,
            "t": 242422.45998837054,
            "t2cof": -1.7311588508502906e-12,
            "t3cof": 3.405837201614744e-23,
            "t4cof": -1.0642374872351853e-33,
            "t5cof": 4.077863225652393e-44,
            "x1mth2": 0.9243474408007714,
            "x7thm1": -0.4704320856053995,
            "mdot": 0.05522365521398721,
            "nodedot": -0.0000165725182370087,
            "xlcof": 0.0019290487584842854,
            "xmcof": 2.5242864723357888e-8,
            "nodecf": 6.707243413092309e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.24402541299891567,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 530"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06266",
            "epochyr": 22,
            "epochdays": 53.51969642,
            "ndot": -7.272205216643039e-13,
            "nddot": 0,
            "bstar": -0.000051455,
            "inclo": 1.2921230957874659,
            "nodeo": 1.174528046775844,
            "ecco": 0.0030717,
            "argpo": 2.7149347006350157,
            "mo": 5.5978206898601925,
            "no": 0.05477239675259601,
            "a": 1.2264953403953018,
            "alta": 0.23026276613239416,
            "altp": 0.2227279146582095,
            "jdsatepoch": 2459633.01969642,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243295451390492,
            "con41": -0.7729924738615102,
            "cc1": -3.078209800800942e-12,
            "cc4": 3.2804374680468214e-9,
            "cc5": 0.000002206239749743357,
            "d2": 2.17240129288521e-22,
            "d3": -2.2774200349559287e-32,
            "d4": 2.7792688948478606e-42,
            "delmo": 1.0414511378902798,
            "eta": 0.017606070061821702,
            "argpdot": -0.00001837846854468281,
            "omgcof": 1.5764811617695304e-11,
            "sinmao": -0.632955336051562,
            "t": 242560.06310507655,
            "t2cof": -4.617314701201413e-12,
            "t3cof": 2.361908804440149e-22,
            "t4cof": -1.915970033240326e-32,
            "t5cof": 1.9050622446884913e-42,
            "x1mth2": 0.9243308246205034,
            "x7thm1": -0.47031577234352373,
            "mdot": 0.054749541032855245,
            "nodedot": -0.00001624223114394425,
            "xlcof": 0.0019290523078812607,
            "xmcof": 5.694701635874772e-7,
            "nodecf": 1.7533664983834417e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.925159998722322,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 531"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06267",
            "epochyr": 22,
            "epochdays": 53.62614744,
            "ndot": -5.45415391248228e-13,
            "nddot": 0,
            "bstar": -0.000009839,
            "inclo": 1.2921300771044741,
            "nodeo": 1.8888494217150753,
            "ecco": 0.0107122,
            "argpo": 1.5052574680532576,
            "mo": 0.48106161106869305,
            "no": 0.0554243796140357,
            "a": 1.2168632631431455,
            "alta": 0.22989854579058755,
            "altp": 0.2038279804957035,
            "jdsatepoch": 2459633.12614744,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243317909410593,
            "con41": -0.7730035517493382,
            "cc1": -7.254048002374826e-13,
            "cc4": 1.815833900679432e-8,
            "cc5": 0.000002698792789712722,
            "d2": 1.2534080832655698e-23,
            "d3": -3.2182892223704322e-34,
            "d4": 9.620115473033179e-45,
            "delmo": 1.179423897827449,
            "eta": 0.0637896650983511,
            "argpdot": -0.000018897339978499308,
            "omgcof": -7.923195194679779e-14,
            "sinmao": 0.46272055877579393,
            "t": 242406.77363611758,
            "t2cof": -1.088107200356224e-12,
            "t3cof": 1.3586505081070862e-23,
            "t4cof": -2.6960283088760997e-34,
            "t5cof": 6.561292300112417e-45,
            "x1mth2": 0.9243345172497794,
            "x7thm1": -0.47034162074845587,
            "mdot": 0.055400880161578105,
            "nodedot": -0.000016699513851620333,
            "xlcof": 0.0019290515194251066,
            "xmcof": 1.0362461306714035e-8,
            "nodecf": 4.247968414176085e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.31265743178769156,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 532"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06268",
            "epochyr": 22,
            "epochdays": 53.56649169,
            "ndot": -3.0300855069346e-14,
            "nddot": 0,
            "bstar": 0.000080447,
            "inclo": 1.292133567762978,
            "nodeo": 3.592231430466973,
            "ecco": 0.0097794,
            "argpo": 3.5154020367941827,
            "mo": 3.962869550420489,
            "no": 0.05533148928631969,
            "a": 1.2182240171026715,
            "alta": 0.23013751705552532,
            "altp": 0.20631051714981763,
            "jdsatepoch": 2459633.06649169,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243329138215148,
            "con41": -0.773009090600185,
            "cc1": 5.749706858333487e-12,
            "cc4": 1.587784966732339e-8,
            "cc5": 0.000002618509110738385,
            "d2": 7.83113443212387e-22,
            "d3": 1.58489873848123e-31,
            "d4": 3.7341826731412994e-41,
            "delmo": 0.8862402566818449,
            "eta": 0.05791425733393048,
            "argpdot": -0.00001882310702842157,
            "omgcof": -9.741206388985178e-12,
            "sinmao": -0.7320163595336411,
            "t": 242492.67791636288,
            "t2cof": 8.62456028750023e-12,
            "t3cof": 8.492317011259213e-22,
            "t4cof": 1.3285062434319961e-31,
            "t5cof": 2.5486677799777817e-41,
            "x1mth2": 0.924336363533395,
            "x7thm1": -0.47035454473376503,
            "mdot": 0.05530808210754135,
            "nodedot": -0.000016633518637109684,
            "xlcof": 0.0019290511251330161,
            "xmcof": -9.954444256841182e-8,
            "nodecf": -3.353769165620742e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.219988360553927,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 533"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06269",
            "epochyr": 22,
            "epochdays": 53.3787406,
            "ndot": -3.0300855069346e-13,
            "nddot": 0,
            "bstar": 0.000033986,
            "inclo": 1.2921806916527818,
            "nodeo": 0.45679804380746786,
            "ecco": 0.0075704,
            "argpo": 0.7730970828293923,
            "mo": 1.179128734684101,
            "no": 0.0551596758212116,
            "a": 1.2207510093588356,
            "alta": 0.22999258280008594,
            "altp": 0.21150943591758553,
            "jdsatepoch": 2459632.8787406,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243480713668053,
            "con41": -0.7730838590138627,
            "cc1": 2.293147917469613e-12,
            "cc4": 1.12220935404478e-8,
            "cc5": 0.0000024758625771846193,
            "d2": 1.233083284255314e-22,
            "d3": 9.851643473655343e-33,
            "d4": 9.162881949695407e-43,
            "delmo": 1.0516894171610163,
            "eta": 0.04437998053364525,
            "argpdot": -0.000018689356542487405,
            "omgcof": 3.833216382700607e-12,
            "sinmao": 0.9242737749268813,
            "t": 242763.03948618472,
            "t2cof": 3.4397218762044195e-12,
            "t3cof": 1.3382538316832186e-22,
            "t4cof": 8.267171767575187e-33,
            "t5cof": 6.26211388980508e-43,
            "x1mth2": 0.9243612863379542,
            "x7thm1": -0.4705290043656797,
            "mdot": 0.05513643692932278,
            "nodedot": -0.000016509403659725248,
            "xlcof": 0.0019290457980128955,
            "xmcof": -6.751141896965191e-8,
            "nodecf": -1.3276384528860546e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.037083626561454,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 534"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06270",
            "epochyr": 22,
            "epochdays": 53.62403659,
            "ndot": -5.75716246317574e-13,
            "nddot": 0,
            "bstar": -0.000010924,
            "inclo": 1.2921161144704578,
            "nodeo": 3.87631867281409,
            "ecco": 0.0054889,
            "argpo": 4.753461813671872,
            "mo": 2.7488080507577215,
            "no": 0.0549709545497979,
            "a": 1.223541769076479,
            "alta": 0.23025766749276277,
            "altp": 0.2168258706601951,
            "jdsatepoch": 2459633.12403659,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243272992822408,
            "con41": -0.7729813957255061,
            "cc1": -6.94377409497412e-13,
            "cc4": 7.259754547239967e-9,
            "cc5": 0.000002337786569840956,
            "d2": 1.1182185719267588e-23,
            "d3": -2.675270145742053e-34,
            "d4": 7.450829515858407e-45,
            "delmo": 0.9143650866803934,
            "eta": 0.03182444669416264,
            "argpdot": -0.000018534465980100137,
            "omgcof": -9.089235611635438e-14,
            "sinmao": 0.38276244219024314,
            "t": 242409.81326021254,
            "t2cof": -1.0415661142461178e-12,
            "t3cof": 1.2146505692908262e-23,
            "t4cof": -2.2477623489397493e-34,
            "t5cof": 5.099429609181566e-45,
            "x1mth2": 0.924327131908502,
            "x7thm1": -0.47028992335951403,
            "mdot": 0.05494790470006801,
            "nodedot": -0.000016380869746429085,
            "xlcof": 0.0019290530961667144,
            "xmcof": 3.957113815408065e-8,
            "nodecf": 3.9889313751934915e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.2993582571445117,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 535"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06275",
            "epochyr": 22,
            "epochdays": 53.50032599,
            "ndot": 3.817907738737596e-12,
            "nddot": 0,
            "bstar": 0.000067407,
            "inclo": 1.718128295601998,
            "nodeo": 4.252170091243313,
            "ecco": 0.003458,
            "argpo": 4.864483952720484,
            "mo": 1.4139278789548984,
            "no": 0.06234652473258692,
            "a": 1.125170776900433,
            "alta": 0.12906161744695477,
            "altp": 0.12127993635391143,
            "jdsatepoch": 2459633.00032599,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001156775817754489,
            "con41": -0.9353496925258431,
            "cc1": 5.4516054049676835e-11,
            "cc4": 7.746050469655145e-8,
            "cc5": 0.000026619272120193746,
            "d2": 1.1885935293015311e-19,
            "d3": 3.865571166317441e-28,
            "d4": 1.4648865169288718e-36,
            "delmo": 1.0162917382339867,
            "eta": 0.034573992413021615,
            "argpdot": -0.00003563137430420366,
            "omgcof": 8.89326557119266e-11,
            "sinmao": 0.9877213551573085,
            "t": 242587.9565244913,
            "t2cof": 8.177408107451525e-11,
            "t3cof": 1.248033532284477e-19,
            "t4cof": 3.09762120501674e-28,
            "t5cof": 9.486075283271682e-37,
            "x1mth2": 0.9784498975086144,
            "x7thm1": -0.8491492825603008,
            "mdot": 0.06230911685865037,
            "nodedot": 0.000011716122947136502,
            "xlcof": 0.0015361317821311342,
            "xmcof": -0.000004413469216489177,
            "nodecf": 2.2419005543408936e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.8031187711425645,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 7323 (DMSP 5B F3)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06305",
            "epochyr": 22,
            "epochdays": 53.59114778,
            "ndot": -1.06052992742711e-12,
            "nddot": 0,
            "bstar": 0.000016379,
            "inclo": 1.7437741636308026,
            "nodeo": 5.641705248572339,
            "ecco": 0.0008945,
            "argpo": 0.7306210048236063,
            "mo": 0.386894116606591,
            "no": 0.05868101627776142,
            "a": 1.1715043636242872,
            "alta": 0.17255227427754916,
            "altp": 0.1704564529710253,
            "jdsatepoch": 2459633.09114778,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011519931801377166,
            "con41": -0.9111277258713598,
            "cc1": 3.2714478601925003e-12,
            "cc4": -9.224635749949723e-10,
            "cc5": 0.00000691782531881565,
            "d2": 3.155943041212887e-22,
            "d3": 4.532359505856604e-32,
            "d4": 7.581037734134113e-42,
            "delmo": 1.018432799389776,
            "eta": 0.006594312193697987,
            "argpdot": -0.000029543248359822872,
            "omgcof": 6.854239980075599e-11,
            "sinmao": 0.37731392630774463,
            "t": 242457.173146829,
            "t2cof": 4.907171790288751e-12,
            "t3cof": 3.369990463252049e-22,
            "t4cof": 3.717757784924534e-32,
            "t5cof": 5.044608692006248e-42,
            "x1mth2": 0.9703759086237865,
            "x7thm1": -0.792631360366506,
            "mdot": 0.05864937975557888,
            "nodedot": 0.000011928832851271245,
            "xlcof": 0.001488491046676841,
            "xmcof": -0.000005466046109301837,
            "nodecf": 1.3693805298880353e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.09214598908979355,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "NIMBUS 5"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06319",
            "epochyr": 22,
            "epochdays": 53.48915546,
            "ndot": -4.84813681109536e-13,
            "nddot": 0,
            "bstar": 0.0000067957,
            "inclo": 1.291859551070415,
            "nodeo": 5.328689173873415,
            "ecco": 0.0023251,
            "argpo": 1.0173611476337547,
            "mo": 2.003720011764334,
            "no": 0.05567331392229309,
            "a": 1.2132350206401288,
            "alta": 0.21605591338661911,
            "altp": 0.21041412789363845,
            "jdsatepoch": 2459632.98915546,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124244726034218,
            "con41": -0.7725741020975746,
            "cc1": 5.272966048044734e-13,
            "cc4": 2.9715332928881854e-9,
            "cc5": 0.0000028170413963945006,
            "d2": 6.722460850998074e-24,
            "d3": 1.2737457007236597e-34,
            "d4": 2.8097931418715157e-45,
            "delmo": 0.9824160050512735,
            "eta": 0.014054000887340561,
            "argpdot": -0.00001906983010259393,
            "omgcof": 2.2229621367660077e-12,
            "sinmao": 0.9077430676252333,
            "t": 242604.04208734632,
            "t2cof": 7.909449072067102e-13,
            "t3cof": 7.278544269874724e-24,
            "t4cof": 1.0653164602571347e-34,
            "t5cof": 1.9127463576213877e-45,
            "x1mth2": 0.9241913673658582,
            "x7thm1": -0.46933957156100736,
            "mdot": 0.05564958460181427,
            "nodedot": -0.00001688713203308331,
            "xlcof": 0.0019290819472554946,
            "xmcof": -1.6079415537212747e-7,
            "nodecf": -3.122913645749477e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.732740098381711,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 539"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06323",
            "epochyr": 22,
            "epochdays": 53.56696894,
            "ndot": 1.878653014299452e-12,
            "nddot": 0,
            "bstar": 0.000029805,
            "inclo": 1.2929346738896434,
            "nodeo": 1.9001417019754785,
            "ecco": 0.001694,
            "argpo": 2.101320568865109,
            "mo": 4.1868057654268735,
            "no": 0.06271164189631717,
            "a": 1.1207250154280897,
            "alta": 0.12262352360422502,
            "altp": 0.11882650725195454,
            "jdsatepoch": 2459633.06696894,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124590252504338,
            "con41": -0.77427861524571,
            "cc1": 2.825941314978322e-11,
            "cc4": 2.9386520988667755e-8,
            "cc5": 0.00003089032849185695,
            "d2": 3.3099920644262304e-20,
            "d3": 5.784253104916033e-29,
            "d4": 1.1778693874680733e-37,
            "delmo": 0.9738118780694177,
            "eta": 0.017553110613711932,
            "argpdot": -0.00002528769281085728,
            "omgcof": -3.1957351253030634e-10,
            "sinmao": -0.8650314795526316,
            "t": 242491.99067607522,
            "t2cof": 4.238911972467483e-11,
            "t3cof": 3.4697109507402585e-20,
            "t4cof": 4.624447080995613e-29,
            "t5cof": 7.607043303525581e-38,
            "x1mth2": 0.9247595384152366,
            "x7thm1": -0.4733167689066564,
            "mdot": 0.0626802482930804,
            "nodedot": -0.00002220248322766416,
            "xlcof": 0.001928959506160736,
            "xmcof": -0.000009193868159498677,
            "nodecf": -2.2012497900353927e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.222995222040865,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 540"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6350",
            "epochyr": 22,
            "epochdays": 53.84934175,
            "ndot": 1.4302003592731312e-11,
            "nddot": 0,
            "bstar": 0.000035797,
            "inclo": 0.883953415599064,
            "nodeo": 4.905207720157268,
            "ecco": 0.0014086,
            "argpo": 5.545745300968438,
            "mo": 0.7372235853839009,
            "no": 0.06634967311120073,
            "a": 1.0789105104886874,
            "alta": 0.08043026383376173,
            "altp": 0.07739075714361299,
            "jdsatepoch": 2459633.34934175,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0009042756351013319,
            "con41": 0.2062450890325716,
            "cc1": 2.4514855047229845e-10,
            "cc4": 7.529370330788059e-7,
            "cc5": 0.00020465078572353042,
            "d2": 3.883905188641424e-18,
            "d3": 9.19820838986554e-26,
            "d4": 2.539552229759016e-33,
            "delmo": 1.0514026619262042,
            "eta": 0.022758186550319085,
            "argpdot": 0.000046690590572074264,
            "omgcof": 6.389095306698573e-9,
            "sinmao": 0.672235020497129,
            "t": 242085.3738297522,
            "t2cof": 3.6772282570844764e-10,
            "t3cof": 4.004100812238762e-18,
            "t4cof": 7.18797963341159e-26,
            "t5cof": 1.5973625806212344e-33,
            "x1mth2": 0.5979183036558093,
            "x7thm1": 1.8145718744093342,
            "mdot": 0.06635922686364634,
            "nodedot": -0.00005872429831769097,
            "xlcof": 0.0017073103954792653,
            "xmcof": -0.00007036284428489745,
            "nodecf": -5.035137453555644e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.718868206139767,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 546"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06392",
            "epochyr": 22,
            "epochdays": 53.404635,
            "ndot": -3.33309405762806e-13,
            "nddot": 0,
            "bstar": -0.000013569,
            "inclo": 1.4179037389909415,
            "nodeo": 0.3131504650513266,
            "ecco": 0.0042741,
            "argpo": 5.4899000008923755,
            "mo": 0.7892396330810878,
            "no": 0.06145503980943104,
            "a": 1.1360150324422906,
            "alta": 0.14087047429245225,
            "altp": 0.131159590592129,
            "jdsatepoch": 2459632.904635,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011558033248732476,
            "con41": -0.9304163135378483,
            "cc1": -7.590000607590788e-12,
            "cc4": 6.752448394756428e-8,
            "cc5": 0.000018638374878907434,
            "d2": 2.1215114083084035e-21,
            "d3": -8.841207763567459e-31,
            "d4": 4.292791570929679e-40,
            "delmo": 1.085479105405259,
            "eta": 0.039350154138519985,
            "argpdot": -0.00003413940726622211,
            "omgcof": -4.167683008552401e-11,
            "sinmao": 0.7098178864269734,
            "t": 242725.75154989958,
            "t2cof": -1.1385000911386182e-11,
            "t3cof": 2.2367276267548604e-21,
            "t4cof": -7.124905148617902e-31,
            "t5cof": 2.7981686604214897e-40,
            "x1mth2": 0.9768054378459494,
            "x7thm1": -0.8376380649216459,
            "mdot": 0.061419058013175286,
            "nodedot": -0.000011754213791201879,
            "xlcof": 0.001886465943289789,
            "xmcof": 4.369541702194694e-7,
            "nodecf": 3.1311977334555e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.200228397396515,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "METEOR 1-14"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06659",
            "epochyr": 22,
            "epochdays": 53.54944511,
            "ndot": 7.5752137673365e-13,
            "nddot": 0,
            "bstar": 0.0000069994,
            "inclo": 1.417081688913252,
            "nodeo": 6.1063939259280735,
            "ecco": 0.0026896,
            "argpo": 3.0516715451977934,
            "mo": 3.234049725384941,
            "no": 0.061558181579776626,
            "a": 1.1347463645327112,
            "alta": 0.1377983783547585,
            "altp": 0.13169435071066404,
            "jdsatepoch": 2459633.04944511,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001155656524185079,
            "con41": -0.9296719657707758,
            "cc1": 4.061571369265574e-12,
            "cc4": 3.495233952577636e-8,
            "cc5": 0.00001928697232975265,
            "d2": 6.131335072084882e-22,
            "d3": 1.380075603185755e-31,
            "d4": 3.6192473924058683e-41,
            "delmo": 0.9271876997253059,
            "eta": 0.024991629703321146,
            "argpdot": -0.0000342244257711647,
            "omgcof": -5.115643487752754e-11,
            "sinmao": -0.09232540279796247,
            "t": 242517.2249916941,
            "t2cof": 6.0923570538983605e-12,
            "t3cof": 6.461262311837638e-22,
            "t4cof": 1.1114402961304285e-31,
            "t5cof": 2.3573372948952886e-41,
            "x1mth2": 0.976557321923592,
            "x7thm1": -0.8359012534651438,
            "mdot": 0.06152208824670729,
            "nodedot": -0.000011862934198693314,
            "xlcof": 0.001886932930841268,
            "xmcof": -5.877873931450707e-7,
            "nodecf": -1.6910942702572472e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.112588290216465,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "METEOR 1-15"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06675",
            "epochyr": 22,
            "epochdays": 53.51637413,
            "ndot": -1.8180513041607598e-13,
            "nddot": 0,
            "bstar": 0.000062002,
            "inclo": 1.2919101656187226,
            "nodeo": 5.558110958718818,
            "ecco": 0.0054356,
            "argpo": 1.1490706743062546,
            "mo": 1.8746162616650615,
            "no": 0.054851213171108554,
            "a": 1.2253206622072086,
            "alta": 0.23198101519870207,
            "altp": 0.2186603092157151,
            "jdsatepoch": 2459633.01637413,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242610218544522,
            "con41": -0.772654479075215,
            "cc1": 3.807817201818575e-12,
            "cc4": 6.892224717091324e-9,
            "cc5": 0.0000022633367365696507,
            "d2": 3.339420993634052e-22,
            "d3": 4.350576330786781e-32,
            "d4": 6.59798621926456e-42,
            "delmo": 0.9721728158753448,
            "eta": 0.03129727232518075,
            "argpdot": -0.000018424302428079065,
            "omgcof": 4.968484211752275e-12,
            "sinmao": 0.9542006538487939,
            "t": 242564.84720304608,
            "t2cof": 5.711725802727863e-12,
            "t3cof": 3.6294104304833607e-22,
            "t4cof": 3.658212223775056e-32,
            "t5cof": 4.519883916247626e-42,
            "x1mth2": 0.9242181596917383,
            "x7thm1": -0.46952711784216816,
            "mdot": 0.0548282899893525,
            "nodedot": -0.000016309553086146576,
            "xlcof": 0.0019290762737967301,
            "xmcof": -2.2299911082928022e-7,
            "nodecf": -2.1779080223086988e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.904228280738991,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 564"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06676",
            "epochyr": 22,
            "epochdays": 53.46565733,
            "ndot": -4.5451282604019e-13,
            "nddot": 0,
            "bstar": 0.0000062949,
            "inclo": 1.2918717683751788,
            "nodeo": 5.184915931411131,
            "ecco": 0.0025605,
            "argpo": 2.350386034441708,
            "mo": 0.6897069964983552,
            "no": 0.05451769249436669,
            "a": 1.2303101644558172,
            "alta": 0.2334603736319063,
            "altp": 0.2271599552797281,
            "jdsatepoch": 2459632.96565733,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124248659771767,
            "con41": -0.7725935046309926,
            "cc1": 3.501953561100629e-13,
            "cc4": 2.3391750811532165e-9,
            "cc5": 0.0000020606037878365984,
            "d2": 2.7709909977269967e-24,
            "d3": 3.2565570389741877e-35,
            "d4": 4.455039531772649e-46,
            "delmo": 1.0338481597247167,
            "eta": 0.014463691111222018,
            "argpdot": -0.000018160253614735928,
            "omgcof": -1.6277662955378478e-12,
            "sinmao": 0.6363111771184844,
            "t": 242637.87939459085,
            "t2cof": 5.252930341650943e-13,
            "t3cof": 3.0162645726091043e-24,
            "t4cof": 2.7442709413612046e-35,
            "t5cof": 3.0597086083352848e-46,
            "x1mth2": 0.9241978348769976,
            "x7thm1": -0.46938484413898296,
            "mdot": 0.05449509570070365,
            "nodedot": -0.000016080775371008232,
            "xlcof": 0.0019290805786213135,
            "xmcof": -9.478822136281978e-8,
            "nodecf": -1.974884063412075e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.58469275958889,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 565"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06677",
            "epochyr": 22,
            "epochdays": 53.60884308,
            "ndot": 2.1210598548542201e-13,
            "nddot": 0,
            "bstar": 0.00015088,
            "inclo": 1.2918822403506909,
            "nodeo": 3.0756610957664554,
            "ecco": 0.0031909,
            "argpo": 5.714078816664788,
            "mo": 0.7615639471322138,
            "no": 0.054637039983950086,
            "a": 1.228518876420485,
            "alta": 0.23243895730325526,
            "altp": 0.2245987955377149,
            "jdsatepoch": 2459633.10884308,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242520314132473,
            "con41": -0.7726101347691827,
            "cc1": 8.68720729019005e-12,
            "cc4": 3.3023809399353488e-9,
            "cc5": 0.0000021284582007576337,
            "d2": 1.7168414316114358e-21,
            "d3": 5.03974175870035e-31,
            "d4": 1.7221173284027349e-40,
            "delmo": 1.0399235592671252,
            "eta": 0.018147759652375032,
            "argpdot": -0.000018254064585484854,
            "omgcof": 3.9183411910004274e-11,
            "sinmao": 0.6900542073218937,
            "t": 242431.69191509485,
            "t2cof": 1.3030810935285074e-11,
            "t3cof": 1.8677765726168982e-21,
            "t4cof": 4.2436331017652245e-31,
            "t5cof": 1.1816608180225252e-40,
            "x1mth2": 0.9242033782563943,
            "x7thm1": -0.46942364779475987,
            "mdot": 0.05461432701501878,
            "nodedot": -0.000016162468029517908,
            "xlcof": 0.0019290794050902784,
            "xmcof": -0.0000015018249415330223,
            "nodecf": -4.923943507742366e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.2036332454528278,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 566"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06678",
            "epochyr": 22,
            "epochdays": 53.54979015,
            "ndot": -7.5752137673365e-13,
            "nddot": 0,
            "bstar": -0.000054329,
            "inclo": 1.291835116460887,
            "nodeo": 1.216094808241341,
            "ecco": 0.0045783,
            "argpo": 3.579640625243086,
            "mo": 5.768557523936539,
            "no": 0.054741927925622415,
            "a": 1.2269499531912127,
            "alta": 0.23256729816190802,
            "altp": 0.22133260822051737,
            "jdsatepoch": 2459633.04979015,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124236858055698,
            "con41": -0.7725352947513779,
            "cc1": -3.229035440173064e-12,
            "cc4": 5.408925041650782e-9,
            "cc5": 0.0000021939046751378614,
            "d2": 2.3863149008216555e-22,
            "d3": -2.619609056614062e-32,
            "d4": 3.347555311871877e-42,
            "delmo": 1.0699793366974502,
            "eta": 0.026195481497372712,
            "argpdot": -0.000018332632482092795,
            "omgcof": 1.098485368061686e-11,
            "sinmao": -0.4922108773896982,
            "t": 242516.72813393176,
            "t2cof": -4.843553160259596e-12,
            "t3cof": 2.5948482982995286e-22,
            "t4cof": -2.2042886756819793e-32,
            "t5cof": 2.295133561336241e-42,
            "x1mth2": 0.9241784315837926,
            "x7thm1": -0.4692490210865484,
            "mdot": 0.05471911495427492,
            "nodedot": -0.000016237899486995277,
            "xlcof": 0.0019290846829557865,
            "xmcof": 2.688408860787531e-7,
            "nodecf": 1.8387611536215576e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.114762176836322,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 567"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06679",
            "epochyr": 22,
            "epochdays": 53.58158067,
            "ndot": 0,
            "nddot": 0,
            "bstar": 0.000097575,
            "inclo": 1.291835116460887,
            "nodeo": 3.7268888182460915,
            "ecco": 0.006792,
            "argpo": 5.349367834851044,
            "mo": 2.0818444397421043,
            "no": 0.05495347913265543,
            "a": 1.2238008154362334,
            "alta": 0.23211287057467622,
            "altp": 0.2154887602977904,
            "jdsatepoch": 2459633.08158067,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124236858055698,
            "con41": -0.7725352947513779,
            "cc1": 6.190116468192326e-12,
            "cc4": 9.243058790287979e-9,
            "cc5": 0.0000023351582874978767,
            "d2": 8.877522070741805e-22,
            "d3": 1.8914299113805776e-31,
            "d4": 4.691197937973544e-41,
            "delmo": 0.9433812317946598,
            "eta": 0.039339769026618635,
            "argpdot": -0.00001849924168692587,
            "omgcof": 9.441643830530599e-12,
            "sinmao": 0.8722323634737827,
            "t": 242470.94978503883,
            "t2cof": 9.285174702288488e-12,
            "t3cof": 9.643872908537522e-22,
            "t4cof": 1.5893608714127675e-31,
            "t5cof": 3.211137714787111e-41,
            "x1mth2": 0.9241784315837926,
            "x7thm1": -0.4692490210865484,
            "mdot": 0.0549304591075521,
            "nodedot": -0.000016385352465485143,
            "xlcof": 0.0019290846829557865,
            "xmcof": -2.2994195620492372e-7,
            "nodecf": -3.556893303861282e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.031869483938088194,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 568"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6680",
            "epochyr": 22,
            "epochdays": 53.6593238,
            "ndot": -7.5752137673365e-13,
            "nddot": 0,
            "bstar": -0.000045147,
            "inclo": 1.2918490790949029,
            "nodeo": 1.9823275111226395,
            "ecco": 0.0079217,
            "argpo": 3.33831394956983,
            "mo": 5.033625555860507,
            "no": 0.055050620850005755,
            "a": 1.2223615439483435,
            "alta": 0.23204472539103915,
            "altp": 0.21267836250564787,
            "jdsatepoch": 2459633.1593238,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124241354125615,
            "con41": -0.7725574707499128,
            "cc1": -2.954744138467555e-12,
            "cc4": 1.1379399642619959e-8,
            "cc5": 0.0000024064210602888278,
            "d2": 2.034195585011967e-22,
            "d3": -2.080629881824573e-32,
            "d4": 2.4774088261841672e-42,
            "delmo": 1.0443480380939325,
            "eta": 0.04614358659800259,
            "argpdot": -0.000018577327533262636,
            "omgcof": 6.402211636749259e-12,
            "sinmao": -0.9488457071403849,
            "t": 242358.99967812002,
            "t2cof": -4.432116207701332e-12,
            "t3cof": 2.2088058434881346e-22,
            "t4cof": -1.74723734377961e-32,
            "t5cof": 1.6945306186653238e-42,
            "x1mth2": 0.9241858235833043,
            "x7thm1": -0.4693007650831299,
            "mdot": 0.05502750454920958,
            "nodedot": -0.000016452681280164866,
            "xlcof": 0.0019290831199544878,
            "xmcof": 7.992617377862809e-8,
            "nodecf": 1.704777393658943e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.5216813737435118,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 569"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06681",
            "epochyr": 22,
            "epochdays": 53.59872226,
            "ndot": 3.0300855069346e-14,
            "nddot": 0,
            "bstar": 0.000091064,
            "inclo": 1.2919188922649827,
            "nodeo": 0.13254379405495337,
            "ecco": 0.0091231,
            "argpo": 1.2363266649304592,
            "mo": 1.7824838211107847,
            "no": 0.055153366535200345,
            "a": 1.2208438833043274,
            "alta": 0.23198176413610105,
            "altp": 0.20970600247255367,
            "jdsatepoch": 2459633.09872226,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242638311875326,
            "con41": -0.772668335856744,
            "cc1": 6.1641876765153e-12,
            "cc4": 1.3818071726817298e-8,
            "cc5": 0.0000024863331600447613,
            "d2": 8.906744188954843e-22,
            "d3": 1.9121259685895492e-31,
            "d4": 4.778821168354322e-41,
            "delmo": 0.9666780680701622,
            "eta": 0.053462555887414456,
            "argpdot": -0.000018664599826934063,
            "omgcof": 3.89942331953243e-12,
            "sinmao": 0.97767774745681,
            "t": 242446.2658955902,
            "t2cof": 9.246281514772949e-12,
            "t3cof": 9.666688383180904e-22,
            "t4cof": 1.6046585530405607e-31,
            "t5cof": 3.266108713417473e-41,
            "x1mth2": 0.9242227786189147,
            "x7thm1": -0.46955945033240265,
            "mdot": 0.05513014542338665,
            "nodedot": -0.00001652098039921033,
            "xlcof": 0.001929075294707455,
            "xmcof": -1.243830548288693e-7,
            "nodecf": -3.5712168201482724e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.1398681529036807,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 570"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6682",
            "epochyr": 22,
            "epochdays": 53.857385,
            "ndot": -5.75716246317574e-13,
            "nddot": 0,
            "bstar": -0.000011618,
            "inclo": 1.291815917839115,
            "nodeo": 4.523680491000558,
            "ecco": 0.0103282,
            "argpo": 5.284876173660602,
            "mo": 1.1772175991531673,
            "no": 0.055257818445270585,
            "a": 1.2193057226581505,
            "alta": 0.23189895602290833,
            "altp": 0.2067124892933927,
            "jdsatepoch": 2459633.357385,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242306756016893,
            "con41": -0.7725048011330757,
            "cc1": -8.144450187581582e-13,
            "cc4": 1.6452499087261054e-8,
            "cc5": 0.000002572472762825236,
            "d2": 1.564455115159156e-23,
            "d3": -4.465235154967155e-34,
            "d4": 1.4836738662760114e-44,
            "delmo": 1.0717115977096412,
            "eta": 0.06089816584410145,
            "argpdot": -0.000018739833735308265,
            "omgcof": -7.539831990818133e-13,
            "sinmao": 0.9235425491876271,
            "t": 242073.79154965281,
            "t2cof": -1.2216675281372373e-12,
            "t3cof": 1.6971192528751513e-23,
            "t4cof": -3.7446811246753245e-34,
            "t5cof": 1.0132134931291106e-44,
            "x1mth2": 0.9241682670443585,
            "x7thm1": -0.46917786931051,
            "mdot": 0.055234498732721724,
            "nodedot": -0.000016600745390572277,
            "xlcof": 0.0019290868309678702,
            "xmcof": 1.267621383980423e-8,
            "nodecf": 4.7411728641996924e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.7695438031525086,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 571"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06707",
            "epochyr": 22,
            "epochdays": 53.57681409,
            "ndot": 9.69627362219072e-13,
            "nddot": 0,
            "bstar": 0.000018478,
            "inclo": 1.4476912733347287,
            "nodeo": 4.789457484165004,
            "ecco": 0.002034,
            "argpo": 5.34278270758327,
            "mo": 1.953253816442918,
            "no": 0.059908478542514534,
            "a": 1.1554793173244355,
            "alta": 0.15782956225587363,
            "altp": 0.15312907239299767,
            "jdsatepoch": 2459633.07681409,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001160595078459527,
            "con41": -0.954764643463924,
            "cc1": 5.6808054890143085e-12,
            "cc4": 9.465207794442806e-9,
            "cc5": 0.000010463348382421801,
            "d2": 1.0440875840165517e-21,
            "d3": 2.858656023129046e-31,
            "d4": 9.117258776348067e-41,
            "delmo": 0.9816935755212508,
            "eta": 0.016451596528668906,
            "argpdot": -0.00003364072748521648,
            "omgcof": 4.7154850946397736e-11,
            "sinmao": 0.9277502990601528,
            "t": 242477.81366050243,
            "t2cof": 8.521208233521463e-12,
            "t3cof": 1.1086306860245818e-21,
            "t4cof": 2.3265129817976377e-31,
            "t5cof": 6.011445814971442e-41,
            "x1mth2": 0.9849215478213079,
            "x7thm1": -0.8944508347491558,
            "mdot": 0.059873687544640786,
            "nodedot": -0.00000892993401915195,
            "xlcof": 0.0018678210417369925,
            "xmcof": -0.0000016644800459124112,
            "nodecf": -1.7804492188892828e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.0018381788842347646,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 574"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6787",
            "epochyr": 22,
            "epochdays": 53.85574482,
            "ndot": 3.93911115901498e-12,
            "nddot": 0,
            "bstar": 0.000065016,
            "inclo": 1.723673206635584,
            "nodeo": 4.537952048294116,
            "ecco": 0.0026163,
            "argpo": 6.2344487331468965,
            "mo": 0.050539499149999806,
            "no": 0.06252093891966257,
            "a": 1.1230765182064613,
            "alta": 0.12601482330104474,
            "altp": 0.12013821311187778,
            "jdsatepoch": 2459633.35574482,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001155806122377373,
            "con41": -0.930430499102937,
            "cc1": 5.656730437116494e-11,
            "cc4": 5.36150405705482e-8,
            "cc5": 0.00002855153024454571,
            "d2": 1.301553769257822e-19,
            "d3": 4.467564288265678e-28,
            "d4": 1.7868941895834093e-36,
            "delmo": 1.0818490235449285,
            "eta": 0.02660472026572354,
            "argpdot": -0.000035535478358295376,
            "omgcof": 8.225930772791857e-10,
            "sinmao": 0.05051798688763351,
            "t": 242076.153409034,
            "t2cof": 8.485095655674741e-11,
            "t3cof": 1.3655509677342223e-19,
            "t4cof": 3.5760745671187867e-28,
            "t5cof": 1.155646948012937e-36,
            "x1mth2": 0.9768101663676457,
            "x7thm1": -0.8376711645735198,
            "mdot": 0.06248348468539876,
            "nodedot": 0.00001223309883892189,
            "xlcof": 0.001526082844610983,
            "xmcof": -0.000007882162632476442,
            "nodecf": 2.4289033641126122e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.7592100318007837,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 8364 (DMSP 4)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6822",
            "epochyr": 22,
            "epochdays": 53.86332407,
            "ndot": 4.2421197097084403e-13,
            "nddot": 0,
            "bstar": 0.00016257,
            "inclo": 1.669431864142104,
            "nodeo": 6.131435910035687,
            "ecco": 0.0029968,
            "argpo": 2.792552983129707,
            "mo": 4.656658872039259,
            "no": 0.05481259238559621,
            "a": 1.225983306763084,
            "alta": 0.22965733353679174,
            "altp": 0.22230927998937644,
            "jdsatepoch": 2459633.36332407,
            "isimp": 0,
            "method": "n",
            "aycof": 0.00116376114144558,
            "con41": -0.9709076224609279,
            "cc1": 9.812166165693816e-12,
            "cc4": 2.91413709231533e-9,
            "cc5": 0.0000022298517656365544,
            "d2": 2.2124823966972114e-21,
            "d3": 7.410812765095747e-31,
            "d4": 2.889605621681526e-40,
            "delmo": 0.9971257961616463,
            "eta": 0.01721661644309259,
            "argpdot": -0.00002813878164913892,
            "omgcof": -5.5358619915912265e-11,
            "sinmao": -0.998447479398337,
            "t": 242065.23928932846,
            "t2cof": 1.4718249248540725e-11,
            "t3cof": 2.4050396064235844e-21,
            "t4cof": 6.233004463001746e-31,
            "t5cof": 1.9800819865337045e-40,
            "x1mth2": 0.9903025408203092,
            "x7thm1": -0.9321177857421649,
            "mdot": 0.05478383873794031,
            "nodedot": 0.00000582149506873154,
            "xlcof": 0.001618521273171538,
            "xmcof": -0.000001907193310706576,
            "nodecf": 2.0042507634416274e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.8069622470076396,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 8314 (2)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06825",
            "epochyr": 22,
            "epochdays": 53.55617808,
            "ndot": 3.0300855069346e-14,
            "nddot": 0,
            "bstar": 0.00008953,
            "inclo": 1.2919695068132906,
            "nodeo": 2.9901312357724734,
            "ecco": 0.0018016,
            "argpo": 1.7114977897736714,
            "mo": 4.7732276674507075,
            "no": 0.0553591622531525,
            "a": 1.2178180712455244,
            "alta": 0.22001209228268048,
            "altp": 0.2156240502083686,
            "jdsatepoch": 2459633.05617808,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242801236310133,
            "con41": -0.7727486975444893,
            "cc1": 6.33348359553403e-12,
            "cc4": 1.7473730009996977e-9,
            "cc5": 0.0000025819611032648126,
            "d2": 9.51769595045346e-22,
            "d3": 2.1253263025534235e-31,
            "d4": 5.525075618266731e-41,
            "delmo": 1.0019505640256232,
            "eta": 0.010686731761094885,
            "argpdot": -0.00001882848539459421,
            "omgcof": -8.956818574129407e-12,
            "sinmao": -0.9981498978393287,
            "t": 242507.529514879,
            "t2cof": 9.500225393301046e-12,
            "t3cof": 1.0319956239551434e-21,
            "t4cof": 1.7811866183989387e-31,
            "t5cof": 3.770196201636341e-41,
            "x1mth2": 0.9242495658481631,
            "x7thm1": -0.46974696093714163,
            "mdot": 0.055335738892419654,
            "nodedot": -0.000016659401303606987,
            "xlcof": 0.0019290696107305183,
            "xmcof": -0.000003284749477251217,
            "nodecf": -3.7003740611771376e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.155008614343771,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 585"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6828",
            "epochyr": 22,
            "epochdays": 53.80609214,
            "ndot": 1.545343608536646e-12,
            "nddot": 0,
            "bstar": 0.000037511,
            "inclo": 1.4475324483727972,
            "nodeo": 4.379559928017127,
            "ecco": 0.0026397,
            "argpo": 4.858364828362992,
            "mo": 1.6130647106196954,
            "no": 0.06003803596823444,
            "a": 1.153817663591064,
            "alta": 0.15686339607764532,
            "altp": 0.15077193110448261,
            "jdsatepoch": 2459633.30609214,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011605722563548567,
            "con41": -0.954648438792363,
            "cc1": 1.2103664920632227e-11,
            "cc4": 1.6698986613111834e-8,
            "cc5": 0.000010963262497257092,
            "d2": 4.788619367284714e-21,
            "d3": 2.822489817192977e-30,
            "d4": 1.937934119002065e-39,
            "delmo": 0.9972679869837126,
            "eta": 0.02157104150855689,
            "argpdot": -0.00003380364917985672,
            "omgcof": 1.9340230397288255e-11,
            "sinmao": 0.9991068248564036,
            "t": 242147.65326865017,
            "t2cof": 1.815549738094834e-11,
            "t3cof": 5.0816167763066e-21,
            "t4cof": 2.2951798237336926e-30,
            "t5cof": 1.2765409971224904e-39,
            "x1mth2": 0.9848828129307876,
            "x7thm1": -0.8941796905155135,
            "mdot": 0.06000307332877231,
            "nodedot": -0.00000898656215710496,
            "xlcof": 0.0018679293988378876,
            "xmcof": -0.0000020809190085762473,
            "nodecf": -3.817543615805826e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.4463788758304403,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 586"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06845",
            "epochyr": 22,
            "epochdays": 53.34348475,
            "ndot": -5.75716246317574e-13,
            "nddot": 0,
            "bstar": -0.000022111,
            "inclo": 1.2915331745002918,
            "nodeo": 4.955244564482693,
            "ecco": 0.0028684,
            "argpo": 6.115813467901086,
            "mo": 2.1959383582742253,
            "no": 0.05450309749046124,
            "a": 1.2305294351689757,
            "alta": 0.23405908580081447,
            "altp": 0.22699978453713698,
            "jdsatepoch": 2459632.84348475,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011241395769276347,
            "con41": -0.7720554960509683,
            "cc1": -1.2254027663668983e-12,
            "cc4": 2.734996517910927e-9,
            "cc5": 0.000002053407835769895,
            "d2": 3.390094990908441e-23,
            "d3": -1.392964797838065e-33,
            "d4": 6.66249429141655e-44,
            "delmo": 0.9718455173169912,
            "eta": 0.016189516435733894,
            "argpdot": -0.000018122859016730544,
            "omgcof": -7.12016932297502e-12,
            "sinmao": 0.8108800090945147,
            "t": 242813.8079099357,
            "t2cof": -1.8381041495503474e-12,
            "t3cof": 3.69041737887237e-23,
            "t4cof": -1.1739507503443833e-33,
            "t5cof": 4.576295897650082e-44,
            "x1mth2": 0.924018498683656,
            "x7thm1": -0.46812949078559263,
            "mdot": 0.054480530468952695,
            "nodedot": -0.000016089818669215716,
            "xlcof": 0.0019291183158600055,
            "xmcof": 2.6445597759616793e-7,
            "nodecf": 6.914369946855488e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.814958089893864,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 588"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06846",
            "epochyr": 22,
            "epochdays": 53.55254494,
            "ndot": -6.66618811525612e-13,
            "nddot": 0,
            "bstar": -0.000035836,
            "inclo": 1.291519211866276,
            "nodeo": 1.4212408085207544,
            "ecco": 0.0046116,
            "argpo": 1.7045164727656943,
            "mo": 0.26567925472633286,
            "no": 0.05470386012230011,
            "a": 1.2275185640167103,
            "alta": 0.23317938862652987,
            "altp": 0.2218577394068908,
            "jdsatepoch": 2459633.05254494,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011241350758990807,
            "con41": -0.772033297604764,
            "cc1": -2.1071176253557857e-12,
            "cc4": 5.389202006844293e-9,
            "cc5": 0.0000021718767078619384,
            "d2": 1.0139346334502799e-22,
            "d3": -7.247289365146944e-33,
            "d4": 6.030058809701576e-43,
            "delmo": 1.078166460556726,
            "eta": 0.026328373916574593,
            "argpdot": -0.000018278341731461725,
            "omgcof": 1.044267760186271e-12,
            "sinmao": 0.2625647513209254,
            "t": 242512.76123665273,
            "t2cof": -3.1606764380336787e-12,
            "t3cof": 1.10273352719198e-22,
            "t4cof": -6.099799599255135e-33,
            "t5cof": 4.135506561904418e-43,
            "x1mth2": 0.9240110992015881,
            "x7thm1": -0.46807769441111624,
            "mdot": 0.054681098924291634,
            "nodedot": -0.000016229503803669447,
            "xlcof": 0.0019291198634168185,
            "xmcof": 1.733139541754672e-7,
            "nodecf": 1.1992650690757354e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.132118421574361,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 589"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06847",
            "epochyr": 22,
            "epochdays": 53.56731124,
            "ndot": 9.090256520803799e-14,
            "nddot": 0,
            "bstar": 0.00012178,
            "inclo": 1.2915733170730879,
            "nodeo": 3.0564624739945176,
            "ecco": 0.0034723,
            "argpo": 3.6034940401300926,
            "mo": 2.8861689535481787,
            "no": 0.054611090486997395,
            "a": 1.2289075844086859,
            "alta": 0.23317472021402819,
            "altp": 0.22464044860334353,
            "jdsatepoch": 2459633.06731124,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124152516163953,
            "con41": -0.7721193110581346,
            "cc1": 6.962857502173461e-12,
            "cc4": 3.66048561416455e-9,
            "cc5": 0.0000021147021131731295,
            "d2": 1.101287473709042e-21,
            "d3": 2.587233524750361e-31,
            "d4": 7.075308528788868e-41,
            "delmo": 0.9438476251065211,
            "eta": 0.01971891132472457,
            "argpdot": -0.000018209980218512456,
            "omgcof": -3.059167306609207e-11,
            "sinmao": 0.25265538495899775,
            "t": 242491.4977645129,
            "t2cof": 1.0444286253260191e-11,
            "t3cof": 1.1982502429001886e-21,
            "t4cof": 2.1789076003248867e-31,
            "t5cof": 4.855814428161116e-41,
            "x1mth2": 0.9240397703527115,
            "x7thm1": -0.4682783924689805,
            "mdot": 0.05458841701770363,
            "nodedot": -0.00001616207842445194,
            "xlcof": 0.0019291138628320281,
            "xmcof": -0.0000010178246142786094,
            "nodecf": -3.9464627546998823e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.225151842973375,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 590"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06848",
            "epochyr": 22,
            "epochdays": 53.51981235,
            "ndot": -7.272205216643039e-13,
            "nddot": 0,
            "bstar": -0.000042648,
            "inclo": 1.29153142917104,
            "nodeo": 1.098829626458346,
            "ecco": 0.0089031,
            "argpo": 0.2667037629972535,
            "mo": 1.754438125360488,
            "no": 0.055075639425539245,
            "a": 1.2219913293420723,
            "alta": 0.23287084034633776,
            "altp": 0.2111118183378069,
            "jdsatepoch": 2459633.01981235,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011241390143110505,
            "con41": -0.7720527212994415,
            "cc1": -2.8204191047949823e-12,
            "cc4": 1.3088941938951163e-8,
            "cc5": 0.0000024319475224471493,
            "d2": 1.8561605289755804e-22,
            "d3": -1.8149005322983595e-32,
            "d4": 2.0658192388184063e-42,
            "delmo": 0.9718166197920907,
            "eta": 0.05193611953105936,
            "argpdot": -0.000018572530772972504,
            "omgcof": -5.341885806698361e-12,
            "sinmao": 0.9831851803825264,
            "t": 242559.89616572857,
            "t2cof": -4.230628657192473e-12,
            "t3cof": 2.015255807509431e-22,
            "t4cof": -1.5238388597866867e-32,
            "t5cof": 1.4127352755315073e-42,
            "x1mth2": 0.9240175737664804,
            "x7thm1": -0.46812301636536324,
            "mdot": 0.05505251315131844,
            "nodedot": -0.00001648894387112296,
            "xlcof": 0.0019291185093419352,
            "xmcof": 6.010978151693943e-8,
            "nodecf": 1.6308364674214686e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.925890403374453,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 591"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06849",
            "epochyr": 22,
            "epochdays": 53.498514,
            "ndot": -3.93911115901498e-13,
            "nddot": 0,
            "bstar": 0.000022952,
            "inclo": 1.2916117143166317,
            "nodeo": 5.69716483088371,
            "ecco": 0.0099367,
            "argpo": 4.55956271509231,
            "mo": 1.7058115070706739,
            "no": 0.055169786194544254,
            "a": 1.2206015667402483,
            "alta": 0.23273031832847613,
            "altp": 0.20847281515202054,
            "jdsatepoch": 2459632.998514,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011241648911297188,
            "con41": -0.772180343827085,
            "cc1": 1.5657962699005227e-12,
            "cc4": 1.528868696025788e-8,
            "cc5": 0.000002506428410543136,
            "d2": 5.752503411361763e-23,
            "d3": 3.140052572249409e-33,
            "d4": 1.995375684752692e-43,
            "delmo": 0.9766471248973811,
            "eta": 0.05828657864346495,
            "argpdot": -0.000018653768818666854,
            "omgcof": -4.209874631534897e-13,
            "sinmao": 0.990899287972338,
            "t": 242590.5657901615,
            "t2cof": 2.348694404850784e-12,
            "t3cof": 6.242847003128641e-23,
            "t4cof": 2.6348541077970432e-33,
            "t5cof": 1.363577785148587e-43,
            "x1mth2": 0.9240601146090283,
            "x7thm1": -0.46842080226319815,
            "mdot": 0.055146563083215305,
            "nodedot": -0.000016550714107045038,
            "xlcof": 0.0019291095981345948,
            "xmcof": -2.6523912492968776e-8,
            "nodecf": -9.087608835767214e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.791702530612767,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 592"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6850",
            "epochyr": 22,
            "epochdays": 53.77311229,
            "ndot": -2.1210598548542201e-13,
            "nddot": 0,
            "bstar": 0.00004948,
            "inclo": 1.291576807731592,
            "nodeo": 2.678644069498297,
            "ecco": 0.007719,
            "argpo": 2.064911255339255,
            "mo": 6.269091773469732,
            "no": 0.05498692741802111,
            "a": 1.2233045794231576,
            "alta": 0.23274726747172503,
            "altp": 0.21386189137459022,
            "jdsatepoch": 2459633.27311229,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011241536412293282,
            "con41": -0.7721248598016888,
            "cc1": 3.1774858689331097e-12,
            "cc4": 1.0815750798750534e-8,
            "cc5": 0.000002363510621105884,
            "d2": 2.343724733825081e-22,
            "d3": 2.568285548815686e-32,
            "d4": 3.276249694458646e-42,
            "delmo": 1.1404837595510504,
            "eta": 0.044796119778934676,
            "argpdot": -0.000018505674033355497,
            "omgcof": -3.4007568063633788e-12,
            "sinmao": -0.014093067153474656,
            "t": 242195.14425225556,
            "t2cof": 4.766228803399665e-12,
            "t3cof": 2.545653062770473e-22,
            "t4cof": 2.1576490334307267e-32,
            "t5cof": 2.2420266945859445e-42,
            "x1mth2": 0.9240416199338962,
            "x7thm1": -0.46829133953727364,
            "mdot": 0.05496388647274573,
            "nodedot": -0.000016423861674178443,
            "xlcof": 0.0019291134753455707,
            "xmcof": -9.095425084640587e-8,
            "nodecf": -1.8300778241798905e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.238593023111342,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 593"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06851",
            "epochyr": 22,
            "epochdays": 53.60752431,
            "ndot": -6.36317956456266e-13,
            "nddot": 0,
            "bstar": -0.000025131,
            "inclo": 1.29150524923226,
            "nodeo": 4.291549955156061,
            "ecco": 0.0067744,
            "argpo": 3.921063678847469,
            "mo": 3.355636342395874,
            "no": 0.05489662880982748,
            "a": 1.224644869485048,
            "alta": 0.23294110368888754,
            "altp": 0.2163486352812085,
            "jdsatepoch": 2459633.10752431,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011241305746513706,
            "con41": -0.7720110981666021,
            "cc1": -1.5684413132230329e-12,
            "cc4": 9.039968440518379e-9,
            "cc5": 0.0000022994960114241558,
            "d2": 5.680642355940659e-23,
            "d3": -3.0564568621728588e-33,
            "d4": 1.914391513505932e-43,
            "delmo": 0.8896773121645428,
            "eta": 0.039108552880979586,
            "argpdot": -0.000018428745718488398,
            "omgcof": 2.854866873782335e-12,
            "sinmao": -0.21241303742479242,
            "t": 242433.59094388783,
            "t2cof": -2.3526619698345492e-12,
            "t3cof": 6.172643986545617e-23,
            "t4cof": -2.5692812173758765e-33,
            "t5cof": 1.3109777074574782e-43,
            "x1mth2": 0.9240036993888674,
            "x7thm1": -0.46802589572207154,
            "mdot": 0.054873679883558436,
            "nodedot": -0.000016364711001502324,
            "xlcof": 0.0019291214102910674,
            "xmcof": 5.8782052187548685e-8,
            "nodecf": 9.00100818023625e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.1953244826737759,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 594"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06852",
            "epochyr": 22,
            "epochdays": 53.56005571,
            "ndot": -1.21203420277384e-13,
            "nddot": 0,
            "bstar": 0.000076182,
            "inclo": 1.2916239316213955,
            "nodeo": 5.968078328036774,
            "ecco": 0.0055916,
            "argpo": 5.821800538097877,
            "mo": 3.471150958939118,
            "no": 0.0548021719400143,
            "a": 1.226050954576267,
            "alta": 0.23290654109387576,
            "altp": 0.21919536805865825,
            "jdsatepoch": 2459633.06005571,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011241688282712502,
            "con41": -0.7721997617711304,
            "cc1": 4.6151267452016946e-12,
            "cc4": 7.008816061882387e-9,
            "cc5": 0.0000022346073729612424,
            "d2": 4.891659215715306e-22,
            "d3": 7.701889644433935e-32,
            "d4": 1.4116417388210934e-41,
            "delmo": 0.911609968770719,
            "eta": 0.03210443516358756,
            "argpdot": -0.000018363607402309212,
            "omgcof": 1.2748768749727654e-11,
            "sinmao": -0.3236251349565553,
            "t": 242501.94572769105,
            "t2cof": 6.9226901178025415e-12,
            "t3cof": 5.317647113200826e-22,
            "t4cof": 6.478260903306473e-32,
            "t5cof": 9.673949738199306e-42,
            "x1mth2": 0.9240665872570435,
            "x7thm1": -0.4684661107993042,
            "mdot": 0.05477930993724579,
            "nodedot": -0.000016291930951037163,
            "xlcof": 0.001929108240102856,
            "xmcof": -2.561217700063115e-7,
            "nodecf": -2.6367884436723015e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.179439188196213,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 595"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06909",
            "epochyr": 22,
            "epochdays": 53.57566553,
            "ndot": 2.181661564992912e-12,
            "nddot": 0,
            "bstar": 0.000065828,
            "inclo": 1.5675395424106753,
            "nodeo": 4.88145902502538,
            "ecco": 0.015472,
            "argpo": 4.9087350305755475,
            "mo": 1.3461899053557462,
            "no": 0.05984185088933678,
            "a": 1.1563574708747049,
            "alta": 0.17424863366407828,
            "altp": 0.13846630808533145,
            "jdsatepoch": 2459633.07566553,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001169439077431297,
            "con41": -0.9999681801789247,
            "cc1": 2.1446304505008046e-11,
            "cc4": 1.5350095304197864e-7,
            "cc5": 0.000011292719563101525,
            "d2": 1.4802843065309022e-20,
            "d3": 1.5220186364118188e-29,
            "d4": 1.8229238913911239e-38,
            "delmo": 1.0855062965011781,
            "eta": 0.1244877634007675,
            "argpdot": -0.00003629410919220305,
            "omgcof": 7.139642301446804e-12,
            "sinmao": 0.9748818414478075,
            "t": 242479.46758702397,
            "t2cof": 3.216945675751207e-11,
            "t3cof": 1.5722731019152078e-20,
            "t4cof": 1.239219885930479e-29,
            "t5cof": 1.2025378063497925e-38,
            "x1mth2": 0.999989393392975,
            "x7thm1": -0.9999257537508246,
            "mdot": 0.05980549541527892,
            "nodedot": -2.3630819798472938e-7,
            "xlcof": 0.001757954856824361,
            "xmcof": -1.0058283353997624e-7,
            "nodecf": -1.7785109372113e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.277787111769086,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "NNSS 20 (TRANSIT 20)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06920",
            "epochyr": 22,
            "epochdays": 53.54324139,
            "ndot": -6.66618811525612e-13,
            "nddot": 0,
            "bstar": 0.00017592,
            "inclo": 1.7836374837463531,
            "nodeo": 0.6071110349769755,
            "ecco": 0.0006443,
            "argpo": 2.464452027705797,
            "mo": 5.789721386446222,
            "no": 0.05414521609345505,
            "a": 1.2359839217849715,
            "alta": 0.23678026622577764,
            "altp": 0.2351875773441654,
            "jdsatepoch": 2459633.04324139,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011430563967589169,
            "con41": -0.866135783058934,
            "cc1": 8.798681212397257e-12,
            "cc4": -2.7715006937706897e-10,
            "cc5": 0.000001866495788703449,
            "d2": 1.7129289995394826e-21,
            "d3": 4.951861961495012e-31,
            "d4": 1.6662681756865215e-40,
            "delmo": 1.0094458864395124,
            "eta": 0.003563956019889778,
            "argpdot": -0.0000223423480892082,
            "omgcof": -1.781157045980836e-10,
            "sinmao": -0.47367938968418366,
            "t": 242526.15834832191,
            "t2cof": 1.3198021818595885e-11,
            "t3cof": 1.8677625816942676e-21,
            "t4cof": 4.1830710989432316e-31,
            "t5cof": 1.1476744348137379e-40,
            "x1mth2": 0.955378594352978,
            "x7thm1": -0.6876501604708462,
            "mdot": 0.054120286746193916,
            "nodedot": 0.000012139184894798746,
            "xlcof": 0.0014084635488388257,
            "xmcof": -0.00003857304531138001,
            "nodecf": 3.7465346189988477e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.073502447307348,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "NOAA 3"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06938",
            "epochyr": 22,
            "epochdays": 53.53712213,
            "ndot": 6.0601710138692e-13,
            "nddot": 0,
            "bstar": 0.00023046,
            "inclo": 1.6918401464084594,
            "nodeo": 0.4372608281606434,
            "ecco": 0.0026531,
            "argpo": 6.27494386245167,
            "mo": 2.0270655358390104,
            "no": 0.054880032598579036,
            "a": 1.2249729548854678,
            "alta": 0.22822293063207444,
            "altp": 0.22172297913886108,
            "jdsatepoch": 2459633.03712213,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011608886085514762,
            "con41": -0.9562594318376758,
            "cc1": 1.4177264616415256e-11,
            "cc4": 2.48665194316031e-9,
            "cc5": 0.000002269529433365665,
            "d2": 4.6369049394262846e-21,
            "d3": 2.2529498705854098e-30,
            "d4": 1.2742820157500048e-39,
            "delmo": 0.9799103013991165,
            "eta": 0.015301602996632791,
            "argpdot": -0.000027497738641662884,
            "omgcof": 9.645993154753068e-11,
            "sinmao": 0.8977025352846083,
            "t": 242534.97008286417,
            "t2cof": 2.1265896924622884e-11,
            "t3cof": 5.038894603434004e-21,
            "t4cof": 1.8940521802209123e-30,
            "t5cof": 8.727410342528566e-40,
            "x1mth2": 0.9854198106125587,
            "x7thm1": -0.8979386742879105,
            "mdot": 0.05485163125897869,
            "nodedot": 0.000007158898870791947,
            "xlcof": 0.0015819069707054343,
            "xmcof": -0.0000035015633958341593,
            "nodecf": 3.561044575785206e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.0349487338066155,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 6630 (2)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6965",
            "epochyr": 22,
            "epochdays": 53.7398811,
            "ndot": 1.878653014299452e-12,
            "nddot": 0,
            "bstar": 0.000028353,
            "inclo": 1.2925070682229047,
            "nodeo": 1.0591949444748068,
            "ecco": 0.0022599,
            "argpo": 0.3671177908522433,
            "mo": 5.919696055842239,
            "no": 0.06282315168244644,
            "a": 1.1193990062478993,
            "alta": 0.12192873606211907,
            "altp": 0.11686927643367984,
            "jdsatepoch": 2459633.2398811,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124452982870855,
            "con41": -0.7736013890901726,
            "cc1": 2.8290210116561696e-11,
            "cc4": 5.588015394151858e-8,
            "cc5": 0.000032468290540817636,
            "d2": 3.3544263282109095e-20,
            "d3": 5.934482275276128e-29,
            "d4": 1.223440544305206e-37,
            "delmo": 1.0678777621075544,
            "eta": 0.023679642577073837,
            "argpdot": -0.000025347047381194217,
            "omgcof": 4.4785259805988185e-10,
            "sinmao": -0.35553766144721094,
            "t": 242242.99716576934,
            "t2cof": 4.2435315174842543e-11,
            "t3cof": 3.5144935258987517e-20,
            "t4cof": 4.7412144017131334e-29,
            "t5cof": 7.894900148903872e-38,
            "x1mth2": 0.924533796363391,
            "x7thm1": -0.4717365745437363,
            "mdot": 0.06279165516811211,
            "nodedot": -0.000022328150243429006,
            "xlcof": 0.001929008689282409,
            "xmcof": -0.000005105634307782436,
            "nodecf": -2.216124421190814e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.0292236294855215,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 614"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6985",
            "epochyr": 22,
            "epochdays": 53.66537834,
            "ndot": -3.0300855069346e-13,
            "nddot": 0,
            "bstar": 0.000036393,
            "inclo": 1.292081207885418,
            "nodeo": 0.4521729212896829,
            "ecco": 0.0096282,
            "argpo": 5.937650257857505,
            "mo": 3.3595406439325854,
            "no": 0.055153353511419284,
            "a": 1.2208441944360622,
            "alta": 0.23259872650893154,
            "altp": 0.20908966236319282,
            "jdsatepoch": 2459633.16537834,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243160691762255,
            "con41": -0.7729260013229148,
            "cc1": 2.4679914575069705e-12,
            "cc4": 1.4671529902488225e-8,
            "cc5": 0.0000024917247245518794,
            "d2": 1.4277568264224447e-22,
            "d3": 1.2272109725377205e-32,
            "d4": 1.2279790901810108e-42,
            "delmo": 0.8436737191310698,
            "eta": 0.05642246459629531,
            "argpdot": -0.000018677803329406503,
            "omgcof": 4.2325187438264864e-12,
            "sinmao": -0.21622661404143287,
            "t": 242350.28114028275,
            "t2cof": 3.701987186260456e-12,
            "t3cof": 1.5495764631089922e-22,
            "t4cof": 1.0298771017172636e-32,
            "t5cof": 8.392684022113871e-43,
            "x1mth2": 0.9243086671076383,
            "x7thm1": -0.4701606697534678,
            "mdot": 0.05513012434203507,
            "nodedot": -0.000016511906991247306,
            "xlcof": 0.0019290570350334886,
            "xmcof": -4.462988293195547e-8,
            "nodecf": -1.4290309352508013e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.5598273265360589,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 617"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06986",
            "epochyr": 22,
            "epochdays": 53.60199133,
            "ndot": -6.36317956456266e-13,
            "nddot": 0,
            "bstar": -0.000032714,
            "inclo": 1.2920026680690784,
            "nodeo": 4.6493180172053705,
            "ecco": 0.0027524,
            "argpo": 5.658736171413299,
            "mo": 1.664548432895024,
            "no": 0.05455952245336953,
            "a": 1.2296816833054307,
            "alta": 0.23306625917056079,
            "altp": 0.22629710744030085,
            "jdsatepoch": 2459633.10199133,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242907964288504,
            "con41": -0.7728013412338028,
            "cc1": -1.8418645991936736e-12,
            "cc4": 2.6289342771957e-9,
            "cc5": 0.0000020839817664067706,
            "d2": 7.683579096501358e-23,
            "d3": -4.7607845773795726e-33,
            "d4": 3.4337230783054077e-43,
            "delmo": 0.9956294927231262,
            "eta": 0.01558474578768028,
            "argpdot": -0.00001820292218922995,
            "omgcof": -9.22156767393178e-12,
            "sinmao": 0.9956084892980085,
            "t": 242441.55843503773,
            "t2cof": -2.7627968987905102e-12,
            "t3cof": 8.362072136853932e-23,
            "t4cof": -4.010772956920999e-33,
            "t5cof": 2.3575130355512587e-43,
            "x1mth2": 0.924267113744601,
            "x7thm1": -0.4698697962122067,
            "mdot": 0.054536879072578606,
            "nodedot": -0.000016102207801057136,
            "xlcof": 0.0019290658818811011,
            "xmcof": 4.302445209248857e-7,
            "nodecf": 1.0400830914311947e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.16046456154540323,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 618"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06987",
            "epochyr": 22,
            "epochdays": 53.54344475,
            "ndot": 1.5150427534673e-13,
            "nddot": 0,
            "bstar": 0.00013331,
            "inclo": 1.2920724812391582,
            "nodeo": 2.890759169480924,
            "ecco": 0.0041037,
            "argpo": 3.642697625788389,
            "mo": 2.63838106898404,
            "no": 0.05466016976483749,
            "a": 1.2281726102612867,
            "alta": 0.23321266220201586,
            "altp": 0.22313255832055745,
            "jdsatepoch": 2459633.04344475,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243132614356672,
            "con41": -0.7729121517528681,
            "cc1": 7.735489574672093e-12,
            "cc4": 4.599831895615768e-9,
            "cc5": 0.0000021446820998017086,
            "d2": 1.3630766730328874e-21,
            "d3": 3.567685228236708e-31,
            "d4": 1.0870023841620148e-40,
            "delmo": 0.9398295913008367,
            "eta": 0.02337008479739245,
            "argpdot": -0.000018287097661310943,
            "omgcof": -2.8267106142055268e-11,
            "sinmao": 0.4822414919437768,
            "t": 242525.8655101061,
            "t2cof": 1.1603234362008139e-11,
            "t3cof": 1.4827522709526086e-21,
            "t4cof": 3.003657749739903e-31,
            "t5cof": 7.457330945701736e-41,
            "x1mth2": 0.9243040505842893,
            "x7thm1": -0.4701283540900254,
            "mdot": 0.05463742524912042,
            "nodedot": -0.000016167874092917204,
            "xlcof": 0.0019290580190833941,
            "xmcof": -8.06381008470497e-7,
            "nodecf": -4.3859519249698906e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.074783693420997,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 619"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06988",
            "epochyr": 22,
            "epochdays": 53.3884551,
            "ndot": -3.0300855069346e-13,
            "nddot": 0,
            "bstar": 0.000038762,
            "inclo": 1.292089934531678,
            "nodeo": 0.35853251626168314,
            "ecco": 0.0021513,
            "argpo": 2.2483069624803154,
            "mo": 6.0286883769707815,
            "no": 0.05444528163978595,
            "a": 1.2314003263523698,
            "alta": 0.23404943787445176,
            "altp": 0.22875121483028793,
            "jdsatepoch": 2459632.8884551,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243188768311622,
            "con41": -0.7729398505052065,
            "cc1": 2.1121547048510834e-12,
            "cc4": 1.7551651221561087e-9,
            "cc5": 0.0000020207834104227435,
            "d2": 1.0038789807887937e-22,
            "d3": 7.086276243613554e-33,
            "d4": 5.822638222997749e-43,
            "delmo": 1.0355508580308517,
            "eta": 0.012102383119748152,
            "argpdot": -0.000018120742647694787,
            "omgcof": -1.0362308676286209e-11,
            "sinmao": -0.2517585745637678,
            "t": 242749.05060611665,
            "t2cof": 3.168232057276625e-12,
            "t3cof": 1.093102930733285e-22,
            "t4cof": 5.9743683446299965e-33,
            "t5cof": 4.001199258627687e-43,
            "x1mth2": 0.9243132835017355,
            "x7thm1": -0.4701929845121485,
            "mdot": 0.05442274476744068,
            "nodedot": -0.00001601875052374303,
            "xlcof": 0.001929056050716869,
            "xmcof": -8.138170072833031e-7,
            "nodecf": -1.1865288370967823e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.098288747049466,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 620"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06989",
            "epochyr": 22,
            "epochdays": 53.45393769,
            "ndot": -6.0601710138692e-13,
            "nddot": 0,
            "bstar": -0.000027537,
            "inclo": 1.2920288480078583,
            "nodeo": 1.0211101148670385,
            "ecco": 0.0049391,
            "argpo": 1.2927706129399559,
            "mo": 0.614666565308859,
            "no": 0.05476680165390194,
            "a": 1.2265787685518628,
            "alta": 0.23263696374761733,
            "altp": 0.2205205733561082,
            "jdsatepoch": 2459632.95393769,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242992214485598,
            "con41": -0.7728428980864493,
            "cc1": -1.6493328022679479e-12,
            "cc4": 5.977686381516341e-9,
            "cc5": 0.000002210201730932132,
            "d2": 6.234767855086778e-23,
            "d3": -3.5010003763945006e-33,
            "d4": 2.288484856527967e-43,
            "delmo": 1.0709772252519307,
            "eta": 0.028300331500736273,
            "argpdot": -0.000018367295905828366,
            "omgcof": -1.578593870180111e-12,
            "sinmao": 0.5766861496156966,
            "t": 242654.75567668676,
            "t2cof": -2.4739992034019217e-12,
            "t3cof": 6.778827593614186e-23,
            "t4cof": -2.9454631910978196e-33,
            "t5cof": 1.568719523698293e-43,
            "x1mth2": 0.9242809660288165,
            "x7thm1": -0.4699667622017152,
            "mdot": 0.05474395528758738,
            "nodedot": -0.000016244204606510956,
            "xlcof": 0.0019290629353322607,
            "xmcof": 1.1772911797965085e-7,
            "nodecf": 9.395692425153668e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.510854477030463,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 621"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 6990",
            "epochyr": 22,
            "epochdays": 53.80872817,
            "ndot": -1.5150427534673e-13,
            "nddot": 0,
            "bstar": 0.000068951,
            "inclo": 1.2920131400445902,
            "nodeo": 3.871281652592834,
            "ecco": 0.0074196,
            "argpo": 3.632506648285994,
            "mo": 4.490594284370503,
            "no": 0.054960819430159506,
            "a": 1.2236920401375824,
            "alta": 0.23277134559858714,
            "altp": 0.2146127346765776,
            "jdsatepoch": 2459633.30872817,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242941665292037,
            "con41": -0.7728179643936025,
            "cc1": 4.3908921886848835e-12,
            "cc4": 1.0247379462951284e-8,
            "cc5": 0.0000023444814488452256,
            "d2": 4.468739393712166e-22,
            "d3": 6.756544313418276e-32,
            "d4": 1.1892130746150317e-41,
            "delmo": 0.9718944593665736,
            "eta": 0.042993220879127096,
            "argpdot": -0.000018519328783111295,
            "omgcof": -9.081109984425378e-12,
            "sinmao": -0.9755042220560243,
            "t": 242143.85738499463,
            "t2cof": 6.586338283027325e-12,
            "t3cof": 4.854338077965244e-22,
            "t4cof": 5.677224850110457e-32,
            "t5cof": 8.13973756098046e-42,
            "x1mth2": 0.9242726547978675,
            "x7thm1": -0.4699085835850725,
            "mdot": 0.05493778350140131,
            "nodedot": -0.000016380546144326736,
            "xlcof": 0.0019290647035496052,
            "xmcof": -1.3638460993419616e-7,
            "nodecf": -2.522284067757422e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.4629868898638492,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 622"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06991",
            "epochyr": 22,
            "epochdays": 53.51362272,
            "ndot": -3.6361026083215196e-13,
            "nddot": 0,
            "bstar": 0.000028372,
            "inclo": 1.2920969158486861,
            "nodeo": 5.550223815829055,
            "ecco": 0.006314,
            "argpo": 5.556072414152489,
            "mo": 3.754691913230361,
            "no": 0.05486638066399497,
            "a": 1.225095091876116,
            "alta": 0.2328303422862219,
            "altp": 0.21735984146601028,
            "jdsatepoch": 2459633.01362272,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243211228934638,
            "con41": -0.7729509295718531,
            "cc1": 1.753423233957253e-12,
            "cc4": 8.250331011268209e-9,
            "cc5": 0.0000022777929365237533,
            "d2": 7.087181745298121e-23,
            "d3": 4.255441574341373e-33,
            "d4": 2.9744425118885787e-43,
            "delmo": 0.9133515328005234,
            "eta": 0.036386865245537844,
            "argpdot": -0.00001845118460610332,
            "omgcof": 3.592504230195169e-12,
            "sinmao": -0.5754050067435849,
            "t": 242568.80923345685,
            "t2cof": 2.6301348509358795e-12,
            "t3cof": 7.702080352774344e-23,
            "t4cof": 3.577863273631493e-33,
            "t5cof": 2.03737471407641e-43,
            "x1mth2": 0.9243169765239511,
            "x7thm1": -0.4702188356676572,
            "mdot": 0.05484343354071941,
            "nodedot": -0.000016309745764760746,
            "xlcof": 0.0019290552630715386,
            "xmcof": -7.588162210526327e-8,
            "nodecf": -1.0028858874244512e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.886893329869437,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 623"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "06992",
            "epochyr": 22,
            "epochdays": 53.60936678,
            "ndot": -5.15114536178882e-13,
            "nddot": 0,
            "bstar": -0.0000082814,
            "inclo": 1.29204804662963,
            "nodeo": 2.197451558735705,
            "ecco": 0.0085241,
            "argpo": 1.7330857672915894,
            "mo": 0.2083416981398151,
            "no": 0.055055509777941394,
            "a": 1.222289364480049,
            "alta": 0.2327082812518133,
            "altp": 0.21187044770828467,
            "jdsatepoch": 2459633.10936678,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124305399306599,
            "con41": -0.7728733708939131,
            "cc1": -5.437931845542137e-13,
            "cc4": 1.238180592940486e-8,
            "cc5": 0.000002415037549981905,
            "d2": 6.891988529286615e-24,
            "d3": -1.2977344175356934e-34,
            "d4": 2.8446452352812723e-45,
            "delmo": 1.1529765914827195,
            "eta": 0.04966673030908489,
            "argpdot": -0.00001859724529307182,
            "omgcof": 1.8014714938469348e-13,
            "sinmao": 0.20683774347558717,
            "t": 242430.93778654933,
            "t2cof": -8.156897768313205e-13,
            "t3cof": 7.483410584421841e-24,
            "t4cof": -1.0897554458940463e-34,
            "t5cof": 1.94564489691766e-45,
            "x1mth2": 0.9242911236313044,
            "x7thm1": -0.4700378654191306,
            "mdot": 0.05503237889401646,
            "nodedot": -0.000016444966442626373,
            "xlcof": 0.001929060773004223,
            "xmcof": 1.2675896295031398e-8,
            "nodecf": 3.1359854596071916e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.20693276108899994,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 624"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 7003",
            "epochyr": 22,
            "epochdays": 53.84068426,
            "ndot": 2.9525153179570745e-10,
            "nddot": 0,
            "bstar": 0.00036116,
            "inclo": 1.2902084695980283,
            "nodeo": 4.057366912111218,
            "ecco": 0.0367942,
            "argpo": 3.2688236654016762,
            "mo": 3.0069405017984305,
            "no": 0.06470706216280121,
            "a": 1.0975787590379051,
            "alta": 0.13796329141369768,
            "altp": 0.0571942266621126,
            "jdsatepoch": 2459633.34068426,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011237115660205608,
            "con41": -0.7699450034747609,
            "cc1": 3.065747848308218e-9,
            "cc4": 0.000012392212972872888,
            "cc5": 0.0003237760718282282,
            "d2": 4.854640664336485e-16,
            "d3": 1.1481443646408673e-22,
            "d4": 3.16497685234544e-29,
            "delmo": 0.14818741916909448,
            "eta": 0.47512031313973535,
            "argpdot": -0.000026963380689783736,
            "omgcof": -1.202207337008982e-9,
            "sinmao": 0.13424561961869905,
            "t": 242097.84061588347,
            "t2cof": 4.5986217724623275e-9,
            "t3cof": 5.042616861724614e-16,
            "t4cof": 9.064779455219927e-23,
            "t5cof": 2.0145094333171296e-29,
            "x1mth2": 0.9233150011582536,
            "x7thm1": -0.46320500810777543,
            "mdot": 0.06467340975586255,
            "nodedot": -0.000024177178808044416,
            "xlcof": 0.00192926210149155,
            "xmcof": -4.968251268301921e-7,
            "nodecf": -2.5971721310876846e-13,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.6643226568495706,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "AUREOLE 2"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07005",
            "epochyr": 22,
            "epochdays": 53.60527755,
            "ndot": -1.7271487389527223e-12,
            "nddot": 0,
            "bstar": 0.000025422,
            "inclo": 1.1421137919078053,
            "nodeo": 2.7343602152097124,
            "ecco": 0.0054419,
            "argpo": 6.082866887611189,
            "mo": 0.2000042603030382,
            "no": 0.060466352137105245,
            "a": 1.1481438904578138,
            "alta": 0.15439197469529642,
            "altp": 0.1418958062203315,
            "jdsatepoch": 2459633.10527755,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010636270566065414,
            "con41": -0.4816480948599611,
            "cc1": 9.802355730840048e-12,
            "cc4": 6.575526225973001e-8,
            "cc5": 0.000012913266539748702,
            "d2": 3.2515565837093095e-21,
            "d3": 1.6072449871688537e-30,
            "d4": 9.255096464823738e-40,
            "delmo": 1.141561708263044,
            "eta": 0.046038478593933334,
            "argpdot": -0.0000051184967688433114,
            "omgcof": 4.814725348169798e-11,
            "sinmao": 0.19867350617387747,
            "t": 242436.82627804577,
            "t2cof": 1.4703533596260073e-11,
            "t3cof": 3.443728939457175e-21,
            "t4cof": 1.303407160554904e-30,
            "t5cof": 6.0770669674226485e-40,
            "x1mth2": 0.827216031619987,
            "x7thm1": 0.20948777866009083,
            "mdot": 0.06044841240089488,
            "nodedot": -0.00003093345410369372,
            "xlcof": 0.0019077450380764157,
            "xmcof": -3.752395899830468e-7,
            "nodecf": -1.0627407177452593e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.18116902377473565,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 626"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 7008",
            "epochyr": 22,
            "epochdays": 53.82044927,
            "ndot": 1.605945318675338e-12,
            "nddot": 0,
            "bstar": 0.000041303,
            "inclo": 1.44783264500414,
            "nodeo": 3.540569684607941,
            "ecco": 0.0032786,
            "argpo": 0.6867591353917367,
            "mo": 1.1851326673109615,
            "no": 0.05993820938184068,
            "a": 1.155097536529357,
            "alta": 0.1588846393126222,
            "altp": 0.15131043374609177,
            "jdsatepoch": 2459633.32044927,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011606153680132042,
            "con41": -0.9548679549133359,
            "cc1": 1.2866718009493528e-11,
            "cc4": 2.2780725236814817e-8,
            "cc5": 0.000010602879730301235,
            "d2": 5.368738531952655e-21,
            "d3": 3.337196079387249e-30,
            "d4": 2.416407910195464e-39,
            "delmo": 1.030297762895613,
            "eta": 0.026580621472166315,
            "argpdot": -0.00003368634032696889,
            "omgcof": 8.698595342721573e-11,
            "sinmao": 0.9265489852072445,
            "t": 242126.97900138795,
            "t2cof": 1.9300077014240292e-11,
            "t3cof": 5.699843396624305e-21,
            "t4cof": 2.7154564849690748e-30,
            "t5cof": 1.5929008655355137e-39,
            "x1mth2": 0.984955984971112,
            "x7thm1": -0.894691894797784,
            "mdot": 0.05990337398654808,
            "nodedot": -0.000008930161615364687,
            "xlcof": 0.0018677245109063008,
            "xmcof": -0.000001443988180501432,
            "nodecf": -4.032706338737128e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 1.5368343670790168,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 627"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 7094",
            "epochyr": 22,
            "epochdays": 53.66371111,
            "ndot": 9.0902565208038e-13,
            "nddot": 0,
            "bstar": 0.000014992,
            "inclo": 1.4477977384191,
            "nodeo": 4.682315212043576,
            "ecco": 0.0035712,
            "argpo": 3.894365377279711,
            "mo": 3.4159933185883418,
            "no": 0.0600640935340993,
            "a": 1.1534842865473451,
            "alta": 0.15760360963146325,
            "altp": 0.14936496346322725,
            "jdsatepoch": 2459633.16371111,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011606103604034647,
            "con41": -0.9548424567267082,
            "cc1": 4.894291316162096e-12,
            "cc4": 2.734684456474319e-8,
            "cc5": 0.000011092690567897243,
            "d2": 7.846179662819284e-22,
            "d3": 1.8739650635159653e-31,
            "d4": 5.213756290185418e-41,
            "delmo": 0.9179059268458076,
            "eta": 0.029243732229968296,
            "argpdot": -0.00003385003334747304,
            "omgcof": -2.9020725781935835e-11,
            "sinmao": -0.2709700731132674,
            "t": 242352.68195137382,
            "t2cof": 7.341436974243145e-12,
            "t3cof": 8.3252614125684775e-22,
            "t4cof": 1.5236092216627378e-31,
            "t5cof": 3.433699382901851e-41,
            "x1mth2": 0.9849474855755693,
            "x7thm1": -0.8946323990289857,
            "mdot": 0.0600290880783202,
            "nodedot": -0.000008976486805452747,
            "xlcof": 0.0018677483527817446,
            "xmcof": -4.577682774067418e-7,
            "nodecf": -1.5419425541620358e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.5493231309748339,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 628"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07209",
            "epochyr": 22,
            "epochdays": 53.56210773,
            "ndot": 2.42406840554768e-12,
            "nddot": 0,
            "bstar": 0.000035427,
            "inclo": 1.4177065167854659,
            "nodeo": 2.3902353919232424,
            "ecco": 0.0038616,
            "argpo": 3.6427569669829567,
            "mo": 2.6387650414194788,
            "no": 0.061731920551527854,
            "a": 1.1326182101551576,
            "alta": 0.1369919286354928,
            "altp": 0.12824449167482244,
            "jdsatepoch": 2459633.06210773,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001155768176386285,
            "con41": -0.9302380857524779,
            "cc1": 2.2150777980954376e-11,
            "cc4": 6.70302257641773e-8,
            "cc5": 0.000020749607100822512,
            "d2": 1.852553807795475e-20,
            "d3": 2.3103633077487345e-29,
            "d4": 3.3571185455095647e-38,
            "delmo": 0.9072120202099693,
            "eta": 0.03645022027674588,
            "argpdot": -0.000034487174719483426,
            "omgcof": -1.7391607401934421e-10,
            "sinmao": 0.48190508183400815,
            "t": 242498.99081848562,
            "t2cof": 3.322616697143156e-11,
            "t3cof": 1.9506852008277817e-20,
            "t4cof": 1.8585961134693238e-29,
            "t5cof": 2.1838038557317812e-38,
            "x1mth2": 0.9767460285841594,
            "x7thm1": -0.8372222000891154,
            "mdot": 0.06169556663736577,
            "nodedot": -0.00001189308183568156,
            "xlcof": 0.0018865782122705532,
            "xmcof": -0.0000015243217229057029,
            "nodecf": -9.246279506325418e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.192367712352663,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "METEOR 1-16"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07213",
            "epochyr": 22,
            "epochdays": 53.39860607,
            "ndot": 5.938967593591816e-12,
            "nddot": 0,
            "bstar": 0.000065024,
            "inclo": 1.708253222694214,
            "nodeo": 0.0415213829049451,
            "ecco": 0.0118699,
            "argpo": 2.336421655096501,
            "mo": 3.966089682890418,
            "no": 0.06300836614395651,
            "a": 1.117288150335961,
            "alta": 0.13055024895163392,
            "altp": 0.10402605172028823,
            "jdsatepoch": 2459632.89860607,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011584146814252957,
            "con41": -0.9436729054373926,
            "cc1": 7.622284097868155e-11,
            "cc4": 5.463613892195686e-7,
            "cc5": 0.000038916481708859885,
            "d2": 2.481297844875518e-19,
            "d3": 1.205308612960851e-27,
            "d4": 6.822804483730576e-36,
            "delmo": 0.763442785443573,
            "eta": 0.1267347474294305,
            "argpdot": -0.00003709414813489288,
            "omgcof": -1.664187641184929e-10,
            "sinmao": -0.7342063950766307,
            "t": 242734.43320937455,
            "t2cof": 1.1433426146802234e-10,
            "t3cof": 2.5974962746127457e-19,
            "t4cof": 9.61828052839825e-28,
            "t5cof": 4.396808623306031e-36,
            "x1mth2": 0.9812243018124642,
            "x7thm1": -0.8685701126872495,
            "mdot": 0.06296967705369418,
            "nodedot": 0.000011210902914015964,
            "xlcof": 0.0015536873484186492,
            "xmcof": -4.5259128787060986e-7,
            "nodecf": 2.999211085884445e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.162243797382345,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "MIRANDA (X-4)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07218",
            "epochyr": 22,
            "epochdays": 53.58944626,
            "ndot": 1.939254724438144e-12,
            "nddot": 0,
            "bstar": 0.000042145,
            "inclo": 1.7301553594774908,
            "nodeo": 1.2315933319990506,
            "ecco": 0.0056666,
            "argpo": 3.560578139152804,
            "mo": 2.7200537513311147,
            "no": 0.062467616117514745,
            "a": 1.1237121704204525,
            "alta": 0.13007979780535717,
            "altp": 0.11734454303554798,
            "jdsatepoch": 2459633.08944626,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011546274701796145,
            "con41": -0.9244568376625799,
            "cc1": 3.6330176646138155e-11,
            "cc4": 1.6387693021346775e-7,
            "cc5": 0.000028387956000226903,
            "d2": 5.340816197025122e-20,
            "d3": 1.171244005548363e-28,
            "d4": 2.9929785795414797e-37,
            "delmo": 0.8511474027801941,
            "eta": 0.057323827310295984,
            "argpdot": -0.0000350688016542616,
            "omgcof": -2.1835335736097063e-10,
            "sinmao": 0.4091651243044042,
            "t": 242459.62333537638,
            "t2cof": 5.449526496920723e-11,
            "t3cof": 5.604792544053043e-20,
            "t4cof": 9.378416313377566e-29,
            "t5cof": 1.9364217428702583e-37,
            "x1mth2": 0.9748189458875267,
            "x7thm1": -0.8237326212126866,
            "mdot": 0.062430474782299884,
            "nodedot": 0.000012723051718128832,
            "xlcof": 0.0015141599935260394,
            "xmcof": -0.000001069885772266256,
            "nodecf": 1.6223581497229798e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.08142575383785555,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "OPS 8579 (DMSP 5B F5)"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07265",
            "epochyr": 22,
            "epochdays": 53.63225442,
            "ndot": -6.0601710138692e-13,
            "nddot": 0,
            "bstar": -0.000023148,
            "inclo": 1.2918316258023828,
            "nodeo": 4.961620252240228,
            "ecco": 0.0060345,
            "argpo": 2.755410631318016,
            "mo": 4.603749215765051,
            "no": 0.05488376385472266,
            "a": 1.2248363538202793,
            "alta": 0.23222762879740766,
            "altp": 0.21744507884315079,
            "jdsatepoch": 2459633.13225442,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242357340039723,
            "con41": -0.7725297505966886,
            "cc1": -1.4367816639147121e-12,
            "cc4": 7.874929037999635e-9,
            "cc5": 0.0000022867131127698075,
            "d2": 4.7634181960572414e-23,
            "d3": -2.3460385672368717e-33,
            "d4": 1.3450625855357857e-43,
            "delmo": 0.9887193625529624,
            "eta": 0.034811156985417466,
            "argpdot": -0.00001844391489782197,
            "omgcof": 3.826774959392533e-12,
            "sinmao": -0.9941045027107761,
            "t": 242397.97958537936,
            "t2cof": -2.155172495872068e-12,
            "t3cof": 5.176286506009547e-23,
            "t4cof": -1.9722637032941224e-33,
            "t5cof": 9.211914579655599e-44,
            "x1mth2": 0.9241765835322295,
            "x7thm1": -0.46923608472560663,
            "mdot": 0.05486081239513634,
            "nodedot": -0.00001633682862050641,
            "xlcof": 0.0019290850735994413,
            "xmcof": 6.804008857312418e-8,
            "nodecf": 8.231471645367092e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.35113377387565237,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 641"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07266",
            "epochyr": 22,
            "epochdays": 53.57785262,
            "ndot": -5.45415391248228e-13,
            "nddot": 0,
            "bstar": -0.0000097738,
            "inclo": 1.291807191192855,
            "nodeo": 4.702129935041467,
            "ecco": 0.0102842,
            "argpo": 1.4747421314113887,
            "mo": 5.103318298221891,
            "no": 0.05525412897235734,
            "a": 1.2193599625598939,
            "alta": 0.23190010428685248,
            "altp": 0.20681982083293549,
            "jdsatepoch": 2459633.07785262,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242278652583376,
            "con41": -0.7724909397772776,
            "cc1": -6.843031586676324e-13,
            "cc4": 1.6355174514128795e-8,
            "cc5": 0.0000025693215700654517,
            "d2": 1.1041854265107495e-23,
            "d3": -2.647368934349078e-34,
            "d4": 7.389236954571066e-45,
            "delmo": 1.0709169824088862,
            "eta": 0.06062551545483181,
            "argpdot": -0.000018736186566411163,
            "omgcof": -1.1262060540518215e-13,
            "sinmao": -0.9245553446421609,
            "t": 242476.31817743182,
            "t2cof": -1.0264547380014486e-12,
            "t3cof": 1.1978395891032493e-23,
            "t4cof": -2.2202169532071827e-34,
            "t5cof": 5.046315230323789e-45,
            "x1mth2": 0.9241636465924258,
            "x7thm1": -0.4691455261469808,
            "mdot": 0.055230813341629034,
            "nodedot": -0.000016598638418292874,
            "xlcof": 0.0019290878069103223,
            "xmcof": 1.074653915838264e-8,
            "nodecf": 3.983068153497652e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.008381320368378908,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 642"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07267",
            "epochyr": 22,
            "epochdays": 53.58118146,
            "ndot": -6.66618811525612e-13,
            "nddot": 0,
            "bstar": -0.000027635,
            "inclo": 1.291824644485375,
            "nodeo": 1.7069494617429743,
            "ecco": 0.0083252,
            "argpo": 5.2726152356653415,
            "mo": 2.9633596303761323,
            "no": 0.055068691951388034,
            "a": 1.2220942485808965,
            "alta": 0.2322684276191822,
            "altp": 0.2119200695426109,
            "jdsatepoch": 2459633.08118146,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242334858594261,
            "con41": -0.7725186621012464,
            "cc1": -1.82039617628874e-12,
            "cc4": 1.2111783152883031e-8,
            "cc5": 0.0000024218707621498135,
            "d2": 7.729360580693245e-23,
            "d3": -4.875901607757984e-33,
            "d4": 3.5807012289140924e-43,
            "delmo": 0.8634100837603118,
            "eta": 0.04854521434057961,
            "argpdot": -0.000018589868669355663,
            "omgcof": -2.0340170040318465e-12,
            "sinmao": 0.17729086588028617,
            "t": 242471.5246474743,
            "t2cof": -2.7305942644331102e-12,
            "t3cof": 8.392129028422578e-23,
            "t4cof": -4.0941224235561564e-33,
            "t5cof": 2.4488358742109494e-43,
            "x1mth2": 0.9241728873670821,
            "x7thm1": -0.469210211569575,
            "mdot": 0.05504555887980972,
            "nodedot": -0.00001646689330322219,
            "xlcof": 0.0019290858547587459,
            "xmcof": 4.447577298217903e-8,
            "nodecf": 1.05120205435834e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.029354305851619245,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 643"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07268",
            "epochyr": 22,
            "epochdays": 53.28619749,
            "ndot": -2.72707695624114e-13,
            "nddot": 0,
            "bstar": 0.000038795,
            "inclo": 1.2919084202894706,
            "nodeo": 0.08222071573220087,
            "ecco": 0.0094866,
            "argpo": 3.4615132508096056,
            "mo": 2.8175373713720058,
            "no": 0.055160457392552174,
            "a": 1.2207393098252184,
            "alta": 0.23231997536180637,
            "altp": 0.2091586442886304,
            "jdsatepoch": 2459632.78619749,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242604599775619,
            "con41": -0.7726517076723882,
            "cc1": 2.6349408014012077e-12,
            "cc4": 1.4466678556755917e-8,
            "cc5": 0.000002495025797853481,
            "d2": 1.6281332446409585e-22,
            "d3": 1.4947382624247608e-32,
            "d4": 1.5975245243944796e-42,
            "delmo": 0.8500284809287693,
            "eta": 0.05561588046254164,
            "argpdot": -0.000018669619815267193,
            "omgcof": -4.631941742627315e-12,
            "sinmao": 0.31841338100739125,
            "t": 242896.30156427622,
            "t2cof": 3.952411202101812e-12,
            "t3cof": 1.7669915051787354e-22,
            "t4cof": 1.2543282795150188e-32,
            "t5cof": 1.091776657658368e-42,
            "x1mth2": 0.9242172358907961,
            "x7thm1": -0.46952065123557263,
            "mdot": 0.05513722958004976,
            "nodedot": -0.000016526759482308082,
            "xlcof": 0.0019290764695825825,
            "xmcof": -4.908464651677203e-8,
            "nodecf": -1.5270748456070358e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 4.454026119016291,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 644"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07269",
            "epochyr": 22,
            "epochdays": 53.50015326,
            "ndot": -2.1210598548542201e-13,
            "nddot": 0,
            "bstar": 0.000049637,
            "inclo": 1.2918560604119107,
            "nodeo": 3.2828002620516465,
            "ecco": 0.0071711,
            "argpo": 0.8277590496726027,
            "mo": 0.295793165640243,
            "no": 0.05497918837822018,
            "a": 1.2234195020794605,
            "alta": 0.2321927656708227,
            "altp": 0.2146462384880985,
            "jdsatepoch": 2459633.00015326,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001124243602078382,
            "con41": -0.7725685583770436,
            "cc1": 3.175509457185093e-12,
            "cc4": 9.920943887936928e-9,
            "cc5": 0.0000023542402544124957,
            "d2": 2.33975548671653e-22,
            "d3": 2.5611757182400076e-32,
            "d4": 3.2636592015832794e-42,
            "delmo": 1.124186539170796,
            "eta": 0.041597711715888996,
            "argpdot": -0.00001852127905901546,
            "omgcof": 5.223888766036985e-12,
            "sinmao": 0.29149866117394957,
            "t": 242588.20525579154,
            "t2cof": 4.7632641857776396e-12,
            "t3cof": 2.5414326929699693e-22,
            "t4cof": 2.151784607394033e-32,
            "t5cof": 2.2335432081689554e-42,
            "x1mth2": 0.9241895194590146,
            "x7thm1": -0.4693266362131019,
            "mdot": 0.05495614204805886,
            "nodedot": -0.00001640219659143905,
            "xlcof": 0.0019290823381978275,
            "xmcof": -1.0553566923065666e-7,
            "nodecf": -1.8265431770762216e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 5.80203050467064,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 645"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 7270",
            "epochyr": 22,
            "epochdays": 53.68151083,
            "ndot": -3.6361026083215196e-13,
            "nddot": 0,
            "bstar": 0.000027986,
            "inclo": 1.2918822403506909,
            "nodeo": 0.4463487575757778,
            "ecco": 0.005246,
            "argpo": 4.933864281145762,
            "mo": 4.373140607028292,
            "no": 0.054782100726125514,
            "a": 1.2263504182267015,
            "alta": 0.23278385252071887,
            "altp": 0.21991698393268422,
            "jdsatepoch": 2459633.18151083,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242520314132473,
            "con41": -0.7726101347691827,
            "cc1": 1.6845350294938804e-12,
            "cc4": 6.456856031376237e-9,
            "cc5": 0.000002220793383200464,
            "d2": 6.509482876740158e-23,
            "d3": 3.736599533528723e-33,
            "d4": 2.4968447505537726e-43,
            "delmo": 0.9702644639622596,
            "eta": 0.030085323861447497,
            "argpdot": -0.000018367946157573187,
            "omgcof": 1.2157062747745032e-12,
            "sinmao": -0.9430050569873667,
            "t": 242327.05035500228,
            "t2cof": 2.5268025442408204e-12,
            "t3cof": 7.077014529858548e-23,
            "t4cof": 3.143363544914631e-33,
            "t5cof": 1.7113458603163376e-43,
            "x1mth2": 0.9242033782563943,
            "x7thm1": -0.46942364779475987,
            "mdot": 0.05475924624479519,
            "nodedot": -0.000016263219848244932,
            "xlcof": 0.0019290794050902784,
            "xmcof": -1.0641889364479311e-7,
            "nodecf": -9.607432275392306e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.6614682731461912,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 646"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07271",
            "epochyr": 22,
            "epochdays": 53.59097448,
            "ndot": -3.93911115901498e-13,
            "nddot": 0,
            "bstar": 0.000016777,
            "inclo": 1.2918403524486428,
            "nodeo": 2.0906775510864475,
            "ecco": 0.0038672,
            "argpo": 0.5358090990452512,
            "mo": 1.309679362733277,
            "no": 0.054688140588758045,
            "a": 1.2277538689074483,
            "alta": 0.2325018386692872,
            "altp": 0.22300589914560942,
            "jdsatepoch": 2459633.09097448,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242385441076013,
            "con41": -0.7725436108671202,
            "cc1": 9.809241032962992e-13,
            "cc4": 4.310236781628916e-9,
            "cc5": 0.0000021598229978109006,
            "d2": 2.195389453918629e-23,
            "d3": 7.29841168602506e-34,
            "d4": 2.824389019744559e-44,
            "delmo": 1.0171813822345213,
            "eta": 0.022058572449137018,
            "argpdot": -0.000018290831402443733,
            "omgcof": 3.738749900278626e-12,
            "sinmao": 0.9661022256186,
            "t": 242457.4226988852,
            "t2cof": 1.4713861549444487e-12,
            "t3cof": 2.3878318732041586e-23,
            "t4cof": 6.143458319906909e-34,
            "t5cof": 1.9372430779948286e-44,
            "x1mth2": 0.9241812036223733,
            "x7thm1": -0.4692684253566137,
            "mdot": 0.054665379831520804,
            "nodedot": -0.000016200247680339157,
            "xlcof": 0.0019290840969103022,
            "xmcof": -1.1498218334617967e-7,
            "nodecf": -5.57289929165981e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.09105413158354025,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 647"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07272",
            "epochyr": 22,
            "epochdays": 53.61396257,
            "ndot": -3.33309405762806e-13,
            "nddot": 0,
            "bstar": 0.000030937,
            "inclo": 1.291807191192855,
            "nodeo": 3.9888435403486686,
            "ecco": 0.0033157,
            "argpo": 3.058396298805728,
            "mo": 4.350545574531973,
            "no": 0.05457905436837198,
            "a": 1.2293883201271198,
            "alta": 0.23346460298016525,
            "altp": 0.22531203727407423,
            "jdsatepoch": 2459633.11396257,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011242278652583376,
            "con41": -0.7724909397772776,
            "cc1": 1.752549060739144e-12,
            "cc4": 3.4091033770363036e-9,
            "cc5": 0.000002096331396314199,
            "d2": 6.964212472737241e-23,
            "d3": 4.110434454602506e-33,
            "d4": 2.8240759350697937e-43,
            "delmo": 0.9801720762237242,
            "eta": 0.018795196985588236,
            "argpdot": -0.000018203133184528955,
            "omgcof": -8.955172409474295e-12,
            "sinmao": -0.9352458495061678,
            "t": 242424.31984886527,
            "t2cof": 2.628823591108716e-12,
            "t3cof": 7.578498114796772e-23,
            "t4cof": 3.462436633351096e-33,
            "t5cof": 1.9386526378321273e-43,
            "x1mth2": 0.9241636465924258,
            "x7thm1": -0.4691455261469808,
            "mdot": 0.054556401056395566,
            "nodedot": -0.000016126774061064003,
            "xlcof": 0.0019290878069103223,
            "xmcof": -2.8157720719517327e-7,
            "nodecf": -9.911540942912627e-17,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.23588802207918746,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 648"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 7274",
            "epochyr": 22,
            "epochdays": 53.67963301,
            "ndot": 5.969268448661163e-12,
            "nddot": 0,
            "bstar": 0.0001074,
            "inclo": 1.4174586800316826,
            "nodeo": 0.5690576212957431,
            "ecco": 0.0018358,
            "argpo": 1.7554626336314088,
            "mo": 4.533375794995387,
            "no": 0.06149044777013156,
            "a": 1.1355790291643388,
            "alta": 0.13766372514607883,
            "altp": 0.13349433318259885,
            "jdsatepoch": 2459633.17963301,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011557239437495785,
            "con41": -0.9300138025802069,
            "cc1": 6.052683992669752e-11,
            "cc4": 1.5164043326361755e-8,
            "cc5": 0.000018741974345053908,
            "d2": 1.3534081209822032e-19,
            "d3": 4.512118846478504e-28,
            "d4": 1.752653969463762e-36,
            "delmo": 0.9909703564028282,
            "eta": 0.016955013965501343,
            "argpdot": -0.000034158408453029944,
            "omgcof": -2.0472162560835507e-10,
            "sinmao": -0.9840198827232832,
            "t": 242329.75441530347,
            "t2cof": 9.079025989004629e-11,
            "t3cof": 1.4266780880124445e-19,
            "t4cof": 3.6353851843987676e-28,
            "t5cof": 1.142133163730393e-36,
            "x1mth2": 0.9766712675267357,
            "x7thm1": -0.8366988726871497,
            "mdot": 0.06145443398152354,
            "nodedot": -0.00001180365326740762,
            "xlcof": 0.0018867190863024888,
            "xmcof": -0.000018954446495756023,
            "nodecf": -2.5075314091047672e-15,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.6496372805496762,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "METEOR 1-17"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07281",
            "epochyr": 22,
            "epochdays": 53.61200052,
            "ndot": 3.0300855069346e-14,
            "nddot": 0,
            "bstar": 0.000089012,
            "inclo": 1.2922714487738856,
            "nodeo": 3.5185907533375764,
            "ecco": 0.0021101,
            "argpo": 0.040730748753791665,
            "mo": 1.3054835912114826,
            "no": 0.05541743891107867,
            "a": 1.2169648497001364,
            "alta": 0.21953276722948845,
            "altp": 0.21439693217078415,
            "jdsatepoch": 2459633.11200052,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011243772566413561,
            "con41": -0.7732278255776903,
            "cc1": 6.406163072128634e-12,
            "cc4": 2.3363980526825216e-9,
            "cc5": 0.000002624290451674617,
            "d2": 9.771202272106324e-22,
            "d3": 2.2147098614075977e-31,
            "d4": 5.843969004356733e-41,
            "delmo": 1.0099128122446022,
            "eta": 0.012560157070562426,
            "argpdot": -0.00001889897277749681,
            "omgcof": 5.537441000251984e-11,
            "sinmao": 0.9650105453401556,
            "t": 242427.14520134032,
            "t2cof": 9.609244608192952e-12,
            "t3cof": 1.0591980778240415e-21,
            "t4cof": 1.8553926927487904e-31,
            "t5cof": 3.9860253323652203e-41,
            "x1mth2": 0.9244092751925634,
            "x7thm1": -0.4708649263479441,
            "mdot": 0.05539394339496604,
            "nodedot": -0.000016682707903394412,
            "xlcof": 0.0019290355164594715,
            "xmcof": -0.0000024122810351039404,
            "nodecf": -3.748084565993561e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.22352634352969147,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 650"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07291",
            "epochyr": 22,
            "epochdays": 53.5638324,
            "ndot": -1.999856434576836e-12,
            "nddot": 0,
            "bstar": 0.000019178,
            "inclo": 1.1339613589717397,
            "nodeo": 2.455189565365463,
            "ecco": 0.005089,
            "argpo": 4.089800365601029,
            "mo": 2.1869656205897225,
            "no": 0.060795738185322495,
            "a": 1.1439859422922118,
            "alta": 0.14980768675253686,
            "altp": 0.13816419783188683,
            "jdsatepoch": 2459633.0638324,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010596288027656562,
            "con41": -0.4630257596951475,
            "cc1": 8.381057500863177e-12,
            "cc4": 7.13038066267308e-8,
            "cc5": 0.000014553175401340209,
            "d2": 2.4431225623088027e-21,
            "d3": 1.0614493943565936e-30,
            "d4": 5.372537570126694e-40,
            "delmo": 0.9252260446087057,
            "eta": 0.044250692690421874,
            "argpdot": -0.000004015692174545328,
            "omgcof": -2.7039766570181437e-11,
            "sinmao": 0.8160982546687161,
            "t": 242496.5072941035,
            "t2cof": 1.2571586251294765e-11,
            "t3cof": 2.5836068119743525e-21,
            "t4cof": 8.589866560145596e-31,
            "t5cof": 3.519098984013419e-40,
            "x1mth2": 0.8210085865650492,
            "x7thm1": 0.2529398940446559,
            "mdot": 0.060778272118681156,
            "nodedot": -0.00003188705026892942,
            "xlcof": 0.0019044663326619451,
            "xmcof": -3.5660034503326164e-7,
            "nodecf": -9.36620446120086e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 6.203233800868858,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 651"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 7297",
            "epochyr": 22,
            "epochdays": 53.69550388,
            "ndot": -2.545271825825064e-12,
            "nddot": 0,
            "bstar": 0.0000041773,
            "inclo": 1.1335913491703171,
            "nodeo": 0.5336710707115582,
            "ecco": 0.0048064,
            "argpo": 2.2763090249993123,
            "mo": 0.7212450960818927,
            "no": 0.06020861452689863,
            "a": 1.1514077171261015,
            "alta": 0.15694184317769655,
            "altp": 0.1458735910745066,
            "jdsatepoch": 2459633.19550388,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0010594456635851957,
            "con41": -0.4621744473537369,
            "cc1": 1.4588705299335614e-12,
            "cc4": 5.107858903879295e-8,
            "cc5": 0.000011731236552869944,
            "d2": 7.052566342225061e-23,
            "d3": 5.0797999667609605e-33,
            "d4": 4.262260540256084e-43,
            "delmo": 1.0924160300682153,
            "eta": 0.03981746409442474,
            "argpdot": -0.000003872890366401611,
            "omgcof": -5.2177901860085185e-12,
            "sinmao": 0.6603202309871345,
            "t": 242306.90036304295,
            "t2cof": 2.1883057949003423e-12,
            "t3cof": 7.478226986846787e-23,
            "t4cof": 4.126275708110314e-33,
            "t5cof": 2.8040431358792866e-43,
            "x1mth2": 0.820724815784579,
            "x7thm1": 0.2549262895079474,
            "mdot": 0.060191570882637706,
            "nodedot": -0.000031198290243369955,
            "xlcof": 0.0019043125134022138,
            "xmcof": -7.33767898882038e-8,
            "nodecf": -1.5951095005010017e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.7496299186542714,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 654"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07337",
            "epochyr": 22,
            "epochdays": 53.58345965,
            "ndot": 8.223652065820505e-11,
            "nddot": 0,
            "bstar": 0.00013765,
            "inclo": 1.4477226892612645,
            "nodeo": 2.8542503721877064,
            "ecco": 0.0534158,
            "argpo": 6.11016383711238,
            "mo": 0.1572506749461851,
            "no": 0.06291718426201282,
            "a": 1.1183737449168558,
            "alta": 0.1781125732005857,
            "altp": 0.05863491663312592,
            "jdsatepoch": 2459633.08345965,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011605995892538046,
            "con41": -0.9547876116146501,
            "cc1": 8.592856033206107e-10,
            "cc4": 0.0000099201074205697,
            "cc5": 0.0002544732753193814,
            "d2": 3.124258705124703e-17,
            "d3": 1.6949653467741202e-24,
            "d4": 1.0715566006091716e-31,
            "delmo": 3.7823535652885267,
            "eta": 0.5650432135861594,
            "argpdot": -0.000037926965218311726,
            "omgcof": 1.0576269673430331e-10,
            "sinmao": 0.15660339920369032,
            "t": 242468.24405372143,
            "t2cof": 1.288928404980916e-9,
            "t3cof": 3.2719330547395163e-17,
            "t4cof": 1.3533491064040193e-24,
            "t5cof": 6.910026494100817e-32,
            "x1mth2": 0.98492920387155,
            "x7thm1": -0.8945044271008502,
            "mdot": 0.06287801264489727,
            "nodedot": -0.000010064285724392097,
            "xlcof": 0.001867799597042962,
            "xmcof": -4.583276357841665e-8,
            "nodecf": -3.027203988107119e-14,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.043707787686024346,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 660"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": "07349",
            "epochyr": 22,
            "epochdays": 53.58381681,
            "ndot": 1.242335057843186e-12,
            "nddot": 0,
            "bstar": 0.000026807,
            "inclo": 1.4476912733347287,
            "nodeo": 4.573078544819754,
            "ecco": 0.0024531,
            "argpo": 5.849760712714827,
            "mo": 1.3330004521984251,
            "no": 0.06005797450544059,
            "a": 1.1535625321817915,
            "alta": 0.1563923364294868,
            "altp": 0.15073272793409642,
            "jdsatepoch": 2459633.08381681,
            "isimp": 0,
            "method": "n",
            "aycof": 0.001160595078459527,
            "con41": -0.954764643463924,
            "cc1": 8.710316407594605e-12,
            "cc4": 1.4749460443641819e-8,
            "cc5": 0.000011035985279575536,
            "d2": 2.4839021826415594e-21,
            "d3": 1.0552817009610633e-30,
            "d4": 5.222614661071463e-40,
            "delmo": 1.0142560477431593,
            "eta": 0.02007806646826505,
            "argpdot": -0.00003383681406496727,
            "omgcof": 9.366972503452256e-11,
            "sinmao": 0.9718595413642388,
            "t": 242467.72974349558,
            "t2cof": 1.3065474611391907e-11,
            "t3cof": 2.635641406482383e-21,
            "t4cof": 8.580201183436364e-31,
            "t5cof": 3.4396899852455334e-40,
            "x1mth2": 0.9849215478213079,
            "x7thm1": -0.8944508347491558,
            "mdot": 0.06002298057071066,
            "nodedot": -0.000008981966703851023,
            "xlcof": 0.0018678210417369925,
            "xmcof": -0.0000017317221589537794,
            "nodecf": -2.7458701707575113e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.04595803353108607,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "COSMOS 663"
    },
    {
        "satrec": {
            "error": 0,
            "satnum": " 7363",
            "epochyr": 22,
            "epochdays": 53.60153086,
            "ndot": 2.060458144715528e-12,
            "nddot": 0,
            "bstar": 0.000038086,
            "inclo": 1.4176314676276303,
            "nodeo": 1.4132698898268965,
            "ecco": 0.0017304,
            "argpo": 3.4594729609140242,
            "mo": 2.824668786695655,
            "no": 0.0611177026823696,
            "a": 1.1401879504210781,
            "alta": 0.14216093165048682,
            "altp": 0.13821496919166942,
            "jdsatepoch": 2459633.10153086,
            "isimp": 0,
            "method": "n",
            "aycof": 0.0011557547894899206,
            "con41": -0.9301702061080943,
            "cc1": 1.8498057448375093e-11,
            "cc4": 1.0907429266401423e-8,
            "cc5": 0.00001623547286888043,
            "d2": 1.2233528853348161e-20,
            "d3": 1.2060374137031313e-29,
            "d4": 1.385203194448504e-38,
            "delmo": 0.9565566202210939,
            "eta": 0.015466285328651718,
            "argpdot": -0.000033687649113061836,
            "omgcof": -3.294333467994288e-10,
            "sinmao": 0.31164510241959503,
            "t": 242442.22151130438,
            "t2cof": 2.7747086172562638e-11,
            "t3cof": 1.2917885112074931e-20,
            "t4cof": 9.739994238086605e-30,
            "t5cof": 9.051702158991507e-39,
            "x1mth2": 0.9767234020360315,
            "x7thm1": -0.8370638142522202,
            "mdot": 0.06108219009604322,
            "nodedot": -0.000011624611375184027,
            "xlcof": 0.0018866208956831857,
            "xmcof": -0.000006746653273409269,
            "nodecf": -7.54704681148974e-16,
            "irez": 0,
            "d2201": 0,
            "d2211": 0,
            "d3210": 0,
            "d3222": 0,
            "d4410": 0,
            "d4422": 0,
            "d5220": 0,
            "d5232": 0,
            "d5421": 0,
            "d5433": 0,
            "dedt": 0,
            "del1": 0,
            "del2": 0,
            "del3": 0,
            "didt": 0,
            "dmdt": 0,
            "dnodt": 0,
            "domdt": 0,
            "e3": 0,
            "ee2": 0,
            "peo": 0,
            "pgho": 0,
            "pho": 0,
            "pinco": 0,
            "plo": 0,
            "se2": 0,
            "se3": 0,
            "sgh2": 0,
            "sgh3": 0,
            "sgh4": 0,
            "sh2": 0,
            "sh3": 0,
            "si2": 0,
            "si3": 0,
            "sl2": 0,
            "sl3": 0,
            "sl4": 0,
            "gsto": 0.15756342416820956,
            "xfact": 0,
            "xgh2": 0,
            "xgh3": 0,
            "xgh4": 0,
            "xh2": 0,
            "xh3": 0,
            "xi2": 0,
            "xi3": 0,
            "xl2": 0,
            "xl3": 0,
            "xl4": 0,
            "xlamo": 0,
            "zmol": 0,
            "zmos": 0,
            "atime": 0,
            "xli": 0,
            "xni": 0,
            "operationmode": "i",
            "init": "n"
        },
        "name": "METEOR 1-18"
    }
];

// EXTERNAL MODULE: ./PageSections/HomeSections/Components/GlobeAnimation.module.scss
var GlobeAnimation_module = __webpack_require__(570);
var GlobeAnimation_module_default = /*#__PURE__*/__webpack_require__.n(GlobeAnimation_module);
;// CONCATENATED MODULE: ./PageSections/HomeSections/Components/GlobeAnimation.tsx









var TLE_DATA_DATE = new Date(2018, 0, 26);
var TIME_SCALE = 33; // per frame
var RADIUS = 228;
var EARTH_RADIUS = 6371;
function satrecToXYZ(satrec, date) {
    var positionAndVelocity = (0,satellite_es/* propagate */.a0)(satrec, date);
    var gmst = (0,satellite_es/* gstime */.Ut)(date);
    var positionGd = (0,satellite_es/* eciToGeodetic */.jX)(positionAndVelocity.position, gmst);
    return [
        positionGd.longitude,
        positionGd.latitude,
        positionGd.height
    ];
}
function satelliteVector(satrec, date) {
    var xyz = satrecToXYZ(satrec, date);
    var lambda = xyz[0];
    var phi = xyz[1];
    var cosPhi = Math.cos(phi);
    var r = (xyz[2] + EARTH_RADIUS) / EARTH_RADIUS * RADIUS;
    return new three_module/* Vector3 */.Pa4(r * cosPhi * Math.cos(lambda), r * cosPhi * Math.sin(lambda), r * Math.sin(phi));
}
var GlobeAnimation = function(props) {
    var modeClassName = react.useContext(_app.ThemeContext).modeClassName;
    var scene = react.useMemo(function() {
        return new three_module/* Scene */.xsS;
    }, []);
    var camera = react.useMemo(function() {
        return new three_module/* PerspectiveCamera */.cPb(70, props.width / props.height, 1, 10000);
    }, []);
    var renderer = react.useMemo(function() {
        return new three_module/* WebGLRenderer */.CP7();
    }, []);
    var controls = react.useMemo(function() {
        return new dist.OrbitControls(camera, renderer.domElement);
    }, []);
    var globeMaterial = react.useMemo(function() {
        return new three_module/* MeshStandardMaterial */.Wid({
            color: 0xE7D4FF,
            wireframe: true
        });
    }, []);
    var sphere = react.useMemo(function() {
        return new three_module/* Mesh */.Kj0(new three_module/* SphereBufferGeometry */.Aip(RADIUS - 0.5, 36, 36), globeMaterial);
    }, []);
    var ref = react.useRef(null);
    var animRef = react.useRef(0);
    //const satellites = React.useRef<Points>(new Points);
    var parsedTles = react.useMemo(function() {
        return preProcessedTLE;
    }, []);
    var previousTimeRef = react.useRef(0);
    var satelliteGeometries = react.useRef([]);
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState({
        sat: 0x00DDC2,
        wire: 0xE7D4FF,
        atmo: 0xF4F4F4
    }), 2), theme = ref1[0], setTheme = ref1[1];
    var handleThemeChange = function handleThemeChange() {
        //light mode vs dark mode
        var newTheme = {
            sat: 0x00DDC2,
            wire: 0xE7D4FF,
            atmo: 0xF4F4F4
        };
        if (modeClassName !== "light") {
            newTheme = {
                sat: 0x00B6CF,
                wire: 0x6A45B8,
                atmo: 0x262626
            };
        }
        for(var i = 0; i < satelliteGeometries.current.length; i++){
            //@ts-expect-error not typed correctly
            satelliteGeometries.current[i].material.color.setHex(newTheme.sat);
        }
        setTheme(newTheme);
        globeMaterial.color = new three_module/* Color */.Ilk(newTheme.wire);
        renderer.setClearColor(newTheme.atmo, 1);
    };
    var animate = function(time) {
        var newDate = new Date(TLE_DATA_DATE.getTime() + Math.floor(time * TIME_SCALE));
        for(var i = 0; i < parsedTles.length; i++){
            var newVectors = satelliteVector(parsedTles[i].satrec, newDate);
            satelliteGeometries.current[i].position.setX(newVectors.x);
            satelliteGeometries.current[i].position.setY(newVectors.y);
            satelliteGeometries.current[i].position.setZ(newVectors.z);
        //satelliteGeometries.current[i].geometry.attributes.position.setXYZ(0, newVectors.x, newVectors.y, newVectors.z);
        //satelliteGeometries.current[i].geometry.attributes.position.needsUpdate = true;
        //satellites.current.geometry.attributes.position.setXYZ(i, newVectors.x, newVectors.y, newVectors.z);
        }
        sphere.rotation.y += 0.0003;
        controls.update();
        previousTimeRef.current = time;
        //satellites.current.geometry.attributes.position.needsUpdate = true;
        renderer.render(scene, camera);
        animRef.current = requestAnimationFrame(animate);
    };
    react.useEffect(function() {
        //resize
        renderer.setSize(props.width, props.height);
    }, [
        props.width,
        props.height
    ]);
    react.useEffect(function() {
        //handle theme change
        handleThemeChange();
    }, [
        modeClassName
    ]);
    react.useEffect(function() {
        if (parsedTles.length > 0) {
            var ref1;
            (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.appendChild(renderer.domElement);
            renderer.setPixelRatio(window.devicePixelRatio);
            renderer.setSize(props.width, props.height);
            if (controls) {
                controls.autoRotate = false;
                controls.enableZoom = false;
                controls.enableRotate = true;
                controls.enablePan = false;
                controls.enableDamping = true;
                controls.dampingFactor = .07;
                controls.rotateSpeed = 0.02;
                camera.position.set(300, 300, 300);
                controls.update();
            }
            var ambientLight = new three_module/* AmbientLight */.Mig(0xbbbbbb);
            var directionalLight = new three_module/* DirectionalLight */.Ox3(0x5548ED, 0.6);
            directionalLight.position.x += 2;
            scene.add(sphere);
            scene.add(ambientLight);
            scene.add(directionalLight);
            var points = parsedTles.map(function(d) {
                return satelliteVector(d.satrec, TLE_DATA_DATE);
            });
            var satGeometries = points.map(function(d) {
                var satGeometry = new three_module/* OctahedronBufferGeometry */.REq(1.75, 0);
                var satMaterial = new three_module/* MeshLambertMaterial */.YBo({
                    color: theme.sat
                });
                var satMesh = new three_module/* Mesh */.Kj0(satGeometry, satMaterial);
                satMesh.position.setX(d.x);
                satMesh.position.setY(d.y);
                satMesh.position.setZ(d.z);
                return satMesh;
            });
            satelliteGeometries.current = satGeometries;
            //const satGeometry = new BufferGeometry();
            //satGeometry.setFromPoints(points);
            //satellites.current = new Points(satGeometry, new PointsMaterial({ color: 0x00CEEA, size: 4 }));
            satelliteGeometries.current.forEach(function(mesh) {
                return scene.add(mesh);
            });
            //scene.add(satellites.current);
            renderer.render(scene, camera);
            animRef.current = requestAnimationFrame(animate);
            return function() {
                return cancelAnimationFrame(animRef.current);
            };
        }
    }, [
        parsedTles
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: (GlobeAnimation_module_default())["viz-container"]
    });
};
/* harmony default export */ var Components_GlobeAnimation = (GlobeAnimation);


/***/ }),

/***/ 570:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"viz-container":"GlobeAnimation_viz-container___PIfr"};

/***/ })

}]);